webpackJsonp([1],Array(23).concat([
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  methods: {
    errorHandling: function errorHandling(error, callback) {
      var payload = {
        type: 'danger',
        vueInstance: this
      };
      if (callback) {
        payload.retryCallback = callback;
        payload.isCanRetry = true;
      }
      if (error.response) {
        var response = error.response;
        if (response.status === 500 || response.status === 400) {
          payload.errorCode = response.status;
          if (response.data.hasOwnProperty('message')) {
            payload.message = response.data.message;
          } else if (response.data.hasOwnProperty('requestId')) {
            payload.message = response.data.error;
            payload.details = error;
          } else {
            payload.message = 'Unknown Error';
            payload.details = error;
          }
        } else if (response.status === 502) {
          payload.errorCode = response.status;
          if (response.status === 502) {
            payload.message = 'Server Bad Gateway';
          }
          if (!callback) {
            payload.isCanRetry = true;
            payload.retryCallback = function () {
              location.reload();
            };
          }
        }
      } else if (error.message) {
        payload.message = error.message;
        if (error.message === 'Network Error') {
          if (!callback) {
            payload.isCanRetry = true;
            payload.retryCallback = function () {
              location.reload();
            };
          }
        }
      }
      this.$notifications.add(payload);
    }
  }
};

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultConfig = undefined;

var _entries = __webpack_require__(99);

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = __webpack_require__(50);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = __webpack_require__(52);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _typeof2 = __webpack_require__(149);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(80);

var _stringify2 = _interopRequireDefault(_stringify);

exports.escapeString = escapeString;
exports.buildJobToCompare = buildJobToCompare;
exports.errorHandlingAppSync = errorHandlingAppSync;
exports.downloadFileBlob = downloadFileBlob;
exports.jobDescription = jobDescription;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escapeString(string) {
  var escString = (0, _stringify2.default)(string);
  return escString.substring(1, escString.length - 1);
}

function buildJobToCompare(job, jobOutput) {
  var jobOutputPathKey = jobOutput.jobOutputPathKey,
      analysisId = jobOutput.analysisId,
      objectiveId = jobOutput.objectiveId,
      outputFiles = jobOutput.outputFiles;
  var sourceFilePathKey = job.sourceFilePathKey,
      jobPathKey = job.jobPathKey,
      filename = job.filename,
      isNested = job.isNested,
      nestedJobName = job.nestedJobName,
      nestedJobs = job.nestedJobs,
      config = job.config;


  return {
    jobOutputPathKey: jobOutputPathKey,
    analysisId: analysisId,
    objectiveId: objectiveId,
    outputFiles: outputFiles,
    sourceFilePathKey: sourceFilePathKey,
    jobPathKey: jobPathKey,
    isNested: isNested,
    filename: filename,
    nestedJobs: nestedJobs,
    nestedJobName: nestedJobName,
    config: config
  };
}

function errorHandlingAppSync(response) {
  if (response.data && response.data.hasOwnProperty('errors') && response.data.errors.length > 0) {
    var error = new Error(response.data.errors[0].message);
    if (response.data.errors[0].code) {
      error.code = response.data.errors[0].code;
    }
    throw error;
  }
  return parseAppSyncData(response.data);
}

function parseAppSyncData(data, dataKey) {
  var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) !== 'object' || data === null) {
    return dataKey !== 'config' ? data : JSON.parse(data);
  }

  if (!Array.isArray(data)) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = (0, _slicedToArray3.default)(_ref, 2);

        var key = _ref2[0];
        var value = _ref2[1];

        if (key === 'item' || key === 'items') {
          result = parseAppSyncData(value, key);
        } else {
          result[key] = parseAppSyncData(value, key);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } else {
    if (dataKey === 'item') {
      var entries = data[0] ? (0, _entries2.default)(data[0]) : [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(entries), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref3 = _step2.value;

          var _ref4 = (0, _slicedToArray3.default)(_ref3, 2);

          var _key = _ref4[0];
          var _value = _ref4[1];

          result[_key] = parseAppSyncData(_value, _key);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    } else {
      result = data.map(function (elem) {
        return parseAppSyncData(elem);
      });
    }
  }
  return result;
}

function downloadFileBlob(data, filename, mime) {
  var blob = new Blob([data], { type: mime || 'application/octet-stream' });
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    var blobURL = window.URL.createObjectURL(blob);
    var tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename);

    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  }
}

function jobDescription(analysisId, objectiveId, compensated, forViewer, isShortName) {
  var description = [];
  var descriptionCompensated = [];
  var descriptionForViewer = [];
  var descriptionShort = [];

  descriptionShort[0] = [];
  descriptionShort[0][0] = 'nested';
  descriptionShort[1] = [];
  descriptionShort[1][0] = 'manual';
  descriptionShort[3] = [];
  descriptionShort[3][0] = 'manual';
  descriptionShort[4] = [];
  descriptionShort[4][10] = 'min. supp. vol.';
  descriptionShort[4][11] = 'min. supp. rm';
  descriptionShort[4][14] = 'min. time';
  descriptionShort[4][20] = 'expert';
  descriptionShort[4][21] = 'cust. weight.';
  descriptionShort[4][22] = 'max. dist.';
  descriptionShort[5] = [];
  descriptionShort[5][1] = 'min. dist.';
  descriptionShort[5][14] = 'min. time';
  descriptionShort[99] = [];
  descriptionShort[99][0] = 'manual';

  description[0] = [];
  description[0][0] = 'Nested optimization';
  description[1] = [];
  description[1][0] = 'Manual orientation without thermal distortion';
  description[3] = [];
  description[3][0] = 'Manual orientation with thermal distortion';
  description[4] = [];
  description[4][10] = 'Optimization for minimum support volume';
  description[4][11] = 'Optimization for minimum support removal';
  description[4][14] = 'Optimization for minimum build time';
  description[4][20] = 'Optimization based on expert knowledge';
  description[4][21] = 'Optimization based on custom weighting';
  description[4][22] = 'Build Time Optimization Based on Maximum Distortion';
  description[5] = [];
  description[5][1] = 'Optimization for minimum thermal distortion';
  description[5][14] = 'Optimization for build time with maximum distortion';
  description[99] = [];
  description[99][0] = 'Manual orientation with modified support';

  descriptionCompensated[0] = [];
  descriptionCompensated[0][0] = 'Nested optimization';
  descriptionCompensated[1] = [];
  descriptionCompensated[1][0] = 'Compensated manual orientation without thermal distortion';
  descriptionCompensated[3] = [];
  descriptionCompensated[3][0] = 'Compensated manual orientation with thermal distortion';
  descriptionCompensated[4] = [];
  descriptionCompensated[4][10] = 'Compensated optimization for minimum support volume';
  descriptionCompensated[4][11] = 'Compensated optimization for minimum support removal';
  descriptionCompensated[4][14] = 'Compensated optimization for minimum build time';
  descriptionCompensated[4][20] = 'Compensated optimization based on expert knowledge';
  descriptionCompensated[4][21] = 'Compensated optimization based on custom weighting';
  descriptionCompensated[4][22] = 'Build Time Compensated Optimization Based on Maximum Distortion';
  descriptionCompensated[5] = [];
  descriptionCompensated[5][1] = 'Compensated optimization for minimum thermal distortion';
  descriptionCompensated[5][14] = 'Compensated optimization for build time with maximum distortion';
  descriptionCompensated[99] = [];
  descriptionCompensated[99][0] = 'Compensated manual orientation with modified support';

  descriptionForViewer[0] = [];
  descriptionForViewer[0][0] = 'Nested';
  descriptionForViewer[1] = [];
  descriptionForViewer[1][0] = 'manual orientation without thermal distortion';
  descriptionForViewer[3] = [];
  descriptionForViewer[3][0] = 'manual orientation with thermal distortion';
  descriptionForViewer[4] = [];
  descriptionForViewer[4][10] = 'for minimum support volume';
  descriptionForViewer[4][11] = 'for minimum support removal';
  descriptionForViewer[4][14] = 'for minimum build time';
  descriptionForViewer[4][20] = 'based on expert knowledge';
  descriptionForViewer[4][21] = 'based on custom weighting';
  descriptionForViewer[4][22] = 'for Build Time Based on Maximum Distortion';
  descriptionForViewer[5] = [];
  descriptionForViewer[5][1] = 'for minimum thermal distortion';
  descriptionForViewer[5][14] = 'for build time with maximum distortion';
  descriptionForViewer[99] = [];
  descriptionForViewer[99][0] = 'for manual orientation with modified support';

  if (forViewer) {
    if (descriptionForViewer[analysisId] && descriptionForViewer[analysisId][objectiveId]) {
      if (compensated) {
        return descriptionForViewer[analysisId][objectiveId] + ', compensated';
      } else {
        return descriptionForViewer[analysisId][objectiveId];
      }
    } else {
      return 'No jobDescription yet: analysisId ' + analysisId + ', objectiveId ' + objectiveId;
    }
  } else if (isShortName) {
    if (descriptionShort[analysisId] && descriptionShort[analysisId][objectiveId]) {
      return descriptionShort[analysisId][objectiveId];
    } else {
      return 'No description';
    }
  } else {
    if (compensated) {
      if (descriptionCompensated[analysisId] && descriptionCompensated[analysisId][objectiveId]) {
        return descriptionCompensated[analysisId][objectiveId];
      } else {
        return 'No jobDescription yet: analysisId ' + analysisId + ', objectiveId ' + objectiveId;
      }
    } else {
      if (description[analysisId] && description[analysisId][objectiveId]) {
        return description[analysisId][objectiveId];
      } else {
        return 'No jobDescription yet: analysisId ' + analysisId + ', objectiveId ' + objectiveId;
      }
    }
  }
}

var defaultConfig = exports.defaultConfig = {
  'N_part': [],
  'filename': '',
  'printer': 'EOSM290',
  'unit': 'mm',
  'scaling': [1],
  'material': [1],
  'RotationalAngle': [],
  'Weights': [0.5, 0.5, 0.5],
  'layerThickness': [40],
  'elementsize': [0.002],
  'Power_laser': [200],
  'NLaser': [1],
  'VlaserSupp': [1000],
  'hatch': [0.11],
  'Diameter_laser': [100],
  'Speed_laser': [400],
  'suppSpacing_xy': [1.0],
  'suppHatchSize': [3.5],
  'supp_size_boundary': [0.6],
  'hsub': [5],
  'critical_angle': [40],
  'Tplate': [80],
  'isCompensate': [0],
  'isSupport': [1],
  'isHeatTreatment': true,
  'isMinPeeling': false,
  'MaxDist': [-1],
  'AllowedFaces': [],
  'RestrictedFaces': [],
  'AngleRestriction': [],
  'scalingX_material': [0],
  'scalingY_material': [0],
  'Wt': [0.5],
  'Pt': [0.16],
  'Tt': [0.5],
  'Ot': [0.8],
  'Wb': [0.8],
  'Pb': [0.16],
  'Tb': [0.5],
  'Ob': [0.8],
  'fraction_avg': [0.42],
  'isRepair': false,
  'isEvalFacet': true,
  'isEvalVertex': true,
  'isEvalEdge': true,
  'isFragmentation': false,
  'H_buildPlate': [30],
  'CrashTolerance': [0.4],
  'fragmentationSize': [5.0],
  'tetraEps': [0.001],
  'tetraMeshSize': [2.0],
  'PrinterXYZ': [],
  'DirectionRecoater': [],
  'plateThickness': [30],
  'material_name': '',
  'nu': [],
  'E': [],
  'E_heat': [],
  'rho': [],
  'Cp': [],
  'k': [],
  'Tsolid': [],
  'Tliquid': [],
  'sigma_y': [],
  'sigma_y_heat': [],
  'hsl': [],
  'alpha': [],
  'filename_supp': [],
  'unit_supp': 'mm',
  'needRemesh': false,
  'isStrengthSupp': [0],
  'compensationScale': [1.0]
};

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(148);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = __webpack_require__(50);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(24);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(17);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(137);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(136);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(79);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(12);

var _vuex2 = _interopRequireDefault(_vuex);

var _axios = __webpack_require__(64);

var _axios2 = _interopRequireDefault(_axios);

var _billing = __webpack_require__(318);

var _billing2 = _interopRequireDefault(_billing);

var _user = __webpack_require__(321);

var _user2 = _interopRequireDefault(_user);

var _jobs2 = __webpack_require__(319);

var _jobs3 = _interopRequireDefault(_jobs2);

var _notifications = __webpack_require__(320);

var _notifications2 = _interopRequireDefault(_notifications);

var _helpers = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  state: {
    config: {
      API_URL: "https://dev.portal.atlas3d.xyz/api",
      API_TRIALS_URL: "https://dev.trials.atlas3d.xyz/api",
      AUTH0_CALLBACK_URL: "https://dev.portal.atlas3d.xyz/callback",
      TARGET_VERSION: '1.2.0'
    },
    jobs: {
      sourceFiles: []
    },
    gettingFileURL: false,
    files: [],
    filesNested: {},
    filesCompare: {},
    nestedFilesCompare: {},
    materials: [],
    printers: [],
    customMaterials: [],
    customPrinters: [],
    filesNestedJobName: '',
    jobsPagination: {
      loading: true,
      nextToken: null
    },
    filesPagination: {
      loading: true,
      filesOnPage: 10,
      loadedByIteration: 0,
      nextToken: null,
      isAllLoaded: false
    },
    jobsProgress: {
      loaded: 0,
      total: 0
    },
    fileUrls: {},
    auth: null,
    isAuthenticated: false,
    createConfig: null,
    updateTimers: [],
    webGL: false
  },
  actions: {
    getConfig: function getConfig(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      if (window.location.hostname !== 'local.atlas3d.xyz') {
        commit('SET_URL_CONFIG', {
          API_URL: window.location.origin + '/api',
          API_TRIALS_URL: window.location.origin + '/api',
          AUTH0_CALLBACK_URL: window.location.origin + '/callback'
        });
      }
    },
    getDownloadURL: function getDownloadURL(_ref2, _ref3) {
      var state = _ref2.state;
      var filename = _ref3.filename,
          sourceFilePathKey = _ref3.sourceFilePathKey,
          jobPathKey = _ref3.jobPathKey,
          jobOutputPathKey = _ref3.jobOutputPathKey;

      return _axios2.default.post(state.config.API_URL + '/files/download', {
        filename: filename,
        sourceFilePathKey: sourceFilePathKey,
        jobPathKey: jobPathKey,
        jobOutputPathKey: jobOutputPathKey
      }, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      });
    },
    getURLData: function getURLData(_ref4, _ref5) {
      var state = _ref4.state;
      var url = _ref5.url,
          binary = _ref5.binary,
          blob = _ref5.blob;

      if (binary) {
        return _axios2.default.get(url, { responseType: 'arraybuffer' });
      } else if (blob) {
        return _axios2.default.get(url, { responseType: 'blob' });
      } else {
        return _axios2.default.get(url);
      }
    },
    refreshUrl: function refreshUrl(_ref6, payload) {
      var dispatch = _ref6.dispatch,
          state = _ref6.state,
          commit = _ref6.commit;

      if (state.fileUrls[payload.jobOutputPathKey] == null) {
        return dispatch('getDownloadURL', payload).then(function (response) {
          if (payload.jobOutputPathKey) {
            commit('SET_URL', { filePathKeyAndName: payload.jobOutputPathKey + payload.filename, url: response.data.url });
          } else {
            commit('SET_URL', { filePathKeyAndName: payload.sourceFilePathKey + payload.filename, url: response.data.url });
          }
          return response.data.url;
        });
      }
      var timerId = setInterval(function () {
        dispatch('getDownloadURL', payload).then(function (response) {
          if (payload.jobOutputPathKey) {
            commit('SET_URL', { filePathKeyAndName: payload.jobOutputPathKey + payload.filename, url: response.data.url });
          } else {
            commit('SET_URL', { filePathKeyAndName: payload.sourceFilePathKey + payload.filename, url: response.data.url });
          }
        });
      }, 15 * 60 * 1000);
      commit('SET_UPDATE_TIMER', timerId);
    },
    refreshFiles: function refreshFiles(_ref7, rule) {
      var _this = this;

      var rootState = _ref7.rootState,
          state = _ref7.state,
          commit = _ref7.commit;
      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var loadedFiles, token, limit, response, files, nextToken;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(rule === 'notFirstInit')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (rule === 'resetFiles') commit('RESET_UPLOADED_FILES');

                state.filesPagination.loading = true;
                loadedFiles = [];

              case 5:
                if (!state.filesPagination.isAllLoaded) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('break', 15);

              case 7:
                token = state.filesPagination.nextToken;
                limit = state.filesPagination.filesOnPage;
                _context.next = 11;
                return _axios2.default.post("https://dev.portal.atlas3d.xyz/graphql", {
                  query: 'query {\n              user: sourceFileByUser(\n                limit: ' + limit + '\n                userId: "' + rootState.user.siemensId + '"\n                sortDirection: DESC\n                nextToken: ' + (token ? '"' + token + '"' : null) + '\n                filter: {\n                  isDeleted: { eq: false }\n                }\n              ) {\n                sourceFiles: items {\n                  id\n                  name\n                  pathKey\n                  isVirus\n                  isInvalidStlFile\n                  fixOperation {\n                    status\n                    createdAt\n                    downloadedAt\n                    id\n                    updatedAt\n                  }\n                }\n                nextToken\n              }\n            }'
                }, {
                  headers: {
                    Authorization: '' + state.user.token,
                    'Content-Type': 'application/json'
                  }
                });

              case 11:
                response = _context.sent;


                response = (0, _helpers.errorHandlingAppSync)(response);

                if (response) {
                  files = response.data.user.sourceFiles;
                  nextToken = response.data.user.nextToken;

                  loadedFiles = loadedFiles.concat(files);

                  if (nextToken === null) commit('SET_FILES_IS_ALL_LOADED');
                  commit('SET_FILES_NEXT_TOKEN', nextToken);
                  commit('SET_LOAD_BY_ITERATION', files.length);
                }

              case 14:
                if (state.filesPagination.loadedByIteration < state.filesPagination.filesOnPage) {
                  _context.next = 5;
                  break;
                }

              case 15:

                commit('SET_FILES', { files: loadedFiles });
                commit('RESET_LOAD_BY_ITERATION');
                state.filesPagination.loading = false;

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadSourceFile: function loadSourceFile(_ref8, _ref9) {
      var state = _ref8.state,
          commit = _ref8.commit;
      var id = _ref9.id,
          forceRefresh = _ref9.forceRefresh;

      return new _promise2.default(function (resolve, reject) {
        var sourceFile = state.files.find(function (file) {
          return file.id === id;
        });
        if (sourceFile && !forceRefresh) {
          return resolve(sourceFile);
        }

        _axios2.default.post("https://dev.portal.atlas3d.xyz/graphql", {
          query: '\n            query {\n              sourceFile: getSourceFile(id: "' + id + '") {\n                id\n                name\n                pathKey\n                fixOperation {\n                  status\n                }\n              }\n            }'
        }, {
          headers: {
            Authorization: '' + state.user.token,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          response = (0, _helpers.errorHandlingAppSync)(response);
          if (response) {
            if (sourceFile) {
              commit('UPDATE_FILE', response.data.sourceFile);
            } else {
              commit('SET_FILE', response.data.sourceFile);
            }
            resolve(response.data.sourceFile);
          }
        }, reject);
      });
    },

    checkSourceFile: function () {
      var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref11, payload) {
        var commit = _ref11.commit,
            state = _ref11.state,
            rootState = _ref11.rootState;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new _promise2.default(function (resolve, reject) {
                  _axios2.default.post("https://dev.portal.atlas3d.xyz/graphql", {
                    query: 'query {\n                user: sourceFileByUser(\n                  userId: "' + rootState.user.siemensId + '",\n                  sortDirection: DESC,\n                  nextToken: null\n                  filter: {\n                    isDeleted: { eq: false },\n                    pathKey: { eq: "' + payload.pathKey + '" }\n                  }\n                ) {\n                  sourceFiles: items {\n                    id\n                    name\n                    pathKey\n                    isVirus\n                    isInvalidStlFile\n                    fixOperation {\n                      status\n                      createdAt\n                      downloadedAt\n                      id\n                      updatedAt\n                    }\n                  }\n                  nextToken\n                }\n              }'
                  }, {
                    headers: {
                      Authorization: '' + state.user.token,
                      'Content-Type': 'application/json'
                    }
                  }).then(function (response) {
                    response = (0, _helpers.errorHandlingAppSync)(response);
                    if (response) {
                      if (response.data.user.sourceFiles.length) {
                        commit('SET_FIRST_FILE', response.data.user.sourceFiles[0]);
                      }
                      resolve(response.data.user.sourceFiles);
                    }
                  }, reject);
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, undefined);
      }));

      return function checkSourceFile(_x, _x2) {
        return _ref10.apply(this, arguments);
      };
    }(),
    submitJob: function submitJob(_ref12, payload) {
      var state = _ref12.state,
          commit = _ref12.commit;

      var data = {
        jobPathKey: payload.jobPathKey,
        analysisId: payload.analysisId,
        objectiveId: payload.objectiveId
      };
      if (payload.hasOwnProperty('outputFilePathKey') && payload.hasOwnProperty('filename')) {
        data.outputFilePathKey = payload.outputFilePathKey;
        data.filename = payload.filename;
      }
      return _axios2.default.post(state.config.API_URL + '/jobs/submit', data, {
        headers: {
          Authorization: 'Bearer ' + state.user.token,
          'Content-Type': 'application/json'
        }
      });
    },
    updateJob: function updateJob(_ref13, payload) {
      var state = _ref13.state,
          commit = _ref13.commit;

      if ('AdditionalConfig' in payload.config) {
        payload.config.AdditionalConfig = payload.config.RestrictedFaces.length > 0 || payload.config.AllowedFaces.length > 0;
      }
      var data = {
        jobPathKey: payload.jobPathKey,
        config: payload.config,
        isArchived: false
      };
      if (payload.jobDescription) {
        data.jobDescription = (0, _helpers.escapeString)(payload.jobDescription);
      }
      return _axios2.default.post(state.config.API_URL + '/jobs/update', data, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      });
    },
    createJob: function createJob(_ref14, payload) {
      var state = _ref14.state,
          commit = _ref14.commit;

      payload.config.AdditionalConfig = payload.config.RestrictedFaces.length > 0 || payload.config.AllowedFaces.length > 0;
      return _axios2.default.post(state.config.API_URL + '/jobs/create', {
        sourceFilePathKey: payload.sourceFilePathKey,
        targetVersion: state.config.TARGET_VERSION,
        config: payload.config
      }, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      });
    },
    createNestedJob: function createNestedJob(_ref15, payload) {
      var state = _ref15.state,
          commit = _ref15.commit;

      return _axios2.default.post(state.config.API_URL + '/nested/create', {
        config: payload.config,
        nestedJobs: payload.nestedJobs,
        nestedJobName: (0, _helpers.escapeString)(payload.nestedJobName),
        targetVersion: state.config.TARGET_VERSION
      }, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      });
    },
    updateNestedJob: function updateNestedJob(_ref16, payload) {
      var state = _ref16.state,
          commit = _ref16.commit;

      return _axios2.default.post(state.config.API_URL + '/nested/update', {
        nestedJobs: payload.nestedJobs,
        nestedJobName: (0, _helpers.escapeString)(payload.nestedJobName),
        parentPathKey: payload.parentPathKey
      }, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      });
    },
    submitNestedJob: function submitNestedJob(_ref17, payload) {
      var state = _ref17.state,
          commit = _ref17.commit;

      return _axios2.default.post(state.config.API_URL + '/nested/submit', {
        nestedJobs: payload
      }, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      });
    },
    redeemJob: function redeemJob(_ref18, pathKey) {
      var state = _ref18.state,
          commit = _ref18.commit;

      return _axios2.default.post(state.config.API_URL + '/joboutputs/redeem', {
        jobOutputPathKey: pathKey
      }, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      });
    },
    uploadFile: function uploadFile(_ref19, payload) {
      var state = _ref19.state,
          commit = _ref19.commit;

      var data = {
        filename: payload.file.name
      };
      if (payload.hasOwnProperty('sourceFilePathKey') && payload.hasOwnProperty('jobPathKey')) {
        data.sourceFilePathKey = payload.sourceFilePathKey;
        data.jobPathKey = payload.jobPathKey;
      }
      return _axios2.default.post(state.config.API_URL + '/files/upload', data, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      }).then(function (response) {
        return _axios2.default.put(response.data.url, payload.file, {
          headers: {
            'Content-Type': 'application/octet-stream'
          },
          pathKey: response.data.filePathKey
        });
      });
    },
    deleteFile: function deleteFile(_ref20, file) {
      var state = _ref20.state,
          commit = _ref20.commit;

      return _axios2.default.post(state.config.API_URL + '/files/delete', {
        sourceFilePathKey: file.pathKey
      }, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      }).then(function (response) {
        commit('DELETE_FILE', file);
      });
    },
    repairFile: function repairFile(_ref21, file) {
      var state = _ref21.state,
          commit = _ref21.commit;

      return _axios2.default.post(state.config.API_URL + '/files/repair', {
        sourceFilePathKey: file.pathKey,
        config: (0, _assign2.default)({}, _helpers.defaultConfig, {
          filename: file.name,
          isRepair: true,
          tetraEps: [file.config.tetraEps],
          tetraMeshSize: [file.config.tetraMeshSize]
        }),
        targetVersion: state.config.TARGET_VERSION
      }, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      });
    },
    generateSupport: function generateSupport(_ref22, payload) {
      var state = _ref22.state,
          commit = _ref22.commit;

      payload.config.AdditionalConfig = payload.config.RestrictedFaces.length > 0 || payload.config.AllowedFaces.length > 0;
      return _axios2.default.post(state.config.API_URL + '/supports/preview', {
        sourceFilePathKey: payload.sourceFilePathKey,
        targetVersion: state.config.TARGET_VERSION,
        config: payload.config
      }, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      });
    },
    checkElementSize: function checkElementSize(_ref23, payload) {
      var state = _ref23.state,
          commit = _ref23.commit;

      return _axios2.default.post(state.config.API_URL + '/actions/check-size', {
        sourceFilePathKey: payload.sourceFilePathKey,
        targetVersion: state.config.TARGET_VERSION,
        config: payload.config
      }, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      });
    },
    remeshPart: function remeshPart(_ref24, payload) {
      var state = _ref24.state,
          dispatch = _ref24.dispatch;

      return _axios2.default.post(state.config.API_URL + '/actions/remesh', {
        sourceFilePathKey: payload.sourceFilePathKey,
        targetVersion: state.config.TARGET_VERSION,
        config: payload.config
      }, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      });
    },
    paintByCurvature: function paintByCurvature(_ref25, payload) {
      var state = _ref25.state,
          dispatch = _ref25.dispatch;

      return _axios2.default.post(state.config.API_URL + '/actions/paint', {
        sourceFilePathKey: payload.sourceFilePathKey,
        targetVersion: state.config.TARGET_VERSION,
        config: (0, _extends3.default)({}, payload.config, { filename_supp: '' })
      }, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      });
    },
    getJobsOrdered: function getJobsOrdered(_ref26) {
      var _this2 = this;

      var rootState = _ref26.rootState,
          state = _ref26.state,
          commit = _ref26.commit;
      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var loadedJobs, token, response, nextToken;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state.jobsPagination.loading = true;
                loadedJobs = {
                  sourceFiles: []
                };

              case 2:
                token = state.jobsPagination.nextToken;
                _context3.next = 5;
                return _axios2.default.post("https://dev.portal.atlas3d.xyz/graphql", {
                  query: 'query {\n                user: sourceFileByUser(\n                  userId: "' + rootState.user.siemensId + '",\n                  sortDirection: DESC,\n                  nextToken: ' + (token ? '"' + token + '"' : null) + '\n                  filter: {\n                    isDeleted: { eq: false }\n                  }\n                ) {\n                  sourceFiles: items {\n                    id\n                    pathKey\n                    name\n                    jobs (sortDirection: DESC) {\n                      items {\n                        id\n                        pathKey\n                        parentPathKey\n                        nestedJobName\n                        jobDescription\n                        config\n                        jobOutputs (sortDirection: DESC) {\n                          items {\n                            isArchived\n                          }\n                        }\n                        isNested\n                        isArchived\n                        createdAt\n                        updatedAt\n                      }\n                    }\n                  }\n                  nextToken\n                }\n              }'
                }, {
                  headers: {
                    Authorization: '' + state.user.token,
                    'Content-Type': 'application/json'
                  }
                });

              case 5:
                response = _context3.sent;


                response = (0, _helpers.errorHandlingAppSync)(response);
                nextToken = response.data.user.nextToken;


                response.data.user.sourceFiles = response.data.user.sourceFiles.map(function (file) {
                  var archived = void 0,
                      unarchived = void 0;

                  var jobs = file.jobs.map(function (job) {
                    if (job.jobOutputs.length) {
                      archived = job.jobOutputs.filter(function (job) {
                        return job.isArchived;
                      }).length;
                      unarchived = job.jobOutputs.length - archived;
                    } else {
                      archived = 0;
                      unarchived = 0;
                    }

                    var result = (0, _extends3.default)({}, job, {
                      jobOutputs: null,
                      jobOutputsCount: job.jobOutputs.length,
                      archived: {
                        count: archived
                      },
                      unarchived: {
                        count: unarchived
                      }
                    });
                    return result;
                  });
                  return (0, _extends3.default)({}, file, {
                    jobs: jobs
                  });
                });
                loadedJobs.sourceFiles = loadedJobs.sourceFiles.concat(response.data.user.sourceFiles);

                commit('SET_JOBS_NEXT_TOKEN', nextToken);

              case 11:
                if (state.jobsPagination.nextToken) {
                  _context3.next = 2;
                  break;
                }

              case 12:

                commit('SET_JOBS', { user: loadedJobs });

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    getJobsOutputs: function getJobsOutputs(_ref27, _ref28) {
      var state = _ref27.state,
          commit = _ref27.commit,
          dispatch = _ref27.dispatch;
      var sourceFilePathKey = _ref28.sourceFilePathKey,
          ids = _ref28.ids;

      var jobsById = ids.map(function (id) {
        return _axios2.default.post("https://dev.portal.atlas3d.xyz/graphql", {
          query: 'query {\n              Job: getJob (id: "' + id + '") {\n                id\n                pathKey\n                createdAt\n                updatedAt\n                jobDescription\n                jobOutputs {\n                  items {\n                    id\n                    status\n                    progress\n                    pathKey\n                    isArchived\n                    subscription {\n                      id\n                  }\n                  pathKey\n                  analysisId\n                  objectiveId\n                  outputFiles(limit: 10000) {\n                    items {\n                        name\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n            }'
        }, {
          headers: {
            Authorization: '' + state.user.token,
            'Content-Type': 'application/json'
          }
        });
      });
      return _promise2.default.all(jobsById).then(function (response) {
        var mappingResponse = {
          data: {
            data: {
              allJobs: []
            }
          }
        };
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(response), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var res = _step.value;

            if (res.data && res.data.data && res.data.data.Job) {
              mappingResponse.data.data.allJobs.push(res.data.data.Job);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        response = (0, _helpers.errorHandlingAppSync)(mappingResponse);
        var jobs = response.data.allJobs;
        jobs.forEach(function (job) {
          commit('SET_JOB_OUTPUTS', job);
        });
        return jobs;
      });
    },
    getJobOutputs: function getJobOutputs(_ref29, _ref30) {
      var state = _ref29.state,
          commit = _ref29.commit,
          dispatch = _ref29.dispatch;
      var jobPathKey = _ref30.jobPathKey,
          sourceFilePathKey = _ref30.sourceFilePathKey;

      return _axios2.default.post("https://dev.portal.atlas3d.xyz/graphql", {
        query: 'query {\n              Job: jobByPathKey(\n                pathKey: "' + jobPathKey + '"\n                sortDirection: DESC\n                ) {\n                item: items {\n                  id\n                  pathKey\n                  config\n                  parentPathKey\n                  nestedJobName\n                  isNested\n                  isArchived\n                  createdAt\n                  updatedAt\n                  jobDescription\n                  jobOutputs {\n                    items {\n                      id\n                      status\n                      progress\n                      pathKey\n                      isArchived\n                      subscription {\n                        id\n                      }\n                      pathKey\n                      analysisId\n                      objectiveId\n                      outputFiles(limit: 10000) {\n                        items {\n                          name\n                          id\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }'
      }, {
        headers: {
          Authorization: '' + state.user.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        response = (0, _helpers.errorHandlingAppSync)(response);
        var jobOutputs = response.data.Job;
        var sortOutputFiles = function sortOutputFiles(a, b) {
          if (a.name.match(/plate_[0-9]+\.stl$/) && b.name.match(/plate_[0-9]+\.stl$/)) {
            return Number(a.name.match(/plate_([0-9]+)\.stl$/)[1]) - Number(b.name.match(/plate_([0-9]+)\.stl$/)[1]);
          } else if (a.name.match(/support[0-9]+\.stl$/) && b.name.match(/support[0-9]+\.stl$/)) {
            return Number(a.name.match(/support([0-9]+)\.stl$/)[1]) - Number(b.name.match(/support([0-9]+)\.stl$/)[1]);
          } else if (a.name.match(/plate_[0-9]+\.stl$/) && b.name.match(/support[0-9]+\.stl$/)) {
            return -1;
          } else if (b.name.match(/plate_[0-9]+\.stl$/) && a.name.match(/support[0-9]+\.stl$/)) {
            return 1;
          }
        };
        jobOutputs.jobOutputs.forEach(function (jobOutput) {
          var paidFor = !!(jobOutput.credit || jobOutput.subscription) || jobOutput.analysisId === 0 && jobOutput.objectiveId === 0;
          if (paidFor) {
            jobOutput.outputFiles.sort(sortOutputFiles);
          }
        });
        commit('SET_JOB_OUTPUTS', jobOutputs);
        return new _promise2.default(function (resolve) {
          resolve(jobOutputs);
        }, function (reject) {});
      });
    },
    getJob: function getJob(_ref31, pathKey) {
      var state = _ref31.state,
          commit = _ref31.commit,
          dispatch = _ref31.dispatch;

      var mainResponse = void 0;
      return _axios2.default.post("https://dev.portal.atlas3d.xyz/graphql", {
        query: 'query {\n              Job: jobByPathKey(pathKey: "' + pathKey + '") {\n                item: items {\n                  id\n                  pathKey\n                  config\n                  parentPathKey\n                  nestedJobName\n                  jobDescription\n                  isNested\n                  isArchived\n                  createdAt\n                  updatedAt\n                  sourceFile {\n                    id\n                    pathKey\n                  }\n                  jobOutputs {\n                    items {\n                      id\n                      analysisId\n                      objectiveId\n                      isArchived\n                      pathKey\n                      progress\n                      status\n                      subscription {\n                        id\n                      }\n                      outputFiles(limit: 10000) {\n                        items {\n                          id\n                          name\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }'
      }, {
        headers: {
          Authorization: '' + state.user.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        response = (0, _helpers.errorHandlingAppSync)(response);
        if (response.data.Job.config.AdditionalConfig && response.data.Job.jobOutputs[0] && response.data.Job.jobOutputs[0].status === 'COMPLETED') {
          mainResponse = response;
          return dispatch('getDownloadURL', {
            sourceFilePathKey: response.data.Job.sourceFile.pathKey,
            jobPathKey: pathKey,
            filename: 'additional_config.json'
          }).then(function (response) {
            return dispatch('getURLData', { url: response.data.url });
          }).then(function (data) {
            mainResponse.data.config = (0, _assign2.default)(mainResponse.data.config, data.data);
            return mainResponse;
          });
        } else {
          commit('SET_JOB', {
            sourceFilePathKey: response.data.Job.sourceFile.pathKey,
            pathKey: response.data.Job.pathKey,
            job: response.data.Job
          });
          return response;
        }
      });
    },
    getNestedJobs: function getNestedJobs(_ref32, pathKey) {
      var state = _ref32.state,
          commit = _ref32.commit;

      return _axios2.default.post("https://dev.portal.atlas3d.xyz/graphql", {
        query: 'query {\n            allJobs: jobByParentPathKey(parentPathKey: "' + pathKey + '") {\n              items {\n                id\n                pathKey\n                config\n                parentPathKey\n                importance\n                quantity\n                isNested\n                isArchived\n                createdAt\n                updatedAt\n                sourceFile {\n                  id\n                  name\n                  pathKey\n                }\n              }\n            }\n          }'
      }, {
        headers: {
          Authorization: '' + state.user.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        response = (0, _helpers.errorHandlingAppSync)(response);
        return response;
      });
    },
    getJobById: function getJobById(_ref33, _ref34) {
      var state = _ref33.state,
          dispatch = _ref33.dispatch;
      var id = _ref34.id,
          jobPathKey = _ref34.jobPathKey;

      return new _promise2.default(function (resolve, reject) {
        var job = void 0;
        var file = void 0;
        if (state.jobs.sourceFiles) {
          file = state.jobs.sourceFiles.find(function (sourceFile) {
            return sourceFile.id === id;
          });
          job = file.jobs.find(function (jobItem) {
            return jobItem.pathKey === jobPathKey;
          });
          if (job) {
            resolve(job);
          }
        } else {
          dispatch('getJob', jobPathKey).then(function (response) {
            resolve(response.data.Job);
          });
        }
      });
    },
    getPrintConfig: function getPrintConfig(_ref35) {
      var state = _ref35.state;

      return _axios2.default.post(state.config.API_URL + '/files/printconfig', {
        targetVersion: state.config.TARGET_VERSION
      }, {
        headers: {
          Authorization: 'Bearer ' + state.user.token
        }
      });
    },
    clearUpdateTimers: function clearUpdateTimers(_ref36) {
      var state = _ref36.state,
          commit = _ref36.commit;

      state.updateTimers.forEach(function (timer) {
        clearInterval(timer);
      });
      commit('CLEAR_UPDATE_TIMERS');
    },
    setNestedFile: function setNestedFile(_ref37, payload) {
      var state = _ref37.state,
          commit = _ref37.commit;

      commit('SET_NESTED_FILE', payload);
    },
    setJobToCompare: function setJobToCompare(_ref38, _ref39) {
      var state = _ref38.state,
          commit = _ref38.commit;
      var job = _ref39.job,
          jobOutput = _ref39.jobOutput;

      var jobToState = (0, _helpers.buildJobToCompare)(job, jobOutput);
      if (jobToState.isNested) {
        commit('SET_NESTED_COMPARE_FILE', jobToState);
      } else {
        commit('SET_COMPARE_FILE', jobToState);
      }
    },
    removeJobFromCompare: function removeJobFromCompare(_ref40, _ref41) {
      var state = _ref40.state,
          commit = _ref40.commit;
      var job = _ref41.job,
          jobOutput = _ref41.jobOutput;

      var jobToState = (0, _helpers.buildJobToCompare)(job, jobOutput);
      if (jobToState.isNested) {
        commit('REMOVE_NESTED_COMPARE_FILE', jobToState);
      } else {
        commit('REMOVE_COMPARE_FILE', jobToState);
      }
    },
    removeCompareData: function removeCompareData(_ref42, payload) {
      var state = _ref42.state,
          commit = _ref42.commit;

      commit('REMOVE_COMPARE_DATA', payload);
    },
    resetCompareFiles: function resetCompareFiles(_ref43) {
      var state = _ref43.state,
          commit = _ref43.commit;

      commit('RESET_COMPARE_DATA');
    },
    setNestedFileData: function setNestedFileData(_ref44, payload) {
      var state = _ref44.state,
          commit = _ref44.commit;

      payload.forEach(function (job) {
        commit('SET_NESTED_FILE_DATA', job);
      });
    },
    resetJobs: function resetJobs(_ref45) {
      var commit = _ref45.commit;

      commit('RESET_JOBS');
    },
    submitTrialForm: function submitTrialForm(_ref46, _ref47) {
      var state = _ref46.state;
      var firstName = _ref47.firstName,
          lastName = _ref47.lastName,
          email = _ref47.email;

      return _axios2.default.post(state.config.API_TRIALS_URL + '/trial', { firstName: firstName, lastName: lastName, email: email });
    }
  },
  mutations: {
    'SET_URL': function SET_URL(state, _ref48) {
      var filePathKeyAndName = _ref48.filePathKeyAndName,
          url = _ref48.url;

      _vue2.default.set(state.fileUrls, filePathKeyAndName, url);
    },
    'SET_JOBS': function SET_JOBS(state, payload) {
      state.jobs.sourceFiles = state.jobs.sourceFiles.concat(payload.user.sourceFiles);
      state.jobsPagination.loading = false;
    },
    'SET_JOB': function SET_JOB(state, payload) {
      var fileIndex = -1;
      fileIndex = state.jobs.sourceFiles.findIndex(function (file) {
        return file.pathKey === payload.sourceFilePathKey;
      });
      if (fileIndex > -1) {
        var archived = void 0,
            unarchived = void 0;
        if (payload.job.jobOutputs.length > 0) {
          archived = payload.job.jobOutputs.filter(function (job) {
            return job.isArchived;
          }).length;
          unarchived = payload.job.jobOutputs.length - archived;
        } else {
          archived = 0;
          unarchived = 0;
        }
        payload.job.archived = { count: archived };
        payload.job.unarchived = { count: unarchived };
        var _jobs = state.jobs.sourceFiles[fileIndex].jobs.slice();
        _jobs.push(payload.job);
        state.jobs.sourceFiles.splice(fileIndex, 1, (0, _assign2.default)({}, state.jobs.sourceFiles[fileIndex], { jobs: _jobs }));
      }
    },
    'RESET_JOBS': function RESET_JOBS(state) {
      state.jobs.sourceFiles = [];
      state.jobsPagination.nextToken = null;
    },
    'SET_JOB_OUTPUTS': function SET_JOB_OUTPUTS(state, payload) {
      state.jobs.sourceFiles.forEach(function (sourceFile) {
        sourceFile.jobs.forEach(function (job) {
          if (job.pathKey === payload.pathKey) {
            _vue2.default.set(job, 'outputsLoaded', true);
            _vue2.default.set(job, 'jobOutputs', payload.jobOutputs);
          }
        });
      });
    },
    'SET_MATERIALS': function SET_MATERIALS(state, payload) {
      state.materials = payload;
    },
    'SET_PRINTERS': function SET_PRINTERS(state, payload) {
      state.printers = payload;
    },
    'ADD_CUSTOM_MATERIAL': function ADD_CUSTOM_MATERIAL(state, payload) {
      var findIdx = state.customMaterials.findIndex(function (material) {
        return material.name === payload.name;
      });
      if (findIdx > -1) {
        state.customMaterials.splice(findIdx, 1, payload);
      } else {
        state.customMaterials.push(payload);
      }
    },
    'ADD_CUSTOM_PRINTER': function ADD_CUSTOM_PRINTER(state, payload) {
      var findIdx = state.customPrinters.findIndex(function (printer) {
        return printer.name === payload.name;
      });
      if (findIdx > -1) {
        state.customPrinters.splice(findIdx, 1, payload);
      } else {
        state.customPrinters.push(payload);
      }
    },
    'REMOVE_CUSTOM_MATERIAL': function REMOVE_CUSTOM_MATERIAL(state, payload) {
      state.customMaterials = state.customMaterials.filter(function (material) {
        return material.name !== payload;
      });
    },
    'REMOVE_CUSTOM_PRINTER': function REMOVE_CUSTOM_PRINTER(state, payload) {
      state.customPrinters = state.customPrinters.filter(function (printer) {
        return printer.name !== payload;
      });
    },
    'ARCHIVE_JOB': function ARCHIVE_JOB(state, payload) {
      state.jobs.sourceFiles.forEach(function (file) {
        file.jobs.forEach(function (job) {
          if (job.pathKey === payload.jobPathKey) {
            _vue2.default.set(job, 'isArchived', payload.isArchived);
          }
        });
      });
    },
    'ARCHIVE_JOB_OUTPUT': function ARCHIVE_JOB_OUTPUT(state, payload) {
      state.jobs.sourceFiles.forEach(function (file) {
        if (file.pathKey === payload.sourceFilePathKey) {
          file.jobs.forEach(function (job) {
            if (job.pathKey === payload.jobPathKey) {
              var archivedCount = 0;
              var unarchivedCount = 0;
              if (payload.isArchived) {
                archivedCount = job.archived.count + 1;
                unarchivedCount = job.unarchived.count - 1;
              } else {
                archivedCount = job.archived.count - 1;
                unarchivedCount = job.unarchived.count + 1;
              }
              _vue2.default.set(job.archived, 'count', archivedCount);
              _vue2.default.set(job.unarchived, 'count', unarchivedCount);
              job.jobOutputs.forEach(function (jobOutput) {
                if (jobOutput.pathKey === payload.jobOutputPathKey) {
                  _vue2.default.set(jobOutput, 'isArchived', payload.isArchived);
                }
              });
            }
          });
        }
      });
    },
    'REMOVE_JOB': function REMOVE_JOB(state, payload) {
      var fileIndex = -1;
      var jobIndex = -1;
      fileIndex = state.jobs.sourceFiles.findIndex(function (file) {
        return file.pathKey === payload.sourceFilePathKey;
      });
      if (fileIndex > -1) {
        jobIndex = state.jobs.sourceFiles[fileIndex].jobs.findIndex(function (job) {
          return job.pathKey === payload.pathKey;
        });
        if (jobIndex > -1) {
          state.jobs.sourceFiles[fileIndex].jobs.splice(jobIndex, 1);
        }
      }
    },
    'SET_JOBS_NEXT_TOKEN': function SET_JOBS_NEXT_TOKEN(state, token) {
      state.jobsPagination.nextToken = token;
    },
    'SET_FILES': function SET_FILES(state, payload) {
      state.files = state.files.concat(payload.files);
    },
    'SET_LOAD_BY_ITERATION': function SET_LOAD_BY_ITERATION(state, payload) {
      state.filesPagination.loadedByIteration += payload;
    },
    'RESET_LOAD_BY_ITERATION': function RESET_LOAD_BY_ITERATION(state) {
      state.filesPagination.loadedByIteration = 0;
    },
    'DELETE_FILE': function DELETE_FILE(state, payload) {
      state.files = state.files.filter(function (el) {
        return el.id !== payload.id;
      });
    },
    'RESET_UPLOADED_FILES': function RESET_UPLOADED_FILES(state) {
      state.files = [];
      state.filesPagination.isAllLoaded = false;
      state.filesPagination.nextToken = null;
    },
    'SET_FILES_NEXT_TOKEN': function SET_FILES_NEXT_TOKEN(state, token) {
      state.filesPagination.nextToken = token;
    },
    'SET_FILES_IS_ALL_LOADED': function SET_FILES_IS_ALL_LOADED(state, token) {
      state.filesPagination.isAllLoaded = true;
    },
    'SET_FILE': function SET_FILE(state, file) {
      _vue2.default.set(state.files, state.files.length, file);
    },
    'SET_FIRST_FILE': function SET_FIRST_FILE(state, file) {
      state.files = [file].concat((0, _toConsumableArray3.default)(state.files));
    },
    'UPDATE_FILE': function UPDATE_FILE(state, file) {
      var index = state.files.findIndex(function (_file) {
        return _file.id === file.id && file;
      });
      _vue2.default.set(state.files, index, file);
    },
    'SET_AUTH': function SET_AUTH(state, auth) {
      state.auth = auth;
    },
    'SET_AUTHENTICATED': function SET_AUTHENTICATED(state, authenticated) {
      state.isAuthenticated = authenticated;
    },
    'SET_CONFIG': function SET_CONFIG(state, config) {
      _vue2.default.set(state, 'createConfig', config);
    },
    'SET_FILES_TOTAL': function SET_FILES_TOTAL(state, payload) {
      _vue2.default.set(state.filesPagination, 'totalFiles', payload);
    },
    'SET_TOTAL_JOBS': function SET_TOTAL_JOBS(state, payload) {
      _vue2.default.set(state.jobsProgress, 'total', payload);
    },
    'SET_LOADED_JOBS': function SET_LOADED_JOBS(state) {
      state.jobsProgress.loaded++;
    },
    'RESET_LOADED_JOBS': function RESET_LOADED_JOBS(state) {
      state.jobsProgress.loaded = 0;
    },
    'SET_UPDATE_TIMER': function SET_UPDATE_TIMER(state, timerId) {
      state.updateTimers.push(timerId);
    },
    'CLEAR_UPDATE_TIMERS': function CLEAR_UPDATE_TIMERS(state) {
      _vue2.default.set(state, 'updateTimers', []);
    },
    'SET_NESTED_FILE': function SET_NESTED_FILE(state, payload) {
      if (state.filesNested[payload.pathKey]) {
        _vue2.default.delete(state.filesNested, payload.pathKey);
      } else {
        _vue2.default.set(state.filesNested, payload.pathKey, {
          id: payload.id,
          name: payload.name,
          pathKey: payload.pathKey,
          quantity: 1,
          importance: 0.5,
          parentPathKey: null
        });
      }
    },
    'SET_NESTED_FILE_DATA': function SET_NESTED_FILE_DATA(state, payload) {
      _vue2.default.set(state.filesNested, payload.sourceFile.pathKey, {
        config: payload.config,
        name: payload.config.filename,
        importance: payload.importance,
        quantity: payload.quantity,
        pathKey: payload.sourceFile.pathKey,
        parentPathKey: payload.parentPathKey,
        jobPathKey: payload.pathKey,
        sourceFile: payload.sourceFile
      });
    },
    'SET_NESTED_FILE_URL': function SET_NESTED_FILE_URL(state, payload) {
      _vue2.default.set(state.filesNested[payload.sourceFilePathKey], 'downloadUrl', payload.url);
    },
    'SET_NESTED_FILE_CONFIG': function SET_NESTED_FILE_CONFIG(state, payload) {
      _vue2.default.set(state.filesNested[payload.pathKey], 'config', payload.config);
    },
    'SET_NESTED_FILE_NAME': function SET_NESTED_FILE_NAME(state, name) {
      _vue2.default.set(state, 'filesNestedJobName', name);
    },
    'SET_COMPARE_FILE': function SET_COMPARE_FILE(state, payload) {
      var jobOutputPathKey = payload.jobOutputPathKey;


      if (!state.filesCompare[jobOutputPathKey]) {
        _vue2.default.set(state.filesCompare, jobOutputPathKey, payload);
      }
    },
    'SET_NESTED_COMPARE_FILE': function SET_NESTED_COMPARE_FILE(state, payload) {
      var jobOutputPathKey = payload.jobOutputPathKey;


      if (!state.nestedFilesCompare[jobOutputPathKey]) {
        _vue2.default.set(state.nestedFilesCompare, jobOutputPathKey, payload);
      }
    },
    'REMOVE_COMPARE_FILE': function REMOVE_COMPARE_FILE(state, payload) {
      var jobOutputPathKey = payload.jobOutputPathKey;


      if (state.filesCompare[jobOutputPathKey]) {
        _vue2.default.delete(state.filesCompare, jobOutputPathKey);
      }
    },
    'REMOVE_NESTED_COMPARE_FILE': function REMOVE_NESTED_COMPARE_FILE(state, payload) {
      var jobOutputPathKey = payload.jobOutputPathKey;


      if (state.nestedFilesCompare[jobOutputPathKey]) {
        _vue2.default.delete(state.nestedFilesCompare, jobOutputPathKey);
      }
    },
    'RESET_COMPARE_DATA': function RESET_COMPARE_DATA(state) {
      _vue2.default.set(state, 'filesCompare', {});
      _vue2.default.set(state, 'nestedFilesCompare', {});
    },
    'REMOVE_COMPARE_DATA': function REMOVE_COMPARE_DATA(state, payload) {
      if (state.filesCompare[payload]) {
        _vue2.default.delete(state.filesCompare, payload);
      } else if (state.nestedFilesCompare[payload]) {
        _vue2.default.delete(state.nestedFilesCompare, payload);
      }
    },
    'UPDATE_DESIRED_QUANTITY': function UPDATE_DESIRED_QUANTITY(state, payload) {
      _vue2.default.set(state.filesNested[payload.pathKey], 'quantity', Number(payload.value));
    },
    'UPDATE_RELATIVE_IMPORTANCE': function UPDATE_RELATIVE_IMPORTANCE(state, payload) {
      _vue2.default.set(state.filesNested[payload.pathKey], 'importance', Number(payload.value));
    },
    'RESET_NESTED_DATA': function RESET_NESTED_DATA(state) {
      _vue2.default.set(state, 'filesNested', {});
      _vue2.default.set(state, 'filesNestedJobName', '');
    },
    'SET_URL_CONFIG': function SET_URL_CONFIG(state, payload) {
      _vue2.default.set(state.config, 'API_URL', payload.API_URL);
      _vue2.default.set(state.config, 'API_TRIALS_URL', payload.API_TRIALS_URL);
      _vue2.default.set(state.config, 'AUTH0_CALLBACK_URL', payload.AUTH0_CALLBACK_URL);
    },
    'TOGGLE_GETTING_FILE_URL': function TOGGLE_GETTING_FILE_URL(state, flag) {
      _vue2.default.set(state, 'gettingFileURL', flag);
    },
    'SET_WEBGL_STATUS': function SET_WEBGL_STATUS(state, status) {
      _vue2.default.set(state, 'webGL', status);
    }
  },
  getters: {
    filesFormatted: function filesFormatted(state) {
      var parentJobs = [];
      var filesFormatted = [];
      var jobs = state.jobs;
      if (!(jobs && jobs.sourceFiles)) {
        return [];
      }
      filesFormatted = [].concat(state.jobs.sourceFiles.filter(function (file) {
        return file.jobs.length > 0;
      })).map(function (file) {
        file.jobs.sort(function (prev, next) {
          return new Date(next.createdAt) - new Date(prev.createdAt);
        });
        return file;
      }).map(function (file) {
        var sortDate = file.jobs.find(function (job) {
          return !(job.isNested || job.parentPathKey);
        });
        if (!sortDate) {
          sortDate = file.jobs[0].createdAt;
        } else {
          sortDate = sortDate.createdAt;
        }
        var archivedCount = 0;
        var unarchivedCount = 0;
        var fileData = {
          id: file.id,
          name: file.name,
          pathKey: file.pathKey,
          jobs: file.jobs.map(function (job) {
            archivedCount += job.archived.count;
            unarchivedCount += job.unarchived.count;
            var jobFormatted = {
              filename: file.name,
              sourceFilePathKey: file.pathKey,
              id: file.id,
              jobId: job.id,
              config: job.config,
              jobPathKey: job.pathKey,
              parentPathKey: job.parentPathKey,
              isNested: !!(job.isNested || job.nestedJobName),
              nestedJobName: job.nestedJobName,
              nestedJobs: [],
              jobDescription: job.jobDescription,
              isArchived: job.isArchived,
              archived: job.archived.count,
              unarchived: job.unarchived.count,
              createdAt: job.createdAt,
              updatedAt: job.updatedAt,
              outputsLoaded: job.outputsLoaded,
              jobOutputs: job.jobOutputs ? job.jobOutputs.map(function (jobOutput) {
                var outputFilesKeys = {};
                var outputFiles = jobOutput.outputFiles.filter(function (file) {
                  if (!outputFilesKeys.hasOwnProperty(file.name)) {
                    outputFilesKeys[file.name] = true;
                    return true;
                  }
                  return false;
                });
                return {
                  id: jobOutput.id,
                  objectiveId: jobOutput.objectiveId,
                  analysisId: jobOutput.analysisId,
                  jobOutputPathKey: jobOutput.pathKey,
                  isArchived: jobOutput.isArchived,
                  'status': jobOutput.status,
                  progress: jobOutput.progress,
                  paidfor: !!(jobOutput.credit || jobOutput.subscription),
                  outputFiles: outputFiles
                };
              }) : null,
              jobOutputsCount: job.jobOutputsCount
            };
            if ((job.isNested || job.nestedJobName) && job.jobOutputsCount > 0) {
              parentJobs.push((0, _extends3.default)({}, jobFormatted, {
                sortDate: jobFormatted.createdAt
              }));
            }
            return jobFormatted;
          }),
          isNested: false,
          sortDate: sortDate
        };
        _vue2.default.set(fileData, 'archived', archivedCount);
        _vue2.default.set(fileData, 'unarchived', unarchivedCount);
        return fileData;
      });

      filesFormatted.forEach(function (file) {
        file.jobs.forEach(function (job) {
          var parentJob = parentJobs.find(function (pJob) {
            return pJob.jobPathKey === job.parentPathKey;
          });
          if (parentJob) {
            parentJob.nestedJobs.push(job);
          }
        });
      });

      filesFormatted = filesFormatted.map(function (file) {
        return (0, _extends3.default)({}, file, {
          jobs: file.jobs.filter(function (job) {
            return !(job.isNested || job.parentPathKey) && job.jobOutputsCount > 0;
          })
        });
      });
      filesFormatted = filesFormatted.filter(function (file) {
        return file.jobs.length > 0;
      });

      filesFormatted = filesFormatted.concat(parentJobs);
      filesFormatted.sort(function (a, b) {
        return new Date(b.sortDate) - new Date(a.sortDate);
      });
      return filesFormatted;
    },
    jobById: function jobById(state) {
      return function (fileId, jobPathKey) {
        var file = state.jobs.sourceFiles.find(function (sourceFile) {
          return sourceFile.id === fileId;
        });
        if (file) {
          return file.jobs.find(function (job) {
            return job.pathKey === jobPathKey;
          });
        }
      };
    },
    materials: function materials(state) {
      return state.materials.concat(state.customMaterials, { name: 'Custom Material...' });
    },
    predefinedMaterials: function predefinedMaterials(state) {
      return state.materials.length;
    },
    predefinedPrinters: function predefinedPrinters(state) {
      return state.printers.length;
    },
    printers: function printers(state) {
      return state.printers.concat(state.customPrinters, { name: 'Custom Printer...' });
    }
  },
  modules: {
    billing: _billing2.default,
    user: _user2.default,
    _jobs: _jobs3.default,
    notifications: _notifications2.default
  }
});

exports.default = store;

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(492),
  /* scopeId */
  "data-v-a5456eb0",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/BuyCredits.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] BuyCredits.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a5456eb0", Component.options)
  } else {
    hotAPI.reload("data-v-a5456eb0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(500)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(477),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/node_modules/vue-my-dropdown/src/vue-my-dropdown.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] vue-my-dropdown.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3764253e", Component.options)
  } else {
    hotAPI.reload("data-v-3764253e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerTrials = exports.router = undefined;

var _vue = __webpack_require__(79);

var _vue2 = _interopRequireDefault(_vue);

var _AuthService = __webpack_require__(312);

var _AuthService2 = _interopRequireDefault(_AuthService);

var _vueRouter = __webpack_require__(497);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(49);

var _store2 = _interopRequireDefault(_store);

var _Dash = __webpack_require__(461);

var _Dash2 = _interopRequireDefault(_Dash);

var _Files = __webpack_require__(463);

var _Files2 = _interopRequireDefault(_Files);

var _Start = __webpack_require__(470);

var _Start2 = _interopRequireDefault(_Start);

var _Login = __webpack_require__(465);

var _Login2 = _interopRequireDefault(_Login);

var _Callback = __webpack_require__(458);

var _Callback2 = _interopRequireDefault(_Callback);

var _Create = __webpack_require__(459);

var _Create2 = _interopRequireDefault(_Create);

var _Splash = __webpack_require__(469);

var _Splash2 = _interopRequireDefault(_Splash);

var _Viewer = __webpack_require__(472);

var _Viewer2 = _interopRequireDefault(_Viewer);

var _Nested = __webpack_require__(466);

var _Nested2 = _interopRequireDefault(_Nested);

var _Onboard = __webpack_require__(468);

var _Onboard2 = _interopRequireDefault(_Onboard);

var _Trial = __webpack_require__(471);

var _Trial2 = _interopRequireDefault(_Trial);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = exports.router = new _vueRouter2.default({
  mode: 'history',
  routes: [{
    path: '/dash',
    component: _Dash2.default,
    meta: {
      requiresAuth: true
    },
    children: [{
      path: '',
      name: 'Dash',
      component: _Files2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'magic/:jobPath',
      name: 'Magic',

      component: _Start2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'create/:id/:jobPathKey',

      name: 'ContinueCreateJob',
      component: _Create2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'create/:id',

      name: 'CreateJob',
      component: _Create2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'nested/create/:id',
      name: 'NestedCreateById',
      component: _Create2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'nested/create/',
      name: 'NestedCreate',
      component: _Create2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'nested/magic/',
      name: 'NestedMagic',
      component: _Start2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'nested/magic/:id',
      name: 'NestedMagicById',
      component: _Start2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'nested/',
      name: 'NestedQuantity',
      component: _Nested2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'nested/:id',
      name: 'NestedQuantityById',
      component: _Nested2.default,
      meta: {
        requiresAuth: true
      }
    }]
  }, {
    path: '/viewer/:type/:id',
    name: 'ThreeJSViewer',

    component: _Viewer2.default,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/onboarding',
    name: 'Onboard',
    component: _Onboard2.default,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/login',
    name: 'Login',
    component: _Login2.default
  }, {
    path: '/callback',
    name: 'Callback',
    component: _Callback2.default
  }, {
    path: '/splash',
    name: 'Splash',
    component: _Splash2.default,
    alias: '/logout'
  }, {
    path: '*',
    redirect: '/splash'
  }]
});

var routerTrials = exports.routerTrials = new _vueRouter2.default({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Trial',
    component: _Trial2.default
  }, {
    path: '*',
    redirect: '/'
  }]
});

router.beforeEach(function (to, from, next) {
  _store2.default.dispatch('getConfig');
  if (_store2.default.state.auth === null) {
    var auth = new _AuthService2.default();

    _store2.default.commit('SET_AUTH', auth);
    auth.authNotifier.on('authChange', function (authState) {
      _store2.default.commit('SET_AUTHENTICATED', authState.authenticated);
    });
  }
  if (to.meta.requiresAuth) {
    var token = localStorage.getItem('id_token');
    var siemensId = localStorage.getItem('siemens_id');
    var lastLogin = localStorage.getItem('last_login');
    var tokenNx = to.query.token;
    if (tokenNx) {
      _store2.default.commit('user/SET_TOKEN', tokenNx);
      return next();
    } else if (token && siemensId) {
      var expiration = JSON.parse(localStorage.getItem('expires_at'));
      if (expiration > new Date().getTime()) {
        _store2.default.commit('user/SET_TOKEN', token);
        _store2.default.commit('user/SET_SIEMENS_ID', siemensId);
        _store2.default.commit('SET_AUTHENTICATED', _store2.default.state.auth.authenticated);

        if (lastLogin) {
          _store2.default.commit('user/SET_LAST_LOGIN', JSON.parse(lastLogin));
        }

        var createAndLoadUser = function createAndLoadUser() {
          return _store2.default.dispatch('user/createUser').then(function () {
            return _store2.default.dispatch('user/loadUser');
          });
        };

        if (_store2.default.state.user.isOnboard === null) {
          return _store2.default.dispatch('user/loadUser').then(function () {
            if (!_store2.default.state.user.loaded) return createAndLoadUser();
          }).then(function () {
            if (to.name === 'Onboard') {
              _store2.default.state.user.isOnboard ? next('/dash') : next();
            } else {
              _store2.default.state.user.isOnboard ? next() : next('/onboarding');
            }
          }).catch(function () {
            return next('/splash');
          });
        } else {
          if (to.name === 'Onboard') {
            return _store2.default.state.user.isOnboard ? next('/dash') : next();
          } else {
            return _store2.default.state.user.isOnboard ? next() : next('/onboarding');
          }
        }
      }
    }
    return next('/splash');
  }

  next();
});

routerTrials.beforeEach(function (to, from, next) {
  _store2.default.dispatch('getConfig');
  next();
});

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(50);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = __webpack_require__(24);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(17);

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__(33);

var _errorHandling = __webpack_require__(23);

var _errorHandling2 = _interopRequireDefault(_errorHandling);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_errorHandling2.default],
  data: function data() {
    return {
      isOpen: false,
      isLoading: false,
      jobsFilesToggle: [],
      temperatureFilesToggle: [],
      jobsFilesCompensatedToggle: [],
      jobsFilesSupportVisible: [],
      jobsFilesSupportCompensatedVisible: [],
      jobsFilesPartVisible: [],
      jobsFilesPartCompensatedVisible: [],
      archivingProcess: {},
      unarchivingProcess: {},
      timers: []
    };
  },

  methods: {
    buymodal: function buymodal() {
      this.$modal.show('details');
    },
    isCost: function isCost(outputFiles) {
      var isCost = false;
      outputFiles.forEach(function (file) {
        if (file.name.match(/cost.json$/) || file.name.match(/buildCostNesting.json$/)) {
          isCost = true;
        }
      });
      return isCost;
    },
    isNestedConfig: function isNestedConfig(outputFiles) {
      var isNestingConfig = false;
      outputFiles.forEach(function (file) {
        if (file.name.match(/configNesting.json$/)) {
          isNestingConfig = true;
        }
      });
      return isNestingConfig;
    },
    fileDownload: function fileDownload(event, _ref) {
      var _this = this;

      var filename = _ref.filename,
          sourceFilePathKey = _ref.sourceFilePathKey,
          jobPathKey = _ref.jobPathKey,
          jobOutputPathKey = _ref.jobOutputPathKey,
          newTab = _ref.newTab;

      if (!this.gettingFileURL) {
        event.stopPropagation();
        var originalTitle = event.target.innerHTML;
        event.target.innerHTML = 'Downloading...';
        event.target.disabled = true;
        this.$store.commit('TOGGLE_GETTING_FILE_URL', true);
        return this.getDownloadURL({ filename: filename, sourceFilePathKey: sourceFilePathKey, jobPathKey: jobPathKey, jobOutputPathKey: jobOutputPathKey }).then(function (response) {
          if (newTab) {
            _this.getURLData({ url: response.data.url, blob: true }).then(function (data) {
              (0, _helpers.downloadFileBlob)(data.data, filename);
              event.target.innerHTML = originalTitle;
              event.target.disabled = false;
            });
          } else {
            location.assign(response.data.url);
            event.target.innerHTML = originalTitle;
            event.target.disabled = false;
          }
          _this.$store.commit('TOGGLE_GETTING_FILE_URL', false);
        }).catch(function (err) {
          event.target.innerHTML = originalTitle;
          event.target.disabled = false;
          _this.$store.commit('TOGGLE_GETTING_FILE_URL', false);
          console.log(err);
        });
      }
    },
    allFilesDownload: function allFilesDownload(event, _ref2) {
      var _this2 = this;

      var list = _ref2.list,
          sourceFilePathKey = _ref2.sourceFilePathKey,
          jobPathKey = _ref2.jobPathKey,
          jobOutputPathKey = _ref2.jobOutputPathKey,
          newTab = _ref2.newTab;

      return new _promise2.default(function (resolve) {
        var downloadFile = function downloadFile(i) {
          if (i === list.length) return resolve();
          _this2.fileDownload(event, { filename: list[i].name, sourceFilePathKey: sourceFilePathKey, jobPathKey: jobPathKey, jobOutputPathKey: jobOutputPathKey }).then(function () {
            return downloadFile(i + 1);
          });
        };
        downloadFile(0);
      });
    },
    getJobsProgress: function getJobsProgress(_ref3) {
      var _this3 = this;

      var jobPathKey = _ref3.jobPathKey,
          sourceFilePathKey = _ref3.sourceFilePathKey;

      return new _promise2.default(function (resolve, reject) {
        _this3.getJobOutputs({ jobPathKey: jobPathKey, sourceFilePathKey: sourceFilePathKey }).then(function (output) {
          var jobs = output.jobOutputs;
          var unfinishedJobs = _this3.countUnfinishedJobs(jobs);
          if (jobs && jobs.length > 0 && unfinishedJobs > 0) {
            var timerId = setTimeout(function () {
              _this3.getJobsProgress({ jobPathKey: jobPathKey, sourceFilePathKey: sourceFilePathKey });
            }, 30000);
            _this3.timers.push(timerId);
          } else {
            resolve();
          }
        }).catch(function (err) {
          _this3.errorHandling(err, function () {
            _this3.getJobsProgress({ jobPathKey: jobPathKey, sourceFilePathKey: sourceFilePathKey });
          });
        });
      });
    },
    countUnfinishedJobs: function countUnfinishedJobs(jobs) {
      var unfinishedJobs = void 0;
      if (jobs && jobs.length > 0) {
        unfinishedJobs = jobs.length;
        jobs.forEach(function (job) {
          if (job.outputFiles && job.outputFiles.length > 0 || job.status === 'COMPLETE' || job.status === 'ERROR') {
            unfinishedJobs--;
          }
        });
      }
      return unfinishedJobs;
    },
    createJob: function createJob(id, jobPathKey) {
      this.$router.push({ name: 'ContinueCreateJob', params: { id: id, jobPathKey: jobPathKey } });
    },
    unlockJob: function unlockJob(event, jobOutput, job) {
      var _this4 = this;

      var defaultMessage = event.target.innerHTML;
      event.target.innerHTML = 'Unlocking...';
      event.target.disabled = true;
      this.redeemJob(jobOutput.jobOutputPathKey).then(function () {
        return _this4.getJobOutputs({ jobPathKey: job.jobPathKey, sourceFilePathKey: job.sourceFilePathKey });
      }).then(function () {
        return _this4.refreshCredits();
      }).catch(function (err) {
        _this4.errorHandling(err);
        event.target.innerHTML = defaultMessage;
        event.target.disabled = false;
      });
    },
    removeJobConfirmation: function removeJobConfirmation(event, sourceFilePathKey, pathKey) {
      this.$modal.show('removemodal', {
        element: event,
        sourceFilePathKey: sourceFilePathKey,
        pathKey: pathKey
      });
    },
    resubmitJobConfirmation: function resubmitJobConfirmation(event, data) {
      this.$modal.show('resubmitjobmodal', (0, _assign2.default)(data, { element: event }));
    },

    displayMessage: function displayMessage(status) {
      switch (status) {
        case 'PROCESSING':
          return 'Processing...';
        case 'QUEUED':
          return 'Job Queued...';
        case 'CREATED':
          return 'Job Created.';
        case 'COMPLETE':
          return 'Job Complete..';
        case 'ERROR':
          return 'Error in processing job.  Please contact hao.peng@siemens.com';
      }
    },
    jobDescription: function jobDescription(analysisId, objectiveId, compensated) {
      return (0, _helpers.jobDescription)(analysisId, objectiveId, compensated);
    },
    isHasOutput: function isHasOutput(filesList) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(filesList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var file = _step.value;

          if (file.name.match(/(.*)_output\.stl$/) || file.name.match(/(.*)_new\.stl$/)) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },
    isHasLog: function isHasLog(filesList) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(filesList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var file = _step2.value;

          if (file.name.match(/Log[_A-Za-z]*\.txt$/)) {
            return file.name;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return false;
    },
    isHasConfigJson: function isHasConfigJson(filesList) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(filesList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var file = _step3.value;

          if (file.name.match(/^config\.json$/)) {
            return file.name;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return false;
    },
    isHasCompensated: function isHasCompensated(filesList) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = (0, _getIterator3.default)(filesList), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var file = _step4.value;

          if (file.name.match(/output_compensated\.stl$/) || file.name.match(/_compensated_0m\.stl$/)) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    },
    showEstimateCost: function showEstimateCost(event, _ref4) {
      var _this5 = this;

      var filename = _ref4.filename,
          sourceFilePathKey = _ref4.sourceFilePathKey,
          jobPathKey = _ref4.jobPathKey,
          jobOutputPathKey = _ref4.jobOutputPathKey;

      event.target.innerHTML = 'Estimating...';
      event.target.disabled = true;
      this.getDownloadURL({ filename: filename, sourceFilePathKey: sourceFilePathKey, jobPathKey: jobPathKey, jobOutputPathKey: jobOutputPathKey }).then(function (response) {
        return _this5.getURLData({ url: response.data.url });
      }).then(function (response) {
        event.target.innerHTML = 'Estimate print costs';
        event.target.disabled = false;
        _this5.$modal.show('estimate-cost', { data: response.data });
      }).catch(function (err) {
        event.target.innerHTML = 'Estimate print costs';
        event.target.disabled = false;
        _this5.errorHandling(err, function () {
          _this5.showEstimateCost(event, { filename: filename, sourceFilePathKey: sourceFilePathKey, jobPathKey: jobPathKey, jobOutputPathKey: jobOutputPathKey });
        });
      });
    }
  }
};

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(501)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(478),
  /* scopeId */
  "data-v-38ba4ea0",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Banner.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Banner.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38ba4ea0", Component.options)
  } else {
    hotAPI.reload("data-v-38ba4ea0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(503)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(480),
  /* scopeId */
  "data-v-3cf5c9a2",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Files/JobOutput.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] JobOutput.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3cf5c9a2", Component.options)
  } else {
    hotAPI.reload("data-v-3cf5c9a2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(504)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(481),
  /* scopeId */
  "data-v-3e32201d",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/JobSummary.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] JobSummary.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3e32201d", Component.options)
  } else {
    hotAPI.reload("data-v-3e32201d", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(65);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(66);

var _createClass3 = _interopRequireDefault(_createClass2);

var _store = __webpack_require__(49);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notifications = function () {
  function Notifications() {
    (0, _classCallCheck3.default)(this, Notifications);
    this.notifications = [];
  }

  (0, _createClass3.default)(Notifications, [{
    key: 'add',
    value: function add(payload) {
      _store2.default.dispatch('notifications/add', payload);
    }
  }, {
    key: 'remove',
    value: function remove(index) {
      _store2.default.dispatch('notifications/remove', index);
    }
  }]);
  return Notifications;
}();

exports.default = Notifications;

/***/ }),
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(509)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(486),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6fe9077c", Component.options)
  } else {
    hotAPI.reload("data-v-6fe9077c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(80);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(65);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(66);

var _createClass3 = _interopRequireDefault(_createClass2);

var _auth0Js = __webpack_require__(294);

var _auth0Js2 = _interopRequireDefault(_auth0Js);

var _eventemitter = __webpack_require__(434);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _router = __webpack_require__(135);

var _store = __webpack_require__(49);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthService = function () {
  function AuthService() {
    (0, _classCallCheck3.default)(this, AuthService);

    this.auth0 = new _auth0Js2.default.WebAuth({
      domain: "siemens-qa-00101.eu.auth0.com",
      clientID: "x9pbpJvypSwRdxhD4h8UdZf46Yx73NcD",
      redirectUri: _store2.default.state.config.AUTH0_CALLBACK_URL,
      responseType: 'id_token token'
    });
    this.authenticated = this.isAuthenticated();
    this.authNotifier = new _eventemitter2.default();
    this.login = this.login.bind(this);
    this.setSession = this.setSession.bind(this);
    this.logout = this.logout.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
  }

  (0, _createClass3.default)(AuthService, [{
    key: 'login',
    value: function login(isSignup) {
      this.auth0.authorize({
        connection: 'main-tenant-oidc',
        scope: 'openid profile email user_metadata',
        display: isSignup ? 'sup-active' : 'sup' });
    }
  }, {
    key: 'handleAuthentication',
    value: function handleAuthentication() {
      var _this = this;

      this.auth0.parseHash({ hash: window.location.hash }, function (err, authResult) {
        if (err) {
          _router.router.replace('splash');
          alert('Error logging in.');
        } else {
          _this.setSession(authResult);
          _router.router.push({ name: 'Dash' });
        }
      });
    }
  }, {
    key: 'setSession',
    value: function setSession(authResult) {
      var siemensId = authResult.idTokenPayload['https://login.siemens.com/gid'];
      var lastLogin = authResult.idTokenPayload['https://login.siemens.com/ll'];
      _store2.default.commit('user/SET_TOKEN', authResult.idToken);
      _store2.default.commit('user/SET_SIEMENS_ID', siemensId);
      if (lastLogin) {
        _store2.default.commit('user/SET_LAST_LOGIN', {
          date: lastLogin.last_login,
          ip: lastLogin.last_ip,
          geo: lastLogin.last_geo
        });
      }

      var expiresAt = authResult.idTokenPayload.exp * 1000;

      localStorage.setItem('siemens_id', siemensId);
      localStorage.setItem('access_token', authResult.accessToken);
      localStorage.setItem('id_token', authResult.idToken);
      localStorage.setItem('expires_at', expiresAt);
      if (lastLogin) {
        localStorage.setItem('last_login', (0, _stringify2.default)({
          date: lastLogin.last_login,
          ip: lastLogin.last_ip,
          geo: lastLogin.last_geo
        }));
      }
      this.authNotifier.emit('authChange', { authenticated: true });
    }
  }, {
    key: 'logout',
    value: function logout() {
      localStorage.removeItem('access_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('siemens_id');
      localStorage.removeItem('expires_at');
      localStorage.removeItem('jobSpecification');
      localStorage.removeItem('last_login');
      this.userProfile = null;
      this.authNotifier.emit('authChange', false);

      var getUrl = window.location;
      var baseUrl = getUrl.protocol + '//' + getUrl.host;
      window.location = 'https://' + "login-qa.siemens.com" + '/v2/logout?returnTo=' + ('' + encodeURIComponent('https://' + "siemens-qa-00101.eu.auth0.com" + '/v2/logout?returnTo=' + (baseUrl + '/logout&client_id=' + "x9pbpJvypSwRdxhD4h8UdZf46Yx73NcD")));
    }
  }, {
    key: 'isAuthenticated',
    value: function isAuthenticated() {
      var expiresAt = JSON.parse(localStorage.getItem('expires_at'));
      return new Date().getTime() < expiresAt;
    }
  }]);
  return AuthService;
}();

exports.default = AuthService;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(17);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(137);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(136);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

__webpack_require__(271);

__webpack_require__(276);

__webpack_require__(279);

__webpack_require__(280);

__webpack_require__(274);

__webpack_require__(277);

__webpack_require__(275);

__webpack_require__(278);

__webpack_require__(272);

__webpack_require__(273);

__webpack_require__(206);

__webpack_require__(262);

__webpack_require__(281);

__webpack_require__(282);

__webpack_require__(244);

__webpack_require__(245);

__webpack_require__(246);

__webpack_require__(247);

__webpack_require__(250);

__webpack_require__(248);

__webpack_require__(249);

__webpack_require__(251);

__webpack_require__(252);

__webpack_require__(253);

__webpack_require__(254);

__webpack_require__(256);

__webpack_require__(255);

__webpack_require__(243);

__webpack_require__(270);

__webpack_require__(232);

__webpack_require__(242);

__webpack_require__(241);

__webpack_require__(237);

__webpack_require__(238);

__webpack_require__(236);

__webpack_require__(233);

__webpack_require__(235);

__webpack_require__(240);

__webpack_require__(234);

__webpack_require__(231);

__webpack_require__(239);

__webpack_require__(205);

__webpack_require__(267);

__webpack_require__(265);

__webpack_require__(263);

__webpack_require__(268);

__webpack_require__(269);

__webpack_require__(264);

__webpack_require__(266);

__webpack_require__(257);

__webpack_require__(258);

__webpack_require__(259);

__webpack_require__(261);

__webpack_require__(260);

__webpack_require__(203);

__webpack_require__(204);

__webpack_require__(199);

__webpack_require__(202);

__webpack_require__(201);

__webpack_require__(200);

__webpack_require__(97);

__webpack_require__(225);

__webpack_require__(226);

__webpack_require__(228);

__webpack_require__(227);

__webpack_require__(224);

__webpack_require__(230);

__webpack_require__(229);

__webpack_require__(207);

__webpack_require__(208);

__webpack_require__(209);

__webpack_require__(210);

__webpack_require__(211);

__webpack_require__(212);

__webpack_require__(213);

__webpack_require__(214);

__webpack_require__(215);

__webpack_require__(216);

__webpack_require__(218);

__webpack_require__(217);

__webpack_require__(219);

__webpack_require__(220);

__webpack_require__(221);

__webpack_require__(222);

__webpack_require__(223);

__webpack_require__(283);

__webpack_require__(286);

__webpack_require__(284);

__webpack_require__(285);

__webpack_require__(288);

__webpack_require__(287);

__webpack_require__(291);

__webpack_require__(290);

__webpack_require__(289);

__webpack_require__(138);

var _vue = __webpack_require__(79);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(64);

var _axios2 = _interopRequireDefault(_axios);

var _App = __webpack_require__(293);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(135);

var _store = __webpack_require__(49);

var _store2 = _interopRequireDefault(_store);

var _vueJsModal = __webpack_require__(292);

var _vueJsModal2 = _interopRequireDefault(_vueJsModal);

var _notifications = __webpack_require__(198);

var _notifications2 = _interopRequireDefault(_notifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.validateStatus = function (status) {
  return status < 400;
};

var prevSessionCheck = new Date().getTime();

var checkSession = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
    var now;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            now = new Date().getTime();

            if (!(now - prevSessionCheck > 60000 && _store2.default.state.user.loaded)) {
              _context.next = 4;
              break;
            }

            _context.next = 4;
            return _axios2.default.post(_store2.default.state.config.API_URL + '/users/checkSession', undefined, {
              headers: {
                Authorization: 'Bearer ' + _store2.default.state.user.token
              }
            });

          case 4:
            setTimeout(function () {
              if (_store2.default.state.user.token) {
                checkSession();
              }
            }, 60000);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function checkSession() {
    return _ref.apply(this, arguments);
  };
}();

_axios2.default.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (_store2.default.state.auth && error.response && error.response.status === 401) {
    return _store2.default.state.auth.logout();
  } else {
    return _promise2.default.reject(error);
  }
});

_axios2.default.interceptors.request.use(function () {
  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(request) {
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (request.url.includes('/users/checkSession')) {
              prevSessionCheck = new Date();
            }

            if (!(request.url.includes('/graphql') && _store2.default.state.user.loaded)) {
              _context2.next = 13;
              break;
            }

            _context2.prev = 2;
            _context2.next = 5;
            return _axios2.default.post(_store2.default.state.config.API_URL + '/users/checkSession', undefined, {
              headers: {
                Authorization: 'Bearer ' + _store2.default.state.user.token
              }
            });

          case 5:
            return _context2.abrupt('return', request);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2['catch'](2);
            return _context2.abrupt('return', _store2.default.state.auth.logout());

          case 11:
            _context2.next = 14;
            break;

          case 13:
            return _context2.abrupt('return', request);

          case 14:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[2, 8]]);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());

checkSession();

_vue2.default.config.productionTip = false;

_vue2.default.prototype.$notifications = new _notifications2.default();

_vue2.default.directive('click-outside', {
  bind: function bind(el, binding, vNode) {
    if (typeof binding.value !== 'function') {
      var compName = vNode.context.name;
      var warn = '[Vue-click-outside:] provided expression \'' + binding.expression + '\' is not a function, but has to be';
      if (compName) {
        warn += 'Found in component \'' + compName + '\'';
      }

      console.warn(warn);
    }

    var bubble = binding.modifiers.bubble;
    var handler = function handler(e) {
      if (bubble || !el.contains(e.target) && el !== e.target) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;

    document.addEventListener('click', handler);
  },

  unbind: function unbind(el, binding) {
    document.removeEventListener('click', el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  }
});

var isPortal = !location.hostname.includes('trials');

_vue2.default.use(_vueJsModal2.default);
new _vue2.default({
  el: '#app',
  router: isPortal ? _router.router : _router.routerTrials,
  store: _store2.default,
  render: function render(h) {
    return h(_App2.default);
  }
});

if (!Element.prototype.remove) {
  Element.prototype.remove = function () {
    this.parentElement.removeChild(this);
  };
}
if (!NodeList.prototype.remove) {
  NodeList.prototype.remove = HTMLCollection.prototype.remove = function () {
    for (var i = this.length - 1; i >= 0; i--) {
      if (this[i] && this[i].parentElement) {
        this[i].parentElement.removeChild(this[i]);
      }
    }
  };
}

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadScriptsInOrder = exports.loadScript = undefined;

var _promise = __webpack_require__(17);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadScript = exports.loadScript = function loadScript(script) {
  return new _promise2.default(function (resolve, reject) {
    var id = script.replace(/\/|\./g, '-');
    if (document.getElementById(id)) {
      return resolve('Already loaded.');
    }
    var scriptElem = document.createElement('script');
    scriptElem.id = id;
    scriptElem.src = script;
    scriptElem.onload = resolve;
    scriptElem.onerror = reject;
    document.getElementsByTagName('head')[0].appendChild(scriptElem);
  });
};

var loadScriptsInOrder = exports.loadScriptsInOrder = function loadScriptsInOrder(scripts) {
  if (!scripts || scripts.length <= 0) {
    return _promise2.default.resolve();
  }
  var script = scripts.shift();
  return loadScript(script).then(function () {
    if (scripts.length > 0) {
      return loadScriptsInOrder(scripts);
    }

    return _promise2.default.resolve();
  });
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OutputViewer = exports.InputViewer = undefined;

var _keys = __webpack_require__(51);

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = __webpack_require__(52);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__(50);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends3 = __webpack_require__(10);

var _extends4 = _interopRequireDefault(_extends3);

var _toConsumableArray2 = __webpack_require__(148);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = __webpack_require__(100);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(65);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(66);

var _createClass3 = _interopRequireDefault(_createClass2);

var _promise = __webpack_require__(17);

var _promise2 = _interopRequireDefault(_promise);

var _loader = __webpack_require__(314);

var _support = __webpack_require__(316);

var _support_output = __webpack_require__(317);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadStylesheet = function loadStylesheet(href) {
  return new _promise2.default(function (resolve, reject) {
    var id = href.replace(/\/|\./g, '-');
    if (document.getElementById(id)) {
      return resolve();
    }
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.id = id;
    link.href = href;
    link.onload = resolve;
    document.head.appendChild(link);
  });
};
var loadStylesheetList = function loadStylesheetList(list) {
  return _promise2.default.all(list.map(loadStylesheet));
};

var InputViewer = exports.InputViewer = function () {
  function InputViewer(configs, files, callback, finishedLoadingCB, onSave, _ref) {
    var fetchSupport = _ref.fetchSupport,
        generateSupportExternal = _ref.generateSupportExternal,
        getCurvaturePerFaceData = _ref.getCurvaturePerFaceData,
        supportLoading = _ref.supportLoading,
        curvatureLoading = _ref.curvatureLoading,
        contextMenuToggle = _ref.contextMenuToggle,
        showHelp = _ref.showHelp,
        changeZRotationAccess = _ref.changeZRotationAccess,
        savePartsConfig = _ref.savePartsConfig,
        savePlatesConfig = _ref.savePlatesConfig,
        openRemovePlateModal = _ref.openRemovePlateModal;
    (0, _classCallCheck3.default)(this, InputViewer);
    this.LIBRARY_DEPS = ['https://ajax.googleapis.com/ajax/libs/jquery/1.12.4/jquery.min.js', '/static/js/three.js', '/static/js/renderers/CanvasRenderer.js', '/static/js/controls/TrackballControls.js', '/static/js/controls/TransformControls.js', '/static/js/Detector.js', '/static/js/libs/stats.min.js', '/static/js/loaders/STLLoader.js', '/static/js/math/Lut.js', '/static/js/libs/dat.gui.min.js', '/static/js/three-text2d.min.js', '/static/js/quaternion.js', '/static/js/jquery-ui/jquery-ui.js'];
    this.STYLESHEET_DEPS = ['/static/js/jquery-ui/jquery-ui.css', '/static/js/jquery-ui/jquery-tooltip.css'];
    this.STATIC_PREFIX = '/static/models/stl/binary/';
    this.PRINTER_CONFIG_LIBRARY = {
      EOSM100: {
        base: this.STATIC_PREFIX + 'build_plate_EOSM100.stl',
        position: [-100, -200, 200],
        zRotation: -15
      },
      EOSM290: {
        base: this.STATIC_PREFIX + 'build_plate_EOSM290.stl',
        position: [-150, -350, 300],
        zRotation: -25
      },
      EOSM400: {
        base: this.STATIC_PREFIX + 'build_plate_EOSM400.stl',
        position: [-300, -500, 400],
        zRotation: -40
      },
      SLM280: {
        base: this.STATIC_PREFIX + 'build_plate_SLM280.stl',
        position: [-250, -350, 300],
        zRotation: -30
      },
      RenishawAM250: {
        base: this.STATIC_PREFIX + 'build_plate_RenishawAM250.stl',
        position: [-250, -350, 300],
        zRotation: -30
      },
      RenishawAM500: {
        base: this.STATIC_PREFIX + 'build_plate_RenishawAM500.stl',
        position: [-250, -350, 350],
        zRotation: -30
      },
      ArcamQ20: {
        base: this.STATIC_PREFIX + 'build_plate_arcamQ20.stl',
        position: [-350, -350, 200],
        zRotation: -15
      },
      IntechSF1: {
        base: this.STATIC_PREFIX + 'build_plate_IntechSF1.stl',
        position: [-100, -200, 200],
        zRotation: -15
      }
    };

    this.PRINTER = configs.config.printer;
    this.STL_FILES = files.parts;
    this.uploadedSupports = false;
    this.isNested = !!configs.nestedConfig;
    if (files.hasOwnProperty('supports') && files.supports.length > 0 || configs.config.isHideSupports) {
      this.STL_SUPPORT_FILES = files.supports || [];
      this.uploadedSupports = true;
    }
    this.CONFIG = configs.config;
    this.old = {
      scale: this.CONFIG.scaling[0],
      supportTransparency: this.uploadedSupports ? 0.7 : 0.2
    };
    if ('nestedConfig' in configs) {
      this.allowZRotation = configs.nestedConfig.allowZRotation;
      this.nestedPartsNames = configs.nestedConfig.partsNames;
      this.currentPartName = this.nestedPartsNames[0];
      this.old = (0, _defineProperty3.default)({}, this.currentPartName, {
        scale: this.CONFIG.scaling[0],
        supportTransparency: this.uploadedSupports ? 0.7 : 0.2
      });
      this.oldPosition = [];
      this.isManualPlacement = configs.nestedConfig.isManualPlacement;
      if (this.isManualPlacement) {
        this.currentPlateName = '';
        this.platesConfig = [];
        this.plateMatch = new RegExp('plate');
        this.savePlatesConfig = savePlatesConfig;
        this.openRemovePlateModal = openRemovePlateModal;
        this.currentObject = null;
      }
      this.partsConfig = configs.nestedConfig.partsConfig;
      this.transformControl = null;
      this.marginX = configs.nestedConfig.margin.marginX;
      this.marginY = configs.nestedConfig.margin.marginY;
    }
    this.isManualPlacementMode = false;
    this.PRINTERS_CONFIG = configs.printersConfig;
    this.finishedLoadingCB = finishedLoadingCB;
    this.STLList = [];
    this.finishedLoading = false;
    this._saveCallback = onSave;
    this.fetchSupport = fetchSupport;
    this.generateSupportExternal = generateSupportExternal;
    this.getCurvaturePerFaceData = getCurvaturePerFaceData;
    this.supportLoading = supportLoading;
    this.curvatureLoading = curvatureLoading;
    this.contextMenuToggle = contextMenuToggle;
    this.changeZRotationAccess = changeZRotationAccess;
    this.savePartsConfig = savePartsConfig;
    this.showHelp = showHelp;
    this.contextMenuIntersect = null;

    _promise2.default.all([loadStylesheetList(this.STYLESHEET_DEPS), (0, _loader.loadScriptsInOrder)(this.LIBRARY_DEPS)]).then(function () {
      callback && callback();
    });
  }

  (0, _createClass3.default)(InputViewer, [{
    key: 'rad2deg',
    value: function rad2deg(rads) {
      return rads * (180.0 / Math.PI);
    }
  }, {
    key: 'deg2rad',
    value: function deg2rad(degs) {
      return degs * (Math.PI / 180.0);
    }
  }, {
    key: 'unit2mmConstant',
    value: function unit2mmConstant(unit) {
      var conversionConstant = 1;
      switch (unit) {
        case 'm':
          conversionConstant = 1000.0;
          break;
        case 'cm':
          conversionConstant = 10.0;
          break;
        case 'inch':
          conversionConstant = 25.4;
          break;
      }
      return conversionConstant;
    }
  }, {
    key: 'preInitializer',
    value: function preInitializer() {
      this.THREE = window['THREE'];
      this.jQuery = window['$'];
      this.support = new _support.Support(this.THREE);
      this.dat = window['dat'];
      var Detector = window['Detector'];

      this.INTERSECTED = null;
      this.restrictedFaces = [];
      this.allowedFaces = [];
      this.highlightedFaces = [];
      this.curvaturePerFacet = [];
      this.facetAdjacents = [];
      this.maxCurvature = 0;

      this.color = {
        restrict: 0xff0000,
        allow: 0x00ff00,
        highlighted: 0xd5d5d5,
        default: 0x93969b,
        erase: 0x93969b
      };

      this.colorObj = {
        restrict: new this.THREE.Color(this.color.restrict),
        allow: new this.THREE.Color(this.color.allow),
        highlighted: new this.THREE.Color(this.color.highlighted),
        default: new this.THREE.Color(this.color.default),
        erase: new this.THREE.Color(this.color.erase)
      };

      this.facesMode = 'erase';
      this.mouse = new this.THREE.Vector2();

      if (!Detector.webgl) Detector.addGetWebGLMessage();

      this.params = {
        printer_type: this.PRINTER,
        critical_angle: this.CONFIG.critical_angle[0],
        hsub: this.CONFIG.hsub[0],
        scale_factor: this.CONFIG.scaling[0],
        fetch_support: false,
        units: this.CONFIG.unit,
        Rotate_about_X: 0,
        Rotate_about_Y: 0,
        Rotate_about_Z: 0,
        orientation_mode: true,
        supportStructures: false,
        brushMode: true,
        brushRadius: 1,
        brushBothSide: false,
        selectionTolerance: 1.5,
        restrictOrientation: this.CONFIG.restrictOrientation,

        restrictFaces: true,
        Restrict_rotation_X: 180,
        Restrict_rotation_Y: 180,
        Restrict_rotation_Z: 180,
        supportTransparency: this.uploadedSupports ? 0.7 : 0.2
      };
      if (this.isNested) {
        this.params.allowZRotation = this.allowZRotation;
        this.params.currentPartName = this.currentPartName;
        if (this.isManualPlacement) {
          this.params.currentPartOrPlateName = this.currentPartName;
          this.params.selectedPartName = '';
          this.params.partsAndPlatesNames = [].concat((0, _toConsumableArray3.default)(this.nestedPartsNames));
        }
      }
      if (this.CONFIG.unit_supp) {
        this.params.unit_supp = this.CONFIG.unit_supp;
      }
      document.body.style.margin = '0';
      document.body.style.overflow = 'hidden';
    }
  }, {
    key: 'init',
    value: function init() {
      var _this = this;

      this.preInitializer();
      this.scene = new this.THREE.Scene();
      this.scene.fog = new this.THREE.Fog(0xd4d4d4, 0.01, 4000);
      this.renderer = new this.THREE.WebGLRenderer({ antialias: true, alpha: true });
      this.renderer.setClearColor(this.scene.fog.color);

      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      document.body.appendChild(this.renderer.domElement);

      this.camera = new this.THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 30, 10000);
      this.camera.up.set(0, 0, 1);
      if (this.PRINTER_CONFIG_LIBRARY[this.PRINTER]) {
        var _camera$position;

        (_camera$position = this.camera.position).set.apply(_camera$position, (0, _toConsumableArray3.default)(this.PRINTER_CONFIG_LIBRARY[this.PRINTER].position));
      } else if (this.PRINTERS_CONFIG[this.PRINTER]) {
        var printerConfig = this.PRINTERS_CONFIG[this.PRINTER];
        this.camera.position.set(printerConfig.plateX * -0.9, printerConfig.plateY * -1.2, printerConfig.plateZ);
      } else {
        this.camera.position.set(this.CONFIG.PrinterXYZ[0] * -0.9, this.CONFIG.PrinterXYZ[1] * -1.2, this.CONFIG.PrinterXYZ[2]);
      }
      this.scene.add(this.camera);

      this.ray = new this.THREE.Raycaster();

      this.threePointLight();
      this.scene.add(new this.THREE.AmbientLight(0x333333));

      this.groupBase = new this.THREE.Group();
      this.drawGround();
      this.drawPrinter();
      this.groupPart = new this.THREE.Group();
      this.groupPart.rotation.order = 'ZYX';
      this.groupSupp = new this.THREE.Group();
      var material = new this.THREE.MeshPhongMaterial({
        color: 0xffffff,
        specular: 0x111111,
        shininess: 200,
        vertexColors: this.THREE.VertexColors
      });
      if (this.isNested) {
        this.STL_FILES.forEach(function (part, index) {
          var name = part.match(/[A-Za-z0-9-._()]+\.stl/)[0];
          _this['nestedPart' + name] = new _this.THREE.Group();
          var forcedMesh = index === 0;
          _this.STLList.push(_this.STL_LOAD(_this['nestedPart' + name], part, material, forcedMesh, true));
        });
        this.transformControl = new this.THREE.TransformControls(this.camera, this.renderer.domElement);
        this.scene.add(this.transformControl);
      } else {
        this.STLList.push(this.STL_LOAD(this.groupPart, this.STL_FILES[0], material, true, true));
      }
      var initScale = this.params.scale_factor * this.unit2mmConstant(this.CONFIG.unit);
      var setScale = function setScale(group) {
        return group.scale.set(initScale, initScale, initScale);
      };
      if (!this.isNested) {
        setScale(this.groupPart);
      } else {
        var group = this['nestedPart' + this.currentPartName];
        setScale(group);
      }
      var materialSupp = new this.THREE.MeshPhongMaterial({ color: 0x8e44ad, side: this.THREE.DoubleSide });

      if (this.uploadedSupports) {
        materialSupp.transparent = true;
        this.STL_SUPPORT_FILES.forEach(function (fileSupports) {
          _this.STLList.push(_this.STL_LOAD(_this.groupSupp, fileSupports, materialSupp, false, true));
        });
        var initSuppScale = this.unit2mmConstant(this.CONFIG.unit_supp);
        this.groupSupp.scale.set(initSuppScale, initSuppScale, initSuppScale);
      }

      this.controls = new this.THREE.TrackballControls(this.camera, this.renderer.domElement);
      this.controls.rotateSpeed = 5.0;
      this.controls.zoomSpeed = 5;
      this.controls.panSpeed = 2;
      this.controls.noZoom = false;
      this.controls.noPan = true;
      this.controls.staticMoving = true;
      this.controls.noRotate = true;
      this.controls.dynamicDampingFactor = 0.3;
      this.controls.enabled = true;

      var handle = new this.GUI_SETUP(this);
      this.gui = new this.dat.GUI({ width: 350 });
      var folderGeometry = this.gui.addFolder('Input Viewer');
      if (this.isNested) {
        var folderJobList = this.gui.addFolder('Nested parts');
      }
      this.setTextGray = function (el, value) {
        el.__li.style.color = value ? 'gray' : '';
      };

      this.toggleControlDisabled = function (el) {
        var isDisableNext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var isDisableNow = el.domElement.style.pointerEvents;
        var toggle = function toggle(disable) {
          el.domElement.style.pointerEvents = disable ? 'none' : '';
          el.domElement.style.opacity = disable ? 0.5 : 1;
          _this.setTextGray(el, isDisableNext);
        };
        if (isDisableNow && isDisableNext) return;else if (!isDisableNow && !isDisableNext) return;else toggle(isDisableNext);
      };
      this.disableList = function (el, value) {
        _this.setTextGray(el, value);
        el.__select.disabled = value;
        _this.toggleControlDisabled(el, value);
      };
      this.disableCheckbox = function (el, value) {
        _this.toggleControlDisabled(el, value);
        el.__checkbox.disabled = value;
      };
      this.switchGuiToolsDisable = function () {
        var disable = !_this.params.orientation_mode;
        var disableOrientModel = _this.params.supportStructures;
        _this.toggleControlDisabled(_this._scale, disable);
        _this.toggleControlDisabled(_this._x, disable);
        _this.toggleControlDisabled(_this._y, disable);
        _this.toggleControlDisabled(_this._z, disable);
        _this.disableCheckbox(_this._orientation_mode, disableOrientModel);
        _this.disableList(_this._units, disable);
        if (_this._z_rotation_access) {
          _this.disableCheckbox(_this._z_rotation_access, disable);
        }
        if (_this.isManualPlacement) {
          _this.disableList(_this._add_part, disable);
          _this.setTextGray(_this._remove_part, disable);
          _this.setTextGray(_this._remove_plate, disable);
          _this.setTextGray(_this._add_plate, disable);
          _this.togglePlacementMode(_this.isManualPlacementMode);
        }
      };
      this.togglePlacementMode = function (value) {
        _this.isManualPlacementMode = value;
        if (!_this.params.orientation_mode) return;
        var mode = value ? 'translate' : 'rotate';
        _this.toggleControlDisabled(_this._scale, value);
        _this.toggleControlDisabled(_this._x, value);
        _this.toggleControlDisabled(_this._y, value);
        _this.setTextGray(_this._remove_part, !value);
        _this.setTextGray(_this._remove_plate, !value);
        _this.disableList(_this._units, value);
        _this.disableList(_this._add_part, !value);
        _this.transformControl.setMode(mode);
        _this.transformControl.showZ = !value;
      };

      var toggleSupportStructures = function toggleSupportStructures(value) {
        if (value) {
          _this._orientation_mode.setValue(false);
          _this.jQuery('input', _this.jQuery('.dg .cr.boolean')[0]).prop('disabled', true);

          var bbox = new _this.THREE.Box3().setFromObject(_this.groupPart);
          var modelBase = bbox.min.z;
          _this.groupPart.position.z = _this.groupPart.position.z - modelBase + _this.params.hsub;
          var center = bbox.getCenter();
          _this.groupPart.position.x = _this.groupPart.position.x - center.x;
          _this.groupPart.position.y = _this.groupPart.position.y - center.y;

          _this.supportLoading(true);
          setTimeout(function () {
            _this.support.draw(_this.scene, _this.groupPart, {
              criticalAngle: _this.params.critical_angle,
              restrictedFaces: _this.restrictedFaces,
              allowedFaces: _this.allowedFaces,
              supportConfig: _this.CONFIG
            });
            _this.supportLoading(false);
          }, 50);
        } else {
          _this.jQuery('input', _this.jQuery('.dg .cr.boolean')[0]).prop('disabled', false);
          _this.params.orientation_mode = false;
          _this._orientation_mode.updateDisplay();
          _this.support.clear(_this.scene);
        }
      };
      this.toggleSupportStructuresExternal = function (value) {
        if (value) {
          _this.jQuery('input', _this.jQuery('.dg .cr.boolean')[0]).prop('disabled', true);

          var bbox = new _this.THREE.Box3().setFromObject(_this.groupPart);
          var modelBase = bbox.min.z;
          _this.groupPart.position.z = _this.groupPart.position.z - modelBase + _this.params.hsub;
          var center = bbox.getCenter();
          _this.groupPart.position.x = _this.groupPart.position.x - center.x;
          _this.groupPart.position.y = _this.groupPart.position.y - center.y;

          _this.supportLoading(true);
          _this.generateSupportExternal({
            rotation: [_this.params.Rotate_about_X, _this.params.Rotate_about_Y, _this.params.Rotate_about_Z],
            scaling: [_this.params.scale_factor],
            units: _this.params.units,
            AllowedFaces: _this.allowedFaces,
            RestrictedFaces: _this.restrictedFaces
          }).then(function (payload) {
            if (_this.groupSupp.children.length > 0) {
              _this.groupSupp.remove(_this.groupSupp.children[0]);
            }
            _this.processSupportsLoading(payload.data.url, 0);
          });
        } else {
          _this.jQuery('input', _this.jQuery('.dg .cr.boolean')[0]).prop('disabled', false);
          _this.params.orientation_mode = false;
          _this.groupSupp.position.x = 0;
          _this.groupSupp.position.y = 0;
          _this._orientation_mode.updateDisplay();
          _this.scene.remove(_this.groupSupp);
        }
      };
      this.processSupportsLoading = function (supportsUrl, attempt) {
        _this.STL_LOAD(_this.groupSupp, supportsUrl, materialSupp, false, true).then(function () {
          var bbox = new _this.THREE.Box3().setFromObject(_this.groupPart);
          _this.groupSupp.position.x = _this.groupSupp.position.x + bbox.min.x;
          _this.groupSupp.position.y = _this.groupSupp.position.y + bbox.min.y;
          for (var i = 0; i < _this.groupSupp.children.length; i++) {
            _this.groupSupp.children[i].material.opacity = _this.params.supportTransparency;
            _this.groupSupp.children[i].material.transparent = true;
          }
          _this.scene.add(_this.groupSupp);
          _this.supportLoading(false);
        }).catch(function (err) {
          if (err.currentTarget && err.currentTarget.status && err.currentTarget.status === 404 && attempt < 30) {
            attempt++;
            var delay = 2000 * attempt;
            if (attempt > 3) {
              delay = 15000;
            }
            setTimeout(function () {
              _this.processSupportsLoading(supportsUrl, attempt);
            }, delay);
          } else {
            _this.supportLoading(false);
            _this.toggleSupportStructuresExternal(false);
            _this._supports_mode.setValue(false);
          }
        });
      };
      this.getCurvaturePerFace = function () {
        _this.curvatureLoading(true);
        _this.getCurvaturePerFaceData().then(function (data) {
          _this.curvaturePerFacet = data.curvature_per_facet;
          _this.facetAdjacents = data.triangles_adjacent_triangle;
          for (var i = 0; i < _this.curvaturePerFacet.length; i++) {
            if (_this.curvaturePerFacet[i] > _this.maxCurvature) {
              _this.maxCurvature = _this.curvaturePerFacet[i];
            }
          }
          _this.curvatureLoading(false);
        }).catch(function (err) {
          _this.curvatureLoading(false);
          _this._brushMode.setValue(true);
          console.log(err);
        });
      };
      this.changeSupportTransparency = function (value) {
        for (var i = 0; i < _this.groupSupp.children.length; i++) {
          _this.groupSupp.children[i].material.opacity = value;
        }
      };
      this.applyRotation = function () {
        var group = _this.groupPart;
        if (_this.isNested) {
          if (!_this.isManualPlacementMode) group = _this['nestedPart' + _this.currentPartName];else group = _this.currentObject;
        }
        if (_this.params.orientation_mode) {
          _this.STL_ROTATE(group);
          _this.centeredPosition(group);
        }
      };
      if (!this.uploadedSupports) {
        var toggleOrientModel = function toggleOrientModel(value) {
          var control = _this.isNested ? _this.transformControl : _this.myquart;
          if (_this.params.supportStructures) {
            _this.params.orientation_mode = false;
            _this._orientation_mode.updateDisplay();
            value = false;
          }
          _this.switchGuiToolsDisable();
          if (value) {
            _this.controls.noPan = true;
            _this.controls.noRotate = true;
            control.enabled = true;

            if (_this.isNested && !_this.isManualPlacementMode) {
              control.attach(_this['nestedPart' + _this.currentPartName]);
            }
            _this.support.clear(_this.scene);
          } else {
            _this.controls.noPan = false;
            _this.controls.noRotate = false;
            control.enabled = false;
            if (_this.isNested && !_this.isManualPlacementMode) {
              control.detach(_this['nestedPart' + _this.currentPartName]);
            }
            if (_this.isManualPlacementMode) {
              _this.saveAndRemoveCurrentObject();
            }

            var setPosition = function setPosition(group) {
              var bbox = new _this.THREE.Box3().setFromObject(group);
              var modelBase = bbox.min.z;
              group.position.z = group.position.z - modelBase + _this.params.hsub;
              var center = bbox.getCenter();
              group.position.x = group.position.x - center.x;
              group.position.y = group.position.y - center.y;
            };
            if (!_this.isNested) {
              setPosition(_this.groupPart);
            } else if (!_this.isManualPlacementMode) {
              var _group = _this['nestedPart' + _this.currentPartName];
              setPosition(_group);
            }
          }
        };
        this._orientation_mode = folderGeometry.add(this.params, 'orientation_mode').name('Orient Model');
        this._orientation_mode.onChange(toggleOrientModel);
        if (!this.isNested) {
          this._supports_mode = folderGeometry.add(this.params, 'supportStructures').name('Support structures');
          this._supports_mode.onChange(function (value) {
            if (_this.params.orientation_mode && value) {
              toggleOrientModel(false);
            }
            _this.switchGuiToolsDisable();
            _this.toggleSupportStructuresExternal(value);
          });
          this._supports_transparency = folderGeometry.add(this.params, 'supportTransparency', 0, 1).step(0.01).name('Support transparency').onChange(function (value) {
            if (_this.params.supportStructures && !_this.isNested) {
              _this.changeSupportTransparency(value);
            } else return;
          });
          folderGeometry.add(handle, 'generateSupports').name('Generate support');
        }
        var _setScale = function _setScale(group, scaleFactor) {
          return group.scale.set(scaleFactor, scaleFactor, scaleFactor);
        };
        this._units = folderGeometry.add(this.params, 'units').options({
          'Millimeters': 'mm',
          'Centimeters': 'cm',
          'Meters': 'm',
          'Inches': 'inch'
        }).name('Unit').onChange(function (value) {
          if (_this.params.orientation_mode) {
            _this.CONFIG.unit = value;
            var scaleFactor = _this.params.scale_factor * _this.unit2mmConstant(value);
            if (!_this.isNested) {
              _setScale(_this.groupPart, scaleFactor);
            } else if (!_this.isManualPlacementMode) {
              var _group2 = _this['nestedPart' + _this.currentPartName];
              _setScale(_group2, scaleFactor);
            }
          }
        });
        this._scale = folderGeometry.add(this.params, 'scale_factor', 0.001, 20).step(0.001).name('Scaling factor of part');
        this._scale.onChange(function (value) {
          if (_this.params.orientation_mode) {
            var scaleFactor = value * _this.unit2mmConstant(_this.CONFIG.unit);
            if (!_this.isNested) {
              _setScale(_this.groupPart, scaleFactor);
            } else {
              var _group3 = _this['nestedPart' + _this.currentPartName];
              _setScale(_group3, scaleFactor);
            }
          }
        });
        this._x = folderGeometry.add(this.params, 'Rotate_about_X', -180, 180).step(1).name('x rotation \xB0').onChange(function () {
          return _this.applyRotation();
        });
        this._y = folderGeometry.add(this.params, 'Rotate_about_Y', -180, 180).step(1).name('y rotation \xB0').onChange(function () {
          return _this.applyRotation();
        });

        if (this.isNested && !this.isManualPlacement) {
          var getController = function getController(name) {
            return folderGeometry.__controllers.find(function (_ref2) {
              var property = _ref2.property;
              return property === name;
            });
          };
          this._z_rotation_access = folderGeometry.add(this.params, 'allowZRotation').name('Set z rotation manually').listen();
          this._z_rotation_access.onChange(function (value) {
            if (!_this.params.orientation_mode) return;
            _this.changeZRotationAccess(value);
          });
          this._z = folderGeometry.add(this.params, 'Rotate_about_Z', -180, 180).step(1).name('z rotation \xB0').onChange(function () {
            return _this.applyRotation();
          });
          if (!this.allowZRotation) {
            getController('Rotate_about_Z').__li.style.display = 'none';
          }
        }
        if (!this.isNested || this.isNested && this.isManualPlacement) {
          this._z = folderGeometry.add(this.params, 'Rotate_about_Z', -180, 180).step(1).name('z rotation \xB0').onChange(function () {
            return _this.applyRotation();
          });
        }
        if (this.isNested) {
          var changeRotation = function changeRotation(axis, value) {
            _this.params['Rotate_about_' + axis.toUpperCase()] = value;
            _this['_' + axis].updateDisplay();
          };
          this.refreshGuiData = function (config) {
            if (!config) {
              config = { RotationalAngle: [0, 0, 0], scaling: [1], unit: 'Millimeters' };
            }
            var _config = config,
                RotationalAngle = _config.RotationalAngle,
                scaling = _config.scaling,
                unit = _config.unit;

            changeRotation('x', RotationalAngle[0]);
            changeRotation('y', RotationalAngle[1]);
            changeRotation('z', RotationalAngle[2]);
            _this.params.scale_factor = scaling[0];
            _this.params.units = unit;
            _this._scale.updateDisplay();
          };

          var setupNewPart = function setupNewPart(newName) {
            var newPartGroup = _this['nestedPart' + newName];
            var newPartConfig = _this.partsConfig[newName];
            _this.refreshGuiData(newPartConfig);
            if (_this.params.orientation_mode) {
              _this.transformControl.attach(newPartGroup);
            }
            _this.scene.add(newPartGroup);
            _this.currentPartName = newName;
          };
          var saveAndRemovePart = function saveAndRemovePart() {
            var currentData = handle.getData();
            var currentGroup = _this['nestedPart' + _this.currentPartName];
            _this.transformControl.detach(currentGroup);
            _this.updateConfig(currentData, _this.partsConfig[_this.currentPartName]);
            _this.refreshGuiData();
            _this.scene.remove(currentGroup);
            _this.currentPartName = '';
          };

          var checkOldParam = function checkOldParam(newName, config) {
            if (!_this.old[newName]) {
              _this.old[newName] = {
                scale: config.scaling[0],
                supportTransparency: 0.2
              };
            }
          };

          var saveAndRemovePlate = function saveAndRemovePlate() {
            var plateGroup = _this.getPlateGroup();
            _this.saveAndRemoveCurrentObject();
            _this.togglePrintBoxVisible(false);
            _this.scene.remove(plateGroup);
            _this.currentPlateName = '';
          };

          var recreatePlate = function recreatePlate(plateName) {
            _this.currentPlateName = plateName;
            var pInx = _this.getIndex();
            var plate = _this.platesConfig[pInx];
            var plateGroup = new _this.THREE.Group();
            plateGroup.name = plateName;
            for (var partName in plate) {
              for (var i = 0; i < plate[partName].length; i += 3) {
                var cloneGroup = _this['nestedPart' + partName].clone();
                cloneGroup.name = partName + '_copy_' + (i / 3 + 1);
                _this.setCloneRotPosFromConfig(cloneGroup);
                _this.centeredPosition(cloneGroup);
                plateGroup.add(cloneGroup);
              }
            }
            _this.scene.add(plateGroup);
            _this.refreshGuiData();
            _this.checkOverlaps();
          };
          this.refreshList = function (el, options, name, onChange) {
            _this[el] = _this[el].options(options).name(name).onChange(onChange);
            var elements = document.getElementsByClassName('ui-tooltip');
            while (elements.length > 0) {
              elements[0].parentNode.removeChild(elements[0]);
            }
            _this.initLegend();
          };
          this.onAddingPlate = function () {
            if (!_this.params.orientation_mode) return;
            var count = _this.platesConfig.length;
            var newName = 'plate_' + (count + 1);
            _this.platesConfig.push({});
            _this.oldPosition.push([]);
            if (_this.currentPartName) {
              _this.togglePlacementMode(true);
              saveAndRemovePart();
              _this.refreshGuiData();
            } else saveAndRemovePlate();
            var plateGroup = new _this.THREE.Group();
            plateGroup.name = newName;
            _this.scene.add(plateGroup);
            _this.params.partsAndPlatesNames.push(newName);
            _this.params.currentPartOrPlateName = newName;
            _this.currentPlateName = newName;
            _this.refreshList('_part_or_plate', _this.params.partsAndPlatesNames, 'Parts and Plates', _onPartOrPlateChange);
          };

          this.onSelectPart = function (partName) {
            _this.saveAndRemoveCurrentObject();
            var cloneGroup = _this['nestedPart' + partName].clone();
            var plateGroup = _this.getPlateGroup();
            var pInx = _this.getIndex();

            var _toPrinterZero = _this.toPrinterZero(0, 0),
                x = _toPrinterZero.x,
                y = _toPrinterZero.y;

            var count = _this.platesConfig[pInx][partName] ? _this.platesConfig[pInx][partName].length / 3 : 0;
            if (!count) {
              _this.platesConfig[pInx][partName] = [x, y, 0];
              _this.oldPosition[pInx] = (0, _extends4.default)({}, _this.oldPosition[pInx], (0, _defineProperty3.default)({}, partName, [0, 0, 0]));
            } else {
              _this.platesConfig[pInx][partName].push(x, y, 0);
              _this.oldPosition[pInx][partName].push(0, 0, 0);
            }
            cloneGroup.name = partName + '_copy_' + (count + 1);
            _this.params.selectedPartName = '';
            _this.refreshList('_add_part', _this.nestedPartsNames, 'Add part to Build Plate', _this.onSelectPart);
            plateGroup.add(cloneGroup);
            _this.transformControl.attach(cloneGroup);
            _this.currentObject = cloneGroup;
            _this.centeredPosition(cloneGroup);
            _this.setCloneRotPosFromConfig();
            _this.checkOverlaps();
          };
          var onPartChange = function onPartChange(newName) {
            saveAndRemovePart();
            setupNewPart(newName);
            checkOldParam(newName, _this.partsConfig[newName]);
          };
          var _onPartOrPlateChange = function _onPartOrPlateChange(newName) {
            var isNewThingPlate = newName.match(_this.plateMatch);
            if (_this.currentPartName) saveAndRemovePart();else {
              _this.togglePlacementMode(false);
              saveAndRemovePlate();
            }
            if (!isNewThingPlate) {
              _this.togglePlacementMode(false);
              setupNewPart(newName);
              checkOldParam(newName, _this.partsConfig[newName]);
            } else {
              _this.togglePlacementMode(true);
              recreatePlate(newName);
            }
          };
          this.onRemoveClone = function () {
            if (!_this.currentObject) return;
            var cloneName = _this.currentObject.name;
            var pInx = _this.getIndex();
            var cInx = _this.getIndex(cloneName) * 3;
            var partName = _this.getPartName();
            var plateGroup = _this.scene.getObjectByName(_this.currentPlateName);
            var clones = _this.platesConfig[pInx][partName];
            var oldClonesPos = _this.oldPosition[pInx][partName];
            var newConf = [];
            var newOldConf = [];
            for (var i = 0; i < clones.length; i += 3) {
              if (i === cInx) continue;
              var _ref3 = [clones[i], clones[i + 1], clones[i + 2]],
                  x = _ref3[0],
                  y = _ref3[1],
                  zRot = _ref3[2];
              var _ref4 = [oldClonesPos[i], oldClonesPos[i + 1], oldClonesPos[i + 2]],
                  xPos = _ref4[0],
                  yPos = _ref4[1],
                  zPos = _ref4[2];

              newConf.push(x, y, zRot);
              newOldConf.push(xPos, yPos, zPos);
            }
            plateGroup.remove(_this.currentObject);
            var names = [];
            plateGroup.children.forEach(function (child) {
              if (child.name.match(new RegExp(partName))) {
                var inx = names.length + 1;
                child.name = partName + '_copy_' + inx;
                names.push(1);
              }
            });
            _this.saveAndRemoveCurrentObject();
            _this.platesConfig[pInx][partName] = [].concat(newConf);
            _this.oldPosition[pInx][partName] = [].concat(newOldConf);
            _this.checkOverlaps();
          };
          this.getRemovePlateModal = function () {
            if (!_this.isManualPlacementMode) return;
            var isNotEmpyty = _this.getPlateGroup().children.length;
            if (isNotEmpyty) _this.openRemovePlateModal();else _this.onRemovePlate(true);
          };
          this.onRemovePlate = function (value) {
            if (!value) return;
            var plateGroup = _this.getPlateGroup();
            var pInx = _this.getIndex();
            _this.togglePrintBoxVisible(false);
            _this.saveAndRemoveCurrentObject();
            _this.scene.remove(plateGroup);
            var newNames = [];
            var plates = [];
            _this.params.partsAndPlatesNames.forEach(function (name) {
              if (name === _this.currentPlateName) return;
              if (name.match(_this.plateMatch)) {
                newNames.push('plate_' + (plates.length + 1));
                plates.push(1);
              } else newNames.push(name);
            });
            _this.params.partsAndPlatesNames = newNames;
            var firstName = newNames[0];
            var newConfig = [];
            var newOldConf = [];
            for (var i = 0; i < _this.platesConfig.length; i += 1) {
              if (i === pInx) continue;
              newConfig.push(_this.platesConfig[i]);
              newOldConf.push(_this.oldPosition[i]);
            }
            _this.platesConfig = newConfig;
            _this.oldPosition = newOldConf;
            _this.currentPlateName = '';
            _this.params.currentPartOrPlateName = firstName;
            _this.refreshList('_part_or_plate', _this.params.partsAndPlatesNames, 'Parts and Plates', _onPartOrPlateChange);
            _this.togglePlacementMode(false);
            setupNewPart(firstName);
          };

          if (!this.isManualPlacement) {
            folderJobList.add(this.params, 'currentPartName').options(this.nestedPartsNames).name('List of Parts').onChange(onPartChange);
          } else {
            this._part_or_plate = folderJobList.add(this.params, 'currentPartOrPlateName').options(this.params.partsAndPlatesNames).name('Parts and plates').onChange(_onPartOrPlateChange);
            this._add_plate = folderJobList.add(this, 'onAddingPlate').name('Add new build plate');
            this._add_part = folderJobList.add(this.params, 'selectedPartName').options(this.nestedPartsNames).name('Add part to build plate').onChange(this.onSelectPart);
            this._remove_part = folderJobList.add(this, 'onRemoveClone').name('Remove selected part');
            this._remove_plate = folderJobList.add(this, 'getRemovePlateModal').name('Remove current plate');
            this.togglePlacementMode(false);
          }
          folderJobList.open();
        }
      } else {
        if (!this.CONFIG.isHideSupports) {
          folderGeometry.add(this.params, 'supportTransparency', 0, 1).step(0.01).name('Support transparency').onChange(this.changeSupportTransparency);
        }
        folderGeometry.add(this.params, 'units').options({
          'Millimeters': 'mm',
          'Centimeters': 'cm',
          'Meters': 'm',
          'Inches': 'inch'
        }).name('Unit').onChange(function (value) {
          _this.CONFIG.unit = value;
          var scaleFactor = _this.params.scale_factor * _this.unit2mmConstant(value);
          _this.groupPart.scale.set(scaleFactor, scaleFactor, scaleFactor);
        });
        if (!this.CONFIG.isHideSupports) {
          folderGeometry.add(this.params, 'unit_supp').options({
            'Millimeters': 'mm',
            'Centimeters': 'cm',
            'Inches': 'inch'
          }).name('Supports Unit').onChange(function (value) {
            _this.CONFIG.unit_supp = value;
            var scaleFactor = _this.unit2mmConstant(value);
            _this.groupSupp.scale.set(scaleFactor, scaleFactor, scaleFactor);
            var bbox = new _this.THREE.Box3().setFromObject(_this.groupSupp);
            var modelBase = bbox.min.z;
            _this.groupSupp.position.z = _this.groupSupp.position.z - modelBase;
            var bboxPart = new _this.THREE.Box3().setFromObject(_this.groupPart);
            var center = bboxPart.getCenter();
            _this.groupSupp.position.x = _this.groupPart.position.x - center.x;
            _this.groupSupp.position.y = _this.groupPart.position.y - center.y;
          });
        }
        this.controls.noPan = false;
        this.controls.noRotate = false;
      }
      folderGeometry.add(handle, 'reset').name('Reset View');
      folderGeometry.add(handle, 'save').name('RUN JOB');
      folderGeometry.add(handle, 'help').name('Get Help');
      folderGeometry.open();
      if (this.params.restrictFaces && !this.uploadedSupports && !this.isNested) {
        var folderFacet = this.gui.addFolder('Restrict or allow support generation on facets');

        this._brushMode = folderFacet.add(this.params, 'brushMode').name('Brush mode').onChange(function (value) {
          _this.params.brushMode = value;
          if (!value && _this.curvaturePerFacet.length === 0) {
            _this.getCurvaturePerFace();
          }
        });
        folderFacet.add(this.params, 'brushRadius', 0, 5).step(0.1).name('Brush radius').onChange(function (value) {
          _this.params.brushRadius = value;
        });
        folderFacet.add(this.params, 'brushBothSide').name('Brush paints on both sides').onChange(function (value) {
          _this.params.brushBothSide = value;
        });
        folderFacet.add(this.params, 'selectionTolerance', 0, 5).step(0.1).name('Tolerance').onChange(function (value) {
          _this.params.selectionTolerance = value;
        });
        folderFacet.add(this, 'facesMode').options({ 'Restrict Support Attachment': 'restrict', 'Allow Support Attachment': 'allow', 'Erase Support Attachment': 'erase' }).name('Facets selection');
        folderFacet.add(handle, 'selectAll').name('Select All');
        folderFacet.add(handle, 'resetFaces').name('Reset selection');
        folderFacet.open();
      }
      if (this.params.restrictOrientation && !this.uploadedSupports) {
        var folderOrientation = this.gui.addFolder('Add degrees of freedom for the orientation on the left');
        this._xRestrict = folderOrientation.add(this.params, 'Restrict_rotation_X', 0, 180).step(1).name('Restrict x rotation \xB0');
        this._yRestrict = folderOrientation.add(this.params, 'Restrict_rotation_Y', 0, 180).step(1).name('Restrict y rotation \xB0');
        this._zRestrict = folderOrientation.add(this.params, 'Restrict_rotation_Z', 0, 180).step(1).name('Restrict z rotation \xB0');
        folderOrientation.open();
      }

      this.initLegend = this.initLegend.bind(this);
      this.initLegend();

      this.setupInset();
      this.onWindowResize = this.onWindowResize.bind(this);
      this.onDocumentMouseClick = this.onDocumentMouseClick.bind(this);
      this.onDocumentMouseMove = this.onDocumentMouseMove.bind(this);
      this.onDocumentMouseUp = this.onDocumentMouseUp.bind(this);
      this.onDocumentContextMenu = this.onDocumentContextMenu.bind(this);
      this.colorFaces = this.colorFaces.bind(this);
      window.addEventListener('resize', this.onWindowResize);

      _promise2.default.all(this.STLList).then(function () {
        _this.STL_LOAD_FINISHED();
      });
    }
  }, {
    key: 'changeAllowZRotation',
    value: function changeAllowZRotation(value) {
      this.allowZRotation = value;
      this.params.allowZRotation = value;
      var controller = this.gui.__folders['Input Viewer'].__controllers.find(function (_ref5) {
        var property = _ref5.property;
        return property === 'Rotate_about_Z';
      });
      var checkbox = this.gui.__folders['Input Viewer'].__controllers.find(function (_ref6) {
        var property = _ref6.property;
        return property === 'allowZRotation';
      });
      checkbox.__checkbox.checked = value;
      checkbox.__prev = value;
      checkbox.updateDisplay();
      this.transformControl.showZ = value;
      var group = this['nestedPart' + this.currentPartName];
      if (this.allowZRotation) {
        controller.__li.style.display = '';
      } else {
        group.rotation.z = 0;
        this.params.Rotate_about_Z = this.rad2deg(group.rotation.z);
        this._z.updateDisplay();
        controller.__li.style.display = 'none';
      }
    }
  }, {
    key: 'initLegend',
    value: function initLegend() {
      var _this2 = this;

      this.jQuery('.dg.main').click(function (event) {
        event.stopPropagation();
      });
      var $folders = this.jQuery('.dg.main.a ul li.folder');
      var $mainParams;
      var $secondParams;
      var $restriction;
      var $restrictionSupport;
      if ($folders.length > 1 && !this.isNested) {
        if ($folders.length === 3) {
          $restriction = $folders[2];
          $restrictionSupport = $folders[1];
        } else {
          var $checkFolder = this.jQuery($folders[1]).find('li');
          if ($checkFolder[0].innerHTML === 'Restrict or allow support generation on facets') {
            $restrictionSupport = $folders[1];
          } else {
            $restriction = $folders[1];
          }
        }
      }
      $mainParams = $folders[0];
      $secondParams = $folders[1];

      if ($secondParams && this.isManualPlacement) {
        var paramsList = this.jQuery($secondParams).find('li');
        paramsList.each(function (index, element) {
          switch (index) {
            case 0:
              break;
            case 1:
              _this2.jQuery(element).attr('title', 'By selecting part you can change its rotation. By selecting plate you can manually change position or rotation about z of each part that placed on current plate');
              break;
            case 2:
              _this2.jQuery(element).attr('title', 'Add new build plate to start your manual placement');
              break;
            case 3:
              _this2.jQuery(element).attr('title', 'Select part which copy you want add to build plate');
              break;
            case 4:
              _this2.jQuery(element).attr('title', 'You need to select copy on build plate first to remove it');
              break;
            case 5:
              _this2.jQuery(element).attr('title', 'You can remove current build plate. All copies on it will be removed also.');
              break;
            default:
              break;
          }
        });
      }

      if ($mainParams) {
        var _paramsList = this.jQuery($mainParams).find('li');
        _paramsList.each(function (index, element) {
          if (_this2.uploadedSupports) {
            switch (index) {
              case 0:
                break;
              case 1:
                _this2.jQuery(element).attr('title', 'Adjust support transparency.');
                break;
              case 2:
                _this2.jQuery(element).attr('title', 'If you selected the wrong unit of measure, simply select the correct unit of measure from the dropdown.');
                break;
              case 3:
                _this2.jQuery(element).attr('title', 'If you selected the wrong unit of measure, simply select the correct unit of measure from the dropdown.');
                break;
              case 4:
                _this2.jQuery(element).attr('title', '"Reset view" returns the viewer to the default state that was first presented to you.');
                break;
              case 5:
                _this2.jQuery(element).attr('title', '"RUN JOB" will save your orientation and generate your oriented part and support structure files.');
                break;
              case 6:
                break;
            }
          }if (_this2.isNested) {
            var isRunJob = _paramsList.length - 2 === index;
            var isReset = _paramsList.length - 3 === index;
            var isZRotation = _paramsList.length - 4 === index;
            if (isRunJob) {
              _this2.jQuery(element).attr('title', '"RUN JOB" will save your orientation and generate your oriented part and support structure files.');
            }
            if (isReset) {
              _this2.jQuery(element).attr('title', '"Reset view" returns the viewer to the default state that was first presented to you.');
            }
            if (isZRotation) {
              _this2.jQuery(element).attr('title', 'You may enter positive or negative numerical values to change the orientation of your part.');
            }
            switch (index) {
              case 0:
                break;
              case 1:
                _this2.jQuery(element).attr('title', 'Uncheck this checkbox to freeze your orientation.');
                break;
              case 2:
                _this2.jQuery(element).attr('title', 'If you selected the wrong unit of measure, simply select the correct unit of measure from the dropdown.');
                break;
              case 3:
                _this2.jQuery(element).attr('title', 'The scaling factor for your STL file may be changed by sliding the blue bar left or right or manually entering the desired scaling factor to the right of the slider.');
                break;
              case 4:
                _this2.jQuery(element).attr('title', 'You may enter positive or negative numerical values to change the orientation of your part.');
                break;
              case 5:
                _this2.jQuery(element).attr('title', 'You may enter positive or negative numerical values to change the orientation of your part.');
                break;
              case 6:
                _this2.jQuery(element).attr('title', 'By setting the z orientation manually, you may not achieve the best possible density of parts, check the box again to let AM Build Optimizer maximize your part density');
                break;
              default:
                break;
            }
          } else {
            switch (index) {
              case 0:
                break;
              case 1:
                _this2.jQuery(element).attr('title', 'Uncheck this checkbox to freeze your orientation.');
                break;
              case 2:
                _this2.jQuery(element).attr('title', 'Check this checkbox to view the support structures AM Build Optimizer™ will create for you.');
                break;
              case 3:
                _this2.jQuery(element).attr('title', 'Adjust support transparency.');
                break;
              case 4:
                _this2.jQuery(element).attr('title', 'Create support structures by AM Build Optimizer™.');
                break;
              case 5:
                _this2.jQuery(element).attr('title', 'If you selected the wrong unit of measure, simply select the correct unit of measure from the dropdown.');
                break;
              case 6:
                _this2.jQuery(element).attr('title', 'The scaling factor for your STL file may be changed by sliding the blue bar left or right or manually entering the desired scaling factor to the right of the slider.');
                break;
              case 7:
                _this2.jQuery(element).attr('title', 'You may enter positive or negative numerical values to change the orientation of your part.');
                break;
              case 8:
                _this2.jQuery(element).attr('title', 'You may enter positive or negative numerical values to change the orientation of your part.');
                break;
              case 9:
                _this2.jQuery(element).attr('title', 'You may enter positive or negative numerical values to change the orientation of your part.');
                break;
              case 10:
                _this2.jQuery(element).attr('title', '"Reset view" returns the viewer to the default state that was first presented to you.');
                break;
              case 11:
                _this2.jQuery(element).attr('title', '"RUN JOB" will save your orientation and generate your oriented part and support structure files.');
                break;
              case 12:
                break;
              default:
                break;
            }
          }
        });
      }

      if ($restriction) {
        var $restrictionList = this.jQuery($restriction).find('li');
        $restrictionList.each(function (index, element) {
          switch (index) {
            case 0:
              break;
            case 1:
              _this2.jQuery(element).attr('title', 'Once you set a baseline orientation, you may restrict our optimization to a specified number of degrees of freedom from that baseline orientation. Simply enter positive values indicating the degrees of freedom for each axis of rotation.');
              break;
            case 2:
              _this2.jQuery(element).attr('title', 'Once you set a baseline orientation, you may restrict our optimization to a specified number of degrees of freedom from that baseline orientation. Simply enter positive values indicating the degrees of freedom for each axis of rotation.');
              break;
            case 3:
              _this2.jQuery(element).attr('title', 'Once you set a baseline orientation, you may restrict our optimization to a specified number of degrees of freedom from that baseline orientation. Simply enter positive values indicating the degrees of freedom for each axis of rotation.');
              break;
            default:
              break;
          }
        });
      }

      if ($restrictionSupport) {
        var $restrictionSupportList = this.jQuery($restrictionSupport).find('li');
        $restrictionSupportList.each(function (index, element) {
          switch (index) {
            case 0:
              break;
            case 1:
              _this2.jQuery(element).attr('title', 'You can make it easier to select multiple STL faces by checking the "Brush mode" box and increasing the size of the "Brush radius".');
              break;
            case 2:
              _this2.jQuery(element).attr('title', 'You can make it easier to select multiple STL faces by checking the "Brush mode" box and increasing the size of the "Brush radius".');
              break;
            case 3:
              _this2.jQuery(element).attr('title', 'If checked, brush will paint both (inside and outside) sides of the hollowed part.');
              break;
            case 4:
              _this2.jQuery(element).attr('title', 'Selection tolerance for non brush mode');
              break;
            case 5:
              _this2.jQuery(element).attr('title', 'To restrict support structures, simply choose "Restrict Support Attachment" from the dropdown.');
              break;
            case 6:
              _this2.jQuery(element).attr('title', 'Select all faces');
              break;
            case 7:
              _this2.jQuery(element).attr('title', 'Clear all faces selections');
              break;
            default:
              break;
          }
        });
      }
      var jQ = this.jQuery;
      this.jQuery('.dg.main.a').tooltip({
        position: {
          my: 'left center',
          at: 'right center',
          using: function using(position, feedback) {
            jQ(this).css({
              'left': position.left - 10,
              'top': position.top
            });
            jQ('<div>').addClass('arrow').addClass(feedback.vertical).addClass(feedback.horizontal).appendTo(this);
          }
        }
      });
    }
  }, {
    key: 'GUI_SETUP',
    value: function GUI_SETUP(context) {
      var _this3 = this;

      this.reset = function () {
        context.controls.reset();
      };
      this.resetFaces = function () {
        context.restrictedFaces = [];
        context.allowedFaces = [];
      };
      this.generateSupports = function () {
        context.toggleSupportStructuresExternal(false);
        context._supports_mode.setValue(true);
      };
      this.selectAll = function () {
        var i = 0;
        if (context.facesMode === 'restrict') {
          context.allowedFaces = [];
          for (i = 0; i < context.mesh.geometry.attributes.position.count / 3; i++) {
            context.restrictedFaces.push(i);
          }
        } else if (context.facesMode === 'allow') {
          context.restrictedFaces = [];
          for (i = 0; i < context.mesh.geometry.attributes.position.count / 3; i++) {
            context.allowedFaces.push(i);
          }
        } else {
          _this3.resetFaces();
        }
      };
      this.save = function () {
        var data = _this3.getData();
        if (context.isNested && !context.isManualPlacement) {
          context.updateConfig(data, context.partsConfig[context.currentPartName]);
          context.savePartsConfig(context.partsConfig);
        } else if (context.isManualPlacement) {
          context.savePartsConfig(context.partsConfig);
          context.savePlatesConfig(context.platesConfig);
        }
        context._saveCallback(data);
      };
      this.help = function () {
        context.showHelp();
      };
      this.getData = function () {
        return {
          viewer: context,
          rotation: [context.params.Rotate_about_X, context.params.Rotate_about_Y, context.params.Rotate_about_Z],
          scaling: [context.params.scale_factor],
          facesRestrictions: { restrictedFaces: context.restrictedFaces, allowedFaces: context.allowedFaces },
          restriction: context.params.restrictOrientation ? [context.params.Restrict_rotation_X, context.params.Restrict_rotation_Y, context.params.Restrict_rotation_Z] : [],
          units: { part: context.params.units, support: context.params.unit_supp }
        };
      };
    }
  }, {
    key: 'STL_LOAD',
    value: function STL_LOAD(groupx, file, material, forceMesh, isCalculateNormals) {
      var _this4 = this;

      return new _promise2.default(function (resolve, reject) {
        var loader = new _this4.THREE.STLLoader();
        loader.load(file, function (geometry) {
          var mesh = new _this4.THREE.Mesh(geometry, material);
          var scalexyz = 1;
          mesh.scale.set(scalexyz, scalexyz, scalexyz);

          mesh.castShadow = true;
          mesh.receiveShadow = true;
          groupx.add(mesh);
          if (forceMesh) {
            _this4.mesh = mesh;
          }
          if (isCalculateNormals) {
            var normals = groupx.children[0].geometry.attributes.normal.array;
            var needCalc = true;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = (0, _getIterator3.default)(normals), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var normal = _step.value;

                if (normal !== 0) {
                  needCalc = false;
                  break;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            if (needCalc) groupx.children[0].geometry.computeVertexNormals();
          }
          resolve(geometry);
        }, function () {}, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: 'STL_LOAD_FINISHED',
    value: function STL_LOAD_FINISHED() {
      var _this5 = this;

      if (this.isNested) {
        this.STL_FILES.forEach(function (plate, index) {
          var name = plate.match(/[A-Za-z0-9-._()]+\.stl/)[0];
          _this5.colorChange(_this5['nestedPart' + name].children[0], _this5.colorObj.default);
          var group = _this5['nestedPart' + name];
          group.name = name;
          group.rotation.order = 'ZYX';
          group.children[0].name = name;
          group.children[0].geometry.center();
          _this5.centeredPosition(group);
          _this5.getMinMaxVerticles(group);
          if (name === _this5.currentPartName) {
            if (!_this5.allowZRotation && !_this5.isManualPlacement) _this5.transformControl.showZ = _this5.allowZRotation;
            _this5.scene.add(group);
            _this5.transformControl.setMode('rotate');
            _this5.transformControl.attach(group);
          }
        });
      } else {
        this.colorChange(this.groupPart.children[0], this.colorObj.default);
        if (!this.uploadedSupports) {
          this.groupPart.children[0].geometry.center();
          this.myquart = new this.THREE.RotationWithQuaternion(this.groupPart, this.camera, this.renderer.domElement);
          this.myquart.enabled = true;
        }
        this.scene.add(this.groupPart);
        this.centeredPosition(this.groupPart);
      }
      this.finishedLoading = true;
      this.finishedLoadingCB();
      if (this.params.restrictFaces && !this.uploadedSupports) {
        window.addEventListener('click', this.onDocumentMouseClick);
        window.addEventListener('mousemove', this.onDocumentMouseMove);
      }
      window.addEventListener('mouseup', this.onDocumentMouseUp, true);
      window.addEventListener('contextmenu', this.onDocumentContextMenu);

      if (this.uploadedSupports) {
        var bbox = new this.THREE.Box3().setFromObject(this.groupPart);
        var center = bbox.getCenter();
        this.groupSupp.position.x = this.groupPart.position.x - center.x;
        this.groupSupp.position.y = this.groupPart.position.y - center.y;
        this.scene.add(this.groupSupp);
        this.changeSupportTransparency(this.params.supportTransparency);
      }
    }
  }, {
    key: 'STL_ROTATE',
    value: function STL_ROTATE(group) {
      group.rotation.x = this.deg2rad(this.params.Rotate_about_X);
      group.rotation.y = this.deg2rad(this.params.Rotate_about_Y);
      group.rotation.z = this.deg2rad(this.params.Rotate_about_Z);
      group.rotation.order = 'ZYX';
    }
  }, {
    key: 'light',
    value: function light(color, _ref7) {
      var _light$position;

      var position = _ref7.position,
          _ref7$normalize = _ref7.normalize,
          normalize = _ref7$normalize === undefined ? null : _ref7$normalize,
          _ref7$intensity = _ref7.intensity,
          intensity = _ref7$intensity === undefined ? 0.5 : _ref7$intensity,
          _ref7$castShadow = _ref7.castShadow,
          castShadow = _ref7$castShadow === undefined ? true : _ref7$castShadow;

      var light = new this.THREE.DirectionalLight(color);
      (_light$position = light.position).set.apply(_light$position, (0, _toConsumableArray3.default)(position)).normalize(normalize);
      light.intensity = intensity;
      light.castShadow = castShadow;
      return light;
    }
  }, {
    key: 'threePointLight',
    value: function threePointLight() {
      var dist = 400;
      this.scene.add(this.light(0xb8b8b8, { position: [1 * dist, 2 * dist, 1 * dist] }));
      this.scene.add(this.light(0xb8b8b8, { position: [-1 * dist, 0.6 * dist, 0.5 * dist], intensity: 2 }));
      this.scene.add(this.light(0xffffff, { position: [-0.3 * dist, -0.6 * dist, 0.8 * dist], normalize: 0xb8b8b8 }));
    }
  }, {
    key: 'onWindowResize',
    value: function onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    }
  }, {
    key: 'toPrinterZero',
    value: function toPrinterZero(x, y) {
      var isToZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var bbox = this.scene.getObjectByName('printer').geometry.attributes.position.array;
      var min = { x: 0, y: 0 };
      for (var i = 0; i < bbox.length; i += 3) {
        var _ref8 = [bbox[i], bbox[i + 1]],
            _x3 = _ref8[0],
            _y = _ref8[1];

        if (min.y > _y && min.x > _x3) min = { x: _x3, y: _y };
      }
      var minX = min.x - this.marginX;
      var minY = min.y - this.marginY;
      return isToZero ? { x: x - minX, y: y - minY } : { x: x + minX, y: y + minY };
    }
  }, {
    key: 'setCloneRotPosFromConfig',
    value: function setCloneRotPosFromConfig() {
      var clone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentObject;

      var partName = this.getPartName(clone);
      var pInx = this.getIndex();
      var cInx = this.getIndex(clone.name) * 3;
      var clones = this.platesConfig[pInx][partName];
      var _toPrinterZero2 = this.toPrinterZero(clones[cInx], clones[cInx + 1], false),
          x = _toPrinterZero2.x,
          y = _toPrinterZero2.y;

      var _partsConfig$partName = this.partsConfig[partName],
          _partsConfig$partName2 = (0, _slicedToArray3.default)(_partsConfig$partName.RotationalAngle, 3),
          parentX = _partsConfig$partName2[0],
          parentY = _partsConfig$partName2[1],
          parentZ = _partsConfig$partName2[2],
          scaling = _partsConfig$partName.scaling,
          unit = _partsConfig$partName.unit;

      var summZ = parentZ + this.rad2deg(clones[cInx + 2]);
      clone.rotation.order = 'ZYX';
      clone.rotation.x = this.deg2rad(parentX);
      clone.rotation.y = this.deg2rad(parentY);
      clone.rotation.z = this.deg2rad(summZ);
      clone.position.x = x;
      clone.position.y = y;
      if (this.currentObject) {
        var guiConf = { RotationalAngle: [parentX, parentY, summZ], scaling: scaling, unit: unit };
        this.refreshGuiData(guiConf);
      }
    }
  }, {
    key: 'setCloneRotPosToConfig',
    value: function setCloneRotPosToConfig() {
      var clone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentObject;

      var partName = this.getPartName(clone);
      var pInx = this.getIndex();
      var cInx = this.getIndex(clone.name) * 3;
      var z = clone.rotation.z,
          position = clone.position;

      var _toPrinterZero3 = this.toPrinterZero(position.x, position.y),
          x = _toPrinterZero3.x,
          y = _toPrinterZero3.y;

      var _partsConfig$partName3 = (0, _slicedToArray3.default)(this.partsConfig[partName].RotationalAngle, 3),
          parentZ = _partsConfig$partName3[2];

      var cloneConfig = this.platesConfig[pInx][partName];
      var cloneZ = this.rad2deg(z) - parentZ;
      cloneConfig[cInx] = x;
      cloneConfig[cInx + 1] = y;
      cloneConfig[cInx + 2] = this.deg2rad(cloneZ);
    }
  }, {
    key: 'saveAndRemoveCurrentObject',
    value: function saveAndRemoveCurrentObject() {
      if (!this.currentObject) return;
      this.transformControl.detach(this.currentObject);
      this.currentObject = null;
      this.transformControl.setMode('translate');
      this.transformControl.showY = true;
      this.transformControl.showX = true;
      this.transformControl.showZ = false;
      this.refreshGuiData();
    }
  }, {
    key: 'getPartName',
    value: function getPartName() {
      var clone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentObject;

      return clone.name.replace(/_copy.+/, '');
    }
  }, {
    key: 'getPlateGroup',
    value: function getPlateGroup() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentPlateName;

      return this.scene.getObjectByName(name);
    }
  }, {
    key: 'getIndex',
    value: function getIndex() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentPlateName;

      return name.match(/_(\d)+$/)[1] - 1;
    }
  }, {
    key: 'onDocumentMouseClick',
    value: function onDocumentMouseClick(event) {
      this.contextMenuToggle(false);
      this.mouse.x = event.clientX / window.innerWidth * 2 - 1;
      this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
      this.ray.setFromCamera(this.mouse, this.camera);
      if (this.isManualPlacementMode) {
        if (!this.params.orientation_mode) return;
        var intersectsHandle = this.ray.intersectObjects([this.transformControl.children[0]], true);
        if (intersectsHandle.length) return;
        var plateGroup = this.getPlateGroup();
        var intersects = this.ray.intersectObjects([plateGroup], true);
        if (!intersects.length) {
          return this.saveAndRemoveCurrentObject();
        }
        var newObj = intersects[0].object.parent;
        if (this.currentObject) {
          if (this.currentObject.name === newObj.name) {
            var mode = this.transformControl.getMode();
            if (mode === 'translate') {
              this.transformControl.setMode('rotate');
              this.transformControl.showY = false;
              this.transformControl.showX = false;
              this.transformControl.showZ = true;
            } else {
              this.transformControl.setMode('translate');
              this.transformControl.showY = true;
              this.transformControl.showX = true;
              this.transformControl.showZ = false;
            }
          } else {
            this.saveAndRemoveCurrentObject();
            this.currentObject = newObj;
            this.setCloneRotPosFromConfig();
            this.transformControl.attach(newObj);
          }
        } else {
          this.currentObject = newObj;
          this.setCloneRotPosFromConfig();
          this.transformControl.attach(newObj);
        }
      } else {
        var _intersects = this.ray.intersectObjects([this.mesh]);
        if (!_intersects.length) return;
        if (this.params.brushMode) {
          this.mesh.updateMatrixWorld();
          var vert = new this.THREE.Vector3();
          var normal = new this.THREE.Vector3();
          for (var i = 0; i < this.mesh.geometry.attributes.position.count; i++) {
            vert = vert.set(this.mesh.geometry.attributes.position.array[i * 3], this.mesh.geometry.attributes.position.array[i * 3 + 1], this.mesh.geometry.attributes.position.array[i * 3 + 2]).clone().applyMatrix4(this.mesh.matrixWorld);
            normal = normal.set(this.mesh.geometry.attributes.normal.array[i * 3], this.mesh.geometry.attributes.normal.array[i * 3 + 1], this.mesh.geometry.attributes.normal.array[i * 3 + 2]);
            var angle = normal.angleTo(_intersects[0].face.normal);
            var dist = vert.distanceTo(_intersects[0].point);
            if (dist < this.params.brushRadius) {
              if (!this.params.brushBothSide) {
                if (angle >= -Math.PI / 2 && angle <= Math.PI / 2) {
                  this.faceSelect(Math.floor(i / 3));
                }
              } else {
                this.faceSelect(Math.floor(i / 3));
              }
            }
          }
          this.faceSelect(_intersects[0].faceIndex / 3);
        } else {
          this.adjacentFaceSelect(_intersects[0].faceIndex / 3, false);
        }
        this.highlightedFaces = [];
      }
    }
  }, {
    key: 'faceSelect',
    value: function faceSelect(faceIndex) {
      var idxRestricted = this.restrictedFaces.indexOf(faceIndex);
      var idxAllowed = this.allowedFaces.indexOf(faceIndex);
      var isSelect = false;
      if (this.facesMode === 'restrict') {
        if (idxAllowed > -1) {
          this.allowedFaces.splice(idxAllowed, 1);
        }
        if (idxRestricted === -1) {
          this.restrictedFaces.push(faceIndex);
          isSelect = true;
        }
      } else if (this.facesMode === 'allow') {
        if (idxRestricted > -1) {
          this.restrictedFaces.splice(idxRestricted, 1);
        }
        if (idxAllowed === -1) {
          this.allowedFaces.push(faceIndex);
          isSelect = true;
        }
      } else {
        if (idxAllowed > -1) {
          this.allowedFaces.splice(idxAllowed, 1);
        }
        if (idxRestricted > -1) {
          this.restrictedFaces.splice(idxRestricted, 1);
        }
      }
      return isSelect;
    }
  }, {
    key: 'adjacentFaceSelect',
    value: function adjacentFaceSelect(faceIndex, highLight) {
      var curvatureClicked = this.curvaturePerFacet[faceIndex];
      var facetsAdjacent = [faceIndex];
      while (1) {
        var facetsAdjacentNew = [];
        for (var iFacet = 0; iFacet < facetsAdjacent.length; iFacet++) {
          var isSelected = void 0;
          if (highLight) {
            isSelected = this.checkHighlight(facetsAdjacent[iFacet]);
          } else {
            isSelected = this.faceSelect(facetsAdjacent[iFacet]);
          }
          if (isSelected) {
            for (var i = 0; i < 3; i++) {
              var curvature = this.curvaturePerFacet[this.facetAdjacents[3 * facetsAdjacent[iFacet] + i]];
              if (Math.abs(curvature - curvatureClicked) < this.maxCurvature * this.params.selectionTolerance / 100) {
                facetsAdjacentNew.push(this.facetAdjacents[3 * facetsAdjacent[iFacet] + i]);
              }
            }
          }
        }
        if (facetsAdjacentNew.length === 0) {
          break;
        } else {
          facetsAdjacent = facetsAdjacentNew;
        }
      }
    }
  }, {
    key: 'toggleFaceSelection',
    value: function toggleFaceSelection(faceIndex) {
      var result = null;
      var idxRestricted = this.restrictedFaces.indexOf(faceIndex);
      var idxAllowed = this.allowedFaces.indexOf(faceIndex);
      if (this.facesMode === 'restrict') {
        if (idxAllowed > -1) {
          this.allowedFaces.splice(idxAllowed, 1);
        }
        if (idxRestricted > -1) {
          this.restrictedFaces.splice(idxRestricted, 1);
          result = false;
        } else {
          this.restrictedFaces.push(faceIndex);
          result = true;
        }
      } else if (this.facesMode === 'allow') {
        if (idxRestricted > -1) {
          this.restrictedFaces.splice(idxRestricted, 1);
        }
        if (idxAllowed > -1) {
          this.allowedFaces.splice(idxAllowed, 1);
          result = false;
        } else {
          this.allowedFaces.push(faceIndex);
          result = true;
        }
      } else {
        if (idxAllowed > -1) {
          this.allowedFaces.splice(idxAllowed, 1);
        }
        if (idxRestricted > -1) {
          this.restrictedFaces.splice(idxRestricted, 1);
        }
      }
      return result;
    }
  }, {
    key: 'onDocumentMouseMove',
    value: function onDocumentMouseMove(event) {
      if (this.isNested) return;
      this.mouse.x = event.clientX / window.innerWidth * 2 - 1;
      this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
      this.ray.setFromCamera(this.mouse, this.camera);
      var intersects = this.ray.intersectObjects([this.mesh]);
      if (intersects.length > 0) {
        var i, dist, angle;
        var vert = new this.THREE.Vector3();
        var normal = new this.THREE.Vector3();
        if (event.shiftKey) {
          this.highlightedFaces = [];
          if (this.params.brushMode) {
            this.mesh.updateMatrixWorld();
            for (i = 0; i < this.mesh.geometry.attributes.position.count; i++) {
              vert = vert.set(this.mesh.geometry.attributes.position.array[i * 3], this.mesh.geometry.attributes.position.array[i * 3 + 1], this.mesh.geometry.attributes.position.array[i * 3 + 2]).clone().applyMatrix4(this.mesh.matrixWorld);
              normal = normal.set(this.mesh.geometry.attributes.normal.array[i * 3], this.mesh.geometry.attributes.normal.array[i * 3 + 1], this.mesh.geometry.attributes.normal.array[i * 3 + 2]);
              angle = normal.angleTo(intersects[0].face.normal);
              dist = vert.distanceTo(intersects[0].point);
              if (dist < this.params.brushRadius) {
                if (!this.params.brushBothSide) {
                  if (angle >= -Math.PI / 2 && angle <= Math.PI / 2) {
                    this.faceSelect(Math.floor(i / 3));
                  }
                } else {
                  this.faceSelect(Math.floor(i / 3));
                }
              }
            }
            this.faceSelect(intersects[0].faceIndex / 3);
          } else {
            this.faceSelect(intersects[0].faceIndex / 3);
          }
        } else {
          this.highlightedFaces = [];
          if (this.params.brushMode) {
            this.mesh.updateMatrixWorld();
            for (i = 0; i < this.mesh.geometry.attributes.position.count; i++) {
              vert = vert.set(this.mesh.geometry.attributes.position.array[i * 3], this.mesh.geometry.attributes.position.array[i * 3 + 1], this.mesh.geometry.attributes.position.array[i * 3 + 2]).clone().applyMatrix4(this.mesh.matrixWorld);
              normal = normal.set(this.mesh.geometry.attributes.normal.array[i * 3], this.mesh.geometry.attributes.normal.array[i * 3 + 1], this.mesh.geometry.attributes.normal.array[i * 3 + 2]);
              angle = normal.angleTo(intersects[0].face.normal);
              dist = vert.distanceTo(intersects[0].point);
              if (dist < this.params.brushRadius) {
                if (!this.params.brushBothSide) {
                  if (angle >= -Math.PI / 2 && angle < Math.PI / 2) {
                    this.checkHighlight(Math.floor(i / 3));
                  }
                } else {
                  this.checkHighlight(Math.floor(i / 3));
                }
              }
            }
            this.checkHighlight(intersects[0].faceIndex / 3);
          } else {
            this.highlightedFaces = [];

            this.checkHighlight(intersects[0].faceIndex / 3);
          }
        }
      } else {
        this.highlightedFaces = [];
      }
    }
  }, {
    key: 'onDocumentMouseUp',
    value: function onDocumentMouseUp() {
      if (this.isManualPlacementMode || !this.params.orientation_mode) return;

      var group = this.groupPart;
      if (this.isNested) {
        if (!this.transformControl.wasDragging) return;
        group = this.scene.getObjectByName(this.currentPartName);
      }
      this.centeredPosition(group);
    }
  }, {
    key: 'onDocumentContextMenu',
    value: function onDocumentContextMenu(event) {
      if (this.params.orientation_mode) {
        this.mouse.x = event.clientX / window.innerWidth * 2 - 1;
        this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        this.ray.setFromCamera(this.mouse, this.camera);
        var intersects = this.ray.intersectObjects([this.mesh]);
        if (intersects.length > 0) {
          this.contextMenuToggle(true, { x: event.clientX, y: event.clientY });
          this.contextMenuIntersect = intersects[0].face.normal;
        }
      }
    }
  }, {
    key: 'roundRotation',
    value: function roundRotation(group) {
      group.rotation.x = this.deg2rad(Math.round(this.rad2deg(group.rotation.x)));
      group.rotation.y = this.deg2rad(Math.round(this.rad2deg(group.rotation.y)));
      group.rotation.z = this.deg2rad(Math.round(this.rad2deg(group.rotation.z)));
    }
  }, {
    key: 'updateConfig',
    value: function updateConfig(data, config) {
      var rotation = data.rotation,
          scaling = data.scaling,
          facesRestrictions = data.facesRestrictions,
          restriction = data.restriction,
          units = data.units;

      config.RotationalAngle = rotation;
      config.scaling = scaling;
      config.AllowedFaces = facesRestrictions.allowedFaces;
      config.RestrictedFaces = facesRestrictions.restrictedFaces;
      config.unit = units.part;
      if (this.isNested && !this.allowZRotation && !this.isManualPlacement) {
        var _rotation = (0, _slicedToArray3.default)(rotation, 2),
            x = _rotation[0],
            y = _rotation[1];

        config.RotationalAngle = [x, y, 0];
      }
      if (units.hasOwnProperty('support')) {
        config.unit_supp = units.support;
      }
      if (restriction) {
        config['AngleRestriction'] = restriction;
      } else {
        config['AngleRestriction'] = [];
      }
    }
  }, {
    key: 'centeredPosition',
    value: function centeredPosition(group) {
      var bbox = new this.THREE.Box3().setFromObject(group);
      var modelBase = bbox.min.z;
      var center = bbox.getCenter();
      if (!this.isManualPlacementMode) {
        group.position.x = group.position.x - center.x;
        group.position.y = group.position.y - center.y;
      }
      if (!this.uploadedSupports) {
        group.position.z = group.position.z - modelBase + this.params.hsub;
      }
      this.roundRotation(group);
    }
  }, {
    key: 'makeParallelToBuildPlate',
    value: function makeParallelToBuildPlate() {
      if (this.params.orientation_mode) {
        if (this.contextMenuIntersect) {
          var n = this.contextMenuIntersect.clone();
          var q = new this.THREE.Quaternion().setFromUnitVectors(n, new this.THREE.Vector3(0, 0, -1));
          this.groupPart.rotation.setFromQuaternion(q);
          this.centeredPosition(this.groupPart);
          this.contextMenuIntersect = null;
        }
      }
    }
  }, {
    key: 'checkHighlight',
    value: function checkHighlight(faceIndex) {
      var idxHighlighted = this.highlightedFaces.indexOf(faceIndex);
      if (idxHighlighted === -1) {
        this.highlightedFaces.push(faceIndex);
        return true;
      }
      return false;
    }
  }, {
    key: 'colorChange',
    value: function colorChange(child, color) {
      if (!child.geometry.attributes.hasOwnProperty('color')) {
        var colorData = new Float32Array(child.geometry.attributes.position.count * 3);
        for (var i = 0; i < child.geometry.attributes.position.count; i++) {
          colorData[i * 3] = color.r;
          colorData[i * 3 + 1] = color.g;
          colorData[i * 3 + 2] = color.b;
        }
        child.geometry.addAttribute('color', new this.THREE.BufferAttribute(colorData, 3));
      } else {
        for (var _i = 0; _i < child.geometry.attributes.color.count; _i++) {
          child.geometry.attributes.color.array[_i * 3] = color.r;
          child.geometry.attributes.color.array[_i * 3 + 1] = color.g;
          child.geometry.attributes.color.array[_i * 3 + 2] = color.b;
        }
      }
      child.geometry.attributes.color.needsUpdate = true;
    }
  }, {
    key: 'colorFaces',
    value: function colorFaces() {
      var _this6 = this;

      if (this.mesh) {
        for (var i = 0; i < this.mesh.geometry.attributes.color.count; i++) {
          this.mesh.geometry.attributes.color.array[i * 3] = this.colorObj.default.r;
          this.mesh.geometry.attributes.color.array[i * 3 + 1] = this.colorObj.default.g;
          this.mesh.geometry.attributes.color.array[i * 3 + 2] = this.colorObj.default.b;
        }
        this.restrictedFaces.forEach(function (faceIndex) {
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3] = _this6.colorObj.restrict.r;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 1] = _this6.colorObj.restrict.g;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 2] = _this6.colorObj.restrict.b;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 3] = _this6.colorObj.restrict.r;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 4] = _this6.colorObj.restrict.g;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 5] = _this6.colorObj.restrict.b;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 6] = _this6.colorObj.restrict.r;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 7] = _this6.colorObj.restrict.g;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 8] = _this6.colorObj.restrict.b;
        });
        this.allowedFaces.forEach(function (faceIndex) {
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3] = _this6.colorObj.allow.r;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 1] = _this6.colorObj.allow.g;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 2] = _this6.colorObj.allow.b;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 3] = _this6.colorObj.allow.r;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 4] = _this6.colorObj.allow.g;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 5] = _this6.colorObj.allow.b;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 6] = _this6.colorObj.allow.r;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 7] = _this6.colorObj.allow.g;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 8] = _this6.colorObj.allow.b;
        });
        this.highlightedFaces.forEach(function (faceIndex) {
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3] = _this6.colorObj.highlighted.r;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 1] = _this6.colorObj.highlighted.g;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 2] = _this6.colorObj.highlighted.b;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 3] = _this6.colorObj.highlighted.r;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 4] = _this6.colorObj.highlighted.g;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 5] = _this6.colorObj.highlighted.b;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 6] = _this6.colorObj.highlighted.r;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 7] = _this6.colorObj.highlighted.g;
          _this6.mesh.geometry.attributes.color.array[faceIndex * 3 * 3 + 8] = _this6.colorObj.highlighted.b;
        });
        this.mesh.geometry.attributes.color.needsUpdate = true;
      }
    }
  }, {
    key: 'drawGround',
    value: function drawGround() {
      var plane = new this.THREE.Mesh(new this.THREE.PlaneBufferGeometry(100000, 100000), new this.THREE.MeshPhongMaterial({ color: 0x73767b, specular: 0x000000 }));

      if (this.PRINTER_CONFIG_LIBRARY[this.PRINTER]) {
        plane.position.z = this.PRINTER_CONFIG_LIBRARY[this.PRINTER].zRotation;
      } else if (this.PRINTERS_CONFIG[this.PRINTER]) {
        plane.position.z = Number(this.PRINTERS_CONFIG[this.PRINTER].plateThickness) * -1 / 2;
      } else {
        plane.position.z = Number(this.CONFIG.plateThickness[0]) * -1 / 2;
      }
      plane.receiveShadow = true;
      this.groupBase.add(plane);
    }
  }, {
    key: 'drawPrinter',
    value: function drawPrinter() {
      var _this7 = this;

      var THREE_TEXT = window['THREE_Text'];

      var _ref9 = this.isManualPlacement ? [this.marginX, this.marginY] : [0, 0],
          _ref10 = (0, _slicedToArray3.default)(_ref9, 2),
          x = _ref10[0],
          y = _ref10[1];

      var getPoints = function getPoints(d, h) {
        var w = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : d;

        var halfD = d / 2;
        var halfW = w / 2;
        return [new _this7.THREE.Vector3(-halfD, -halfW, 0), new _this7.THREE.Vector3(-halfD, halfW, 0), new _this7.THREE.Vector3(halfD, halfW, 0), new _this7.THREE.Vector3(halfD, -halfW, 0), new _this7.THREE.Vector3(-halfD, -halfW, h), new _this7.THREE.Vector3(-halfD, halfW, h), new _this7.THREE.Vector3(halfD, halfW, h), new _this7.THREE.Vector3(halfD, -halfW, h)];
      };
      var getMarginPoints = function getMarginPoints(d, h) {
        var w = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : d;

        var halfD = d / 2;
        var halfW = w / 2;
        return [new _this7.THREE.Vector3(-halfD + x, -halfW + y, 0), new _this7.THREE.Vector3(-halfD + x, halfW - y, 0), new _this7.THREE.Vector3(halfD - x, halfW - y, 0), new _this7.THREE.Vector3(halfD - x, -halfW + y, 0), new _this7.THREE.Vector3(-halfD + x, -halfW + y, h), new _this7.THREE.Vector3(-halfD + x, halfW - y, h), new _this7.THREE.Vector3(halfD - x, halfW - y, h), new _this7.THREE.Vector3(halfD - x, -halfW + y, h)];
      };
      switch (this.PRINTER) {
        case 'EOSM100':
          var material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          var Diameter = 100;
          var Height = 95;
          var points = getPoints(Diameter, Height);
          var p1 = points[0];
          var p2 = points[1];
          var p3 = points[2];
          var p4 = points[3];
          var p5 = points[4];
          var p6 = points[5];
          var p7 = points[6];
          var p8 = points[7];
          var geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(p5, p6, p7, p8, p5);
          var line1 = new this.THREE.Line(geometry1, material);
          line1.name = 'top';
          var geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(p1, p5);
          var line2 = new this.THREE.Line(geometry2, material);
          var geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(p2, p6);
          var line3 = new this.THREE.Line(geometry3, material);
          var geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(p3, p7);
          var line4 = new this.THREE.Line(geometry4, material);
          var geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(p4, p8);
          var line5 = new this.THREE.Line(geometry5, material);
          var geometry6 = new this.THREE.Geometry();
          geometry6.vertices.push(p1, p2, p3, p4, p1);
          var line6 = new this.THREE.Line(geometry6, material);
          if (this.isManualPlacement) {
            var geometry7 = new this.THREE.BoxGeometry(1, 1, 1);
            geometry7.vertices = getMarginPoints(Diameter, Height);
            var pMesh = new this.THREE.Mesh(geometry7, material);
            pMesh.position.z = 0.0002;
            var pBox = new this.THREE.BoxHelper(pMesh, 0xFF0000);
            pBox.name = 'printer';
            pBox.visible = false;
            this.scene.add(pBox);
          }
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);
          this.scene.add(line6);

          var grid = new this.THREE.GridHelper(100, 10, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          var arrow1 = new this.THREE.ArrowHelper(new this.THREE.Vector3(-1, 0, 0), new this.THREE.Vector3(Diameter / 2 + 5, Diameter / 2 + 5, 0), 20, 0x000000);
          var arrow2 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, -1, 0), new this.THREE.Vector3(Diameter / 2 + 5, Diameter / 2 + 5, 0), 20, 0x000000);
          var arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 20, 0x000000);
          var arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 20, 0x000000);
          var arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 20, 0x000000);
          this.scene.add(arrow1);
          this.scene.add(arrow2);
          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);

          var Text2D = THREE_TEXT.Text2D;
          var textAlign = THREE_TEXT.textAlign;
          var sprdtext = new Text2D('Recoater', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0.5 * Math.PI, -0.5 * Math.PI, 0);
          sprdtext.position.set(54, 0, 17);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('recoating', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(Diameter / 2 - 5, Diameter / 2 + 10, 0);
          this.scene.add(sprdtext);

          sprdtext = new Text2D('x', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-40, -55, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-57, -40, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-57, -57, 20);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('ϕ100 x 95mm', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -55, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = 0;
          this.groupBase.position.y = 0;
          this.groupBase.position.z = -15;
          this.scene.add(this.groupBase);
          break;
        case 'ArcamQ20':
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          Diameter = 350;
          Height = 380;
          points = getPoints(Diameter, Height);
          p1 = points[0];
          p2 = points[1];
          p3 = points[2];
          p4 = points[3];
          p5 = points[4];
          p6 = points[5];
          p7 = points[6];
          p8 = points[7];
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(p5, p6, p7, p8, p5);
          line1 = new this.THREE.Line(geometry1, material);
          line1.name = 'top';
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(p1, p5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(p2, p6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(p3, p7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(p4, p8);
          line5 = new this.THREE.Line(geometry5, material);
          geometry6 = new this.THREE.Geometry();
          geometry6.vertices.push(p1, p2, p3, p4, p1);
          line6 = new this.THREE.Line(geometry6, material);
          if (this.isManualPlacement) {
            geometry7 = new this.THREE.Geometry();
            geometry7.vertices = getMarginPoints(Diameter, Height);
            pMesh = new this.THREE.Mesh(geometry7, material);
            pMesh.position.z = 0.0002;
            pBox = new this.THREE.BoxHelper(pMesh, 0xFF0000);
            pBox.name = 'printer';
            pBox.visible = false;
            this.scene.add(pBox);
          }
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);
          this.scene.add(line6);

          grid = new this.THREE.GridHelper(350, 35, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);

          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('x', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-130, -180, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-185, -150, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-185, -185, 50);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('ϕ350 x 380 mm', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -200, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = -Diameter / 2;
          this.groupBase.position.y = -Diameter / 2;
          this.groupBase.position.z = -30;
          this.scene.add(this.groupBase);
          break;
        case 'IntechSF1':
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          Diameter = 150;
          Height = 180;
          points = getPoints(Diameter, Height);
          p1 = points[0];
          p2 = points[1];
          p3 = points[2];
          p4 = points[3];
          p5 = points[4];
          p6 = points[5];
          p7 = points[6];
          p8 = points[7];
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(p5, p6, p7, p8, p5);
          line1 = new this.THREE.Line(geometry1, material);
          line1.name = 'top';
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(p1, p5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(p2, p6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(p3, p7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(p4, p8);
          line5 = new this.THREE.Line(geometry5, material);
          geometry6 = new this.THREE.Geometry();
          geometry6.vertices.push(p1, p2, p3, p4, p1);
          line6 = new this.THREE.Line(geometry6, material);
          if (this.isManualPlacement) {
            geometry7 = new this.THREE.Geometry();
            geometry7.vertices = getMarginPoints(Diameter, Height);
            pMesh = new this.THREE.Mesh(geometry7, material);
            pMesh.position.z = 0.0002;
            pBox = new this.THREE.BoxHelper(pMesh, 0xFF0000);
            pBox.name = 'printer';
            pBox.visible = false;
            this.scene.add(pBox);
          }
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);
          this.scene.add(line6);

          grid = new this.THREE.GridHelper(150, 15, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);

          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('x', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-30, -80, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-85, -50, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-85, -85, 50);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('ϕ150 x 180 mm', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -80, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = -Diameter / 2;
          this.groupBase.position.y = -Diameter / 2;
          this.groupBase.position.z = -30;
          this.scene.add(this.groupBase);
          break;
        case 'EOSM290':
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          points = getPoints(250, 325);
          p1 = points[0];
          p2 = points[1];
          p3 = points[2];
          p4 = points[3];
          p5 = points[4];
          p6 = points[5];
          p7 = points[6];
          p8 = points[7];
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(p5, p6, p7, p8, p5);
          line1 = new this.THREE.Line(geometry1, material);
          line1.name = 'top';
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(p1, p5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(p2, p6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(p3, p7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(p4, p8);
          line5 = new this.THREE.Line(geometry5, material);
          if (this.isManualPlacement) {
            geometry7 = new this.THREE.BoxGeometry(1, 1, 1);
            geometry7.vertices = getMarginPoints(250, 325);
            pMesh = new this.THREE.Mesh(geometry7, material);
            pMesh.position.z = 0.0002;
            pBox = new this.THREE.BoxHelper(pMesh, 0xFF0000);
            pBox.name = 'printer';
            pBox.visible = false;
            this.scene.add(pBox);
          }
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);

          grid = new this.THREE.GridHelper(250, 25, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          arrow1 = new this.THREE.ArrowHelper(new this.THREE.Vector3(-1, 0, 0), new this.THREE.Vector3(130, 130, 0), 40, 0x000000);
          arrow2 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, -1, 0), new this.THREE.Vector3(130, 130, 0), 40, 0x000000);
          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          this.scene.add(arrow1);
          this.scene.add(arrow2);
          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('Recoater', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0.5 * Math.PI, -0.5 * Math.PI, 0);
          sprdtext.position.set(144, 0, 17);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('recoating', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(105, 142, 0);
          this.scene.add(sprdtext);

          sprdtext = new Text2D('x', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-95, -130, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-135, -90, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-135, -135, 40);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('250 x 250 x 325mm', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -130, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = -125;
          this.groupBase.position.y = -125;
          this.groupBase.position.z = -25;
          this.scene.add(this.groupBase);
          break;
        case 'EOSM400':
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          Diameter = 400;
          Height = 360;
          points = getPoints(Diameter, Height);
          p1 = points[0];
          p2 = points[1];
          p3 = points[2];
          p4 = points[3];
          p5 = points[4];
          p6 = points[5];
          p7 = points[6];
          p8 = points[7];
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(p5, p6, p7, p8, p5);
          line1 = new this.THREE.Line(geometry1, material);
          line1.name = 'top';
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(p1, p5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(p2, p6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(p3, p7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(p4, p8);
          line5 = new this.THREE.Line(geometry5, material);
          geometry6 = new this.THREE.Geometry();
          geometry6.vertices.push(p1, p2, p3, p4, p1);
          line6 = new this.THREE.Line(geometry6, material);
          if (this.isManualPlacement) {
            geometry7 = new this.THREE.BoxGeometry(1, 1, 1);
            geometry7.vertices = getMarginPoints(Diameter, Height);
            pMesh = new this.THREE.Mesh(geometry7, material);
            pMesh.position.z = 0.0002;
            pBox = new this.THREE.BoxHelper(pMesh, 0xFF0000);
            pBox.name = 'printer';
            pBox.visible = false;
            this.scene.add(pBox);
          }
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);
          this.scene.add(line6);

          grid = new this.THREE.GridHelper(400, 40, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          arrow1 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(240, 0, 0), 50, 0x000000);
          arrow2 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, -1, 0), new this.THREE.Vector3(205, 40, 0), 80, 0x000000);
          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);
          var arrow6 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(205, -40, 0), 80, 0x000000);
          this.scene.add(arrow1);
          this.scene.add(arrow2);
          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);
          this.scene.add(arrow6);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('Recoater', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.25, 0.25, 0.25);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(0, 219, 30);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('recoating', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.2, 0.2, 0.2);
          sprdtext.rotation.set(0, 0, -0.5 * Math.PI);
          sprdtext.position.set(230, 0, 0);
          this.scene.add(sprdtext);

          sprdtext = new Text2D('x', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.2, 0.2, 0.2);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-160, -205, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.2, 0.2, 0.2);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-215, -155, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.2, 0.2, 0.2);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-210, -210, 50);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('400 x 400 x 400 mm', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.2, 0.2, 0.2);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -210, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = -200;
          this.groupBase.position.y = -200;
          this.groupBase.position.z = -40;
          this.scene.add(this.groupBase);
          break;
        case 'SLM280':
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          Diameter = 280;
          Height = 335;
          points = getPoints(Diameter, Height);
          p1 = points[0];
          p2 = points[1];
          p3 = points[2];
          p4 = points[3];
          p5 = points[4];
          p6 = points[5];
          p7 = points[6];
          p8 = points[7];
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(p5, p6, p7, p8, p5);
          line1 = new this.THREE.Line(geometry1, material);
          line1.name = 'top';
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(p1, p5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(p2, p6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(p3, p7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(p4, p8);
          line5 = new this.THREE.Line(geometry5, material);
          if (this.isManualPlacement) {
            geometry7 = new this.THREE.BoxGeometry(1, 1, 1);
            geometry7.vertices = getMarginPoints(Diameter, Height);
            pMesh = new this.THREE.Mesh(geometry7, material);
            pMesh.position.z = 0.0002;
            pBox = new this.THREE.BoxHelper(pMesh, 0xFF0000);
            pBox.name = 'printer';
            pBox.visible = false;
            this.scene.add(pBox);
          }
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);

          grid = new this.THREE.GridHelper(280, 28, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          arrow1 = new this.THREE.ArrowHelper(new this.THREE.Vector3(-1, 0, 0), new this.THREE.Vector3(145, 145, 0), 40, 0x000000);
          arrow2 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, -1, 0), new this.THREE.Vector3(145, 20, 0), 40, 0x000000);
          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-145, -145, 0), 40, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-145, -145, 0), 40, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-145, -145, 0), 40, 0x000000);
          arrow6 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(145, -20, 0), 40, 0x000000);
          this.scene.add(arrow1);
          this.scene.add(arrow2);
          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);
          this.scene.add(arrow6);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('Recoater', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(0, 159, 30);
          this.scene.add(sprdtext);

          sprdtext = new Text2D('recoating', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, -0.5 * Math.PI);
          sprdtext.position.set(158, 0, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('x', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-110, -145, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-150, -105, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-150, -150, 40);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('280 x 280 x 365mm', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -147, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = -140;
          this.groupBase.position.y = -140;
          this.groupBase.position.z = -30;
          this.scene.add(this.groupBase);
          break;
        case 'RenishawAM250':
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          Diameter = 250;
          Height = 300;
          points = getPoints(Diameter, Height);
          p1 = points[0];
          p2 = points[1];
          p3 = points[2];
          p4 = points[3];
          p5 = points[4];
          p6 = points[5];
          p7 = points[6];
          p8 = points[7];
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(p5, p6, p7, p8, p5);
          line1 = new this.THREE.Line(geometry1, material);
          line1.name = 'top';
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(p1, p5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(p2, p6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(p3, p7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(p4, p8);
          line5 = new this.THREE.Line(geometry5, material);
          if (this.isManualPlacement) {
            geometry7 = new this.THREE.BoxGeometry(1, 1, 1);
            geometry7.vertices = getMarginPoints(Diameter, Height);
            pMesh = new this.THREE.Mesh(geometry7, material);
            pMesh.position.z = 0.0002;
            pBox = new this.THREE.BoxHelper(pMesh, 0xFF0000);
            pBox.name = 'printer';
            pBox.visible = false;
            this.scene.add(pBox);
          }
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);

          grid = new this.THREE.GridHelper(250, 25, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          arrow1 = new this.THREE.ArrowHelper(new this.THREE.Vector3(-1, 0, 0), new this.THREE.Vector3(130, 130, 0), 40, 0x000000);
          arrow2 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, -1, 0), new this.THREE.Vector3(130, 130, 0), 40, 0x000000);
          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          this.scene.add(arrow1);
          this.scene.add(arrow2);
          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('Recoater', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(0, 144, 22);
          this.scene.add(sprdtext);

          sprdtext = new Text2D('recoating', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, -0.5 * Math.PI);
          sprdtext.position.set(140, 105, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('x', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-95, -130, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-135, -90, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-135, -135, 40);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('250 x 250 x 300mm', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -130, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = -125;
          this.groupBase.position.y = -125;
          this.groupBase.position.z = -15;
          this.scene.add(this.groupBase);
          break;
        case 'RenishawAM500':
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          Diameter = 250;
          Height = 350;
          points = getPoints(Diameter, Height);
          p1 = points[0];
          p2 = points[1];
          p3 = points[2];
          p4 = points[3];
          p5 = points[4];
          p6 = points[5];
          p7 = points[6];
          p8 = points[7];
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(p5, p6, p7, p8, p5);
          line1 = new this.THREE.Line(geometry1, material);
          line1.name = 'top';
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(p1, p5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(p2, p6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(p3, p7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(p4, p8);
          line5 = new this.THREE.Line(geometry5, material);
          if (this.isManualPlacement) {
            geometry7 = new this.THREE.BoxGeometry(1, 1, 1);
            geometry7.vertices = getMarginPoints(Diameter, Height);
            pMesh = new this.THREE.Mesh(geometry7, material);
            pMesh.position.z = 0.0002;
            pBox = new this.THREE.BoxHelper(pMesh, 0xFF0000);
            pBox.name = 'printer';
            pBox.visible = false;
            this.scene.add(pBox);
          }
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);

          grid = new this.THREE.GridHelper(250, 25, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          arrow1 = new this.THREE.ArrowHelper(new this.THREE.Vector3(-1, 0, 0), new this.THREE.Vector3(130, 130, 0), 40, 0x000000);
          arrow2 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, -1, 0), new this.THREE.Vector3(130, 130, 0), 40, 0x000000);
          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          this.scene.add(arrow1);
          this.scene.add(arrow2);
          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('Recoater', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(0, 144, 22);
          this.scene.add(sprdtext);

          sprdtext = new Text2D('recoating', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, -0.5 * Math.PI);
          sprdtext.position.set(140, 105, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('x', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-95, -130, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-135, -90, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-135, -135, 40);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('250 x 250 x 350mm', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -130, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = -125;
          this.groupBase.position.y = -125;
          this.groupBase.position.z = -15;
          this.scene.add(this.groupBase);
          break;
        default:
          var length, width, height, thickness;
          if (this.PRINTERS_CONFIG[this.PRINTER]) {
            var printerConfig = this.PRINTERS_CONFIG[this.PRINTER];
            length = printerConfig.plateX;
            width = printerConfig.plateY;
            height = printerConfig.plateZ;
            thickness = printerConfig.plateThickness;
          } else {
            length = this.CONFIG.PrinterXYZ[0];
            width = this.CONFIG.PrinterXYZ[1];
            height = this.CONFIG.PrinterXYZ[2];
            thickness = Number(this.CONFIG.plateThickness[0]);
          }

          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          var buildPlate = new this.THREE.BoxBufferGeometry(length, width, thickness);
          buildPlate.computeFaceNormals();
          buildPlate.computeVertexNormals();
          buildPlate = new this.THREE.Mesh(buildPlate, material);

          var recoaterShape = new this.THREE.Shape([new this.THREE.Vector2(0, 0), new this.THREE.Vector2(8, 4), new this.THREE.Vector2(8, 24), new this.THREE.Vector2(0, 24)]);
          var recoaterGeometry;
          if (this.CONFIG.DirectionRecoater[0]) {
            recoaterGeometry = new this.THREE.ExtrudeGeometry(recoaterShape, {
              amount: width,
              bevelEnabled: false
            });
          } else {
            recoaterGeometry = new this.THREE.ExtrudeGeometry(recoaterShape, {
              amount: length,
              bevelEnabled: false
            });
          }
          var recoater = new this.THREE.Mesh(recoaterGeometry, material);
          if (this.CONFIG.DirectionRecoater[0]) {
            recoater.rotation.set(Math.PI / 2, 0, 0);
            recoater.position.set(length / 2 + 24, width / 2, 7);
          } else {
            recoater.rotation.set(Math.PI / 2, Math.PI / 2, 0);
            recoater.position.set(-length / 2, width / 2 + 24, 7);
          }

          this.scene.add(recoater);

          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          points = getPoints(length, height, length);
          p1 = points[0];
          p2 = points[1];
          p3 = points[2];
          p4 = points[3];
          p5 = points[4];
          p6 = points[5];
          p7 = points[6];
          p8 = points[7];
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(p5, p6, p7, p8, p5);
          line1 = new this.THREE.Line(geometry1, material);
          line1.name = 'top';
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(p1, p5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(p2, p6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(p3, p7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(p4, p8);
          line5 = new this.THREE.Line(geometry5, material);
          if (this.isManualPlacement) {
            geometry7 = new this.THREE.BoxGeometry(1, 1, 1);
            geometry7.vertices = getMarginPoints(length, height, length);
            pMesh = new this.THREE.Mesh(geometry7, material);
            pMesh.position.z = 0.0002;
            pBox = new this.THREE.BoxHelper(pMesh, 0xFF0000);
            pBox.name = 'printer';
            pBox.visible = false;
            this.scene.add(pBox);
          }
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);

          grid = new this.THREE.Geometry();
          material = new this.THREE.LineBasicMaterial({ color: 0x555555 });
          for (var i = 0; i <= length; i += 10) {
            grid.vertices.push(new this.THREE.Vector3(i, 0, 0));
            grid.vertices.push(new this.THREE.Vector3(i, width, 0));
          }
          grid.vertices.push(new this.THREE.Vector3(length, 0, 0));
          grid.vertices.push(new this.THREE.Vector3(length, width, 0));

          for (i = 0; i <= width; i += 10) {
            grid.vertices.push(new this.THREE.Vector3(0, i, 0));
            grid.vertices.push(new this.THREE.Vector3(length, i, 0));
          }
          grid.vertices.push(new this.THREE.Vector3(0, width, 0));
          grid.vertices.push(new this.THREE.Vector3(length, width, 0));

          var gridLine = new this.THREE.LineSegments(grid, material);
          gridLine.position.set(-length / 2, -width / 2, 0.0001);
          this.scene.add(gridLine);

          arrow1 = new this.THREE.ArrowHelper(new this.THREE.Vector3(-1, 0, 0), new this.THREE.Vector3(length / 2 + 10, width / 2 + 10, 0), 40, 0x000000);
          arrow2 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, -1, 0), new this.THREE.Vector3(length / 2 + 10, width / 2 + 10, 0), 40, 0x000000);
          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-(length / 2) - 10, -(width / 2) - 10, 0), 40, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-(length / 2) - 10, -(width / 2) - 10, 0), 40, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-(length / 2) - 10, -(width / 2) - 10, 0), 40, 0x000000);
          this.scene.add(arrow1);
          this.scene.add(arrow2);
          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('Recoater', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          if (this.CONFIG.DirectionRecoater[0]) {
            sprdtext.rotation.set(0.5 * Math.PI, -0.5 * Math.PI, 0);
            sprdtext.position.set(length / 2 + 24 - 0.01, 0, 28);
          } else {
            sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
            sprdtext.position.set(0, width / 2 + 24 - 0.01, 28);
          }

          this.scene.add(sprdtext);
          sprdtext = new Text2D('recoating', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          if (this.CONFIG.DirectionRecoater[0]) {
            sprdtext.rotation.set(0, 0, 0);
            sprdtext.position.set(length / 2 - 8, width / 2 + 22, 0);
          } else {
            sprdtext.rotation.set(0, 0, -0.5 * Math.PI);
            sprdtext.position.set(length / 2 + 22, width / 2 - 10, 0);
          }
          this.scene.add(sprdtext);

          sprdtext = new Text2D('x', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-(length / 2) - 15 + 40, -(width / 2) - 10, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-(length / 2) - 15, -(width / 2) - 10 + 40, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-(length / 2) - 15, -(width / 2) - 10, 40);
          this.scene.add(sprdtext);
          sprdtext = new Text2D(length + ' x ' + width + ' x ' + height + 'mm', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -(width / 2) - 24, 0);
          this.scene.add(sprdtext);

          this.groupBase.add(buildPlate);
          this.groupBase.position.z = -(thickness / 2);
          this.scene.add(this.groupBase);
          break;
      }
    }
  }, {
    key: 'setupInset',
    value: function setupInset() {
      var insetWidth = 150;
      var insetHeight = 150;

      this.container = document.getElementById('inset');
      this.container.width = insetWidth;
      this.container.height = insetHeight;

      this.renderer2 = new this.THREE.WebGLRenderer({ alpha: true });
      this.renderer2.setClearColor(0x000000, 0);
      this.renderer2.setSize(insetWidth, insetHeight);
      this.container.appendChild(this.renderer2.domElement);

      this.scene2 = new this.THREE.Scene();

      this.camera2 = new this.THREE.PerspectiveCamera(50, insetWidth / insetHeight, 1, 1000);
      this.camera2.up = this.camera.up;
      var axis2 = new this.THREE.AxisHelper(100);
      this.scene2.add(axis2);
    }
  }, {
    key: 'togglePrintBoxVisible',
    value: function togglePrintBoxVisible() {
      var isVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var pBox = this.scene.getObjectByName('printer');
      pBox.visible = isVisible;
    }
  }, {
    key: 'getMinMaxVerticles',
    value: function getMinMaxVerticles(obj) {
      var vertices = obj.children[0].geometry.attributes.position.array;
      var maxXMaxYMaxZ = void 0,
          maxXMaxYMinZ = void 0,
          maxXMinYMaxZ = void 0,
          maxXMinYMinZ = void 0,
          minXMaxYMaxZ = void 0,
          minXMaxYMinZ = void 0,
          minXMinYMaxZ = void 0,
          minXMinYMinZ = void 0;
      var maxXMaxYQuart = [];
      var maxXMinYQuart = [];
      var minXMinYQuart = [];
      var minXMaxYQuart = [];
      for (var i = 0; i < vertices.length; i += 3) {
        var _ref11 = [vertices[i], vertices[i + 1], vertices[i + 2]],
            x = _ref11[0],
            y = _ref11[1],
            z = _ref11[2];

        if (x > 0 && y > 0) maxXMaxYQuart.push(x, y, z);
        if (x > 0 && y < 0) maxXMinYQuart.push(x, y, z);
        if (x < 0 && y < 0) minXMinYQuart.push(x, y, z);
        if (x < 0 && y > 0) minXMaxYQuart.push(x, y, z);
      }
      for (var _i2 = 0; _i2 < maxXMaxYQuart.length; _i2 += 3) {
        var _ref12 = [maxXMaxYQuart[_i2], maxXMaxYQuart[_i2 + 1], maxXMaxYQuart[_i2 + 2]],
            _x12 = _ref12[0],
            _y2 = _ref12[1],
            _z = _ref12[2];

        if (_i2 === 0) maxXMaxYMaxZ = maxXMaxYMinZ = { x: _x12, y: _y2, z: _z };
        if (maxXMaxYMaxZ.x < _x12 && maxXMaxYMaxZ.y < _y2 && maxXMaxYMaxZ.z < _z) maxXMaxYMaxZ = { x: _x12, y: _y2, z: _z };
        if (maxXMaxYMinZ.x < _x12 && maxXMaxYMinZ.y < _y2 && maxXMaxYMinZ.z > _z) maxXMaxYMinZ = { x: _x12, y: _y2, z: _z };
      }
      for (var _i3 = 0; _i3 < maxXMinYQuart.length; _i3 += 3) {
        var _ref13 = [maxXMinYQuart[_i3], maxXMinYQuart[_i3 + 1], maxXMinYQuart[_i3 + 2]],
            _x13 = _ref13[0],
            _y3 = _ref13[1],
            _z2 = _ref13[2];

        if (_i3 === 0) maxXMinYMaxZ = maxXMinYMinZ = { x: _x13, y: _y3, z: _z2 };
        if (maxXMinYMaxZ.x < _x13 && maxXMinYMaxZ.y > _y3 && maxXMinYMaxZ.z < _z2) maxXMinYMaxZ = { x: _x13, y: _y3, z: _z2 };
        if (maxXMinYMinZ.x < _x13 && maxXMinYMinZ.y > _y3 && maxXMinYMinZ.z > _z2) maxXMinYMinZ = { x: _x13, y: _y3, z: _z2 };
      }
      for (var _i4 = 0; _i4 < minXMaxYQuart.length; _i4 += 3) {
        var _ref14 = [minXMaxYQuart[_i4], minXMaxYQuart[_i4 + 1], minXMaxYQuart[_i4 + 2]],
            _x14 = _ref14[0],
            _y4 = _ref14[1],
            _z3 = _ref14[2];

        if (_i4 === 0) minXMaxYMaxZ = minXMaxYMinZ = { x: _x14, y: _y4, z: _z3 };
        if (minXMaxYMaxZ.x > _x14 && minXMaxYMaxZ.y < _y4 && minXMaxYMaxZ.z < _z3) minXMaxYMaxZ = { x: _x14, y: _y4, z: _z3 };
        if (minXMaxYMinZ.x > _x14 && minXMaxYMinZ.y < _y4 && minXMaxYMinZ.z > _z3) minXMaxYMinZ = { x: _x14, y: _y4, z: _z3 };
      }
      for (var _i5 = 0; _i5 < minXMinYQuart.length; _i5 += 3) {
        var _ref15 = [minXMinYQuart[_i5], minXMinYQuart[_i5 + 1], minXMinYQuart[_i5 + 2]],
            _x15 = _ref15[0],
            _y5 = _ref15[1],
            _z4 = _ref15[2];

        if (_i5 === 0) minXMinYMaxZ = minXMinYMinZ = { x: _x15, y: _y5, z: _z4 };
        if (minXMinYMaxZ.x > _x15 && minXMinYMaxZ.y > _y5 && minXMinYMaxZ.z < _z4) minXMinYMaxZ = { x: _x15, y: _y5, z: _z4 };
        if (minXMinYMinZ.x > _x15 && minXMinYMinZ.y > _y5 && minXMinYMinZ.z > _z4) minXMinYMinZ = { x: _x15, y: _y5, z: _z4 };
      }
      obj.userData = [maxXMaxYMaxZ, maxXMaxYMinZ, maxXMinYMaxZ, maxXMinYMinZ, minXMaxYMaxZ, minXMaxYMinZ, minXMinYMaxZ, minXMinYMinZ];
    }
  }, {
    key: 'isOutGround',
    value: function isOutGround(vectors) {
      var ground = this.groupBase.children[1];
      ground.name = 'ground';
      var ray = new this.THREE.Raycaster();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(vectors), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var vector = _step2.value;

          ray.set(vector, new this.THREE.Vector3(0, 0, -1));
          var intersects = ray.intersectObjects([ground], true);
          if (!intersects.length) return true;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return false;
    }
  }, {
    key: 'isHigherTop',
    value: function isHigherTop(vectors) {
      var top = this.scene.getObjectByName('top');
      var height = top.geometry.vertices[0].z;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(vectors), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var vector = _step3.value;

          if (vector.z >= height) return true;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return false;
    }
  }, {
    key: 'isOutOfMargin',
    value: function isOutOfMargin(vectors) {
      var pBox = this.scene.getObjectByName('printer').geometry.attributes.position.array;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = (0, _getIterator3.default)(vectors), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _ref16 = _step4.value;
          var x = _ref16.x,
              y = _ref16.y;

          for (var i = 0; i < pBox.length; i += 3) {
            var _ref17 = [Math.abs(pBox[0]), Math.abs(pBox[1])],
                pX = _ref17[0],
                pY = _ref17[1];

            if (Math.abs(x) > pX || Math.abs(y) > pY) return true;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    }
  }, {
    key: 'checkOverlaps',
    value: function checkOverlaps() {
      var _this8 = this;

      var plateGroup = this.getPlateGroup().children;
      if (!plateGroup.length) return this.togglePrintBoxVisible(false);
      var pInx = this.getIndex();
      var config = this.platesConfig[pInx];
      var isOutGround = false;
      var isHeigerThenPrinter = false;
      var isOutOfMargin = false;

      var _loop = function _loop(clone) {
        var vectors = clone.userData;
        var mtrx = clone.matrix;
        vectors = vectors.map(function (_ref18) {
          var x = _ref18.x,
              y = _ref18.y,
              z = _ref18.z;

          var newVector = new _this8.THREE.Vector3(x, y, z);
          newVector.applyMatrix4(mtrx);
          return newVector;
        });
        isHeigerThenPrinter = _this8.isHigherTop(vectors);
        if (isHeigerThenPrinter) return 'break';
        isOutOfMargin = _this8.isOutOfMargin(vectors);
        if (isOutOfMargin) return 'break';
        if (_this8.PRINTERS_CONFIG[_this8.PRINTER].plateMode) {
          isOutGround = _this8.isOutGround(vectors);
          if (isOutGround) return 'break';
        }
      };

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = (0, _getIterator3.default)(plateGroup), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var clone = _step5.value;

          var _ret = _loop(clone);

          if (_ret === 'break') break;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.togglePrintBoxVisible(isOutGround || isHeigerThenPrinter || isOutOfMargin);
      config.errors = isOutGround || isHeigerThenPrinter || isOutOfMargin;
    }
  }, {
    key: 'onTranslateGroup',
    value: function onTranslateGroup() {
      if (!this.isManualPlacementMode || !this.currentObject) return;
      var _currentObject$positi = this.currentObject.position,
          x = _currentObject$positi.x,
          y = _currentObject$positi.y,
          z = _currentObject$positi.z;

      var pInx = this.getIndex();
      var cInx = this.getIndex(this.currentObject.name) * 3;
      var partName = this.getPartName();
      var config = this.oldPosition[pInx][partName];
      var pX = config[cInx];
      var pY = config[cInx + 1];
      if (pX !== x || pY !== y) {
        var newConfig = [];
        for (var i = 0; i < config.length; i += 3) {
          var _ref19 = [config[i], config[i + 1], config[i + 2]],
              _pX = _ref19[0],
              _pY = _ref19[1],
              pZ = _ref19[2];

          if (i === cInx) {
            newConfig.push(x, y, z);
          } else newConfig.push(_pX, _pY, pZ);
        }
        this.oldPosition[pInx][partName] = newConfig;
        this.setCloneRotPosToConfig();
        this.checkOverlaps();
      }
    }
  }, {
    key: 'onRotateGroup',
    value: function onRotateGroup(group, prev) {
      if (!this.params.supportStructures && !this.uploadedSupports && !this.isNested) {
        if (this.groupSupp.children.length > 0) {
          prev.supportTransparency = this.groupSupp.children[0].material.opacity;
        }
        this.params.supportTransparency = prev.supportTransparency;
        this._supports_transparency.updateDisplay();
      }
      if ((prev.scale !== group.scale.z || !this.params.orientation_mode) && !this.uploadedSupports) {
        prev.scale = group.scale.z;
        this.params.scale_factor = group.scale.z / this.unit2mmConstant(this.CONFIG.unit);
        this._scale.updateDisplay();
      }
      if ((prev.x !== group.rotation.x || !this.params.orientation_mode) && !this.uploadedSupports) {
        prev.x = group.rotation.x;
        this.params.Rotate_about_X = this.rad2deg(group.rotation.x);
        this._x.updateDisplay();
      }
      if ((prev.y !== group.rotation.y || !this.params.orientation_mode) && !this.uploadedSupports) {
        prev.y = group.rotation.y;
        this.params.Rotate_about_Y = this.rad2deg(group.rotation.y);
        this._y.updateDisplay();
      }
      if ((prev.z !== group.rotation.z || !this.params.orientation_mode) && !this.uploadedSupports) {
        prev.z = group.rotation.z;
        this.params.Rotate_about_Z = this.rad2deg(group.rotation.z);
        if (this.isNested && !this.allowZRotation && !this.isManualPlacement) return;else this._z.updateDisplay();
      }
    }
  }, {
    key: 'animate',
    value: function animate() {
      this.cancelID = requestAnimationFrame(this.animate.bind(this));

      this.controls.update();

      if (this.finishedLoading) {
        if (!this.isNested) {
          this.colorFaces();
        }
        if (this.camera.getWorldDirection().angleTo(new this.THREE.Vector3(0, 0, -1)) > Math.PI / 2) {
          this.groupBase.visible = false;
        } else {
          this.groupBase.visible = true;
        }
      }

      this.camera2.position.copy(this.camera.position);
      this.camera2.position.sub(this.controls.target);
      this.camera2.position.setLength(300);
      this.camera2.lookAt(this.scene2.position);
      if (this.params.orientation_mode) {
        if (!this.isNested) {
          this.onRotateGroup(this.groupPart, this.old);
        } else if (!this.isManualPlacementMode) {
          this.toggleControlDisabled(this._z, false);
          var group = this['nestedPart' + this.currentPartName];
          var prev = this.old[this.currentPartName];
          this.onRotateGroup(group, prev);
        } else {
          if (this.currentObject) {
            this.toggleControlDisabled(this._z, false);
            this.onTranslateGroup();
            if (this.rad2deg(this.currentObject.rotation.z) !== this.params.Rotate_about_Z) {
              this.params.Rotate_about_Z = this.rad2deg(this.currentObject.rotation.z);
              this._z.updateDisplay();
              this.checkOverlaps();
              this.setCloneRotPosToConfig();
            }
            this.setTextGray(this._remove_part, false);
          } else {
            this.toggleControlDisabled(this._z, true);
            this.setTextGray(this._remove_part, true);
          }
        }
      }
      this.renderer.render(this.scene, this.camera);
      this.renderer2.render(this.scene2, this.camera2);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      cancelAnimationFrame(this.cancelID);
      this.renderer.domElement.addEventListener('dblclick', null, false);
      window.removeEventListener('resize', this.onWindowResize);
      window.removeEventListener('click', this.onDocumentMouseClick);
      window.removeEventListener('mousemove', this.onDocumentMouseMove);
      window.removeEventListener('mouseup', this.onDocumentMouseUp, true);
      window.removeEventListener('contextmenu', this.onDocumentContextMenu);

      var elements = document.getElementsByClassName('ui-tooltip');
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0]);
      }

      this.scene = null;
      this.projector = null;
      this.camera = null;
      this.controls = null;
      this.transformControl = null;
      function empty(elem) {
        while (elem.lastChild) {
          elem.removeChild(elem.lastChild);
        }elem.remove();
      }
      empty(this.renderer.domElement);
      empty(this.renderer2.domElement);
      empty(this.gui.domElement);
      this.renderer.dispose();
      this.renderer2.dispose();
      document.body.style.margin = '0';
      document.body.style.overflow = 'auto';
    }
  }]);
  return InputViewer;
}();

var OutputViewer = exports.OutputViewer = function () {
  function OutputViewer(configs, files, callbacks) {
    (0, _classCallCheck3.default)(this, OutputViewer);
    this.LIBRARY_DEPS = ['/static/js/three.js', '/static/js/controls/TrackballControls.js', '/static/js/Detector.js', '/static/js/libs/stats.min.js', '/static/js/loaders/STLLoader.js', '/static/js/math/Lut.js', '/static/js/libs/dat.gui.min.js', '/static/js/three-text2d.min.js'];
    this.STYLESHEET_DEPS = [];
    this.STATIC_PREFIX = '/static/models/stl/binary/';
    this.PRINTER_CONFIG_LIBRARY = {
      EOSM100: {
        base: this.STATIC_PREFIX + 'build_plate_EOSM100.stl',
        position: [-100, -200, 200],
        zRotation: -15
      },
      EOSM290: {
        base: this.STATIC_PREFIX + 'build_plate_EOSM290.stl',
        position: [-150, -350, 300],
        zRotation: -25
      },
      EOSM400: {
        base: this.STATIC_PREFIX + 'build_plate_EOSM400.stl',
        position: [-300, -500, 400],
        zRotation: -40
      },
      SLM280: {
        base: this.STATIC_PREFIX + 'build_plate_SLM280.stl',
        position: [-250, -350, 300],
        zRotation: -30
      },
      RenishawAM250: {
        base: this.STATIC_PREFIX + 'build_plate_RenishawAM250.stl',
        position: [-250, -350, 300],
        zRotation: -30
      },
      RenishawAM500: {
        base: this.STATIC_PREFIX + 'build_plate_RenishawAM500.stl',
        position: [-250, -350, 350],
        zRotation: -30
      },
      ArcamQ20: {
        base: this.STATIC_PREFIX + 'build_plate_arcamQ20.stl',
        position: [-350, -350, 200],
        zRotation: -15
      },
      IntechSF1: {
        base: this.STATIC_PREFIX + 'build_plate_IntechSF1.stl',
        position: [-100, -200, 200],
        zRotation: -15
      }
    };

    this.PRINTER = configs.config.printer;
    this.CONFIG = configs.config;
    this.PRINTERS_CONFIG = configs.printersConfig;
    this.STL_FILES = files.parts;
    this.positionConfig = files.nestedPositionConfig;
    this.nestedPartsNames = [];
    this.isManualPlacement = configs.isManualPlacement;
    this.platesConfig = [];
    this.nestedPlateConfig = files.nestedPlateConfig ? files.nestedPlateConfig[0] : null;
    this.nestedPositionWithRotation = configs.nestedPositionWithRotation;
    this.suppConfig = files.support;
    if (files.legend) {
      this.distortionConfig = files.legend;
    } else {
      this.distortionConfig = files.displayConfig || files.displayConfigBinary;
    }
    this.isPlate = true;
    this.minMaxConfig = [{ setMin: '', setMax: '' }];
    this.minMaxNestedConfig = { setMin: '', setMax: '' };
    this.currentInx = 0;
    this.finishedLoadingCB = callbacks.finishedLoading;
    this.getCurvaturePerFaceData = callbacks.getCurvaturePerFaceData;
    this.curvatureLoading = callbacks.curvatureLoading;
    this.switchBrushModeCallback = callbacks.switchBrushModeCallback;
    this.STLList = [];
    this.finishedLoading = false;
    this.isNested = !!this.positionConfig;
    this.isThermalPredict = !!this.distortionConfig;
    this.isDistortionConfig = this.isThermalPredict && (!!files.displayConfigBinary || !!this.distortionConfig[0].dispZ);
    this.isDistortionData = false;
    this.isHasXYZDistortion = this.isThermalPredict && this.STL_FILES.length === 3;
    this.isHasXYZNDistortion = this.isThermalPredict && this.STL_FILES.length === 4;
    this.distortionAxis = 'z';
    this.distortionOptionSuffix = '';
    this.modifySupportsMode = false;
    this.uploadedSupports = false;
    this.isStrengthenSupp = false;
    this.facesCount = [];
    _promise2.default.all([loadStylesheetList(this.STYLESHEET_DEPS), (0, _loader.loadScriptsInOrder)(this.LIBRARY_DEPS)]).then(function () {
      callbacks.init && callbacks.init();
    });
  }

  (0, _createClass3.default)(OutputViewer, [{
    key: 'preInitializer',
    value: function preInitializer() {
      this.THREE = window['THREE'];
      this.jQuery = window['$'];
      this.support = new _support_output.SupportOutput(this.THREE);
      this.dat = window['dat'];
      var Detector = window['Detector'];
      this.mouse = new this.THREE.Vector2();
      this.facesMode = 'erase';
      this.modifyMode = false;
      this.restrictedFaces = this.CONFIG.RestrictedFaces ? this.CONFIG.RestrictedFaces.slice() : [];
      this.allowedFaces = this.CONFIG.AllowedFaces ? this.CONFIG.AllowedFaces.slice() : [];
      this.highlightedFaces = [];
      this.curvaturePerFacet = [];
      this.facetAdjacents = [];
      this.maxCurvature = 0;
      this.lutConfig = {
        colorMap: 'rainbow',
        numberOfColors: 512
      };

      this.INTERSECTED2 = null;

      if (!Detector.webgl) Detector.addGetWebGLMessage();

      this.params = {
        critical_angle: this.CONFIG.critical_angle[0],
        Rotate_about_X: 0,
        Rotate_about_Y: 0,
        Rotate_about_Z: 0,
        brushMode: true,
        brushRadius: 1,
        brushBothSide: false,
        selectionTolerance: 1.5,
        showSupp: false,
        relocate: true,
        supportTransparency: 0.2,
        strengthenSuppTransparency: 0.7
      };

      this.color = {
        restrict: 0xff0000,
        allow: 0x00ff00,
        highlighted: 0xd5d5d5,
        default: 0x93969b,
        erase: 0x93969b
      };

      this.colorObj = {
        restrict: new this.THREE.Color(this.color.restrict),
        allow: new this.THREE.Color(this.color.allow),
        highlighted: new this.THREE.Color(this.color.highlighted),
        default: new this.THREE.Color(this.color.default),
        erase: new this.THREE.Color(this.color.erase)
      };

      document.body.style.margin = '0';
      document.body.style.overflow = 'hidden';
    }
  }, {
    key: 'init',
    value: function init() {
      var _this9 = this;

      this.showLegend = true;
      this.preInitializer();
      this.scene = new this.THREE.Scene();
      this.scene.fog = new this.THREE.Fog(0xd4d4d4, 0.01, 4000);
      this.renderer = new this.THREE.WebGLRenderer({ antialias: true, alpha: true });
      this.renderer.domElement.id = 'viewer3d';
      this.renderer.setClearColor(this.scene.fog.color);

      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      document.body.appendChild(this.renderer.domElement);

      this.camera = new this.THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 30, 10000);
      this.camera.up.set(0, 0, 1);
      if (this.PRINTER_CONFIG_LIBRARY[this.PRINTER]) {
        var _camera$position2;

        (_camera$position2 = this.camera.position).set.apply(_camera$position2, (0, _toConsumableArray3.default)(this.PRINTER_CONFIG_LIBRARY[this.PRINTER].position));
      } else if (this.PRINTERS_CONFIG[this.PRINTER]) {
        var printerConfig = this.PRINTERS_CONFIG[this.PRINTER];
        this.camera.position.set(printerConfig.plateX * -0.9, printerConfig.plateY * -1.2, printerConfig.plateZ);
      } else {
        this.camera.position.set(this.CONFIG.PrinterXYZ[0] * -0.9, this.CONFIG.PrinterXYZ[1] * -1.2, this.CONFIG.PrinterXYZ[2]);
      }
      this.scene.add(this.camera);
      this.controls = new this.THREE.TrackballControls(this.camera, this.renderer.domElement);
      this.controls.rotateSpeed = 5.0;
      this.controls.zoomSpeed = 5;
      this.controls.panSpeed = 2;
      this.controls.noZoom = false;
      this.controls.noPan = false;
      this.controls.staticMoving = true;
      this.controls.dynamicDampingFactor = 0.3;
      this.controls.enabled = true;

      this.ray = new this.THREE.Raycaster();

      this.threePointLight();
      this.scene.add(new this.THREE.AmbientLight(0x333333));

      this.groupBase = new this.THREE.Group();
      this.drawGround();
      this.drawPrinter();
      this.groupPart = new this.THREE.Group();
      this.groupSupp = new this.THREE.Group();
      var material = new this.THREE.MeshPhongMaterial({ color: 0xffffff, specular: 0x111111, shininess: 200, vertexColors: this.THREE.VertexColors });
      var materialSupp = function materialSupp() {
        return new _this9.THREE.MeshPhongMaterial({ color: 0x8e44ad, side: _this9.THREE.DoubleSide });
      };
      if (this.isNested) {
        this.STL_FILES.forEach(function (part, index) {
          _this9.nestedPartsNames.push(part.match(/[A-Za-z0-9-._()]+\.stl/)[0]);
          _this9['nestedPart' + _this9.nestedPartsNames[index]] = new _this9.THREE.Group();
          _this9['nestedSupp' + _this9.nestedPartsNames[index]] = new _this9.THREE.Group();
          _this9.STLList.push(_this9.STL_LOAD(_this9['nestedPart' + _this9.nestedPartsNames[index]], part, material, true));
        });

        var filteredSupports = this.suppConfig.filter(function (suppUrl) {
          return _this9.nestedPartsNames.some(function (partName) {
            return suppUrl.includes(partName.slice(0, -4));
          });
        });
        filteredSupports.forEach(function (support, index) {
          _this9.STLList.push(_this9.STL_LOAD(_this9['nestedSupp' + _this9.nestedPartsNames[index]], support, materialSupp(), true));
        });
      } else {
        if (this.isDistortionConfig) {
          this.STLList.push(this.STL_LOAD(this.groupPart, this.STL_FILES[0], material, true));
        } else if (this.isHasXYZNDistortion) {
          this.groupPartX = new this.THREE.Group();
          this.groupPartY = new this.THREE.Group();
          this.groupPartZ = new this.THREE.Group();
          this.groupPartN = new this.THREE.Group();
          this.groupPartNoColor = new this.THREE.Group();
          this.STLList.push(this.STL_LOAD(this.groupPartN, this.STL_FILES[0], material, false));
          this.STLList.push(this.STL_LOAD(this.groupPartX, this.STL_FILES[1], material, false));
          this.STLList.push(this.STL_LOAD(this.groupPartY, this.STL_FILES[2], material, false));
          this.STLList.push(this.STL_LOAD(this.groupPartZ, this.STL_FILES[3], material, false));
          this.STLList.push(this.STL_LOAD(this.groupPartNoColor, this.STL_FILES[0], material, false));
          this.groupPart.add(this.groupPartNoColor);
        } else if (this.isHasXYZDistortion) {
          this.groupPartX = new this.THREE.Group();
          this.groupPartY = new this.THREE.Group();
          this.groupPartZ = new this.THREE.Group();
          this.groupPartNoColor = new this.THREE.Group();
          this.STLList.push(this.STL_LOAD(this.groupPartX, this.STL_FILES[0], material, false));
          this.STLList.push(this.STL_LOAD(this.groupPartY, this.STL_FILES[1], material, false));
          this.STLList.push(this.STL_LOAD(this.groupPartZ, this.STL_FILES[2], material, false));
          this.STLList.push(this.STL_LOAD(this.groupPartNoColor, this.STL_FILES[0], material, false));
          this.groupPart.add(this.groupPartNoColor);
        } else if (this.isThermalPredict) {
          this.groupPartZ = new this.THREE.Group();
          this.groupPartNoColor = new this.THREE.Group();
          this.STLList.push(this.STL_LOAD(this.groupPartZ, this.STL_FILES[0], material, false));
          this.STLList.push(this.STL_LOAD(this.groupPartNoColor, this.STL_FILES[0], material, false));
          if (this.suppConfig) {
            this.groupPart.add(this.groupPartNoColor);
          } else {
            this.groupPart.add(this.groupPartZ);
          }
        } else {
          this.groupPartNoColor = new this.THREE.Group();
          this.STLList.push(this.STL_LOAD(this.groupPartNoColor, this.STL_FILES[0], material, false));
          this.groupPart.add(this.groupPartNoColor);
        }
        if (this.suppConfig) {
          this.suppConfig.forEach(function (support) {
            _this9.STLList.push(_this9.STL_LOAD(_this9.groupSupp, support, materialSupp(), true));
          });
        }
      }
      this.setupInset();
      _promise2.default.all(this.STLList).then(function () {
        _this9.STL_LOAD_FINISHED();
      });
      this.onWindowResize = this.onWindowResize.bind(this);
      this.onDocumentMouseClick = this.onDocumentMouseClick.bind(this);
      this.onDocumentMouseMove = this.onDocumentMouseMove.bind(this);
      this.colorFaces = this.colorFaces.bind(this);
      window.addEventListener('resize', this.onWindowResize);
      this.addEventListeners();
    }
  }, {
    key: 'addEventListeners',
    value: function addEventListeners() {
      window.addEventListener('click', this.onDocumentMouseClick);
      window.addEventListener('mousemove', this.onDocumentMouseMove);
    }
  }, {
    key: 'addSupport',
    value: function addSupport() {
      this.scene.add(this.groupSupp);
    }
  }, {
    key: 'removeSupport',
    value: function removeSupport() {
      this.scene.remove(this.groupSupp);
    }
  }, {
    key: 'changeSuppOpacity',
    value: function changeSuppOpacity() {
      var opacity = this.isStrengthenSupp ? 0.2 : 0.7;
      var strengthenOpacity = 0.7;
      var meshGroupSupp = this.groupSupp.children;
      if (this.modifySupportsMode) {
        opacity = this.params.supportTransparency;
        strengthenOpacity = this.params.strengthenSuppTransparency;
      }
      if (this.isNested) {
        meshGroupSupp = meshGroupSupp[0].children;
      }
      var change = function change(group) {
        var isMesh = group.type === 'Mesh';
        if (isMesh) {
          var isNameStrengthen = group.name === 'isStrengthenSupp';
          group.material.opacity = isNameStrengthen ? strengthenOpacity : opacity;
          group.material.transparent = true;
        } else {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = (0, _getIterator3.default)(group.children), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var child = _step6.value;

              change(child);
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      };
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = (0, _getIterator3.default)(meshGroupSupp), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var child = _step7.value;

          change(child);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }
    }
  }, {
    key: 'ShowSupp',
    value: function ShowSupp() {
      var _this10 = this;

      this.params.showSupp = true;
      return new _promise2.default(function (resolve) {
        if (!_this10.modifySupportsMode) {
          _this10.addSupport();
          if (_this10.isDistortionConfig) {
            var part = 'groupPart';
            _this10.STL_FILES.forEach(function (file, index) {
              if (_this10.isNested) {
                part = 'nestedPart' + _this10.nestedPartsNames[index];
              }
              _this10.changeColor(_this10[part], _this10.color.default);
            });
          } else if (_this10.isThermalPredict) {
            _this10.groupPart.remove(_this10.groupPart.children[0]);
            _this10.groupPart.add(_this10.groupPartNoColor);
          }
          if (_this10.isThermalPredict) {
            _this10['cameraL'].layers.set(1);
          }
        }
        _this10.changeSuppOpacity();
        resolve();
      });
    }
  }, {
    key: 'HideSupp',
    value: function HideSupp() {
      this.params.showSupp = false;
      if (this.modifySupportsMode) {
        this.changeSuppOpacity();
      } else {
        if (!(this.isDistortionConfig && this.distortionOptionSuffix === '_on') && this.isThermalPredict) {
          this.removeSupport();
        }
        if (this.isDistortionConfig) {
          this.switchDistortion();
          this.changeSuppOpacity();
        } else if (this.isThermalPredict) {
          this.groupPart.remove(this.groupPart.children[0]);
          this.groupPart.add(this.groupPartZ);
        }
        if (this.isThermalPredict) {
          this['cameraL'].layers.set(0);
        } else {
          this.params.showSupp = true;
        }
      }
    }
  }, {
    key: 'paintSupports',
    value: function paintSupports() {
      console.time('t1');
      var direction = new this.THREE.Vector3(0, 0, 1);
      for (var i = 0; i < this.groupSupp.children[0].geometry.vertices.length; i++) {
        this.ray.set(this.groupSupp.children[0].geometry.vertices[i].clone().applyMatrix4(this.groupPart.children[0].matrixWorld), direction);
        var intersects = this.ray.intersectObjects([this.groupPart.children[0]]);
        if (intersects.length > 0) {
          this.groupSupp.children[0].geometry.faces[Math.floor(i / 3)].color.setHex(0x00ff00);
        }
      }
      console.timeEnd('t1');
      this.groupSupp.children[0].geometry.colorsNeedUpdate = true;
    }
  }, {
    key: 'getCurvaturePerFace',
    value: function getCurvaturePerFace() {
      var _this11 = this;

      this.curvatureLoading(true);
      this.getCurvaturePerFaceData().then(function (data) {
        _this11.curvaturePerFacet = data.curvature_per_facet;
        _this11.facetAdjacents = data.triangles_adjacent_triangle;
        for (var i = 0; i < _this11.curvaturePerFacet.length; i++) {
          if (_this11.curvaturePerFacet[i] > _this11.maxCurvature) {
            _this11.maxCurvature = _this11.curvaturePerFacet[i];
          }
        }
        _this11.curvatureLoading(false);
      }).catch(function (err) {
        _this11.switchBrushModeCallback();
        _this11.curvatureLoading(false);
        console.log(err);
      });
    }
  }, {
    key: 'changeColor',
    value: function changeColor(group, colorConfig) {
      var color = void 0;
      if (typeof colorConfig === 'number') {
        color = new this.THREE.Color(colorConfig);
      }
      if (!group.children[0].geometry.attributes.hasOwnProperty('color')) {
        var colorData = new Float32Array(group.children[0].geometry.attributes.position.count * 3);
        for (var i = 0; i < group.children[0].geometry.attributes.position.count; i++) {
          colorData[i * 3] = color.r;
          colorData[i * 3 + 1] = color.g;
          colorData[i * 3 + 2] = color.b;
        }
        group.children[0].geometry.addAttribute('color', new this.THREE.BufferAttribute(colorData, 3));
      } else {
        for (var _i6 = 0; _i6 < group.children[0].geometry.attributes.position.count / 3; _i6++) {
          if (colorConfig[0] && colorConfig[0].hasOwnProperty('r')) {
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3] = colorConfig[_i6].r;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 1] = colorConfig[_i6].g;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 2] = colorConfig[_i6].b;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 3] = colorConfig[_i6].r;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 4] = colorConfig[_i6].g;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 5] = colorConfig[_i6].b;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 6] = colorConfig[_i6].r;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 7] = colorConfig[_i6].g;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 8] = colorConfig[_i6].b;
          } else if (typeof colorConfig === 'number') {
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3] = color.r;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 1] = color.g;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 2] = color.b;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 3] = color.r;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 4] = color.g;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 5] = color.b;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 6] = color.r;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 7] = color.g;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 8] = color.b;
          } else {
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3] = colorConfig[_i6 * 3] / 255;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 1] = colorConfig[_i6 * 3 + 1] / 255;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 2] = colorConfig[_i6 * 3 + 2] / 255;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 3] = colorConfig[_i6 * 3] / 255;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 4] = colorConfig[_i6 * 3 + 1] / 255;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 5] = colorConfig[_i6 * 3 + 2] / 255;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 6] = colorConfig[_i6 * 3] / 255;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 7] = colorConfig[_i6 * 3 + 1] / 255;
            group.children[0].geometry.attributes.color.array[_i6 * 3 * 3 + 8] = colorConfig[_i6 * 3 + 2] / 255;
          }
        }
      }
      group.children[0].geometry.attributes.color.needsUpdate = true;
    }
  }, {
    key: 'switchDistortionOption',
    value: function switchDistortionOption(option) {
      switch (option) {
        case 'default':
          this.distortionOptionSuffix = '';
          break;
        case 'removal':
          this.distortionOptionSuffix = '_removal';
          break;
        case 'on':
          this.distortionOptionSuffix = '_on';
          break;
      }
      this.switchDistortion();
    }
  }, {
    key: 'switchDistortion',
    value: function switchDistortion() {
      var _this12 = this;

      var axis = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.distortionAxis;

      this.distortionAxis = axis;
      if (this.isDistortionConfig) {
        this.STL_FILES.forEach(function (plate, index) {
          var maxVal = void 0,
              minVal = void 0;
          var part = 'groupPart';
          if (_this12.isNested) {
            part = 'nestedPart' + _this12.nestedPartsNames[index];
          }
          if (axis === 'n') {
            _this12.changeColor(_this12[part], _this12.distortionConfig[index]['dispN' + _this12.distortionOptionSuffix]);
            minVal = _this12.distortionConfig[index]['dispLegendN' + _this12.distortionOptionSuffix][0];
            _this12.minMaxConfig[index].setMin = minVal;
            maxVal = _this12.distortionConfig[index]['dispLegendN' + _this12.distortionOptionSuffix][1];
            _this12.minMaxConfig[index].setMax = maxVal;
          } else if (axis === 'x') {
            _this12.changeColor(_this12[part], _this12.distortionConfig[index]['dispX' + _this12.distortionOptionSuffix]);
            minVal = _this12.distortionConfig[index]['dispLegendX' + _this12.distortionOptionSuffix][0];
            _this12.minMaxConfig[index].setMin = minVal;
            maxVal = _this12.distortionConfig[index]['dispLegendX' + _this12.distortionOptionSuffix][1];
            _this12.minMaxConfig[index].setMax = maxVal;
          } else if (axis === 'y') {
            _this12.changeColor(_this12[part], _this12.distortionConfig[index]['dispY' + _this12.distortionOptionSuffix]);
            minVal = _this12.distortionConfig[index]['dispLegendY' + _this12.distortionOptionSuffix][0];
            _this12.minMaxConfig[index].setMin = minVal;
            maxVal = _this12.distortionConfig[index]['dispLegendY' + _this12.distortionOptionSuffix][1];
            _this12.minMaxConfig[index].setMax = maxVal;
          } else if (axis === 'z') {
            _this12.changeColor(_this12[part], _this12.distortionConfig[index]['dispZ' + _this12.distortionOptionSuffix]);
            minVal = _this12.distortionConfig[index]['dispLegendZ' + _this12.distortionOptionSuffix][0];
            _this12.minMaxConfig[index].setMin = minVal;
            maxVal = _this12.distortionConfig[index]['dispLegendZ' + _this12.distortionOptionSuffix][1];
            _this12.minMaxConfig[index].setMax = maxVal;
          } else {
            _this12.changeColor(_this12[part], _this12.color.default);
          }
        });
      } else if (this.isHasXYZDistortion) {
        this.groupPart.remove(this.groupPart.children[0]);
        if (axis === 'x') {
          this.groupPart.add(this.groupPartX);
          this.minMaxConfig[0].setMin = this.distortionConfig[0].setMin[0];
          this.minMaxConfig[0].setMax = this.distortionConfig[0].setMax[0];
        } else if (axis === 'y') {
          this.groupPart.add(this.groupPartY);
          this.minMaxConfig[0].setMin = this.distortionConfig[1].setMin[0];
          this.minMaxConfig[0].setMax = this.distortionConfig[1].setMax[0];
        } else if (axis === 'z') {
          this.groupPart.add(this.groupPartZ);
          this.minMaxConfig[0].setMin = this.distortionConfig[2].setMin[0];
          this.minMaxConfig[0].setMax = this.distortionConfig[2].setMax[0];
        } else {
          this.groupPart.add(this.groupPartNoColor);
        }
      } else if (this.isHasXYZNDistortion) {
        this.groupPart.remove(this.groupPart.children[0]);
        if (axis === 'n') {
          this.groupPart.add(this.groupPartN);
          this.minMaxConfig[0].setMin = this.distortionConfig[0].setMin[0];
          this.minMaxConfig[0].setMax = this.distortionConfig[0].setMax[0];
        } else if (axis === 'x') {
          this.groupPart.add(this.groupPartX);
          this.minMaxConfig[0].setMin = this.distortionConfig[1].setMin[0];
          this.minMaxConfig[0].setMax = this.distortionConfig[1].setMax[0];
        } else if (axis === 'y') {
          this.groupPart.add(this.groupPartY);
          this.minMaxConfig[0].setMin = this.distortionConfig[2].setMin[0];
          this.minMaxConfig[0].setMax = this.distortionConfig[2].setMax[0];
        } else if (axis === 'z') {
          this.groupPart.add(this.groupPartZ);
          this.minMaxConfig[0].setMin = this.distortionConfig[3].setMin[0];
          this.minMaxConfig[0].setMax = this.distortionConfig[3].setMax[0];
        } else {
          this.groupPart.add(this.groupPartNoColor);
        }
      }
      if (this.isDistortionConfig || this.isHasXYZDistortion || this.isHasXYZNDistortion) {
        this.setNestedMinMax();
        this.selectLegendToAdd();
      }
    }
  }, {
    key: 'switchModifySupportsMode',
    value: function switchModifySupportsMode(mode) {
      this.modifySupportsMode = mode;
    }
  }, {
    key: 'switchFacetSelectionMode',
    value: function switchFacetSelectionMode(mode) {
      this.facesMode = mode;
    }
  }, {
    key: 'switchBrushMode',
    value: function switchBrushMode(mode) {
      this.params.brushMode = mode;
      if (!mode && this.curvaturePerFacet.length === 0) {
        this.getCurvaturePerFace();
      }
    }
  }, {
    key: 'switchBrushSide',
    value: function switchBrushSide(mode) {
      this.params.brushBothSide = mode;
    }
  }, {
    key: 'setBrushRadius',
    value: function setBrushRadius(event) {
      this.params.brushRadius = event.target.value;
    }
  }, {
    key: 'setSelectionTolerance',
    value: function setSelectionTolerance(event) {
      this.params.selectionTolerance = event.target.value;
    }
  }, {
    key: 'setSupportTransparency',
    value: function setSupportTransparency(event, isStrength) {
      var key = isStrength ? 'strengthenSuppTransparency' : 'supportTransparency';
      this.params[key] = event.target.value;
      this.changeSuppOpacity();
    }
  }, {
    key: 'setNestedMinMax',
    value: function setNestedMinMax() {
      var min = this.minMaxConfig[0].setMin;
      var max = this.minMaxConfig[0].setMax;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = (0, _getIterator3.default)(this.minMaxConfig), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var _ref20 = _step8.value;
          var setMin = _ref20.setMin,
              setMax = _ref20.setMax;

          if (min > setMin) min = setMin;
          if (max < setMax) max = setMax;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      this.minMaxNestedConfig = { setMin: min, setMax: max };
    }
  }, {
    key: 'initLegend',
    value: function initLegend() {
      var _this13 = this;

      if (this.isNested) {
        this.STL_FILES.forEach(function (part, index) {
          _this13.minMaxConfig[index] = {
            setMin: _this13.distortionConfig[index].dispLegendZ_on[0],
            setMax: _this13.distortionConfig[index].dispLegendZ_on[1]
          };
        });
        this.setNestedMinMax();
      } else {
        if (this.isDistortionConfig) {
          if (this.distortionConfig[0].dispLegendZ_on) {
            this.minMaxConfig[0].setMin = this.distortionConfig[0].dispLegendZ_on[0];
            this.minMaxConfig[0].setMax = this.distortionConfig[0].dispLegendZ_on[1];
          } else {
            this.minMaxConfig[0].setMin = this.distortionConfig[0].dispLegendZ[0];
            this.minMaxConfig[0].setMax = this.distortionConfig[0].dispLegendZ[1];
          }
        } else if (this.isHasXYZNDistortion) {
          this.minMaxConfig[0].setMin = this.distortionConfig[3].setMin[0];
          this.minMaxConfig[0].setMax = this.distortionConfig[3].setMax[0];
        } else if (this.isHasXYZDistortion) {
          this.minMaxConfig[0].setMin = this.distortionConfig[2].setMin[0];
          this.minMaxConfig[0].setMax = this.distortionConfig[2].setMax[0];
        } else if (this.isThermalPredict) {
          this.minMaxConfig[0].setMin = this.distortionConfig[0].setMin[0];
          this.minMaxConfig[0].setMax = this.distortionConfig[0].setMax[0];
        }
      }
      if (!this.modifySupportsMode && this.isThermalPredict) {
        this.setupInsetLegend();
        this['cameraL'].layers.set(1);
      }
    }
  }, {
    key: 'setDistColors',
    value: function setDistColors(min, max) {
      var _this14 = this;

      this.STL_FILES.forEach(function (plate, index) {
        var part = 'groupPart';
        if (_this14.isNested) {
          part = 'nestedPart' + _this14.nestedPartsNames[index];
        }
        var dist = void 0;
        if (_this14.distortionAxis === 'n') {
          dist = _this14.distortionConfig[index]['distN' + _this14.distortionOptionSuffix];
        } else if (_this14.distortionAxis === 'x') {
          dist = _this14.distortionConfig[index]['distX' + _this14.distortionOptionSuffix];
        } else if (_this14.distortionAxis === 'y') {
          dist = _this14.distortionConfig[index]['distY' + _this14.distortionOptionSuffix];
        } else if (_this14.distortionAxis === 'z') {
          dist = _this14.distortionConfig[index]['distZ' + _this14.distortionOptionSuffix];
        }
        var dispConfigTemp = _this14.processColors(dist, min, max);
        _this14.changeColor(_this14[part], dispConfigTemp);
        if (_this14.isNested && _this14.isPlate) {
          _this14.minMaxNestedConfig.setMin = min;
          _this14.minMaxNestedConfig.setMax = max;
        } else {
          _this14.minMaxConfig[_this14.currentInx].setMin = min;
          _this14.minMaxConfig[_this14.currentInx].setMax = max;
        }
        if (_this14.INTERSECTED2) {
          var name = _this14.INTERSECTED2.parent.name || _this14.INTERSECTED2.parent.parent.name || '';
          if (!_this14.isNested || plate.match(new RegExp(name))) {
            var faceId = _this14.INTERSECTED2.faceID;
            var _dispConfigTemp$faceI = dispConfigTemp[faceId],
                r = _dispConfigTemp$faceI.r,
                g = _dispConfigTemp$faceI.g,
                b = _dispConfigTemp$faceI.b;

            _this14.INTERSECTED2.faceColor = [r, g, b];
          }
        }
      });
    }
  }, {
    key: 'setLegendFromElem',
    value: function setLegendFromElem() {
      if (this.isDistortionConfig) {
        var minVal = parseFloat(document.getElementById('legendLowerLimit').value);
        var maxVal = parseFloat(document.getElementById('legendUpperLimit').value);
        if (minVal >= maxVal) return;
        this.setDistColors(minVal, maxVal);
      }
    }
  }, {
    key: 'setLegendToElem',
    value: function setLegendToElem(min, max) {
      var ele0 = document.getElementById('legendLowerLimit');
      var ele1 = document.getElementById('legendUpperLimit');
      if (ele0 && ele1) {
        ele0.value = Math.round(min * 10000) / 10000;
        ele1.value = Math.round(max * 10000) / 10000;
      }
      this.setDistColors(min, max);
    }
  }, {
    key: 'applyNewLegendLimit',
    value: function applyNewLegendLimit() {
      this.setLegendFromElem();
      this.selectLegendToAdd();
    }
  }, {
    key: 'selectLegendToAdd',
    value: function selectLegendToAdd() {
      var min = void 0,
          max = void 0;
      if (this.isNested && this.isPlate) {
        min = this.minMaxNestedConfig.setMin;
        max = this.minMaxNestedConfig.setMax;
      } else {
        min = this.minMaxConfig[this.currentInx].setMin;
        max = this.minMaxConfig[this.currentInx].setMax;
      }
      this.addLegend(min, max);
    }
  }, {
    key: 'resetLegendLimit',
    value: function resetLegendLimit() {
      this.switchDistortion();
      this.setNestedMinMax();
      this.selectLegendToAdd();
    }
  }, {
    key: 'parseBinFile',
    value: function parseBinFile(arrayBuffer, index) {
      var _this15 = this;

      var fileLength = arrayBuffer.byteLength;
      var fullColorLength = (16 + this.facesCount[index] * 3) * 12;
      var onColorLength = (16 + this.facesCount[index] * 3) * 4;
      var fullDistLength = this.facesCount[index] * 12 * 4;
      var onDistLength = this.facesCount[index] * 4 * 4;
      var colorDataLength = this.facesCount[index] * 3;
      var distDataLength = this.facesCount[index] * 4;
      this.isDistortionData = fileLength === fullDistLength || fileLength === onDistLength;
      var dispConfig = {
        dispLegendZ_on: [],
        dispZ_on: [],
        dispLegendY_on: [],
        dispY_on: [],
        dispLegendX_on: [],
        dispX_on: [],
        dispLegendN_on: [],
        dispN_on: []
      };

      if (fileLength === fullDistLength || fileLength === fullColorLength) {
        dispConfig.dispLegendZ = [];
        dispConfig.dispZ = [];
        dispConfig.dispLegendY = [];
        dispConfig.dispY = [];
        dispConfig.dispLegendX = [];
        dispConfig.dispX = [];
        dispConfig.dispLegendN = [];
        dispConfig.dispN = [];
        dispConfig.dispLegendZ_removal = [];
        dispConfig.dispZ_removal = [];
        dispConfig.dispLegendY_removal = [];
        dispConfig.dispY_removal = [];
        dispConfig.dispLegendX_removal = [];
        dispConfig.dispX_removal = [];
        dispConfig.dispLegendN_removal = [];
        dispConfig.dispN_removal = [];
      }

      var view = void 0;
      if (this.isDistortionData) {
        if (fileLength === onDistLength) {
          dispConfig.distZ_on = new Float32Array(arrayBuffer, 0 * distDataLength, this.facesCount[index]);
          dispConfig.distY_on = new Float32Array(arrayBuffer, 1 * distDataLength, this.facesCount[index]);
          dispConfig.distX_on = new Float32Array(arrayBuffer, 2 * distDataLength, this.facesCount[index]);
          dispConfig.distN_on = new Float32Array(arrayBuffer, 3 * distDataLength, this.facesCount[index]);
          dispConfig.dispLegendZ_on = this.calculateMinMaxFixNaN(dispConfig.distZ_on);
          dispConfig.dispLegendY_on = this.calculateMinMaxFixNaN(dispConfig.distY_on);
          dispConfig.dispLegendX_on = this.calculateMinMaxFixNaN(dispConfig.distX_on);
          dispConfig.dispLegendN_on = this.calculateMinMaxFixNaN(dispConfig.distN_on);
          dispConfig.dispZ_on = this.processColors(dispConfig.distZ_on, dispConfig.dispLegendZ_on[0], dispConfig.dispLegendZ_on[1]);
          dispConfig.dispY_on = this.processColors(dispConfig.distY_on, dispConfig.dispLegendY_on[0], dispConfig.dispLegendY_on[1]);
          dispConfig.dispX_on = this.processColors(dispConfig.distX_on, dispConfig.dispLegendX_on[0], dispConfig.dispLegendX_on[1]);
          dispConfig.dispN_on = this.processColors(dispConfig.distN_on, dispConfig.dispLegendN_on[0], dispConfig.dispLegendN_on[1]);
        } else if (fileLength === fullDistLength) {
          dispConfig.distZ = new Float32Array(arrayBuffer, 0 * distDataLength, this.facesCount[index]);
          dispConfig.distY = new Float32Array(arrayBuffer, 1 * distDataLength, this.facesCount[index]);
          dispConfig.distX = new Float32Array(arrayBuffer, 2 * distDataLength, this.facesCount[index]);
          dispConfig.distN = new Float32Array(arrayBuffer, 3 * distDataLength, this.facesCount[index]);
          dispConfig.distZ_removal = new Float32Array(arrayBuffer, 4 * distDataLength, this.facesCount[index]);
          dispConfig.distY_removal = new Float32Array(arrayBuffer, 5 * distDataLength, this.facesCount[index]);
          dispConfig.distX_removal = new Float32Array(arrayBuffer, 6 * distDataLength, this.facesCount[index]);
          dispConfig.distN_removal = new Float32Array(arrayBuffer, 7 * distDataLength, this.facesCount[index]);
          dispConfig.distZ_on = new Float32Array(arrayBuffer, 8 * distDataLength, this.facesCount[index]);
          dispConfig.distY_on = new Float32Array(arrayBuffer, 9 * distDataLength, this.facesCount[index]);
          dispConfig.distX_on = new Float32Array(arrayBuffer, 10 * distDataLength, this.facesCount[index]);
          dispConfig.distN_on = new Float32Array(arrayBuffer, 11 * distDataLength, this.facesCount[index]);
          dispConfig.dispLegendZ = this.calculateMinMaxFixNaN(dispConfig.distZ);
          dispConfig.dispLegendY = this.calculateMinMaxFixNaN(dispConfig.distY);
          dispConfig.dispLegendX = this.calculateMinMaxFixNaN(dispConfig.distX);
          dispConfig.dispLegendN = this.calculateMinMaxFixNaN(dispConfig.distN);
          dispConfig.dispLegendZ_removal = this.calculateMinMaxFixNaN(dispConfig.distZ_removal);
          dispConfig.dispLegendY_removal = this.calculateMinMaxFixNaN(dispConfig.distY_removal);
          dispConfig.dispLegendX_removal = this.calculateMinMaxFixNaN(dispConfig.distX_removal);
          dispConfig.dispLegendN_removal = this.calculateMinMaxFixNaN(dispConfig.distN_removal);
          dispConfig.dispLegendZ_on = this.calculateMinMaxFixNaN(dispConfig.distZ_on);
          dispConfig.dispLegendY_on = this.calculateMinMaxFixNaN(dispConfig.distY_on);
          dispConfig.dispLegendX_on = this.calculateMinMaxFixNaN(dispConfig.distX_on);
          dispConfig.dispLegendN_on = this.calculateMinMaxFixNaN(dispConfig.distN_on);
          dispConfig.dispZ = this.processColors(dispConfig.distZ, dispConfig.dispLegendZ[0], dispConfig.dispLegendZ[1]);
          dispConfig.dispY = this.processColors(dispConfig.distY, dispConfig.dispLegendY[0], dispConfig.dispLegendY[1]);
          dispConfig.dispX = this.processColors(dispConfig.distX, dispConfig.dispLegendX[0], dispConfig.dispLegendX[1]);
          dispConfig.dispN = this.processColors(dispConfig.distN, dispConfig.dispLegendN[0], dispConfig.dispLegendN[1]);
          dispConfig.dispZ_removal = this.processColors(dispConfig.distZ_removal, dispConfig.dispLegendZ_removal[0], dispConfig.dispLegendZ_removal[1]);
          dispConfig.dispY_removal = this.processColors(dispConfig.distY_removal, dispConfig.dispLegendY_removal[0], dispConfig.dispLegendY_removal[1]);
          dispConfig.dispX_removal = this.processColors(dispConfig.distX_removal, dispConfig.dispLegendX_removal[0], dispConfig.dispLegendX_removal[1]);
          dispConfig.dispN_removal = this.processColors(dispConfig.distN_removal, dispConfig.dispLegendN_removal[0], dispConfig.dispLegendN_removal[1]);
          dispConfig.dispZ_on = this.processColors(dispConfig.distZ_on, dispConfig.dispLegendZ_on[0], dispConfig.dispLegendZ_on[1]);
          dispConfig.dispY_on = this.processColors(dispConfig.distY_on, dispConfig.dispLegendY_on[0], dispConfig.dispLegendY_on[1]);
          dispConfig.dispX_on = this.processColors(dispConfig.distX_on, dispConfig.dispLegendX_on[0], dispConfig.dispLegendX_on[1]);
          dispConfig.dispN_on = this.processColors(dispConfig.distN_on, dispConfig.dispLegendN_on[0], dispConfig.dispLegendN_on[1]);
        }
      } else {
        if (fileLength === onColorLength) {
          view = new DataView(arrayBuffer, 16 * 0 + colorDataLength * 0, 16);
          dispConfig.dispLegendZ_on = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          view = new DataView(arrayBuffer, 16 * 1 + colorDataLength * 1, 16);
          dispConfig.dispLegendY_on = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          view = new DataView(arrayBuffer, 16 * 2 + colorDataLength * 2, 16);
          dispConfig.dispLegendX_on = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          view = new DataView(arrayBuffer, 16 * 3 + colorDataLength * 3, 16);
          dispConfig.dispLegendN_on = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          dispConfig.dispZ_on = new Uint8Array(arrayBuffer, 16 * 1 + colorDataLength * 0, colorDataLength);
          dispConfig.dispY_on = new Uint8Array(arrayBuffer, 16 * 2 + colorDataLength * 1, colorDataLength);
          dispConfig.dispX_on = new Uint8Array(arrayBuffer, 16 * 3 + colorDataLength * 2, colorDataLength);
          dispConfig.dispN_on = new Uint8Array(arrayBuffer, 16 * 4 + colorDataLength * 3, colorDataLength);
        } else if (fileLength === fullColorLength) {
          view = new DataView(arrayBuffer, 16 * 0 + colorDataLength * 0, 16);
          dispConfig.dispLegendZ = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          view = new DataView(arrayBuffer, 16 * 1 + colorDataLength * 1, 16);
          dispConfig.dispLegendY = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          view = new DataView(arrayBuffer, 16 * 2 + colorDataLength * 2, 16);
          dispConfig.dispLegendX = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          view = new DataView(arrayBuffer, 16 * 3 + colorDataLength * 3, 16);
          dispConfig.dispLegendN = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          view = new DataView(arrayBuffer, 16 * 4 + colorDataLength * 4, 16);
          dispConfig.dispLegendZ_removal = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          view = new DataView(arrayBuffer, 16 * 5 + colorDataLength * 5, 16);
          dispConfig.dispLegendY_removal = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          view = new DataView(arrayBuffer, 16 * 6 + colorDataLength * 6, 16);
          dispConfig.dispLegendX_removal = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          view = new DataView(arrayBuffer, 16 * 7 + colorDataLength * 7, 16);
          dispConfig.dispLegendN_removal = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          view = new DataView(arrayBuffer, 16 * 8 + colorDataLength * 8, 16);
          dispConfig.dispLegendZ_on = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          view = new DataView(arrayBuffer, 16 * 9 + colorDataLength * 9, 16);
          dispConfig.dispLegendY_on = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          view = new DataView(arrayBuffer, 16 * 10 + colorDataLength * 10, 16);
          dispConfig.dispLegendX_on = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          view = new DataView(arrayBuffer, 16 * 11 + colorDataLength * 11, 16);
          dispConfig.dispLegendN_on = new Float64Array([view.getFloat64(0, true), view.getFloat64(8, true)]);
          dispConfig.dispZ = new Uint8Array(arrayBuffer, 16 * 1 + colorDataLength * 0, colorDataLength);
          dispConfig.dispY = new Uint8Array(arrayBuffer, 16 * 2 + colorDataLength * 1, colorDataLength);
          dispConfig.dispX = new Uint8Array(arrayBuffer, 16 * 3 + colorDataLength * 2, colorDataLength);
          dispConfig.dispN = new Uint8Array(arrayBuffer, 16 * 4 + colorDataLength * 3, colorDataLength);
          dispConfig.dispZ_removal = new Uint8Array(arrayBuffer, 16 * 5 + colorDataLength * 4, colorDataLength);
          dispConfig.dispY_removal = new Uint8Array(arrayBuffer, 16 * 6 + colorDataLength * 5, colorDataLength);
          dispConfig.dispX_removal = new Uint8Array(arrayBuffer, 16 * 7 + colorDataLength * 6, colorDataLength);
          dispConfig.dispN_removal = new Uint8Array(arrayBuffer, 16 * 8 + colorDataLength * 7, colorDataLength);
          dispConfig.dispZ_on = new Uint8Array(arrayBuffer, 16 * 9 + colorDataLength * 8, colorDataLength);
          dispConfig.dispY_on = new Uint8Array(arrayBuffer, 16 * 10 + colorDataLength * 9, colorDataLength);
          dispConfig.dispX_on = new Uint8Array(arrayBuffer, 16 * 11 + colorDataLength * 10, colorDataLength);
          dispConfig.dispN_on = new Uint8Array(arrayBuffer, 16 * 12 + colorDataLength * 11, colorDataLength);
        }
        (0, _keys2.default)(dispConfig).forEach(function (config) {
          if (config.match(/Legend/)) {
            dispConfig[config] = dispConfig[config].map(function (unit) {
              return _this15.convertUnits(unit);
            });
          }
        });
      }
      return dispConfig;
    }
  }, {
    key: 'calculateMinMaxFixNaN',
    value: function calculateMinMaxFixNaN(distData) {
      var min = Number.MAX_VALUE;
      var max = Number.MIN_VALUE;
      for (var i = 0; i < distData.length; i++) {
        if (isNaN(distData[i])) {
          distData[i] = 0;
        }
        if (distData[i] < min) {
          min = distData[i];
        }
        if (distData[i] > max) {
          max = distData[i];
        }
      }
      return [min, max];
    }
  }, {
    key: 'processColors',
    value: function processColors(distData, distMin, distMax) {
      var colorData = [];
      var lut = new this.THREE.Lut(this.lutConfig.colorMap, this.lutConfig.numberOfColors);
      lut.setMin(distMin);
      lut.setMax(distMax);
      for (var i = 0; i < distData.length; i++) {
        colorData[i] = lut.getColor(distData[i]);
      }
      return colorData;
    }
  }, {
    key: 'convertUnits',
    value: function convertUnits(unit) {
      return unit * 1000;
    }
  }, {
    key: 'getLegendValues',
    value: function getLegendValues(buffer, colorLength, offset) {
      var view = new DataView(buffer, 16 * offset + colorLength * offset, 16);
      return new Float64Array([view.getFloat64(0, true) * 1000, view.getFloat64(8, true) * 1000]);
    }
  }, {
    key: 'getColorValues',
    value: function getColorValues(buffer, colorLength, offset) {
      return new Uint8Array(buffer, 16 * (offset + 1) + colorLength * offset, colorLength);
    }
  }, {
    key: 'STL_LOAD',
    value: function STL_LOAD(groupx, stlFile, material, isCalculateNormals) {
      var _this16 = this;

      return new _promise2.default(function (resolve, reject) {
        var loader = new _this16.THREE.STLLoader();
        loader.load(stlFile, function (geometry) {
          var mesh = new _this16.THREE.Mesh(geometry, material);
          var scalexyz = 1;
          mesh.scale.set(scalexyz, scalexyz, scalexyz);
          mesh.castShadow = true;
          mesh.receiveShadow = true;
          groupx.add(mesh);
          if (isCalculateNormals) {
            var normals = groupx.children[0].geometry.attributes.normal.array;
            var needCalc = true;
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
              for (var _iterator9 = (0, _getIterator3.default)(normals), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                var normal = _step9.value;

                if (normal !== 0) {
                  needCalc = false;
                  break;
                }
              }
            } catch (err) {
              _didIteratorError9 = true;
              _iteratorError9 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                  _iterator9.return();
                }
              } finally {
                if (_didIteratorError9) {
                  throw _iteratorError9;
                }
              }
            }

            if (needCalc) groupx.children[0].geometry.computeVertexNormals();
          }
          if (stlFile.match(/strengthen/)) {
            _this16.isStrengthenSupp = true;
            mesh.name = 'isStrengthenSupp';
          }
          resolve(geometry);
        });
      });
    }
  }, {
    key: 'STL_LOAD_FINISHED',
    value: function STL_LOAD_FINISHED() {
      var _this17 = this;

      if (this.isNested) {
        this.createNestedPlates();
        this.STL_FILES.forEach(function (plate, index) {
          _this17.facesCount[index] = _this17['nestedPart' + _this17.nestedPartsNames[index]].children[0].geometry.attributes.normal.count / 3;
          _this17['nestedPart' + _this17.nestedPartsNames[index]].name = _this17.nestedPartsNames[index];
          if (!_this17.distortionConfig[index].hasOwnProperty('dispZ')) {
            _this17.distortionConfig[index] = _this17.parseBinFile(_this17.distortionConfig[index], index);
          }
          _this17.changeColor(_this17['nestedPart' + _this17.nestedPartsNames[index]], _this17.color.default);
        });
      } else {
        if (this.isDistortionConfig) {
          this.facesCount[0] = this.groupPart.children[0].geometry.attributes.normal.count / 3;
          if (!this.distortionConfig[0].hasOwnProperty('dispZ')) {
            this.distortionConfig = this.distortionConfig.map(function (data, index) {
              return _this17.parseBinFile(data, index);
            });
          }
          this.changeColor(this.groupPart, this.color.default);
          var bbox = new this.THREE.Box3().setFromObject(this.groupPart);
          var center = bbox.getCenter();
          this.groupPart.position.x = this.groupPart.position.x - center.x;
          this.groupPart.position.y = this.groupPart.position.y - center.y;
          this.groupSupp.position.x = this.groupSupp.position.x - center.x;
          this.groupSupp.position.y = this.groupSupp.position.y - center.y;
        } else {
          var _bbox = new this.THREE.Box3().setFromObject(this.groupPart.children[0]);
          var _center = _bbox.getCenter();
          this.groupSupp.position.x = this.groupSupp.position.x - _center.x;
          this.groupSupp.position.y = this.groupSupp.position.y - _center.y;
          if (this.groupPartX) {
            this.groupPartX.position.x = this.groupPartX.position.x - _center.x;
            this.groupPartX.position.y = this.groupPartX.position.y - _center.y;
          }
          if (this.groupPartY) {
            this.groupPartY.position.x = this.groupPartY.position.x - _center.x;
            this.groupPartY.position.y = this.groupPartY.position.y - _center.y;
          }
          if (this.groupPartZ) {
            this.groupPartZ.position.x = this.groupPartZ.position.x - _center.x;
            this.groupPartZ.position.y = this.groupPartZ.position.y - _center.y;
          }
          if (this.groupPartN) {
            this.groupPartN.position.x = this.groupPartN.position.x - _center.x;
            this.groupPartN.position.y = this.groupPartN.position.y - _center.y;
          }
          if (this.groupPartNoColor) {
            this.groupPartNoColor.position.x = this.groupPartNoColor.position.x - _center.x;
            this.groupPartNoColor.position.y = this.groupPartNoColor.position.y - _center.y;
            this.changeColor(this.groupPartNoColor, this.color.default);
          }
        }
      }
      this.initLegend();
      this.scene.add(this.groupPart);
      this.scene.add(this.groupSupp);
      var callbackData = {};
      if (this.isDistortionConfig) {
        callbackData.maxDistortion = this.distortionConfig[0].dispLegendZ_on[1];
        if (this.distortionConfig[0].dispLegendZ) {
          callbackData.maxDistortion = this.distortionConfig[0].dispLegendZ[1];
        }
        if (this.distortionConfig[0].dispLegendZ_on) {
          callbackData.isHasOptions = true;
        }
        if (this.distortionConfig[0].dispLegendZ && this.distortionConfig[0].dispLegendZ_on) {
          callbackData.isHasOptionsFull = true;
        }
      } else {
        this.params.showSupp = true;
        this.changeSuppOpacity();
      }

      if (this.isNested) {
        this.distortionConfig.forEach(function (distortion) {
          if (distortion.hasOwnProperty('dispLegendZ_on') && !distortion.hasOwnProperty('dispLegendZ')) {
            callbackData.isHasOptionsFull = false;
          }
        });
        callbackData.legendsData = this.distortionConfig.map(function (distortion) {
          return distortion.dispLegendZ_on;
        });
      }
      this.finishedLoading = true;
      this.finishedLoadingCB(callbackData);
      this.HideSupp();
    }
  }, {
    key: 'createNestedPlates',
    value: function createNestedPlates() {
      var _this18 = this;

      var offsetX = this.calculateOffset('x');
      var offsetY = this.calculateOffset('y');
      var bbox = void 0,
          center = void 0;

      if ((0, _keys2.default)(this.positionConfig).length) {
        (0, _keys2.default)(this.positionConfig).forEach(function (key) {
          _this18['nestedParts' + key] = new _this18.THREE.Group();
          _this18['nestedSupports' + key] = new _this18.THREE.Group();
          _this18.platesConfig.push(key);
          (0, _keys2.default)(_this18.positionConfig[key]).forEach(function (partKey) {
            var paramsByPart = _this18.nestedPositionWithRotation ? 3 : 2;
            _this18['nestedPart' + partKey].children[0].geometry.computeBoundingBox();
            var partCenter = _this18['nestedPart' + partKey].children[0].geometry.boundingBox.getCenter();
            for (var i = 0; i < _this18.positionConfig[key][partKey].length / paramsByPart; i++) {
              _this18['nestedPart' + partKey + i] = _this18['nestedPart' + partKey].clone();
              _this18['nestedSupp' + partKey + i] = _this18['nestedSupp' + partKey].clone();
              _this18['nestedPart' + partKey + i].position.x = _this18.positionConfig[key][partKey][i * paramsByPart] + offsetX;
              _this18['nestedPart' + partKey + i].position.y = _this18.positionConfig[key][partKey][i * paramsByPart + 1] + offsetY;
              _this18['nestedSupp' + partKey + i].position.x = _this18.positionConfig[key][partKey][i * paramsByPart] + offsetX;
              _this18['nestedSupp' + partKey + i].position.y = _this18.positionConfig[key][partKey][i * paramsByPart + 1] + offsetY;
              if (_this18.nestedPositionWithRotation) {
                _this18['nestedPart' + partKey + i].children[0].position.x = _this18['nestedPart' + partKey + i].children[0].position.x - partCenter.x;
                _this18['nestedPart' + partKey + i].children[0].position.y = _this18['nestedPart' + partKey + i].children[0].position.y - partCenter.y;
                _this18['nestedSupp' + partKey + i].children[0].position.x = _this18['nestedSupp' + partKey + i].children[0].position.x - partCenter.x;
                _this18['nestedSupp' + partKey + i].children[0].position.y = _this18['nestedSupp' + partKey + i].children[0].position.y - partCenter.y;
                _this18['nestedPart' + partKey + i].rotateOnAxis(new _this18.THREE.Vector3(0, 0, 1), _this18.positionConfig[key][partKey][i * paramsByPart + 2] * (Math.PI / 180));
                _this18['nestedSupp' + partKey + i].rotateOnAxis(new _this18.THREE.Vector3(0, 0, 1), _this18.positionConfig[key][partKey][i * paramsByPart + 2] * (Math.PI / 180));
                _this18['nestedPart' + partKey + i].position.x = _this18['nestedPart' + partKey + i].position.x + partCenter.x;
                _this18['nestedPart' + partKey + i].position.y = _this18['nestedPart' + partKey + i].position.y + partCenter.y;
                _this18['nestedSupp' + partKey + i].position.x = _this18['nestedSupp' + partKey + i].position.x + partCenter.x;
                _this18['nestedSupp' + partKey + i].position.y = _this18['nestedSupp' + partKey + i].position.y + partCenter.y;
              }
              _this18['nestedPart' + partKey + i].name = partKey;
              _this18['nestedParts' + key].add(_this18['nestedPart' + partKey + i]);
              _this18['nestedSupports' + key].add(_this18['nestedSupp' + partKey + i]);
            }
          });
          if (_this18.isManualPlacement) {
            var printerConfig = _this18.PRINTERS_CONFIG[_this18.PRINTER];
            var length = printerConfig.plateX;
            var width = printerConfig.plateY;
            center = { x: length / 2, y: width / 2 };
          } else {
            bbox = new _this18.THREE.Box3().setFromObject(_this18['nestedParts' + key]);
            center = bbox.getCenter();
          }
          _this18['nestedParts' + key].position.x = _this18['nestedParts' + key].position.x - center.x;
          _this18['nestedParts' + key].position.y = _this18['nestedParts' + key].position.y - center.y;
          _this18['nestedSupports' + key].position.x = _this18['nestedSupports' + key].position.x - center.x;
          _this18['nestedSupports' + key].position.y = _this18['nestedSupports' + key].position.y - center.y;
        });
        this.nestedPartsNames.forEach(function (partKey) {
          _this18['nestedParts' + partKey] = new _this18.THREE.Group();
          _this18['nestedSupports' + partKey] = new _this18.THREE.Group();
          _this18['nestedParts' + partKey].name = partKey;
          _this18['nestedPart' + partKey + 'single'] = _this18['nestedPart' + partKey].clone();
          _this18['nestedSupp' + partKey + 'single'] = _this18['nestedSupp' + partKey].clone();
          bbox = new _this18.THREE.Box3().setFromObject(_this18['nestedPart' + partKey + 'single']);
          center = bbox.getCenter();
          _this18['nestedPart' + partKey + 'single'].position.x = _this18['nestedPart' + partKey + 'single'].position.x - center.x;
          _this18['nestedPart' + partKey + 'single'].position.y = _this18['nestedPart' + partKey + 'single'].position.y - center.y;
          _this18['nestedSupp' + partKey + 'single'].position.x = _this18['nestedSupp' + partKey + 'single'].position.x - center.x;
          _this18['nestedSupp' + partKey + 'single'].position.y = _this18['nestedSupp' + partKey + 'single'].position.y - center.y;
          _this18['nestedParts' + partKey].add(_this18['nestedPart' + partKey + 'single']);
          _this18['nestedSupports' + partKey].add(_this18['nestedSupp' + partKey + 'single']);
        });
        this.groupPart.add(this['nestedPartsplate0']);
        this.groupSupp.add(this['nestedSupportsplate0']);
      }
    }
  }, {
    key: 'switchNestedPlates',
    value: function switchNestedPlates(plate) {
      var _this19 = this;

      this.isPlate = !this.nestedPartsNames.includes(plate);
      this.nestedPartsNames.forEach(function (name, inx) {
        if (name === plate) _this19.currentInx = inx;
      });
      this.groupPart.remove(this.groupPart.children[0]);
      this.groupSupp.remove(this.groupSupp.children[0]);
      this.groupPart.add(this['nestedParts' + plate]);
      this.groupSupp.add(this['nestedSupports' + plate]);
      this.switchDistortion();
      if (this.params.showSupp) {
        this.ShowSupp();
      }
    }
  }, {
    key: 'calculateOffset',
    value: function calculateOffset(axis) {
      if (this.nestedPlateConfig) {
        if (this.nestedPlateConfig.plateMode > 0) {
          return this.nestedPlateConfig.plateDiameter * -1 / 2;
        } else {
          if (axis === 'x') {
            return this.nestedPlateConfig.plateWidth * -1 / 2;
          } else if (axis === 'y') {
            return this.nestedPlateConfig.plateHeight * -1 / 2;
          }
        }
      }
      return 0;
    }
  }, {
    key: 'onDocumentMouseClick',
    value: function onDocumentMouseClick(event) {
      if (this.modifyMode) {
        var part = this.getPartToColor();
        this.mouse.x = event.clientX / window.innerWidth * 2 - 1;
        this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        this.ray.setFromCamera(this.mouse, this.camera);
        var intersects = this.ray.intersectObjects([part]);
        if (intersects.length > 0) {
          if (this.params.brushMode) {
            part.updateMatrixWorld();
            var vert = new this.THREE.Vector3();
            var normal = new this.THREE.Vector3();
            for (var i = 0; i < part.geometry.attributes.position.count; i++) {
              vert = vert.set(part.geometry.attributes.position.array[i * 3], part.geometry.attributes.position.array[i * 3 + 1], part.geometry.attributes.position.array[i * 3 + 2]).clone().applyMatrix4(part.matrixWorld);
              normal = normal.set(part.geometry.attributes.normal.array[i * 3], part.geometry.attributes.normal.array[i * 3 + 1], part.geometry.attributes.normal.array[i * 3 + 2]);
              var angle = normal.angleTo(intersects[0].face.normal);
              var dist = vert.distanceTo(intersects[0].point);
              if (dist < this.params.brushRadius) {
                if (!this.params.brushBothSide) {
                  if (angle >= -Math.PI / 2 && angle <= Math.PI / 2) {
                    this.faceSelect(Math.floor(i / 3));
                  }
                } else {
                  this.faceSelect(Math.floor(i / 3));
                }
              }
            }
            this.faceSelect(intersects[0].faceIndex / 3);
          } else {
            this.adjacentFaceSelect(intersects[0].faceIndex / 3, false);
          }
          this.highlightedFaces = [];
        }
      } else if (!this.params.showSupp) {
        this.mouse.x = event.clientX / window.innerWidth * 2 - 1;
        this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

        this.ray.setFromCamera(this.mouse, this.camera);
        var intersects2 = this.ray.intersectObject(this.groupPart, true);

        if (intersects2.length > 0 && intersects2[0].object.geometry.attributes.hasOwnProperty('color')) {
          var faceID = intersects2[0].faceIndex / 3;
          if (!this.INTERSECTED2 || this.INTERSECTED2 !== intersects2[0].object || this.INTERSECTED2.faceID !== faceID) {
            if (this.INTERSECTED2) {
              var faceID2 = this.INTERSECTED2.faceID;
              var faceColor2 = this.INTERSECTED2.faceColor;
              for (var iv = 0; iv < 3; iv++) {
                this.INTERSECTED2.geometry.attributes.color.array[9 * faceID2 + 3 * iv] = faceColor2[0];
                this.INTERSECTED2.geometry.attributes.color.array[9 * faceID2 + 3 * iv + 1] = faceColor2[1];
                this.INTERSECTED2.geometry.attributes.color.array[9 * faceID2 + 3 * iv + 2] = faceColor2[2];
              }
              if (this.INTERSECTED2 !== intersects2[0].object) {
                this.INTERSECTED2.geometry.attributes.color.needsUpdate = true;
              }
            }
            this.INTERSECTED2 = intersects2[0].object;
            this.INTERSECTED2.faceID = faceID;
            this.INTERSECTED2.faceColor = [intersects2[0].object.geometry.attributes.color.array[faceID * 9], intersects2[0].object.geometry.attributes.color.array[faceID * 9 + 1], intersects2[0].object.geometry.attributes.color.array[faceID * 9 + 2]];
            for (var _iv = 0; _iv < 3; _iv++) {
              this.INTERSECTED2.geometry.attributes.color.array[9 * faceID + 3 * _iv] = 1;
              this.INTERSECTED2.geometry.attributes.color.array[9 * faceID + 3 * _iv + 1] = 1;
              this.INTERSECTED2.geometry.attributes.color.array[9 * faceID + 3 * _iv + 2] = 1;
            }
            this.INTERSECTED2.geometry.attributes.color.needsUpdate = true;
            var ele = document.getElementById('distortionAtSelect');
            var disVal = void 0;
            var inx = 0;
            if (this.isNested) {
              var name = intersects2[0].object.parent.name || intersects2[0].object.parent.parent.name;
              this.nestedPartsNames.forEach(function (key, i) {
                if (key === name) inx = i;
              });
            }
            if (this.distortionOptionSuffix === '') {
              if (this.distortionAxis === 'n') {
                disVal = this.distortionConfig[inx].distN[faceID];
              } else if (this.distortionAxis === 'x') {
                disVal = this.distortionConfig[inx].distX[faceID];
              } else if (this.distortionAxis === 'y') {
                disVal = this.distortionConfig[inx].distY[faceID];
              } else if (this.distortionAxis === 'z') {
                disVal = this.distortionConfig[inx].distZ[faceID];
              }
            } else if (this.distortionOptionSuffix === '_removal') {
              if (this.distortionAxis === 'n') {
                disVal = this.distortionConfig[inx].distN_removal[faceID];
              } else if (this.distortionAxis === 'x') {
                disVal = this.distortionConfig[inx].distX_removal[faceID];
              } else if (this.distortionAxis === 'y') {
                disVal = this.distortionConfig[inx].distY_removal[faceID];
              } else if (this.distortionAxis === 'z') {
                disVal = this.distortionConfig[inx].distZ_removal[faceID];
              }
            } else if (this.distortionOptionSuffix === '_on') {
              if (this.distortionAxis === 'n') {
                disVal = this.distortionConfig[inx].distN_on[faceID];
              } else if (this.distortionAxis === 'x') {
                disVal = this.distortionConfig[inx].distX_on[faceID];
              } else if (this.distortionAxis === 'y') {
                disVal = this.distortionConfig[inx].distY_on[faceID];
              } else if (this.distortionAxis === 'z') {
                disVal = this.distortionConfig[inx].distZ_on[faceID];
              }
            }
            disVal = Math.round(disVal * 10000) / 10000;
            if (ele) ele.innerHTML = 'Distortion at select is ' + disVal + ' mm';
          }
        }
      }
    }
  }, {
    key: 'faceSelect',
    value: function faceSelect(faceIndex) {
      var idxRestricted = this.restrictedFaces.indexOf(faceIndex);
      var idxAllowed = this.allowedFaces.indexOf(faceIndex);
      var isSelect = false;
      if (this.facesMode === 'restrict') {
        if (idxAllowed > -1) {
          this.allowedFaces.splice(idxAllowed, 1);
        }
        if (idxRestricted === -1) {
          this.restrictedFaces.push(faceIndex);
          isSelect = true;
        }
      } else if (this.facesMode === 'allow') {
        if (idxRestricted > -1) {
          this.restrictedFaces.splice(idxRestricted, 1);
        }
        if (idxAllowed === -1) {
          this.allowedFaces.push(faceIndex);
          isSelect = true;
        }
      } else {
        if (idxAllowed > -1) {
          this.allowedFaces.splice(idxAllowed, 1);
        }
        if (idxRestricted > -1) {
          this.restrictedFaces.splice(idxRestricted, 1);
        }
      }
      return isSelect;
    }
  }, {
    key: 'adjacentFaceSelect',
    value: function adjacentFaceSelect(faceIndex, highLight) {
      var curvatureClicked = this.curvaturePerFacet[faceIndex];
      var facetsAdjacent = [faceIndex];
      while (1) {
        var facetsAdjacentNew = [];
        for (var iFacet = 0; iFacet < facetsAdjacent.length; iFacet++) {
          var isSelected = void 0;
          if (highLight) {
            isSelected = this.checkHighlight(facetsAdjacent[iFacet]);
          } else {
            isSelected = this.faceSelect(facetsAdjacent[iFacet]);
          }
          if (isSelected) {
            for (var i = 0; i < 3; i++) {
              var curvature = this.curvaturePerFacet[this.facetAdjacents[3 * facetsAdjacent[iFacet] + i]];
              if (Math.abs(curvature - curvatureClicked) < this.maxCurvature * this.params.selectionTolerance / 100) {
                facetsAdjacentNew.push(this.facetAdjacents[3 * facetsAdjacent[iFacet] + i]);
              }
            }
          }
        }
        if (facetsAdjacentNew.length === 0) {
          break;
        } else {
          facetsAdjacent = facetsAdjacentNew;
        }
      }
    }
  }, {
    key: 'toggleFaceSelection',
    value: function toggleFaceSelection(faceIndex) {
      var result = null;
      var idxRestricted = this.restrictedFaces.indexOf(faceIndex);
      var idxAllowed = this.allowedFaces.indexOf(faceIndex);
      if (this.facesMode === 'restrict') {
        if (idxAllowed > -1) {
          this.allowedFaces.splice(idxAllowed, 1);
        }
        if (idxRestricted > -1) {
          this.restrictedFaces.splice(idxRestricted, 1);
          result = false;
        } else {
          this.restrictedFaces.push(faceIndex);
          result = true;
        }
      } else if (this.facesMode === 'allow') {
        if (idxRestricted > -1) {
          this.restrictedFaces.splice(idxRestricted, 1);
        }
        if (idxAllowed > -1) {
          this.allowedFaces.splice(idxAllowed, 1);
          result = false;
        } else {
          this.allowedFaces.push(faceIndex);
          result = true;
        }
      } else {
        if (idxAllowed > -1) {
          this.allowedFaces.splice(idxAllowed, 1);
        }
        if (idxRestricted > -1) {
          this.restrictedFaces.splice(idxRestricted, 1);
        }
      }
      return result;
    }
  }, {
    key: 'onDocumentMouseMove',
    value: function onDocumentMouseMove(event) {
      if (this.modifyMode) {
        var part = this.getPartToColor();
        this.mouse.x = event.clientX / window.innerWidth * 2 - 1;
        this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        this.ray.setFromCamera(this.mouse, this.camera);
        var intersects = this.ray.intersectObjects([part]);
        if (intersects.length > 0) {
          var i, dist, angle;
          var vert = new this.THREE.Vector3();
          var normal = new this.THREE.Vector3();
          if (event.shiftKey) {
            this.highlightedFaces = [];
            if (this.params.brushMode) {
              part.updateMatrixWorld();
              for (i = 0; i < part.geometry.attributes.position.count; i++) {
                vert = vert.set(part.geometry.attributes.position.array[i * 3], part.geometry.attributes.position.array[i * 3 + 1], part.geometry.attributes.position.array[i * 3 + 2]).clone().applyMatrix4(part.matrixWorld);
                normal = normal.set(part.geometry.attributes.normal.array[i * 3], part.geometry.attributes.normal.array[i * 3 + 1], part.geometry.attributes.normal.array[i * 3 + 2]);
                angle = normal.angleTo(intersects[0].face.normal);
                dist = vert.distanceTo(intersects[0].point);
                if (dist < this.params.brushRadius) {
                  if (!this.params.brushBothSide) {
                    if (angle >= -Math.PI / 2 && angle <= Math.PI / 2) {
                      this.faceSelect(Math.floor(i / 3));
                    }
                  } else {
                    this.faceSelect(Math.floor(i / 3));
                  }
                }
              }
              this.faceSelect(intersects[0].faceIndex / 3);
            } else {
              this.faceSelect(intersects[0].faceIndex / 3);
            }
          } else {
            this.highlightedFaces = [];
            if (this.params.brushMode) {
              part.updateMatrixWorld();
              for (i = 0; i < part.geometry.attributes.position.count; i++) {
                vert = vert.set(part.geometry.attributes.position.array[i * 3], part.geometry.attributes.position.array[i * 3 + 1], part.geometry.attributes.position.array[i * 3 + 2]).clone().applyMatrix4(part.matrixWorld);
                normal = normal.set(part.geometry.attributes.normal.array[i * 3], part.geometry.attributes.normal.array[i * 3 + 1], part.geometry.attributes.normal.array[i * 3 + 2]);
                angle = normal.angleTo(intersects[0].face.normal);
                dist = vert.distanceTo(intersects[0].point);
                if (dist < this.params.brushRadius) {
                  if (!this.params.brushBothSide) {
                    if (angle >= -Math.PI / 2 && angle < Math.PI / 2) {
                      this.checkHighlight(Math.floor(i / 3));
                    }
                  } else {
                    this.checkHighlight(Math.floor(i / 3));
                  }
                }
              }
              this.checkHighlight(intersects[0].faceIndex / 3);
            } else {
              this.highlightedFaces = [];

              this.checkHighlight(intersects[0].faceIndex / 3);
            }
          }
        } else {
          this.highlightedFaces = [];
        }
      }
    }
  }, {
    key: 'checkHighlight',
    value: function checkHighlight(faceIndex) {
      var idxHighlighted = this.highlightedFaces.indexOf(faceIndex);
      if (idxHighlighted === -1) {
        this.highlightedFaces.push(faceIndex);
        return true;
      }
      return false;
    }
  }, {
    key: 'colorFaces',
    value: function colorFaces() {
      var _this20 = this;

      var part = this.getPartToColor();
      if (this.modifyMode) {
        for (var i = 0; i < part.geometry.attributes.color.count; i++) {
          part.geometry.attributes.color.array[i * 3] = this.colorObj.default.r;
          part.geometry.attributes.color.array[i * 3 + 1] = this.colorObj.default.g;
          part.geometry.attributes.color.array[i * 3 + 2] = this.colorObj.default.b;
        }
        this.restrictedFaces.forEach(function (faceIndex) {
          part.geometry.attributes.color.array[faceIndex * 3 * 3] = _this20.colorObj.restrict.r;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 1] = _this20.colorObj.restrict.g;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 2] = _this20.colorObj.restrict.b;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 3] = _this20.colorObj.restrict.r;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 4] = _this20.colorObj.restrict.g;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 5] = _this20.colorObj.restrict.b;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 6] = _this20.colorObj.restrict.r;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 7] = _this20.colorObj.restrict.g;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 8] = _this20.colorObj.restrict.b;
        });
        this.allowedFaces.forEach(function (faceIndex) {
          part.geometry.attributes.color.array[faceIndex * 3 * 3] = _this20.colorObj.allow.r;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 1] = _this20.colorObj.allow.g;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 2] = _this20.colorObj.allow.b;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 3] = _this20.colorObj.allow.r;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 4] = _this20.colorObj.allow.g;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 5] = _this20.colorObj.allow.b;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 6] = _this20.colorObj.allow.r;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 7] = _this20.colorObj.allow.g;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 8] = _this20.colorObj.allow.b;
        });
        this.highlightedFaces.forEach(function (faceIndex) {
          part.geometry.attributes.color.array[faceIndex * 3 * 3] = _this20.colorObj.highlighted.r;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 1] = _this20.colorObj.highlighted.g;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 2] = _this20.colorObj.highlighted.b;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 3] = _this20.colorObj.highlighted.r;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 4] = _this20.colorObj.highlighted.g;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 5] = _this20.colorObj.highlighted.b;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 6] = _this20.colorObj.highlighted.r;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 7] = _this20.colorObj.highlighted.g;
          part.geometry.attributes.color.array[faceIndex * 3 * 3 + 8] = _this20.colorObj.highlighted.b;
        });
        part.geometry.attributes.color.needsUpdate = true;
      } else {
        for (var _i7 = 0; _i7 < part.geometry.attributes.color.count; _i7++) {
          part.geometry.attributes.color.array[_i7 * 3] = this.colorObj.default.r;
          part.geometry.attributes.color.array[_i7 * 3 + 1] = this.colorObj.default.g;
          part.geometry.attributes.color.array[_i7 * 3 + 2] = this.colorObj.default.b;
        }
      }
    }
  }, {
    key: 'getPartToColor',
    value: function getPartToColor() {
      var part = void 0;
      if (this.groupPart.children[0] && this.groupPart.children[0].geometry) {
        part = this.groupPart.children[0];
      } else if (this.groupPart.children[0].children[0] && this.groupPart.children[0].children[0].geometry) {
        part = this.groupPart.children[0].children[0];
      }
      return part;
    }
  }, {
    key: 'getAllowedFaces',
    value: function getAllowedFaces() {
      return this.allowedFaces;
    }
  }, {
    key: 'getRestrictedFaces',
    value: function getRestrictedFaces() {
      return this.restrictedFaces;
    }
  }, {
    key: 'resetFaces',
    value: function resetFaces() {
      this.allowedFaces = [];
      this.restrictedFaces = [];
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.controls.reset();
    }
  }, {
    key: 'light',
    value: function light(color, _ref21) {
      var _light$position2;

      var position = _ref21.position,
          _ref21$normalize = _ref21.normalize,
          normalize = _ref21$normalize === undefined ? null : _ref21$normalize,
          _ref21$intensity = _ref21.intensity,
          intensity = _ref21$intensity === undefined ? 0.5 : _ref21$intensity,
          _ref21$castShadow = _ref21.castShadow,
          castShadow = _ref21$castShadow === undefined ? true : _ref21$castShadow;

      var light = new this.THREE.DirectionalLight(color);
      (_light$position2 = light.position).set.apply(_light$position2, (0, _toConsumableArray3.default)(position)).normalize(normalize);
      light.intensity = intensity;
      light.castShadow = castShadow;
      return light;
    }
  }, {
    key: 'threePointLight',
    value: function threePointLight() {
      var dist = 400;
      this.scene.add(this.light(0xb8b8b8, { position: [1 * dist, 2 * dist, 1 * dist] }));
      this.scene.add(this.light(0xb8b8b8, { position: [-1 * dist, 0.6 * dist, 0.5 * dist], intensity: 2 }));
      this.scene.add(this.light(0xffffff, { position: [-0.3 * dist, -0.6 * dist, 0.8 * dist], normalize: 0xb8b8b8 }));
    }
  }, {
    key: 'onWindowResize',
    value: function onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    }
  }, {
    key: 'drawGround',
    value: function drawGround() {
      var plane = new this.THREE.Mesh(new this.THREE.PlaneBufferGeometry(100000, 100000), new this.THREE.MeshPhongMaterial({ color: 0x73767b, specular: 0x000000 }));

      if (this.PRINTER_CONFIG_LIBRARY[this.PRINTER]) {
        plane.position.z = this.PRINTER_CONFIG_LIBRARY[this.PRINTER].zRotation;
      } else if (this.PRINTERS_CONFIG[this.PRINTER]) {
        plane.position.z = Number(this.PRINTERS_CONFIG[this.PRINTER].plateThickness) * -1 / 2;
      } else {
        plane.position.z = Number(this.CONFIG.plateThickness[0]) * -1 / 2;
      }
      plane.receiveShadow = true;
      this.groupBase.add(plane);
    }
  }, {
    key: 'drawPrinter',
    value: function drawPrinter() {
      var THREE_TEXT = window['THREE_Text'];
      switch (this.PRINTER) {
        case 'EOSM100':
          var material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material, false));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          var Diameter = 100;
          var Height = 95;
          var point1 = new this.THREE.Vector3(-Diameter / 2, -Diameter / 2, 0);
          var point2 = new this.THREE.Vector3(-Diameter / 2, Diameter / 2, 0);
          var point3 = new this.THREE.Vector3(Diameter / 2, Diameter / 2, 0);
          var point4 = new this.THREE.Vector3(Diameter / 2, -Diameter / 2, 0);
          var point5 = new this.THREE.Vector3(-Diameter / 2, -Diameter / 2, Height);
          var point6 = new this.THREE.Vector3(-Diameter / 2, Diameter / 2, Height);
          var point7 = new this.THREE.Vector3(Diameter / 2, Diameter / 2, Height);
          var point8 = new this.THREE.Vector3(Diameter / 2, -Diameter / 2, Height);
          var geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(point5, point6, point7, point8, point5);
          var line1 = new this.THREE.Line(geometry1, material);
          var geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(point1, point5);
          var line2 = new this.THREE.Line(geometry2, material);
          var geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(point2, point6);
          var line3 = new this.THREE.Line(geometry3, material);
          var geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(point3, point7);
          var line4 = new this.THREE.Line(geometry4, material);
          var geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(point4, point8);
          var line5 = new this.THREE.Line(geometry5, material);
          var geometry6 = new this.THREE.Geometry();
          geometry6.vertices.push(point1, point2, point3, point4, point1);
          var line6 = new this.THREE.Line(geometry6, material);
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);
          this.scene.add(line6);

          var grid = new this.THREE.GridHelper(100, 10, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          var arrow1 = new this.THREE.ArrowHelper(new this.THREE.Vector3(-1, 0, 0), new this.THREE.Vector3(Diameter / 2 + 5, Diameter / 2 + 5, 0), 20, 0x000000);
          var arrow2 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, -1, 0), new this.THREE.Vector3(Diameter / 2 + 5, Diameter / 2 + 5, 0), 20, 0x000000);
          var arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 20, 0x000000);
          var arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 20, 0x000000);
          var arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 20, 0x000000);
          this.scene.add(arrow1);
          this.scene.add(arrow2);
          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);

          var Text2D = THREE_TEXT.Text2D;
          var textAlign = THREE_TEXT.textAlign;
          var sprdtext = new Text2D('Recoater', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0.5 * Math.PI, -0.5 * Math.PI, 0);
          sprdtext.position.set(54, 0, 17);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('recoating', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(Diameter / 2 - 5, Diameter / 2 + 10, 0);
          this.scene.add(sprdtext);

          sprdtext = new Text2D('x', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-40, -55, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-57, -40, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-57, -57, 20);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('ϕ100 x 95mm', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -55, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = 0;
          this.groupBase.position.y = 0;
          this.groupBase.position.z = -15;
          this.scene.add(this.groupBase);
          break;
        case 'ArcamQ20':
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          Diameter = 350;
          Height = 380;
          point1 = new this.THREE.Vector3(-Diameter / 2, -Diameter / 2, 0);
          point2 = new this.THREE.Vector3(-Diameter / 2, Diameter / 2, 0);
          point3 = new this.THREE.Vector3(Diameter / 2, Diameter / 2, 0);
          point4 = new this.THREE.Vector3(Diameter / 2, -Diameter / 2, 0);
          point5 = new this.THREE.Vector3(-Diameter / 2, -Diameter / 2, Height);
          point6 = new this.THREE.Vector3(-Diameter / 2, Diameter / 2, Height);
          point7 = new this.THREE.Vector3(Diameter / 2, Diameter / 2, Height);
          point8 = new this.THREE.Vector3(Diameter / 2, -Diameter / 2, Height);
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(point5, point6, point7, point8, point5);
          line1 = new this.THREE.Line(geometry1, material);
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(point1, point5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(point2, point6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(point3, point7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(point4, point8);
          line5 = new this.THREE.Line(geometry5, material);
          geometry6 = new this.THREE.Geometry();
          geometry6.vertices.push(point1, point2, point3, point4, point1);
          line6 = new this.THREE.Line(geometry6, material);
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);
          this.scene.add(line6);

          grid = new this.THREE.GridHelper(350, 35, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);

          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('x', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-130, -180, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-185, -150, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-185, -185, 50);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('ϕ350 x 380 mm', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -200, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = -Diameter / 2;
          this.groupBase.position.y = -Diameter / 2;
          this.groupBase.position.z = -30;
          this.scene.add(this.groupBase);
          break;
        case 'IntechSF1':
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          Diameter = 150;
          Height = 180;
          point1 = new this.THREE.Vector3(-Diameter / 2, -Diameter / 2, 0);
          point2 = new this.THREE.Vector3(-Diameter / 2, Diameter / 2, 0);
          point3 = new this.THREE.Vector3(Diameter / 2, Diameter / 2, 0);
          point4 = new this.THREE.Vector3(Diameter / 2, -Diameter / 2, 0);
          point5 = new this.THREE.Vector3(-Diameter / 2, -Diameter / 2, Height);
          point6 = new this.THREE.Vector3(-Diameter / 2, Diameter / 2, Height);
          point7 = new this.THREE.Vector3(Diameter / 2, Diameter / 2, Height);
          point8 = new this.THREE.Vector3(Diameter / 2, -Diameter / 2, Height);
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(point5, point6, point7, point8, point5);
          line1 = new this.THREE.Line(geometry1, material);
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(point1, point5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(point2, point6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(point3, point7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(point4, point8);
          line5 = new this.THREE.Line(geometry5, material);
          geometry6 = new this.THREE.Geometry();
          geometry6.vertices.push(point1, point2, point3, point4, point1);
          line6 = new this.THREE.Line(geometry6, material);
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);
          this.scene.add(line6);

          grid = new this.THREE.GridHelper(150, 15, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);

          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('x', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-30, -80, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-85, -50, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.05, 0.05, 0.05);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-85, -85, 50);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('ϕ150 x 180 mm', { align: textAlign.center, font: '150px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -55, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = -Diameter / 2;
          this.groupBase.position.y = -Diameter / 2;
          this.groupBase.position.z = -30;
          this.scene.add(this.groupBase);
          break;
        case 'EOSM290':
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material, false));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          point1 = new this.THREE.Vector3(-125, -125, 0);
          point2 = new this.THREE.Vector3(-125, 125, 0);
          point3 = new this.THREE.Vector3(125, 125, 0);
          point4 = new this.THREE.Vector3(125, -125, 0);
          point5 = new this.THREE.Vector3(-125, -125, 325);
          point6 = new this.THREE.Vector3(-125, 125, 325);
          point7 = new this.THREE.Vector3(125, 125, 325);
          point8 = new this.THREE.Vector3(125, -125, 325);
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(point5, point6, point7, point8, point5);
          line1 = new this.THREE.Line(geometry1, material);
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(point1, point5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(point2, point6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(point3, point7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(point4, point8);
          line5 = new this.THREE.Line(geometry5, material);
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);

          grid = new this.THREE.GridHelper(250, 25, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0);
          this.scene.add(grid);

          arrow1 = new this.THREE.ArrowHelper(new this.THREE.Vector3(-1, 0, 0), new this.THREE.Vector3(130, 130, 0), 40, 0x000000);
          arrow2 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, -1, 0), new this.THREE.Vector3(130, 130, 0), 40, 0x000000);
          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          this.scene.add(arrow1);
          this.scene.add(arrow2);
          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('Recoater', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0.5 * Math.PI, -0.5 * Math.PI, 0);
          sprdtext.position.set(144, 0, 17);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('recoating', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(105, 142, 0);
          this.scene.add(sprdtext);

          sprdtext = new Text2D('x', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-95, -130, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-135, -90, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-135, -135, 40);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('250 x 250 x 325mm', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -130, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = -125;
          this.groupBase.position.y = -125;
          this.groupBase.position.z = -25;
          this.scene.add(this.groupBase);
          break;
        case 'EOSM400':
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material, false));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          Diameter = 400;
          Height = 360;
          point1 = new this.THREE.Vector3(-Diameter / 2, -Diameter / 2, 0);
          point2 = new this.THREE.Vector3(-Diameter / 2, Diameter / 2, 0);
          point3 = new this.THREE.Vector3(Diameter / 2, Diameter / 2, 0);
          point4 = new this.THREE.Vector3(Diameter / 2, -Diameter / 2, 0);
          point5 = new this.THREE.Vector3(-Diameter / 2, -Diameter / 2, Height);
          point6 = new this.THREE.Vector3(-Diameter / 2, Diameter / 2, Height);
          point7 = new this.THREE.Vector3(Diameter / 2, Diameter / 2, Height);
          point8 = new this.THREE.Vector3(Diameter / 2, -Diameter / 2, Height);
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(point5, point6, point7, point8, point5);
          line1 = new this.THREE.Line(geometry1, material);
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(point1, point5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(point2, point6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(point3, point7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(point4, point8);
          line5 = new this.THREE.Line(geometry5, material);
          geometry6 = new this.THREE.Geometry();
          geometry6.vertices.push(point1, point2, point3, point4, point1);
          line6 = new this.THREE.Line(geometry6, material);
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);
          this.scene.add(line6);

          grid = new this.THREE.GridHelper(400, 40, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          arrow1 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(240, 0, 0), 50, 0x000000);
          arrow2 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, -1, 0), new this.THREE.Vector3(205, 40, 0), 80, 0x000000);
          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-(Diameter / 2 + 5), -(Diameter / 2 + 5), 0), 50, 0x000000);
          arrow6 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(205, -40, 0), 80, 0x000000);
          this.scene.add(arrow1);
          this.scene.add(arrow2);
          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);
          this.scene.add(arrow6);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('Recoater', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.25, 0.25, 0.25);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(0, 219, 30);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('recoating', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.2, 0.2, 0.2);
          sprdtext.rotation.set(0, 0, -0.5 * Math.PI);
          sprdtext.position.set(230, 0, 0);
          this.scene.add(sprdtext);

          sprdtext = new Text2D('x', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.2, 0.2, 0.2);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-160, -205, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.2, 0.2, 0.2);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-215, -155, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.2, 0.2, 0.2);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-210, -210, 50);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('400 x 400 x 400 mm', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.2, 0.2, 0.2);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -210, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = -200;
          this.groupBase.position.y = -200;
          this.groupBase.position.z = -40;
          this.scene.add(this.groupBase);
          break;
        case 'SLM280':
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material, false));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          Diameter = 280;
          Height = 335;
          point1 = new this.THREE.Vector3(-Diameter / 2, -Diameter / 2, 0);
          point2 = new this.THREE.Vector3(-Diameter / 2, Diameter / 2, 0);
          point3 = new this.THREE.Vector3(Diameter / 2, Diameter / 2, 0);
          point4 = new this.THREE.Vector3(Diameter / 2, -Diameter / 2, 0);
          point5 = new this.THREE.Vector3(-Diameter / 2, -Diameter / 2, Height);
          point6 = new this.THREE.Vector3(-Diameter / 2, Diameter / 2, Height);
          point7 = new this.THREE.Vector3(Diameter / 2, Diameter / 2, Height);
          point8 = new this.THREE.Vector3(Diameter / 2, -Diameter / 2, Height);
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(point5, point6, point7, point8, point5);
          line1 = new this.THREE.Line(geometry1, material);
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(point1, point5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(point2, point6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(point3, point7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(point4, point8);
          line5 = new this.THREE.Line(geometry5, material);
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);

          grid = new this.THREE.GridHelper(280, 28, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          arrow1 = new this.THREE.ArrowHelper(new this.THREE.Vector3(-1, 0, 0), new this.THREE.Vector3(145, 145, 0), 40, 0x000000);
          arrow2 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, -1, 0), new this.THREE.Vector3(145, 20, 0), 40, 0x000000);
          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-145, -145, 0), 40, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-145, -145, 0), 40, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-145, -145, 0), 40, 0x000000);
          var arrow6 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(145, -20, 0), 40, 0x000000);
          this.scene.add(arrow1);
          this.scene.add(arrow2);
          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);
          this.scene.add(arrow6);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('Recoater', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(0, 159, 30);
          this.scene.add(sprdtext);

          sprdtext = new Text2D('recoating', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, -0.5 * Math.PI);
          sprdtext.position.set(158, 0, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('x', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-110, -145, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-150, -105, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-150, -150, 40);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('280 x 280 x 365mm', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -147, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = -140;
          this.groupBase.position.y = -140;
          this.groupBase.position.z = -30;
          this.scene.add(this.groupBase);
          break;
        case 'RenishawAM250':
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material, false));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          Diameter = 250;
          Height = 300;
          point1 = new this.THREE.Vector3(-Diameter / 2, -Diameter / 2, 0);
          point2 = new this.THREE.Vector3(-Diameter / 2, Diameter / 2, 0);
          point3 = new this.THREE.Vector3(Diameter / 2, Diameter / 2, 0);
          point4 = new this.THREE.Vector3(Diameter / 2, -Diameter / 2, 0);
          point5 = new this.THREE.Vector3(-Diameter / 2, -Diameter / 2, Height);
          point6 = new this.THREE.Vector3(-Diameter / 2, Diameter / 2, Height);
          point7 = new this.THREE.Vector3(Diameter / 2, Diameter / 2, Height);
          point8 = new this.THREE.Vector3(Diameter / 2, -Diameter / 2, Height);
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(point5, point6, point7, point8, point5);
          line1 = new this.THREE.Line(geometry1, material);
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(point1, point5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(point2, point6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(point3, point7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(point4, point8);
          line5 = new this.THREE.Line(geometry5, material);
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);

          grid = new this.THREE.GridHelper(250, 25, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          arrow1 = new this.THREE.ArrowHelper(new this.THREE.Vector3(-1, 0, 0), new this.THREE.Vector3(130, 130, 0), 40, 0x000000);
          arrow2 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, -1, 0), new this.THREE.Vector3(130, 130, 0), 40, 0x000000);
          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          this.scene.add(arrow1);
          this.scene.add(arrow2);
          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('Recoater', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(0, 144, 22);
          this.scene.add(sprdtext);

          sprdtext = new Text2D('recoating', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, -0.5 * Math.PI);
          sprdtext.position.set(140, 105, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('x', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-95, -130, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-135, -90, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-135, -135, 40);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('250 x 250 x 300mm', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -130, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = -125;
          this.groupBase.position.y = -125;
          this.groupBase.position.z = -15;
          this.scene.add(this.groupBase);
          break;
        case 'RenishawAM500':
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          this.STLList.push(this.STL_LOAD(this.groupBase, this.PRINTER_CONFIG_LIBRARY[this.PRINTER].base, material, false));
          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          Diameter = 250;
          Height = 350;
          point1 = new this.THREE.Vector3(-Diameter / 2, -Diameter / 2, 0);
          point2 = new this.THREE.Vector3(-Diameter / 2, Diameter / 2, 0);
          point3 = new this.THREE.Vector3(Diameter / 2, Diameter / 2, 0);
          point4 = new this.THREE.Vector3(Diameter / 2, -Diameter / 2, 0);
          point5 = new this.THREE.Vector3(-Diameter / 2, -Diameter / 2, Height);
          point6 = new this.THREE.Vector3(-Diameter / 2, Diameter / 2, Height);
          point7 = new this.THREE.Vector3(Diameter / 2, Diameter / 2, Height);
          point8 = new this.THREE.Vector3(Diameter / 2, -Diameter / 2, Height);
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(point5, point6, point7, point8, point5);
          line1 = new this.THREE.Line(geometry1, material);
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(point1, point5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(point2, point6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(point3, point7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(point4, point8);
          line5 = new this.THREE.Line(geometry5, material);
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);

          grid = new this.THREE.GridHelper(250, 25, 0xffffff, 0x555555);
          grid.rotateOnAxis(new this.THREE.Vector3(1, 0, 0), 90 * (Math.PI / 180));
          grid.position.set(0, 0, 0.0001);
          this.scene.add(grid);

          arrow1 = new this.THREE.ArrowHelper(new this.THREE.Vector3(-1, 0, 0), new this.THREE.Vector3(130, 130, 0), 40, 0x000000);
          arrow2 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, -1, 0), new this.THREE.Vector3(130, 130, 0), 40, 0x000000);
          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-130, -130, 0), 40, 0x000000);
          this.scene.add(arrow1);
          this.scene.add(arrow2);
          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('Recoater', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(0, 144, 22);
          this.scene.add(sprdtext);

          sprdtext = new Text2D('recoating', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, -0.5 * Math.PI);
          sprdtext.position.set(140, 105, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('x', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-95, -130, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-135, -90, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-135, -135, 40);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('250 x 250 x 350mm', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -130, 0);
          this.scene.add(sprdtext);

          this.groupBase.position.x = -125;
          this.groupBase.position.y = -125;
          this.groupBase.position.z = -15;
          this.scene.add(this.groupBase);
          break;
        default:
          var length, width, height, thickness;
          if (this.PRINTERS_CONFIG[this.PRINTER]) {
            var printerConfig = this.PRINTERS_CONFIG[this.PRINTER];
            length = printerConfig.plateX;
            width = printerConfig.plateY;
            height = printerConfig.plateZ;
            thickness = printerConfig.plateThickness;
          } else {
            length = this.CONFIG.PrinterXYZ[0];
            width = this.CONFIG.PrinterXYZ[1];
            height = this.CONFIG.PrinterXYZ[2];
            thickness = Number(this.CONFIG.plateThickness[0]);
          }
          material = new this.THREE.MeshPhongMaterial({ color: 0xAAAAAA, specular: 0x111111, shininess: 200 });
          var buildPlate = new this.THREE.BoxBufferGeometry(length, width, thickness);
          buildPlate.computeVertexNormals();
          buildPlate = new this.THREE.Mesh(buildPlate, material);

          var recoaterShape = new this.THREE.Shape([new this.THREE.Vector2(0, 0), new this.THREE.Vector2(8, 4), new this.THREE.Vector2(8, 24), new this.THREE.Vector2(0, 24)]);
          var recoaterGeometry;
          if (this.CONFIG.DirectionRecoater[0]) {
            recoaterGeometry = new this.THREE.ExtrudeGeometry(recoaterShape, {
              amount: width,
              bevelEnabled: false
            });
          } else {
            recoaterGeometry = new this.THREE.ExtrudeGeometry(recoaterShape, {
              amount: length,
              bevelEnabled: false
            });
          }
          var recoater = new this.THREE.Mesh(recoaterGeometry, material);
          if (this.CONFIG.DirectionRecoater[0]) {
            recoater.rotation.set(Math.PI / 2, 0, 0);
            recoater.position.set(length / 2 + 24, width / 2, 7);
          } else {
            recoater.rotation.set(Math.PI / 2, Math.PI / 2, 0);
            recoater.position.set(-length / 2, width / 2 + 24, 7);
          }

          this.scene.add(recoater);

          material = new this.THREE.LineBasicMaterial({ color: 0x000000 });
          point1 = new this.THREE.Vector3(-length / 2, -width / 2, 0);
          point2 = new this.THREE.Vector3(-length / 2, width / 2, 0);
          point3 = new this.THREE.Vector3(length / 2, width / 2, 0);
          point4 = new this.THREE.Vector3(length / 2, -width / 2, 0);
          point5 = new this.THREE.Vector3(-length / 2, -width / 2, height);
          point6 = new this.THREE.Vector3(-length / 2, width / 2, height);
          point7 = new this.THREE.Vector3(length / 2, width / 2, height);
          point8 = new this.THREE.Vector3(length / 2, -width / 2, height);
          geometry1 = new this.THREE.Geometry();
          geometry1.vertices.push(point5, point6, point7, point8, point5);
          line1 = new this.THREE.Line(geometry1, material);
          geometry2 = new this.THREE.Geometry();
          geometry2.vertices.push(point1, point5);
          line2 = new this.THREE.Line(geometry2, material);
          geometry3 = new this.THREE.Geometry();
          geometry3.vertices.push(point2, point6);
          line3 = new this.THREE.Line(geometry3, material);
          geometry4 = new this.THREE.Geometry();
          geometry4.vertices.push(point3, point7);
          line4 = new this.THREE.Line(geometry4, material);
          geometry5 = new this.THREE.Geometry();
          geometry5.vertices.push(point4, point8);
          line5 = new this.THREE.Line(geometry5, material);
          this.scene.add(line1);
          this.scene.add(line2);
          this.scene.add(line3);
          this.scene.add(line4);
          this.scene.add(line5);

          grid = new this.THREE.Geometry();
          material = new this.THREE.LineBasicMaterial({ color: 0x555555 });
          for (var i = 0; i <= length; i += 10) {
            grid.vertices.push(new this.THREE.Vector3(i, 0, 0));
            grid.vertices.push(new this.THREE.Vector3(i, width, 0));
          }
          grid.vertices.push(new this.THREE.Vector3(length, 0, 0));
          grid.vertices.push(new this.THREE.Vector3(length, width, 0));

          for (i = 0; i <= width; i += 10) {
            grid.vertices.push(new this.THREE.Vector3(0, i, 0));
            grid.vertices.push(new this.THREE.Vector3(length, i, 0));
          }
          grid.vertices.push(new this.THREE.Vector3(0, width, 0));
          grid.vertices.push(new this.THREE.Vector3(length, width, 0));

          var gridLine = new this.THREE.LineSegments(grid, material);
          gridLine.position.set(-length / 2, -width / 2, 0.0001);
          this.scene.add(gridLine);

          arrow1 = new this.THREE.ArrowHelper(new this.THREE.Vector3(-1, 0, 0), new this.THREE.Vector3(length / 2 + 10, width / 2 + 10, 0), 40, 0x000000);
          arrow2 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, -1, 0), new this.THREE.Vector3(length / 2 + 10, width / 2 + 10, 0), 40, 0x000000);
          arrow3 = new this.THREE.ArrowHelper(new this.THREE.Vector3(1, 0, 0), new this.THREE.Vector3(-(length / 2) - 10, -(width / 2) - 10, 0), 40, 0x000000);
          arrow4 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 1, 0), new this.THREE.Vector3(-(length / 2) - 10, -(width / 2) - 10, 0), 40, 0x000000);
          arrow5 = new this.THREE.ArrowHelper(new this.THREE.Vector3(0, 0, 1), new this.THREE.Vector3(-(length / 2) - 10, -(width / 2) - 10, 0), 40, 0x000000);
          this.scene.add(arrow1);
          this.scene.add(arrow2);
          this.scene.add(arrow3);
          this.scene.add(arrow4);
          this.scene.add(arrow5);

          Text2D = THREE_TEXT.Text2D;
          textAlign = THREE_TEXT.textAlign;
          sprdtext = new Text2D('Recoater', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          if (this.CONFIG.DirectionRecoater[0]) {
            sprdtext.rotation.set(0.5 * Math.PI, -0.5 * Math.PI, 0);
            sprdtext.position.set(length / 2 + 24 - 0.01, 0, 28);
          } else {
            sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
            sprdtext.position.set(0, width / 2 + 24 - 0.01, 28);
          }

          this.scene.add(sprdtext);
          sprdtext = new Text2D('recoating', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          if (this.CONFIG.DirectionRecoater[0]) {
            sprdtext.rotation.set(0, 0, 0);
            sprdtext.position.set(length / 2 - 8, width / 2 + 22, 0);
          } else {
            sprdtext.rotation.set(0, 0, -0.5 * Math.PI);
            sprdtext.position.set(length / 2 + 22, width / 2 - 10, 0);
          }
          this.scene.add(sprdtext);

          sprdtext = new Text2D('x', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-(length / 2) - 15 + 40, -(width / 2) - 10, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('y', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(-(length / 2) - 15, -(width / 2) - 10 + 40, 0);
          this.scene.add(sprdtext);
          sprdtext = new Text2D('z', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.1, 0.1, 0.1);
          sprdtext.rotation.set(0.5 * Math.PI, 0, 0);
          sprdtext.position.set(-(length / 2) - 15, -(width / 2) - 10, 40);
          this.scene.add(sprdtext);
          sprdtext = new Text2D(length + ' x ' + width + ' x ' + height + 'mm', { align: textAlign.center, font: '90px Arial', fillStyle: '#000000', antialias: true });
          sprdtext.scale.set(0.15, 0.15, 0.15);
          sprdtext.rotation.set(0, 0, 0);
          sprdtext.position.set(0, -(width / 2) - 24, 0);
          this.scene.add(sprdtext);

          this.groupBase.add(buildPlate);
          this.groupBase.position.z = -(thickness / 2);
          this.scene.add(this.groupBase);
          break;
      }
    }
  }, {
    key: 'setupInset',
    value: function setupInset() {
      var insetWidth = 150;
      var insetHeight = 150;

      this.container = document.getElementById('inset');
      this.container.width = insetWidth;
      this.container.height = insetHeight;

      this.renderer2 = new this.THREE.WebGLRenderer({ alpha: true });
      this.renderer2.setClearColor(0x000000, 0);
      this.renderer2.setSize(insetWidth, insetHeight);
      this.container.appendChild(this.renderer2.domElement);

      this.scene2 = new this.THREE.Scene();

      this.camera2 = new this.THREE.PerspectiveCamera(50, insetWidth / insetHeight, 1, 1000);
      this.camera2.up = this.camera.up;
      var axis2 = new this.THREE.AxisHelper(100);
      this.scene2.add(axis2);
    }
  }, {
    key: 'addLegend',
    value: function addLegend(min, max) {
      while (this['sceneL'].children.length > 0) {
        this['sceneL'].remove(this['sceneL'].children[0]);
      }

      this.lut = new this.THREE.Lut(this.lutConfig.colorMap, this.lutConfig.numberOfColors);
      var lut = this.lut.copy(this.lut);
      this.lut.setMax(max);
      this.lut.setMin(min);
      var legend = lut.setLegendOn({ 'layout': 'horizontal', 'position': { 'x': 0, 'y': 0, 'z': 0 } });
      this['sceneL'].remove(legend);
      this['sceneL'].add(legend);
      var labels = lut.setLegendLabels({ 'ticks': 5, 'decimal': 4 });
      for (var i = 0; i < (0, _keys2.default)(labels['ticks']).length; i++) {
        this['sceneL'].add(labels['ticks'][i]);
        this['sceneL'].add(labels['lines'][i]);
      }
      this.setLegendToElem(min, max);
    }
  }, {
    key: 'setupInsetLegend',
    value: function setupInsetLegend() {
      var insetWidth = 300;
      var insetHeight = 150;

      this['sceneL'] = new this.THREE.Scene();

      this['cameraL'] = new this.THREE.PerspectiveCamera(20, insetWidth / insetHeight, 1, 10000);
      this['cameraL'].name = 'camera';
      this['sceneL'].add(this['cameraL']);
      this['cameraL'].position.x = 0;
      this['cameraL'].position.y = 0;
      this['cameraL'].position.z = 5;
      this['containerL'] = document.getElementById('inset-legend-wrp');
      this['containerL'].width = insetWidth;
      this['containerL'].height = insetHeight;

      this['rendererL'] = new this.THREE.WebGLRenderer({ alpha: true });
      this['rendererL'].setClearColor(0x000000, 0);
      this['rendererL'].setSize(insetWidth, insetHeight);
      this['containerL'].appendChild(this['rendererL'].domElement);
    }
  }, {
    key: 'animate',
    value: function animate() {
      if (this.modifySupportsMode && this.finishedLoading) {
        this.colorFaces();
      }

      if (this.camera.getWorldDirection().angleTo(new this.THREE.Vector3(0, 0, -1)) > Math.PI / 2) {
        this.groupBase.visible = false;
      } else {
        this.groupBase.visible = true;
      }

      this.cancelID = requestAnimationFrame(this.animate.bind(this));
      this.controls.update();

      this.camera2.position.copy(this.camera.position);
      this.camera2.position.sub(this.controls.target);
      this.camera2.position.setLength(300);
      this.camera2.lookAt(this.scene2.position);
      this.renderer.render(this.scene, this.camera);
      this.renderer2.render(this.scene2, this.camera2);
      if (!this.modifySupportsMode && this.finishedLoading && this.isThermalPredict) {
        this['rendererL'].render(this['sceneL'], this['cameraL']);
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      cancelAnimationFrame(this.cancelID);
      this.renderer.domElement.addEventListener('dblclick', null, false);
      window.removeEventListener('resize', this.onWindowResize);
      window.removeEventListener('click', this.onDocumentMouseClick);
      window.removeEventListener('mousemove', this.onDocumentMouseMove);
      this.scene = null;
      this.projector = null;
      this.camera = null;
      this.controls = null;
      function empty(elem) {
        while (elem.lastChild) {
          elem.removeChild(elem.lastChild);
        }elem.remove();
      }
      empty(this.renderer.domElement);
      empty(this.renderer2.domElement);

      if (!this.modifySupportsMode && this.isThermalPredict) {
        empty(this['rendererL'].domElement);
      }
      this.renderer.dispose();
      this.renderer2.dispose();
      if (!this.modifySupportsMode && this.isThermalPredict) {
        this['rendererL'].dispose();
      }
      document.body.style.margin = '0';
      document.body.style.overflow = 'auto';
    }
  }]);
  return OutputViewer;
}();

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Support = undefined;

var _classCallCheck2 = __webpack_require__(65);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(66);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Support = exports.Support = function () {
  function Support(THREE) {
    (0, _classCallCheck3.default)(this, Support);

    this.THREE = THREE;
    this.groupSupp = new this.THREE.Group();
    this.raycaster = new this.THREE.Raycaster();
    this.suppColor = 0x8e44ad;
  }

  (0, _createClass3.default)(Support, [{
    key: 'addShape',
    value: function addShape(shape, color, x, y, z, rx, ry, rz, s) {
      var geometry = new this.THREE.ShapeBufferGeometry(shape);
      var mesh = new this.THREE.Mesh(geometry, new this.THREE.MeshPhongMaterial({ color: color, side: this.THREE.DoubleSide }));
      mesh.rotation.order = 'ZYX';
      rx = rx / 180 * Math.PI;
      ry = ry / 180 * Math.PI;
      rz = rz / 180 * Math.PI;
      mesh.rotation.set(rx, ry, rz);
      mesh.position.set(x, y, z);
      mesh.scale.set(s, s, s);
      this.groupSupp.add(mesh);
    }
  }, {
    key: 'draw',
    value: function draw(scene, group, _params) {
      var criticalAngle = _params.criticalAngle;
      var restrictedFaces = _params.restrictedFaces;
      var allowedFaces = _params.allowedFaces;
      var supportConfig = _params.supportConfig;

      this.clear(scene);

      var Ot = 0.8;
      var Ob = 0.8;
      var Tt = 0.5;
      var Tb = 0.5;
      var Wt = 0.5;
      var Wb = 0.8;
      var Pt = 0.16;
      var Pb = 0.16;
      if (supportConfig) {
        Ot = supportConfig.Ot[0];
        Ob = supportConfig.Ob[0];
        Tt = supportConfig.Tt[0];
        Tb = supportConfig.Tb[0];
        Wt = supportConfig.Wt[0];
        Wb = supportConfig.Wb[0];
        Pt = supportConfig.Pt[0];
        Pb = supportConfig.Pb[0];
      }

      var distanceSet = 1;
      var cosine35 = Math.cos(criticalAngle / 180 * Math.PI);
      var bbox = new this.THREE.Box3().setFromObject(group);
      var zPosition = 0;

      var largestDimX = bbox.max.x - bbox.min.x;
      var largestDimY = bbox.max.y - bbox.min.y;
      var halfLargestDistanceX = largestDimX / 2;
      var halfLargestDistanceY = largestDimY / 2;
      var supportnumberX = Math.ceil(largestDimX / distanceSet);
      var supportnumberY = Math.ceil(largestDimY / distanceSet);
      var distanceX = largestDimX / supportnumberX;
      var distanceY = largestDimY / supportnumberY;

      var objHight5pc = (bbox.max.z - bbox.min.z) * 0.05 + bbox.min.z;
      var currentEuler = new this.THREE.Euler(group.rotation.x, group.rotation.y, group.rotation.z, 'ZYX');
      var direction = new this.THREE.Vector3(0, 0, 1);

      for (var x = 0; x <= supportnumberX; x++) {
        for (var y = 0; y <= supportnumberY; y++) {
          var xPosition = -halfLargestDistanceX + distanceX * x;
          var yPosition = -halfLargestDistanceY + distanceY * y;

          var begin = new this.THREE.Vector3(xPosition, yPosition, zPosition);

          this.raycaster.set(begin, direction);
          var intersections = this.raycaster.intersectObjects(group.children, true);

          if (intersections.length) {
            for (var i = 0; i < intersections.length; i += 2) {
              var faceIndex = intersections[i].faceIndex;
              var idxRestricted = restrictedFaces.indexOf(Math.floor(faceIndex / 3));
              var idxAllowed = allowedFaces.indexOf(Math.floor(faceIndex / 3));

              if (idxRestricted === -1) {
                var lastPointZ = zPosition;
                if (i > 0) {
                  lastPointZ = intersections[i - 1].point.z;
                }

                var newPointZ = intersections[i].point.z;

                var inormal = intersections[i].face.normal;
                inormal.applyEuler(currentEuler);

                var cosangle = inormal.dot(new this.THREE.Vector3(0, 0, -1.0));
                if (idxAllowed > -1 || cosangle > cosine35 || newPointZ <= objHight5pc) {
                  var startx = xPosition;
                  var starty = yPosition;
                  var startz = lastPointZ;

                  var endz = newPointZ;
                  var rectLength = distanceSet * Math.sqrt(2.0);

                  var rectShape = new this.THREE.Shape();
                  if (startz < 1e-9) {
                    rectShape.moveTo(rectLength / 2, startz);
                    rectShape.lineTo(0, startz);
                    rectShape.lineTo(0, endz - Ot - Tt);
                    rectShape.lineTo((rectLength - Wt * rectLength) * 0.5, endz - Ot);
                    rectShape.lineTo((rectLength - Wt * rectLength) * 0.5, endz + Pt);
                    rectShape.lineTo((rectLength - Wt * rectLength) * 0.5 + Wt * rectLength, endz + Pt);
                    rectShape.lineTo((rectLength - Wt * rectLength) * 0.5 + Wt * rectLength, endz - Ot);
                    rectShape.lineTo(rectLength, endz - Ot - Tt);
                    rectShape.lineTo(rectLength, startz);
                    rectShape.lineTo(rectLength / 2, startz);
                  } else {
                    rectShape.moveTo(rectLength / 2, startz - Pb);
                    rectShape.lineTo((rectLength - Wb * rectLength) * 0.5, startz - Pb);
                    rectShape.lineTo((rectLength - Wb * rectLength) * 0.5, startz + Ob);
                    rectShape.lineTo(0, startz + Ob + Tb);
                    rectShape.lineTo(0, endz - Ot - Tt);
                    rectShape.lineTo((rectLength - Wt * rectLength) * 0.5, endz - Ot);
                    rectShape.lineTo((rectLength - Wt * rectLength) * 0.5, endz + Pt);
                    rectShape.lineTo((rectLength - Wt * rectLength) * 0.5 + Wt * rectLength, endz + Pt);
                    rectShape.lineTo((rectLength - Wt * rectLength) * 0.5 + Wt * rectLength, endz - Ot);
                    rectShape.lineTo(rectLength, endz - Ot - Tt);
                    rectShape.lineTo(rectLength, startz + Ob + Tb);
                    rectShape.lineTo(rectLength - (rectLength - Wt * rectLength) * 0.5, startz + Ob);
                    rectShape.lineTo(rectLength - (rectLength - Wt * rectLength) * 0.5, startz - Pb);
                    rectShape.moveTo(rectLength / 2, startz - Pb);
                  }
                  this.addShape(rectShape, this.suppColor, startx - distanceSet / 2, starty - distanceSet / 2, 0, 90, 0, 45, 1);
                  this.addShape(rectShape, this.suppColor, startx - distanceSet / 2, starty + distanceSet / 2, 0, 90, 0, -45, 1);
                }
              }
            }
          }
        }
      }
      scene.add(this.groupSupp);
    }
  }, {
    key: 'clear',
    value: function clear(scene) {
      scene.remove(this.groupSupp);
      this.groupSupp = new this.THREE.Group();
    }
  }]);
  return Support;
}();

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SupportOutput = undefined;

var _classCallCheck2 = __webpack_require__(65);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(66);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SupportOutput = exports.SupportOutput = function () {
  function SupportOutput(THREE) {
    (0, _classCallCheck3.default)(this, SupportOutput);

    this.THREE = THREE;
    this.groupSupp = new this.THREE.Group();
    this.raycaster = new this.THREE.Raycaster();
    this.suppColor = {
      default: 0x8e44ad,
      allowed: 0x00ff00,
      restricted: 0xff0000
    };

    this.materials = {
      default: new this.THREE.MeshPhongMaterial({ color: this.suppColor.default, side: this.THREE.DoubleSide }),
      allowed: new this.THREE.MeshPhongMaterial({ color: this.suppColor.allowed, side: this.THREE.DoubleSide }),
      restricted: new this.THREE.MeshPhongMaterial({ color: this.suppColor.restricted, side: this.THREE.DoubleSide })
    };
  }

  (0, _createClass3.default)(SupportOutput, [{
    key: 'addShape',
    value: function addShape(shape, color, x, y, z, rx, ry, rz, s) {
      var geometry = new this.THREE.ShapeBufferGeometry(shape);
      var mesh = new this.THREE.Mesh(geometry, this.materials[color]);
      mesh.rotation.order = 'ZYX';
      rx = rx / 180 * Math.PI;
      ry = ry / 180 * Math.PI;
      rz = rz / 180 * Math.PI;
      mesh.rotation.set(rx, ry, rz);
      mesh.position.set(x, y, z);
      mesh.scale.set(s, s, s);
      this.groupSupp.add(mesh);
    }
  }, {
    key: 'draw',
    value: function draw(scene, group, _params) {
      var criticalAngle = _params.criticalAngle;
      var restrictedFaces = _params.restrictedFaces;
      var allowedFaces = _params.allowedFaces;
      var supportConfig = _params.supportConfig;

      this.clear(scene);

      var Ot = 0.8;
      var Ob = 0.8;
      var Tt = 0.5;
      var Tb = 0.5;
      var Wt = 0.5;
      var Wb = 0.8;
      var Pt = 0.16;
      var Pb = 0.16;
      if (supportConfig) {
        Ot = supportConfig.Ot[0];
        Ob = supportConfig.Ob[0];
        Tt = supportConfig.Tt[0];
        Tb = supportConfig.Tb[0];
        Wt = supportConfig.Wt[0];
        Wb = supportConfig.Wb[0];
        Pt = supportConfig.Pt[0];
        Pb = supportConfig.Pb[0];
      }

      var faceColor = void 0;

      var distanceSet = 1;
      var cosine35 = Math.cos(criticalAngle / 180 * Math.PI);
      var bbox = new this.THREE.Box3().setFromObject(group);
      var zPosition = 0;

      var largestDimX = bbox.max.x - bbox.min.x;
      var largestDimY = bbox.max.y - bbox.min.y;
      var halfLargestDistanceX = largestDimX / 2;
      var halfLargestDistanceY = largestDimY / 2;
      var supportnumberX = Math.ceil(largestDimX / distanceSet);
      var supportnumberY = Math.ceil(largestDimY / distanceSet);
      var distanceX = largestDimX / supportnumberX;
      var distanceY = largestDimY / supportnumberY;

      var objHight5pc = (bbox.max.z - bbox.min.z) * 0.05 + bbox.min.z;

      var currentEuler = new this.THREE.Euler(group.rotation.x, group.rotation.y, group.rotation.z, 'ZYX');
      var direction = new this.THREE.Vector3(0, 0, 1);
      var directionRev = new this.THREE.Vector3(0, 0, -1);

      for (var x = 0; x <= supportnumberX; x++) {
        for (var y = 0; y <= supportnumberY; y++) {
          var xPosition = -halfLargestDistanceX + distanceX * x;
          var yPosition = -halfLargestDistanceY + distanceY * y;

          var begin = new this.THREE.Vector3(xPosition, yPosition, zPosition);

          this.raycaster.set(begin, direction);
          var intersections = this.raycaster.intersectObject(group.children[0], true);

          if (intersections.length) {
            for (var i = 0; i < intersections.length; i += 2) {
              var faceIndex = intersections[i].faceIndex;
              var idxRestricted = restrictedFaces.indexOf(Math.floor(faceIndex / 3));
              var idxAllowed = allowedFaces.indexOf(Math.floor(faceIndex / 3));

              if (idxRestricted > -1) {
                faceColor = 'restricted';
              } else if (idxAllowed > -1) {
                faceColor = 'allowed';
              } else {
                faceColor = 'default';
              }
              var lastPointZ = zPosition;
              if (i > 0) {
                lastPointZ = intersections[i - 1].point.z;
              }

              var newPointZ = intersections[i].point.z;

              var inormal = intersections[i].face.normal;
              inormal.applyEuler(currentEuler);

              var cosangle = inormal.dot(directionRev);
              if (cosangle > cosine35 || newPointZ <= objHight5pc) {
                var startx = xPosition;
                var starty = yPosition;
                var startz = lastPointZ;

                var endz = newPointZ;
                var rectLength = distanceSet * Math.sqrt(2.0);

                var rectShape = new this.THREE.Shape();
                if (startz < 1e-9) {
                  rectShape.moveTo(rectLength / 2, startz);
                  rectShape.lineTo(0, startz);
                  rectShape.lineTo(0, endz - Ot - Tt);
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5, endz - Ot);
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5, endz + Pt);
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5 + Wt * rectLength, endz + Pt);
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5 + Wt * rectLength, endz - Ot);
                  rectShape.lineTo(rectLength, endz - Ot - Tt);
                  rectShape.lineTo(rectLength, startz);
                  rectShape.lineTo(rectLength / 2, startz);
                } else {
                  rectShape.moveTo(rectLength / 2, startz - Pb);
                  rectShape.lineTo((rectLength - Wb * rectLength) * 0.5, startz - Pb);
                  rectShape.lineTo((rectLength - Wb * rectLength) * 0.5, startz + Ob);
                  rectShape.lineTo(0, startz + Ob + Tb);
                  rectShape.lineTo(0, endz - Ot - Tt);
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5, endz - Ot);
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5, endz + Pt);
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5 + Wt * rectLength, endz + Pt);
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5 + Wt * rectLength, endz - Ot);
                  rectShape.lineTo(rectLength, endz - Ot - Tt);
                  rectShape.lineTo(rectLength, startz + Ob + Tb);
                  rectShape.lineTo(rectLength - (rectLength - Wt * rectLength) * 0.5, startz + Ob);
                  rectShape.lineTo(rectLength - (rectLength - Wt * rectLength) * 0.5, startz - Pb);
                  rectShape.moveTo(rectLength / 2, startz - Pb);
                }
                this.addShape(rectShape, faceColor, startx - distanceSet / 2, starty - distanceSet / 2, 0, 90, 0, 45, 1);
                this.addShape(rectShape, faceColor, startx - distanceSet / 2, starty + distanceSet / 2, 0, 90, 0, -45, 1);
              }
            }
          }
        }
      }
      scene.add(this.groupSupp);
    }
  }, {
    key: 'clear',
    value: function clear(scene) {
      scene.remove(this.groupSupp);
      this.groupSupp = new this.THREE.Group();
    }
  }]);
  return SupportOutput;
}();

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(17);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(51);

var _keys2 = _interopRequireDefault(_keys);

var _axios = __webpack_require__(64);

var _axios2 = _interopRequireDefault(_axios);

var _vue = __webpack_require__(79);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  state: {
    isLoading: false,
    prices: {
      UNLIMITED_MONTHLY: 125000,
      UNLIMITED_YEAR: 1200000,
      UNLIMITED_THREE_YEARS: 3000000
    },
    subscriptionTypes: {
      UNLIMITED_MONTHLY: 'UNLIMITED_MONTHLY',
      UNLIMITED_YEAR: 'UNLIMITED_YEAR',
      UNLIMITED_THREE_YEARS: 'UNLIMITED_THREE_YEARS'
    }
  },
  mutations: {
    'SET_LOADING': function SET_LOADING(state, value) {
      _vue2.default.set(state, 'isLoading', value);
    },
    'SET_SUBSCRIPTION_MONTHLY_PRICE': function SET_SUBSCRIPTION_MONTHLY_PRICE(state, price) {
      _vue2.default.set(state.prices, 'UNLIMITED_MONTHLY', Number(price));
    },
    'SET_SUBSCRIPTION_YEAR_PRICE': function SET_SUBSCRIPTION_YEAR_PRICE(state, price) {
      _vue2.default.set(state.prices, 'UNLIMITED_YEAR', Number(price));
    },
    'SET_SUBSCRIPTION_THREE_YEARS_PRICE': function SET_SUBSCRIPTION_THREE_YEARS_PRICE(state, price) {
      _vue2.default.set(state.prices, 'UNLIMITED_THREE_YEARS', Number(price));
    }
  },
  getters: {},
  actions: {
    loadSubscriptionPrices: function loadSubscriptionPrices(_ref) {
      var state = _ref.state,
          dispatch = _ref.dispatch,
          commit = _ref.commit;

      if ((0, _keys2.default)(state.prices).length < 1 && !state.isLoading) {
        commit('SET_LOADING', true);
        return dispatch('getSubscriptionPrices').then(function (response) {
          if (response.length > 0) {
            commit('SET_SUBSCRIPTION_MONTHLY_PRICE', response[0].data.cost);
            commit('SET_SUBSCRIPTION_YEAR_PRICE', response[1].data.cost);
            commit('SET_SUBSCRIPTION_THREE_YEARS_PRICE', response[2].data.cost);
          }
          commit('SET_LOADING', false);
        }).catch(function () {
          commit('SET_LOADING', false);
        });
      }
    },
    getSubscriptionPrice: function getSubscriptionPrice(_ref2, subscriptionType) {
      var rootState = _ref2.rootState;

      return _axios2.default.post(rootState.config.API_URL + '/billing/calculate', {
        type: 'subscription',
        value: rootState.billing.subscriptionTypes[subscriptionType]
      }, {
        headers: {
          Authorization: 'Bearer ' + rootState.user.token,
          'Content-Type': 'application/json'
        }
      });
    },
    getSubscriptionPrices: function getSubscriptionPrices(_ref3) {
      var rootState = _ref3.rootState,
          dispatch = _ref3.dispatch;

      return _promise2.default.all([dispatch('getSubscriptionPrice', rootState.billing.subscriptionTypes.UNLIMITED_MONTHLY), dispatch('getSubscriptionPrice', rootState.billing.subscriptionTypes.UNLIMITED_YEAR), dispatch('getSubscriptionPrice', rootState.billing.subscriptionTypes.UNLIMITED_THREE_YEARS)]);
    },
    sendSubscriptionData: function sendSubscriptionData(_ref4, _ref5) {
      var rootState = _ref4.rootState,
          dispatch = _ref4.dispatch;
      var name = _ref5.name,
          company = _ref5.company,
          address = _ref5.address,
          phone = _ref5.phone,
          email = _ref5.email,
          plan = _ref5.plan;

      return _axios2.default.post(rootState.config.API_URL + '/billing/order', { name: name, company: company, address: address, phone: phone, email: email, plan: plan }, {
        headers: {
          Authorization: 'Bearer ' + rootState.user.token,
          'Content-Type': 'application/json'
        }
      });
    },
    buySubscription: function buySubscription(_ref6, _ref7) {
      var rootState = _ref6.rootState;
      var token = _ref7.token,
          idempotentKey = _ref7.idempotentKey,
          subscriptionType = _ref7.subscriptionType;

      return _axios2.default.post(rootState.config.API_URL + '/billing/submit', {
        type: 'subscription',
        value: subscriptionType,
        token: token,
        transactionKey: idempotentKey
      }, {
        headers: {
          Authorization: 'Bearer ' + rootState.user.token,
          'Content-Type': 'application/json'
        }
      });
    }
  }
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(24);

var _assign2 = _interopRequireDefault(_assign);

var _axios = __webpack_require__(64);

var _axios2 = _interopRequireDefault(_axios);

var _helpers = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  state: {
    jobs: {}
  },
  actions: {
    getJobOutput: function getJobOutput(_ref, jobOutputId) {
      var rootState = _ref.rootState,
          dispatch = _ref.dispatch;

      var mainResponse = void 0;
      return _axios2.default.post("https://dev.portal.atlas3d.xyz/graphql", {
        query: '\n          query {\n            JobOutput: getJobOutput(id: "' + jobOutputId + '") {\n              job {\n                config\n                pathKey\n                isNested\n                sourceFile {\n                  pathKey\n                }\n              }\n              id\n              analysisId\n              objectiveId\n              pathKey\n              outputFiles(limit: 10000) {\n                items {\n                  id\n                  name\n                }\n              }\n            }\n          }'
      }, {
        headers: {
          Authorization: '' + rootState.user.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        response = (0, _helpers.errorHandlingAppSync)(response);
        mainResponse = response;
        if (response.data.JobOutput.job.config.AdditionalConfig) {
          return dispatch('getDownloadURL', {
            sourceFilePathKey: response.data.JobOutput.job.sourceFile.pathKey,
            jobPathKey: response.data.JobOutput.job.pathKey,
            filename: 'additional_config.json'
          }, { root: true }).then(function (response) {
            return dispatch('getURLData', { url: response.data.url }, { root: true });
          }).then(function (data) {
            mainResponse.data.JobOutput.job.config = (0, _assign2.default)(mainResponse.data.JobOutput.job.config, data.data);
            return mainResponse;
          });
        } else {
          return response;
        }
      });
    },
    getNestedJobs: function getNestedJobs(_ref2, pathKey) {
      var rootState = _ref2.rootState,
          commit = _ref2.commit;

      return _axios2.default.post("https://dev.portal.atlas3d.xyz/graphql", {
        query: 'query {\n            allJobs: jobByParentPathKey(parentPathKey: "' + pathKey + '") {\n              items {\n                id\n                pathKey\n                config\n                parentPathKey\n                importance\n                quantity\n                isNested\n                isArchived\n                createdAt\n                updatedAt\n                sourceFile {\n                  id\n                  pathKey\n                }\n                jobOutputs {\n                  items {\n                    id\n                    pathKey\n                    analysisId\n                    objectiveId\n                    outputFiles(limit: 10000) {\n                      items {\n                        id\n                        name\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }'
      }, {
        headers: {
          Authorization: '' + rootState.user.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        response = (0, _helpers.errorHandlingAppSync)(response);
        return response;
      });
    },
    archiveJob: function archiveJob(_ref3, payload) {
      var rootState = _ref3.rootState,
          commit = _ref3.commit;

      var data = {
        isArchived: true
      };
      if (payload.hasOwnProperty('jobOutputPathKey')) {
        data.jobOutputPathKey = payload.jobOutputPathKey;
      } else {
        data.jobPathKey = payload.jobPathKey;
      }
      return _axios2.default.post(rootState.config.API_URL + '/jobs/update', data, {
        headers: {
          Authorization: 'Bearer ' + rootState.user.token
        }
      });
    },
    unarchiveJob: function unarchiveJob(_ref4, payload) {
      var rootState = _ref4.rootState,
          commit = _ref4.commit;

      var data = {
        isArchived: false
      };
      if (payload.hasOwnProperty('jobOutputPathKey')) {
        data.jobOutputPathKey = payload.jobOutputPathKey;
      } else {
        data.jobPathKey = payload.jobPathKey;
      }
      return _axios2.default.post(rootState.config.API_URL + '/jobs/update', data, {
        headers: {
          Authorization: 'Bearer ' + rootState.user.token
        }
      });
    },
    deleteJob: function deleteJob(_ref5, job) {
      var rootState = _ref5.rootState,
          commit = _ref5.commit;

      return _axios2.default.post(rootState.config.API_URL + '/jobs/delete', {
        jobPathKey: job
      }, {
        headers: {
          Authorization: 'Bearer ' + rootState.user.token
        }
      });
    }
  }
};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(24);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  state: {
    defaultNotification: {
      title: null,
      message: '',
      typeOfMessage: 'ALERT',
      type: null,
      isViewed: false,
      isCanRetry: false,
      retryTitle: 'Retry',
      retryCallback: null,
      dismissTitle: 'OK',
      details: null,
      errorCode: null
    },
    notifications: []
  },
  mutations: {
    'ADD_NOTIFICATION': function ADD_NOTIFICATION(state, payload) {
      state.notifications.push(payload);
    },
    'REMOVE_NOTIFICATION': function REMOVE_NOTIFICATION(state, index) {
      state.notifications.splice(index, 1);
    }
  },
  actions: {
    add: function add(_ref, payload) {
      var state = _ref.state,
          commit = _ref.commit;

      var vueInstance = payload.vueInstance;
      delete payload.vueInstance;
      var data = (0, _assign2.default)(state.defaultNotification, payload);
      commit('ADD_NOTIFICATION', data);
      if (data.typeOfMessage === 'ALERT') {
        vueInstance.$modal.show('alertmodal', data);
      }
    },
    remove: function remove(_ref2, payload) {
      var commit = _ref2.commit;

      commit('REMOVE_NOTIFICATION', payload);
    }
  }
};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(64);

var _axios2 = _interopRequireDefault(_axios);

var _helpers = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  state: {
    token: null,
    siemensId: null,
    lastLogin: null,
    firstName: '',
    lastName: '',
    credits: [],
    subscription: null,
    isGovcloudUser: false,
    loaded: false,
    isOnboard: null,
    isPassWasChangedCookieName: 'isPassWasChanged'
  },
  mutations: {
    'SET_TOKEN': function SET_TOKEN(state, token) {
      state.token = token;
    },
    'SET_SIEMENS_ID': function SET_SIEMENS_ID(state, id) {
      state.siemensId = id;
    },
    'SET_LAST_LOGIN': function SET_LAST_LOGIN(state, lastLogin) {
      state.lastLogin = lastLogin;
    },
    'SET_FIRST_NAME': function SET_FIRST_NAME(state, name) {
      state.firstName = name;
    },
    'SET_LAST_NAME': function SET_LAST_NAME(state, name) {
      state.lastName = name;
    },
    'SET_CREDITS': function SET_CREDITS(state, credits) {
      state.credits = credits;
    },
    'SET_SUBSCRIPTION': function SET_SUBSCRIPTION(state, subscription) {
      state.subscription = subscription;
    },
    'SET_GOVCLOUD': function SET_GOVCLOUD(state, isGovcloudUser) {
      state.isGovcloudUser = isGovcloudUser;
    },
    'SET_USER_EMAIL': function SET_USER_EMAIL(state, email) {
      state.email = email;
    },
    'SET_USER_LOADED': function SET_USER_LOADED(state) {
      state.loaded = true;
    },
    'SET_ONBOARD': function SET_ONBOARD(state, onBoard) {
      state.isOnboard = onBoard;
    }
  },
  getters: {
    subscriptionExpiration: function subscriptionExpiration(state) {
      var subscription = state.subscription;
      if (subscription) {
        var expDate = new Date(subscription.activeUntil);
        if (expDate > new Date()) {
          return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][expDate.getMonth()] + (' ' + expDate.getDate() + ', ' + expDate.getFullYear());
        }
      }
      return null;
    }
  },
  actions: {
    loadUser: function loadUser(_ref) {
      var rootState = _ref.rootState,
          state = _ref.state,
          commit = _ref.commit;

      return _axios2.default.post("https://dev.portal.atlas3d.xyz/graphql", {
        query: 'query {\n              user: getUser (siemensUserId: "' + state.siemensId + '") {\n                firstName\n                lastName\n                isGovcloudUser\n                email\n                userOnboardingComplete\n                subscription {\n                  id\n                  activeUntil\n                }\n                siemensUserId\n              }\n            }'
      }, {
        headers: {
          Authorization: '' + state.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        response = (0, _helpers.errorHandlingAppSync)(response);
        var user = response.data.user;
        if (user) {
          commit('SET_FIRST_NAME', user.firstName);
          commit('SET_LAST_NAME', user.lastName);
          commit('SET_SUBSCRIPTION', user.subscription);
          commit('SET_GOVCLOUD', user.isGovcloudUser);
          commit('SET_USER_EMAIL', user.email);
          commit('SET_ONBOARD', user.userOnboardingComplete);
          commit('SET_USER_LOADED');
        }
      });
    },
    refreshCredits: function refreshCredits(_ref2) {
      var rootState = _ref2.rootState,
          state = _ref2.state,
          commit = _ref2.commit;

      return _axios2.default.post("https://dev.portal.atlas3d.xyz/graphql", {
        query: 'query {\n              user: getUser (siemensUserId: "' + rootState.user.siemensId + '") {\n                subscription {\n                  id\n                  activeUntil\n                }\n              }\n            }'
      }, {
        headers: {
          Authorization: '' + state.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        response = (0, _helpers.errorHandlingAppSync)(response);
        commit('SET_SUBSCRIPTION', response.data.user.subscription);
      });
    },
    createUser: function createUser(_ref3, payload) {
      var rootState = _ref3.rootState,
          commit = _ref3.commit;

      return _axios2.default.post(rootState.config.API_URL + '/users/create', payload, {
        headers: {
          Authorization: 'Bearer ' + rootState.user.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        commit('SET_SIEMENS_ID', response.data.siemensUserId);
      });
    },
    onboarding: function onboarding(_ref4, payload) {
      var rootState = _ref4.rootState,
          state = _ref4.state,
          commit = _ref4.commit;

      return _axios2.default.post(rootState.config.API_URL + '/users/onboarding', payload, {
        headers: {
          Authorization: 'Bearer ' + rootState.user.token,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        commit('SET_GOVCLOUD', response.data.isGovcloudUser);
        commit('SET_ONBOARD', response.data.userOnboardingComplete);
      });
    }
  }
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(52);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

__webpack_require__(496);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSize($ele) {
  var $clone = $ele.cloneNode(true);
  var size = {};

  $clone.style.display = 'block';
  $clone.style.visibility = 'hidden';
  $clone.style.position = 'absolute';
  $ele.parentNode.insertBefore($clone, $ele);
  size.width = $clone.offsetWidth;
  size.height = $clone.offsetHeight;
  $clone.remove();

  return size;
}

function _setPosition($link, $dd, position, margin) {
  var refSize = getSize($link);
  var cornerPos = {};
  var outStyle = {};
  var origin = {};

  var _position = (0, _slicedToArray3.default)(position, 4),
      p1 = _position[0],
      p2 = _position[1],
      p3 = _position[2],
      p4 = _position[3];

  var rect = $link.getBoundingClientRect();
  var refPos = { top: 0, left: 0 };
  var dpSize = getSize($dd);
  var parentPosition = document.defaultView.getComputedStyle($link.offsetParent).position;

  switch (parentPosition.toLowerCase()) {
    case 'fixed':
      refPos.left = rect.left - $link.offsetParent.offsetLeft;
      refPos.top = rect.top - $link.offsetParent.offsetTop;
      break;

    case 'absolute':
      var parentRect = $link.offsetParent.getBoundingClientRect();
      refPos.left = rect.left - parentRect.left;
      refPos.top = rect.top - parentRect.top;
      break;

    default:
      refPos.left = rect.left - $link.offsetParent.offsetLeft + window.pageXOffset;
      refPos.top = rect.top - $link.offsetParent.offsetTop + window.pageYOffset;
  }

  cornerPos.left = refPos.left;
  switch (p1) {
    case 'center':
      cornerPos.left += refSize.width / 2;
      break;

    case 'right':
      cornerPos.left += refSize.width;
      break;
  }

  cornerPos.top = refPos.top;
  switch (p2) {
    case 'center':
      cornerPos.top += refSize.height / 2;
      break;
    case 'bottom':
      cornerPos.top += refSize.height;
      break;
  }

  switch (p3) {
    case 'left':
      outStyle.left = Math.round(cornerPos.left);
      origin.left = 'left';
      break;

    case 'center':
      outStyle.left = Math.round(cornerPos.left - dpSize.width / 2);
      origin.left = 'center';
      break;

    default:
      outStyle.left = Math.round(cornerPos.left - dpSize.width);
      origin.left = 'right';
  }

  switch (p4) {
    case 'top':
      outStyle.top = Math.round(cornerPos.top);
      origin.top = 'top';
      break;

    case 'center':
      outStyle.top = Math.round(cornerPos.top - dpSize.height / 2);
      origin.top = 'center';
      break;

    default:
      outStyle.top = Math.round(cornerPos.top - dpSize.height);
      origin.top = 'bottom';
  }

  outStyle.left = outStyle.left + margin[0] + 'px';
  outStyle.top = outStyle.top + margin[1] + 'px';
  outStyle.transformOrigin = origin.left + ' ' + origin.top;
  outStyle.position = 'absolute';
  return outStyle;
}

var getWindow = function getWindow() {
  return window.document;
};

exports.default = {
  name: 'VueMyDropdown',

  data: function data() {
    return {
      ddStyle: {}
    };
  },


  props: {
    visible: {
      required: true,
      type: Boolean
    },

    position: {
      required: false,
      type: Array,
      default: function _default() {
        return ['right', 'top', 'left', 'top'];
      }
    },

    animation: {
      required: false,
      type: String,
      default: 'ani-slide'
    }
  },

  methods: {
    open: function open() {
      var _this = this;

      this.setPosition();
      getWindow().addEventListener('resize', this.resizeEvent);
      setTimeout(function () {
        return getWindow().addEventListener('click', _this.clickOutEvent);
      }, 10);
    },
    close: function close() {
      getWindow().removeEventListener('resize', this.resizeEvent);
      getWindow().removeEventListener('click', this.clickOutEvent);
    },
    resizeEvent: function resizeEvent() {
      this.setPosition();
    },
    clickOutEvent: function clickOutEvent(evt) {
      var $dd = this.$el.children[1];
      if (evt.target !== $dd && !$dd.contains(evt.target)) {
        this.$emit('clickout', evt);
      }
    },
    setPosition: function setPosition() {
      var $link = this.$el.children[0];
      var $dd = this.$el.children[1];
      this.ddStyle = _setPosition($link, $dd, this.position, [0, 0]);
      this.$emit('positioned', this.ddStyle);
    }
  },

  watch: {
    visible: function visible(isVisible) {
      if (isVisible) {
        this.open();
      } else {
        this.close();
      }
    }
  },

  mounted: function mounted() {
    if (this.visible) {
      this.open();
    }
  },
  destroyed: function destroyed() {
    getWindow().removeEventListener('resize', this.resizeEvent);
    getWindow().removeEventListener('click', this.clickOutEvent);
  }
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alert = __webpack_require__(467);

var _Alert2 = _interopRequireDefault(_Alert);

var _WebGLDetect = __webpack_require__(473);

var _WebGLDetect2 = _interopRequireDefault(_WebGLDetect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  components: {
    Alert: _Alert2.default,
    'webgl-detect': _WebGLDetect2.default
  }
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _errorHandling = __webpack_require__(23);

var _errorHandling2 = _interopRequireDefault(_errorHandling);

var _BuyCredits = __webpack_require__(133);

var _BuyCredits2 = _interopRequireDefault(_BuyCredits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    'buy-credits': _BuyCredits2.default
  },
  name: 'DashBanner',
  mixins: [_errorHandling2.default],
  data: function data() {
    return {
      showModal: function showModal() {}
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['user']), (0, _vuex.mapGetters)({
    subscription: 'user/subscriptionExpiration'
  })),
  created: function created() {
    var _this = this;

    if (!this.user.loaded) {
      this.$store.dispatch('user/loadUser').then().catch(function (err) {
        _this.errorHandling(err, function () {
          _this.$store.dispatch('user/loadUser');
        });
      });
    }
  }
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {};
  },

  methods: {
    showModal: function showModal() {
      this.$modal.show('details');
    }
  }
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'callback',
  data: function data() {
    return {};
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['auth'])),
  mounted: function mounted() {
    this.auth.handleAuthentication();
  }
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(80);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(17);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(51);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(100);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(24);

var _assign2 = _interopRequireDefault(_assign);

var _from = __webpack_require__(145);

var _from2 = _interopRequireDefault(_from);

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _Banner = __webpack_require__(195);

var _Banner2 = _interopRequireDefault(_Banner);

var _SupportCanvas = __webpack_require__(460);

var _SupportCanvas2 = _interopRequireDefault(_SupportCanvas);

var _vuex = __webpack_require__(12);

var _vueMyDropdown = __webpack_require__(134);

var _vueMyDropdown2 = _interopRequireDefault(_vueMyDropdown);

var _store = __webpack_require__(49);

var _store2 = _interopRequireDefault(_store);

var _errorHandling = __webpack_require__(23);

var _errorHandling2 = _interopRequireDefault(_errorHandling);

var _helpers = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'home',
  mixins: [_errorHandling2.default],
  data: function data() {
    return {
      nestedMode: false,
      parentPathKey: null,
      parentJobConfig: {
        plateWidth: 250,
        plateHeight: 250,
        plateThickness: 30,
        precision: 0.5,
        spacing: 2,
        delta: 2,
        deltaR: 30,
        plateMode: 0,
        plateDiameter: 250
      },
      partParamsAll: true,
      files: [],
      fileIndex: 0,
      file: null,
      fileLoading: true,
      fileSupports: {},
      isPreviewSupports: true,
      failure: false,
      confirming: false,
      loading: false,
      submitting: false,
      remeshingPart: [false],
      remeshingProgress: null,
      statusMessage: null,
      checkElementSizeProcess: false,
      checkElementSizeResult: null,
      checkElementSizeError: false,
      nestedJobFlow: { isManually: false, isManualPlacement: false },
      unitvisible: false,
      unitsuppvisible: false,
      materialvisible: false,
      printervisible: false,
      structurevisible: false,
      saveSpec: false,
      showAdvanced: false,
      printerAdded: false,
      materialAdded: false,
      x: 0,
      y: 0,
      z: 0,
      nestedJobName: { last: '', current: '', invalid: false },
      deltaR: { last: '', current: '30', invalid: false },
      marginY: { last: 0, current: '0', invalid: false },
      marginX: { last: 0, current: '0', invalid: false },
      defaultFileConfig: {
        scale: { last: '', current: _helpers.defaultConfig.scaling[0], invalid: false },
        hsub: { last: '', current: _helpers.defaultConfig.hsub[0], invalid: false },
        suppSpacing_xy: { last: '', current: _helpers.defaultConfig.suppSpacing_xy[0], invalid: false },
        suppHatchSize: { last: '', current: _helpers.defaultConfig.suppHatchSize[0], invalid: false },
        supp_size_boundary: { last: '', current: _helpers.defaultConfig.supp_size_boundary[0], invalid: false },
        critical_angle: { last: '', current: _helpers.defaultConfig.critical_angle[0], invalid: false },
        isCompensate: false,
        unit: 1,
        unit_supp: 0,
        filename_supp: '',
        needRemesh: false
      },
      power: { last: '', current: _helpers.defaultConfig.Power_laser[0], invalid: false },
      diameter: { last: '', current: _helpers.defaultConfig.Diameter_laser[0], invalid: false },
      thickness: { last: '', current: _helpers.defaultConfig.layerThickness[0], invalid: false },
      speed: { last: '', current: _helpers.defaultConfig.Speed_laser[0], invalid: false },
      element: { last: '', current: _helpers.defaultConfig.elementsize[0] * 1000, invalid: false },
      tplate: { last: '', current: _helpers.defaultConfig.Tplate[0], invalid: false },
      nlaser: { last: '', current: _helpers.defaultConfig.NLaser[0], invalid: false },
      vlaserSupp: { last: '', current: _helpers.defaultConfig.VlaserSupp[0], invalid: false },
      hatch: { last: '', current: _helpers.defaultConfig.hatch[0], invalid: false },
      scalingX_material: { last: '', current: _helpers.defaultConfig.scalingX_material[0], invalid: false },
      scalingY_material: { last: '', current: _helpers.defaultConfig.scalingY_material[0], invalid: false },
      material: _helpers.defaultConfig.material[0],
      printer: 1,
      structure: 1,
      H_buildPlate: { last: '', current: _helpers.defaultConfig.H_buildPlate[0], invalid: false },
      CrashTolerance: { last: '', current: _helpers.defaultConfig.CrashTolerance[0], invalid: false },
      fragmentationSize: { last: '', current: _helpers.defaultConfig.fragmentationSize[0], invalid: false },
      tetraEps: { last: '', current: _helpers.defaultConfig.tetraEps[0], invalid: false },
      compensationScale: { last: '', current: _helpers.defaultConfig.compensationScale[0], invalid: false },
      tetraMeshSize: { last: '', current: _helpers.defaultConfig.tetraMeshSize[0], invalid: false },
      isWithoutSupport: false,
      isRepair: false,
      isStrengthSupp: false,
      isEvalFacet: true,
      isEvalVertex: true,
      isEvalEdge: true,
      isFragmentation: false,
      position: ['center', 'top', 'center', 'top'],
      units: [{ name: 'mm' }, { name: 'cm' }, { name: 'm' }, { name: 'inch' }],
      units_supp: [{ name: 'mm' }, { name: 'cm' }, { name: 'inch' }],
      structures: [{ name: 'Block', img: '/static/img/block.jpg' }, { name: 'Point', img: '/static/img/point.jpg' }, { name: 'Web', img: '/static/img/web.jpg' }, { name: 'Contour', img: '/static/img/contour.jpg' }, { name: 'Line', img: '/static/img/line.jpg' }],
      printersConfig: {},
      printerCustom: {
        name: { last: '', current: '', invalid: false, duplicate: false },
        DirectionRecoater: { last: '', current: 'width', invalid: false },
        diameter: { last: '', current: '100', invalid: false },
        power: { last: '', current: '200', invalid: false },
        speed: { last: '', current: '500', invalid: false },
        thickness: { last: '', current: '40', invalid: false },
        plateX: { last: '', current: '250', invalid: false },
        plateY: { last: '', current: '250', invalid: false },
        plateZ: { last: '', current: '250', invalid: false },
        plateThickness: { last: '', current: '30', invalid: false },
        plateMode: { last: '', current: '0', invalid: false },
        plateDiameter: { last: '', current: '250', invalid: false },
        calibrationFactor: { last: '', current: '1', invalid: false }
      },
      materialsConfig: {},
      materialCustom: {
        name: { last: '', current: '', invalid: false, duplicate: false },
        nu: { last: '', current: '', invalid: false },
        E: { last: '', current: '', invalid: false },
        E_heat: [{
          temperature: { last: '', current: '', invalid: false },
          value: { last: '', current: '', invalid: false }
        }],
        rho: { last: '', current: '', invalid: false },
        Cp: { last: '', current: '', invalid: false },
        k: { last: '', current: '', invalid: false },
        Tsolid: { last: '', current: '', invalid: false },
        Tliquid: { last: '', current: '', invalid: false },
        sigma_y: { last: '', current: '', invalid: false },
        sigma_y_heat: [{
          temperature: { last: '', current: '', invalid: false },
          value: { last: '', current: '', invalid: false }
        }],
        hsl: { last: '', current: '', invalid: false },
        alpha: { last: '', current: '', invalid: false }
      },
      suppRanges: {
        wt: { min: 0, max: 100 },
        pt: { min: 0, max: 1, step: 0.01 },
        tt: { min: 0, max: 5, step: 0.01 },
        ot: { min: 0, max: 5, step: 0.01 },
        wb: { min: 0, max: 100 },
        pb: { min: 0, max: 1, step: 0.01 },
        tb: { min: 0, max: 5, step: 0.01 },
        ob: { min: 0, max: 5, step: 0.01 },
        fraction_avg: { min: 0, max: 1, step: 0.01 }
      },
      supportParams: {
        wt: { last: '50', current: '50', invalid: false },
        pt: { last: '0.16', current: '0.16', invalid: false },
        tt: { last: '0.5', current: '0.5', invalid: false },
        ot: { last: '0.8', current: '0.8', invalid: false },
        wb: { last: '80', current: '80', invalid: false },
        pb: { last: '0.16', current: '0.16', invalid: false },
        tb: { last: '0.5', current: '0.5', invalid: false },
        ob: { last: '0.8', current: '0.8', invalid: false },
        fraction_avg: { last: '0.42', current: '0.42', invalid: false }
      },
      supportParamsDefault: {
        wt: '50',
        pt: '0.16',
        tt: '0.5',
        ot: '0.8',
        wb: '80',
        pb: '0.16',
        tb: '0.5',
        ob: '0.8',
        fraction_avg: '0.42'
      },
      uploadSupportsMessage: null
    };
  },
  components: {
    dropdown: _vueMyDropdown2.default,
    'dash-banner': _Banner2.default,
    DrawSupport: _SupportCanvas2.default
  },
  props: ['auth', 'authenticated'],
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    refreshCredits: 'user/refreshCredits'
  }), (0, _vuex.mapActions)(['uploadFile', 'refreshFiles', 'createJob', 'updateJob', 'submitJob', 'createNestedJob', 'updateNestedJob', 'deleteFile', 'getJobById', 'getNestedJobs', 'getJob', 'setNestedFileData', 'checkElementSize', 'getURLData', 'remeshPart', 'getPrintConfig']), {
    buymodal: function buymodal() {
      this.$modal.show('details');
    },
    selectSupportsFile: function selectSupportsFile() {
      document.getElementById('uploadsupports').click();
    },
    uploadSupports: function uploadSupports() {
      var _this = this;

      var uploadSupportsInput = document.getElementById('uploadsupports');
      var supportFiles = (0, _from2.default)(uploadSupportsInput.files);
      if (supportFiles.length > 0) {
        if (supportFiles.every(function (supportFile) {
          return supportFile.name.match(/.(stl)$/i);
        })) {
          this.uploadSupportsMessage = null;
          supportFiles.forEach(function (supportFile) {
            _this.fileSupports = (0, _assign2.default)((0, _defineProperty3.default)({}, supportFile.name, supportFile), _this.fileSupports);
          });
        } else {
          this.uploadSupportsMessage = 'Sorry, your file(s) is an invalid file type. Please upload only STL files at this time.';
        }
      } else {
        this.removeSupportsFile();
      }
      uploadSupportsInput.value = '';
    },
    removeSupportsFile: function removeSupportsFile(fileSupport) {
      var _this2 = this;

      document.getElementById('uploadsupports').value = '';
      this.uploadSupportsMessage = null;

      if (fileSupport) {
        this.fileSupports = (0, _keys2.default)(this.fileSupports).reduce(function (acc, curr) {
          if (curr !== fileSupport) {
            acc[curr] = _this2.fileSupports[curr];
          }
          return acc;
        }, {});
      }
    },
    calculateElementSize: function calculateElementSize() {
      var _this3 = this;

      if (this.verifyNumPositive(this.defaultFileConfig.scale) && this.verifyNumPositive(this.element) && this.verifyNumPositive(this.power) && this.verifyNumPositive(this.diameter) && this.verifyNumPositive(this.speed) && this.verifyNumPositive(this.thickness) && this.verifyNumPositive(this.nlaser) && this.verifyNumPositive(this.vlaserSupp) && this.verifyNumPositive(this.hatch) && this.verifyNumPositive(this.CrashTolerance) && this.verifyNumPositive(this.fragmentationSize) && this.verifyNumPositive(this.tetraEps) && this.verifyNumPositive(this.tetraMeshSize) && this.verifyNumPositive(this.compensationScale) && this.verifyNum(this.tplate)) {
        this.checkElementSizeProcess = true;
        this.calculateElementSizeReset();
        this.checkElementSize({
          sourceFilePathKey: this.file.pathKey,
          config: this.config
        }).then(function (response) {
          _this3.calculateElementSizeGetData(response.data.url, 1);
        });
      }
    },
    calculateElementSizeGetData: function calculateElementSizeGetData(url, attempt) {
      var _this4 = this;

      this.getURLData({ url: url }).then(function (optimizerResponse) {
        if (optimizerResponse.data && optimizerResponse.data.message) {
          _this4.checkElementSizeProcess = false;
          _this4.checkElementSizeResult = optimizerResponse.data.message;
        }
      }).catch(function (err) {
        if (err.response && err.response.status && err.response.status === 404 && attempt <= 10) {
          attempt++;
          var delay = 1500 * attempt;
          if (attempt > 3) {
            delay = 5000;
          }
          setTimeout(function () {
            _this4.calculateElementSizeGetData(url, attempt);
          }, delay);
        } else {
          _this4.checkElementSizeProcess = false;
          _this4.checkElementSizeResult = 'Something went wrong. Please try again';
          _this4.checkElementSizeError = true;
        }
      });
    },
    calculateElementSizeReset: function calculateElementSizeReset() {
      this.checkElementSizeError = false;
      this.checkElementSizeResult = null;
    },
    submit: function submit(isManually, thermalPredict) {
      var _this5 = this;

      if (this.verifyNumPositive(this.defaultFileConfig.scale) && this.verifyNumPositive(this.element) && this.verifyNumPositive(this.power) && this.verifyNumPositive(this.nlaser) && this.verifyNumPositive(this.CrashTolerance) && this.verifyNumPositive(this.fragmentationSize) && this.verifyNumPositive(this.tetraEps) && this.verifyNumPositive(this.tetraMeshSize) && this.verifyNumPositive(this.diameter) && this.verifyNumPositive(this.speed) && this.verifyNumPositive(this.thickness) && this.verifyNumPositive(this.compensationScale) && this.verifyNumPositiveFromZero(this.scalingX_material) && this.verifyNumPositiveFromZero(this.scalingY_material) && this.verifyNum(this.tplate)) {
        this.loading = true;
        this.submitting = true;
        this.saveSpecifications();

        var jobPathKey = null;
        var needRemesh = this.files[0].needRemesh && (thermalPredict || thermalPredict === false);
        var remeshPromise = needRemesh ? this.remeshSourceFile(this.files[0], 0, thermalPredict) : _promise2.default.resolve();
        return remeshPromise.then(function () {
          return _this5.processJob();
        }).then(function (response) {
          jobPathKey = response.data.jobPathKey;
          if ((0, _keys2.default)(_this5.fileSupports).length > 0) {
            _this5.statusMessage = 'Uploading supports...';
            return _promise2.default.all((0, _keys2.default)(_this5.fileSupports).map(function (fileSupport) {
              return _this5.uploadFile({
                file: _this5.fileSupports[fileSupport],
                sourceFilePathKey: _this5.file.pathKey,
                jobPathKey: response.data.jobPathKey
              });
            }));
          } else {
            return _promise2.default.resolve('Skip supports upload');
          }
        }).then(function () {
          _this5.refreshCredits();
          if (isManually) {
            _this5.$router.push({ name: 'ThreeJSViewer', params: { id: jobPathKey, type: 'input', createConfig: (0, _extends3.default)({}, _this5.config, { needRemesh: needRemesh }) }, query: { shouldPredict: thermalPredict } });
          } else {
            _this5.$router.replace('/dash/magic/' + jobPathKey);
          }
          _this5.submitting = false;
          _this5.loading = false;
          _this5.statusMessage = null;
        }).catch(function (err) {
          _this5.errorHandling(err, function () {
            _this5.submit(isManually, thermalPredict);
          });
          _this5.submitting = false;
          _this5.loading = false;
          _this5.statusMessage = null;
        });
      }
    },

    processJob: function processJob() {
      if (this.$route.params.jobPathKey) {
        this.statusMessage = 'Updating job...';
        return this.updateJob({
          jobPathKey: this.$route.params.jobPathKey,
          config: this.config,
          isArchived: false
        });
      } else {
        this.statusMessage = 'Creating job...';
        return this.createJob({
          sourceFilePathKey: this.file.pathKey,
          config: this.config
        });
      }
    },


    remeshPartAttempt: function remeshPartAttempt(url, attempt) {
      var _this6 = this;

      return new _promise2.default(function (resolve, reject) {
        _this6.getURLData({ url: url }).then(function (response) {
          if (response.data) {
            if (response.data.result === true) {
              resolve();
            } else {
              reject({ message: 'Server error' });
            }
          }
        }).catch(function (err) {
          if (err.response && err.response.status && err.response.status === 404 && attempt <= 42) {
            attempt++;
            var delay = 1500 * attempt;
            if (attempt > 15) {
              delay = 30000;
            } else if (attempt > 3) {
              delay = 10000;
            }
            setTimeout(function () {
              resolve(_this6.remeshPartAttempt(url, attempt));
            }, delay);
          } else {
            reject(err);
          }
        });
      });
    },
    remeshPartProgress: function remeshPartProgress(url, index) {
      var _this7 = this;

      if (this.remeshingPart[index]) {
        this.getURLData({ url: url }).then(function (response) {
          if (!_this7.nestedMode) {
            _this7.remeshingProgress = response.data.progress;
          } else {
            _this7.remeshingProgress = (response.data.progress + _this7.remeshingProgress) / _this7.filesNested.length;
          }
          setTimeout(function () {
            _this7.remeshPartProgress(url);
          }, 2500);
        }).catch(function () {
          console.log('Getting remesh progress...');
          setTimeout(function () {
            _this7.remeshPartProgress(url);
          }, 2500);
        });
      }
    },
    remeshSourceFile: function remeshSourceFile(file, index) {
      var _this8 = this;

      var newConf = (0, _extends3.default)({}, this.config);
      if (this.nestedMode) {
        newConf.filename = file.name;
      }
      this.statusMessage = 'Remeshing in progress...';
      this.remeshingPart[index] = true;
      return new _promise2.default(function (resolve, reject) {
        var filename = void 0;
        _this8.remeshPart({
          sourceFilePathKey: file.pathKey,
          config: newConf
        }).then(function (res) {
          filename = res.data.filename;
          _this8.remeshPartProgress(res.data.progress, index);
          return _this8.remeshPartAttempt(res.data.url, 1);
        }).then(function () {
          _this8.remeshingPart[index] = false;
          if (filename) {
            file.name = filename;
            file.needRemesh = false;
          }
          resolve();
        }).catch(function (err) {
          if (err) {
            console.log('Remeshing error');
          }
          resolve(null);
        });
      });
    },


    supportErrorMessage: function supportErrorMessage(paramname) {
      var _suppRanges$paramname = this.suppRanges[paramname],
          min = _suppRanges$paramname.min,
          max = _suppRanges$paramname.max;

      return 'Must be a number in range from ' + min + ' to ' + max;
    },
    saveSpecifications: function saveSpecifications() {
      var jobSpecification = {};
      if (this.saveSpec) {
        jobSpecification.material = this.material;
        jobSpecification.printer = this.printer;
        jobSpecification.scale = this.files[0].scale.current;
        jobSpecification.unit = this.files[0].unit;
        jobSpecification.speed = this.speed.current;
        jobSpecification.diameter = this.diameter.current;
        jobSpecification.power = this.power.current;
        jobSpecification.nlaser = this.nlaser.current;
        jobSpecification.vlaserSupp = this.vlaserSupp.current;
        jobSpecification.hatch = this.hatch.current;
        jobSpecification.CrashTolerance = this.CrashTolerance.current;
        jobSpecification.fragmentationSize = this.fragmentationSize.current;
        jobSpecification.tetraEps = this.element.tetraEps;
        jobSpecification.tetraMeshSize = this.element.tetraMeshSize;
        jobSpecification.thickness = this.thickness.current;
        jobSpecification.element = this.element.current;
        jobSpecification.critical_angle = this.files[0].critical_angle.current;
        jobSpecification.hsub = this.files[0].hsub.current;
        jobSpecification.suppSpacing_xy = this.files[0].suppSpacing_xy.current;
        jobSpecification.suppHatchSize = this.files[0].suppHatchSize.current;
        jobSpecification.supp_size_boundary = this.files[0].supp_size_boundary.current;
        jobSpecification.tplate = this.tplate.current;
        jobSpecification.isCompensate = this.files[0].isCompensate;
        jobSpecification.wt = this.supportParams.wt.current;
        jobSpecification.pt = this.supportParams.pt.current;
        jobSpecification.tt = this.supportParams.tt.current;
        jobSpecification.ot = this.supportParams.ot.current;
        jobSpecification.wb = this.supportParams.wb.current;
        jobSpecification.pb = this.supportParams.pb.current;
        jobSpecification.tb = this.supportParams.tb.current;
        jobSpecification.ob = this.supportParams.ob.current;
        jobSpecification.fraction_avg = this.supportParams.fraction_avg.current;
        jobSpecification.isRepair = this.isRepair;
        jobSpecification.isStrengthSupp = this.isStrengthSupp;
        jobSpecification.isEvalFacet = this.isEvalFacet;
        jobSpecification.isEvalVertex = this.isEvalVertex;
        jobSpecification.isEvalEdge = this.isEvalEdge;
        jobSpecification.isFragmentation = this.isFragmentation;
        jobSpecification.H_buildPlate = this.H_buildPlate.current;
        jobSpecification.scalingX_material = this.scalingX_material.current;
        jobSpecification.scalingY_material = this.scalingY_material.current;
        localStorage.setItem('jobSpecification', (0, _stringify2.default)(jobSpecification));
      } else {
        localStorage.removeItem('jobSpecification');
      }
    },
    verifyNum: function verifyNum(sNum) {
      if (isNaN(sNum.current) || sNum.current === '') {
        sNum.current = sNum.last;
        sNum.invalid = true;
        return false;
      } else {
        sNum.last = sNum.current;
        sNum.invalid = false;
        return true;
      }
    },
    verifyNumPositive: function verifyNumPositive(sNum) {
      if (isNaN(sNum.current) || sNum.current === '' || sNum.current <= 0) {
        sNum.current = sNum.last;
        sNum.invalid = true;
        return false;
      } else {
        sNum.last = sNum.current;
        sNum.invalid = false;
        return true;
      }
    },
    verifyNumPositiveFromZero: function verifyNumPositiveFromZero(sNum) {
      if (isNaN(sNum.current) || sNum.current === '' || sNum.current < 0) {
        sNum.current = sNum.last;
        sNum.invalid = true;
        return false;
      } else {
        sNum.last = sNum.current;
        sNum.invalid = false;
        return true;
      }
    },
    verifyString: function verifyString(sString, length) {
      if (sString.current.length < length) {
        sString.current = sString.last;
        sString.invalid = true;
        return false;
      } else {
        sString.last = sString.current;
        sString.invalid = false;
        return true;
      }
    },
    verifyNumBetween: function verifyNumBetween(sNum, min, max) {
      if (isNaN(sNum.current) || sNum.current === '' || sNum.current <= min || sNum.current >= max) {
        sNum.current = sNum.last;
        sNum.invalid = true;
        return false;
      } else {
        sNum.last = sNum.current;
        sNum.invalid = false;
        return true;
      }
    },
    verifyNumExactRange: function verifyNumExactRange(sNum, min, max) {
      if (isNaN(sNum.current) || sNum.current === '' || sNum.current < min || sNum.current > max) {
        sNum.current = sNum.last;
        sNum.invalid = true;
        return false;
      } else {
        sNum.last = sNum.current;
        sNum.invalid = false;
        return true;
      }
    },
    verifySuppRange: function verifySuppRange(paramname) {
      var range = function range(min, max) {
        return function (number) {
          if (number >= min && number <= max) {
            return number;
          } else if (number < min) {
            return min;
          } else if (number > max) {
            return max;
          }
        };
      };
      var _supportParams$paramn = this.supportParams[paramname],
          current = _supportParams$paramn.current,
          last = _supportParams$paramn.last;
      var _suppRanges$paramname2 = this.suppRanges[paramname],
          min = _suppRanges$paramname2.min,
          max = _suppRanges$paramname2.max;

      var numberNotNaN = isNaN(current) === false;
      var restrict = range(Number(min), Number(max));
      var allowedNum = restrict(Number(current));
      var numberIsInRange = Number(current) === allowedNum;

      if (numberNotNaN && numberIsInRange) {
        this.supportParams[paramname].last = current;
        this.supportParams[paramname].invalid = false;
      } else {
        this.supportParams[paramname].current = last;
        this.supportParams[paramname].invalid = true;
      }
    },
    verifyPrinterName: function verifyPrinterName(name) {
      if (this.printersConfig.hasOwnProperty(name.current)) {
        name.current = name.last;
        name.invalid = true;
        name.duplicate = true;
        return false;
      } else {
        name.last = name.current;
        name.invalid = false;
        name.duplicate = false;
        return true;
      }
    },
    verifyMaterialName: function verifyMaterialName(name) {
      if (this.materialsConfig.hasOwnProperty(name.current) || this.materials.find(function (material) {
        return material.name === name.current;
      })) {
        name.current = name.last;
        name.invalid = true;
        name.duplicate = true;
        return false;
      } else {
        name.last = name.current;
        name.invalid = false;
        name.duplicate = false;
        return true;
      }
    },
    verifyHeatDependentValues: function verifyHeatDependentValues(param) {
      var _this9 = this;

      var flag = true;
      param.forEach(function (item) {
        if (!(_this9.verifyNumPositive(item.temperature) && _this9.verifyNumPositive(item.value))) {
          flag = false;
        }
      });
      return flag;
    },
    parseHeatDependentValues: function parseHeatDependentValues(param, directionForward) {
      if (directionForward) {
        var result = [];
        param.forEach(function (item) {
          result.push(Number(item.temperature.current));
          result.push(Number(item.value.current));
        });
        return result;
      } else {
        var resultBack = [];
        param.forEach(function (item, index) {
          if (!resultBack[Math.floor(index / 2)]) {
            resultBack[Math.floor(index / 2)] = {};
          }
          if (index % 2 === 0) {
            resultBack[Math.floor(index / 2)].temperature = {
              last: item,
              current: item,
              invalid: false
            };
          } else {
            resultBack[Math.floor(index / 2)].value = {
              last: item,
              current: item,
              invalid: false
            };
          }
        });
        return resultBack;
      }
    },
    expHeatDependentValues: function expHeatDependentValues(param, exp) {
      param.forEach(function (item, index) {
        if (index % 2 === 1) {
          param[index] = Number(item * Math.pow(10, exp));
        }
      });
      return param;
    },
    validateNestedJob: function validateNestedJob() {
      var _this10 = this;

      var valid = true;
      valid = this.verifyString(this.nestedJobName, 2) && this.verifyNumPositive(this.power) && this.verifyNumPositive(this.nlaser) && this.verifyNumPositive(this.vlaserSupp) && this.verifyNumPositive(this.hatch) && this.verifyNumPositive(this.CrashTolerance) && this.verifyNumPositive(this.fragmentationSize) && this.verifyNumPositive(this.tetraEps) && this.verifyNumPositive(this.tetraMeshSize) && this.verifyNumPositive(this.diameter) && this.verifyNumPositive(this.thickness) && this.verifyNumPositive(this.speed) && this.verifyNumPositive(this.element);
      this.files.forEach(function (file, index) {
        if (_this10.verifyNumPositive(file.scale) && _this10.verifyNum(file.hsub) && _this10.verifyNumPositive(file.suppSpacing_xy) && _this10.verifyNumPositive(file.suppHatchSize) && _this10.verifyNumPositive(file.supp_size_boundary) && _this10.verifyNum(file.critical_angle)) {
          return;
        } else {
          valid = false;
          _this10.fileIndex = index;
        }
      });
      return valid;
    },
    materialChoice: function materialChoice(index) {
      this.material = index + 1;
      this.materialvisible = false;
      if (this.material === this.materials.length) {
        this.$modal.show('othermaterialmodal');
      }
    },
    removeMaterial: function removeMaterial(index) {
      var materialName = this.materials[index].name;
      this.materialChoice(0);
      _store2.default.commit('REMOVE_CUSTOM_MATERIAL', materialName);
      delete this.materialsConfig[materialName];
      var userMaterials = JSON.parse(localStorage.getItem('materials'));
      delete userMaterials[materialName];
      localStorage.setItem('materials', (0, _stringify2.default)(userMaterials));
    },
    unitChoice: function unitChoice(index) {
      this.files[this.fileIndex].unit = index + 1;
      this.unitvisible = false;
    },
    unitSuppChoice: function unitSuppChoice(index) {
      this.files[this.fileIndex].unit_supp = index;
      this.unitsuppvisible = false;
    },
    structureChoice: function structureChoice(index) {
      this.structure = index + 1;
      this.structurevisible = false;
    },
    printerChoice: function printerChoice(index) {
      this.printer = index + 1;
      this.printervisible = false;
      if (this.printer < this.printers.length) {
        var printerConfig = this.printersConfig[this.printers[index].name];
        this.diameter.current = printerConfig.diameter;
        this.power.current = printerConfig.power;
        this.speed.current = printerConfig.speed;
        this.thickness.current = printerConfig.thickness;
        if (this.nestedMode) {
          this.parentJobConfig.plateWidth = this.isCustomPrinter ? printerConfig.PrinterXYZ[0] : printerConfig.plateX;
          this.parentJobConfig.plateHeight = this.isCustomPrinter ? printerConfig.PrinterXYZ[1] : printerConfig.plateY;
          this.parentJobConfig.plateMode = printerConfig.plateMode;
          this.parentJobConfig.plateDiameter = Number(printerConfig.plateDiameter);
          this.parentJobConfig.plateThickness = Number(printerConfig.plateThickness);
          this.parentJobConfig.calibrationFactor = Number(printerConfig.calibrationFactor);
        }
      }
      if (this.printer === this.printers.length) {
        this.printerAdded = false;
        this.$modal.show('otherprintermodal');
      }
    },
    removePrinter: function removePrinter(index) {
      var printerName = this.printers[index].name;
      this.printerChoice(0);
      _store2.default.commit('REMOVE_CUSTOM_PRINTER', printerName);
      delete this.printersConfig[printerName];
      var userPrinters = JSON.parse(localStorage.getItem('printers'));
      delete userPrinters[printerName];
      localStorage.setItem('printers', (0, _stringify2.default)(userPrinters));
    },
    confirmAdvanced: function confirmAdvanced() {
      this.$modal.show('cautionmodal');
    },
    acceptModal: function acceptModal(showAdvanced) {
      this.$modal.hide('cautionmodal');
      this.showAdvanced = showAdvanced;
    },
    toggleRemesh: function toggleRemesh(event) {
      this.files = this.files.map(function (file) {
        file.needRemesh = event.target.checked;
        return file;
      });
    },
    toggleNestedRemesh: function toggleNestedRemesh(event, inx) {
      if (!this.partParamsAll) this.files[inx].needRemesh = event.target.checked;else this.toggleRemesh(event);
    },
    getPrinters: function getPrinters() {
      var userPrinters = localStorage.getItem('printers');
      if (userPrinters) {
        userPrinters = JSON.parse(userPrinters);
        (0, _keys2.default)(userPrinters).forEach(function (key) {
          _store2.default.commit('ADD_CUSTOM_PRINTER', { name: key });
          if (userPrinters[key].plateHeight || userPrinters[key].plateWidth) {
            userPrinters[key] = (0, _assign2.default)({}, {
              DirectionRecoater: userPrinters[key].DirectionRecoater,
              PrinterXYZ: userPrinters[key].PrinterXYZ,
              diameter: userPrinters[key].diameter,
              plateDiameter: userPrinters[key].PrinterXYZ[1],
              plateMode: userPrinters[key].plateMode,
              plateThickness: userPrinters[key].plateThickness || 30,
              power: userPrinters[key].power,
              speed: userPrinters[key].speed,
              thickness: userPrinters[key].thickness,
              calibrationFactor: userPrinters[key].calibrationFactor || 1
            });
          }
        });
        localStorage.setItem('printers', (0, _stringify2.default)(userPrinters));
        (0, _assign2.default)(this.printersConfig, userPrinters);
      }
    },
    getMaterials: function getMaterials() {
      var userMaterials = localStorage.getItem('materials');
      if (userMaterials) {
        userMaterials = JSON.parse(userMaterials);
        (0, _keys2.default)(userMaterials).forEach(function (key) {
          _store2.default.commit('ADD_CUSTOM_MATERIAL', {
            name: key,
            trademark: false,
            valid: false
          });
        });
        (0, _assign2.default)(this.materialsConfig, userMaterials);
      }
    },
    addPrinter: function addPrinter() {
      if (this.verifyPrinterName(this.printerCustom.name) && this.verifyString(this.printerCustom.name, 2) && this.verifyNumPositive(this.printerCustom.plateX) && this.verifyNumPositive(this.printerCustom.plateY) && this.verifyNumPositive(this.printerCustom.plateZ) && this.verifyNumPositive(this.printerCustom.plateThickness) && this.verifyNumPositive(this.printerCustom.diameter) && this.verifyNumPositive(this.printerCustom.power) && this.verifyNumPositive(this.printerCustom.speed) && this.verifyNumPositive(this.printerCustom.thickness) && this.verifyNumBetween(this.printerCustom.calibrationFactor, 0, 2)) {
        var userPrinters = localStorage.getItem('printers');
        if (userPrinters) {
          userPrinters = JSON.parse(userPrinters);
        } else {
          userPrinters = {};
        }
        _store2.default.commit('ADD_CUSTOM_PRINTER', { name: this.printerCustom.name.current });
        this.printersConfig[this.printerCustom.name.current] = {
          PrinterXYZ: [Number(this.printerCustom.plateX.current), Number(this.printerCustom.plateY.current), Number(this.printerCustom.plateZ.current)],
          DirectionRecoater: this.printerCustom.DirectionRecoater.current === 'width' ? [-1, 0, 0] : [0, -1, 0],
          diameter: this.printerCustom.diameter.current,
          power: this.printerCustom.power.current,
          speed: this.printerCustom.speed.current,
          thickness: this.printerCustom.thickness.current,
          plateMode: 0,
          plateDiameter: Number(this.printerCustom.plateY.current),
          plateThickness: Number(this.printerCustom.plateThickness.current),
          calibrationFactor: Number(this.printerCustom.calibrationFactor.current)
        };
        userPrinters[this.printerCustom.name.current] = this.printersConfig[this.printerCustom.name.current];
        localStorage.setItem('printers', (0, _stringify2.default)(userPrinters));
        this.printerCustom = {
          name: { last: '', current: '', invalid: false, duplicate: false },
          DirectionRecoater: { last: '', current: 'width', invalid: false },
          diameter: { last: '', current: '100', invalid: false },
          power: { last: '', current: '200', invalid: false },
          speed: { last: '', current: '500', invalid: false },
          thickness: { last: '', current: '40', invalid: false },
          plateX: { last: '', current: '250', invalid: false },
          plateY: { last: '', current: '250', invalid: false },
          plateZ: { last: '', current: '250', invalid: false },
          plateThickness: { last: '', current: '30', invalid: false },
          plateMode: { last: '', current: '0', invalid: false },
          plateDiameter: { last: '', current: '250', invalid: false },
          calibrationFactor: { last: '', current: '1', invalid: false }
        };
        this.printerAdded = true;
        this.printerChoice(this.printers.length - 2);
        this.$modal.hide('otherprintermodal');
      }
    },
    addMaterial: function addMaterial(skipValidation) {
      if (skipValidation || this.verifyMaterialName(this.materialCustom.name) && this.verifyString(this.materialCustom.name, 2) && this.verifyNumPositive(this.materialCustom.nu) && this.verifyNumPositive(this.materialCustom.E) && this.verifyHeatDependentValues(this.materialCustom.E_heat) && this.verifyNumPositive(this.materialCustom.rho) && this.verifyNumPositive(this.materialCustom.Cp) && this.verifyNumPositive(this.materialCustom.k) && this.verifyNumPositive(this.materialCustom.Tsolid) && this.verifyNumPositive(this.materialCustom.Tliquid) && this.verifyNumPositive(this.materialCustom.sigma_y) && this.verifyHeatDependentValues(this.materialCustom.sigma_y_heat) && this.verifyNumPositive(this.materialCustom.hsl) && this.verifyNumPositive(this.materialCustom.alpha)) {
        var userMaterials = localStorage.getItem('materials');
        if (userMaterials) {
          userMaterials = JSON.parse(userMaterials);
        } else {
          userMaterials = {};
        }
        _store2.default.commit('ADD_CUSTOM_MATERIAL', {
          name: this.materialCustom.name.current,
          trademark: false,
          valid: false
        });
        this.materialsConfig[this.materialCustom.name.current] = {
          nu: this.materialCustom.nu.current,
          E: this.materialCustom.E.current,
          E_heat: this.parseHeatDependentValues(this.materialCustom.E_heat, true),
          rho: this.materialCustom.rho.current,
          Cp: this.materialCustom.Cp.current,
          k: this.materialCustom.k.current,
          Tsolid: this.materialCustom.Tsolid.current,
          Tliquid: this.materialCustom.Tliquid.current,
          sigma_y: this.materialCustom.sigma_y.current,
          sigma_y_heat: this.parseHeatDependentValues(this.materialCustom.sigma_y_heat, true),
          hsl: this.materialCustom.hsl.current,
          alpha: this.materialCustom.alpha.current
        };
        userMaterials[this.materialCustom.name.current] = this.materialsConfig[this.materialCustom.name.current];
        localStorage.setItem('materials', (0, _stringify2.default)(userMaterials));
        this.materialCustom = {
          name: { last: '', current: '', invalid: false, duplicate: false },
          nu: { last: '', current: '', invalid: false },
          E: { last: '', current: '', invalid: false },
          E_heat: [{
            temperature: { last: '', current: '', invalid: false },
            value: { last: '', current: '', invalid: false }
          }],
          rho: { last: '', current: '', invalid: false },
          Cp: { last: '', current: '', invalid: false },
          k: { last: '', current: '', invalid: false },
          Tsolid: { last: '', current: '', invalid: false },
          Tliquid: { last: '', current: '', invalid: false },
          sigma_y: { last: '', current: '', invalid: false },
          sigma_y_heat: [{
            temperature: { last: '', current: '', invalid: false },
            value: { last: '', current: '', invalid: false }
          }],
          hsl: { last: '', current: '', invalid: false },
          alpha: { last: '', current: '', invalid: false }
        };
        this.materialAdded = true;
        this.$modal.hide('othermaterialmodal');
      }
    },
    addMaterialHeatDependentValue: function addMaterialHeatDependentValue(value) {
      value.push({
        temperature: { last: '', current: '', invalid: false },
        value: { last: '', current: '', invalid: false }
      });
    },
    removeMaterialHeatDependentValue: function removeMaterialHeatDependentValue(value, index) {
      value.splice(index, 1);
    },
    beforeClosePrinter: function beforeClosePrinter() {
      if (this.printerAdded) {
        this.printer = this.printers.length - 1;
      } else {
        this.printer = 1;
      }
    },
    beforeCloseMaterial: function beforeCloseMaterial() {
      if (this.materialAdded) {
        this.material = this.materials.length - 1;
      } else {
        this.material = 1;
      }
    },
    restoreJob: function restoreJob(job) {
      this.restorePrinterConfig(job.config);
      this.printer = this.printers.findIndex(function (printer) {
        return printer.name === job.config.printer;
      }) + 1;
      this.printerChoice(this.printer - 1);
      this.restoreMaterialConfig(job.config);
      if (job.config.material_name) {
        this.material = this.materials.findIndex(function (material) {
          return material.name === job.config.material_name;
        }) + 1;
      } else {
        this.material = job.config.material[0];
      }
      this.restoreJobConfig(job.config);
    },
    restorePrinterConfig: function restorePrinterConfig(config) {
      var printerIndex = this.printers.findIndex(function (printer) {
        return printer.name === config.printer;
      }) + 1;
      if (printerIndex > 0) {
        this.speed.current = config.Speed_laser[0];
        this.diameter.current = config.Diameter_laser[0];
        this.power.current = config.Power_laser[0];
        this.thickness.current = config.layerThickness[0];
      } else {
        this.printerCustom.name.current = config.printer;
        this.printerCustom.plateX.current = config.PrinterXYZ[0];
        this.printerCustom.plateY.current = config.PrinterXYZ[1];
        this.printerCustom.plateZ.current = config.PrinterXYZ[2];
        this.printerCustom.plateThickness = config.plateThickness && config.plateThickness[0] || 30;
        this.printerCustom.DirectionRecoater.current = config.DirectionRecoater && config.DirectionRecoater[0] ? 'width' : 'length';
        this.printerCustom.diameter.current = config.Diameter_laser[0];
        this.printerCustom.power.current = config.Power_laser[0];
        this.printerCustom.speed.current = config.Speed_laser[0];
        this.printerCustom.thickness.current = config.layerThickness[0];
        this.printerCustom.calibrationFactor.current = config.calibrationFactor && config.calibrationFactor[0] || 1;
        this.addPrinter();
      }
    },
    restoreMaterialConfig: function restoreMaterialConfig(config) {
      var materialIndex = this.materials.findIndex(function (material) {
        return material.name === config.material_name;
      }) + 1;
      if (materialIndex === 0 && config.material_name) {
        this.materialCustom.name.current = config.material_name;
        this.materialCustom.nu.current = config.nu[0];
        this.materialCustom.E.current = config.E[0];
        this.materialCustom.E_heat = this.parseHeatDependentValues(config.E_heat, false);
        this.materialCustom.rho.current = config.rho[0];
        this.materialCustom.Cp.current = config.Cp[0];
        this.materialCustom.k.current = config.k[0];
        this.materialCustom.Tsolid.current = config.Tsolid[0];
        this.materialCustom.Tliquid.current = config.Tliquid[0];
        this.materialCustom.sigma_y.current = config.sigma_y[0];
        this.materialCustom.sigma_y_heat = this.parseHeatDependentValues(config.sigma_y_heat, false);
        this.materialCustom.hsl.current = Number(config.hsl[0] * Math.pow(10, -3));
        this.materialCustom.alpha.current = Number(config.alpha[0] * Math.pow(10, 6));
        this.addMaterial(true);
      }
    },
    restoreJobConfig: function restoreJobConfig(config, def) {
      this.defaultFileConfig.scale.current = config.scaling[0];
      this.defaultFileConfig.unit = this.units.findIndex(function (unit) {
        return unit.name === config.unit;
      }) + 1;
      this.element.current = config.elementsize[0] * 1000;
      this.element.last = config.elementsize[0] * 1000;
      this.defaultFileConfig.critical_angle.current = config.critical_angle[0];
      this.defaultFileConfig.hsub.current = config.hsub[0];
      this.defaultFileConfig.suppSpacing_xy.current = config.suppSpacing_xy[0];
      this.defaultFileConfig.suppHatchSize.current = config.suppHatchSize[0];
      this.defaultFileConfig.supp_size_boundary.current = config.supp_size_boundary[0];

      this.speed.current = config.Speed_laser;
      this.diameter.current = config.Diameter_laser;
      this.power.current = config.Power_laser;
      this.thickness.current = config.layerThickness;

      if (config.Wt && config.Wt[0]) {
        this.supportParams.wt.current = config.Wt[0] * 100;
      }
      if (config.Pt && config.Pt[0]) {
        this.supportParams.pt.current = config.Pt[0];
      }
      if (config.Tt && config.Tt[0]) {
        this.supportParams.tt.current = config.Tt[0];
      }
      if (config.Ot && config.Ot[0]) {
        this.supportParams.ot.current = config.Ot[0];
      }
      if (config.Wb && config.Wb[0]) {
        this.supportParams.wb.current = config.Wb[0] * 100;
      }
      if (config.Pb && config.Pb[0]) {
        this.supportParams.pb.current = config.Pb[0];
      }
      if (config.Tb && config.Tb[0]) {
        this.supportParams.tb.current = config.Tb[0];
      }
      if (config.Ob && config.Ob[0]) {
        this.supportParams.ob.current = config.Ob[0];
      }
      if (config.fraction_avg && config.fraction_avg[0]) {
        this.supportParams.fraction_avg.current = config.fraction_avg[0];
      }
      if (config.Tplate && config.Tplate[0]) {
        this.tplate.current = config.Tplate[0];
      }
      if (config.isCompensate && config.isCompensate.length > 0) {
        this.defaultFileConfig.isCompensate = config.isCompensate[0] > 0;
      }
      if (config.filename_supp && config.filename_supp.length > 0) {
        this.fileSupports = config.filename_supp.reduce(function (acc, curr) {
          acc[curr] = true;
          return acc;
        }, {});
        this.defaultFileConfig.filename_supp = config.filename_supp;
        this.defaultFileConfig.unit_supp = this.units_supp.findIndex(function (unit) {
          return unit.name === config.unit_supp;
        });
      }

      if (config.scalingX_material && config.scalingX_material.length > 0) {
        this.scalingX_material.current = config.scalingX_material[0];
      }
      if (config.scalingY_material && config.scalingY_material.length > 0) {
        this.scalingY_material.current = config.scalingY_material[0];
      }

      if (config.NLaser && config.NLaser[0]) {
        this.nlaser.current = config.NLaser[0];
      }

      if (config.VlaserSupp && config.VlaserSupp[0]) {
        this.vlaserSupp.current = config.VlaserSupp[0];
      }

      if (config.hatch && config.hatch[0]) {
        this.hatch.current = config.hatch[0];
      }

      if (config.hasOwnProperty('isRepair')) {
        this.isRepair = config.isRepair;
      }
      if (config.hasOwnProperty('isStrengthSupp')) {
        this.isStrengthSupp = !!config.isStrengthSupp[0];
      }
      if (config.hasOwnProperty('isEvalFacet')) {
        this.isEvalFacet = config.isEvalFacet;
      }

      if (config.hasOwnProperty('isEvalVertex')) {
        this.isEvalVertex = config.isEvalVertex;
      }

      if (config.hasOwnProperty('isEvalEdge')) {
        this.isEvalEdge = config.isEvalEdge;
      }

      if (config.hasOwnProperty('isFragmentation')) {
        this.isFragmentation = config.isFragmentation;
      }

      if (config.H_buildPlate && config.H_buildPlate.length > 0) {
        this.H_buildPlate.current = config.H_buildPlate[0];
      }

      if (config.CrashTolerance && config.CrashTolerance.length > 0) {
        this.CrashTolerance.current = config.CrashTolerance[0];
      }

      if (config.fragmentationSize && config.fragmentationSize.length > 0) {
        this.fragmentationSize.current = config.fragmentationSize[0];
      }

      if (config.compensationScale && config.compensationScale.length > 0) {
        this.compensationScale.current = config.compensationScale[0];
      }

      if (config.tetraEps && config.tetraEps.length > 0) {
        this.tetraEps.current = config.tetraEps[0];
      }
      if (config.tetraMeshSize && config.tetraMeshSize.length > 0) {
        this.tetraMeshSize.current = config.tetraMeshSize[0];
      }

      this.isWithoutSupport = config.isSupport && !config.isSupport[0];
    },
    restoreJobSpecification: function restoreJobSpecification(specification) {
      this.saveSpec = true;
      if (specification.printer >= this.printers.length) {
        specification.printer = 1;
      }
      if (specification.material >= this.materials.length) {
        specification.material = 1;
      }
      this.printer = specification.printer;
      this.material = specification.material;
      this.speed.current = specification.speed;
      this.diameter.current = specification.diameter;
      this.power.current = specification.power;
      this.thickness.current = specification.thickness;
      this.element.current = specification.element;
      this.defaultFileConfig.scale.current = specification.scale;
      this.defaultFileConfig.hsub.current = specification.hsub;
      this.defaultFileConfig.suppSpacing_xy.current = specification.suppSpacing_xy;
      this.defaultFileConfig.suppHatchSize.current = specification.suppHatchSize;
      this.defaultFileConfig.supp_size_boundary.current = specification.supp_size_boundary;
      this.defaultFileConfig.critical_angle.current = specification.critical_angle;
      this.defaultFileConfig.unit = specification.unit;
      if (specification.wt) {
        this.supportParams.wt.current = specification.wt;
      }
      if (specification.pt) {
        this.supportParams.pt.current = specification.pt;
      }
      if (specification.tt) {
        this.supportParams.tt.current = specification.tt;
      }
      if (specification.ot) {
        this.supportParams.ot.current = specification.ot;
      }
      if (specification.wb) {
        this.supportParams.wb.current = specification.wb;
      }
      if (specification.pb) {
        this.supportParams.pb.current = specification.pb;
      }
      if (specification.tb) {
        this.supportParams.tb.current = specification.tb;
      }
      if (specification.ob) {
        this.supportParams.ob.current = specification.ob;
      }
      if (specification.fraction_avg) {
        this.supportParams.fraction_avg.current = specification.fraction_avg;
      }
      if (specification.tplate) {
        this.tplate.current = specification.tplate;
      }
      if (specification.hasOwnProperty('isCompensate')) {
        this.defaultFileConfig.isCompensate = false;
      }
      if (specification.nlaser) {
        this.nlaser.current = specification.nlaser;
      }
      if (specification.vlaserSupp) {
        this.vlaserSupp.current = specification.vlaserSupp;
      }
      if (specification.hatch) {
        this.hatch.current = specification.hatch;
      }

      if (specification.hasOwnProperty('isRepair')) {
        this.isRepair = specification.isRepair;
      }

      if (specification.hasOwnProperty('isEvalFacet')) {
        this.isEvalFacet = specification.isEvalFacet;
      }
      if (specification.hasOwnProperty('isStrengthSupp')) {
        this.isStrengthSupp = !!specification.isStrengthSupp[0];
      }
      if (specification.hasOwnProperty('isEvalVertex')) {
        this.isEvalVertex = specification.isEvalVertex;
      }

      if (specification.hasOwnProperty('isEvalEdge')) {
        this.isEvalEdge = specification.isEvalEdge;
      }

      if (specification.hasOwnProperty('isFragmentation')) {
        this.isFragmentation = specification.isFragmentation;
      }

      if (specification.hasOwnProperty('H_buildPlate')) {
        this.H_buildPlate.current = specification.H_buildPlate;
      }

      if (specification.hasOwnProperty('scalingX_material')) {
        this.scalingX_material.current = specification.scalingX_material;
      }

      if (specification.hasOwnProperty('scalingY_material')) {
        this.scalingY_material.current = specification.scalingY_material;
      }

      if (specification.hasOwnProperty('CrashTolerance')) {
        this.CrashTolerance.current = specification.CrashTolerance;
      }
      if (specification.hasOwnProperty('fragmentationSize')) {
        this.fragmentationSize.current = specification.fragmentationSize;
      }
      if (specification.hasOwnProperty('tetraEps')) {
        this.tetraEps.current = specification.tetraEps;
      }
      if (specification.hasOwnProperty('compensationScale')) {
        this.compensationScale = specification.compensationScale;
      }
      if (specification.hasOwnProperty('tetraMeshSize')) {
        this.tetraMeshSize.current = specification.tetraMeshSize;
      }
    },
    filesPrepare: function filesPrepare(keys) {
      var _this11 = this;

      var files = [];
      keys.forEach(function (key) {
        if (_this11.parentPathKey) {
          var defaultFileConfig = {
            scale: { last: '', current: _this11.filesNested[key].config.scaling[0], invalid: false },
            hsub: { last: '', current: _this11.filesNested[key].config.hsub[0], invalid: false },
            suppSpacing_xy: { last: '', current: _this11.filesNested[key].config.suppSpacing_xy[0], invalid: false },
            suppHatchSize: { last: '', current: _this11.filesNested[key].config.suppHatchSize[0], invalid: false },
            supp_size_boundary: { last: '', current: _this11.filesNested[key].config.supp_size_boundary[0], invalid: false },
            critical_angle: { last: '', current: _this11.filesNested[key].config.critical_angle[0], invalid: false },
            unit: _this11.units.findIndex(function (unit) {
              return unit.name === _this11.filesNested[key].config.unit;
            }) + 1,
            isCompensate: _this11.filesNested[key].config.isCompensate[0]
          };
          files.push(JSON.parse((0, _stringify2.default)((0, _assign2.default)({}, _this11.filesNested[key], defaultFileConfig))));
          _this11.partParamsAll = false;
        } else {
          files.push(JSON.parse((0, _stringify2.default)((0, _assign2.default)({}, _this11.filesNested[key], _this11.defaultFileConfig))));
        }
      });
      return files;
    },
    switchFile: function switchFile(index) {
      this.fileIndex = index;
    },
    switchPartParamAll: function switchPartParamAll() {
      this.switchFile(0);
      if (!this.partParamsAll) {
        this.copyPartParamAll();
      }
    },
    copyPartParamAll: function copyPartParamAll() {
      var _this12 = this;

      this.files.forEach(function (file) {
        file.scale.current = _this12.files[0].scale.current;
        file.hsub.current = _this12.files[0].hsub.current;
        file.suppSpacing_xy.current = _this12.files[0].suppSpacing_xy.current;
        file.suppHatchSize.current = _this12.files[0].suppHatchSize.current;
        file.supp_size_boundary.current = _this12.files[0].supp_size_boundary.current;
        file.critical_angle.current = _this12.files[0].critical_angle.current;
        file.isCompensate = _this12.files[0].isCompensate;
        file.unit = _this12.files[0].unit;
        file.needRemesh = _this12.files[0].needRemesh;
      });
    },
    checkNestedMode: function checkNestedMode() {
      return this.$route.name === 'NestedCreate' || this.$route.name === 'NestedCreateById';
    },
    getNestedJobsFromState: function getNestedJobsFromState() {
      if ((0, _keys2.default)(this.filesNested).length > 0) {
        this.files = this.filesPrepare((0, _keys2.default)(this.filesNested));
        this.switchFile(0);
      } else {
        this.$router.replace({ name: 'Dash' });
      }
    },
    getNestedJobsRestore: function getNestedJobsRestore() {
      var _this13 = this;

      return new _promise2.default(function (resolve, reject) {
        return _this13.getJob(_this13.parentPathKey).then(function (response) {
          if (response && response.data.Job && response.data.Job.hasOwnProperty('nestedJobName')) {
            _this13.nestedJobName.current = response.data.Job.nestedJobName;
            return _this13.getNestedJobs(_this13.parentPathKey);
          } else {
            _this13.$router.push({ name: 'Dash' });
          }
        }).then(function (response) {
          if (response && response.data.allJobs && response.data.allJobs.length > 0) {
            _this13.setNestedFileData(response.data.allJobs);
            resolve(response.data.allJobs);
          } else {
            reject();
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    getMaterailConfig: function getMaterailConfig() {
      return !this.isCustomMaterial ? {
        'material': this.material,
        'material_name': this.materials[this.material - 1].name,
        'nu': [],
        'E': [],
        'E_heat': [],
        'rho': [],
        'Cp': [],
        'k': [],
        'Tsolid': [],
        'Tliquid': [],
        'sigma_y': [],
        'sigma_y_heat': [],
        'hsl': [],
        'alpha': []
      } : {
        'material': this.material,
        'material_name': this.materials[this.material - 1].name,
        'nu': [Number(this.materialsConfig[this.materials[this.material - 1].name].nu)],
        'E': [Number(this.materialsConfig[this.materials[this.material - 1].name].E)],
        'E_heat': this.materialsConfig[this.materials[this.material - 1].name].E_heat,
        'rho': [Number(this.materialsConfig[this.materials[this.material - 1].name].rho)],
        'Cp': [Number(this.materialsConfig[this.materials[this.material - 1].name].Cp)],
        'k': [Number(this.materialsConfig[this.materials[this.material - 1].name].k)],
        'Tsolid': [Number(this.materialsConfig[this.materials[this.material - 1].name].Tsolid)],
        'Tliquid': [Number(this.materialsConfig[this.materials[this.material - 1].name].Tliquid)],
        'sigma_y': [Number(this.materialsConfig[this.materials[this.material - 1].name].sigma_y)],
        'sigma_y_heat': this.materialsConfig[this.materials[this.material - 1].name].sigma_y_heat,
        'hsl': [Number(this.materialsConfig[this.materials[this.material - 1].name].hsl * Math.pow(10, 3))],
        'alpha': [Number(this.materialsConfig[this.materials[this.material - 1].name].alpha * Math.pow(10, -6))]
      };
    },
    goBack: function goBack() {
      if (this.parentPathKey) {
        this.$router.push({ name: 'NestedQuantityById', params: { id: this.parentPathKey } });
      } else {
        this.$router.push({ name: 'NestedQuantity' });
      }
    },
    changeNestedJobsFlow: function changeNestedJobsFlow() {
      if (!this.nestedJobFlow.isManually) {
        this.nestedJobFlow.isManualPlacement = false;
      }
    },
    goNext: function goNext() {
      var _this14 = this;

      if (this.validateNestedJob()) {
        this.submitting = true;
        var material = this.getMaterailConfig();
        var nestedJobData = {
          nestedJobs: [],
          nestedJobName: this.nestedJobName.current,
          config: (0, _extends3.default)({
            plateWidth: [this.parentJobConfig.plateWidth],
            plateHeight: [this.parentJobConfig.plateHeight],
            plateThickness: [this.parentJobConfig.plateThickness],
            precision: [this.parentJobConfig.precision],
            spacing: [this.parentJobConfig.spacing],
            delta: [this.parentJobConfig.delta],
            deltaR: [Number(this.deltaR.current)],
            manualPlacement: this.nestedJobFlow.isManualPlacement,
            plateMode: [this.parentJobConfig.plateMode],
            plateDiameter: [this.parentJobConfig.plateDiameter],
            Speed_laser: [Number(this.speed.current)],
            VlaserSupp: [Number(this.vlaserSupp.current)],
            hatch: [Number(this.hatch.current)],
            calibrationFactor: [Number(this.parentJobConfig.calibrationFactor) || 1],
            Nlaser: [Number(this.nlaser.current)],
            printer: this.printers[this.printer - 1].name,
            marginX: [Number(this.marginX.current)],
            marginY: [Number(this.marginY.current)]
          }, material)
        };
        var remeshPromises = [];
        this.files.forEach(function (file, index) {
          var needRemesh = file.needRemesh && !_this14.partParamsAll || _this14.partParamsAll && _this14.files[_this14.fileIndex].needRemesh;
          needRemesh && remeshPromises.push(_this14.remeshSourceFile(file, index));
        });
        _promise2.default.all(remeshPromises).then(function (res) {
          if (_this14.partParamsAll) {
            _this14.copyPartParamAll();
          }
          _store2.default.commit('SET_NESTED_FILE_NAME', _this14.nestedJobName.current);
          var currentIndex = _this14.fileIndex;
          _this14.files.forEach(function (file, index) {
            _this14.fileIndex = index;
            _store2.default.commit('SET_NESTED_FILE_CONFIG', {
              pathKey: file.pathKey,
              config: _this14.config
            });
            if (_this14.parentPathKey) {
              nestedJobData.nestedJobs.push({
                config: _this14.config,
                importance: file.importance,
                quantity: file.quantity,
                jobPathKey: file.jobPathKey,
                targetVersion: _this14.$store.state.config.TARGET_VERSION
              });
            } else {
              nestedJobData.nestedJobs.push({
                config: _this14.config,
                importance: file.importance,
                quantity: file.quantity,
                sourceFilePathKey: file.pathKey,
                targetVersion: _this14.$store.state.config.TARGET_VERSION
              });
            }
          });
          _this14.fileIndex = currentIndex;
          var flow = function flow(id) {
            var isManually = _this14.nestedJobFlow.isManually;

            var params = { id: id, type: 'input', createConfig: _this14.config };
            if (!isManually) {
              return _this14.$router.push({ name: 'NestedMagicById', params: params });
            }
            _this14.$router.push({ name: 'ThreeJSViewer', params: params });
          };
          if (_this14.parentPathKey) {
            nestedJobData.parentPathKey = _this14.parentPathKey;
            _this14.updateNestedJob(nestedJobData).then(function (response) {
              return flow(_this14.parentPathKey);
            }).catch(function (err) {
              _this14.errorHandling(err, function () {
                _this14.updateNestedJob(nestedJobData);
              });
              _this14.submitting = false;
            });
          } else {
            _this14.createNestedJob(nestedJobData).then(function (response) {
              return flow(response.data.jobPathKey);
            }).catch(function (err) {
              _this14.errorHandling(err, function () {
                _this14.createNestedJob(nestedJobData);
              });
              _this14.submitting = false;
            });
          }
        });
      }
    }
  }),
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['user', 'filesNested']), (0, _vuex.mapGetters)(['jobById', 'materials', 'predefinedMaterials', 'printers', 'predefinedPrinters']), (0, _vuex.mapGetters)({
    subscription: 'user/subscriptionExpiration'
  }), {
    config: function config() {
      var currentConfig = {
        'N_part': [],
        'filename': this.files[this.fileIndex].name,
        'printer': this.printers[this.printer - 1].name,
        'unit': this.units[this.files[this.fileIndex].unit - 1].name,
        'scaling': [Number(this.files[this.fileIndex].scale.current)],
        'material': [Number(this.material)],
        'RotationalAngle': [Number(this.x), Number(this.y), Number(this.z)],
        'Weights': [0.5, 0.5, 0.5],
        'layerThickness': [Number(this.thickness.current)],
        'elementsize': [Number(this.element.current) / 1000],
        'Power_laser': [Number(this.power.current)],
        'Diameter_laser': [Number(this.diameter.current)],
        'Speed_laser': [Number(this.speed.current)],
        'suppSpacing_xy': [Number(this.files[this.fileIndex].suppSpacing_xy.current)],
        'suppHatchSize': [Number(this.files[this.fileIndex].suppHatchSize.current)],
        'supp_size_boundary': [Number(this.files[this.fileIndex].supp_size_boundary.current)],
        'hsub': [Number(this.files[this.fileIndex].hsub.current)],
        'critical_angle': [Number(this.files[this.fileIndex].critical_angle.current)],
        'Tplate': [Number(this.tplate.current)],
        'scalingX_material': [Number(this.scalingX_material.current)],
        'scalingY_material': [Number(this.scalingY_material.current)],
        'isCompensate': [Number(this.files[this.fileIndex].isCompensate)],
        'isSupport': [Number(!this.isWithoutSupport)],
        'isStrengthSupp': [Number(this.isStrengthSupp)],
        'isHeatTreatment': true,
        'isMinPeeling': false,
        'NLaser': [Number(this.nlaser.current)],
        'VlaserSupp': [Number(this.vlaserSupp.current)],
        'hatch': [Number(this.hatch.current)],
        'MaxDist': [-1],
        'AllowedFaces': [],
        'RestrictedFaces': [],
        'AngleRestriction': [],
        'Wt': [Number(this.supportParams.wt.current) / 100],
        'Pt': [Number(this.supportParams.pt.current)],
        'Tt': [Number(this.supportParams.tt.current)],
        'Ot': [Number(this.supportParams.ot.current)],
        'Wb': [Number(this.supportParams.wb.current) / 100],
        'Pb': [Number(this.supportParams.pb.current)],
        'Tb': [Number(this.supportParams.tb.current)],
        'Ob': [Number(this.supportParams.ob.current)],
        'isRepair': this.isRepair,
        'isEvalFacet': this.isEvalFacet,
        'isEvalVertex': this.isEvalVertex,
        'isEvalEdge': this.isEvalEdge,
        'isFragmentation': this.isFragmentation,
        'H_buildPlate': [Number(this.H_buildPlate.current)],
        'CrashTolerance': [Number(this.CrashTolerance.current)],
        'fragmentationSize': [Number(this.fragmentationSize.current)],
        'tetraEps': [Number(this.tetraEps.current)],
        'tetraMeshSize': [Number(this.tetraMeshSize.current)],
        'fraction_avg': [Number(this.supportParams.fraction_avg.current)],
        'PrinterXYZ': [],
        'DirectionRecoater': [],
        'plateThickness': [],
        'material_name': this.materials[this.material - 1].name,
        'nu': [],
        'E': [],
        'E_heat': [],
        'rho': [],
        'Cp': [],
        'k': [],
        'Tsolid': [],
        'Tliquid': [],
        'sigma_y': [],
        'sigma_y_heat': [],
        'hsl': [],
        'alpha': [],
        'filename_supp': [],
        'needRemesh': this.files[this.fileIndex].needRemesh,
        'isHideSupports': !this.isPreviewSupports,
        'compensationScale': [Number(this.compensationScale.current)]
      };
      if ((0, _keys2.default)(this.fileSupports).length > 0) {
        currentConfig.Wt = [Number(this.supportParamsDefault.wt) / 100];
        currentConfig.Pt = [Number(this.supportParamsDefault.pt)];
        currentConfig.Tt = [Number(this.supportParamsDefault.tt)];
        currentConfig.Ot = [Number(this.supportParamsDefault.ot)];
        currentConfig.Wb = [Number(this.supportParamsDefault.wb) / 100];
        currentConfig.Pb = [Number(this.supportParamsDefault.pb)];
        currentConfig.Tb = [Number(this.supportParamsDefault.tb)];
        currentConfig.Ob = [Number(this.supportParamsDefault.ob)];
        currentConfig.fraction_avg = [Number(this.supportParamsDefault.fraction_avg)];
      }
      if (this.isCustomPrinter) {
        currentConfig.PrinterXYZ = this.printersConfig[this.printers[this.printer - 1].name].PrinterXYZ;
        currentConfig.DirectionRecoater = this.printersConfig[this.printers[this.printer - 1].name].DirectionRecoater;
        currentConfig.plateThickness = [Number(this.printersConfig[this.printers[this.printer - 1].name].plateThickness)];
      }
      if (this.isCustomMaterial) {
        currentConfig.nu = [Number(this.materialsConfig[this.materials[this.material - 1].name].nu)];
        currentConfig.E = [Number(this.materialsConfig[this.materials[this.material - 1].name].E)];
        currentConfig.E_heat = this.materialsConfig[this.materials[this.material - 1].name].E_heat;
        currentConfig.rho = [Number(this.materialsConfig[this.materials[this.material - 1].name].rho)];
        currentConfig.Cp = [Number(this.materialsConfig[this.materials[this.material - 1].name].Cp)];
        currentConfig.k = [Number(this.materialsConfig[this.materials[this.material - 1].name].k)];
        currentConfig.Tsolid = [Number(this.materialsConfig[this.materials[this.material - 1].name].Tsolid)];
        currentConfig.Tliquid = [Number(this.materialsConfig[this.materials[this.material - 1].name].Tliquid)];
        currentConfig.sigma_y = [Number(this.materialsConfig[this.materials[this.material - 1].name].sigma_y)];
        currentConfig.sigma_y_heat = this.materialsConfig[this.materials[this.material - 1].name].sigma_y_heat;
        currentConfig.hsl = [Number(this.materialsConfig[this.materials[this.material - 1].name].hsl * Math.pow(10, 3))];
        currentConfig.alpha = [Number(this.materialsConfig[this.materials[this.material - 1].name].alpha * Math.pow(10, -6))];
      }
      if (this.isWithoutSupport) {
        currentConfig.hsub = [0];
      }
      if (this.nestedMode) {
        currentConfig.N_part = [this.numberOfParts];
      }
      if ((0, _keys2.default)(this.fileSupports).length > 0 && !this.isWithoutSupport) {
        currentConfig.filename_supp = (0, _keys2.default)(this.fileSupports);
        currentConfig.unit_supp = this.units_supp[this.files[0].unit_supp].name;
      } else {
        currentConfig.filename_supp = [];
        currentConfig.unit_supp = 'mm';
      }
      return currentConfig;
    },
    numberOfParts: function numberOfParts() {
      var _this15 = this;

      var count = 0;
      (0, _keys2.default)(this.filesNested).forEach(function (fileKey) {
        count += Number(_this15.filesNested[fileKey].quantity);
      });
      return count;
    },
    isCustomPrinter: function isCustomPrinter() {
      return this.printer > this.predefinedPrinters;
    },
    isCustomMaterial: function isCustomMaterial() {
      return this.material > this.predefinedMaterials;
    },
    isValidMaterial: function isValidMaterial() {
      return this.materials[this.material - 1].valid;
    }
  }),
  created: function created() {
    var _this16 = this;

    this.getPrintConfig().then(function (_ref) {
      var data = _ref.data;

      _store2.default.commit('SET_MATERIALS', data.config.materials);
      _store2.default.commit('SET_PRINTERS', data.config.printers);
      _this16.printersConfig = data.config.printers.reduce(function (acc, current) {
        return (0, _assign2.default)(_this16.printersConfig, (0, _defineProperty3.default)({}, current.name, current));
      }, {});
      _this16.nestedMode = _this16.checkNestedMode();
      _this16.getPrinters();
      _this16.getMaterials();
      var jobSpecification = localStorage.getItem('jobSpecification');
      if (jobSpecification) {
        jobSpecification = JSON.parse(jobSpecification);
        _this16.restoreJobSpecification(jobSpecification);
      } else {
        _this16.printerChoice(0);
      }
      if (_this16.nestedMode) {
        if (_this16.$route.params.id) {
          _this16.parentPathKey = _this16.$route.params.id;
          return _this16.getNestedJobsRestore().then(function (jobs) {
            _this16.getNestedJobsFromState();
            _this16.restoreJob(jobs[0]);
            _this16.fileLoading = false;
          }).catch(function (err) {
            _this16.errorHandling(err, _this16.getNestedJobsRestore);
          });
        } else {
          _this16.getNestedJobsFromState();
          _this16.fileLoading = false;
        }
      } else {
        return _store2.default.dispatch('loadSourceFile', { id: _this16.$route.params.id, forceRefresh: false }).then(function () {
          _this16.file = _this16.$store.state.files.find(function (file) {
            return file.id === _this16.$route.params.id;
          });
          _this16.files.push(JSON.parse((0, _stringify2.default)((0, _assign2.default)({}, _this16.file, _this16.defaultFileConfig))));
          if (_this16.$route.params.jobPathKey) {
            _this16.getJobById({ id: _this16.$route.params.id, jobPathKey: _this16.$route.params.jobPathKey }).then(function (job) {
              if (job) {
                _this16.restoreJob(job);
                _this16.files = [JSON.parse((0, _stringify2.default)((0, _assign2.default)({}, _this16.file, _this16.defaultFileConfig)))];
              }
              _this16.fileLoading = false;
            });
          } else {
            _this16.fileLoading = false;
          }
        }).catch(function (err) {
          _this16.errorHandling(err, function () {
            _store2.default.dispatch('loadSourceFile', { id: _this16.$route.params.id, forceRefresh: false });
          });
        });
      }
    }).catch(function (err) {
      _this16.errorHandling(err, _this16.getPrintConfig);
    });
  }
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(52);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var range = function range(min, max) {
  return function (number) {
    if (number >= min && number <= max) {
      return number;
    } else if (number < min) {
      return min;
    } else if (number > max) {
      return max;
    }
  };
};

exports.default = {
  props: ['params', 'buildPlate'],
  data: function data() {
    return {
      legendVertDiff: 24,

      trapecia: {
        med: [0.5, 50]
      },
      depth: {
        max: [0.5, 69]
      },
      rect: {
        max: [1, 50]
      }
    };
  },
  methods: {
    getWidth: function getWidth(side) {
      var _params = this.params,
          wt = _params.wt,
          wb = _params.wb;

      var restrict = range(20, 100);
      var widthTop = restrict(Number(wt.current));
      var widthBot = restrict(Number(wb.current));
      if (this.buildPlate) {
        widthBot = restrict(Number(wb.default));
      }
      var floor2 = function floor2(num) {
        return Math.floor(num / 2) * 2;
      };
      switch (side) {
        case 'top':
          return floor2(110 * widthTop / 100);
        case 'bot':
          return floor2(110 * widthBot / 100);
        default:
          return 30;
      }
    },
    getTopTrapeHeight: function getTopTrapeHeight() {
      var _trapecia$med = (0, _slicedToArray3.default)(this.trapecia.med, 2),
          medMm = _trapecia$med[0],
          medPx = _trapecia$med[1];

      var enteredMm = this.params.tt.current;

      var restrict = range(24, 90);
      return restrict(medPx * enteredMm / medMm);
    },
    getBotTrapeHeight: function getBotTrapeHeight() {
      var _trapecia$med2 = (0, _slicedToArray3.default)(this.trapecia.med, 2),
          medMm = _trapecia$med2[0],
          medPx = _trapecia$med2[1];

      var enteredMm = this.params.tb.current;
      if (this.buildPlate) {
        enteredMm = this.params.tb.default;
      }
      var restrict = range(24, 90);
      return restrict(medPx * enteredMm / medMm);
    },
    getTrapeSkew: function getTrapeSkew(side) {
      var countTrapeSkew = function countTrapeSkew(enteredWidth) {
        return Math.floor((110 - enteredWidth) / 2);
      };
      return countTrapeSkew(this.getWidth(side)) + 'px';
    },
    getTopDepthHeight: function getTopDepthHeight() {
      var _depth$max = (0, _slicedToArray3.default)(this.depth.max, 2),
          maxMm = _depth$max[0],
          maxPx = _depth$max[1];

      var enteredMm = this.params.pt.current;

      var restrict = range(24, maxPx);
      return restrict(maxPx * enteredMm / maxMm);
    },
    getBotDepthHeight: function getBotDepthHeight() {
      var _depth$max2 = (0, _slicedToArray3.default)(this.depth.max, 2),
          maxMm = _depth$max2[0],
          maxPx = _depth$max2[1];

      var enteredMm = this.params.pb.current;
      if (this.buildPlate) {
        enteredMm = this.params.pb.default;
      }
      var restrict = range(0, maxPx);
      return restrict(maxPx * enteredMm / maxMm);
    },
    isDepthVisible: function isDepthVisible(side) {
      var _params2 = this.params,
          pt = _params2.pt,
          pb = _params2.pb;

      var hideIfHeightIs0 = function hideIfHeightIs0(height) {
        return height === 0 ? 'none' : 'inherit';
      };
      switch (side) {
        case 'top':
          return hideIfHeightIs0(Number(pt.current));
        case 'bot':
          if (this.buildPlate) {
            return hideIfHeightIs0(Number(pb.default));
          }
          return hideIfHeightIs0(Number(pb.current));
        default:
          return 'flex';
      }
    },
    getTopRectHeight: function getTopRectHeight() {
      var _rect$max = (0, _slicedToArray3.default)(this.rect.max, 2),
          maxMm = _rect$max[0],
          maxPx = _rect$max[1];

      var enteredMm = this.params.ot.current;

      var restrict = range(0, maxPx);
      return restrict(maxPx * enteredMm / maxMm);
    },
    getBotRectHeight: function getBotRectHeight() {
      var _rect$max2 = (0, _slicedToArray3.default)(this.rect.max, 2),
          maxMm = _rect$max2[0],
          maxPx = _rect$max2[1];

      var enteredMm = this.params.ob.current;
      if (this.buildPlate) {
        enteredMm = this.params.ob.default;
      }
      var restrict = range(0, maxPx);
      return restrict(maxPx * enteredMm / maxMm);
    },
    getLegendHeight: function getLegendHeight(place) {
      var legendVertDiff = this.legendVertDiff;

      switch (place) {
        case 'top-trape':
          return this.getTopTrapeHeight() - legendVertDiff + 2;
        case 'bot-trape':
          return this.getBotTrapeHeight() - legendVertDiff + 2;
        case 'top-depth':
          return this.getTopDepthHeight() - legendVertDiff + 1;
        case 'bot-depth':
          return this.getBotDepthHeight() - legendVertDiff + 3;
        case 'top-rect':
          return this.getTopRectHeight() - legendVertDiff;
        case 'bot-rect':
          return this.getBotRectHeight() - legendVertDiff;
        default:
          return 1;
      }
    },
    getBaseGapHeight: function getBaseGapHeight() {
      var gapHeight = this.getBotTrapeHeight() + this.getTopTrapeHeight() + this.getBotRectHeight() + this.getTopRectHeight() + 110;
      if (!this.buildPlate) {
        gapHeight -= 4;
      }
      return gapHeight;
    },
    getOpacity: function getOpacity() {
      return this.buildPlate ? 0 : 1;
    }
  } };

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(24);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _Banner = __webpack_require__(195);

var _Banner2 = _interopRequireDefault(_Banner);

var _vuex = __webpack_require__(12);

var _BuyCredits = __webpack_require__(133);

var _BuyCredits2 = _interopRequireDefault(_BuyCredits);

var _errorHandling = __webpack_require__(23);

var _errorHandling2 = _interopRequireDefault(_errorHandling);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    'buy-credits': _BuyCredits2.default,
    'banner': _Banner2.default
  },
  name: 'home',
  mixins: [_errorHandling2.default],
  data: function data() {
    return {
      selectedCredits: 1,
      clearCacheBanner: false,
      formData: {
        name: { last: '', current: '', invalid: false },
        company: { last: '', current: '', invalid: false },
        address: { last: '', current: '', invalid: false },
        phone: { last: '', current: '', invalid: false },
        email: { last: '', current: '', invalid: false },
        plan: '-'
      },
      submitting: false,
      submitted: false
    };
  },
  computed: (0, _extends3.default)({
    whichNotify: function whichNotify() {
      return '/static/img/notification_white.svg';
    }
  }, (0, _vuex.mapState)(['user', 'auth', 'webGL']), (0, _vuex.mapGetters)({
    subscription: 'user/subscriptionExpiration'
  })),
  methods: {
    modalBeforeOpen: function modalBeforeOpen(data) {
      this.formData.name.current = this.user.firstName + ' ' + this.user.lastName;
      this.formData.email.current = this.user.email;
    },
    verifyString: function verifyString(sString, length) {
      if (sString.current.length < length) {
        sString.current = sString.last;
        sString.invalid = true;
        return false;
      } else {
        sString.last = sString.current;
        sString.invalid = false;
        return true;
      }
    },
    closeModal: function closeModal() {
      this.$modal.hide('details-submitted');
    },
    submit: function submit() {
      var _this = this;

      var _formData = this.formData,
          name = _formData.name,
          company = _formData.company,
          address = _formData.address,
          phone = _formData.phone,
          email = _formData.email,
          plan = _formData.plan;

      if (this.verifyString(name, 2) && this.verifyString(address, 2) && this.verifyString(phone, 2) && this.verifyString(email, 2)) {
        this.submitting = true;
        this.$store.dispatch('billing/sendSubscriptionData', {
          name: name.current,
          company: company.current,
          address: address.current,
          phone: phone.current,
          email: email.current,
          plan: plan
        }).then(function (response) {
          _this.resetFormData();
          _this.submitted = true;
          _this.$modal.hide('details');
          _this.$modal.show('details-submitted');
        }).catch(function (err) {
          _this.errorHandling(err, _this.init);
        }).finally(function () {
          _this.submitting = false;
        });
      }
    },
    resetFormData: function resetFormData() {
      this.formData = (0, _assign2.default)(this.formData, {
        name: { last: '', current: this.user.firstName + ' ' + this.user.lastName, invalid: false },
        company: { last: '', current: '', invalid: false },
        address: { last: '', current: '', invalid: false },
        phone: { last: '', current: '', invalid: false },
        email: { last: '', current: this.user.email, invalid: false },
        plan: '-'
      });
    },
    setIsPasswordChanged: function setIsPasswordChanged() {
      var expiresDate = new Date(Date.now() + 1000 * 60 * 60 * 24 * 365 * 10);
      var isPassWasChanged = document.cookie.match('(^|;)?' + this.user.isPassWasChangedCookieName + '=([^;]*)');
      if (!isPassWasChanged) {
        document.cookie = this.user.isPassWasChangedCookieName + '=true; expires=' + expiresDate + '; path=/;';
      }
    }
  },
  created: function created() {
    this.setIsPasswordChanged();
    if (this.$route.name === 'Dash') {
      this.clearCacheBanner = true;
    } else {
      this.clearCacheBanner = false;
    }
  },

  watch: {
    '$route': function $route(to, from) {
      if (to.name === 'Dash') {
        this.clearCacheBanner = true;
      } else {
        this.clearCacheBanner = false;
      }
    }
  },
  filters: {
    dateFormat: function dateFormat(value) {
      return new Date(value).toLocaleString({
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(149);

var _typeof3 = _interopRequireDefault(_typeof2);

var _entries = __webpack_require__(99);

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = __webpack_require__(50);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = __webpack_require__(52);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = __webpack_require__(17);

var _promise2 = _interopRequireDefault(_promise);

var _values = __webpack_require__(147);

var _values2 = _interopRequireDefault(_values);

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _helpers = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      formData: {
        totalPrintTime: 0,
        costPerHour: 125,
        totalMaterial: 0,
        costPerKg: 200,
        multiplier: true,
        overhead: 1.8,
        overheadFlat: 100
      },
      isCompare: false,
      estimates: [],
      nestedEstimates: [],
      validationError: '',
      modalLoading: false
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['filesCompare', 'nestedFilesCompare']), {
    totalCost: function totalCost() {
      if (this.validateForm()) {
        var sum = this.formData.totalPrintTime * this.formData.costPerHour + this.formData.totalMaterial * this.formData.costPerKg;
        if (this.formData.multiplier) {
          return (sum * this.formData.overhead).toFixed(2);
        } else {
          return (sum + parseFloat(this.formData.overheadFlat)).toFixed(2);
        }
      } else {
        return '';
      }
    },
    printTime: function printTime() {
      return this.formData.totalPrintTime.toFixed(3) + ' hours';
    },
    totalMaterial: function totalMaterial() {
      return this.formData.totalMaterial.toFixed(3) + ' kg';
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getDownloadURL', 'getURLData', 'removeCompareData', 'resetCompareFiles']), {
    costPerEstimate: function costPerEstimate(estimate) {
      if (this.validateForm()) {
        var sum = estimate.build_time * this.formData.costPerHour + estimate.M_material * this.formData.costPerKg;
        if (this.formData.multiplier) {
          return (sum * this.formData.overhead).toFixed(2);
        } else {
          return (sum + parseFloat(this.formData.overheadFlat)).toFixed(2);
        }
      } else {
        return '';
      }
    },
    totalCostMaterialPerEstimate: function totalCostMaterialPerEstimate(estimate) {
      return (this.formData.costPerKg * estimate.M_material).toFixed(2);
    },
    totalCostTimePerEstimate: function totalCostTimePerEstimate(estimate) {
      return (this.formData.costPerHour * estimate.build_time).toFixed(2);
    },
    getCompareEstimates: function getCompareEstimates() {
      var _this = this;

      this.modalLoading = true;
      var promises = [];
      var nestedJobPromises = [];
      var nestedPromises = [];

      (0, _values2.default)(this.filesCompare).forEach(function (job) {
        return promises.push(_this.createPromiseToGetData(job));
      });

      (0, _values2.default)(this.nestedFilesCompare).forEach(function (job, index) {
        nestedJobPromises.push(_this.createPromiseToGetData(job));
        nestedPromises[index] = [];

        job.nestedJobs.forEach(function (nestedJob) {
          var objToGetData = (0, _helpers.buildJobToCompare)(nestedJob, nestedJob.jobOutputs[0]);
          nestedPromises[index].push(_this.createPromiseToGetData(objToGetData));
        });
      });

      _promise2.default.all([_promise2.default.all(promises), _promise2.default.all(nestedJobPromises), _promise2.default.all(nestedPromises.map(function (np) {
        return _promise2.default.all(np);
      }))]).then(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 3),
            estimates = _ref2[0],
            nestedEstimates = _ref2[1],
            nestedJobEstimates = _ref2[2];

        var nestedCombinedWithParts = nestedEstimates.map(function (nestedEstimate, index) {
          var plates = [];

          var _loop = function _loop(part) {
            nestedEstimate.plates.map(function (plate, plateIndex) {
              if (!plates[plateIndex]) {
                plates[plateIndex] = [];
              }

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = (0, _getIterator3.default)(plate), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var nestedPart = _step2.value;

                  var suffixes = ['_manual_output', '_support_volume_output', '_support_removal_output', '_build_time_output', '_user_defined_output', '_distortion_output', '_time_distortion_output', '_new_output'];
                  var replaceString = suffixes.join('|');

                  var nestedFilename = nestedPart.file.replace(new RegExp('(' + replaceString + ').stl'), '.stl');
                  if (nestedFilename === part.filename) {
                    plates[plateIndex].push((0, _extends3.default)({}, nestedPart, part));
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            });
          };

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(nestedJobEstimates[index]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var part = _step.value;

              _loop(part);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return (0, _extends3.default)({}, nestedEstimate, {
            plates: plates
          });
        });

        _this.estimates = estimates;
        _this.nestedEstimates = nestedCombinedWithParts;
        _this.computedEstimates();
        _this.modalLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this.modalLoading = false;
      });
    },
    createPromiseToGetData: function createPromiseToGetData(file) {
      var _this2 = this;

      var config = file.config,
          sourceFilePathKey = file.sourceFilePathKey,
          jobPathKey = file.jobPathKey,
          jobOutputPathKey = file.jobOutputPathKey,
          filename = file.filename,
          outputFiles = file.outputFiles,
          analysisId = file.analysisId,
          objectiveId = file.objectiveId,
          isNested = file.isNested,
          nestedJobName = file.nestedJobName;

      var name = isNested ? nestedJobName : filename;
      var costFile = isNested ? 'buildCostNesting.json' : 'cost.json';
      var objectiveFunc = (0, _helpers.jobDescription)(analysisId, objectiveId, false, false, true);

      return new _promise2.default(function (resolve, reject) {
        _this2.getDownloadURL({ filename: costFile, sourceFilePathKey: sourceFilePathKey, jobPathKey: jobPathKey, jobOutputPathKey: jobOutputPathKey }).then(function (response) {
          return _this2.getURLData({ url: response.data.url });
        }).then(function (estimate) {
          if (isNested && config.calibrationFactor && config.calibrationFactor[0]) {
            estimate.data.build_time = estimate.data.build_time.map(function (t) {
              return t * config.calibrationFactor[0];
            });
          }
          var _estimate$data = estimate.data,
              M_material = _estimate$data.M_material,
              build_time = _estimate$data.build_time,
              relative_build_time = _estimate$data.relative_build_time;

          var logFilename = _this2.checkLogFile(outputFiles);

          if (logFilename) {
            _this2.getDownloadURL({ filename: logFilename, sourceFilePathKey: sourceFilePathKey, jobPathKey: jobPathKey, jobOutputPathKey: jobOutputPathKey }).then(function (response) {
              return _this2.getURLData({ url: response.data.url });
            }).then(function (logFile) {
              resolve({
                filename: name,
                jobOutputPathKey: jobOutputPathKey,
                M_material: M_material.reduce(function (acc, current) {
                  return acc + current;
                }, 0).toFixed(6),
                build_time: build_time.reduce(function (acc, current) {
                  return acc + current;
                }, 0).toFixed(6),
                materialPerPlate: M_material.map(function (num) {
                  return num.toFixed(6);
                }),
                timePerPlate: build_time.map(function (num) {
                  return num.toFixed(6);
                }),
                objectiveFunc: objectiveFunc,
                distortion: _this2.parseLogFile(logFile.data, isNested),
                plates: _this2.parseNestedByPlates(logFile.data, relative_build_time, isNested)
              });
            });
          } else {
            resolve({
              filename: name,
              jobOutputPathKey: jobOutputPathKey,
              M_material: M_material.reduce(function (acc, current) {
                return acc + current;
              }, 0).toFixed(6),
              build_time: build_time.reduce(function (acc, current) {
                return acc + current;
              }, 0).toFixed(6),
              objectiveFunc: objectiveFunc
            });
          }
        }).catch(function () {
          resolve({
            filename: name,
            jobOutputPathKey: jobOutputPathKey,
            hasError: true
          });
        });
      });
    },
    computedEstimates: function computedEstimates() {
      this.formData.totalPrintTime = 0;
      this.formData.totalMaterial = 0;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(this.estimates), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var estimate = _step3.value;

          if (!estimate.hasError) {
            this.formData.totalPrintTime += estimate.build_time;
            this.formData.totalMaterial += estimate.M_material;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = (0, _getIterator3.default)(this.nestedEstimates), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _estimate = _step4.value;

          if (!_estimate.hasError) {
            this.formData.totalPrintTime += _estimate.build_time;
            this.formData.totalMaterial += _estimate.M_material;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    deleteJobFromEstimate: function deleteJobFromEstimate(jobOutputPathKey) {
      this.removeCompareData(jobOutputPathKey);
      this.estimates = this.estimates.filter(function (elem) {
        return elem.jobOutputPathKey !== jobOutputPathKey;
      });
      this.nestedEstimates = this.nestedEstimates.filter(function (elem) {
        return elem.jobOutputPathKey !== jobOutputPathKey;
      });
      if (this.estimates.length < 1 && this.nestedEstimates.length < 1) {
        this.$modal.hide('estimate-cost');
      } else {
        this.computedEstimates();
      }
    },
    checkLogFile: function checkLogFile(array) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = (0, _getIterator3.default)(array), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var file = _step5.value;

          if (RegExp(/Log_(.+)_output\.txt|configNesting.json/).test(file.name)) {
            return file.name;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return false;
    },
    parseNestedByPlates: function parseNestedByPlates(data, relativeBuildTime, isNested) {
      if (isNested) {
        var nestingData = data.nesting2d ? data.nesting2d : data.nesting2dWithRotation;
        var paramsByPart = data.nesting2d ? 2 : 3;
        return nestingData.map(function (plate, index) {
          var itemsOnPlate = [];

          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = (0, _getIterator3.default)((0, _entries2.default)(plate)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var _ref3 = _step6.value;

              var _ref4 = (0, _slicedToArray3.default)(_ref3, 2);

              var file = _ref4[0];
              var coordinates = _ref4[1];

              var count = coordinates.length / paramsByPart;
              var buildTime = void 0;
              if (relativeBuildTime && relativeBuildTime[index]) {
                buildTime = relativeBuildTime[index][file];
              }
              itemsOnPlate.push({ file: file, count: count, buildTime: buildTime });
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }

          return itemsOnPlate;
        });
      }
      return false;
    },
    parseLogFile: function parseLogFile(txt, isNested) {
      if (!isNested) {
        var _ret2 = function () {
          var dataRows = txt.match(/^(\s{0,}Max.*disp.*|Part bounding box.*|Part height.*|Part max Z.*|Z-offset.*).*/gm);
          var result = {};

          var parseRow = function parseRow(row) {
            var isPartMaxZ = row.match(/Part max Z/g);
            var isPartHeight = row.match(/Part height/g);
            var isOffsetZ = row.match(/Z-offset/g);

            var valueName = void 0,
                rowPart1 = void 0,
                rowPart2 = void 0;
            if (isPartMaxZ) {
              valueName = 'partMaxZ';
            } else if (isPartHeight) {
              valueName = 'partHeight';
            } else if (isOffsetZ) {
              valueName = 'offsetZ';
            } else {
              rowPart1 = row.match(/(on|off|stress|bounding)/);
              rowPart2 = row.match(/\sx|y|z|normal|max|min(?= )/g);
              if (rowPart1 && rowPart1 !== 'null' && rowPart1 !== 'undefined' && rowPart2 && rowPart2 !== 'null' && rowPart2 !== 'undefined') {
                valueName = rowPart1[0] + '_' + rowPart2[0].trim();
              } else {
                valueName = '';
              }
            }

            var value = row.match(/-?\d+\.\d+/g);
            if (result.hasOwnProperty(valueName)) {
              return null;
            }
            value.length <= 1 ? result[valueName] = Number(value) : result[valueName] = value.map(function (val) {
              return Number(val);
            });
          };
          if (dataRows) {
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
              for (var _iterator7 = (0, _getIterator3.default)(dataRows), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var row = _step7.value;

                var match = row.match(/Part max Z|Part height|Z-offset|\sx|y|z|normal|bounding(?= )/g);
                if (match && match !== 'null' && match !== 'undefined' && match.length === 1) {
                  parseRow(row);
                } else {
                  var splitedRows = row.split(';');
                  splitedRows.forEach(function (row) {
                    if (row && row !== 'null' && row !== 'undefined') {
                      parseRow(row);
                    }
                  });
                }
              }
            } catch (err) {
              _didIteratorError7 = true;
              _iteratorError7 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }
              } finally {
                if (_didIteratorError7) {
                  throw _iteratorError7;
                }
              }
            }
          } else {
            return {
              v: false
            };
          }

          return {
            v: result
          };
        }();

        if ((typeof _ret2 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret2)) === "object") return _ret2.v;
      }
      return false;
    },
    formatDistortion: function formatDistortion(dist, type) {
      if (dist && typeof dist[type] === 'number') {
        return dist[type];
      } else {
        return '-';
      }
    },
    beforeOpen: function beforeOpen(event) {
      if (event.params.isCompare) {
        this.isCompare = true;
        this.getCompareEstimates();
      } else {
        this.isCompare = false;
        this.formData.totalPrintTime = event.params.data.build_time.reduce(function (a, b) {
          return a + b;
        });
        this.formData.totalMaterial = event.params.data.M_material.reduce(function (a, b) {
          return a + b;
        });
      }
    },
    opened: function opened(event) {
      this.$refs['estimate-cost'].setInitialSize();
    },
    validateForm: function validateForm() {
      var valid = false;
      if (!this.formData.costPerHour || this.formData.costPerHour < 0) {
        this.validationError = 'Empty or incorrect cost per print hour';
      } else if (!this.formData.costPerKg || this.formData.costPerKg < 0) {
        this.validationError = 'Empty or incorrect cost per kg';
      } else if ((!this.formData.overhead || this.formData.overhead < 0) && this.formData.multiplier) {
        this.validationError = 'Empty or incorrect multiplier';
      } else if ((!this.formData.overheadFlat || this.formData.overheadFlat < 0) && !this.formData.multiplier) {
        this.validationError = 'Empty or incorrect profit overhead';
      } else {
        this.validationError = false;
        valid = true;
      }
      return valid;
    }
  })
};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(17);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(24);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _errorHandling = __webpack_require__(23);

var _errorHandling2 = _interopRequireDefault(_errorHandling);

var _JobOutput = __webpack_require__(196);

var _JobOutput2 = _interopRequireDefault(_JobOutput);

var _FileOutput = __webpack_require__(464);

var _FileOutput2 = _interopRequireDefault(_FileOutput);

var _EstimateCost = __webpack_require__(462);

var _EstimateCost2 = _interopRequireDefault(_EstimateCost);

var _helpers = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    JobOutput: _JobOutput2.default,
    FileOutput: _FileOutput2.default,
    EstimateCost: _EstimateCost2.default
  },
  name: 'files',
  props: ['showModal'],
  mixins: [_errorHandling2.default],
  data: function data() {
    return {
      selectedCredits: 1,
      uploading: false,
      message: '',
      deleting: false,
      loadingJobs: false,
      jobsToggle: [],
      jobsToggleLoading: [],
      showArchived: false,
      jobArchiving: false,
      jobToRemove: null,
      fileToRepair: null,
      jobToResubmit: null,
      nestedMode: false,
      compareMode: false,
      repairProcess: {},
      repairConfig: {
        tetraEps: { last: '', current: _helpers.defaultConfig.tetraEps[0], invalid: false },
        tetraMeshSize: { last: '', current: _helpers.defaultConfig.tetraMeshSize[0], invalid: false }
      }
    };
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['user', 'gettingFileURL', 'files', 'jobs', 'filesPagination', 'jobsPagination', 'jobsProgress', 'filesNested', 'filesCompare', 'nestedFilesCompare']), (0, _vuex.mapGetters)(['filesFormatted']), (0, _vuex.mapGetters)({
    subscription: 'user/subscriptionExpiration'
  }), {
    countActiveJobs: function countActiveJobs() {
      var count = 0;
      this.filesFormatted.forEach(function (file) {
        if (file.unarchived) {
          count += file.unarchived;
        } else if (file.isNested && !file.isArchived) {
          count += 1;
        }
      });
      return count;
    },
    countArchivedJobs: function countArchivedJobs() {
      var count = 0;
      this.filesFormatted.forEach(function (file) {
        if (file.archived) {
          count += file.archived;
        } else if (file.isNested && file.isArchived) {
          count += 1;
        }
      });
      return count;
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    refreshCredits: 'user/refreshCredits'
  }), (0, _vuex.mapActions)(['uploadFile', 'checkSourceFile', 'refreshFiles', 'loadSourceFile', 'repairFile', 'getJobsOrdered', 'getJobOutputs', 'deleteFile', 'getDownloadURL', 'getURLData', 'clearUpdateTimers', 'setNestedFile', 'resetCompareFiles', 'getJob', 'createJob', 'submitJob', 'updateJob', '_jobs/archiveJob']), {
    init: function init() {
      var _this = this;

      this.loadingJobs = true;
      this.$store.commit('RESET_NESTED_DATA');
      var isResetFiles = this.files.length < this.filesPagination.filesOnPage && !this.filesPagination.isAllLoaded ? 'resetFiles' : null;
      var isNotFirstInit = this.files.length ? 'notFirstInit' : null;
      var rule = isResetFiles || isNotFirstInit;
      this.refreshFiles(rule).then(function () {
        return _this.getJobsOrdered();
      }).then(function () {
        _this.loadingJobs = false;
      }).catch(function (err) {
        _this.loadingJobs = false;
        _this.errorHandling(err, _this.init);
      });
    },
    buymodal: function buymodal() {
      this.$modal.show('details');
    },
    loadSourceFiles: function loadSourceFiles() {
      return this.refreshFiles();
    },
    loadJobs: function loadJobs() {
      this.getJobsOrdered();
    },
    removeJobOpen: function removeJobOpen(event) {
      this.jobToRemove = {
        element: event.params.element,
        sourceFilePathKey: event.params.sourceFilePathKey,
        pathKey: event.params.pathKey
      };
    },
    removeJobConfirmationCancel: function removeJobConfirmationCancel() {
      this.jobToRemove = null;
      this.$modal.hide('removemodal');
    },
    removeJob: function removeJob() {
      var _this2 = this;

      this.jobToRemove.element.target.innerHTML = 'Removing...';
      this.jobToRemove.element.target.disabled = true;
      this.$modal.hide('removemodal');
      this.$store.dispatch('_jobs/deleteJob', this.jobToRemove.pathKey).then(function (response) {
        _this2.$store.commit('REMOVE_JOB', {
          sourceFilePathKey: _this2.jobToRemove.sourceFilePathKey,
          pathKey: _this2.jobToRemove.pathKey
        });
        _this2.jobToRemove.element.target.innerHTML = 'Remove';
        _this2.jobToRemove.element.target.disabled = false;
        _this2.jobToRemove = null;
      }).catch(function (err) {
        _this2.errorHandling(err, _this2.removeJob);
        _this2.jobToRemove.element.target.innerHTML = 'Remove';
        _this2.jobToRemove.element.target.disabled = false;
      });
    },
    toggleArchived: function toggleArchived() {
      this.jobsToggle = [];
      this.showArchived = !this.showArchived;
    },
    fileRepairOpen: function fileRepairOpen(file) {
      this.fileToRepair = file;
      this.$modal.show('repairmodal');
    },
    fileRepairClose: function fileRepairClose() {
      this.fileToRepair = null;
      this.$modal.hide('repairmodal');
    },
    fileRepair: function fileRepair() {
      var _this3 = this;

      var file = this.fileToRepair;
      this.$modal.hide('repairmodal');
      this.$set(this.repairProcess, file.id, true);

      file.config = {
        tetraEps: Number(this.repairConfig.tetraEps.current),
        tetraMeshSize: Number(this.repairConfig.tetraMeshSize.current)
      };

      this.repairFile(file).then(function (response) {
        _this3.repairFileGetData(file, response.data.progress, 1);
      }).catch(function (err) {
        _this3.errorHandling(err, function () {
          return _this3.repairFile(file);
        });
        _this3.$set(_this3.repairProcess, file.id, false);
      });
    },
    repairFileGetData: function repairFileGetData(file, url, attempt) {
      var _this4 = this;

      this.getURLData({ url: url }).then(function (optimizerResponse) {
        if (optimizerResponse.data && optimizerResponse.data.result) {
          _this4.loadSourceFile({ id: file.id, forceRefresh: true }).then(function () {
            _this4.$set(_this4.repairProcess, file.id, false);
          });
        } else {
          _this4.$set(_this4.repairProcess, file.id, false);
          throw new Error('Repair failed');
        }
      }).catch(function (err) {
        if (err.response && err.response.status && err.response.status === 404 && attempt <= 40) {
          attempt++;
          var delay = 5000 * attempt;
          if (attempt > 3) {
            delay = 15000;
          }
          setTimeout(function () {
            _this4.repairFileGetData(file, url, attempt);
          }, delay);
        } else if (err.message === 'Repair failed') {
          _this4.$set(_this4.repairProcess, file.id, false);
          _this4.errorHandling(err, function () {
            _this4.fileToRepair = file;
            _this4.fileRepair();
          });
        } else {
          _this4.errorHandling(err, function () {
            return _this4.repairFileGetData(file.id, url, attempt);
          });
          _this4.$set(_this4.repairProcess, file.id, false);
          throw new Error('Get repair result failed');
        }
      });
    },
    resubmitJobOpen: function resubmitJobOpen(_ref) {
      var params = _ref.params;

      this.jobToResubmit = {
        element: params.element,
        sourceFilePathKey: params.sourceFilePathKey,
        config: (0, _extends3.default)({}, params.jobConfig, { filename: params.filename }),
        jobPathKey: params.jobPathKey,
        jobDescription: params.jobDescription,
        analysisId: params.jobAnalysisId,
        objectiveId: params.jobObjectiveId
      };
    },
    resubmitJobClose: function resubmitJobClose() {
      this.jobToResubmit = null;
      this.$modal.hide('resubmitjobmodal');
    },
    resubmitJob: function resubmitJob() {
      var _this5 = this;

      var jobPathKey = void 0;
      var getAdditionalData = function getAdditionalData() {
        if (_this5.jobToResubmit.config.AdditionalConfig) {
          return _this5.getDownloadURL({
            sourceFilePathKey: _this5.jobToResubmit.sourceFilePathKey,
            jobPathKey: _this5.jobToResubmit.jobPathKey,
            filename: 'additional_config.json'
          }).then(function (response) {
            return _this5.getURLData({ url: response.data.url });
          }).then(function (data) {
            _this5.jobToResubmit.config = (0, _assign2.default)(_this5.jobToResubmit.config, data.data);
            return _promise2.default.resolve('Additional data merged to config');
          });
        } else {
          return _promise2.default.resolve('Skip getting additional data');
        }
      };
      this.jobToResubmit.element.target.innerHTML = 'Submitting...';
      this.jobToResubmit.element.target.disabled = true;
      this.$modal.hide('resubmitjobmodal');
      getAdditionalData().then(function () {
        return _this5.createJob({
          sourceFilePathKey: _this5.jobToResubmit.sourceFilePathKey,
          config: _this5.jobToResubmit.config
        });
      }).then(function (response) {
        jobPathKey = response.data.jobPathKey;
        return _this5.updateJob({
          jobPathKey: jobPathKey,
          config: _this5.jobToResubmit.config,
          jobDescription: _this5.jobToResubmit.jobDescription
        });
      }).then(function () {
        return _this5.submitJob({
          jobPathKey: jobPathKey,
          analysisId: _this5.jobToResubmit.analysisId,
          objectiveId: _this5.jobToResubmit.objectiveId
        });
      }).then(function (response) {
        return _this5.getJob(jobPathKey);
      }).then(function (response) {
        _this5.jobToResubmit.element.target.innerHTML = 'Re-Submit';
        _this5.jobToResubmit.element.target.disabled = false;
        _this5.jobToResubmit = null;
      }).catch(function (err) {
        console.log('error', err);
        _this5.errorHandling(err, _this5.resubmitJob);
        _this5.jobToResubmit.element.target.innerHTML = 'Re-Submit';
        _this5.jobToResubmit.element.target.disabled = false;
      });
    },

    selectUploadFile: function selectUploadFile() {
      document.getElementById('uploadfile').click();
    },
    fileDownload: function fileDownload(_ref2) {
      var _this6 = this;

      var filename = _ref2.filename,
          sourceFilePathKey = _ref2.sourceFilePathKey,
          jobPathKey = _ref2.jobPathKey,
          jobOutputPathKey = _ref2.jobOutputPathKey,
          newTab = _ref2.newTab;

      if (!this.gettingFileURL) {
        this.$store.commit('TOGGLE_GETTING_FILE_URL', true);
        this.getDownloadURL({ filename: filename, sourceFilePathKey: sourceFilePathKey, jobPathKey: jobPathKey, jobOutputPathKey: jobOutputPathKey }).then(function (response) {
          if (newTab) {
            (0, _assign2.default)(document.createElement('a'), { target: '_blank', href: response.data.url }).click();
          } else {
            location.assign(response.data.url);
          }
          _this6.$store.commit('TOGGLE_GETTING_FILE_URL', false);
        }).catch(function (err) {
          _this6.$store.commit('TOGGLE_GETTING_FILE_URL', false);
          _this6.errorHandling(err);
        });
      }
    },

    upload: function upload() {
      var _this7 = this;

      this.uploading = true;
      if (document.getElementById('uploadfile').files[0].name.match(/.(stl)$/i)) {
        this.message = '';
        this.uploadFile({
          file: document.getElementById('uploadfile').files[0]
        }).then(function (response) {
          var pathKey = response.config.pathKey;

          var timing = 25000;
          var i = 0;
          var waitForFile = function waitForFile() {
            return setTimeout(function () {
              _this7.checkSourceFile({ pathKey: pathKey }).then(function (res) {
                if (res.length || i === 3) {
                  _this7.uploading = false;
                  document.getElementById('uploadfile').value = null;
                } else {
                  i += 1;
                  timing = 5000;
                  waitForFile();
                }
              });
            }, timing);
          };
          waitForFile();
        }).catch(function (err) {
          _this7.uploading = false;
          _this7.errorHandling(err);
        });
      } else {
        this.message = 'Sorry, your file is an invalid file type. Please upload only STL files at this time.';
        this.uploading = false;
      }
    },
    deleteF: function deleteF(file) {
      var _this8 = this;

      this.deleting = true;
      this.deleteFile(file).finally(function (res) {
        _this8.deleting = false;
      });
    },
    toggleNestedMode: function toggleNestedMode() {
      this.nestedMode = !this.nestedMode;
    },
    toggleCompareMode: function toggleCompareMode(evt) {
      this.resetCompareFiles();
      this.compareMode = !this.compareMode;
    },
    showEstimateModal: function showEstimateModal() {
      this.$modal.show('estimate-cost', { isCompare: true });
    },
    nestParts: function nestParts() {
      this.$router.push({ name: 'NestedQuantity' });
    },

    verifyNumPositive: function verifyNumPositive(sNum) {
      if (isNaN(sNum.current) || sNum.current === '' || sNum.current <= 0) {
        sNum.current = sNum.last;
        sNum.invalid = true;
        return false;
      } else {
        sNum.last = sNum.current;
        sNum.invalid = false;
        return true;
      }
    }
  }),
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('resetJobs');
  },
  created: function created() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearUpdateTimers();
  },

  filters: {
    dateFormat: function dateFormat(value) {
      return new Date(value).toLocaleString({
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }
};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _errorHandling = __webpack_require__(23);

var _errorHandling2 = _interopRequireDefault(_errorHandling);

var _filesOutput = __webpack_require__(144);

var _filesOutput2 = _interopRequireDefault(_filesOutput);

var _vueMyDropdown = __webpack_require__(134);

var _vueMyDropdown2 = _interopRequireDefault(_vueMyDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    dropdown: _vueMyDropdown2.default
  },
  name: 'FileOutput',
  props: ['file', 'showArchived', 'compareMode'],
  mixins: [_errorHandling2.default, _filesOutput2.default],
  data: function data() {
    return {
      jobsLoadingLimit: 10,
      idsToLoad: [],
      jobsLoaded: 0,
      idsToLoadArchived: [],
      jobsLoadedArchived: 0
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['user', 'gettingFileURL', 'jobs', 'filesCompare']), (0, _vuex.mapGetters)({
    subscription: 'user/subscriptionExpiration'
  }), {
    isCanLoadMore: function isCanLoadMore() {
      return this.showArchived && this.idsToLoadArchived.length > 0 || !this.showArchived && this.idsToLoad.length > 0;
    },
    total: function total() {
      return this.file.jobs.length;
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getJobOutputs', 'getJobsOutputs', 'redeemJob', 'getDownloadURL', 'setJobToCompare', 'removeJobFromCompare', 'getURLData']), (0, _vuex.mapActions)({
    refreshCredits: 'user/refreshCredits'
  }), {
    toggleJobs: function toggleJobs() {
      this.isOpen = !this.isOpen;
      if (this.isOpen && (!this.showArchived && this.jobsLoaded === 0 || this.showArchived && this.jobsLoadedArchived === 0)) {
        this.loadMore();
      }
    },
    toggleJobCompare: function toggleJobCompare(job) {
      this.filesCompare[job.jobOutput.jobOutputPathKey] ? this.removeJobFromCompare(job) : this.setJobToCompare(job);
    },
    getTempList: function getTempList(jI, joI) {
      return this.file.jobs[jI].jobOutputs[joI].outputFiles.reduce(function (acc, file) {
        if (file.name.match(/^temp\d*\.vtk/i)) acc.push(file);
        return acc;
      }, []).sort(function (a, b) {
        var getNumber = function getNumber(str) {
          return +str.match(/\d+/)[0] || 1;
        };
        var _ref = [getNumber(a.name), getNumber(b.name)],
            n1 = _ref[0],
            n2 = _ref[1];

        if (n1 > n2) return 1;else return -1;
      });
    },
    loadMore: function loadMore() {
      var _this = this;

      var requestIdsFiltered = [];
      if (this.showArchived) {
        requestIdsFiltered = this.idsToLoadArchived.slice(0, this.idsToLoadArchived.length > this.jobsLoadingLimit ? this.jobsLoadingLimit : this.idsToLoadArchived.length);
      } else {
        requestIdsFiltered = this.idsToLoad.slice(0, this.idsToLoad.length > this.jobsLoadingLimit ? this.jobsLoadingLimit : this.idsToLoad.length);
      }
      var requestIds = requestIdsFiltered;
      this.isLoading = true;
      this.getJobsOutputs({
        sourceFilePathKey: this.file.pathKey,
        ids: requestIds
      }).then(function (response) {
        response.forEach(function (job) {
          if (job.jobOutputs && job.jobOutputs.length > 0) {
            var unfinishedJobs = _this.countUnfinishedJobs(job.jobOutputs);
            if (unfinishedJobs > 0) {
              _this.getJobsProgress({ jobPathKey: job.pathKey, sourceFilePathKey: _this.file.pathKey });
            }
          }
        });
        _this.calculateIds();
        _this.loaded += _this.fileLoadingLimit;
        _this.isLoading = false;
      }).catch(function (err) {
        _this.isLoading = false;
        _this.errorHandling(err, _this.loadMore);
      });
    },
    toggleJobsFiles: function toggleJobsFiles(jobIndex, index) {
      var jobsFilesToggle = this.jobsFilesToggle.slice();
      jobsFilesToggle[jobIndex][index] = !jobsFilesToggle[jobIndex][index];
      this.$set(this, 'jobsFilesToggle', jobsFilesToggle);
    },
    toggleTemperatureFiles: function toggleTemperatureFiles(jobIndex, index) {
      var temperatureFilesToggle = this.temperatureFilesToggle.slice();
      temperatureFilesToggle[jobIndex][index] = !temperatureFilesToggle[jobIndex][index];
      this.$set(this, 'temperatureFilesToggle', temperatureFilesToggle);
    },
    toggleJobsFilesCompensated: function toggleJobsFilesCompensated(jobIndex, index) {
      var jobsFilesCompensatedToggle = this.jobsFilesCompensatedToggle.slice();
      jobsFilesCompensatedToggle[jobIndex][index] = !jobsFilesCompensatedToggle[jobIndex][index];
      this.$set(this, 'jobsFilesCompensatedToggle', jobsFilesCompensatedToggle);
    },
    visibleJobsFilesSupport: function visibleJobsFilesSupport(jobIndex, index) {
      var jobsFilesSupportVisible = this.jobsFilesSupportVisible.slice();
      jobsFilesSupportVisible[jobIndex][index] = !jobsFilesSupportVisible[jobIndex][index];
      this.$set(this, 'jobsFilesSupportVisible', jobsFilesSupportVisible);
    },
    visibleJobsFilesSupportCompensated: function visibleJobsFilesSupportCompensated(jobIndex, index) {
      var jobsFilesSupportCompensatedVisible = this.jobsFilesSupportCompensatedVisible.slice();
      jobsFilesSupportCompensatedVisible[jobIndex][index] = !jobsFilesSupportCompensatedVisible[jobIndex][index];
      this.$set(this, 'jobsFilesSupportCompensatedVisible', jobsFilesSupportCompensatedVisible);
    },
    visibleJobsFilesPart: function visibleJobsFilesPart(jobIndex, index) {
      var jobsFilesPartVisible = this.jobsFilesPartVisible.slice();
      jobsFilesPartVisible[jobIndex][index] = !jobsFilesPartVisible[jobIndex][index];
      this.$set(this, 'jobsFilesPartVisible', jobsFilesPartVisible);
    },
    visibleJobsFilesPartCompensated: function visibleJobsFilesPartCompensated(jobIndex, index) {
      var jobsFilesPartCompensatedVisible = this.jobsFilesPartCompensatedVisible.slice();
      jobsFilesPartCompensatedVisible[jobIndex][index] = !jobsFilesPartCompensatedVisible[jobIndex][index];
      this.$set(this, 'jobsFilesPartCompensatedVisible', jobsFilesPartCompensatedVisible);
    },
    unlockJob: function unlockJob(event, jobOutput, job) {
      var _this2 = this;

      var defaultMessage = event.target.innerHTML;
      event.target.innerHTML = 'Unlocking...';
      event.target.disabled = true;
      this.redeemJob(jobOutput.jobOutputPathKey).then(function () {
        return _this2.getJobOutputs({ jobPathKey: job.jobPathKey, sourceFilePathKey: job.sourceFilePathKey });
      }).then(function () {
        return _this2.refreshCredits();
      }).catch(function (err) {
        _this2.errorHandling(err);
        event.target.innerHTML = defaultMessage;
        event.target.disabled = false;
      });
    },
    archiveJob: function archiveJob(payload) {
      var _this3 = this;

      this.$set(this.archivingProcess, payload.jobOutputPathKey, true);
      this.$store.dispatch('_jobs/archiveJob', { jobOutputPathKey: payload.jobOutputPathKey }).then(function (response) {
        payload.isArchived = true;
        _this3.$store.commit('ARCHIVE_JOB_OUTPUT', payload);
        _this3.$set(_this3.archivingProcess, payload.jobOutputPathKey, false);
        _this3.calculateIds();
      }).catch(function (err) {
        _this3.errorHandling(err, function () {
          _this3.archiveJob(payload);
        });
        _this3.$set(_this3.archivingProcess, payload.jobOutputPathKey, false);
      });
    },
    unarchiveJob: function unarchiveJob(payload) {
      var _this4 = this;

      this.$set(this.unarchivingProcess, payload.jobOutputPathKey, true);
      this.$store.dispatch('_jobs/unarchiveJob', { jobOutputPathKey: payload.jobOutputPathKey }).then(function (response) {
        payload.isArchived = false;
        _this4.$store.commit('ARCHIVE_JOB_OUTPUT', payload);
        _this4.$set(_this4.unarchivingProcess, payload.jobOutputPathKey, false);
        _this4.calculateIds();
      }).catch(function (err) {
        _this4.errorHandling(err, function () {
          _this4.archiveJob(payload);
        });
        _this4.$set(_this4.unarchivingProcess, payload.jobOutputPathKey, false);
      });
    },
    calculateIds: function calculateIds() {
      var _this5 = this;

      this.idsToLoad = [];
      this.idsToLoadArchived = [];
      this.jobsLoaded = 0;
      this.jobsLoadedArchived = 0;
      this.file.jobs.forEach(function (job) {
        if (!Array.isArray(job.jobOutputs)) {
          if (job.unarchived > 0 && job.archived > 0) {
            _this5.idsToLoad.push(job.jobId);
            _this5.idsToLoadArchived.push(job.jobId);
          } else if (job.unarchived > 0 || job.archived === 0 && job.unarchived === 0) {
            _this5.idsToLoad.push(job.jobId);
          } else {
            _this5.idsToLoadArchived.push(job.jobId);
          }
        } else {
          if (job.unarchived > 0 && job.archived > 0) {
            _this5.jobsLoaded++;
            _this5.jobsLoadedArchived++;
          } else if (job.unarchived > 0 || job.archived === 0 && job.unarchived === 0) {
            _this5.jobsLoaded++;
          } else {
            _this5.jobsLoadedArchived++;
          }
        }
      });
    }
  }),
  created: function created() {
    var _this6 = this;

    this.file.jobs.forEach(function (job, index) {
      _this6.jobsFilesToggle[index] = [];
      _this6.jobsFilesCompensatedToggle[index] = [];
      _this6.temperatureFilesToggle[index] = [];
      _this6.jobsFilesSupportVisible[index] = [];
      _this6.jobsFilesSupportCompensatedVisible[index] = [];
      _this6.jobsFilesPartVisible[index] = [];
      _this6.jobsFilesPartCompensatedVisible[index] = [];
    });
    this.calculateIds();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timers.length > 0) {
      this.timers.forEach(function (timer) {
        clearTimeout(timer);
      });
    }
  },

  watch: {
    showArchived: function showArchived(value, oldValue) {
      if (this.isOpen && (value && this.idsToLoadArchived.length > 0 && this.jobsLoadedArchived < 10 || !value && this.idsToLoad.length > 0 && this.jobsLoaded < 10)) {
        this.loadMore();
      }
    }
  },
  filters: {
    dateFormat: function dateFormat(value) {
      return new Date(value).toLocaleString({
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }
};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _JobOutput = __webpack_require__(196);

var _JobOutput2 = _interopRequireDefault(_JobOutput);

var _errorHandling = __webpack_require__(23);

var _errorHandling2 = _interopRequireDefault(_errorHandling);

var _filesOutput = __webpack_require__(144);

var _filesOutput2 = _interopRequireDefault(_filesOutput);

var _vueMyDropdown = __webpack_require__(134);

var _vueMyDropdown2 = _interopRequireDefault(_vueMyDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    JobOutput: _JobOutput2.default,
    dropdown: _vueMyDropdown2.default
  },
  name: 'JobOutput',
  props: ['job', 'compareMode'],
  mixins: [_errorHandling2.default, _filesOutput2.default],
  data: function data() {
    return {};
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['user', 'gettingFileURL', 'files', 'jobs', 'filesPagination', 'jobsProgress', 'filesNested', 'filesCompare', 'nestedFilesCompare']), (0, _vuex.mapGetters)({
    subscription: 'user/subscriptionExpiration'
  })),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    refreshCredits: 'user/refreshCredits'
  }), (0, _vuex.mapActions)(['getJobOutputs', 'redeemJob', 'getDownloadURL', 'getURLData', 'setJobToCompare', 'removeJobFromCompare', 'setNestedFile']), {
    toggleJobCompare: function toggleJobCompare(job) {
      var jobOutputPathKey = job.jobOutput.jobOutputPathKey;


      this.isCheckedToCompare(jobOutputPathKey) ? this.removeJobFromCompare(job) : this.setJobToCompare(job);
    },
    isHasCost: function isHasCost(outputFiles, job) {
      return this.isCost(outputFiles) && !job.isNested || this.isNestedConfig(outputFiles);
    },
    isCheckedToCompare: function isCheckedToCompare(jobOutputPathKey) {
      return this.filesCompare[jobOutputPathKey] || this.nestedFilesCompare[jobOutputPathKey];
    },
    showEstimateModal: function showEstimateModal(jobToCompare) {
      this.$store.commit('RESET_COMPARE_DATA');
      this.setJobToCompare(jobToCompare);
      this.$modal.show('estimate-cost', { isCompare: true });
    },
    toggleJobs: function toggleJobs(jobPathKey, sourceFilePathKey) {
      var _this = this;

      var _job = this.job,
          jobOutputs = _job.jobOutputs,
          nestedJobs = _job.nestedJobs,
          isNested = _job.isNested;


      this.isOpen = !this.isOpen;
      if (!jobOutputs) {
        this.getOutputs(jobPathKey, sourceFilePathKey);
      }
      if (isNested && nestedJobs[0] && !nestedJobs[0].outputsLoaded) {
        nestedJobs.forEach(function (nestedJob) {
          var jobPathKey = nestedJob.jobPathKey,
              sourceFilePathKey = nestedJob.sourceFilePathKey;

          _this.getOutputs(jobPathKey, sourceFilePathKey);
        });
      }
    },
    getOutputs: function getOutputs(jobPathKey, sourceFilePathKey) {
      var _this2 = this;

      this.isLoading = !this.isLoading;
      this.getJobOutputs({ jobPathKey: jobPathKey, sourceFilePathKey: sourceFilePathKey }).then(function (output) {
        _this2.isLoading = !_this2.isLoading;
        if (output.jobOutputs && output.jobOutputs.length > 0) {
          var unfinishedJobs = _this2.countUnfinishedJobs(output.jobOutputs);
          if (unfinishedJobs > 0) {
            _this2.getJobsProgress({ jobPathKey: jobPathKey, sourceFilePathKey: sourceFilePathKey });
          }
        }
      }).catch(function (err) {
        _this2.isLoading = false;
        _this2.isOpen = false;
        _this2.errorHandling(err);
      });
    },
    toggleJobsFiles: function toggleJobsFiles(index) {
      this.$set(this.jobsFilesToggle, index, !this.jobsFilesToggle[index]);
    },
    toggleJobsFilesCompensated: function toggleJobsFilesCompensated(index) {
      this.$set(this.jobsFilesCompensatedToggle, index, !this.jobsFilesCompensatedToggle[index]);
    },
    visibleJobsFilesSupport: function visibleJobsFilesSupport(index, flag) {
      this.$set(this.jobsFilesSupportVisible, index, flag);
    },
    visibleJobsFilesSupportCompensated: function visibleJobsFilesSupportCompensated(index, flag) {
      this.$set(this.jobsFilesSupportCompensatedVisible, index, flag);
    },
    visibleJobsFilesPart: function visibleJobsFilesPart(index, flag) {
      this.$set(this.jobsFilesPartVisible, index, !this.jobsFilesPartVisible[index]);
    },
    visibleJobsFilesPartCompensated: function visibleJobsFilesPartCompensated(index, flag) {
      this.$set(this.jobsFilesPartCompensatedVisible, index, !this.jobsFilesPartCompensatedVisible[index]);
    },
    createNestedJob: function createNestedJob(id) {
      this.$router.push({ name: 'NestedCreateById', params: { id: id } });
    },
    archiveJob: function archiveJob(payload) {
      var _this3 = this;

      this.$set(this.archivingProcess, payload.jobPathKey, true);
      this.$store.dispatch('_jobs/archiveJob', { jobPathKey: payload.jobPathKey }).then(function () {
        payload.isArchived = true;
        _this3.$store.commit('ARCHIVE_JOB', payload);
        _this3.$set(_this3.archivingProcess, payload.jobPathKey, false);
      }).catch(function (err) {
        _this3.errorHandling(err, function () {
          _this3.archiveJob(payload);
        });
        _this3.$set(_this3.archivingProcess, payload.jobPathKey, false);
      });
    },
    unarchiveJob: function unarchiveJob(payload) {
      var _this4 = this;

      this.$set(this.unarchivingProcess, payload.jobPathKey, true);
      this.$store.dispatch('_jobs/unarchiveJob', { jobPathKey: payload.jobPathKey }).then(function () {
        payload.isArchived = false;
        _this4.$store.commit('ARCHIVE_JOB', payload);
        _this4.$set(_this4.unarchivingProcess, payload.jobPathKey, false);
      }).catch(function (err) {
        _this4.errorHandling(err, function () {
          _this4.unarchiveJob(payload);
        });
        _this4.$set(_this4.unarchivingProcess, payload.jobPathKey, false);
      });
    }
  }),
  beforeDestroy: function beforeDestroy() {
    if (this.timers.length > 0) {
      this.timers.forEach(function (timer) {
        clearTimeout(timer);
      });
    }
  },

  filters: {
    dateFormat: function dateFormat(value) {
      return new Date(value).toLocaleString({
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'JobSummary',
  props: ['config', 'jobDescription', 'submit'],
  data: function data() {
    return {
      jobDescriptionData: ''
    };
  },

  methods: {
    hideSummary: function hideSummary() {
      this.$modal.hide('summarymodal');
    },
    submitData: function submitData() {
      this.$modal.hide('summarymodal');
      this.submit(this.jobDescriptionData);
    }
  },
  created: function created() {
    this.jobDescriptionData = this.jobDescription;
  }
};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'home',
  props: ['auth', 'authenticated'],
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['user']))
};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(51);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _errorHandling = __webpack_require__(23);

var _errorHandling2 = _interopRequireDefault(_errorHandling);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_errorHandling2.default],
  data: function data() {
    return {
      parentPathKey: null,
      loading: false,
      submitting: false,
      continueJob: false
    };
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['filesNested'])),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setNestedFile', 'updateNestedJob', 'setNestedFileData', 'getNestedJobs']), {
    init: function init() {
      var _this = this;

      this.parentPathKey = this.getParentPathKey();
      if (this.continueJob) {
        this.loading = true;
        this.getNestedJobs(this.parentPathKey).then(function (response) {
          if (response && response.data.allJobs && response.data.allJobs.length > 0) {
            _this.setNestedFileData(response.data.allJobs);
            _this.loading = false;
          }
        }).catch(function (err) {
          _this.loading = false;
          _this.errorHandling(err, _this.init);
        });
      } else {
        if ((0, _keys2.default)(this.filesNested).length < 1) {
          this.$router.push({ name: 'Dash' });
        }
      }
    },
    getParentPathKey: function getParentPathKey() {
      if (this.$route.params.id) {
        this.continueJob = true;
        return this.$route.params.id;
      } else if ((0, _keys2.default)(this.filesNested).length > 0) {
        return this.filesNested[(0, _keys2.default)(this.filesNested)[0]].parentPathKey;
      } else {
        return null;
      }
    },
    validate: function validate() {
      var _this2 = this;

      var valid = true;
      (0, _keys2.default)(this.filesNested).forEach(function (key) {
        if (_this2.filesNested[key].quantity < 1) {
          valid = false;
        }
      });
      return valid;
    },
    goBack: function goBack() {
      this.$router.replace({ name: 'Dash' });
    },
    goNext: function goNext() {
      var _this3 = this;

      if (this.validate()) {
        if (this.parentPathKey) {
          this.submitting = true;
          var nestedConfig = [];
          (0, _keys2.default)(this.filesNested).forEach(function (key) {
            nestedConfig.push({
              importance: _this3.filesNested[key].importance,
              quantity: _this3.filesNested[key].quantity,
              jobPathKey: _this3.filesNested[key].jobPathKey
            });
          });
          this.updateNestedJob({
            nestedJobs: nestedConfig,
            parentPathKey: this.parentPathKey
          }).then(function (response) {
            _this3.submitting = false;
            _this3.$router.push({ name: 'NestedCreateById', params: { id: _this3.parentPathKey } });
          }).catch(function (err) {
            _this3.submitting = false;
            _this3.errorHandling(err, _this3.goNext);
          });
        } else {
          this.$router.push({ name: 'NestedCreate' });
        }
      }
    },
    removeFile: function removeFile(file) {
      this.setNestedFile(file);
      if ((0, _keys2.default)(this.filesNested).length < 1) {
        this.$router.replace({ name: 'Dash' });
      }
    },
    updateQuantity: function updateQuantity(pathKey, $event) {
      this.$store.commit('UPDATE_DESIRED_QUANTITY', { pathKey: pathKey, value: $event.target.value });
    },
    updateImportance: function updateImportance(pathKey, $event) {
      this.$store.commit('UPDATE_RELATIVE_IMPORTANCE', { pathKey: pathKey, value: $event.target.value });
    }
  }),
  beforeMount: function beforeMount() {
    this.init();
  }
};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Alert',
  data: function data() {
    return {
      isDetailsOpen: false,
      fireCallback: false,
      params: {
        type: null,
        title: null,
        isCanRetry: false
      }
    };
  },

  computed: {
    title: function title() {
      if (this.params.title) {
        return this.params.title;
      } else {
        if (this.params.type === 'danger') {
          return 'Error';
        } else if (this.params.type === 'info') {
          return 'information';
        } else {
          return null;
        }
      }
    }
  },
  methods: {
    beforeOpen: function beforeOpen(event) {
      this.params = event.params;
      this.fireCallback = false;
    },
    toggleDetails: function toggleDetails() {
      this.isDetailsOpen = !this.isDetailsOpen;
    },
    modalClose: function modalClose() {
      this.$modal.hide('alertmodal');
    },
    retry: function retry() {
      this.fireCallback = true;
      this.$modal.hide('alertmodal');
    },
    onClosed: function onClosed() {
      if (this.fireCallback) {
        this.params.retryCallback();
      }
    }
  }
};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'onboard',
  data: function data() {
    return {
      form: {
        isGovcloudUser: false
      },
      isLoading: false
    };
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['user', 'auth'])),
  methods: {
    submit: function submit() {
      var _this = this;

      this.isLoading = true;
      this.$store.dispatch('user/onboarding', {
        isGovcloudUser: this.form.isGovcloudUser
      }).finally(function () {
        _this.resetFormData();
        _this.isLoading = false;
        _this.$router.replace({ name: 'Dash' });
        _this.auth.login();
      });
    },
    resetFormData: function resetFormData() {
      this.form.isGovcloudUser = false;
    }
  }
};

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Splash',
  data: function data() {
    return {
      isForceLogin: location.search.includes('?login=true')
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['user', 'auth']), {
    isPassWasChanged: function isPassWasChanged() {
      return document.cookie.match('(^|;)?' + this.user.isPassWasChangedCookieName + '=([^;]*)');
    }
  }),
  created: function created() {
    if (this.isForceLogin) {
      this.auth.login(false);
    }
  }
};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(51);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(24);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(80);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(17);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _BuyCredits = __webpack_require__(133);

var _BuyCredits2 = _interopRequireDefault(_BuyCredits);

var _JobSummary = __webpack_require__(197);

var _JobSummary2 = _interopRequireDefault(_JobSummary);

var _errorHandling = __webpack_require__(23);

var _errorHandling2 = _interopRequireDefault(_errorHandling);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'home',
  components: {
    'buy-credits': _BuyCredits2.default,
    JobSummary: _JobSummary2.default
  },
  mixins: [_errorHandling2.default],
  props: ['auth', 'authenticated'],
  data: function data() {
    return {
      initing: true,
      loading: false,
      job: {},
      failure: false,
      expertAdvice: false,
      maxDist: 1,
      validationError: null,
      restrictOrientation: false,
      restrictFaces: false,
      optimizationConstrain: false,
      showModal: function showModal() {},
      nestedMode: false,
      nestedJobName: null,
      partParamsAll: true,
      parentPathKey: null,
      files: [],
      fileIndex: 0,
      submitting: false,
      statusMessage: null,
      remeshingPart: null,
      remeshingProgress: null,
      jobDescription: ''
    };
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    refreshCredits: 'user/refreshCredits'
  }), (0, _vuex.mapActions)(['getNestedJobs', 'setNestedFileData', 'getJob', 'updateJob', 'updateNestedJob', 'submitJob', 'submitNestedJob', 'getURLData', 'remeshPart']), {
    buymodal: function buymodal() {
      this.$modal.show('details');
    },
    validate: function validate() {
      var _this = this;

      this.validationError = [];
      var valid = true;
      this.files.forEach(function (file, index) {
        if (file.optMaxDist && file.maxDist > 0 || !file.optMaxDist) {
          _this.validationError[index] = null;
          return;
        } else {
          _this.validationError[index] = 'Empty or invalid value for maximum thermal distortion';
          valid = false;
          _this.switchFile(index);
        }
      });
      if (this.nestedMode && valid && (!this.nestedJobName || this.nestedJobName.length < 2)) {
        valid = false;
        this.validationError = 'Enter valid job name';
      }
      if (valid) {
        this.submit();
      }
    },
    submit: function submit() {
      this.files.forEach(function (file) {
        if (file.optMinDist) {
          file.analysisId = 5;
          file.objectiveId = 1;
          file.config.MaxDist = [-1];
          file.config.isHeatTreatment = file.isHeatTreatment;
          file.config.isMinPeeling = file.isMinPeeling;
        } else if (file.optMaxDist) {
          file.analysisId = 5;
          file.objectiveId = 14;
          file.config.MaxDist = [parseFloat(file.maxDist)];
        } else {
          file.analysisId = 4;
          file.objectiveId = 21;
          file.config.MaxDist = [-1];
        }

        file.config.Weights = file.weights;
      });

      if (!this.loading) {
        if (this.nestedMode) {
          this.submitNested();
        } else {
          if (this.optimizationConstrain) {
            this.submitSingle('');
          } else {
            this.openSummary();
          }
        }
      }
    },
    submitSingle: function submitSingle(jobDescription) {
      var _this2 = this;

      this.submitting = true;
      this.loading = true;
      this.jobDescription = jobDescription;
      var remeshSourceFile = function remeshSourceFile() {
        if (_this2.files[0].config.needRemesh) {
          _this2.statusMessage = 'Remeshing in progress...';
          _this2.remeshingPart = true;
          return new _promise2.default(function (resolve, reject) {
            var filename = void 0;
            _this2.remeshPart({
              sourceFilePathKey: _this2.files[0].sourceFilePathKey,
              config: (0, _extends3.default)({}, _this2.files[0].config, { AdditionalConfig: undefined, Weights: [0.5, 0.5, 0.5] })
            }).then(function (res) {
              filename = res.data.filename;
              _this2.remeshPartProgress(res.data.progress);
              return _this2.remeshPartAttempt(res.data.url, 1);
            }).then(function () {
              resolve(filename);
            }).catch(function (err) {
              if (err) {
                console.log('Remeshing error');
              }
              resolve(null);
            });
          });
        } else {}
        return _promise2.default.resolve();
      };
      return remeshSourceFile().then(function (filename) {
        if (filename) {
          _this2.files[0].config.filename = filename;
        }
        _this2.remeshingPart = false;
        _this2.statusMessage = 'Updating job...';
        return _this2.updateJob({
          jobPathKey: _this2.files[0].jobPathKey,
          config: (0, _extends3.default)({}, _this2.files[0].config, { needRemesh: false }),
          jobDescription: jobDescription
        });
      }).then(function (response) {
        if (_this2.optimizationConstrain) {
          _this2.$router.push({
            name: 'ThreeJSViewer',
            params: {
              id: _this2.files[0].jobPathKey,
              type: 'input',
              restrictOrientation: _this2.optimizationConstrain,
              restrictFaces: _this2.restrictFaces,
              createConfig: _this2.files[0].config,
              submitJobData: {
                jobPathKey: response.data.jobPathKey,
                objectiveId: _this2.files[0].objectiveId,
                analysisId: _this2.files[0].analysisId
              }
            } });
        } else {
          return _this2.submitJob({
            jobPathKey: response.data.jobPathKey,
            objectiveId: _this2.files[0].objectiveId,
            analysisId: _this2.files[0].analysisId
          }).then(function (success) {
            _this2.loading = false;
            _this2.submitting = false;
            _this2.statusMessage = null;
            _this2.failure = !success;
            _this2.refreshCredits();

            _this2.$router.replace({ name: 'Dash' });
          });
        }
      }).catch(function (err) {
        _this2.loading = false;
        _this2.submitting = false;
        _this2.statusMessage = null;
        _this2.openSummary();
        _this2.errorHandling(err, function () {
          _this2.submitSingle(jobDescription);
        });
      });
    },
    submitNested: function submitNested() {
      var _this3 = this;

      this.loading = true;
      var nestedJobsData = {
        nestedJobs: [],
        nestedJobName: this.nestedJobName,
        parentPathKey: this.parentPathKey
      };
      if (this.partParamsAll) {
        this.copyPartParamAll();
      }
      this.files.forEach(function (file) {
        nestedJobsData.nestedJobs.push({
          config: (0, _extends3.default)({}, file.config, { needRemesh: false }),
          jobPathKey: file.jobPathKey
        });
      });
      this.updateNestedJob(nestedJobsData).then(function (response) {
        var submitJobsData = [];
        _this3.files.forEach(function (file) {
          submitJobsData.push({
            jobPathKey: file.jobPathKey,
            analysisId: file.analysisId,
            objectiveId: file.objectiveId
          });
        });
        return _this3.submitNestedJob(submitJobsData);
      }).then(function (response) {
        _this3.refreshCredits();
        _this3.loading = false;
        _this3.$store.commit('RESET_NESTED_DATA');
        _this3.$router.replace({ name: 'Dash' });
      }).catch(function (err) {
        _this3.loading = false;
        _this3.errorHandling(err, _this3.submitNested);
      });
    },
    remeshPartAttempt: function remeshPartAttempt(url, attempt) {
      var _this4 = this;

      return new _promise2.default(function (resolve, reject) {
        _this4.getURLData({ url: url }).then(function (response) {
          if (response.data) {
            if (response.data.result === true) {
              resolve();
            } else {
              reject({ message: 'Server error' });
            }
          }
        }).catch(function (err) {
          if (err.response && err.response.status && err.response.status === 404 && attempt <= 42) {
            attempt++;
            var delay = 1500 * attempt;
            if (attempt > 15) {
              delay = 30000;
            } else if (attempt > 3) {
              delay = 10000;
            }
            setTimeout(function () {
              resolve(_this4.remeshPartAttempt(url, attempt));
            }, delay);
          } else {
            reject(err);
          }
        });
      });
    },
    remeshPartProgress: function remeshPartProgress(url) {
      var _this5 = this;

      if (this.remeshingPart) {
        this.getURLData({ url: url }).then(function (response) {
          _this5.remeshingProgress = response.data.progress;
          setTimeout(function () {
            _this5.remeshPartProgress(url);
          }, 2500);
        }).catch(function () {
          console.log('Getting remesh progress...');
          setTimeout(function () {
            _this5.remeshPartProgress(url);
          }, 2500);
        });
      }
    },
    openSummary: function openSummary() {
      this.$modal.show('summarymodal');
    },
    checkNestedMode: function checkNestedMode() {
      return this.$route.name === 'NestedMagicById' || this.$route.name === 'NestedMagic';
    },
    filesPrepare: function filesPrepare(keys) {
      var _this6 = this;

      var files = [];
      keys.forEach(function (key) {
        files.push(JSON.parse((0, _stringify2.default)((0, _assign2.default)({}, {
          config: _this6.filesNested[key].config,
          name: _this6.filesNested[key].name,
          pathKey: key,
          jobPathKey: _this6.filesNested[key].jobPathKey,
          analysisId: 0,
          objectiveId: 0,
          optWeights: true,
          optMinDist: false,
          optMaxDist: false,
          isHeatTreatment: true,
          isMinPeeling: false,
          weights: [0.5, 0.5, 0.5, 0.5],
          maxDist: 1
        }))));
      });
      return files;
    },
    switchFile: function switchFile(index) {
      this.fileIndex = index;
    },
    switchPartParamAll: function switchPartParamAll() {
      this.switchFile(0);
      if (!this.partParamsAll) {
        this.copyPartParamAll();
      }
    },
    copyPartParamAll: function copyPartParamAll() {
      var _this7 = this;

      this.files.forEach(function (file) {
        file.weights[0] = _this7.files[0].weights[0];
        file.weights[1] = _this7.files[0].weights[1];
        file.weights[2] = _this7.files[0].weights[2];
        file.weights[3] = _this7.files[0].weights[3];
        file.maxDist = _this7.files[0].maxDist;
        file.analysisId = _this7.files[0].analysisId;
        file.objectiveId = _this7.files[0].objectiveId;
        file.optMaxDist = _this7.files[0].optMaxDist;
        file.optMinDist = _this7.files[0].optMinDist;
        file.optWeights = _this7.files[0].optWeights;
        file.isHeatTreatment = _this7.files[0].isHeatTreatment;
        file.isMinPeeling = _this7.files[0].isMinPeeling;
      });
    },
    getNestedJobsRestore: function getNestedJobsRestore() {
      var _this8 = this;

      return new _promise2.default(function (resolve, reject) {
        return _this8.getJob(_this8.parentPathKey).then(function (response) {
          if (response && response.data.Job && response.data.Job.hasOwnProperty('nestedJobName')) {
            _this8.nestedJobName = response.data.Job.nestedJobName;
            return _this8.getNestedJobs(_this8.parentPathKey);
          } else {
            _this8.$router.push({ name: 'Dash' });
          }
        }).then(function (response) {
          if (response && response.data.allJobs && response.data.allJobs.length > 0) {
            _this8.setNestedFileData(response.data.allJobs);
            resolve(response.data.allJobs);
          } else {
            reject();
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    goBack: function goBack() {
      this.$router.back();
    }
  }),
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['user', 'filesNested']), (0, _vuex.mapGetters)({
    subscription: 'user/subscriptionExpiration'
  }), {
    costString: function costString() {
      var credits = 1;
      if (this.files.length > 0) {
        credits *= this.files.length;
      }
      return credits + ' credit' + (credits > 1 ? 's' : '');
    },
    selectedColumn: function selectedColumn() {
      var message = '';
      if (this.expertAdvice) {
        message = '"I prefer expert advice"';
      } else if (this.files[this.fileIndex].optMinDist) {
        message = '"Minimal distortion is most important"';
      } else if (this.files[this.fileIndex].optMaxDist) {
        message = '"Set a limit on maximum thermal distortion"';
      }
      return message;
    }
  }),
  created: function created() {
    var _this9 = this;

    this.nestedMode = this.checkNestedMode();
    if (this.nestedMode && this.$route.params.id) {
      this.parentPathKey = this.$route.params.id;
      this.getNestedJobsRestore().then(function () {
        if ((0, _keys2.default)(_this9.filesNested).length > 0) {
          _this9.files = _this9.filesPrepare((0, _keys2.default)(_this9.filesNested));
          _this9.switchFile(0);
          _this9.initing = false;
        } else {
          _this9.$router.push({ name: 'Dash' });
        }
      }).catch(function (err) {
        _this9.errorHandling(err, _this9.getNestedJobsRestore);
      });
    } else {
      this.getJob(this.$route.params.jobPath).then(function (response) {
        _this9.initing = false;
        var job = response.data.Job;
        _this9.files.push({
          config: job.config,
          jobPathKey: job.pathKey,
          sourceFilePathKey: job.sourceFile.pathKey,
          analysisId: 0,
          objectiveId: 0,
          optWeights: true,
          optMinDist: false,
          optMaxDist: false,
          weights: [0.5, 0.5, 0.5, 0.5],
          isHeatTreatment: true,
          isMinPeeling: false,
          maxDist: 1
        });
      }).catch(function (err) {
        _this9.errorHandling(err, function () {
          _this9.getJob(_this9.$route.params.jobPath);
        });
      });
    }
  }
};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Trial',
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['auth']), {
    loginHost: function loginHost() {
      return 'https://' + window.location.hostname.replace('trials', 'portal') + '/splash?login=true';
    }
  }),
  data: function data() {
    return {
      isShowForm: false,
      form: {
        firstName: { last: '', current: '', invalid: false },
        lastName: { last: '', current: '', invalid: false },
        email: { last: '', current: '', invalid: false }
      },
      submitting: false,
      submitted: false,
      error: null
    };
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['submitTrialForm']), {
    showForm: function showForm() {
      this.isShowForm = true;
    },
    verifyString: function verifyString(sString, length) {
      if (sString.current.length < length) {
        sString.current = sString.last;
        sString.invalid = true;
        return false;
      } else {
        sString.last = sString.current;
        sString.invalid = false;
        return true;
      }
    },
    isFormValid: function isFormValid() {
      return this.verifyString(this.form.firstName, 2) && this.verifyString(this.form.lastName, 2) && this.verifyString(this.form.email, 2);
    },
    submitForm: function submitForm() {
      var _this = this;

      if (!this.isFormValid()) {
        return;
      }
      this.submitting = true;

      this.submitTrialForm({
        firstName: this.form.firstName.current,
        lastName: this.form.lastName.current,
        email: this.form.email.current
      }).then(function () {
        _this.submitting = false;
        _this.isShowForm = false;
        _this.submitted = true;
      }).catch(function (e) {
        _this.error = true;
        _this.submitting = false;
        console.log(e);
      });
    }
  })
};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(147);

var _values2 = _interopRequireDefault(_values);

var _entries = __webpack_require__(99);

var _entries2 = _interopRequireDefault(_entries);

var _keys = __webpack_require__(51);

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = __webpack_require__(52);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = __webpack_require__(100);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(17);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(24);

var _assign2 = _interopRequireDefault(_assign);

var _vuex = __webpack_require__(12);

var _viewer = __webpack_require__(315);

var Atlas3DViewer = _interopRequireWildcard(_viewer);

var _store = __webpack_require__(49);

var _store2 = _interopRequireDefault(_store);

var _JobSummary = __webpack_require__(197);

var _JobSummary2 = _interopRequireDefault(_JobSummary);

var _errorHandling = __webpack_require__(23);

var _errorHandling2 = _interopRequireDefault(_errorHandling);

var _helpers = __webpack_require__(33);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ThreeJSViewer',
  components: {
    JobSummary: _JobSummary2.default
  },
  props: ['filename', 'source'],
  mixins: [_errorHandling2.default],
  data: function data() {
    return {
      loading3JS: true,
      showOverlay: false,
      job: null,
      jobOutput: null,
      config: this.$route.params.createConfig,
      defaultConfig: (0, _assign2.default)({}, _helpers.defaultConfig),
      printersConfig: {},
      inputViewerData: {},
      jobDescription: null,
      jobOptimization: null,
      jobOptimizationNested: [],
      shouldPredict: this.$route.query.shouldPredict,
      viewer: null,
      creatingJob: false,
      message: 'Loading Siemens Viewer',
      file: null,
      restrictOrientation: false,
      restrictFaces: false,
      submitJobData: {},
      showSupportsOutput: false,
      showDirectionSelection: false,
      isHasSupports: false,
      isHasOptions: false,
      isStrengthenSupp: false,
      isHasOptionsFull: false,
      displacementDirection: 'z',
      displacementDirectionN: false,
      displacementOption: 'default',
      isCompensated: this.$route.query.compensated,
      isCanCompensate: false,
      isBladeCanCrush: false,
      isBladeCanCrushMessage: 'CAUTION: This build may cause a recoater blade crash!',
      layerThicknessCrushcoefficient: 10,
      contextMenu: false,
      contextMenuPosX: null,
      contextMenuPosY: null,
      currentPartName: '',
      modifySupportsMode: false,
      modifyMode: false,
      brushMode: true,
      brushRadius: 1,
      brushBothSide: false,
      selectionTolerance: 1.5,
      facetsSelection: 'erase',
      supportTransparency: 0.2,
      strengthenSupportTransparency: 0.7,
      nestedMode: false,
      platesConfig: [],
      allowZRotation: false,
      nestedJobs: null,
      partsConfig: {},
      platesErrors: false,
      nestedOptions: [],
      nestedPlate: 0,
      nestedPlates: [],
      isManualPlacement: false,
      legends: 0,
      legendsData: null,
      fileNames: [],
      nestedNames: [],
      isSupportUploaded: false,
      legendUpperLimit: null,
      legendLowerLimit: null,
      isNxUser: false
    };
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var _this = this;

    if (this.viewer) {
      this.$nextTick(function () {
        _this.viewer.destroy();
        _this.viewer = null;
        next();
      });
    } else {
      next();
    }
  },
  mounted: function mounted() {
    this.$route.params.type === 'input' ? this.loadInputViewer() : this.loadOutputViewer();
    if (this.$route.params.restrictOrientation) {
      this.restrictOrientation = this.config.restrictOrientation = this.$route.params.restrictOrientation;
    }
    if (this.$route.params.restrictFaces) {
      this.restrictFaces = this.config.restrictFaces = this.$route.params.restrictFaces;
    }
    if (this.$route.params.submitJobData) {
      this.submitJobData = this.$route.params.submitJobData;
    }
    if (this.$route.query.modifySupports) {
      this.modifySupportsMode = true;
    }
    if (this.$route.query.token) {
      this.isNxUser = true;
    }
  },

  computed: {
    isHasDistortionData: function isHasDistortionData() {
      return this.legends > 0;
    }
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    refreshCredits: 'user/refreshCredits'
  }), (0, _vuex.mapActions)(['createJob', 'submitJob', 'updateJob', 'getJob', 'getNestedJobs', 'getDownloadURL', 'getURLData', 'getJobOutputs', 'generateSupport', 'paintByCurvature', 'getPrintConfig', 'setNestedFileData', 'updateNestedJob', 'submitNestedJob']), {
    changePanelEvents: function changePanelEvents() {
      var panel = document.querySelector('.left-panel');
      var canvasElement = document.querySelector('#viewer3d');
      if (!panel || !canvasElement) return;

      var redispatchEvent = function redispatchEvent(event) {
        return canvasElement.dispatchEvent(new event.constructor(event.type, event));
      };
      panel.addEventListener('contextmenu', function (event) {
        return event.preventDefault();
      });
      panel.addEventListener('mousedown', redispatchEvent);
      panel.addEventListener('wheel', redispatchEvent);
      var panelBoxes = document.querySelectorAll('.left-panel__box');
      panelBoxes.forEach(function (item) {
        return item.addEventListener('mousedown', function (event) {
          return event.stopPropagation();
        });
      });
    },
    loadInputViewer: function loadInputViewer() {
      var _this2 = this;

      this.getJob(this.$route.params.id).then(function (response) {
        var isNested = response.data.Job.isNested;

        var promises = [];
        _this2.job = response.data.Job;
        if (isNested) {
          _this2.nestedMode = true;
          _this2.nestedJobName = response.data.Job.nestedJobName;
          _this2.config = _this2.job.config;
          promises.push(_this2.getNestedJobs(_this2.$route.params.id));
        } else {
          promises.push(_store2.default.dispatch('loadSourceFile', { id: _this2.job.sourceFile.id, forceRefresh: false }));
        }
        return _promise2.default.all(promises);
      }).then(function (response) {
        if (_this2.nestedMode) {
          _this2.setNestedFileData(response[0].data.allJobs);
        }
        return _this2.getPrintConfig();
      }).then(function (_ref) {
        var data = _ref.data;

        _store2.default.commit('SET_MATERIALS', data.config.materials);
        _store2.default.commit('SET_PRINTERS', data.config.printers);
        _this2.printersConfig = data.config.printers.reduce(function (acc, current) {
          return (0, _assign2.default)(_this2.printersConfig, (0, _defineProperty3.default)({}, current.name, current));
        }, {});
      }).then(function () {
        var file = void 0;
        if (_this2.nestedMode) {
          file = _this2.$store.state.filesNested[_this2.job.sourceFile.pathKey];
        } else {
          file = _this2.$store.state.files.find(function (f) {
            return f.id === _this2.job.sourceFile.id;
          });
        }
        if (!_this2.config) {
          _this2.config = _this2.job.config;
        }
        if (_this2.config.filename_supp && _this2.config.filename_supp.length > 0) {
          _this2.isSupportUploaded = true;
        }
        var filesUrl = [];
        if (_this2.nestedMode) {
          var jobs = _this2.$store.state.filesNested;
          _this2.isManualPlacement = _this2.config.manualPlacement;
          for (var jobKey in jobs) {
            filesUrl.push(_this2.getDownloadURL({
              filename: jobs[jobKey].config.filename,
              sourceFilePathKey: jobs[jobKey].sourceFile.pathKey
            }));
          }
        } else {
          filesUrl.push(_this2.getDownloadURL({
            filename: _this2.config.filename,
            sourceFilePathKey: file.pathKey
          }));
          if (_this2.isSupportUploaded) {
            _this2.config.filename_supp.forEach(function (fileSupport) {
              filesUrl.push(_this2.getDownloadURL({
                sourceFilePathKey: file.pathKey,
                jobPathKey: _this2.job.pathKey,
                filename: fileSupport
              }));
            });
          }
        }
        _promise2.default.all(filesUrl).then(function (response) {
          var parts = _this2.$store.state.filesNested;
          var callbacks = {
            fetchSupport: function fetchSupport() {
              var id = _this2.$route.params.id;

              var updateThisJob = { jobPathKey: id, config: (0, _extends3.default)({}, _this2.config, { needRemesh: false }) };
              var submitThisJob = {
                jobPathKey: id,
                objectiveId: 0,
                analysisId: 1
              };
              return _this2.updateJob(updateThisJob).then(function () {
                return _this2.submitJob(submitThisJob);
              }).then(function (afterUpdate) {
                return _store2.default.dispatch('getJob', id);
              }).then(function (_ref2) {
                var Job = _ref2.data.data.Job;

                return _store2.default.dispatch('_jobs/getJobOutput', Job.jobOutputs[0].id);
              }).then(function (response) {
                var jobOutput = response.data.data.JobOutput;

                return {
                  jobOutputPathKey: jobOutput.pathKey,
                  jobPathKey: jobOutput.job.pathKey,
                  sourceFilePathKey: jobOutput.job.sourceFile.pathKey
                };
              }).then(function (jobOutputFiles) {
                var filename = '1_cube_0m.stl';
                var stlConfig = (0, _assign2.default)({}, jobOutputFiles, {
                  filename: filename
                });
                return _this2.getDownloadURL(stlConfig);
              }).catch(function (err) {
                _this2.errorHandling(err, location.reload);
              });
            },
            generateSupportExternal: function generateSupportExternal(partParams) {
              _this2.config.RotationalAngle = partParams.rotation;
              _this2.config.scaling = partParams.scaling;
              _this2.config.unit = partParams.units;
              _this2.config.AllowedFaces = partParams.AllowedFaces;
              _this2.config.RestrictedFaces = partParams.RestrictedFaces;
              return _this2.generateSupport({
                sourceFilePathKey: file.pathKey,
                config: _this2.config
              });
            },
            getCurvaturePerFaceData: function getCurvaturePerFaceData() {
              var getData = function getData(url, attempt) {
                return new _promise2.default(function (resolve, reject) {
                  return _this2.getURLData({ url: url }).then(function (response) {
                    resolve(response.data);
                  }).catch(function (err) {
                    if (err.response && err.response.status && err.response.status === 404 && attempt <= 20) {
                      attempt++;
                      var delay = 1500 * attempt;
                      if (attempt > 3) {
                        delay = 8000;
                      }
                      setTimeout(function () {
                        resolve(getData(url, attempt));
                      }, delay);
                    } else {
                      reject(err);
                    }
                  });
                });
              };
              return new _promise2.default(function (resolve, reject) {
                _this2.paintByCurvature({
                  sourceFilePathKey: file.pathKey,
                  config: _this2.config
                }).then(function (response) {
                  return getData(response.data.url, 1);
                }).then(function (response) {
                  resolve(response);
                }).catch(function (err) {
                  reject(err);
                });
              });
            },
            supportLoading: function supportLoading(toggle) {
              if (toggle) {
                _this2.loading3JS = true;
                _this2.message = 'Loading support structure';
              } else {
                _this2.loading3JS = false;
              }
            },
            curvatureLoading: function curvatureLoading(toggle) {
              if (toggle) {
                _this2.loading3JS = true;
                _this2.message = 'Preparing for selection of flat surface...';
              } else {
                _this2.loading3JS = false;
              }
            },
            contextMenuToggle: function contextMenuToggle(toggle, mouse) {
              if (_this2.isSupportUploaded) return;
              _this2.contextMenu = toggle;
              if (mouse) {
                if (window.innerWidth - mouse.x <= _this2.$refs.cMenu.clientWidth && window.clientHeight - mouse.y <= _this2.$refs.cMenu.clientHeight) {
                  _this2.contextMenuPosX = window.innerWidth - _this2.$refs.cMenu.clientWidth;
                  _this2.contextMenuPosY = window.innerHeight - _this2.$refs.cMenu.clientHeight;
                } else if (window.innerWidth - mouse.x <= _this2.$refs.cMenu.clientWidth) {
                  _this2.contextMenuPosX = window.innerWidth - _this2.$refs.cMenu.clientWidth;
                  _this2.contextMenuPosY = mouse.y;
                } else if (window.clientHeight - mouse.y <= _this2.$refs.cMenu.clientHeight) {
                  _this2.contextMenuPosX = mouse.x;
                  _this2.contextMenuPosY = window.innerHeight - _this2.$refs.cMenu.clientHeight;
                } else {
                  _this2.contextMenuPosX = mouse.x;
                  _this2.contextMenuPosY = mouse.y;
                }
              }
            },
            showHelp: function showHelp() {
              _this2.$modal.show('dialoghelp');
            },
            changeZRotationAccess: function changeZRotationAccess(value) {
              if (value) {
                _this2.$modal.show('zrotationmodal');
              } else {
                for (var name in _this2.partsConfig) {
                  var _partsConfig$name$Rot = (0, _slicedToArray3.default)(_this2.partsConfig[name].RotationalAngle, 2),
                      x = _partsConfig$name$Rot[0],
                      y = _partsConfig$name$Rot[1];

                  _this2.partsConfig[name].RotationalAngle = [x, y, 0];
                }
                _this2.changeZRotation(false);
              }
            },
            savePartsConfig: function savePartsConfig(data) {
              var parts = _this2.$store.state.filesNested;
              for (var key in parts) {
                var pathKey = parts[key].sourceFile.pathKey;
                var name = parts[key].config.filename;
                _store2.default.commit('SET_NESTED_FILE_CONFIG', {
                  pathKey: pathKey,
                  config: data[name]
                });
              }
            },
            savePlatesConfig: function savePlatesConfig(platesConfig) {
              _this2.config.manualTransform = [];
              var isErrors = false;
              _this2.platesConfig = platesConfig.reduce(function (acc, plate, inx) {
                if ((0, _keys2.default)(plate).length > 1) {
                  var index = acc.length + 1;
                  var plateName = 'plate ' + index;
                  var namedPlate = (0, _defineProperty3.default)({}, plateName, plate);
                  acc.push(namedPlate);
                  if (plate.errors) isErrors = true;
                }
                return acc;
              }, []);
              _this2.platesErrors = isErrors;
            },
            openRemovePlateModal: function openRemovePlateModal() {
              _this2.$modal.show('removeplatemodal');
            }
          };
          var files = { parts: [] };
          var configs = {
            config: _this2.config,
            printersConfig: _this2.printersConfig
          };
          if (_this2.nestedMode) {
            var partsNames = [];
            response.forEach(function (_ref3) {
              var config = _ref3.config,
                  data = _ref3.data;

              var _JSON$parse = JSON.parse(config.data),
                  sourceFilePathKey = _JSON$parse.sourceFilePathKey;

              var name = parts[sourceFilePathKey].config.filename;
              _store2.default.commit('SET_NESTED_FILE_URL', { url: data.url, sourceFilePathKey: sourceFilePathKey });
              files.parts.push(data.url);
              partsNames.push(name);
              _this2.partsConfig[name] = parts[sourceFilePathKey].config;
            });
            var nestedConfig = { allowZRotation: _this2.allowZRotation, partsNames: partsNames, isManualPlacement: _this2.isManualPlacement, partsConfig: _this2.partsConfig, margin: { marginX: _this2.config.marginX[0], marginY: _this2.config.marginY[0] } };
            configs.nestedConfig = nestedConfig;
            configs.config = (0, _entries2.default)(_this2.partsConfig)[0][1];
          } else {
            files.parts.push(response[0].data.url);
            files.supports = response.length > 1 && !_this2.config.isHideSupports ? response.filter(function (r, index) {
              return index > 0;
            }).map(function (r) {
              return r.data.url;
            }) : [];
          }
          _this2.viewer = new Atlas3DViewer.InputViewer(configs, files, function () {
            _this2.$nextTick(function () {
              _this2.viewer.init();
              _this2.viewer.animate();
              _this2.contextMenu = _this2.viewer.contextMenu;
            });
          }, function () {
            _this2.loading3JS = false;
          }, function (data) {
            _this2.inputViewerData = data;
            _this2.showSummary();
          }, callbacks);
        });
      });
    },
    changeZRotation: function changeZRotation(value) {
      this.allowZRotation = value;
      this.viewer.changeAllowZRotation(value);
      this.$modal.hide('zrotationmodal');
    },
    removePlate: function removePlate(value) {
      this.viewer.onRemovePlate(value);
      this.$modal.hide('removeplatemodal');
    },
    loadOutputViewer: function loadOutputViewer() {
      var _this3 = this;

      this.getPrintConfig().then(function (_ref4) {
        var data = _ref4.data;

        _store2.default.commit('SET_MATERIALS', data.config.materials);
        _store2.default.commit('SET_PRINTERS', data.config.printers);
        _this3.printersConfig = data.config.printers.reduce(function (acc, current) {
          return (0, _assign2.default)(_this3.printersConfig, (0, _defineProperty3.default)({}, current.name, current));
        }, {});
        return _store2.default.dispatch('_jobs/getJobOutput', _this3.$route.params.id);
      }).then(function (response) {
        _this3.jobOutput = response.data.JobOutput;
        _this3.isManualPlacement = _this3.jobOutput.job.config.manualPlacement;
        _this3.job = _this3.jobOutput.job;

        if (_this3.job.config.hasOwnProperty('filename_supp') && _this3.job.config.filename_supp.length > 0) {
          _this3.isSupportUploaded = true;
        }

        if (_this3.job.config && _this3.job.config.isCompensate && _this3.job.config.isCompensate[0]) {
          _this3.isCanCompensate = false;
        } else {
          _this3.isCanCompensate = true;
        }

        if (_this3.job.isNested) {
          return _store2.default.dispatch('_jobs/getNestedJobs', _this3.job.pathKey);
        } else {
          _this3.jobOptimization = (0, _helpers.jobDescription)(_this3.jobOutput.analysisId, _this3.jobOutput.objectiveId, _this3.isCompensated, true);
          return null;
        }
      }).then(function (nestedJobs) {
        var baseConfig = {
          jobOutputPathKey: _this3.jobOutput.pathKey,
          jobPathKey: _this3.job.pathKey,
          sourceFilePathKey: _this3.job.sourceFile.pathKey
        };
        var uploadedFileConfig = {
          sourceFilePathKey: _this3.job.sourceFile.pathKey
        };
        var uploadedSuppConfig = {
          jobPathKey: _this3.job.pathKey,
          sourceFilePathKey: _this3.job.sourceFile.pathKey
        };
        var promises = [];
        var stlFiles = [];
        var stlFilesCompensated = [];
        var jsonConfig = [];
        var binConfig = [];
        var binConfigCompensated = [];
        var suppFiles = [];
        var suppFilesCompensated = [];
        var legendConfig = [];
        var nestedConfig = [];
        var nestedPlateConfig = [];
        var recoaterWarning = [];

        if (nestedJobs) {
          _this3.nestedJobs = nestedJobs.data.allJobs;
          nestedPlateConfig.push(_this3.job.config);
          _this3.job.config = _this3.nestedJobs[0].config;
        }
        var checkSupports = function checkSupports(names) {
          var isRenishawPrinter = _this3.job.config.printer.match(/Renishaw/);
          var newNames = names.filter(function (name) {
            var isReneshawSupp = isRenishawPrinter && name.match(/Renishaw/);
            var isOtherSupp = !isRenishawPrinter && !name.match(/Renishaw/);
            if (name.match(/strengthen/)) {
              _this3.isStrengthenSupp = true;
              return true;
            }if (name.match(/polymer/)) {
              return false;
            }if (isReneshawSupp || isOtherSupp) {
              return true;
            }
          });
          return newNames;
        };
        var outputFiles = {};
        _this3.jobOutput.outputFiles.forEach(function (file) {
          if (!outputFiles.hasOwnProperty(file.name)) {
            outputFiles[file.name] = true;
            if (file.name.match(/_([XYN])?output\.stl$/) && !file.name.match(/_output_compensated\.stl$/) || file.name.match(/_new\.stl$/)) {
              if (_this3.isSupportUploaded) {
                stlFiles.push((0, _assign2.default)({ filename: _this3.job.config.filename }, uploadedFileConfig));
              } else {
                stlFiles.push((0, _assign2.default)({ filename: file.name }, baseConfig));
              }
            }
            if (file.name.match(/_output_compensated\.stl$/)) {
              stlFilesCompensated.push((0, _assign2.default)({ filename: file.name }, baseConfig));
            }
            if (file.name.match(/legend(_[xyN])?\.json$/)) {
              legendConfig.push((0, _assign2.default)({ filename: file.name }, baseConfig));
            }
            if (file.name.match(/disp_config\.json$/)) {
              jsonConfig.push((0, _assign2.default)({ filename: file.name }, baseConfig));
            }
            if (file.name.match(_this3.job.config.isStrengthSupp && _this3.job.config.isStrengthSupp[0] ? /disp_config_strengthen_supp$/ : /disp_config$/)) {
              binConfig.push((0, _assign2.default)({ filename: file.name }, baseConfig));
            }
            if (file.name.match(/disp_config_compensated$/)) {
              binConfigCompensated.push((0, _assign2.default)({ filename: file.name }, baseConfig));
            }
            if (file.name.match(/_0m\.stl$/) && !file.name.match(/_compensated_0m\.stl$/)) {
              if (_this3.isSupportUploaded) {
                _this3.job.config.filename_supp.forEach(function (fileSupp) {
                  suppFiles.push((0, _assign2.default)({ filename: fileSupp }, uploadedSuppConfig));
                });
                _this3.isHasSupports = true;
              } else {
                suppFiles.push((0, _assign2.default)({ filename: file.name }, baseConfig));
                _this3.isHasSupports = true;
              }
            }
            if (file.name.match(/_compensated_0m\.stl$/)) {
              suppFilesCompensated.push((0, _assign2.default)({ filename: file.name }, baseConfig));
            }
            if (file.name.match(/Config_nesting.json$|configNesting.json$/)) {
              nestedConfig.push((0, _assign2.default)({ filename: file.name }, baseConfig));
              _this3.nestedMode = true;
            }
            if (file.name.match(/warningMessage.json$/)) {
              recoaterWarning.push((0, _assign2.default)({ filename: file.name }, baseConfig));
            }
          }
        });
        if (_this3.nestedMode) {
          _this3.nestedJobs.forEach(function (job) {
            var nestedBaseConfig = {
              jobOutputPathKey: job.jobOutputs[0].pathKey,
              jobPathKey: job.pathKey,
              sourceFilePathKey: job.sourceFile.pathKey
            };
            var outputFiles = job.jobOutputs[0].outputFiles;
            var outputFilesKeys = {};
            outputFiles.forEach(function (file) {
              if (!outputFilesKeys.hasOwnProperty(file.name)) {
                outputFilesKeys[file.name] = true;
                if (file.name.match(/_output\.stl$/) && !file.name.match(/_compensated_output\.stl$/)) {
                  stlFiles.push((0, _assign2.default)({ filename: file.name }, nestedBaseConfig));
                  _this3.fileNames.push(file.name);
                  _this3.jobOptimizationNested.push((0, _helpers.jobDescription)(job.jobOutputs[0].analysisId, job.jobOutputs[0].objectiveId, false, true));
                }
                if (file.name.match(/_0m\.stl$/) && !file.name.match(/_compensated_0m\.stl$/) && !file.name.match(/^1_.*_Renishaw_0m\.stl$/) && !file.name.match(/_compensated_Renishaw_0m\.stl$/)) {
                  suppFiles.push((0, _assign2.default)({ filename: file.name }, nestedBaseConfig));
                  _this3.isHasSupports = true;
                }
                if (file.name.match(/Renishaw|strengthen\.stl/)) {
                  suppFiles.push((0, _assign2.default)({ filename: file.name }, nestedBaseConfig));
                }
                if (file.name.match(/disp_config$/)) {
                  binConfig.push((0, _assign2.default)({ filename: file.name }, nestedBaseConfig));
                }
              }
            });
          });
        }

        if (_this3.isCompensated) {
          promises.push(_this3.getFileUrl(stlFilesCompensated));
          promises.push(_this3.getFileUrl(suppFilesCompensated));
        } else {
          promises.push(_this3.getFileUrl(stlFiles));
          var supportFiles = suppFiles.reduce(function (acc, curr) {
            if (!acc[curr.filename]) {
              acc[curr.filename] = curr;
            }
            return acc;
          }, {});
          var newNames = checkSupports((0, _keys2.default)(supportFiles));
          promises.push(_this3.getFileUrl(newNames.map(function (filename) {
            return supportFiles[filename];
          })));
        }

        if (legendConfig.length > 0) {
          legendConfig.push(legendConfig.shift());
        }

        promises.push(_this3.getFileData(legendConfig));
        promises.push(_this3.getFileData(jsonConfig));
        if (_this3.isCompensated) {
          promises.push(_this3.getFileData(binConfigCompensated, true));
        } else {
          promises.push(_this3.getFileData(binConfig, true));
        }
        promises.push(_this3.getFileData(nestedConfig));
        promises.push(nestedPlateConfig);
        promises[7] = _this3.getFileData(recoaterWarning);

        _promise2.default.all(promises).then(function (responses) {
          if (responses[2]) {
            _this3.legends = 1;
          }

          if (responses[5] || responses[2] && (responses[2].length === 3 || responses[2].length === 4) || responses[3] && responses[3][0].dispZ || responses[4]) {
            _this3.legends = 1;
            _this3.showDirectionSelection = true;
            _this3.displacementDirectionN = responses[5] || responses[2] && responses[2].length === 4 || responses[3] && responses[3][0].dispZ || responses[4];
            if (_this3.displacementDirectionN) {
              _this3.displacementDirection = 'n';
            }
          }

          var nestedPositionWithRotation = false;

          if (responses[5]) {
            if (responses[5][0] && (responses[5][0].hasOwnProperty('nesting2d') || responses[5][0].hasOwnProperty('nesting2dWithRotation'))) {
              var nestingData = responses[5][0].hasOwnProperty('nesting2d') ? responses[5][0].nesting2d : responses[5][0].nesting2dWithRotation;
              nestedPositionWithRotation = !!responses[5][0].nesting2dWithRotation;
              var partsPositions = nestingData.reduce(function (result, currentPlate, index) {
                result['plate' + index] = currentPlate;
                return result;
              }, {});
              responses[5] = partsPositions;
            } else {
              responses[5] = responses[5][0];
            }
            _this3.nestedPlates = (0, _keys2.default)(responses[5]);
            _this3.nestedOptions = _this3.nestedPlates.concat(_this3.fileNames);
            _this3.nestedNames = _this3.nestedOptions.map(function (file, inx) {
              if (file.match(/^plate[0-9]+$/)) return 'Build plate #' + (inx + 1);
              return file;
            });
            _this3.currentPartName = _this3.nestedNames[0];
            _this3.legends = responses[0].length;
          }

          var files = {
            parts: responses[0],
            support: responses[1],
            legend: responses[2],
            displayConfig: responses[3],
            nestedPositionConfig: responses[5],
            nestedPlateConfig: responses[6]
          };

          if (responses[4] && responses[4].length > 0) {
            files.displayConfigBinary = responses[4];
          }

          if (_this3.isCompensated && !(responses[0] && responses[1])) {
            _this3.$router.replace({ name: 'ThreeJSViewer', params: { id: _this3.jobOutput.id, type: 'output' } });
            return;
          }

          var configs = {
            config: _this3.jobOutput.job.config,
            printersConfig: _this3.printersConfig,
            nestedPositionWithRotation: nestedPositionWithRotation,
            isManualPlacement: _this3.isManualPlacement
          };

          var callbacks = {
            init: function init() {
              _this3.$nextTick(function () {
                _this3.viewer.switchModifySupportsMode(_this3.modifySupportsMode);
                _this3.viewer.init();
                _this3.changePanelEvents();
                if (_this3.isSupportUploaded) {
                  _this3.viewer.uploadedSupport = true;
                }
                if (_this3.modifySupportsMode) {
                  _this3.viewer.addEventListeners();
                }
                _this3.viewer.animate();
              });
            },
            finishedLoading: function finishedLoading(data) {
              _this3.isHasOptionsFull = !!data.isHasOptionsFull;
              if (!_this3.isHasOptionsFull) {
                _this3.displacementOption = 'on';
                _this3.viewer.switchDistortionOption('on');
              }
              if (_this3.displacementDirectionN && !_this3.modifySupportsMode) {
                _this3.viewer.switchDistortion('n');
              }

              if ((responses[4] || responses[3] && responses[3][0].dispLegendZ) && !_this3.nestedMode) {
                if (responses[7] && responses[7][0] && responses[7][0].hasOwnProperty('warning_message')) {
                  if (responses[7][0].warning_message) {
                    _this3.isBladeCanCrush = true;
                    _this3.isBladeCanCrushMessage = responses[7][0].warning_message;
                  } else {
                    _this3.isBladeCanCrush = false;
                  }
                } else {
                  _this3.isBladeCanCrush = _this3.checkIsBladeCanCrush(_this3.job.config.layerThickness[0], data.maxDistortion);
                }
              } else if (_this3.nestedMode) {
                _this3.isBladeCanCrush = null;
                _this3.legendsData = data.legendsData;
                _this3.checkIsBladeCanCrushNested();
              }

              if (data.hasOwnProperty('isHasOptions')) {
                _this3.isHasOptions = data.isHasOptions;
              }

              if (_this3.modifySupportsMode) {
                _this3.modifySupportStructures();
              }
              _this3.loading3JS = false;
            },
            getCurvaturePerFaceData: function getCurvaturePerFaceData() {
              var getData = function getData(url, attempt) {
                return new _promise2.default(function (resolve, reject) {
                  return _this3.getURLData({ url: url }).then(function (response) {
                    resolve(response.data);
                  }).catch(function (err) {
                    if (err.response && err.response.status && err.response.status === 404 && attempt <= 30) {
                      attempt++;
                      var delay = 1500 * attempt;
                      if (attempt > 10) {
                        delay = 30000;
                      } else if (attempt > 3) {
                        delay = 8000;
                      }
                      setTimeout(function () {
                        resolve(getData(url, attempt));
                      }, delay);
                    } else {
                      reject(err);
                    }
                  });
                });
              };
              return new _promise2.default(function (resolve, reject) {
                _this3.paintByCurvature({
                  sourceFilePathKey: _this3.job.sourceFile.pathKey,
                  config: _this3.job.config
                }).then(function (response) {
                  return getData(response.data.url, 1);
                }).then(function (response) {
                  resolve(response);
                }).catch(function (err) {
                  reject(err);
                });
              });
            },
            curvatureLoading: function curvatureLoading(toggle) {
              if (toggle) {
                _this3.loading3JS = true;
                _this3.message = 'Preparing for selection of flat surface...';
              } else {
                _this3.loading3JS = false;
              }
            },
            switchBrushModeCallback: function switchBrushModeCallback() {
              _this3.brushMode = true;
            }
          };

          _this3.viewer = new Atlas3DViewer.OutputViewer(configs, files, callbacks);
        });
      }).catch(function (err) {
        _this3.errorHandling(err, location.reload);
      });
    },
    showSummary: function showSummary() {
      if (!this.nestedMode) {
        this.viewer.updateConfig(this.inputViewerData, this.config);
        this.$modal.show('summarymodal');
      } else {
        this.$modal.show('summarynestedmodal');
      }
    },
    submitInput: function submitInput() {
      var _this4 = this;

      var jobDescription = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.jobDescription = jobDescription;
      this.creatingJob = true;
      this.showOverlay = true;
      this.message = 'Creating Job';
      delete this.config.restrictOrientation;
      delete this.config.restrictFaces;
      var promise = function promise() {
        return _this4.updateJob({
          jobPathKey: _this4.$route.params.id,
          config: (0, _extends3.default)({}, _this4.config, { needRemesh: false }),
          jobDescription: jobDescription
        }).then(function (response) {
          _this4.message = 'Submitting Job';
          return _this4.submitJob({
            jobPathKey: response.data.jobPathKey,
            objectiveId: 0,
            analysisId: _this4.shouldPredict ? 3 : 1
          });
        });
      };
      if (!this.nestedMode && (this.restrictOrientation || this.restrictFaces)) {
        promise = function promise() {
          return _this4.updateJob({
            jobPathKey: _this4.submitJobData.jobPathKey,
            config: (0, _extends3.default)({}, _this4.config, { needRemesh: false }),
            jobDescription: jobDescription
          }).then(function (response) {
            _this4.message = 'Submitting job';
            return _this4.submitJob({
              jobPathKey: response.data.jobPathKey,
              objectiveId: _this4.submitJobData.objectiveId,
              analysisId: _this4.submitJobData.analysisId
            });
          });
        };
      }
      if (this.nestedMode) {
        this.$modal.hide('summarynestedmodal');
        if (this.allowZRotation) {
          this.config.deltaR = [360];
        }
        if (this.isManualPlacement) {
          if (!this.platesConfig.length) return;
          this.config.manualTransform = [];
          this.platesConfig.forEach(function (plate, inx) {
            var name = (0, _keys2.default)(plate);
            delete _this4.platesConfig[inx][name].errors;
            _this4.config.manualTransform.push(_this4.platesConfig[inx]);
          });
        }
        var parts = this.$store.state.filesNested;
        var nestedJobs = (0, _values2.default)(parts).map(function (file) {
          return {
            config: file.config,
            jobPathKey: file.jobPathKey
          };
        });
        promise = function promise() {
          return _this4.updateJob({
            config: (0, _extends3.default)({}, _this4.config, { needRemesh: false }),
            jobPathKey: _this4.job.pathKey,
            jobDescription: ''
          }).then(function () {
            return _this4.updateNestedJob({
              nestedJobs: nestedJobs,
              nestedJobName: _this4.nestedJobName,
              parentPathKey: _this4.job.pathKey
            });
          }).then(function (response) {
            _this4.message = 'Submitting Job';
            var partsData = response.data.map(function (file) {
              return {
                jobPathKey: file.jobPathKey,
                objectiveId: 0,
                analysisId: 3
              };
            });
            return _this4.submitNestedJob(partsData);
          });
        };
      }
      promise().then(function (success) {
        _this4.inputViewerData.viewer.destroy();
        _this4.viewer = null;
        _this4.refreshCredits();
        _this4.$router.replace({ name: 'Dash' });
      }).catch(function (err) {
        _this4.showOverlay = false;
        _this4.creatingJob = false;
        _this4.errorHandling(err, function () {
          _this4.$modal.show('summarymodal');
        });
      });
    },
    getFileUrl: function getFileUrl(config) {
      var _this5 = this;

      if (config.length > 0) {
        return _promise2.default.all(config.map(function (file) {
          return _this5.getDownloadURL(file).then(function (response) {
            return response.data.url;
          });
        }));
      } else {
        return null;
      }
    },
    getFileData: function getFileData(config, binary) {
      var _this6 = this;

      if (config.length > 0) {
        return _promise2.default.all(config.map(function (file) {
          return _this6.getDownloadURL(file).then(function (response) {
            if (binary) {
              return _this6.getURLData({ url: response.data.url, binary: true });
            } else {
              return _this6.getURLData({ url: response.data.url });
            }
          }).then(function (data) {
            return data.data;
          });
        }));
      } else {
        return null;
      }
    },
    toggleSupports: function toggleSupports() {
      var _this7 = this;

      if (this.showSupportsOutput) {
        this.viewer.HideSupp();
      } else {
        this.viewer.ShowSupp();
        this.loading3JS = true;
        this.message = 'Loading support structure';
        setTimeout(function () {
          _this7.viewer.ShowSupp().then(function () {
            _this7.loading3JS = false;
          });
        }, 50);
      }
      this.showSupportsOutput = !this.showSupportsOutput;
    },
    switchDistortionOption: function switchDistortionOption(option) {
      if (option === 'on') {
        this.viewer.addSupport();
      } else {
        this.viewer.removeSupport();
      }
      this.viewer.switchDistortionOption(option);
    },
    modifySupportStructures: function modifySupportStructures() {
      var _this8 = this;

      this.modifyMode = !this.modifyMode;
      this.viewer.modifyMode = this.modifyMode;
      this.showSupportsOutput = true;
      if (this.modifyMode) {
        this.viewer.HideSupp();
      } else {
        this.loading3JS = true;
        this.message = 'Loading support structure';
        setTimeout(function () {
          _this8.viewer.ShowSupp().then(function () {
            _this8.loading3JS = false;
          });
        }, 50);
      }
    },
    cMenuParallel: function cMenuParallel() {
      this.viewer.makeParallelToBuildPlate();
    },
    generateSupportStructures: function generateSupportStructures() {
      var _this9 = this;

      this.$modal.hide('modifycaution');
      var sourceFilePathKey = this.jobOutput.job.sourceFile.pathKey;
      var outputFilePathKey = this.jobOutput.pathKey;
      var filename = void 0;
      this.jobOutput.outputFiles.forEach(function (file) {
        if (file.name.match(/_output\.stl$/)) {
          filename = file.name;
        }
      });
      var config = (0, _assign2.default)(this.defaultConfig, this.jobOutput.job.config);
      config.AllowedFaces = this.viewer.getAllowedFaces();
      config.RestrictedFaces = this.viewer.getRestrictedFaces();
      config.RotationalAngle = [0, 0, 0];
      config.filename = filename;
      config.unit = 'mm';
      config.scaling = [1];
      this.creatingJob = true;
      this.showOverlay = true;
      this.message = 'Generating support structures';

      this.createJob({
        sourceFilePathKey: sourceFilePathKey,
        config: config
      }).then(function (response) {
        return _this9.submitJob({
          jobPathKey: response.data.jobPathKey,
          outputFilePathKey: outputFilePathKey,
          filename: filename,
          objectiveId: 0,
          analysisId: 99
        });
      }).then(function (response) {
        _this9.viewer.destroy();
        _this9.viewer = null;
        _this9.refreshCredits();
        _this9.$router.replace({ name: 'Dash' });
      }).catch(function (err) {
        _this9.creatingJob = false;
        _this9.showOverlay = false;
        _this9.errorHandling(err, _this9.generateSupportStructures);
      });
    },
    generateCompensated: function generateCompensated() {
      var _this10 = this;

      var sourceFilePathKey = this.jobOutput.job.sourceFile.pathKey;
      var config = (0, _assign2.default)(this.defaultConfig, this.jobOutput.job.config);
      config.isCompensate[0] = 1;
      this.creatingJob = true;
      this.showOverlay = true;
      this.message = 'Generating compensated STL';

      this.createJob({
        sourceFilePathKey: sourceFilePathKey,
        config: config
      }).then(function (response) {
        return _this10.submitJob({
          jobPathKey: response.data.jobPathKey,
          objectiveId: _this10.jobOutput.objectiveId,
          analysisId: _this10.jobOutput.analysisId
        });
      }).then(function (response) {
        _this10.viewer.destroy();
        _this10.viewer = null;
        _this10.refreshCredits();
        _this10.$router.replace({ name: 'Dash' });
      }).catch(function (err) {
        _this10.creatingJob = false;
        _this10.showOverlay = false;
        _this10.errorHandling(err, _this10.generateCompensated);
      });
    },
    convertUnits: function convertUnits(unit) {
      return unit * 1000;
    },
    switchBuildPlate: function switchBuildPlate() {
      var fileIndex = this.nestedPlate - this.nestedPlates.length;
      this.currentPartName = this.nestedNames[this.nestedPlate];
      if (fileIndex > -1) {
        this.jobOptimization = this.jobOptimizationNested[fileIndex];
        if (this.legendsData && this.legendsData[fileIndex]) {
          this.isBladeCanCrush = this.checkIsBladeCanCrush(this.jobOutput.job.config.layerThickness[0], this.legendsData[fileIndex][1]);
        }
      } else {
        this.checkIsBladeCanCrushNested();
        this.jobOptimization = null;
      }
      this.viewer.switchNestedPlates(this.nestedOptions[this.nestedPlate]);
    },
    switchFacetSelectionMode: function switchFacetSelectionMode(mode) {
      this.viewer.switchFacetSelectionMode(mode);
    },
    switchBrushMode: function switchBrushMode() {
      this.viewer.switchBrushMode(this.brushMode);
      if (!this.brushMode && this.brushBothSide) {
        this.brushBothSide = false;
        this.viewer.switchBrushSide(this.brushBothSide);
      }
    },
    switchBrushSide: function switchBrushSide() {
      this.viewer.switchBrushSide(this.brushBothSide);
      if (this.brushBothSide && !this.brushMode) {
        this.brushMode = true;
        this.viewer.switchBrushMode(this.brushMode);
      }
    },
    setBrushRadius: function setBrushRadius(event) {
      this.viewer.setBrushRadius(event);
    },
    setSupportTransparency: function setSupportTransparency(event, isStrength) {
      this.viewer.setSupportTransparency(event, isStrength);
    },
    setSelectionTolerance: function setSelectionTolerance(event) {
      this.viewer.setSelectionTolerance(event);
    },
    resetFaces: function resetFaces() {
      this.viewer.resetFaces();
    },
    checkLegend: function checkLegend(index) {
      if (this.nestedPlate >= this.nestedPlates.length) {
        return this.fileNames[index] === this.nestedOptions[this.nestedPlate];
      } else {
        return true;
      }
    },
    checkIsBladeCanCrush: function checkIsBladeCanCrush(layerThickness, maxDistortion) {
      return maxDistortion > layerThickness / 1000 * this.layerThicknessCrushcoefficient;
    },
    checkIsBladeCanCrushNested: function checkIsBladeCanCrushNested() {
      var _this11 = this;

      this.isBladeCanCrush = null;
      this.legendsData.forEach(function (legend) {
        if (_this11.checkIsBladeCanCrush(_this11.job.config.layerThickness[0], legend[1])) {
          _this11.isBladeCanCrush = true;
        }
      });
    }
  })
};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'WebGLDetect',
  methods: {
    detectWebGL: function detectWebGL() {
      var renderingContext = !!window.WebGLRenderingContext;
      if (renderingContext) {
        var canvas = document.createElement('canvas');
        var names = ['webgl', 'experimental-webgl', 'moz-webgl', 'webkit-3d'];
        var context = false;

        for (var i in names) {
          try {
            context = canvas.getContext(names[i]);
            if (context && typeof context.getParameter === 'function') {
              return 1;
            }
          } catch (e) {}
        }

        return 0;
      }

      return -1;
    }
  },
  created: function created() {
    this.$store.commit('SET_WEBGL_STATUS', this.detectWebGL());
  }
};

/***/ }),
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:'FontAwesome';src:url(" + __webpack_require__(444) + ");src:url(" + __webpack_require__(443) + "?#iefix&v=4.7.0) format('embedded-opentype'),url(" + __webpack_require__(446) + ") format('woff2'),url(" + __webpack_require__(447) + ") format('woff'),url(" + __webpack_require__(445) + ") format('truetype'),url(" + __webpack_require__(439) + "#fontawesomeregular) format('svg');font-weight:normal;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:solid .08em #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scale(-1, 1);-ms-transform:scale(-1, 1);transform:scale(-1, 1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scale(1, -1);-ms-transform:scale(1, -1);transform:scale(1, -1)}:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270,:root .fa-flip-horizontal,:root .fa-flip-vertical{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-remove:before,.fa-close:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-gear:before,.fa-cog:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-rotate-right:before,.fa-repeat:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-photo:before,.fa-image:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-warning:before,.fa-exclamation-triangle:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-gears:before,.fa-cogs:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-save:before,.fa-floppy-o:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-navicon:before,.fa-reorder:before,.fa-bars:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-unsorted:before,.fa-sort:before{content:\"\\F0DC\"}.fa-sort-down:before,.fa-sort-desc:before{content:\"\\F0DD\"}.fa-sort-up:before,.fa-sort-asc:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-legal:before,.fa-gavel:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-flash:before,.fa-bolt:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-paste:before,.fa-clipboard:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-unlink:before,.fa-chain-broken:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-toggle-down:before,.fa-caret-square-o-down:before{content:\"\\F150\"}.fa-toggle-up:before,.fa-caret-square-o-up:before{content:\"\\F151\"}.fa-toggle-right:before,.fa-caret-square-o-right:before{content:\"\\F152\"}.fa-euro:before,.fa-eur:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-rupee:before,.fa-inr:before{content:\"\\F156\"}.fa-cny:before,.fa-rmb:before,.fa-yen:before,.fa-jpy:before{content:\"\\F157\"}.fa-ruble:before,.fa-rouble:before,.fa-rub:before{content:\"\\F158\"}.fa-won:before,.fa-krw:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-toggle-left:before,.fa-caret-square-o-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-turkish-lira:before,.fa-try:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-institution:before,.fa-bank:before,.fa-university:before{content:\"\\F19C\"}.fa-mortar-board:before,.fa-graduation-cap:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-photo-o:before,.fa-file-picture-o:before,.fa-file-image-o:before{content:\"\\F1C5\"}.fa-file-zip-o:before,.fa-file-archive-o:before{content:\"\\F1C6\"}.fa-file-sound-o:before,.fa-file-audio-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-saver:before,.fa-support:before,.fa-life-ring:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-resistance:before,.fa-rebel:before{content:\"\\F1D0\"}.fa-ge:before,.fa-empire:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-y-combinator-square:before,.fa-yc-square:before,.fa-hacker-news:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-send:before,.fa-paper-plane:before{content:\"\\F1D8\"}.fa-send-o:before,.fa-paper-plane-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-soccer-ball-o:before,.fa-futbol-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-shekel:before,.fa-sheqel:before,.fa-ils:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-hotel:before,.fa-bed:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-yc:before,.fa-y-combinator:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery:before,.fa-battery-full:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-stop-o:before,.fa-hand-paper-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-tv:before,.fa-television:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-asl-interpreting:before,.fa-american-sign-language-interpreting:before{content:\"\\F2A3\"}.fa-deafness:before,.fa-hard-of-hearing:before,.fa-deaf:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-signing:before,.fa-sign-language:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-vcard:before,.fa-address-card:before{content:\"\\F2BB\"}.fa-vcard-o:before,.fa-address-card-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer:before,.fa-thermometer-full:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bathtub:before,.fa-s15:before,.fa-bath:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}\n", ""]);

// exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "/*!\r\n * Materialize v0.100.2 (http://materializecss.com)\r\n * Copyright 2014-2017 Materialize\r\n * MIT License (https://raw.githubusercontent.com/Dogfalo/materialize/master/LICENSE)\r\n */\r\n.materialize-red {\n  background-color: #e51c23 !important;\n}\n\n.materialize-red-text {\n  color: #e51c23 !important;\n}\n\n.materialize-red.lighten-5 {\n  background-color: #fdeaeb !important;\n}\n\n.materialize-red-text.text-lighten-5 {\n  color: #fdeaeb !important;\n}\n\n.materialize-red.lighten-4 {\n  background-color: #f8c1c3 !important;\n}\n\n.materialize-red-text.text-lighten-4 {\n  color: #f8c1c3 !important;\n}\n\n.materialize-red.lighten-3 {\n  background-color: #f3989b !important;\n}\n\n.materialize-red-text.text-lighten-3 {\n  color: #f3989b !important;\n}\n\n.materialize-red.lighten-2 {\n  background-color: #ee6e73 !important;\n}\n\n.materialize-red-text.text-lighten-2 {\n  color: #ee6e73 !important;\n}\n\n.materialize-red.lighten-1 {\n  background-color: #ea454b !important;\n}\n\n.materialize-red-text.text-lighten-1 {\n  color: #ea454b !important;\n}\n\n.materialize-red.darken-1 {\n  background-color: #d0181e !important;\n}\n\n.materialize-red-text.text-darken-1 {\n  color: #d0181e !important;\n}\n\n.materialize-red.darken-2 {\n  background-color: #b9151b !important;\n}\n\n.materialize-red-text.text-darken-2 {\n  color: #b9151b !important;\n}\n\n.materialize-red.darken-3 {\n  background-color: #a21318 !important;\n}\n\n.materialize-red-text.text-darken-3 {\n  color: #a21318 !important;\n}\n\n.materialize-red.darken-4 {\n  background-color: #8b1014 !important;\n}\n\n.materialize-red-text.text-darken-4 {\n  color: #8b1014 !important;\n}\n\n.red {\n  background-color: #F44336 !important;\n}\n\n.red-text {\n  color: #F44336 !important;\n}\n\n.red.lighten-5 {\n  background-color: #FFEBEE !important;\n}\n\n.red-text.text-lighten-5 {\n  color: #FFEBEE !important;\n}\n\n.red.lighten-4 {\n  background-color: #FFCDD2 !important;\n}\n\n.red-text.text-lighten-4 {\n  color: #FFCDD2 !important;\n}\n\n.red.lighten-3 {\n  background-color: #EF9A9A !important;\n}\n\n.red-text.text-lighten-3 {\n  color: #EF9A9A !important;\n}\n\n.red.lighten-2 {\n  background-color: #E57373 !important;\n}\n\n.red-text.text-lighten-2 {\n  color: #E57373 !important;\n}\n\n.red.lighten-1 {\n  background-color: #EF5350 !important;\n}\n\n.red-text.text-lighten-1 {\n  color: #EF5350 !important;\n}\n\n.red.darken-1 {\n  background-color: #E53935 !important;\n}\n\n.red-text.text-darken-1 {\n  color: #E53935 !important;\n}\n\n.red.darken-2 {\n  background-color: #D32F2F !important;\n}\n\n.red-text.text-darken-2 {\n  color: #D32F2F !important;\n}\n\n.red.darken-3 {\n  background-color: #C62828 !important;\n}\n\n.red-text.text-darken-3 {\n  color: #C62828 !important;\n}\n\n.red.darken-4 {\n  background-color: #B71C1C !important;\n}\n\n.red-text.text-darken-4 {\n  color: #B71C1C !important;\n}\n\n.red.accent-1 {\n  background-color: #FF8A80 !important;\n}\n\n.red-text.text-accent-1 {\n  color: #FF8A80 !important;\n}\n\n.red.accent-2 {\n  background-color: #FF5252 !important;\n}\n\n.red-text.text-accent-2 {\n  color: #FF5252 !important;\n}\n\n.red.accent-3 {\n  background-color: #FF1744 !important;\n}\n\n.red-text.text-accent-3 {\n  color: #FF1744 !important;\n}\n\n.red.accent-4 {\n  background-color: #D50000 !important;\n}\n\n.red-text.text-accent-4 {\n  color: #D50000 !important;\n}\n\n.pink {\n  background-color: #e91e63 !important;\n}\n\n.pink-text {\n  color: #e91e63 !important;\n}\n\n.pink.lighten-5 {\n  background-color: #fce4ec !important;\n}\n\n.pink-text.text-lighten-5 {\n  color: #fce4ec !important;\n}\n\n.pink.lighten-4 {\n  background-color: #f8bbd0 !important;\n}\n\n.pink-text.text-lighten-4 {\n  color: #f8bbd0 !important;\n}\n\n.pink.lighten-3 {\n  background-color: #f48fb1 !important;\n}\n\n.pink-text.text-lighten-3 {\n  color: #f48fb1 !important;\n}\n\n.pink.lighten-2 {\n  background-color: #f06292 !important;\n}\n\n.pink-text.text-lighten-2 {\n  color: #f06292 !important;\n}\n\n.pink.lighten-1 {\n  background-color: #ec407a !important;\n}\n\n.pink-text.text-lighten-1 {\n  color: #ec407a !important;\n}\n\n.pink.darken-1 {\n  background-color: #d81b60 !important;\n}\n\n.pink-text.text-darken-1 {\n  color: #d81b60 !important;\n}\n\n.pink.darken-2 {\n  background-color: #c2185b !important;\n}\n\n.pink-text.text-darken-2 {\n  color: #c2185b !important;\n}\n\n.pink.darken-3 {\n  background-color: #ad1457 !important;\n}\n\n.pink-text.text-darken-3 {\n  color: #ad1457 !important;\n}\n\n.pink.darken-4 {\n  background-color: #880e4f !important;\n}\n\n.pink-text.text-darken-4 {\n  color: #880e4f !important;\n}\n\n.pink.accent-1 {\n  background-color: #ff80ab !important;\n}\n\n.pink-text.text-accent-1 {\n  color: #ff80ab !important;\n}\n\n.pink.accent-2 {\n  background-color: #ff4081 !important;\n}\n\n.pink-text.text-accent-2 {\n  color: #ff4081 !important;\n}\n\n.pink.accent-3 {\n  background-color: #f50057 !important;\n}\n\n.pink-text.text-accent-3 {\n  color: #f50057 !important;\n}\n\n.pink.accent-4 {\n  background-color: #c51162 !important;\n}\n\n.pink-text.text-accent-4 {\n  color: #c51162 !important;\n}\n\n.purple {\n  background-color: #9c27b0 !important;\n}\n\n.purple-text {\n  color: #9c27b0 !important;\n}\n\n.purple.lighten-5 {\n  background-color: #f3e5f5 !important;\n}\n\n.purple-text.text-lighten-5 {\n  color: #f3e5f5 !important;\n}\n\n.purple.lighten-4 {\n  background-color: #e1bee7 !important;\n}\n\n.purple-text.text-lighten-4 {\n  color: #e1bee7 !important;\n}\n\n.purple.lighten-3 {\n  background-color: #ce93d8 !important;\n}\n\n.purple-text.text-lighten-3 {\n  color: #ce93d8 !important;\n}\n\n.purple.lighten-2 {\n  background-color: #ba68c8 !important;\n}\n\n.purple-text.text-lighten-2 {\n  color: #ba68c8 !important;\n}\n\n.purple.lighten-1 {\n  background-color: #ab47bc !important;\n}\n\n.purple-text.text-lighten-1 {\n  color: #ab47bc !important;\n}\n\n.purple.darken-1 {\n  background-color: #8e24aa !important;\n}\n\n.purple-text.text-darken-1 {\n  color: #8e24aa !important;\n}\n\n.purple.darken-2 {\n  background-color: #7b1fa2 !important;\n}\n\n.purple-text.text-darken-2 {\n  color: #7b1fa2 !important;\n}\n\n.purple.darken-3 {\n  background-color: #6a1b9a !important;\n}\n\n.purple-text.text-darken-3 {\n  color: #6a1b9a !important;\n}\n\n.purple.darken-4 {\n  background-color: #4a148c !important;\n}\n\n.purple-text.text-darken-4 {\n  color: #4a148c !important;\n}\n\n.purple.accent-1 {\n  background-color: #ea80fc !important;\n}\n\n.purple-text.text-accent-1 {\n  color: #ea80fc !important;\n}\n\n.purple.accent-2 {\n  background-color: #e040fb !important;\n}\n\n.purple-text.text-accent-2 {\n  color: #e040fb !important;\n}\n\n.purple.accent-3 {\n  background-color: #d500f9 !important;\n}\n\n.purple-text.text-accent-3 {\n  color: #d500f9 !important;\n}\n\n.purple.accent-4 {\n  background-color: #aa00ff !important;\n}\n\n.purple-text.text-accent-4 {\n  color: #aa00ff !important;\n}\n\n.deep-purple {\n  background-color: #673ab7 !important;\n}\n\n.deep-purple-text {\n  color: #673ab7 !important;\n}\n\n.deep-purple.lighten-5 {\n  background-color: #ede7f6 !important;\n}\n\n.deep-purple-text.text-lighten-5 {\n  color: #ede7f6 !important;\n}\n\n.deep-purple.lighten-4 {\n  background-color: #d1c4e9 !important;\n}\n\n.deep-purple-text.text-lighten-4 {\n  color: #d1c4e9 !important;\n}\n\n.deep-purple.lighten-3 {\n  background-color: #b39ddb !important;\n}\n\n.deep-purple-text.text-lighten-3 {\n  color: #b39ddb !important;\n}\n\n.deep-purple.lighten-2 {\n  background-color: #9575cd !important;\n}\n\n.deep-purple-text.text-lighten-2 {\n  color: #9575cd !important;\n}\n\n.deep-purple.lighten-1 {\n  background-color: #7e57c2 !important;\n}\n\n.deep-purple-text.text-lighten-1 {\n  color: #7e57c2 !important;\n}\n\n.deep-purple.darken-1 {\n  background-color: #5e35b1 !important;\n}\n\n.deep-purple-text.text-darken-1 {\n  color: #5e35b1 !important;\n}\n\n.deep-purple.darken-2 {\n  background-color: #512da8 !important;\n}\n\n.deep-purple-text.text-darken-2 {\n  color: #512da8 !important;\n}\n\n.deep-purple.darken-3 {\n  background-color: #4527a0 !important;\n}\n\n.deep-purple-text.text-darken-3 {\n  color: #4527a0 !important;\n}\n\n.deep-purple.darken-4 {\n  background-color: #311b92 !important;\n}\n\n.deep-purple-text.text-darken-4 {\n  color: #311b92 !important;\n}\n\n.deep-purple.accent-1 {\n  background-color: #b388ff !important;\n}\n\n.deep-purple-text.text-accent-1 {\n  color: #b388ff !important;\n}\n\n.deep-purple.accent-2 {\n  background-color: #7c4dff !important;\n}\n\n.deep-purple-text.text-accent-2 {\n  color: #7c4dff !important;\n}\n\n.deep-purple.accent-3 {\n  background-color: #651fff !important;\n}\n\n.deep-purple-text.text-accent-3 {\n  color: #651fff !important;\n}\n\n.deep-purple.accent-4 {\n  background-color: #6200ea !important;\n}\n\n.deep-purple-text.text-accent-4 {\n  color: #6200ea !important;\n}\n\n.indigo {\n  background-color: #3f51b5 !important;\n}\n\n.indigo-text {\n  color: #3f51b5 !important;\n}\n\n.indigo.lighten-5 {\n  background-color: #e8eaf6 !important;\n}\n\n.indigo-text.text-lighten-5 {\n  color: #e8eaf6 !important;\n}\n\n.indigo.lighten-4 {\n  background-color: #c5cae9 !important;\n}\n\n.indigo-text.text-lighten-4 {\n  color: #c5cae9 !important;\n}\n\n.indigo.lighten-3 {\n  background-color: #9fa8da !important;\n}\n\n.indigo-text.text-lighten-3 {\n  color: #9fa8da !important;\n}\n\n.indigo.lighten-2 {\n  background-color: #7986cb !important;\n}\n\n.indigo-text.text-lighten-2 {\n  color: #7986cb !important;\n}\n\n.indigo.lighten-1 {\n  background-color: #5c6bc0 !important;\n}\n\n.indigo-text.text-lighten-1 {\n  color: #5c6bc0 !important;\n}\n\n.indigo.darken-1 {\n  background-color: #3949ab !important;\n}\n\n.indigo-text.text-darken-1 {\n  color: #3949ab !important;\n}\n\n.indigo.darken-2 {\n  background-color: #303f9f !important;\n}\n\n.indigo-text.text-darken-2 {\n  color: #303f9f !important;\n}\n\n.indigo.darken-3 {\n  background-color: #283593 !important;\n}\n\n.indigo-text.text-darken-3 {\n  color: #283593 !important;\n}\n\n.indigo.darken-4 {\n  background-color: #1a237e !important;\n}\n\n.indigo-text.text-darken-4 {\n  color: #1a237e !important;\n}\n\n.indigo.accent-1 {\n  background-color: #8c9eff !important;\n}\n\n.indigo-text.text-accent-1 {\n  color: #8c9eff !important;\n}\n\n.indigo.accent-2 {\n  background-color: #536dfe !important;\n}\n\n.indigo-text.text-accent-2 {\n  color: #536dfe !important;\n}\n\n.indigo.accent-3 {\n  background-color: #3d5afe !important;\n}\n\n.indigo-text.text-accent-3 {\n  color: #3d5afe !important;\n}\n\n.indigo.accent-4 {\n  background-color: #304ffe !important;\n}\n\n.indigo-text.text-accent-4 {\n  color: #304ffe !important;\n}\n\n.blue {\n  background-color: #2196F3 !important;\n}\n\n.blue-text {\n  color: #2196F3 !important;\n}\n\n.blue.lighten-5 {\n  background-color: #E3F2FD !important;\n}\n\n.blue-text.text-lighten-5 {\n  color: #E3F2FD !important;\n}\n\n.blue.lighten-4 {\n  background-color: #BBDEFB !important;\n}\n\n.blue-text.text-lighten-4 {\n  color: #BBDEFB !important;\n}\n\n.blue.lighten-3 {\n  background-color: #90CAF9 !important;\n}\n\n.blue-text.text-lighten-3 {\n  color: #90CAF9 !important;\n}\n\n.blue.lighten-2 {\n  background-color: #64B5F6 !important;\n}\n\n.blue-text.text-lighten-2 {\n  color: #64B5F6 !important;\n}\n\n.blue.lighten-1 {\n  background-color: #42A5F5 !important;\n}\n\n.blue-text.text-lighten-1 {\n  color: #42A5F5 !important;\n}\n\n.blue.darken-1 {\n  background-color: #1E88E5 !important;\n}\n\n.blue-text.text-darken-1 {\n  color: #1E88E5 !important;\n}\n\n.blue.darken-2 {\n  background-color: #1976D2 !important;\n}\n\n.blue-text.text-darken-2 {\n  color: #1976D2 !important;\n}\n\n.blue.darken-3 {\n  background-color: #1565C0 !important;\n}\n\n.blue-text.text-darken-3 {\n  color: #1565C0 !important;\n}\n\n.blue.darken-4 {\n  background-color: #0D47A1 !important;\n}\n\n.blue-text.text-darken-4 {\n  color: #0D47A1 !important;\n}\n\n.blue.accent-1 {\n  background-color: #82B1FF !important;\n}\n\n.blue-text.text-accent-1 {\n  color: #82B1FF !important;\n}\n\n.blue.accent-2 {\n  background-color: #448AFF !important;\n}\n\n.blue-text.text-accent-2 {\n  color: #448AFF !important;\n}\n\n.blue.accent-3 {\n  background-color: #2979FF !important;\n}\n\n.blue-text.text-accent-3 {\n  color: #2979FF !important;\n}\n\n.blue.accent-4 {\n  background-color: #2962FF !important;\n}\n\n.blue-text.text-accent-4 {\n  color: #2962FF !important;\n}\n\n.light-blue {\n  background-color: #03a9f4 !important;\n}\n\n.light-blue-text {\n  color: #03a9f4 !important;\n}\n\n.light-blue.lighten-5 {\n  background-color: #e1f5fe !important;\n}\n\n.light-blue-text.text-lighten-5 {\n  color: #e1f5fe !important;\n}\n\n.light-blue.lighten-4 {\n  background-color: #b3e5fc !important;\n}\n\n.light-blue-text.text-lighten-4 {\n  color: #b3e5fc !important;\n}\n\n.light-blue.lighten-3 {\n  background-color: #81d4fa !important;\n}\n\n.light-blue-text.text-lighten-3 {\n  color: #81d4fa !important;\n}\n\n.light-blue.lighten-2 {\n  background-color: #4fc3f7 !important;\n}\n\n.light-blue-text.text-lighten-2 {\n  color: #4fc3f7 !important;\n}\n\n.light-blue.lighten-1 {\n  background-color: #29b6f6 !important;\n}\n\n.light-blue-text.text-lighten-1 {\n  color: #29b6f6 !important;\n}\n\n.light-blue.darken-1 {\n  background-color: #039be5 !important;\n}\n\n.light-blue-text.text-darken-1 {\n  color: #039be5 !important;\n}\n\n.light-blue.darken-2 {\n  background-color: #0288d1 !important;\n}\n\n.light-blue-text.text-darken-2 {\n  color: #0288d1 !important;\n}\n\n.light-blue.darken-3 {\n  background-color: #0277bd !important;\n}\n\n.light-blue-text.text-darken-3 {\n  color: #0277bd !important;\n}\n\n.light-blue.darken-4 {\n  background-color: #01579b !important;\n}\n\n.light-blue-text.text-darken-4 {\n  color: #01579b !important;\n}\n\n.light-blue.accent-1 {\n  background-color: #80d8ff !important;\n}\n\n.light-blue-text.text-accent-1 {\n  color: #80d8ff !important;\n}\n\n.light-blue.accent-2 {\n  background-color: #40c4ff !important;\n}\n\n.light-blue-text.text-accent-2 {\n  color: #40c4ff !important;\n}\n\n.light-blue.accent-3 {\n  background-color: #00b0ff !important;\n}\n\n.light-blue-text.text-accent-3 {\n  color: #00b0ff !important;\n}\n\n.light-blue.accent-4 {\n  background-color: #0091ea !important;\n}\n\n.light-blue-text.text-accent-4 {\n  color: #0091ea !important;\n}\n\n.cyan {\n  background-color: #00bcd4 !important;\n}\n\n.cyan-text {\n  color: #00bcd4 !important;\n}\n\n.cyan.lighten-5 {\n  background-color: #e0f7fa !important;\n}\n\n.cyan-text.text-lighten-5 {\n  color: #e0f7fa !important;\n}\n\n.cyan.lighten-4 {\n  background-color: #b2ebf2 !important;\n}\n\n.cyan-text.text-lighten-4 {\n  color: #b2ebf2 !important;\n}\n\n.cyan.lighten-3 {\n  background-color: #80deea !important;\n}\n\n.cyan-text.text-lighten-3 {\n  color: #80deea !important;\n}\n\n.cyan.lighten-2 {\n  background-color: #4dd0e1 !important;\n}\n\n.cyan-text.text-lighten-2 {\n  color: #4dd0e1 !important;\n}\n\n.cyan.lighten-1 {\n  background-color: #26c6da !important;\n}\n\n.cyan-text.text-lighten-1 {\n  color: #26c6da !important;\n}\n\n.cyan.darken-1 {\n  background-color: #00acc1 !important;\n}\n\n.cyan-text.text-darken-1 {\n  color: #00acc1 !important;\n}\n\n.cyan.darken-2 {\n  background-color: #0097a7 !important;\n}\n\n.cyan-text.text-darken-2 {\n  color: #0097a7 !important;\n}\n\n.cyan.darken-3 {\n  background-color: #00838f !important;\n}\n\n.cyan-text.text-darken-3 {\n  color: #00838f !important;\n}\n\n.cyan.darken-4 {\n  background-color: #006064 !important;\n}\n\n.cyan-text.text-darken-4 {\n  color: #006064 !important;\n}\n\n.cyan.accent-1 {\n  background-color: #84ffff !important;\n}\n\n.cyan-text.text-accent-1 {\n  color: #84ffff !important;\n}\n\n.cyan.accent-2 {\n  background-color: #18ffff !important;\n}\n\n.cyan-text.text-accent-2 {\n  color: #18ffff !important;\n}\n\n.cyan.accent-3 {\n  background-color: #00e5ff !important;\n}\n\n.cyan-text.text-accent-3 {\n  color: #00e5ff !important;\n}\n\n.cyan.accent-4 {\n  background-color: #00b8d4 !important;\n}\n\n.cyan-text.text-accent-4 {\n  color: #00b8d4 !important;\n}\n\n.teal {\n  background-color: #009688 !important;\n}\n\n.teal-text {\n  color: #009688 !important;\n}\n\n.teal.lighten-5 {\n  background-color: #e0f2f1 !important;\n}\n\n.teal-text.text-lighten-5 {\n  color: #e0f2f1 !important;\n}\n\n.teal.lighten-4 {\n  background-color: #b2dfdb !important;\n}\n\n.teal-text.text-lighten-4 {\n  color: #b2dfdb !important;\n}\n\n.teal.lighten-3 {\n  background-color: #80cbc4 !important;\n}\n\n.teal-text.text-lighten-3 {\n  color: #80cbc4 !important;\n}\n\n.teal.lighten-2 {\n  background-color: #4db6ac !important;\n}\n\n.teal-text.text-lighten-2 {\n  color: #4db6ac !important;\n}\n\n.teal.lighten-1 {\n  background-color: #26a69a !important;\n}\n\n.teal-text.text-lighten-1 {\n  color: #26a69a !important;\n}\n\n.teal.darken-1 {\n  background-color: #00897b !important;\n}\n\n.teal-text.text-darken-1 {\n  color: #00897b !important;\n}\n\n.teal.darken-2 {\n  background-color: #00796b !important;\n}\n\n.teal-text.text-darken-2 {\n  color: #00796b !important;\n}\n\n.teal.darken-3 {\n  background-color: #00695c !important;\n}\n\n.teal-text.text-darken-3 {\n  color: #00695c !important;\n}\n\n.teal.darken-4 {\n  background-color: #004d40 !important;\n}\n\n.teal-text.text-darken-4 {\n  color: #004d40 !important;\n}\n\n.teal.accent-1 {\n  background-color: #a7ffeb !important;\n}\n\n.teal-text.text-accent-1 {\n  color: #a7ffeb !important;\n}\n\n.teal.accent-2 {\n  background-color: #64ffda !important;\n}\n\n.teal-text.text-accent-2 {\n  color: #64ffda !important;\n}\n\n.teal.accent-3 {\n  background-color: #1de9b6 !important;\n}\n\n.teal-text.text-accent-3 {\n  color: #1de9b6 !important;\n}\n\n.teal.accent-4 {\n  background-color: #00bfa5 !important;\n}\n\n.teal-text.text-accent-4 {\n  color: #00bfa5 !important;\n}\n\n.green {\n  background-color: #4CAF50 !important;\n}\n\n.green-text {\n  color: #4CAF50 !important;\n}\n\n.green.lighten-5 {\n  background-color: #E8F5E9 !important;\n}\n\n.green-text.text-lighten-5 {\n  color: #E8F5E9 !important;\n}\n\n.green.lighten-4 {\n  background-color: #C8E6C9 !important;\n}\n\n.green-text.text-lighten-4 {\n  color: #C8E6C9 !important;\n}\n\n.green.lighten-3 {\n  background-color: #A5D6A7 !important;\n}\n\n.green-text.text-lighten-3 {\n  color: #A5D6A7 !important;\n}\n\n.green.lighten-2 {\n  background-color: #81C784 !important;\n}\n\n.green-text.text-lighten-2 {\n  color: #81C784 !important;\n}\n\n.green.lighten-1 {\n  background-color: #66BB6A !important;\n}\n\n.green-text.text-lighten-1 {\n  color: #66BB6A !important;\n}\n\n.green.darken-1 {\n  background-color: #43A047 !important;\n}\n\n.green-text.text-darken-1 {\n  color: #43A047 !important;\n}\n\n.green.darken-2 {\n  background-color: #388E3C !important;\n}\n\n.green-text.text-darken-2 {\n  color: #388E3C !important;\n}\n\n.green.darken-3 {\n  background-color: #2E7D32 !important;\n}\n\n.green-text.text-darken-3 {\n  color: #2E7D32 !important;\n}\n\n.green.darken-4 {\n  background-color: #1B5E20 !important;\n}\n\n.green-text.text-darken-4 {\n  color: #1B5E20 !important;\n}\n\n.green.accent-1 {\n  background-color: #B9F6CA !important;\n}\n\n.green-text.text-accent-1 {\n  color: #B9F6CA !important;\n}\n\n.green.accent-2 {\n  background-color: #69F0AE !important;\n}\n\n.green-text.text-accent-2 {\n  color: #69F0AE !important;\n}\n\n.green.accent-3 {\n  background-color: #00E676 !important;\n}\n\n.green-text.text-accent-3 {\n  color: #00E676 !important;\n}\n\n.green.accent-4 {\n  background-color: #00C853 !important;\n}\n\n.green-text.text-accent-4 {\n  color: #00C853 !important;\n}\n\n.light-green {\n  background-color: #8bc34a !important;\n}\n\n.light-green-text {\n  color: #8bc34a !important;\n}\n\n.light-green.lighten-5 {\n  background-color: #f1f8e9 !important;\n}\n\n.light-green-text.text-lighten-5 {\n  color: #f1f8e9 !important;\n}\n\n.light-green.lighten-4 {\n  background-color: #dcedc8 !important;\n}\n\n.light-green-text.text-lighten-4 {\n  color: #dcedc8 !important;\n}\n\n.light-green.lighten-3 {\n  background-color: #c5e1a5 !important;\n}\n\n.light-green-text.text-lighten-3 {\n  color: #c5e1a5 !important;\n}\n\n.light-green.lighten-2 {\n  background-color: #aed581 !important;\n}\n\n.light-green-text.text-lighten-2 {\n  color: #aed581 !important;\n}\n\n.light-green.lighten-1 {\n  background-color: #9ccc65 !important;\n}\n\n.light-green-text.text-lighten-1 {\n  color: #9ccc65 !important;\n}\n\n.light-green.darken-1 {\n  background-color: #7cb342 !important;\n}\n\n.light-green-text.text-darken-1 {\n  color: #7cb342 !important;\n}\n\n.light-green.darken-2 {\n  background-color: #689f38 !important;\n}\n\n.light-green-text.text-darken-2 {\n  color: #689f38 !important;\n}\n\n.light-green.darken-3 {\n  background-color: #558b2f !important;\n}\n\n.light-green-text.text-darken-3 {\n  color: #558b2f !important;\n}\n\n.light-green.darken-4 {\n  background-color: #33691e !important;\n}\n\n.light-green-text.text-darken-4 {\n  color: #33691e !important;\n}\n\n.light-green.accent-1 {\n  background-color: #ccff90 !important;\n}\n\n.light-green-text.text-accent-1 {\n  color: #ccff90 !important;\n}\n\n.light-green.accent-2 {\n  background-color: #b2ff59 !important;\n}\n\n.light-green-text.text-accent-2 {\n  color: #b2ff59 !important;\n}\n\n.light-green.accent-3 {\n  background-color: #76ff03 !important;\n}\n\n.light-green-text.text-accent-3 {\n  color: #76ff03 !important;\n}\n\n.light-green.accent-4 {\n  background-color: #64dd17 !important;\n}\n\n.light-green-text.text-accent-4 {\n  color: #64dd17 !important;\n}\n\n.lime {\n  background-color: #cddc39 !important;\n}\n\n.lime-text {\n  color: #cddc39 !important;\n}\n\n.lime.lighten-5 {\n  background-color: #f9fbe7 !important;\n}\n\n.lime-text.text-lighten-5 {\n  color: #f9fbe7 !important;\n}\n\n.lime.lighten-4 {\n  background-color: #f0f4c3 !important;\n}\n\n.lime-text.text-lighten-4 {\n  color: #f0f4c3 !important;\n}\n\n.lime.lighten-3 {\n  background-color: #e6ee9c !important;\n}\n\n.lime-text.text-lighten-3 {\n  color: #e6ee9c !important;\n}\n\n.lime.lighten-2 {\n  background-color: #dce775 !important;\n}\n\n.lime-text.text-lighten-2 {\n  color: #dce775 !important;\n}\n\n.lime.lighten-1 {\n  background-color: #d4e157 !important;\n}\n\n.lime-text.text-lighten-1 {\n  color: #d4e157 !important;\n}\n\n.lime.darken-1 {\n  background-color: #c0ca33 !important;\n}\n\n.lime-text.text-darken-1 {\n  color: #c0ca33 !important;\n}\n\n.lime.darken-2 {\n  background-color: #afb42b !important;\n}\n\n.lime-text.text-darken-2 {\n  color: #afb42b !important;\n}\n\n.lime.darken-3 {\n  background-color: #9e9d24 !important;\n}\n\n.lime-text.text-darken-3 {\n  color: #9e9d24 !important;\n}\n\n.lime.darken-4 {\n  background-color: #827717 !important;\n}\n\n.lime-text.text-darken-4 {\n  color: #827717 !important;\n}\n\n.lime.accent-1 {\n  background-color: #f4ff81 !important;\n}\n\n.lime-text.text-accent-1 {\n  color: #f4ff81 !important;\n}\n\n.lime.accent-2 {\n  background-color: #eeff41 !important;\n}\n\n.lime-text.text-accent-2 {\n  color: #eeff41 !important;\n}\n\n.lime.accent-3 {\n  background-color: #c6ff00 !important;\n}\n\n.lime-text.text-accent-3 {\n  color: #c6ff00 !important;\n}\n\n.lime.accent-4 {\n  background-color: #aeea00 !important;\n}\n\n.lime-text.text-accent-4 {\n  color: #aeea00 !important;\n}\n\n.yellow {\n  background-color: #ffeb3b !important;\n}\n\n.yellow-text {\n  color: #ffeb3b !important;\n}\n\n.yellow.lighten-5 {\n  background-color: #fffde7 !important;\n}\n\n.yellow-text.text-lighten-5 {\n  color: #fffde7 !important;\n}\n\n.yellow.lighten-4 {\n  background-color: #fff9c4 !important;\n}\n\n.yellow-text.text-lighten-4 {\n  color: #fff9c4 !important;\n}\n\n.yellow.lighten-3 {\n  background-color: #fff59d !important;\n}\n\n.yellow-text.text-lighten-3 {\n  color: #fff59d !important;\n}\n\n.yellow.lighten-2 {\n  background-color: #fff176 !important;\n}\n\n.yellow-text.text-lighten-2 {\n  color: #fff176 !important;\n}\n\n.yellow.lighten-1 {\n  background-color: #ffee58 !important;\n}\n\n.yellow-text.text-lighten-1 {\n  color: #ffee58 !important;\n}\n\n.yellow.darken-1 {\n  background-color: #fdd835 !important;\n}\n\n.yellow-text.text-darken-1 {\n  color: #fdd835 !important;\n}\n\n.yellow.darken-2 {\n  background-color: #fbc02d !important;\n}\n\n.yellow-text.text-darken-2 {\n  color: #fbc02d !important;\n}\n\n.yellow.darken-3 {\n  background-color: #f9a825 !important;\n}\n\n.yellow-text.text-darken-3 {\n  color: #f9a825 !important;\n}\n\n.yellow.darken-4 {\n  background-color: #f57f17 !important;\n}\n\n.yellow-text.text-darken-4 {\n  color: #f57f17 !important;\n}\n\n.yellow.accent-1 {\n  background-color: #ffff8d !important;\n}\n\n.yellow-text.text-accent-1 {\n  color: #ffff8d !important;\n}\n\n.yellow.accent-2 {\n  background-color: #ffff00 !important;\n}\n\n.yellow-text.text-accent-2 {\n  color: #ffff00 !important;\n}\n\n.yellow.accent-3 {\n  background-color: #ffea00 !important;\n}\n\n.yellow-text.text-accent-3 {\n  color: #ffea00 !important;\n}\n\n.yellow.accent-4 {\n  background-color: #ffd600 !important;\n}\n\n.yellow-text.text-accent-4 {\n  color: #ffd600 !important;\n}\n\n.amber {\n  background-color: #ffc107 !important;\n}\n\n.amber-text {\n  color: #ffc107 !important;\n}\n\n.amber.lighten-5 {\n  background-color: #fff8e1 !important;\n}\n\n.amber-text.text-lighten-5 {\n  color: #fff8e1 !important;\n}\n\n.amber.lighten-4 {\n  background-color: #ffecb3 !important;\n}\n\n.amber-text.text-lighten-4 {\n  color: #ffecb3 !important;\n}\n\n.amber.lighten-3 {\n  background-color: #ffe082 !important;\n}\n\n.amber-text.text-lighten-3 {\n  color: #ffe082 !important;\n}\n\n.amber.lighten-2 {\n  background-color: #ffd54f !important;\n}\n\n.amber-text.text-lighten-2 {\n  color: #ffd54f !important;\n}\n\n.amber.lighten-1 {\n  background-color: #ffca28 !important;\n}\n\n.amber-text.text-lighten-1 {\n  color: #ffca28 !important;\n}\n\n.amber.darken-1 {\n  background-color: #ffb300 !important;\n}\n\n.amber-text.text-darken-1 {\n  color: #ffb300 !important;\n}\n\n.amber.darken-2 {\n  background-color: #ffa000 !important;\n}\n\n.amber-text.text-darken-2 {\n  color: #ffa000 !important;\n}\n\n.amber.darken-3 {\n  background-color: #ff8f00 !important;\n}\n\n.amber-text.text-darken-3 {\n  color: #ff8f00 !important;\n}\n\n.amber.darken-4 {\n  background-color: #ff6f00 !important;\n}\n\n.amber-text.text-darken-4 {\n  color: #ff6f00 !important;\n}\n\n.amber.accent-1 {\n  background-color: #ffe57f !important;\n}\n\n.amber-text.text-accent-1 {\n  color: #ffe57f !important;\n}\n\n.amber.accent-2 {\n  background-color: #ffd740 !important;\n}\n\n.amber-text.text-accent-2 {\n  color: #ffd740 !important;\n}\n\n.amber.accent-3 {\n  background-color: #ffc400 !important;\n}\n\n.amber-text.text-accent-3 {\n  color: #ffc400 !important;\n}\n\n.amber.accent-4 {\n  background-color: #ffab00 !important;\n}\n\n.amber-text.text-accent-4 {\n  color: #ffab00 !important;\n}\n\n.orange {\n  background-color: #ff9800 !important;\n}\n\n.orange-text {\n  color: #ff9800 !important;\n}\n\n.orange.lighten-5 {\n  background-color: #fff3e0 !important;\n}\n\n.orange-text.text-lighten-5 {\n  color: #fff3e0 !important;\n}\n\n.orange.lighten-4 {\n  background-color: #ffe0b2 !important;\n}\n\n.orange-text.text-lighten-4 {\n  color: #ffe0b2 !important;\n}\n\n.orange.lighten-3 {\n  background-color: #ffcc80 !important;\n}\n\n.orange-text.text-lighten-3 {\n  color: #ffcc80 !important;\n}\n\n.orange.lighten-2 {\n  background-color: #ffb74d !important;\n}\n\n.orange-text.text-lighten-2 {\n  color: #ffb74d !important;\n}\n\n.orange.lighten-1 {\n  background-color: #ffa726 !important;\n}\n\n.orange-text.text-lighten-1 {\n  color: #ffa726 !important;\n}\n\n.orange.darken-1 {\n  background-color: #fb8c00 !important;\n}\n\n.orange-text.text-darken-1 {\n  color: #fb8c00 !important;\n}\n\n.orange.darken-2 {\n  background-color: #f57c00 !important;\n}\n\n.orange-text.text-darken-2 {\n  color: #f57c00 !important;\n}\n\n.orange.darken-3 {\n  background-color: #ef6c00 !important;\n}\n\n.orange-text.text-darken-3 {\n  color: #ef6c00 !important;\n}\n\n.orange.darken-4 {\n  background-color: #e65100 !important;\n}\n\n.orange-text.text-darken-4 {\n  color: #e65100 !important;\n}\n\n.orange.accent-1 {\n  background-color: #ffd180 !important;\n}\n\n.orange-text.text-accent-1 {\n  color: #ffd180 !important;\n}\n\n.orange.accent-2 {\n  background-color: #ffab40 !important;\n}\n\n.orange-text.text-accent-2 {\n  color: #ffab40 !important;\n}\n\n.orange.accent-3 {\n  background-color: #ff9100 !important;\n}\n\n.orange-text.text-accent-3 {\n  color: #ff9100 !important;\n}\n\n.orange.accent-4 {\n  background-color: #ff6d00 !important;\n}\n\n.orange-text.text-accent-4 {\n  color: #ff6d00 !important;\n}\n\n.deep-orange {\n  background-color: #ff5722 !important;\n}\n\n.deep-orange-text {\n  color: #ff5722 !important;\n}\n\n.deep-orange.lighten-5 {\n  background-color: #fbe9e7 !important;\n}\n\n.deep-orange-text.text-lighten-5 {\n  color: #fbe9e7 !important;\n}\n\n.deep-orange.lighten-4 {\n  background-color: #ffccbc !important;\n}\n\n.deep-orange-text.text-lighten-4 {\n  color: #ffccbc !important;\n}\n\n.deep-orange.lighten-3 {\n  background-color: #ffab91 !important;\n}\n\n.deep-orange-text.text-lighten-3 {\n  color: #ffab91 !important;\n}\n\n.deep-orange.lighten-2 {\n  background-color: #ff8a65 !important;\n}\n\n.deep-orange-text.text-lighten-2 {\n  color: #ff8a65 !important;\n}\n\n.deep-orange.lighten-1 {\n  background-color: #ff7043 !important;\n}\n\n.deep-orange-text.text-lighten-1 {\n  color: #ff7043 !important;\n}\n\n.deep-orange.darken-1 {\n  background-color: #f4511e !important;\n}\n\n.deep-orange-text.text-darken-1 {\n  color: #f4511e !important;\n}\n\n.deep-orange.darken-2 {\n  background-color: #e64a19 !important;\n}\n\n.deep-orange-text.text-darken-2 {\n  color: #e64a19 !important;\n}\n\n.deep-orange.darken-3 {\n  background-color: #d84315 !important;\n}\n\n.deep-orange-text.text-darken-3 {\n  color: #d84315 !important;\n}\n\n.deep-orange.darken-4 {\n  background-color: #bf360c !important;\n}\n\n.deep-orange-text.text-darken-4 {\n  color: #bf360c !important;\n}\n\n.deep-orange.accent-1 {\n  background-color: #ff9e80 !important;\n}\n\n.deep-orange-text.text-accent-1 {\n  color: #ff9e80 !important;\n}\n\n.deep-orange.accent-2 {\n  background-color: #ff6e40 !important;\n}\n\n.deep-orange-text.text-accent-2 {\n  color: #ff6e40 !important;\n}\n\n.deep-orange.accent-3 {\n  background-color: #ff3d00 !important;\n}\n\n.deep-orange-text.text-accent-3 {\n  color: #ff3d00 !important;\n}\n\n.deep-orange.accent-4 {\n  background-color: #dd2c00 !important;\n}\n\n.deep-orange-text.text-accent-4 {\n  color: #dd2c00 !important;\n}\n\n.brown {\n  background-color: #795548 !important;\n}\n\n.brown-text {\n  color: #795548 !important;\n}\n\n.brown.lighten-5 {\n  background-color: #efebe9 !important;\n}\n\n.brown-text.text-lighten-5 {\n  color: #efebe9 !important;\n}\n\n.brown.lighten-4 {\n  background-color: #d7ccc8 !important;\n}\n\n.brown-text.text-lighten-4 {\n  color: #d7ccc8 !important;\n}\n\n.brown.lighten-3 {\n  background-color: #bcaaa4 !important;\n}\n\n.brown-text.text-lighten-3 {\n  color: #bcaaa4 !important;\n}\n\n.brown.lighten-2 {\n  background-color: #a1887f !important;\n}\n\n.brown-text.text-lighten-2 {\n  color: #a1887f !important;\n}\n\n.brown.lighten-1 {\n  background-color: #8d6e63 !important;\n}\n\n.brown-text.text-lighten-1 {\n  color: #8d6e63 !important;\n}\n\n.brown.darken-1 {\n  background-color: #6d4c41 !important;\n}\n\n.brown-text.text-darken-1 {\n  color: #6d4c41 !important;\n}\n\n.brown.darken-2 {\n  background-color: #5d4037 !important;\n}\n\n.brown-text.text-darken-2 {\n  color: #5d4037 !important;\n}\n\n.brown.darken-3 {\n  background-color: #4e342e !important;\n}\n\n.brown-text.text-darken-3 {\n  color: #4e342e !important;\n}\n\n.brown.darken-4 {\n  background-color: #3e2723 !important;\n}\n\n.brown-text.text-darken-4 {\n  color: #3e2723 !important;\n}\n\n.blue-grey {\n  background-color: #607d8b !important;\n}\n\n.blue-grey-text {\n  color: #607d8b !important;\n}\n\n.blue-grey.lighten-5 {\n  background-color: #eceff1 !important;\n}\n\n.blue-grey-text.text-lighten-5 {\n  color: #eceff1 !important;\n}\n\n.blue-grey.lighten-4 {\n  background-color: #cfd8dc !important;\n}\n\n.blue-grey-text.text-lighten-4 {\n  color: #cfd8dc !important;\n}\n\n.blue-grey.lighten-3 {\n  background-color: #b0bec5 !important;\n}\n\n.blue-grey-text.text-lighten-3 {\n  color: #b0bec5 !important;\n}\n\n.blue-grey.lighten-2 {\n  background-color: #90a4ae !important;\n}\n\n.blue-grey-text.text-lighten-2 {\n  color: #90a4ae !important;\n}\n\n.blue-grey.lighten-1 {\n  background-color: #78909c !important;\n}\n\n.blue-grey-text.text-lighten-1 {\n  color: #78909c !important;\n}\n\n.blue-grey.darken-1 {\n  background-color: #546e7a !important;\n}\n\n.blue-grey-text.text-darken-1 {\n  color: #546e7a !important;\n}\n\n.blue-grey.darken-2 {\n  background-color: #455a64 !important;\n}\n\n.blue-grey-text.text-darken-2 {\n  color: #455a64 !important;\n}\n\n.blue-grey.darken-3 {\n  background-color: #37474f !important;\n}\n\n.blue-grey-text.text-darken-3 {\n  color: #37474f !important;\n}\n\n.blue-grey.darken-4 {\n  background-color: #263238 !important;\n}\n\n.blue-grey-text.text-darken-4 {\n  color: #263238 !important;\n}\n\n.grey {\n  background-color: #9e9e9e !important;\n}\n\n.grey-text {\n  color: #9e9e9e !important;\n}\n\n.grey.lighten-5 {\n  background-color: #fafafa !important;\n}\n\n.grey-text.text-lighten-5 {\n  color: #fafafa !important;\n}\n\n.grey.lighten-4 {\n  background-color: #f5f5f5 !important;\n}\n\n.grey-text.text-lighten-4 {\n  color: #f5f5f5 !important;\n}\n\n.grey.lighten-3 {\n  background-color: #eeeeee !important;\n}\n\n.grey-text.text-lighten-3 {\n  color: #eeeeee !important;\n}\n\n.grey.lighten-2 {\n  background-color: #e0e0e0 !important;\n}\n\n.grey-text.text-lighten-2 {\n  color: #e0e0e0 !important;\n}\n\n.grey.lighten-1 {\n  background-color: #bdbdbd !important;\n}\n\n.grey-text.text-lighten-1 {\n  color: #bdbdbd !important;\n}\n\n.grey.darken-1 {\n  background-color: #757575 !important;\n}\n\n.grey-text.text-darken-1 {\n  color: #757575 !important;\n}\n\n.grey.darken-2 {\n  background-color: #616161 !important;\n}\n\n.grey-text.text-darken-2 {\n  color: #616161 !important;\n}\n\n.grey.darken-3 {\n  background-color: #424242 !important;\n}\n\n.grey-text.text-darken-3 {\n  color: #424242 !important;\n}\n\n.grey.darken-4 {\n  background-color: #212121 !important;\n}\n\n.grey-text.text-darken-4 {\n  color: #212121 !important;\n}\n\n.black {\n  background-color: #000000 !important;\n}\n\n.black-text {\n  color: #000000 !important;\n}\n\n.white {\n  background-color: #FFFFFF !important;\n}\n\n.white-text {\n  color: #FFFFFF !important;\n}\n\n.transparent {\n  background-color: transparent !important;\n}\n\n.transparent-text {\n  color: transparent !important;\n}\n\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */\n/**\r\n * 1. Set default font family to sans-serif.\r\n * 2. Prevent iOS and IE text size adjust after device orientation change,\r\n *    without disabling user zoom.\r\n */\nhtml {\n  font-family: sans-serif;\n  /* 1 */\n  -ms-text-size-adjust: 100%;\n  /* 2 */\n  -webkit-text-size-adjust: 100%;\n  /* 2 */\n}\n\n/**\r\n * Remove default margin.\r\n */\nbody {\n  margin: 0;\n}\n\n/* HTML5 display definitions\r\n   ========================================================================== */\n/**\r\n * Correct `block` display not defined for any HTML5 element in IE 8/9.\r\n * Correct `block` display not defined for `details` or `summary` in IE 10/11\r\n * and Firefox.\r\n * Correct `block` display not defined for `main` in IE 11.\r\n */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\n\n/**\r\n * 1. Correct `inline-block` display not defined in IE 8/9.\r\n * 2. Normalize vertical alignment of `progress` in Chrome, Firefox, and Opera.\r\n */\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  /* 1 */\n  vertical-align: baseline;\n  /* 2 */\n}\n\n/**\r\n * Prevent modern browsers from displaying `audio` without controls.\r\n * Remove excess height in iOS 5 devices.\r\n */\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\r\n * Address `[hidden]` styling not present in IE 8/9/10.\r\n * Hide the `template` element in IE 8/9/10/11, Safari, and Firefox < 22.\r\n */\n[hidden],\ntemplate {\n  display: none;\n}\n\n/* Links\r\n   ========================================================================== */\n/**\r\n * Remove the gray background color from active links in IE 10.\r\n */\na {\n  background-color: transparent;\n}\n\n/**\r\n * Improve readability of focused elements when they are also in an\r\n * active/hover state.\r\n */\na:active,\na:hover {\n  outline: 0;\n}\n\n/* Text-level semantics\r\n   ========================================================================== */\n/**\r\n * Address styling not present in IE 8/9/10/11, Safari, and Chrome.\r\n */\nabbr[title] {\n  border-bottom: 1px dotted;\n}\n\n/**\r\n * Address style set to `bolder` in Firefox 4+, Safari, and Chrome.\r\n */\nb,\nstrong {\n  font-weight: bold;\n}\n\n/**\r\n * Address styling not present in Safari and Chrome.\r\n */\ndfn {\n  font-style: italic;\n}\n\n/**\r\n * Address variable `h1` font-size and margin within `section` and `article`\r\n * contexts in Firefox 4+, Safari, and Chrome.\r\n */\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/**\r\n * Address styling not present in IE 8/9.\r\n */\nmark {\n  background: #ff0;\n  color: #000;\n}\n\n/**\r\n * Address inconsistent and variable font size in all browsers.\r\n */\nsmall {\n  font-size: 80%;\n}\n\n/**\r\n * Prevent `sub` and `sup` affecting `line-height` in all browsers.\r\n */\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsup {\n  top: -0.5em;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\n/* Embedded content\r\n   ========================================================================== */\n/**\r\n * Remove border when inside `a` element in IE 8/9/10.\r\n */\nimg {\n  border: 0;\n}\n\n/**\r\n * Correct overflow not hidden in IE 9/10/11.\r\n */\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Grouping content\r\n   ========================================================================== */\n/**\r\n * Address margin not present in IE 8/9 and Safari.\r\n */\nfigure {\n  margin: 1em 40px;\n}\n\n/**\r\n * Address differences between Firefox and other browsers.\r\n */\nhr {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  height: 0;\n}\n\n/**\r\n * Contain overflow in all browsers.\r\n */\npre {\n  overflow: auto;\n}\n\n/**\r\n * Address odd `em`-unit font size rendering in all browsers.\r\n */\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n\n/* Forms\r\n   ========================================================================== */\n/**\r\n * Known limitation: by default, Chrome and Safari on OS X allow very limited\r\n * styling of `select`, unless a `border` property is set.\r\n */\n/**\r\n * 1. Correct color not being inherited.\r\n *    Known issue: affects color of disabled elements.\r\n * 2. Correct font properties not being inherited.\r\n * 3. Address margins set differently in Firefox 4+, Safari, and Chrome.\r\n */\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit;\n  /* 1 */\n  font: inherit;\n  /* 2 */\n  margin: 0;\n  /* 3 */\n}\n\n/**\r\n * Address `overflow` set to `hidden` in IE 8/9/10/11.\r\n */\nbutton {\n  overflow: visible;\n}\n\n/**\r\n * Address inconsistent `text-transform` inheritance for `button` and `select`.\r\n * All other form control elements do not inherit `text-transform` values.\r\n * Correct `button` style inheritance in Firefox, IE 8/9/10/11, and Opera.\r\n * Correct `select` style inheritance in Firefox.\r\n */\nbutton,\nselect {\n  text-transform: none;\n}\n\n/**\r\n * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\r\n *    and `video` controls.\r\n * 2. Correct inability to style clickable `input` types in iOS.\r\n * 3. Improve usability and consistency of cursor style between image-type\r\n *    `input` and others.\r\n */\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  /* 2 */\n  cursor: pointer;\n  /* 3 */\n}\n\n/**\r\n * Re-set default cursor for disabled elements.\r\n */\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\n/**\r\n * Remove inner padding and border in Firefox 4+.\r\n */\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n/**\r\n * Address Firefox 4+ setting `line-height` on `input` using `!important` in\r\n * the UA stylesheet.\r\n */\ninput {\n  line-height: normal;\n}\n\n/**\r\n * It's recommended that you don't attempt to style these elements.\r\n * Firefox's implementation doesn't respect box-sizing, padding, or width.\r\n *\r\n * 1. Address box sizing set to `content-box` in IE 8/9/10.\r\n * 2. Remove excess padding in IE 8/9/10.\r\n */\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  /* 1 */\n  padding: 0;\n  /* 2 */\n}\n\n/**\r\n * Fix the cursor style for Chrome's increment/decrement buttons. For certain\r\n * `font-size` values of the `input`, it causes the cursor style of the\r\n * decrement button to change from `default` to `text`.\r\n */\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\r\n * 1. Address `appearance` set to `searchfield` in Safari and Chrome.\r\n * 2. Address `box-sizing` set to `border-box` in Safari and Chrome.\r\n */\ninput[type=\"search\"] {\n  -webkit-appearance: textfield;\n  /* 1 */\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  /* 2 */\n}\n\n/**\r\n * Remove inner padding and search cancel button in Safari and Chrome on OS X.\r\n * Safari (but not Chrome) clips the cancel button when the search input has\r\n * padding (and `textfield` appearance).\r\n */\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\r\n * Define consistent border, margin, and padding.\r\n */\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n/**\r\n * 1. Correct `color` not being inherited in IE 8/9/10/11.\r\n * 2. Remove padding so people aren't caught out if they zero out fieldsets.\r\n */\nlegend {\n  border: 0;\n  /* 1 */\n  padding: 0;\n  /* 2 */\n}\n\n/**\r\n * Remove default vertical scrollbar in IE 8/9/10/11.\r\n */\ntextarea {\n  overflow: auto;\n}\n\n/**\r\n * Don't inherit the `font-weight` (applied by a rule above).\r\n * NOTE: the default cannot safely be changed in Chrome and Safari on OS X.\r\n */\noptgroup {\n  font-weight: bold;\n}\n\n/* Tables\r\n   ========================================================================== */\n/**\r\n * Remove most spacing between table cells.\r\n */\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ntd,\nth {\n  padding: 0;\n}\n\nhtml {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n*, *:before, *:after {\n  -webkit-box-sizing: inherit;\n          box-sizing: inherit;\n}\n\nul:not(.browser-default) {\n  padding-left: 0;\n  list-style-type: none;\n}\n\nul:not(.browser-default) > li {\n  list-style-type: none;\n}\n\na {\n  color: #039be5;\n  text-decoration: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.valign-wrapper {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.clearfix {\n  clear: both;\n}\n\n.z-depth-0 {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n\n.z-depth-1, nav, .card-panel, .card, .toast, .btn, .btn-large, .btn-floating, .dropdown-content, .collapsible, .side-nav {\n  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);\n}\n\n.z-depth-1-half, .btn:hover, .btn-large:hover, .btn-floating:hover {\n  -webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2);\n}\n\n.z-depth-2 {\n  -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);\n}\n\n.z-depth-3 {\n  -webkit-box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px -1px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px -1px rgba(0, 0, 0, 0.3);\n}\n\n.z-depth-4, .modal {\n  -webkit-box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.3);\n}\n\n.z-depth-5 {\n  -webkit-box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.3);\n}\n\n.hoverable {\n  -webkit-transition: -webkit-box-shadow .25s;\n  transition: -webkit-box-shadow .25s;\n  transition: box-shadow .25s;\n  transition: box-shadow .25s, -webkit-box-shadow .25s;\n}\n\n.hoverable:hover {\n  -webkit-box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n          box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.divider {\n  height: 1px;\n  overflow: hidden;\n  background-color: #e0e0e0;\n}\n\nblockquote {\n  margin: 20px 0;\n  padding-left: 1.5rem;\n  border-left: 5px solid #ee6e73;\n}\n\ni {\n  line-height: inherit;\n}\n\ni.left {\n  float: left;\n  margin-right: 15px;\n}\n\ni.right {\n  float: right;\n  margin-left: 15px;\n}\n\ni.tiny {\n  font-size: 1rem;\n}\n\ni.small {\n  font-size: 2rem;\n}\n\ni.medium {\n  font-size: 4rem;\n}\n\ni.large {\n  font-size: 6rem;\n}\n\nimg.responsive-img,\nvideo.responsive-video {\n  max-width: 100%;\n  height: auto;\n}\n\n.pagination li {\n  display: inline-block;\n  border-radius: 2px;\n  text-align: center;\n  vertical-align: top;\n  height: 30px;\n}\n\n.pagination li a {\n  color: #444;\n  display: inline-block;\n  font-size: 1.2rem;\n  padding: 0 10px;\n  line-height: 30px;\n}\n\n.pagination li.active a {\n  color: #fff;\n}\n\n.pagination li.active {\n  background-color: #ee6e73;\n}\n\n.pagination li.disabled a {\n  cursor: default;\n  color: #999;\n}\n\n.pagination li i {\n  font-size: 2rem;\n}\n\n.pagination li.pages ul li {\n  display: inline-block;\n  float: none;\n}\n\n@media only screen and (max-width: 992px) {\n  .pagination {\n    width: 100%;\n  }\n  .pagination li.prev,\n  .pagination li.next {\n    width: 10%;\n  }\n  .pagination li.pages {\n    width: 80%;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n}\n\n.breadcrumb {\n  font-size: 18px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.breadcrumb i,\n.breadcrumb [class^=\"mdi-\"], .breadcrumb [class*=\"mdi-\"],\n.breadcrumb i.material-icons {\n  display: inline-block;\n  float: left;\n  font-size: 24px;\n}\n\n.breadcrumb:before {\n  content: '\\E5CC';\n  color: rgba(255, 255, 255, 0.7);\n  vertical-align: top;\n  display: inline-block;\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  font-size: 25px;\n  margin: 0 10px 0 8px;\n  -webkit-font-smoothing: antialiased;\n}\n\n.breadcrumb:first-child:before {\n  display: none;\n}\n\n.breadcrumb:last-child {\n  color: #fff;\n}\n\n.parallax-container {\n  position: relative;\n  overflow: hidden;\n  height: 500px;\n}\n\n.parallax-container .parallax {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n}\n\n.parallax-container .parallax img {\n  display: none;\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  min-width: 100%;\n  min-height: 100%;\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n\n.pin-top, .pin-bottom {\n  position: relative;\n}\n\n.pinned {\n  position: fixed !important;\n}\n\n/*********************\r\n  Transition Classes\r\n**********************/\nul.staggered-list li {\n  opacity: 0;\n}\n\n.fade-in {\n  opacity: 0;\n  -webkit-transform-origin: 0 50%;\n          transform-origin: 0 50%;\n}\n\n/*********************\r\n  Media Query Classes\r\n**********************/\n@media only screen and (max-width: 600px) {\n  .hide-on-small-only, .hide-on-small-and-down {\n    display: none !important;\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .hide-on-med-and-down {\n    display: none !important;\n  }\n}\n\n@media only screen and (min-width: 601px) {\n  .hide-on-med-and-up {\n    display: none !important;\n  }\n}\n\n@media only screen and (min-width: 600px) and (max-width: 992px) {\n  .hide-on-med-only {\n    display: none !important;\n  }\n}\n\n@media only screen and (min-width: 993px) {\n  .hide-on-large-only {\n    display: none !important;\n  }\n}\n\n@media only screen and (min-width: 993px) {\n  .show-on-large {\n    display: block !important;\n  }\n}\n\n@media only screen and (min-width: 600px) and (max-width: 992px) {\n  .show-on-medium {\n    display: block !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .show-on-small {\n    display: block !important;\n  }\n}\n\n@media only screen and (min-width: 601px) {\n  .show-on-medium-and-up {\n    display: block !important;\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .show-on-medium-and-down {\n    display: block !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .center-on-small-only {\n    text-align: center;\n  }\n}\n\n.page-footer {\n  padding-top: 20px;\n  color: #fff;\n  background-color: #ee6e73;\n}\n\n.page-footer .footer-copyright {\n  overflow: hidden;\n  min-height: 50px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 10px 0px;\n  color: rgba(255, 255, 255, 0.8);\n  background-color: rgba(51, 51, 51, 0.08);\n}\n\ntable, th, td {\n  border: none;\n}\n\ntable {\n  width: 100%;\n  display: table;\n}\n\ntable.bordered > thead > tr,\ntable.bordered > tbody > tr {\n  border-bottom: 1px solid #d0d0d0;\n}\n\ntable.striped > tbody > tr:nth-child(odd) {\n  background-color: #f2f2f2;\n}\n\ntable.striped > tbody > tr > td {\n  border-radius: 0;\n}\n\ntable.highlight > tbody > tr {\n  -webkit-transition: background-color .25s ease;\n  transition: background-color .25s ease;\n}\n\ntable.highlight > tbody > tr:hover {\n  background-color: #f2f2f2;\n}\n\ntable.centered thead tr th, table.centered tbody tr td {\n  text-align: center;\n}\n\nthead {\n  border-bottom: 1px solid #d0d0d0;\n}\n\ntd, th {\n  padding: 15px 5px;\n  display: table-cell;\n  text-align: left;\n  vertical-align: middle;\n  border-radius: 2px;\n}\n\n@media only screen and (max-width: 992px) {\n  table.responsive-table {\n    width: 100%;\n    border-collapse: collapse;\n    border-spacing: 0;\n    display: block;\n    position: relative;\n    /* sort out borders */\n  }\n  table.responsive-table td:empty:before {\n    content: '\\A0';\n  }\n  table.responsive-table th,\n  table.responsive-table td {\n    margin: 0;\n    vertical-align: top;\n  }\n  table.responsive-table th {\n    text-align: left;\n  }\n  table.responsive-table thead {\n    display: block;\n    float: left;\n  }\n  table.responsive-table thead tr {\n    display: block;\n    padding: 0 10px 0 0;\n  }\n  table.responsive-table thead tr th::before {\n    content: \"\\A0\";\n  }\n  table.responsive-table tbody {\n    display: block;\n    width: auto;\n    position: relative;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n  table.responsive-table tbody tr {\n    display: inline-block;\n    vertical-align: top;\n  }\n  table.responsive-table th {\n    display: block;\n    text-align: right;\n  }\n  table.responsive-table td {\n    display: block;\n    min-height: 1.25em;\n    text-align: left;\n  }\n  table.responsive-table tr {\n    padding: 0 10px;\n  }\n  table.responsive-table thead {\n    border: 0;\n    border-right: 1px solid #d0d0d0;\n  }\n  table.responsive-table.bordered th {\n    border-bottom: 0;\n    border-left: 0;\n  }\n  table.responsive-table.bordered td {\n    border-left: 0;\n    border-right: 0;\n    border-bottom: 0;\n  }\n  table.responsive-table.bordered tr {\n    border: 0;\n  }\n  table.responsive-table.bordered tbody tr {\n    border-right: 1px solid #d0d0d0;\n  }\n}\n\n.collection {\n  margin: 0.5rem 0 1rem 0;\n  border: 1px solid #e0e0e0;\n  border-radius: 2px;\n  overflow: hidden;\n  position: relative;\n}\n\n.collection .collection-item {\n  background-color: #fff;\n  line-height: 1.5rem;\n  padding: 10px 20px;\n  margin: 0;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.collection .collection-item.avatar {\n  min-height: 84px;\n  padding-left: 72px;\n  position: relative;\n}\n\n.collection .collection-item.avatar:not(.circle-clipper) > .circle,\n.collection .collection-item.avatar :not(.circle-clipper) > .circle {\n  position: absolute;\n  width: 42px;\n  height: 42px;\n  overflow: hidden;\n  left: 15px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.collection .collection-item.avatar i.circle {\n  font-size: 18px;\n  line-height: 42px;\n  color: #fff;\n  background-color: #999;\n  text-align: center;\n}\n\n.collection .collection-item.avatar .title {\n  font-size: 16px;\n}\n\n.collection .collection-item.avatar p {\n  margin: 0;\n}\n\n.collection .collection-item.avatar .secondary-content {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n}\n\n.collection .collection-item:last-child {\n  border-bottom: none;\n}\n\n.collection .collection-item.active {\n  background-color: #26a69a;\n  color: #eafaf9;\n}\n\n.collection .collection-item.active .secondary-content {\n  color: #fff;\n}\n\n.collection a.collection-item {\n  display: block;\n  -webkit-transition: .25s;\n  transition: .25s;\n  color: #26a69a;\n}\n\n.collection a.collection-item:not(.active):hover {\n  background-color: #ddd;\n}\n\n.collection.with-header .collection-header {\n  background-color: #fff;\n  border-bottom: 1px solid #e0e0e0;\n  padding: 10px 20px;\n}\n\n.collection.with-header .collection-item {\n  padding-left: 30px;\n}\n\n.collection.with-header .collection-item.avatar {\n  padding-left: 72px;\n}\n\n.secondary-content {\n  float: right;\n  color: #26a69a;\n}\n\n.collapsible .collection {\n  margin: 0;\n  border: none;\n}\n\n.video-container {\n  position: relative;\n  padding-bottom: 56.25%;\n  height: 0;\n  overflow: hidden;\n}\n\n.video-container iframe, .video-container object, .video-container embed {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.progress {\n  position: relative;\n  height: 4px;\n  display: block;\n  width: 100%;\n  background-color: #acece6;\n  border-radius: 2px;\n  margin: 0.5rem 0 1rem 0;\n  overflow: hidden;\n}\n\n.progress .determinate {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  background-color: #26a69a;\n  -webkit-transition: width .3s linear;\n  transition: width .3s linear;\n}\n\n.progress .indeterminate {\n  background-color: #26a69a;\n}\n\n.progress .indeterminate:before {\n  content: '';\n  position: absolute;\n  background-color: inherit;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  will-change: left, right;\n  -webkit-animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;\n          animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;\n}\n\n.progress .indeterminate:after {\n  content: '';\n  position: absolute;\n  background-color: inherit;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  will-change: left, right;\n  -webkit-animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;\n          animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;\n  -webkit-animation-delay: 1.15s;\n          animation-delay: 1.15s;\n}\n\n@-webkit-keyframes indeterminate {\n  0% {\n    left: -35%;\n    right: 100%;\n  }\n  60% {\n    left: 100%;\n    right: -90%;\n  }\n  100% {\n    left: 100%;\n    right: -90%;\n  }\n}\n\n@keyframes indeterminate {\n  0% {\n    left: -35%;\n    right: 100%;\n  }\n  60% {\n    left: 100%;\n    right: -90%;\n  }\n  100% {\n    left: 100%;\n    right: -90%;\n  }\n}\n\n@-webkit-keyframes indeterminate-short {\n  0% {\n    left: -200%;\n    right: 100%;\n  }\n  60% {\n    left: 107%;\n    right: -8%;\n  }\n  100% {\n    left: 107%;\n    right: -8%;\n  }\n}\n\n@keyframes indeterminate-short {\n  0% {\n    left: -200%;\n    right: 100%;\n  }\n  60% {\n    left: 107%;\n    right: -8%;\n  }\n  100% {\n    left: 107%;\n    right: -8%;\n  }\n}\n\n/*******************\r\n  Utility Classes\r\n*******************/\n.hide {\n  display: none !important;\n}\n\n.left-align {\n  text-align: left;\n}\n\n.right-align {\n  text-align: right;\n}\n\n.center, .center-align {\n  text-align: center;\n}\n\n.left {\n  float: left !important;\n}\n\n.right {\n  float: right !important;\n}\n\n.no-select, input[type=range],\ninput[type=range] + .thumb {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.circle {\n  border-radius: 50%;\n}\n\n.center-block {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.truncate {\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.no-padding {\n  padding: 0 !important;\n}\n\nspan.badge {\n  min-width: 3rem;\n  padding: 0 6px;\n  margin-left: 14px;\n  text-align: center;\n  font-size: 1rem;\n  line-height: 22px;\n  height: 22px;\n  color: #757575;\n  float: right;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\nspan.badge.new {\n  font-weight: 300;\n  font-size: 0.8rem;\n  color: #fff;\n  background-color: #26a69a;\n  border-radius: 2px;\n}\n\nspan.badge.new:after {\n  content: \" new\";\n}\n\nspan.badge[data-badge-caption]::after {\n  content: \" \" attr(data-badge-caption);\n}\n\nnav ul a span.badge {\n  display: inline-block;\n  float: none;\n  margin-left: 4px;\n  line-height: 22px;\n  height: 22px;\n  -webkit-font-smoothing: auto;\n}\n\n.collection-item span.badge {\n  margin-top: calc(0.75rem - 11px);\n}\n\n.collapsible span.badge {\n  margin-left: auto;\n}\n\n.side-nav span.badge {\n  margin-top: calc(24px - 11px);\n}\n\n/* This is needed for some mobile phones to display the Google Icon font properly */\n.material-icons {\n  text-rendering: optimizeLegibility;\n  -webkit-font-feature-settings: 'liga';\n     -moz-font-feature-settings: 'liga';\n          font-feature-settings: 'liga';\n}\n\n.container {\n  margin: 0 auto;\n  max-width: 1280px;\n  width: 90%;\n}\n\n@media only screen and (min-width: 601px) {\n  .container {\n    width: 85%;\n  }\n}\n\n@media only screen and (min-width: 993px) {\n  .container {\n    width: 70%;\n  }\n}\n\n.container .row {\n  margin-left: -0.75rem;\n  margin-right: -0.75rem;\n}\n\n.section {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.section.no-pad {\n  padding: 0;\n}\n\n.section.no-pad-bot {\n  padding-bottom: 0;\n}\n\n.section.no-pad-top {\n  padding-top: 0;\n}\n\n.row {\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 20px;\n}\n\n.row:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.row .col {\n  float: left;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0 0.75rem;\n  min-height: 1px;\n}\n\n.row .col[class*=\"push-\"], .row .col[class*=\"pull-\"] {\n  position: relative;\n}\n\n.row .col.s1 {\n  width: 8.3333333333%;\n  margin-left: auto;\n  left: auto;\n  right: auto;\n}\n\n.row .col.s2 {\n  width: 16.6666666667%;\n  margin-left: auto;\n  left: auto;\n  right: auto;\n}\n\n.row .col.s3 {\n  width: 25%;\n  margin-left: auto;\n  left: auto;\n  right: auto;\n}\n\n.row .col.s4 {\n  width: 33.3333333333%;\n  margin-left: auto;\n  left: auto;\n  right: auto;\n}\n\n.row .col.s5 {\n  width: 41.6666666667%;\n  margin-left: auto;\n  left: auto;\n  right: auto;\n}\n\n.row .col.s6 {\n  width: 50%;\n  margin-left: auto;\n  left: auto;\n  right: auto;\n}\n\n.row .col.s7 {\n  width: 58.3333333333%;\n  margin-left: auto;\n  left: auto;\n  right: auto;\n}\n\n.row .col.s8 {\n  width: 66.6666666667%;\n  margin-left: auto;\n  left: auto;\n  right: auto;\n}\n\n.row .col.s9 {\n  width: 75%;\n  margin-left: auto;\n  left: auto;\n  right: auto;\n}\n\n.row .col.s10 {\n  width: 83.3333333333%;\n  margin-left: auto;\n  left: auto;\n  right: auto;\n}\n\n.row .col.s11 {\n  width: 91.6666666667%;\n  margin-left: auto;\n  left: auto;\n  right: auto;\n}\n\n.row .col.s12 {\n  width: 100%;\n  margin-left: auto;\n  left: auto;\n  right: auto;\n}\n\n.row .col.offset-s1 {\n  margin-left: 8.3333333333%;\n}\n\n.row .col.pull-s1 {\n  right: 8.3333333333%;\n}\n\n.row .col.push-s1 {\n  left: 8.3333333333%;\n}\n\n.row .col.offset-s2 {\n  margin-left: 16.6666666667%;\n}\n\n.row .col.pull-s2 {\n  right: 16.6666666667%;\n}\n\n.row .col.push-s2 {\n  left: 16.6666666667%;\n}\n\n.row .col.offset-s3 {\n  margin-left: 25%;\n}\n\n.row .col.pull-s3 {\n  right: 25%;\n}\n\n.row .col.push-s3 {\n  left: 25%;\n}\n\n.row .col.offset-s4 {\n  margin-left: 33.3333333333%;\n}\n\n.row .col.pull-s4 {\n  right: 33.3333333333%;\n}\n\n.row .col.push-s4 {\n  left: 33.3333333333%;\n}\n\n.row .col.offset-s5 {\n  margin-left: 41.6666666667%;\n}\n\n.row .col.pull-s5 {\n  right: 41.6666666667%;\n}\n\n.row .col.push-s5 {\n  left: 41.6666666667%;\n}\n\n.row .col.offset-s6 {\n  margin-left: 50%;\n}\n\n.row .col.pull-s6 {\n  right: 50%;\n}\n\n.row .col.push-s6 {\n  left: 50%;\n}\n\n.row .col.offset-s7 {\n  margin-left: 58.3333333333%;\n}\n\n.row .col.pull-s7 {\n  right: 58.3333333333%;\n}\n\n.row .col.push-s7 {\n  left: 58.3333333333%;\n}\n\n.row .col.offset-s8 {\n  margin-left: 66.6666666667%;\n}\n\n.row .col.pull-s8 {\n  right: 66.6666666667%;\n}\n\n.row .col.push-s8 {\n  left: 66.6666666667%;\n}\n\n.row .col.offset-s9 {\n  margin-left: 75%;\n}\n\n.row .col.pull-s9 {\n  right: 75%;\n}\n\n.row .col.push-s9 {\n  left: 75%;\n}\n\n.row .col.offset-s10 {\n  margin-left: 83.3333333333%;\n}\n\n.row .col.pull-s10 {\n  right: 83.3333333333%;\n}\n\n.row .col.push-s10 {\n  left: 83.3333333333%;\n}\n\n.row .col.offset-s11 {\n  margin-left: 91.6666666667%;\n}\n\n.row .col.pull-s11 {\n  right: 91.6666666667%;\n}\n\n.row .col.push-s11 {\n  left: 91.6666666667%;\n}\n\n.row .col.offset-s12 {\n  margin-left: 100%;\n}\n\n.row .col.pull-s12 {\n  right: 100%;\n}\n\n.row .col.push-s12 {\n  left: 100%;\n}\n\n@media only screen and (min-width: 601px) {\n  .row .col.m1 {\n    width: 8.3333333333%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.m2 {\n    width: 16.6666666667%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.m3 {\n    width: 25%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.m4 {\n    width: 33.3333333333%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.m5 {\n    width: 41.6666666667%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.m6 {\n    width: 50%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.m7 {\n    width: 58.3333333333%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.m8 {\n    width: 66.6666666667%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.m9 {\n    width: 75%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.m10 {\n    width: 83.3333333333%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.m11 {\n    width: 91.6666666667%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.m12 {\n    width: 100%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.offset-m1 {\n    margin-left: 8.3333333333%;\n  }\n  .row .col.pull-m1 {\n    right: 8.3333333333%;\n  }\n  .row .col.push-m1 {\n    left: 8.3333333333%;\n  }\n  .row .col.offset-m2 {\n    margin-left: 16.6666666667%;\n  }\n  .row .col.pull-m2 {\n    right: 16.6666666667%;\n  }\n  .row .col.push-m2 {\n    left: 16.6666666667%;\n  }\n  .row .col.offset-m3 {\n    margin-left: 25%;\n  }\n  .row .col.pull-m3 {\n    right: 25%;\n  }\n  .row .col.push-m3 {\n    left: 25%;\n  }\n  .row .col.offset-m4 {\n    margin-left: 33.3333333333%;\n  }\n  .row .col.pull-m4 {\n    right: 33.3333333333%;\n  }\n  .row .col.push-m4 {\n    left: 33.3333333333%;\n  }\n  .row .col.offset-m5 {\n    margin-left: 41.6666666667%;\n  }\n  .row .col.pull-m5 {\n    right: 41.6666666667%;\n  }\n  .row .col.push-m5 {\n    left: 41.6666666667%;\n  }\n  .row .col.offset-m6 {\n    margin-left: 50%;\n  }\n  .row .col.pull-m6 {\n    right: 50%;\n  }\n  .row .col.push-m6 {\n    left: 50%;\n  }\n  .row .col.offset-m7 {\n    margin-left: 58.3333333333%;\n  }\n  .row .col.pull-m7 {\n    right: 58.3333333333%;\n  }\n  .row .col.push-m7 {\n    left: 58.3333333333%;\n  }\n  .row .col.offset-m8 {\n    margin-left: 66.6666666667%;\n  }\n  .row .col.pull-m8 {\n    right: 66.6666666667%;\n  }\n  .row .col.push-m8 {\n    left: 66.6666666667%;\n  }\n  .row .col.offset-m9 {\n    margin-left: 75%;\n  }\n  .row .col.pull-m9 {\n    right: 75%;\n  }\n  .row .col.push-m9 {\n    left: 75%;\n  }\n  .row .col.offset-m10 {\n    margin-left: 83.3333333333%;\n  }\n  .row .col.pull-m10 {\n    right: 83.3333333333%;\n  }\n  .row .col.push-m10 {\n    left: 83.3333333333%;\n  }\n  .row .col.offset-m11 {\n    margin-left: 91.6666666667%;\n  }\n  .row .col.pull-m11 {\n    right: 91.6666666667%;\n  }\n  .row .col.push-m11 {\n    left: 91.6666666667%;\n  }\n  .row .col.offset-m12 {\n    margin-left: 100%;\n  }\n  .row .col.pull-m12 {\n    right: 100%;\n  }\n  .row .col.push-m12 {\n    left: 100%;\n  }\n}\n\n@media only screen and (min-width: 993px) {\n  .row .col.l1 {\n    width: 8.3333333333%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.l2 {\n    width: 16.6666666667%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.l3 {\n    width: 25%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.l4 {\n    width: 33.3333333333%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.l5 {\n    width: 41.6666666667%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.l6 {\n    width: 50%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.l7 {\n    width: 58.3333333333%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.l8 {\n    width: 66.6666666667%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.l9 {\n    width: 75%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.l10 {\n    width: 83.3333333333%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.l11 {\n    width: 91.6666666667%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.l12 {\n    width: 100%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.offset-l1 {\n    margin-left: 8.3333333333%;\n  }\n  .row .col.pull-l1 {\n    right: 8.3333333333%;\n  }\n  .row .col.push-l1 {\n    left: 8.3333333333%;\n  }\n  .row .col.offset-l2 {\n    margin-left: 16.6666666667%;\n  }\n  .row .col.pull-l2 {\n    right: 16.6666666667%;\n  }\n  .row .col.push-l2 {\n    left: 16.6666666667%;\n  }\n  .row .col.offset-l3 {\n    margin-left: 25%;\n  }\n  .row .col.pull-l3 {\n    right: 25%;\n  }\n  .row .col.push-l3 {\n    left: 25%;\n  }\n  .row .col.offset-l4 {\n    margin-left: 33.3333333333%;\n  }\n  .row .col.pull-l4 {\n    right: 33.3333333333%;\n  }\n  .row .col.push-l4 {\n    left: 33.3333333333%;\n  }\n  .row .col.offset-l5 {\n    margin-left: 41.6666666667%;\n  }\n  .row .col.pull-l5 {\n    right: 41.6666666667%;\n  }\n  .row .col.push-l5 {\n    left: 41.6666666667%;\n  }\n  .row .col.offset-l6 {\n    margin-left: 50%;\n  }\n  .row .col.pull-l6 {\n    right: 50%;\n  }\n  .row .col.push-l6 {\n    left: 50%;\n  }\n  .row .col.offset-l7 {\n    margin-left: 58.3333333333%;\n  }\n  .row .col.pull-l7 {\n    right: 58.3333333333%;\n  }\n  .row .col.push-l7 {\n    left: 58.3333333333%;\n  }\n  .row .col.offset-l8 {\n    margin-left: 66.6666666667%;\n  }\n  .row .col.pull-l8 {\n    right: 66.6666666667%;\n  }\n  .row .col.push-l8 {\n    left: 66.6666666667%;\n  }\n  .row .col.offset-l9 {\n    margin-left: 75%;\n  }\n  .row .col.pull-l9 {\n    right: 75%;\n  }\n  .row .col.push-l9 {\n    left: 75%;\n  }\n  .row .col.offset-l10 {\n    margin-left: 83.3333333333%;\n  }\n  .row .col.pull-l10 {\n    right: 83.3333333333%;\n  }\n  .row .col.push-l10 {\n    left: 83.3333333333%;\n  }\n  .row .col.offset-l11 {\n    margin-left: 91.6666666667%;\n  }\n  .row .col.pull-l11 {\n    right: 91.6666666667%;\n  }\n  .row .col.push-l11 {\n    left: 91.6666666667%;\n  }\n  .row .col.offset-l12 {\n    margin-left: 100%;\n  }\n  .row .col.pull-l12 {\n    right: 100%;\n  }\n  .row .col.push-l12 {\n    left: 100%;\n  }\n}\n\n@media only screen and (min-width: 1201px) {\n  .row .col.xl1 {\n    width: 8.3333333333%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.xl2 {\n    width: 16.6666666667%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.xl3 {\n    width: 25%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.xl4 {\n    width: 33.3333333333%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.xl5 {\n    width: 41.6666666667%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.xl6 {\n    width: 50%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.xl7 {\n    width: 58.3333333333%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.xl8 {\n    width: 66.6666666667%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.xl9 {\n    width: 75%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.xl10 {\n    width: 83.3333333333%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.xl11 {\n    width: 91.6666666667%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.xl12 {\n    width: 100%;\n    margin-left: auto;\n    left: auto;\n    right: auto;\n  }\n  .row .col.offset-xl1 {\n    margin-left: 8.3333333333%;\n  }\n  .row .col.pull-xl1 {\n    right: 8.3333333333%;\n  }\n  .row .col.push-xl1 {\n    left: 8.3333333333%;\n  }\n  .row .col.offset-xl2 {\n    margin-left: 16.6666666667%;\n  }\n  .row .col.pull-xl2 {\n    right: 16.6666666667%;\n  }\n  .row .col.push-xl2 {\n    left: 16.6666666667%;\n  }\n  .row .col.offset-xl3 {\n    margin-left: 25%;\n  }\n  .row .col.pull-xl3 {\n    right: 25%;\n  }\n  .row .col.push-xl3 {\n    left: 25%;\n  }\n  .row .col.offset-xl4 {\n    margin-left: 33.3333333333%;\n  }\n  .row .col.pull-xl4 {\n    right: 33.3333333333%;\n  }\n  .row .col.push-xl4 {\n    left: 33.3333333333%;\n  }\n  .row .col.offset-xl5 {\n    margin-left: 41.6666666667%;\n  }\n  .row .col.pull-xl5 {\n    right: 41.6666666667%;\n  }\n  .row .col.push-xl5 {\n    left: 41.6666666667%;\n  }\n  .row .col.offset-xl6 {\n    margin-left: 50%;\n  }\n  .row .col.pull-xl6 {\n    right: 50%;\n  }\n  .row .col.push-xl6 {\n    left: 50%;\n  }\n  .row .col.offset-xl7 {\n    margin-left: 58.3333333333%;\n  }\n  .row .col.pull-xl7 {\n    right: 58.3333333333%;\n  }\n  .row .col.push-xl7 {\n    left: 58.3333333333%;\n  }\n  .row .col.offset-xl8 {\n    margin-left: 66.6666666667%;\n  }\n  .row .col.pull-xl8 {\n    right: 66.6666666667%;\n  }\n  .row .col.push-xl8 {\n    left: 66.6666666667%;\n  }\n  .row .col.offset-xl9 {\n    margin-left: 75%;\n  }\n  .row .col.pull-xl9 {\n    right: 75%;\n  }\n  .row .col.push-xl9 {\n    left: 75%;\n  }\n  .row .col.offset-xl10 {\n    margin-left: 83.3333333333%;\n  }\n  .row .col.pull-xl10 {\n    right: 83.3333333333%;\n  }\n  .row .col.push-xl10 {\n    left: 83.3333333333%;\n  }\n  .row .col.offset-xl11 {\n    margin-left: 91.6666666667%;\n  }\n  .row .col.pull-xl11 {\n    right: 91.6666666667%;\n  }\n  .row .col.push-xl11 {\n    left: 91.6666666667%;\n  }\n  .row .col.offset-xl12 {\n    margin-left: 100%;\n  }\n  .row .col.pull-xl12 {\n    right: 100%;\n  }\n  .row .col.push-xl12 {\n    left: 100%;\n  }\n}\n\nnav {\n  color: #fff;\n  background-color: #ee6e73;\n  width: 100%;\n  height: 56px;\n  line-height: 56px;\n}\n\nnav.nav-extended {\n  height: auto;\n}\n\nnav.nav-extended .nav-wrapper {\n  min-height: 56px;\n  height: auto;\n}\n\nnav.nav-extended .nav-content {\n  position: relative;\n  line-height: normal;\n}\n\nnav a {\n  color: #fff;\n}\n\nnav i,\nnav [class^=\"mdi-\"], nav [class*=\"mdi-\"],\nnav i.material-icons {\n  display: block;\n  font-size: 24px;\n  height: 56px;\n  line-height: 56px;\n}\n\nnav .nav-wrapper {\n  position: relative;\n  height: 100%;\n}\n\n@media only screen and (min-width: 993px) {\n  nav a.button-collapse {\n    display: none;\n  }\n}\n\nnav .button-collapse {\n  float: left;\n  position: relative;\n  z-index: 1;\n  height: 56px;\n  margin: 0 18px;\n}\n\nnav .button-collapse i {\n  height: 56px;\n  line-height: 56px;\n}\n\nnav .brand-logo {\n  position: absolute;\n  color: #fff;\n  display: inline-block;\n  font-size: 2.1rem;\n  padding: 0;\n}\n\nnav .brand-logo.center {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n\n@media only screen and (max-width: 992px) {\n  nav .brand-logo {\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n            transform: translateX(-50%);\n  }\n  nav .brand-logo.left, nav .brand-logo.right {\n    padding: 0;\n    -webkit-transform: none;\n            transform: none;\n  }\n  nav .brand-logo.left {\n    left: 0.5rem;\n  }\n  nav .brand-logo.right {\n    right: 0.5rem;\n    left: auto;\n  }\n}\n\nnav .brand-logo.right {\n  right: 0.5rem;\n  padding: 0;\n}\n\nnav .brand-logo i,\nnav .brand-logo [class^=\"mdi-\"], nav .brand-logo [class*=\"mdi-\"],\nnav .brand-logo i.material-icons {\n  float: left;\n  margin-right: 15px;\n}\n\nnav .nav-title {\n  display: inline-block;\n  font-size: 32px;\n  padding: 28px 0;\n}\n\nnav ul {\n  margin: 0;\n}\n\nnav ul li {\n  -webkit-transition: background-color .3s;\n  transition: background-color .3s;\n  float: left;\n  padding: 0;\n}\n\nnav ul li.active {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\nnav ul a {\n  -webkit-transition: background-color .3s;\n  transition: background-color .3s;\n  font-size: 1rem;\n  color: #fff;\n  display: block;\n  padding: 0 15px;\n  cursor: pointer;\n}\n\nnav ul a.btn, nav ul a.btn-large, nav ul a.btn-large, nav ul a.btn-flat, nav ul a.btn-floating {\n  margin-top: -2px;\n  margin-left: 15px;\n  margin-right: 15px;\n}\n\nnav ul a.btn > .material-icons, nav ul a.btn-large > .material-icons, nav ul a.btn-large > .material-icons, nav ul a.btn-flat > .material-icons, nav ul a.btn-floating > .material-icons {\n  height: inherit;\n  line-height: inherit;\n}\n\nnav ul a:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\nnav ul.left {\n  float: left;\n}\n\nnav form {\n  height: 100%;\n}\n\nnav .input-field {\n  margin: 0;\n  height: 100%;\n}\n\nnav .input-field input {\n  height: 100%;\n  font-size: 1.2rem;\n  border: none;\n  padding-left: 2rem;\n}\n\nnav .input-field input:focus, nav .input-field input[type=text]:valid, nav .input-field input[type=password]:valid, nav .input-field input[type=email]:valid, nav .input-field input[type=url]:valid, nav .input-field input[type=date]:valid {\n  border: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\nnav .input-field label {\n  top: 0;\n  left: 0;\n}\n\nnav .input-field label i {\n  color: rgba(255, 255, 255, 0.7);\n  -webkit-transition: color .3s;\n  transition: color .3s;\n}\n\nnav .input-field label.active i {\n  color: #fff;\n}\n\n.navbar-fixed {\n  position: relative;\n  height: 56px;\n  z-index: 997;\n}\n\n.navbar-fixed nav {\n  position: fixed;\n}\n\n@media only screen and (min-width: 601px) {\n  nav.nav-extended .nav-wrapper {\n    min-height: 64px;\n  }\n  nav, nav .nav-wrapper i, nav a.button-collapse, nav a.button-collapse i {\n    height: 64px;\n    line-height: 64px;\n  }\n  .navbar-fixed {\n    height: 64px;\n  }\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: local(Roboto Thin), url(" + __webpack_require__(457) + ") format(\"woff2\"), url(" + __webpack_require__(456) + ") format(\"woff\");\n  font-weight: 100;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: local(Roboto Light), url(" + __webpack_require__(451) + ") format(\"woff2\"), url(" + __webpack_require__(450) + ") format(\"woff\");\n  font-weight: 300;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: local(Roboto Regular), url(" + __webpack_require__(455) + ") format(\"woff2\"), url(" + __webpack_require__(454) + ") format(\"woff\");\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: local(Roboto Medium), url(" + __webpack_require__(453) + ") format(\"woff2\"), url(" + __webpack_require__(452) + ") format(\"woff\");\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: local(Roboto Bold), url(" + __webpack_require__(449) + ") format(\"woff2\"), url(" + __webpack_require__(448) + ") format(\"woff\");\n  font-weight: 700;\n}\n\na {\n  text-decoration: none;\n}\n\nhtml {\n  line-height: 1.5;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: normal;\n  color: rgba(0, 0, 0, 0.87);\n}\n\n@media only screen and (min-width: 0) {\n  html {\n    font-size: 14px;\n  }\n}\n\n@media only screen and (min-width: 992px) {\n  html {\n    font-size: 14.5px;\n  }\n}\n\n@media only screen and (min-width: 1200px) {\n  html {\n    font-size: 15px;\n  }\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 400;\n  line-height: 1.1;\n}\n\nh1 a, h2 a, h3 a, h4 a, h5 a, h6 a {\n  font-weight: inherit;\n}\n\nh1 {\n  font-size: 4.2rem;\n  line-height: 110%;\n  margin: 2.1rem 0 1.68rem 0;\n}\n\nh2 {\n  font-size: 3.56rem;\n  line-height: 110%;\n  margin: 1.78rem 0 1.424rem 0;\n}\n\nh3 {\n  font-size: 2.92rem;\n  line-height: 110%;\n  margin: 1.46rem 0 1.168rem 0;\n}\n\nh4 {\n  font-size: 2.28rem;\n  line-height: 110%;\n  margin: 1.14rem 0 0.912rem 0;\n}\n\nh5 {\n  font-size: 1.64rem;\n  line-height: 110%;\n  margin: 0.82rem 0 0.656rem 0;\n}\n\nh6 {\n  font-size: 1rem;\n  line-height: 110%;\n  margin: 0.5rem 0 0.4rem 0;\n}\n\nem {\n  font-style: italic;\n}\n\nstrong {\n  font-weight: 500;\n}\n\nsmall {\n  font-size: 75%;\n}\n\n.light, .page-footer .footer-copyright {\n  font-weight: 300;\n}\n\n.thin {\n  font-weight: 200;\n}\n\n.flow-text {\n  font-weight: 300;\n}\n\n@media only screen and (min-width: 360px) {\n  .flow-text {\n    font-size: 1.2rem;\n  }\n}\n\n@media only screen and (min-width: 390px) {\n  .flow-text {\n    font-size: 1.224rem;\n  }\n}\n\n@media only screen and (min-width: 420px) {\n  .flow-text {\n    font-size: 1.248rem;\n  }\n}\n\n@media only screen and (min-width: 450px) {\n  .flow-text {\n    font-size: 1.272rem;\n  }\n}\n\n@media only screen and (min-width: 480px) {\n  .flow-text {\n    font-size: 1.296rem;\n  }\n}\n\n@media only screen and (min-width: 510px) {\n  .flow-text {\n    font-size: 1.32rem;\n  }\n}\n\n@media only screen and (min-width: 540px) {\n  .flow-text {\n    font-size: 1.344rem;\n  }\n}\n\n@media only screen and (min-width: 570px) {\n  .flow-text {\n    font-size: 1.368rem;\n  }\n}\n\n@media only screen and (min-width: 600px) {\n  .flow-text {\n    font-size: 1.392rem;\n  }\n}\n\n@media only screen and (min-width: 630px) {\n  .flow-text {\n    font-size: 1.416rem;\n  }\n}\n\n@media only screen and (min-width: 660px) {\n  .flow-text {\n    font-size: 1.44rem;\n  }\n}\n\n@media only screen and (min-width: 690px) {\n  .flow-text {\n    font-size: 1.464rem;\n  }\n}\n\n@media only screen and (min-width: 720px) {\n  .flow-text {\n    font-size: 1.488rem;\n  }\n}\n\n@media only screen and (min-width: 750px) {\n  .flow-text {\n    font-size: 1.512rem;\n  }\n}\n\n@media only screen and (min-width: 780px) {\n  .flow-text {\n    font-size: 1.536rem;\n  }\n}\n\n@media only screen and (min-width: 810px) {\n  .flow-text {\n    font-size: 1.56rem;\n  }\n}\n\n@media only screen and (min-width: 840px) {\n  .flow-text {\n    font-size: 1.584rem;\n  }\n}\n\n@media only screen and (min-width: 870px) {\n  .flow-text {\n    font-size: 1.608rem;\n  }\n}\n\n@media only screen and (min-width: 900px) {\n  .flow-text {\n    font-size: 1.632rem;\n  }\n}\n\n@media only screen and (min-width: 930px) {\n  .flow-text {\n    font-size: 1.656rem;\n  }\n}\n\n@media only screen and (min-width: 960px) {\n  .flow-text {\n    font-size: 1.68rem;\n  }\n}\n\n@media only screen and (max-width: 360px) {\n  .flow-text {\n    font-size: 1.2rem;\n  }\n}\n\n.scale-transition {\n  -webkit-transition: -webkit-transform 0.3s cubic-bezier(0.53, 0.01, 0.36, 1.63) !important;\n  transition: -webkit-transform 0.3s cubic-bezier(0.53, 0.01, 0.36, 1.63) !important;\n  transition: transform 0.3s cubic-bezier(0.53, 0.01, 0.36, 1.63) !important;\n  transition: transform 0.3s cubic-bezier(0.53, 0.01, 0.36, 1.63), -webkit-transform 0.3s cubic-bezier(0.53, 0.01, 0.36, 1.63) !important;\n}\n\n.scale-transition.scale-out {\n  -webkit-transform: scale(0);\n          transform: scale(0);\n  -webkit-transition: -webkit-transform .2s !important;\n  transition: -webkit-transform .2s !important;\n  transition: transform .2s !important;\n  transition: transform .2s, -webkit-transform .2s !important;\n}\n\n.scale-transition.scale-in {\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n\n.card-panel {\n  -webkit-transition: -webkit-box-shadow .25s;\n  transition: -webkit-box-shadow .25s;\n  transition: box-shadow .25s;\n  transition: box-shadow .25s, -webkit-box-shadow .25s;\n  padding: 24px;\n  margin: 0.5rem 0 1rem 0;\n  border-radius: 2px;\n  background-color: #fff;\n}\n\n.card {\n  position: relative;\n  margin: 0.5rem 0 1rem 0;\n  background-color: #fff;\n  -webkit-transition: -webkit-box-shadow .25s;\n  transition: -webkit-box-shadow .25s;\n  transition: box-shadow .25s;\n  transition: box-shadow .25s, -webkit-box-shadow .25s;\n  border-radius: 2px;\n}\n\n.card .card-title {\n  font-size: 24px;\n  font-weight: 300;\n}\n\n.card .card-title.activator {\n  cursor: pointer;\n}\n\n.card.small, .card.medium, .card.large {\n  position: relative;\n}\n\n.card.small .card-image, .card.medium .card-image, .card.large .card-image {\n  max-height: 60%;\n  overflow: hidden;\n}\n\n.card.small .card-image + .card-content, .card.medium .card-image + .card-content, .card.large .card-image + .card-content {\n  max-height: 40%;\n}\n\n.card.small .card-content, .card.medium .card-content, .card.large .card-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.card.small .card-action, .card.medium .card-action, .card.large .card-action {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.card.small {\n  height: 300px;\n}\n\n.card.medium {\n  height: 400px;\n}\n\n.card.large {\n  height: 500px;\n}\n\n.card.horizontal {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.card.horizontal.small .card-image, .card.horizontal.medium .card-image, .card.horizontal.large .card-image {\n  height: 100%;\n  max-height: none;\n  overflow: visible;\n}\n\n.card.horizontal.small .card-image img, .card.horizontal.medium .card-image img, .card.horizontal.large .card-image img {\n  height: 100%;\n}\n\n.card.horizontal .card-image {\n  max-width: 50%;\n}\n\n.card.horizontal .card-image img {\n  border-radius: 2px 0 0 2px;\n  max-width: 100%;\n  width: auto;\n}\n\n.card.horizontal .card-stacked {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  position: relative;\n}\n\n.card.horizontal .card-stacked .card-content {\n  -webkit-box-flex: 1;\n  -webkit-flex-grow: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n\n.card.sticky-action .card-action {\n  z-index: 2;\n}\n\n.card.sticky-action .card-reveal {\n  z-index: 1;\n  padding-bottom: 64px;\n}\n\n.card .card-image {\n  position: relative;\n}\n\n.card .card-image img {\n  display: block;\n  border-radius: 2px 2px 0 0;\n  position: relative;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 100%;\n}\n\n.card .card-image .card-title {\n  color: #fff;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  max-width: 100%;\n  padding: 24px;\n}\n\n.card .card-content {\n  padding: 24px;\n  border-radius: 0 0 2px 2px;\n}\n\n.card .card-content p {\n  margin: 0;\n  color: inherit;\n}\n\n.card .card-content .card-title {\n  display: block;\n  line-height: 32px;\n  margin-bottom: 8px;\n}\n\n.card .card-content .card-title i {\n  line-height: 32px;\n}\n\n.card .card-action {\n  position: relative;\n  background-color: inherit;\n  border-top: 1px solid rgba(160, 160, 160, 0.2);\n  padding: 16px 24px;\n}\n\n.card .card-action:last-child {\n  border-radius: 0 0 2px 2px;\n}\n\n.card .card-action a:not(.btn):not(.btn-large):not(.btn-large):not(.btn-floating) {\n  color: #ffab40;\n  margin-right: 24px;\n  -webkit-transition: color .3s ease;\n  transition: color .3s ease;\n  text-transform: uppercase;\n}\n\n.card .card-action a:not(.btn):not(.btn-large):not(.btn-large):not(.btn-floating):hover {\n  color: #ffd8a6;\n}\n\n.card .card-reveal {\n  padding: 24px;\n  position: absolute;\n  background-color: #fff;\n  width: 100%;\n  overflow-y: auto;\n  left: 0;\n  top: 100%;\n  height: 100%;\n  z-index: 3;\n  display: none;\n}\n\n.card .card-reveal .card-title {\n  cursor: pointer;\n  display: block;\n}\n\n#toast-container {\n  display: block;\n  position: fixed;\n  z-index: 10000;\n}\n\n@media only screen and (max-width: 600px) {\n  #toast-container {\n    min-width: 100%;\n    bottom: 0%;\n  }\n}\n\n@media only screen and (min-width: 601px) and (max-width: 992px) {\n  #toast-container {\n    left: 5%;\n    bottom: 7%;\n    max-width: 90%;\n  }\n}\n\n@media only screen and (min-width: 993px) {\n  #toast-container {\n    top: 10%;\n    right: 7%;\n    max-width: 86%;\n  }\n}\n\n.toast {\n  border-radius: 2px;\n  top: 35px;\n  width: auto;\n  margin-top: 10px;\n  position: relative;\n  max-width: 100%;\n  height: auto;\n  min-height: 48px;\n  line-height: 1.5em;\n  word-break: break-all;\n  background-color: #323232;\n  padding: 10px 25px;\n  font-size: 1.1rem;\n  font-weight: 300;\n  color: #fff;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  cursor: default;\n}\n\n.toast .toast-action {\n  color: #eeff41;\n  font-weight: 500;\n  margin-right: -25px;\n  margin-left: 3rem;\n}\n\n.toast.rounded {\n  border-radius: 24px;\n}\n\n@media only screen and (max-width: 600px) {\n  .toast {\n    width: 100%;\n    border-radius: 0;\n  }\n}\n\n.tabs {\n  position: relative;\n  overflow-x: auto;\n  overflow-y: hidden;\n  height: 48px;\n  width: 100%;\n  background-color: #fff;\n  margin: 0 auto;\n  white-space: nowrap;\n}\n\n.tabs.tabs-transparent {\n  background-color: transparent;\n}\n\n.tabs.tabs-transparent .tab a,\n.tabs.tabs-transparent .tab.disabled a,\n.tabs.tabs-transparent .tab.disabled a:hover {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.tabs.tabs-transparent .tab a:hover,\n.tabs.tabs-transparent .tab a.active {\n  color: #fff;\n}\n\n.tabs.tabs-transparent .indicator {\n  background-color: #fff;\n}\n\n.tabs.tabs-fixed-width {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.tabs.tabs-fixed-width .tab {\n  -webkit-box-flex: 1;\n  -webkit-flex-grow: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n\n.tabs .tab {\n  display: inline-block;\n  text-align: center;\n  line-height: 48px;\n  height: 48px;\n  padding: 0;\n  margin: 0;\n  text-transform: uppercase;\n}\n\n.tabs .tab a {\n  color: rgba(238, 110, 115, 0.7);\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 0 24px;\n  font-size: 14px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-transition: color .28s ease;\n  transition: color .28s ease;\n}\n\n.tabs .tab a:hover, .tabs .tab a.active {\n  background-color: transparent;\n  color: #ee6e73;\n}\n\n.tabs .tab.disabled a,\n.tabs .tab.disabled a:hover {\n  color: rgba(238, 110, 115, 0.7);\n  cursor: default;\n}\n\n.tabs .indicator {\n  position: absolute;\n  bottom: 0;\n  height: 2px;\n  background-color: #f6b2b5;\n  will-change: left, right;\n}\n\n@media only screen and (max-width: 992px) {\n  .tabs {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n  }\n  .tabs .tab {\n    -webkit-box-flex: 1;\n    -webkit-flex-grow: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n  }\n  .tabs .tab a {\n    padding: 0 12px;\n  }\n}\n\n.material-tooltip {\n  padding: 10px 8px;\n  font-size: 1rem;\n  z-index: 2000;\n  background-color: transparent;\n  border-radius: 2px;\n  color: #fff;\n  min-height: 36px;\n  line-height: 120%;\n  opacity: 0;\n  position: absolute;\n  text-align: center;\n  max-width: calc(100% - 4px);\n  overflow: hidden;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.backdrop {\n  position: absolute;\n  opacity: 0;\n  height: 7px;\n  width: 14px;\n  border-radius: 0 0 50% 50%;\n  background-color: #323232;\n  z-index: -1;\n  -webkit-transform-origin: 50% 0%;\n          transform-origin: 50% 0%;\n  visibility: hidden;\n}\n\n.btn, .btn-large,\n.btn-flat {\n  border: none;\n  border-radius: 2px;\n  display: inline-block;\n  height: 36px;\n  line-height: 36px;\n  padding: 0 2rem;\n  text-transform: uppercase;\n  vertical-align: middle;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.btn.disabled, .disabled.btn-large,\n.btn-floating.disabled,\n.btn-large.disabled,\n.btn-flat.disabled,\n.btn:disabled,\n.btn-large:disabled,\n.btn-floating:disabled,\n.btn-large:disabled,\n.btn-flat:disabled,\n.btn[disabled],\n[disabled].btn-large,\n.btn-floating[disabled],\n.btn-large[disabled],\n.btn-flat[disabled] {\n  pointer-events: none;\n  background-color: #DFDFDF !important;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #9F9F9F !important;\n  cursor: default;\n}\n\n.btn.disabled:hover, .disabled.btn-large:hover,\n.btn-floating.disabled:hover,\n.btn-large.disabled:hover,\n.btn-flat.disabled:hover,\n.btn:disabled:hover,\n.btn-large:disabled:hover,\n.btn-floating:disabled:hover,\n.btn-large:disabled:hover,\n.btn-flat:disabled:hover,\n.btn[disabled]:hover,\n[disabled].btn-large:hover,\n.btn-floating[disabled]:hover,\n.btn-large[disabled]:hover,\n.btn-flat[disabled]:hover {\n  background-color: #DFDFDF !important;\n  color: #9F9F9F !important;\n}\n\n.btn, .btn-large,\n.btn-floating,\n.btn-large,\n.btn-flat {\n  font-size: 1rem;\n  outline: 0;\n}\n\n.btn i, .btn-large i,\n.btn-floating i,\n.btn-large i,\n.btn-flat i {\n  font-size: 1.3rem;\n  line-height: inherit;\n}\n\n.btn:focus, .btn-large:focus,\n.btn-floating:focus {\n  background-color: #1d7d74;\n}\n\n.btn, .btn-large {\n  text-decoration: none;\n  color: #fff;\n  background-color: #26a69a;\n  text-align: center;\n  letter-spacing: .5px;\n  -webkit-transition: .2s ease-out;\n  transition: .2s ease-out;\n  cursor: pointer;\n}\n\n.btn:hover, .btn-large:hover {\n  background-color: #2bbbad;\n}\n\n.btn-floating {\n  display: inline-block;\n  color: #fff;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  padding: 0;\n  background-color: #26a69a;\n  border-radius: 50%;\n  -webkit-transition: .3s;\n  transition: .3s;\n  cursor: pointer;\n  vertical-align: middle;\n}\n\n.btn-floating:hover {\n  background-color: #26a69a;\n}\n\n.btn-floating:before {\n  border-radius: 0;\n}\n\n.btn-floating.btn-large {\n  width: 56px;\n  height: 56px;\n}\n\n.btn-floating.btn-large.halfway-fab {\n  bottom: -28px;\n}\n\n.btn-floating.btn-large i {\n  line-height: 56px;\n}\n\n.btn-floating.halfway-fab {\n  position: absolute;\n  right: 24px;\n  bottom: -20px;\n}\n\n.btn-floating.halfway-fab.left {\n  right: auto;\n  left: 24px;\n}\n\n.btn-floating i {\n  width: inherit;\n  display: inline-block;\n  text-align: center;\n  color: #fff;\n  font-size: 1.6rem;\n  line-height: 40px;\n}\n\nbutton.btn-floating {\n  border: none;\n}\n\n.fixed-action-btn {\n  position: fixed;\n  right: 23px;\n  bottom: 23px;\n  padding-top: 15px;\n  margin-bottom: 0;\n  z-index: 997;\n}\n\n.fixed-action-btn.active ul {\n  visibility: visible;\n}\n\n.fixed-action-btn.horizontal {\n  padding: 0 0 0 15px;\n}\n\n.fixed-action-btn.horizontal ul {\n  text-align: right;\n  right: 64px;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  height: 100%;\n  left: auto;\n  width: 500px;\n  /*width 100% only goes to width of button container */\n}\n\n.fixed-action-btn.horizontal ul li {\n  display: inline-block;\n  margin: 15px 15px 0 0;\n}\n\n.fixed-action-btn.toolbar {\n  padding: 0;\n  height: 56px;\n}\n\n.fixed-action-btn.toolbar.active > a i {\n  opacity: 0;\n}\n\n.fixed-action-btn.toolbar ul {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n}\n\n.fixed-action-btn.toolbar ul li {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  display: inline-block;\n  margin: 0;\n  height: 100%;\n  -webkit-transition: none;\n  transition: none;\n}\n\n.fixed-action-btn.toolbar ul li a {\n  display: block;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #fff;\n  line-height: 56px;\n  z-index: 1;\n}\n\n.fixed-action-btn.toolbar ul li a i {\n  line-height: inherit;\n}\n\n.fixed-action-btn ul {\n  left: 0;\n  right: 0;\n  text-align: center;\n  position: absolute;\n  bottom: 64px;\n  margin: 0;\n  visibility: hidden;\n}\n\n.fixed-action-btn ul li {\n  margin-bottom: 15px;\n}\n\n.fixed-action-btn ul a.btn-floating {\n  opacity: 0;\n}\n\n.fixed-action-btn .fab-backdrop {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  width: 40px;\n  height: 40px;\n  background-color: #26a69a;\n  border-radius: 50%;\n  -webkit-transform: scale(0);\n          transform: scale(0);\n}\n\n.btn-flat {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: transparent;\n  color: #343434;\n  cursor: pointer;\n  -webkit-transition: background-color .2s;\n  transition: background-color .2s;\n}\n\n.btn-flat:focus, .btn-flat:hover {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.btn-flat:focus {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.btn-flat.disabled {\n  background-color: transparent !important;\n  color: #b3b2b2 !important;\n  cursor: default;\n}\n\n.btn-large {\n  height: 54px;\n  line-height: 54px;\n}\n\n.btn-large i {\n  font-size: 1.6rem;\n}\n\n.btn-block {\n  display: block;\n}\n\n.dropdown-content {\n  background-color: #fff;\n  margin: 0;\n  display: none;\n  min-width: 100px;\n  max-height: 650px;\n  overflow-y: auto;\n  opacity: 0;\n  position: absolute;\n  z-index: 999;\n  will-change: width, height;\n}\n\n.dropdown-content li {\n  clear: both;\n  color: rgba(0, 0, 0, 0.87);\n  cursor: pointer;\n  min-height: 50px;\n  line-height: 1.5rem;\n  width: 100%;\n  text-align: left;\n  text-transform: none;\n}\n\n.dropdown-content li:hover, .dropdown-content li.active, .dropdown-content li.selected {\n  background-color: #eee;\n}\n\n.dropdown-content li.active.selected {\n  background-color: #e1e1e1;\n}\n\n.dropdown-content li.divider {\n  min-height: 0;\n  height: 1px;\n}\n\n.dropdown-content li > a, .dropdown-content li > span {\n  font-size: 16px;\n  color: #26a69a;\n  display: block;\n  line-height: 22px;\n  padding: 14px 16px;\n}\n\n.dropdown-content li > span > label {\n  top: 1px;\n  left: 0;\n  height: 18px;\n}\n\n.dropdown-content li > a > i {\n  height: inherit;\n  line-height: inherit;\n  float: left;\n  margin: 0 24px 0 0;\n  width: 24px;\n}\n\n.input-field.col .dropdown-content [type=\"checkbox\"] + label {\n  top: 1px;\n  left: 0;\n  height: 18px;\n}\n\n/*!\r\n * Waves v0.6.0\r\n * http://fian.my.id/Waves\r\n *\r\n * Copyright 2014 Alfiana E. Sibuea and other contributors\r\n * Released under the MIT license\r\n * https://github.com/fians/Waves/blob/master/LICENSE\r\n */\n.waves-effect {\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n  overflow: hidden;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  vertical-align: middle;\n  z-index: 1;\n  -webkit-transition: .3s ease-out;\n  transition: .3s ease-out;\n}\n\n.waves-effect .waves-ripple {\n  position: absolute;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  margin-top: -10px;\n  margin-left: -10px;\n  opacity: 0;\n  background: rgba(0, 0, 0, 0.2);\n  -webkit-transition: all 0.7s ease-out;\n  transition: all 0.7s ease-out;\n  -webkit-transition-property: opacity, -webkit-transform;\n  transition-property: opacity, -webkit-transform;\n  transition-property: transform, opacity;\n  transition-property: transform, opacity, -webkit-transform;\n  -webkit-transform: scale(0);\n          transform: scale(0);\n  pointer-events: none;\n}\n\n.waves-effect.waves-light .waves-ripple {\n  background-color: rgba(255, 255, 255, 0.45);\n}\n\n.waves-effect.waves-red .waves-ripple {\n  background-color: rgba(244, 67, 54, 0.7);\n}\n\n.waves-effect.waves-yellow .waves-ripple {\n  background-color: rgba(255, 235, 59, 0.7);\n}\n\n.waves-effect.waves-orange .waves-ripple {\n  background-color: rgba(255, 152, 0, 0.7);\n}\n\n.waves-effect.waves-purple .waves-ripple {\n  background-color: rgba(156, 39, 176, 0.7);\n}\n\n.waves-effect.waves-green .waves-ripple {\n  background-color: rgba(76, 175, 80, 0.7);\n}\n\n.waves-effect.waves-teal .waves-ripple {\n  background-color: rgba(0, 150, 136, 0.7);\n}\n\n.waves-effect input[type=\"button\"], .waves-effect input[type=\"reset\"], .waves-effect input[type=\"submit\"] {\n  border: 0;\n  font-style: normal;\n  font-size: inherit;\n  text-transform: inherit;\n  background: none;\n}\n\n.waves-effect img {\n  position: relative;\n  z-index: -1;\n}\n\n.waves-notransition {\n  -webkit-transition: none !important;\n  transition: none !important;\n}\n\n.waves-circle {\n  -webkit-transform: translateZ(0);\n          transform: translateZ(0);\n  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);\n}\n\n.waves-input-wrapper {\n  border-radius: 0.2em;\n  vertical-align: bottom;\n}\n\n.waves-input-wrapper .waves-button-input {\n  position: relative;\n  top: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.waves-circle {\n  text-align: center;\n  width: 2.5em;\n  height: 2.5em;\n  line-height: 2.5em;\n  border-radius: 50%;\n  -webkit-mask-image: none;\n}\n\n.waves-block {\n  display: block;\n}\n\n/* Firefox Bug: link not triggered */\n.waves-effect .waves-ripple {\n  z-index: -1;\n}\n\n.modal {\n  display: none;\n  position: fixed;\n  left: 0;\n  right: 0;\n  background-color: #fafafa;\n  padding: 0;\n  max-height: 70%;\n  width: 55%;\n  margin: auto;\n  overflow-y: auto;\n  border-radius: 2px;\n  will-change: top, opacity;\n}\n\n@media only screen and (max-width: 992px) {\n  .modal {\n    width: 80%;\n  }\n}\n\n.modal h1, .modal h2, .modal h3, .modal h4 {\n  margin-top: 0;\n}\n\n.modal .modal-content {\n  padding: 24px;\n}\n\n.modal .modal-close {\n  cursor: pointer;\n}\n\n.modal .modal-footer {\n  border-radius: 0 0 2px 2px;\n  background-color: #fafafa;\n  padding: 4px 6px;\n  height: 56px;\n  width: 100%;\n  text-align: right;\n}\n\n.modal .modal-footer .btn, .modal .modal-footer .btn-large, .modal .modal-footer .btn-flat {\n  margin: 6px 0;\n}\n\n.modal-overlay {\n  position: fixed;\n  z-index: 999;\n  top: -25%;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  height: 125%;\n  width: 100%;\n  background: #000;\n  display: none;\n  will-change: opacity;\n}\n\n.modal.modal-fixed-footer {\n  padding: 0;\n  height: 70%;\n}\n\n.modal.modal-fixed-footer .modal-content {\n  position: absolute;\n  height: calc(100% - 56px);\n  max-height: 100%;\n  width: 100%;\n  overflow-y: auto;\n}\n\n.modal.modal-fixed-footer .modal-footer {\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n  position: absolute;\n  bottom: 0;\n}\n\n.modal.bottom-sheet {\n  top: auto;\n  bottom: -100%;\n  margin: 0;\n  width: 100%;\n  max-height: 45%;\n  border-radius: 0;\n  will-change: bottom, opacity;\n}\n\n.collapsible {\n  border-top: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n  border-left: 1px solid #ddd;\n  margin: 0.5rem 0 1rem 0;\n}\n\n.collapsible-header {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  line-height: 1.5;\n  padding: 1rem;\n  background-color: #fff;\n  border-bottom: 1px solid #ddd;\n}\n\n.collapsible-header i {\n  width: 2rem;\n  font-size: 1.6rem;\n  display: inline-block;\n  text-align: center;\n  margin-right: 1rem;\n}\n\n.collapsible-body {\n  display: none;\n  border-bottom: 1px solid #ddd;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 2rem;\n}\n\n.side-nav .collapsible,\n.side-nav.fixed .collapsible {\n  border: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.side-nav .collapsible li,\n.side-nav.fixed .collapsible li {\n  padding: 0;\n}\n\n.side-nav .collapsible-header,\n.side-nav.fixed .collapsible-header {\n  background-color: transparent;\n  border: none;\n  line-height: inherit;\n  height: inherit;\n  padding: 0 16px;\n}\n\n.side-nav .collapsible-header:hover,\n.side-nav.fixed .collapsible-header:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.side-nav .collapsible-header i,\n.side-nav.fixed .collapsible-header i {\n  line-height: inherit;\n}\n\n.side-nav .collapsible-body,\n.side-nav.fixed .collapsible-body {\n  border: 0;\n  background-color: #fff;\n}\n\n.side-nav .collapsible-body li a,\n.side-nav.fixed .collapsible-body li a {\n  padding: 0 23.5px 0 31px;\n}\n\n.collapsible.popout {\n  border: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.collapsible.popout > li {\n  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n  margin: 0 24px;\n  -webkit-transition: margin 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  transition: margin 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.collapsible.popout > li.active {\n  -webkit-box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);\n          box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);\n  margin: 16px 0;\n}\n\n.chip {\n  display: inline-block;\n  height: 32px;\n  font-size: 13px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.6);\n  line-height: 32px;\n  padding: 0 12px;\n  border-radius: 16px;\n  background-color: #e4e4e4;\n  margin-bottom: 5px;\n  margin-right: 5px;\n}\n\n.chip > img {\n  float: left;\n  margin: 0 8px 0 -12px;\n  height: 32px;\n  width: 32px;\n  border-radius: 50%;\n}\n\n.chip .close {\n  cursor: pointer;\n  float: right;\n  font-size: 16px;\n  line-height: 32px;\n  padding-left: 8px;\n}\n\n.chips {\n  border: none;\n  border-bottom: 1px solid #9e9e9e;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  margin: 0 0 20px 0;\n  min-height: 45px;\n  outline: none;\n  -webkit-transition: all .3s;\n  transition: all .3s;\n}\n\n.chips.focus {\n  border-bottom: 1px solid #26a69a;\n  -webkit-box-shadow: 0 1px 0 0 #26a69a;\n          box-shadow: 0 1px 0 0 #26a69a;\n}\n\n.chips:hover {\n  cursor: text;\n}\n\n.chips .chip.selected {\n  background-color: #26a69a;\n  color: #fff;\n}\n\n.chips .input {\n  background: none;\n  border: 0;\n  color: rgba(0, 0, 0, 0.6);\n  display: inline-block;\n  font-size: 1rem;\n  height: 3rem;\n  line-height: 32px;\n  outline: 0;\n  margin: 0;\n  padding: 0 !important;\n  width: 120px !important;\n}\n\n.chips .input:focus {\n  border: 0 !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n\n.chips .autocomplete-content {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.prefix ~ .chips {\n  margin-left: 3rem;\n  width: 92%;\n  width: calc(100% - 3rem);\n}\n\n.chips:empty ~ label {\n  font-size: 0.8rem;\n  -webkit-transform: translateY(-140%);\n          transform: translateY(-140%);\n}\n\n.materialboxed {\n  display: block;\n  cursor: -webkit-zoom-in;\n  cursor: zoom-in;\n  position: relative;\n  -webkit-transition: opacity .4s;\n  transition: opacity .4s;\n  -webkit-backface-visibility: hidden;\n}\n\n.materialboxed:hover:not(.active) {\n  opacity: .8;\n}\n\n.materialboxed.active {\n  cursor: -webkit-zoom-out;\n  cursor: zoom-out;\n}\n\n#materialbox-overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: #292929;\n  z-index: 1000;\n  will-change: opacity;\n}\n\n.materialbox-caption {\n  position: fixed;\n  display: none;\n  color: #fff;\n  line-height: 50px;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  text-align: center;\n  padding: 0% 15%;\n  height: 50px;\n  z-index: 1000;\n  -webkit-font-smoothing: antialiased;\n}\n\nselect:focus {\n  outline: 1px solid #c9f3ef;\n}\n\nbutton:focus {\n  outline: none;\n  background-color: #2ab7a9;\n}\n\nlabel {\n  font-size: 0.8rem;\n  color: #9e9e9e;\n}\n\n/* Text Inputs + Textarea\r\n   ========================================================================== */\n/* Style Placeholders */\n::-webkit-input-placeholder {\n  color: #d1d1d1;\n}\n::-moz-placeholder {\n  color: #d1d1d1;\n}\n:-ms-input-placeholder {\n  color: #d1d1d1;\n}\n::placeholder {\n  color: #d1d1d1;\n}\n\n/* Text inputs */\ninput:not([type]),\ninput[type=text]:not(.browser-default),\ninput[type=password]:not(.browser-default),\ninput[type=email]:not(.browser-default),\ninput[type=url]:not(.browser-default),\ninput[type=time]:not(.browser-default),\ninput[type=date]:not(.browser-default),\ninput[type=datetime]:not(.browser-default),\ninput[type=datetime-local]:not(.browser-default),\ninput[type=tel]:not(.browser-default),\ninput[type=number]:not(.browser-default),\ninput[type=search]:not(.browser-default),\ntextarea.materialize-textarea {\n  background-color: transparent;\n  border: none;\n  border-bottom: 1px solid #9e9e9e;\n  border-radius: 0;\n  outline: none;\n  height: 3rem;\n  width: 100%;\n  font-size: 1rem;\n  margin: 0 0 20px 0;\n  padding: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\ninput:not([type]):disabled, input:not([type])[readonly=\"readonly\"],\ninput[type=text]:not(.browser-default):disabled,\ninput[type=text]:not(.browser-default)[readonly=\"readonly\"],\ninput[type=password]:not(.browser-default):disabled,\ninput[type=password]:not(.browser-default)[readonly=\"readonly\"],\ninput[type=email]:not(.browser-default):disabled,\ninput[type=email]:not(.browser-default)[readonly=\"readonly\"],\ninput[type=url]:not(.browser-default):disabled,\ninput[type=url]:not(.browser-default)[readonly=\"readonly\"],\ninput[type=time]:not(.browser-default):disabled,\ninput[type=time]:not(.browser-default)[readonly=\"readonly\"],\ninput[type=date]:not(.browser-default):disabled,\ninput[type=date]:not(.browser-default)[readonly=\"readonly\"],\ninput[type=datetime]:not(.browser-default):disabled,\ninput[type=datetime]:not(.browser-default)[readonly=\"readonly\"],\ninput[type=datetime-local]:not(.browser-default):disabled,\ninput[type=datetime-local]:not(.browser-default)[readonly=\"readonly\"],\ninput[type=tel]:not(.browser-default):disabled,\ninput[type=tel]:not(.browser-default)[readonly=\"readonly\"],\ninput[type=number]:not(.browser-default):disabled,\ninput[type=number]:not(.browser-default)[readonly=\"readonly\"],\ninput[type=search]:not(.browser-default):disabled,\ninput[type=search]:not(.browser-default)[readonly=\"readonly\"],\ntextarea.materialize-textarea:disabled,\ntextarea.materialize-textarea[readonly=\"readonly\"] {\n  color: rgba(0, 0, 0, 0.42);\n  border-bottom: 1px dotted rgba(0, 0, 0, 0.42);\n}\n\ninput:not([type]):disabled + label,\ninput:not([type])[readonly=\"readonly\"] + label,\ninput[type=text]:not(.browser-default):disabled + label,\ninput[type=text]:not(.browser-default)[readonly=\"readonly\"] + label,\ninput[type=password]:not(.browser-default):disabled + label,\ninput[type=password]:not(.browser-default)[readonly=\"readonly\"] + label,\ninput[type=email]:not(.browser-default):disabled + label,\ninput[type=email]:not(.browser-default)[readonly=\"readonly\"] + label,\ninput[type=url]:not(.browser-default):disabled + label,\ninput[type=url]:not(.browser-default)[readonly=\"readonly\"] + label,\ninput[type=time]:not(.browser-default):disabled + label,\ninput[type=time]:not(.browser-default)[readonly=\"readonly\"] + label,\ninput[type=date]:not(.browser-default):disabled + label,\ninput[type=date]:not(.browser-default)[readonly=\"readonly\"] + label,\ninput[type=datetime]:not(.browser-default):disabled + label,\ninput[type=datetime]:not(.browser-default)[readonly=\"readonly\"] + label,\ninput[type=datetime-local]:not(.browser-default):disabled + label,\ninput[type=datetime-local]:not(.browser-default)[readonly=\"readonly\"] + label,\ninput[type=tel]:not(.browser-default):disabled + label,\ninput[type=tel]:not(.browser-default)[readonly=\"readonly\"] + label,\ninput[type=number]:not(.browser-default):disabled + label,\ninput[type=number]:not(.browser-default)[readonly=\"readonly\"] + label,\ninput[type=search]:not(.browser-default):disabled + label,\ninput[type=search]:not(.browser-default)[readonly=\"readonly\"] + label,\ntextarea.materialize-textarea:disabled + label,\ntextarea.materialize-textarea[readonly=\"readonly\"] + label {\n  color: rgba(0, 0, 0, 0.42);\n}\n\ninput:not([type]):focus:not([readonly]),\ninput[type=text]:not(.browser-default):focus:not([readonly]),\ninput[type=password]:not(.browser-default):focus:not([readonly]),\ninput[type=email]:not(.browser-default):focus:not([readonly]),\ninput[type=url]:not(.browser-default):focus:not([readonly]),\ninput[type=time]:not(.browser-default):focus:not([readonly]),\ninput[type=date]:not(.browser-default):focus:not([readonly]),\ninput[type=datetime]:not(.browser-default):focus:not([readonly]),\ninput[type=datetime-local]:not(.browser-default):focus:not([readonly]),\ninput[type=tel]:not(.browser-default):focus:not([readonly]),\ninput[type=number]:not(.browser-default):focus:not([readonly]),\ninput[type=search]:not(.browser-default):focus:not([readonly]),\ntextarea.materialize-textarea:focus:not([readonly]) {\n  border-bottom: 1px solid #26a69a;\n  -webkit-box-shadow: 0 1px 0 0 #26a69a;\n          box-shadow: 0 1px 0 0 #26a69a;\n}\n\ninput:not([type]):focus:not([readonly]) + label,\ninput[type=text]:not(.browser-default):focus:not([readonly]) + label,\ninput[type=password]:not(.browser-default):focus:not([readonly]) + label,\ninput[type=email]:not(.browser-default):focus:not([readonly]) + label,\ninput[type=url]:not(.browser-default):focus:not([readonly]) + label,\ninput[type=time]:not(.browser-default):focus:not([readonly]) + label,\ninput[type=date]:not(.browser-default):focus:not([readonly]) + label,\ninput[type=datetime]:not(.browser-default):focus:not([readonly]) + label,\ninput[type=datetime-local]:not(.browser-default):focus:not([readonly]) + label,\ninput[type=tel]:not(.browser-default):focus:not([readonly]) + label,\ninput[type=number]:not(.browser-default):focus:not([readonly]) + label,\ninput[type=search]:not(.browser-default):focus:not([readonly]) + label,\ntextarea.materialize-textarea:focus:not([readonly]) + label {\n  color: #26a69a;\n}\n\ninput:not([type]).validate + label,\ninput[type=text]:not(.browser-default).validate + label,\ninput[type=password]:not(.browser-default).validate + label,\ninput[type=email]:not(.browser-default).validate + label,\ninput[type=url]:not(.browser-default).validate + label,\ninput[type=time]:not(.browser-default).validate + label,\ninput[type=date]:not(.browser-default).validate + label,\ninput[type=datetime]:not(.browser-default).validate + label,\ninput[type=datetime-local]:not(.browser-default).validate + label,\ninput[type=tel]:not(.browser-default).validate + label,\ninput[type=number]:not(.browser-default).validate + label,\ninput[type=search]:not(.browser-default).validate + label,\ntextarea.materialize-textarea.validate + label {\n  width: 100%;\n}\n\ninput:not([type]).invalid + label:after,\ninput:not([type]).valid + label:after,\ninput[type=text]:not(.browser-default).invalid + label:after,\ninput[type=text]:not(.browser-default).valid + label:after,\ninput[type=password]:not(.browser-default).invalid + label:after,\ninput[type=password]:not(.browser-default).valid + label:after,\ninput[type=email]:not(.browser-default).invalid + label:after,\ninput[type=email]:not(.browser-default).valid + label:after,\ninput[type=url]:not(.browser-default).invalid + label:after,\ninput[type=url]:not(.browser-default).valid + label:after,\ninput[type=time]:not(.browser-default).invalid + label:after,\ninput[type=time]:not(.browser-default).valid + label:after,\ninput[type=date]:not(.browser-default).invalid + label:after,\ninput[type=date]:not(.browser-default).valid + label:after,\ninput[type=datetime]:not(.browser-default).invalid + label:after,\ninput[type=datetime]:not(.browser-default).valid + label:after,\ninput[type=datetime-local]:not(.browser-default).invalid + label:after,\ninput[type=datetime-local]:not(.browser-default).valid + label:after,\ninput[type=tel]:not(.browser-default).invalid + label:after,\ninput[type=tel]:not(.browser-default).valid + label:after,\ninput[type=number]:not(.browser-default).invalid + label:after,\ninput[type=number]:not(.browser-default).valid + label:after,\ninput[type=search]:not(.browser-default).invalid + label:after,\ninput[type=search]:not(.browser-default).valid + label:after,\ntextarea.materialize-textarea.invalid + label:after,\ntextarea.materialize-textarea.valid + label:after {\n  display: none;\n}\n\ninput:not([type]).invalid + label.active:after,\ninput:not([type]).valid + label.active:after,\ninput[type=text]:not(.browser-default).invalid + label.active:after,\ninput[type=text]:not(.browser-default).valid + label.active:after,\ninput[type=password]:not(.browser-default).invalid + label.active:after,\ninput[type=password]:not(.browser-default).valid + label.active:after,\ninput[type=email]:not(.browser-default).invalid + label.active:after,\ninput[type=email]:not(.browser-default).valid + label.active:after,\ninput[type=url]:not(.browser-default).invalid + label.active:after,\ninput[type=url]:not(.browser-default).valid + label.active:after,\ninput[type=time]:not(.browser-default).invalid + label.active:after,\ninput[type=time]:not(.browser-default).valid + label.active:after,\ninput[type=date]:not(.browser-default).invalid + label.active:after,\ninput[type=date]:not(.browser-default).valid + label.active:after,\ninput[type=datetime]:not(.browser-default).invalid + label.active:after,\ninput[type=datetime]:not(.browser-default).valid + label.active:after,\ninput[type=datetime-local]:not(.browser-default).invalid + label.active:after,\ninput[type=datetime-local]:not(.browser-default).valid + label.active:after,\ninput[type=tel]:not(.browser-default).invalid + label.active:after,\ninput[type=tel]:not(.browser-default).valid + label.active:after,\ninput[type=number]:not(.browser-default).invalid + label.active:after,\ninput[type=number]:not(.browser-default).valid + label.active:after,\ninput[type=search]:not(.browser-default).invalid + label.active:after,\ninput[type=search]:not(.browser-default).valid + label.active:after,\ntextarea.materialize-textarea.invalid + label.active:after,\ntextarea.materialize-textarea.valid + label.active:after {\n  display: block;\n}\n\n/* Validation Sass Placeholders */\ninput.valid:not([type]), input.valid:not([type]):focus,\ninput[type=text].valid:not(.browser-default),\ninput[type=text].valid:not(.browser-default):focus,\ninput[type=password].valid:not(.browser-default),\ninput[type=password].valid:not(.browser-default):focus,\ninput[type=email].valid:not(.browser-default),\ninput[type=email].valid:not(.browser-default):focus,\ninput[type=url].valid:not(.browser-default),\ninput[type=url].valid:not(.browser-default):focus,\ninput[type=time].valid:not(.browser-default),\ninput[type=time].valid:not(.browser-default):focus,\ninput[type=date].valid:not(.browser-default),\ninput[type=date].valid:not(.browser-default):focus,\ninput[type=datetime].valid:not(.browser-default),\ninput[type=datetime].valid:not(.browser-default):focus,\ninput[type=datetime-local].valid:not(.browser-default),\ninput[type=datetime-local].valid:not(.browser-default):focus,\ninput[type=tel].valid:not(.browser-default),\ninput[type=tel].valid:not(.browser-default):focus,\ninput[type=number].valid:not(.browser-default),\ninput[type=number].valid:not(.browser-default):focus,\ninput[type=search].valid:not(.browser-default),\ninput[type=search].valid:not(.browser-default):focus,\ntextarea.materialize-textarea.valid,\ntextarea.materialize-textarea.valid:focus, .select-wrapper.valid > input.select-dropdown {\n  border-bottom: 1px solid #4CAF50;\n  -webkit-box-shadow: 0 1px 0 0 #4CAF50;\n          box-shadow: 0 1px 0 0 #4CAF50;\n}\n\ninput.invalid:not([type]), input.invalid:not([type]):focus,\ninput[type=text].invalid:not(.browser-default),\ninput[type=text].invalid:not(.browser-default):focus,\ninput[type=password].invalid:not(.browser-default),\ninput[type=password].invalid:not(.browser-default):focus,\ninput[type=email].invalid:not(.browser-default),\ninput[type=email].invalid:not(.browser-default):focus,\ninput[type=url].invalid:not(.browser-default),\ninput[type=url].invalid:not(.browser-default):focus,\ninput[type=time].invalid:not(.browser-default),\ninput[type=time].invalid:not(.browser-default):focus,\ninput[type=date].invalid:not(.browser-default),\ninput[type=date].invalid:not(.browser-default):focus,\ninput[type=datetime].invalid:not(.browser-default),\ninput[type=datetime].invalid:not(.browser-default):focus,\ninput[type=datetime-local].invalid:not(.browser-default),\ninput[type=datetime-local].invalid:not(.browser-default):focus,\ninput[type=tel].invalid:not(.browser-default),\ninput[type=tel].invalid:not(.browser-default):focus,\ninput[type=number].invalid:not(.browser-default),\ninput[type=number].invalid:not(.browser-default):focus,\ninput[type=search].invalid:not(.browser-default),\ninput[type=search].invalid:not(.browser-default):focus,\ntextarea.materialize-textarea.invalid,\ntextarea.materialize-textarea.invalid:focus, .select-wrapper.invalid > input.select-dropdown {\n  border-bottom: 1px solid #F44336;\n  -webkit-box-shadow: 0 1px 0 0 #F44336;\n          box-shadow: 0 1px 0 0 #F44336;\n}\n\ninput:not([type]).valid + label:after,\ninput:not([type]):focus.valid + label:after,\ninput[type=text]:not(.browser-default).valid + label:after,\ninput[type=text]:not(.browser-default):focus.valid + label:after,\ninput[type=password]:not(.browser-default).valid + label:after,\ninput[type=password]:not(.browser-default):focus.valid + label:after,\ninput[type=email]:not(.browser-default).valid + label:after,\ninput[type=email]:not(.browser-default):focus.valid + label:after,\ninput[type=url]:not(.browser-default).valid + label:after,\ninput[type=url]:not(.browser-default):focus.valid + label:after,\ninput[type=time]:not(.browser-default).valid + label:after,\ninput[type=time]:not(.browser-default):focus.valid + label:after,\ninput[type=date]:not(.browser-default).valid + label:after,\ninput[type=date]:not(.browser-default):focus.valid + label:after,\ninput[type=datetime]:not(.browser-default).valid + label:after,\ninput[type=datetime]:not(.browser-default):focus.valid + label:after,\ninput[type=datetime-local]:not(.browser-default).valid + label:after,\ninput[type=datetime-local]:not(.browser-default):focus.valid + label:after,\ninput[type=tel]:not(.browser-default).valid + label:after,\ninput[type=tel]:not(.browser-default):focus.valid + label:after,\ninput[type=number]:not(.browser-default).valid + label:after,\ninput[type=number]:not(.browser-default):focus.valid + label:after,\ninput[type=search]:not(.browser-default).valid + label:after,\ninput[type=search]:not(.browser-default):focus.valid + label:after,\ntextarea.materialize-textarea.valid + label:after,\ntextarea.materialize-textarea:focus.valid + label:after, .select-wrapper.valid + label:after {\n  content: attr(data-success);\n  color: #4CAF50;\n  opacity: 1;\n  -webkit-transform: translateY(9px);\n          transform: translateY(9px);\n}\n\ninput:not([type]).invalid + label:after,\ninput:not([type]):focus.invalid + label:after,\ninput[type=text]:not(.browser-default).invalid + label:after,\ninput[type=text]:not(.browser-default):focus.invalid + label:after,\ninput[type=password]:not(.browser-default).invalid + label:after,\ninput[type=password]:not(.browser-default):focus.invalid + label:after,\ninput[type=email]:not(.browser-default).invalid + label:after,\ninput[type=email]:not(.browser-default):focus.invalid + label:after,\ninput[type=url]:not(.browser-default).invalid + label:after,\ninput[type=url]:not(.browser-default):focus.invalid + label:after,\ninput[type=time]:not(.browser-default).invalid + label:after,\ninput[type=time]:not(.browser-default):focus.invalid + label:after,\ninput[type=date]:not(.browser-default).invalid + label:after,\ninput[type=date]:not(.browser-default):focus.invalid + label:after,\ninput[type=datetime]:not(.browser-default).invalid + label:after,\ninput[type=datetime]:not(.browser-default):focus.invalid + label:after,\ninput[type=datetime-local]:not(.browser-default).invalid + label:after,\ninput[type=datetime-local]:not(.browser-default):focus.invalid + label:after,\ninput[type=tel]:not(.browser-default).invalid + label:after,\ninput[type=tel]:not(.browser-default):focus.invalid + label:after,\ninput[type=number]:not(.browser-default).invalid + label:after,\ninput[type=number]:not(.browser-default):focus.invalid + label:after,\ninput[type=search]:not(.browser-default).invalid + label:after,\ninput[type=search]:not(.browser-default):focus.invalid + label:after,\ntextarea.materialize-textarea.invalid + label:after,\ntextarea.materialize-textarea:focus.invalid + label:after, .select-wrapper.invalid + label:after {\n  content: attr(data-error);\n  color: #F44336;\n  opacity: 1;\n  -webkit-transform: translateY(9px);\n          transform: translateY(9px);\n}\n\ninput:not([type]) + label:after,\ninput[type=text]:not(.browser-default) + label:after,\ninput[type=password]:not(.browser-default) + label:after,\ninput[type=email]:not(.browser-default) + label:after,\ninput[type=url]:not(.browser-default) + label:after,\ninput[type=time]:not(.browser-default) + label:after,\ninput[type=date]:not(.browser-default) + label:after,\ninput[type=datetime]:not(.browser-default) + label:after,\ninput[type=datetime-local]:not(.browser-default) + label:after,\ninput[type=tel]:not(.browser-default) + label:after,\ninput[type=number]:not(.browser-default) + label:after,\ninput[type=search]:not(.browser-default) + label:after,\ntextarea.materialize-textarea + label:after, .select-wrapper + label:after {\n  display: block;\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 0;\n  opacity: 0;\n  -webkit-transition: .2s opacity ease-out, .2s color ease-out;\n  transition: .2s opacity ease-out, .2s color ease-out;\n}\n\n.input-field {\n  position: relative;\n  margin-top: 1rem;\n}\n\n.input-field.inline {\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 5px;\n}\n\n.input-field.inline input,\n.input-field.inline .select-dropdown {\n  margin-bottom: 1rem;\n}\n\n.input-field.col label {\n  left: 0.75rem;\n}\n\n.input-field.col .prefix ~ label,\n.input-field.col .prefix ~ .validate ~ label {\n  width: calc(100% - 3rem - 1.5rem);\n}\n\n.input-field label {\n  color: #9e9e9e;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  font-size: 1rem;\n  cursor: text;\n  -webkit-transition: -webkit-transform .2s ease-out;\n  transition: -webkit-transform .2s ease-out;\n  transition: transform .2s ease-out;\n  transition: transform .2s ease-out, -webkit-transform .2s ease-out;\n  -webkit-transform-origin: 0% 100%;\n          transform-origin: 0% 100%;\n  text-align: initial;\n  -webkit-transform: translateY(12px);\n          transform: translateY(12px);\n  pointer-events: none;\n}\n\n.input-field label:not(.label-icon).active {\n  -webkit-transform: translateY(-14px) scale(0.8);\n          transform: translateY(-14px) scale(0.8);\n  -webkit-transform-origin: 0 0;\n          transform-origin: 0 0;\n}\n\n.input-field .prefix {\n  position: absolute;\n  width: 3rem;\n  font-size: 2rem;\n  -webkit-transition: color .2s;\n  transition: color .2s;\n}\n\n.input-field .prefix.active {\n  color: #26a69a;\n}\n\n.input-field .prefix ~ input,\n.input-field .prefix ~ textarea,\n.input-field .prefix ~ label,\n.input-field .prefix ~ .validate ~ label,\n.input-field .prefix ~ .autocomplete-content {\n  margin-left: 3rem;\n  width: 92%;\n  width: calc(100% - 3rem);\n}\n\n.input-field .prefix ~ label {\n  margin-left: 3rem;\n}\n\n@media only screen and (max-width: 992px) {\n  .input-field .prefix ~ input {\n    width: 86%;\n    width: calc(100% - 3rem);\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .input-field .prefix ~ input {\n    width: 80%;\n    width: calc(100% - 3rem);\n  }\n}\n\n/* Search Field */\n.input-field input[type=search] {\n  display: block;\n  line-height: inherit;\n}\n\n.nav-wrapper .input-field input[type=search] {\n  height: inherit;\n  padding-left: 4rem;\n  width: calc(100% - 4rem);\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.input-field input[type=search]:focus {\n  background-color: #fff;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #444;\n}\n\n.input-field input[type=search]:focus + label i,\n.input-field input[type=search]:focus ~ .mdi-navigation-close,\n.input-field input[type=search]:focus ~ .material-icons {\n  color: #444;\n}\n\n.input-field input[type=search] + label {\n  left: 1rem;\n}\n\n.input-field input[type=search] ~ .mdi-navigation-close,\n.input-field input[type=search] ~ .material-icons {\n  position: absolute;\n  top: 0;\n  right: 1rem;\n  color: transparent;\n  cursor: pointer;\n  font-size: 2rem;\n  -webkit-transition: .3s color;\n  transition: .3s color;\n}\n\n/* Textarea */\ntextarea {\n  width: 100%;\n  height: 3rem;\n  background-color: transparent;\n}\n\ntextarea.materialize-textarea {\n  overflow-y: hidden;\n  /* prevents scroll bar flash */\n  padding: .8rem 0 1.6rem 0;\n  /* prevents text jump on Enter keypress */\n  resize: none;\n  min-height: 3rem;\n}\n\ntextarea.materialize-textarea.validate + label {\n  height: 100%;\n}\n\ntextarea.materialize-textarea.validate + label::after {\n  top: calc(100% - 12px);\n}\n\ntextarea.materialize-textarea.validate + label:not(.label-icon).active {\n  -webkit-transform: translateY(-25px);\n          transform: translateY(-25px);\n}\n\n.hiddendiv {\n  display: none;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  /* future version of deprecated 'word-wrap' */\n  padding-top: 1.2rem;\n  /* prevents text jump on Enter keypress */\n  position: absolute;\n  top: 0;\n}\n\n/* Autocomplete */\n.autocomplete-content {\n  margin-top: -20px;\n  margin-bottom: 20px;\n  display: block;\n  opacity: 1;\n  position: static;\n}\n\n.autocomplete-content li .highlight {\n  color: #444;\n}\n\n.autocomplete-content li img {\n  height: 40px;\n  width: 40px;\n  margin: 5px 15px;\n}\n\n/* Radio Buttons\r\n   ========================================================================== */\n[type=\"radio\"]:not(:checked),\n[type=\"radio\"]:checked {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n[type=\"radio\"]:not(:checked) + label,\n[type=\"radio\"]:checked + label {\n  position: relative;\n  padding-left: 35px;\n  cursor: pointer;\n  display: inline-block;\n  height: 25px;\n  line-height: 25px;\n  font-size: 1rem;\n  -webkit-transition: .28s ease;\n  transition: .28s ease;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n[type=\"radio\"] + label:before,\n[type=\"radio\"] + label:after {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  margin: 4px;\n  width: 16px;\n  height: 16px;\n  z-index: 0;\n  -webkit-transition: .28s ease;\n  transition: .28s ease;\n}\n\n/* Unchecked styles */\n[type=\"radio\"]:not(:checked) + label:before,\n[type=\"radio\"]:not(:checked) + label:after,\n[type=\"radio\"]:checked + label:before,\n[type=\"radio\"]:checked + label:after,\n[type=\"radio\"].with-gap:checked + label:before,\n[type=\"radio\"].with-gap:checked + label:after {\n  border-radius: 50%;\n}\n\n[type=\"radio\"]:not(:checked) + label:before,\n[type=\"radio\"]:not(:checked) + label:after {\n  border: 2px solid #5a5a5a;\n}\n\n[type=\"radio\"]:not(:checked) + label:after {\n  -webkit-transform: scale(0);\n          transform: scale(0);\n}\n\n/* Checked styles */\n[type=\"radio\"]:checked + label:before {\n  border: 2px solid transparent;\n}\n\n[type=\"radio\"]:checked + label:after,\n[type=\"radio\"].with-gap:checked + label:before,\n[type=\"radio\"].with-gap:checked + label:after {\n  border: 2px solid #26a69a;\n}\n\n[type=\"radio\"]:checked + label:after,\n[type=\"radio\"].with-gap:checked + label:after {\n  background-color: #26a69a;\n}\n\n[type=\"radio\"]:checked + label:after {\n  -webkit-transform: scale(1.02);\n          transform: scale(1.02);\n}\n\n/* Radio With gap */\n[type=\"radio\"].with-gap:checked + label:after {\n  -webkit-transform: scale(0.5);\n          transform: scale(0.5);\n}\n\n/* Focused styles */\n[type=\"radio\"].tabbed:focus + label:before {\n  -webkit-box-shadow: 0 0 0 10px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n/* Disabled Radio With gap */\n[type=\"radio\"].with-gap:disabled:checked + label:before {\n  border: 2px solid rgba(0, 0, 0, 0.42);\n}\n\n[type=\"radio\"].with-gap:disabled:checked + label:after {\n  border: none;\n  background-color: rgba(0, 0, 0, 0.42);\n}\n\n/* Disabled style */\n[type=\"radio\"]:disabled:not(:checked) + label:before,\n[type=\"radio\"]:disabled:checked + label:before {\n  background-color: transparent;\n  border-color: rgba(0, 0, 0, 0.42);\n}\n\n[type=\"radio\"]:disabled + label {\n  color: rgba(0, 0, 0, 0.42);\n}\n\n[type=\"radio\"]:disabled:not(:checked) + label:before {\n  border-color: rgba(0, 0, 0, 0.42);\n}\n\n[type=\"radio\"]:disabled:checked + label:after {\n  background-color: rgba(0, 0, 0, 0.42);\n  border-color: #949494;\n}\n\n/* Checkboxes\r\n   ========================================================================== */\n/* CUSTOM CSS CHECKBOXES */\nform p {\n  margin-bottom: 10px;\n  text-align: left;\n}\n\nform p:last-child {\n  margin-bottom: 0;\n}\n\n/* Remove default checkbox */\n[type=\"checkbox\"]:not(:checked),\n[type=\"checkbox\"]:checked {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n[type=\"checkbox\"] {\n  /* checkbox aspect */\n}\n\n[type=\"checkbox\"] + label {\n  position: relative;\n  padding-left: 35px;\n  cursor: pointer;\n  display: inline-block;\n  height: 25px;\n  line-height: 25px;\n  font-size: 1rem;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n[type=\"checkbox\"] + label:before,\n[type=\"checkbox\"]:not(.filled-in) + label:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 18px;\n  height: 18px;\n  z-index: 0;\n  border: 2px solid #5a5a5a;\n  border-radius: 1px;\n  margin-top: 2px;\n  -webkit-transition: .2s;\n  transition: .2s;\n}\n\n[type=\"checkbox\"]:not(.filled-in) + label:after {\n  border: 0;\n  -webkit-transform: scale(0);\n          transform: scale(0);\n}\n\n[type=\"checkbox\"]:not(:checked):disabled + label:before {\n  border: none;\n  background-color: rgba(0, 0, 0, 0.42);\n}\n\n[type=\"checkbox\"].tabbed:focus + label:after {\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  border: 0;\n  border-radius: 50%;\n  -webkit-box-shadow: 0 0 0 10px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 0 10px rgba(0, 0, 0, 0.1);\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n[type=\"checkbox\"]:checked + label:before {\n  top: -4px;\n  left: -5px;\n  width: 12px;\n  height: 22px;\n  border-top: 2px solid transparent;\n  border-left: 2px solid transparent;\n  border-right: 2px solid #26a69a;\n  border-bottom: 2px solid #26a69a;\n  -webkit-transform: rotate(40deg);\n          transform: rotate(40deg);\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  -webkit-transform-origin: 100% 100%;\n          transform-origin: 100% 100%;\n}\n\n[type=\"checkbox\"]:checked:disabled + label:before {\n  border-right: 2px solid rgba(0, 0, 0, 0.42);\n  border-bottom: 2px solid rgba(0, 0, 0, 0.42);\n}\n\n/* Indeterminate checkbox */\n[type=\"checkbox\"]:indeterminate + label:before {\n  top: -11px;\n  left: -12px;\n  width: 10px;\n  height: 22px;\n  border-top: none;\n  border-left: none;\n  border-right: 2px solid #26a69a;\n  border-bottom: none;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  -webkit-transform-origin: 100% 100%;\n          transform-origin: 100% 100%;\n}\n\n[type=\"checkbox\"]:indeterminate:disabled + label:before {\n  border-right: 2px solid rgba(0, 0, 0, 0.42);\n  background-color: transparent;\n}\n\n[type=\"checkbox\"].filled-in + label:after {\n  border-radius: 2px;\n}\n\n[type=\"checkbox\"].filled-in + label:before,\n[type=\"checkbox\"].filled-in + label:after {\n  content: '';\n  left: 0;\n  position: absolute;\n  /* .1s delay is for check animation */\n  -webkit-transition: border .25s, background-color .25s, width .20s .1s, height .20s .1s, top .20s .1s, left .20s .1s;\n  transition: border .25s, background-color .25s, width .20s .1s, height .20s .1s, top .20s .1s, left .20s .1s;\n  z-index: 1;\n}\n\n[type=\"checkbox\"].filled-in:not(:checked) + label:before {\n  width: 0;\n  height: 0;\n  border: 3px solid transparent;\n  left: 6px;\n  top: 10px;\n  -webkit-transform: rotateZ(37deg);\n          transform: rotateZ(37deg);\n  -webkit-transform-origin: 100% 100%;\n          transform-origin: 100% 100%;\n}\n\n[type=\"checkbox\"].filled-in:not(:checked) + label:after {\n  height: 20px;\n  width: 20px;\n  background-color: transparent;\n  border: 2px solid #5a5a5a;\n  top: 0px;\n  z-index: 0;\n}\n\n[type=\"checkbox\"].filled-in:checked + label:before {\n  top: 0;\n  left: 1px;\n  width: 8px;\n  height: 13px;\n  border-top: 2px solid transparent;\n  border-left: 2px solid transparent;\n  border-right: 2px solid #fff;\n  border-bottom: 2px solid #fff;\n  -webkit-transform: rotateZ(37deg);\n          transform: rotateZ(37deg);\n  -webkit-transform-origin: 100% 100%;\n          transform-origin: 100% 100%;\n}\n\n[type=\"checkbox\"].filled-in:checked + label:after {\n  top: 0;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #26a69a;\n  background-color: #26a69a;\n  z-index: 0;\n}\n\n[type=\"checkbox\"].filled-in.tabbed:focus + label:after {\n  border-radius: 2px;\n  border-color: #5a5a5a;\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n[type=\"checkbox\"].filled-in.tabbed:checked:focus + label:after {\n  border-radius: 2px;\n  background-color: #26a69a;\n  border-color: #26a69a;\n}\n\n[type=\"checkbox\"].filled-in:disabled:not(:checked) + label:before {\n  background-color: transparent;\n  border: 2px solid transparent;\n}\n\n[type=\"checkbox\"].filled-in:disabled:not(:checked) + label:after {\n  border-color: transparent;\n  background-color: #949494;\n}\n\n[type=\"checkbox\"].filled-in:disabled:checked + label:before {\n  background-color: transparent;\n}\n\n[type=\"checkbox\"].filled-in:disabled:checked + label:after {\n  background-color: #949494;\n  border-color: #949494;\n}\n\n/* Switch\r\n   ========================================================================== */\n.switch,\n.switch * {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.switch label {\n  cursor: pointer;\n}\n\n.switch label input[type=checkbox] {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.switch label input[type=checkbox]:checked + .lever {\n  background-color: #84c7c1;\n}\n\n.switch label input[type=checkbox]:checked + .lever:before, .switch label input[type=checkbox]:checked + .lever:after {\n  left: 18px;\n}\n\n.switch label input[type=checkbox]:checked + .lever:after {\n  background-color: #26a69a;\n}\n\n.switch label .lever {\n  content: \"\";\n  display: inline-block;\n  position: relative;\n  width: 36px;\n  height: 14px;\n  background-color: rgba(0, 0, 0, 0.38);\n  border-radius: 15px;\n  margin-right: 10px;\n  -webkit-transition: background 0.3s ease;\n  transition: background 0.3s ease;\n  vertical-align: middle;\n  margin: 0 16px;\n}\n\n.switch label .lever:before, .switch label .lever:after {\n  content: \"\";\n  position: absolute;\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  left: 0;\n  top: -3px;\n  -webkit-transition: left 0.3s ease, background .3s ease, -webkit-box-shadow 0.1s ease, -webkit-transform .1s ease;\n  transition: left 0.3s ease, background .3s ease, -webkit-box-shadow 0.1s ease, -webkit-transform .1s ease;\n  transition: left 0.3s ease, background .3s ease, box-shadow 0.1s ease, transform .1s ease;\n  transition: left 0.3s ease, background .3s ease, box-shadow 0.1s ease, transform .1s ease, -webkit-box-shadow 0.1s ease, -webkit-transform .1s ease;\n}\n\n.switch label .lever:before {\n  background-color: rgba(38, 166, 154, 0.15);\n}\n\n.switch label .lever:after {\n  background-color: #F1F1F1;\n  -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);\n          box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);\n}\n\ninput[type=checkbox]:checked:not(:disabled) ~ .lever:active::before,\ninput[type=checkbox]:checked:not(:disabled).tabbed:focus ~ .lever::before {\n  -webkit-transform: scale(2.4);\n          transform: scale(2.4);\n  background-color: rgba(38, 166, 154, 0.15);\n}\n\ninput[type=checkbox]:not(:disabled) ~ .lever:active:before,\ninput[type=checkbox]:not(:disabled).tabbed:focus ~ .lever::before {\n  -webkit-transform: scale(2.4);\n          transform: scale(2.4);\n  background-color: rgba(0, 0, 0, 0.08);\n}\n\n.switch input[type=checkbox][disabled] + .lever {\n  cursor: default;\n  background-color: rgba(0, 0, 0, 0.12);\n}\n\n.switch label input[type=checkbox][disabled] + .lever:after,\n.switch label input[type=checkbox][disabled]:checked + .lever:after {\n  background-color: #949494;\n}\n\n/* Select Field\r\n   ========================================================================== */\nselect {\n  display: none;\n}\n\nselect.browser-default {\n  display: block;\n}\n\nselect {\n  background-color: rgba(255, 255, 255, 0.9);\n  width: 100%;\n  padding: 5px;\n  border: 1px solid #f2f2f2;\n  border-radius: 2px;\n  height: 3rem;\n}\n\n.input-field > select {\n  display: block;\n  position: absolute;\n  width: 0;\n  pointer-events: none;\n  height: 0;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n\n.select-label {\n  position: absolute;\n}\n\n.select-wrapper {\n  position: relative;\n}\n\n.select-wrapper.valid + label,\n.select-wrapper.invalid + label {\n  width: 100%;\n  pointer-events: none;\n}\n\n.select-wrapper input.select-dropdown {\n  position: relative;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  border-bottom: 1px solid #9e9e9e;\n  outline: none;\n  height: 3rem;\n  line-height: 3rem;\n  width: 100%;\n  font-size: 1rem;\n  margin: 0 0 20px 0;\n  padding: 0;\n  display: block;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.select-wrapper span.caret {\n  color: initial;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  height: 10px;\n  margin: auto 0;\n  font-size: 10px;\n  line-height: 10px;\n}\n\n.select-wrapper + label {\n  position: absolute;\n  top: -26px;\n  font-size: 0.8rem;\n}\n\nselect:disabled {\n  color: rgba(0, 0, 0, 0.42);\n}\n\n.select-wrapper.disabled span.caret,\n.select-wrapper.disabled + label {\n  color: rgba(0, 0, 0, 0.42);\n}\n\n.select-wrapper input.select-dropdown:disabled {\n  color: rgba(0, 0, 0, 0.42);\n  cursor: default;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.select-wrapper i {\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.select-dropdown li.disabled,\n.select-dropdown li.disabled > span,\n.select-dropdown li.optgroup {\n  color: rgba(0, 0, 0, 0.3);\n  background-color: transparent;\n}\n\n.select-dropdown.dropdown-content li.active {\n  background-color: transparent;\n}\n\n.select-dropdown.dropdown-content li:hover {\n  background-color: rgba(0, 0, 0, 0.06);\n}\n\n.select-dropdown.dropdown-content li.selected {\n  background-color: rgba(0, 0, 0, 0.03);\n}\n\n.prefix ~ .select-wrapper {\n  margin-left: 3rem;\n  width: 92%;\n  width: calc(100% - 3rem);\n}\n\n.prefix ~ label {\n  margin-left: 3rem;\n}\n\n.select-dropdown li img {\n  height: 40px;\n  width: 40px;\n  margin: 5px 15px;\n  float: right;\n}\n\n.select-dropdown li.optgroup {\n  border-top: 1px solid #eee;\n}\n\n.select-dropdown li.optgroup.selected > span {\n  color: rgba(0, 0, 0, 0.7);\n}\n\n.select-dropdown li.optgroup > span {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.select-dropdown li.optgroup ~ li.optgroup-option {\n  padding-left: 1rem;\n}\n\n/* File Input\r\n   ========================================================================== */\n.file-field {\n  position: relative;\n}\n\n.file-field .file-path-wrapper {\n  overflow: hidden;\n  padding-left: 10px;\n}\n\n.file-field input.file-path {\n  width: 100%;\n}\n\n.file-field .btn, .file-field .btn-large {\n  float: left;\n  height: 3rem;\n  line-height: 3rem;\n}\n\n.file-field span {\n  cursor: pointer;\n}\n\n.file-field input[type=file] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  font-size: 20px;\n  cursor: pointer;\n  opacity: 0;\n  filter: alpha(opacity=0);\n}\n\n.file-field input[type=file]::-webkit-file-upload-button {\n  display: none;\n}\n\n/* Range\r\n   ========================================================================== */\n.range-field {\n  position: relative;\n}\n\ninput[type=range],\ninput[type=range] + .thumb {\n  cursor: pointer;\n}\n\ninput[type=range] {\n  position: relative;\n  background-color: transparent;\n  border: none;\n  outline: none;\n  width: 100%;\n  margin: 15px 0;\n  padding: 0;\n}\n\ninput[type=range]:focus {\n  outline: none;\n}\n\ninput[type=range] + .thumb {\n  position: absolute;\n  top: 10px;\n  left: 0;\n  border: none;\n  height: 0;\n  width: 0;\n  border-radius: 50%;\n  background-color: #26a69a;\n  margin-left: 7px;\n  -webkit-transform-origin: 50% 50%;\n          transform-origin: 50% 50%;\n  -webkit-transform: rotate(-45deg);\n          transform: rotate(-45deg);\n}\n\ninput[type=range] + .thumb .value {\n  display: block;\n  width: 30px;\n  text-align: center;\n  color: #26a69a;\n  font-size: 0;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n\ninput[type=range] + .thumb.active {\n  border-radius: 50% 50% 50% 0;\n}\n\ninput[type=range] + .thumb.active .value {\n  color: #fff;\n  margin-left: -1px;\n  margin-top: 8px;\n  font-size: 10px;\n}\n\ninput[type=range] {\n  -webkit-appearance: none;\n}\n\ninput[type=range]::-webkit-slider-runnable-track {\n  height: 3px;\n  background: #c2c0c2;\n  border: none;\n}\n\ninput[type=range]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  border: none;\n  height: 14px;\n  width: 14px;\n  border-radius: 50%;\n  background-color: #26a69a;\n  -webkit-transform-origin: 50% 50%;\n          transform-origin: 50% 50%;\n  margin: -5px 0 0 0;\n  -webkit-transition: .3s;\n  transition: .3s;\n}\n\ninput[type=range]:focus::-webkit-slider-runnable-track {\n  background: #ccc;\n}\n\ninput[type=range] {\n  /* fix for FF unable to apply focus style bug  */\n  border: 1px solid white;\n  /*required for proper track sizing in FF*/\n}\n\ninput[type=range]::-moz-range-track {\n  height: 3px;\n  background: #ddd;\n  border: none;\n}\n\ninput[type=range]::-moz-range-thumb {\n  border: none;\n  height: 14px;\n  width: 14px;\n  border-radius: 50%;\n  background: #26a69a;\n  margin-top: -5px;\n}\n\ninput[type=range]:-moz-focusring {\n  outline: 1px solid #fff;\n  outline-offset: -1px;\n}\n\ninput[type=range]:focus::-moz-range-track {\n  background: #ccc;\n}\n\ninput[type=range]::-ms-track {\n  height: 3px;\n  background: transparent;\n  border-color: transparent;\n  border-width: 6px 0;\n  /*remove default tick marks*/\n  color: transparent;\n}\n\ninput[type=range]::-ms-fill-lower {\n  background: #777;\n}\n\ninput[type=range]::-ms-fill-upper {\n  background: #ddd;\n}\n\ninput[type=range]::-ms-thumb {\n  border: none;\n  height: 14px;\n  width: 14px;\n  border-radius: 50%;\n  background: #26a69a;\n}\n\ninput[type=range]:focus::-ms-fill-lower {\n  background: #888;\n}\n\ninput[type=range]:focus::-ms-fill-upper {\n  background: #ccc;\n}\n\n/***************\r\n    Nav List\r\n***************/\n.table-of-contents.fixed {\n  position: fixed;\n}\n\n.table-of-contents li {\n  padding: 2px 0;\n}\n\n.table-of-contents a {\n  display: inline-block;\n  font-weight: 300;\n  color: #757575;\n  padding-left: 20px;\n  height: 1.5rem;\n  line-height: 1.5rem;\n  letter-spacing: .4;\n  display: inline-block;\n}\n\n.table-of-contents a:hover {\n  color: #a8a8a8;\n  padding-left: 19px;\n  border-left: 1px solid #ee6e73;\n}\n\n.table-of-contents a.active {\n  font-weight: 500;\n  padding-left: 18px;\n  border-left: 2px solid #ee6e73;\n}\n\n.side-nav {\n  position: fixed;\n  width: 300px;\n  left: 0;\n  top: 0;\n  margin: 0;\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  height: 100%;\n  height: calc(100% + 60px);\n  height: -moz-calc(100%);\n  padding-bottom: 60px;\n  background-color: #fff;\n  z-index: 999;\n  overflow-y: auto;\n  will-change: transform;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  -webkit-transform: translateX(-105%);\n          transform: translateX(-105%);\n}\n\n.side-nav.right-aligned {\n  right: 0;\n  -webkit-transform: translateX(105%);\n          transform: translateX(105%);\n  left: auto;\n  -webkit-transform: translateX(100%);\n          transform: translateX(100%);\n}\n\n.side-nav .collapsible {\n  margin: 0;\n}\n\n.side-nav li {\n  float: none;\n  line-height: 48px;\n}\n\n.side-nav li.active {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.side-nav li > a {\n  color: rgba(0, 0, 0, 0.87);\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  height: 48px;\n  line-height: 48px;\n  padding: 0 32px;\n}\n\n.side-nav li > a:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.side-nav li > a.btn, .side-nav li > a.btn-large, .side-nav li > a.btn-large, .side-nav li > a.btn-flat, .side-nav li > a.btn-floating {\n  margin: 10px 15px;\n}\n\n.side-nav li > a.btn, .side-nav li > a.btn-large, .side-nav li > a.btn-large, .side-nav li > a.btn-floating {\n  color: #fff;\n}\n\n.side-nav li > a.btn-flat {\n  color: #343434;\n}\n\n.side-nav li > a.btn:hover, .side-nav li > a.btn-large:hover, .side-nav li > a.btn-large:hover {\n  background-color: #2bbbad;\n}\n\n.side-nav li > a.btn-floating:hover {\n  background-color: #26a69a;\n}\n\n.side-nav li > a > i,\n.side-nav li > a > [class^=\"mdi-\"], .side-nav li > a li > a > [class*=\"mdi-\"],\n.side-nav li > a > i.material-icons {\n  float: left;\n  height: 48px;\n  line-height: 48px;\n  margin: 0 32px 0 0;\n  width: 24px;\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.side-nav .divider {\n  margin: 8px 0 0 0;\n}\n\n.side-nav .subheader {\n  cursor: initial;\n  pointer-events: none;\n  color: rgba(0, 0, 0, 0.54);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 48px;\n}\n\n.side-nav .subheader:hover {\n  background-color: transparent;\n}\n\n.side-nav .user-view,\n.side-nav .userView {\n  position: relative;\n  padding: 32px 32px 0;\n  margin-bottom: 8px;\n}\n\n.side-nav .user-view > a,\n.side-nav .userView > a {\n  height: auto;\n  padding: 0;\n}\n\n.side-nav .user-view > a:hover,\n.side-nav .userView > a:hover {\n  background-color: transparent;\n}\n\n.side-nav .user-view .background,\n.side-nav .userView .background {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.side-nav .user-view .circle, .side-nav .user-view .name, .side-nav .user-view .email,\n.side-nav .userView .circle,\n.side-nav .userView .name,\n.side-nav .userView .email {\n  display: block;\n}\n\n.side-nav .user-view .circle,\n.side-nav .userView .circle {\n  height: 64px;\n  width: 64px;\n}\n\n.side-nav .user-view .name,\n.side-nav .user-view .email,\n.side-nav .userView .name,\n.side-nav .userView .email {\n  font-size: 14px;\n  line-height: 24px;\n}\n\n.side-nav .user-view .name,\n.side-nav .userView .name {\n  margin-top: 16px;\n  font-weight: 500;\n}\n\n.side-nav .user-view .email,\n.side-nav .userView .email {\n  padding-bottom: 16px;\n  font-weight: 400;\n}\n\n.drag-target {\n  height: 100%;\n  width: 10px;\n  position: fixed;\n  top: 0;\n  z-index: 998;\n}\n\n.side-nav.fixed {\n  left: 0;\n  -webkit-transform: translateX(0);\n          transform: translateX(0);\n  position: fixed;\n}\n\n.side-nav.fixed.right-aligned {\n  right: 0;\n  left: auto;\n}\n\n@media only screen and (max-width: 992px) {\n  .side-nav.fixed {\n    -webkit-transform: translateX(-105%);\n            transform: translateX(-105%);\n  }\n  .side-nav.fixed.right-aligned {\n    -webkit-transform: translateX(105%);\n            transform: translateX(105%);\n  }\n  .side-nav a {\n    padding: 0 16px;\n  }\n  .side-nav .user-view,\n  .side-nav .userView {\n    padding: 16px 16px 0;\n  }\n}\n\n.side-nav .collapsible-body > ul:not(.collapsible) > li.active,\n.side-nav.fixed .collapsible-body > ul:not(.collapsible) > li.active {\n  background-color: #ee6e73;\n}\n\n.side-nav .collapsible-body > ul:not(.collapsible) > li.active a,\n.side-nav.fixed .collapsible-body > ul:not(.collapsible) > li.active a {\n  color: #fff;\n}\n\n.side-nav .collapsible-body {\n  padding: 0;\n}\n\n#sidenav-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 120vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 997;\n  will-change: opacity;\n}\n\n/*\r\n    @license\r\n    Copyright (c) 2014 The Polymer Project Authors. All rights reserved.\r\n    This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt\r\n    The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt\r\n    The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt\r\n    Code distributed by Google as part of the polymer project is also\r\n    subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt\r\n */\n/**************************/\n/* STYLES FOR THE SPINNER */\n/**************************/\n/*\r\n * Constants:\r\n *      STROKEWIDTH = 3px\r\n *      ARCSIZE     = 270 degrees (amount of circle the arc takes up)\r\n *      ARCTIME     = 1333ms (time it takes to expand and contract arc)\r\n *      ARCSTARTROT = 216 degrees (how much the start location of the arc\r\n *                                should rotate each time, 216 gives us a\r\n *                                5 pointed star shape (it's 360/5 * 3).\r\n *                                For a 7 pointed star, we might do\r\n *                                360/7 * 3 = 154.286)\r\n *      CONTAINERWIDTH = 28px\r\n *      SHRINK_TIME = 400ms\r\n */\n.preloader-wrapper {\n  display: inline-block;\n  position: relative;\n  width: 50px;\n  height: 50px;\n}\n\n.preloader-wrapper.small {\n  width: 36px;\n  height: 36px;\n}\n\n.preloader-wrapper.big {\n  width: 64px;\n  height: 64px;\n}\n\n.preloader-wrapper.active {\n  /* duration: 360 * ARCTIME / (ARCSTARTROT + (360-ARCSIZE)) */\n  -webkit-animation: container-rotate 1568ms linear infinite;\n  animation: container-rotate 1568ms linear infinite;\n}\n\n@-webkit-keyframes container-rotate {\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes container-rotate {\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n.spinner-layer {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  border-color: #26a69a;\n}\n\n.spinner-blue,\n.spinner-blue-only {\n  border-color: #4285f4;\n}\n\n.spinner-red,\n.spinner-red-only {\n  border-color: #db4437;\n}\n\n.spinner-yellow,\n.spinner-yellow-only {\n  border-color: #f4b400;\n}\n\n.spinner-green,\n.spinner-green-only {\n  border-color: #0f9d58;\n}\n\n/**\r\n * IMPORTANT NOTE ABOUT CSS ANIMATION PROPERTIES (keanulee):\r\n *\r\n * iOS Safari (tested on iOS 8.1) does not handle animation-delay very well - it doesn't\r\n * guarantee that the animation will start _exactly_ after that value. So we avoid using\r\n * animation-delay and instead set custom keyframes for each color (as redundant as it\r\n * seems).\r\n *\r\n * We write out each animation in full (instead of separating animation-name,\r\n * animation-duration, etc.) because under the polyfill, Safari does not recognize those\r\n * specific properties properly, treats them as -webkit-animation, and overrides the\r\n * other animation rules. See https://github.com/Polymer/platform/issues/53.\r\n */\n.active .spinner-layer.spinner-blue {\n  /* durations: 4 * ARCTIME */\n  -webkit-animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, blue-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;\n  animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, blue-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;\n}\n\n.active .spinner-layer.spinner-red {\n  /* durations: 4 * ARCTIME */\n  -webkit-animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, red-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;\n  animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, red-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;\n}\n\n.active .spinner-layer.spinner-yellow {\n  /* durations: 4 * ARCTIME */\n  -webkit-animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, yellow-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;\n  animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, yellow-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;\n}\n\n.active .spinner-layer.spinner-green {\n  /* durations: 4 * ARCTIME */\n  -webkit-animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, green-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;\n  animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both, green-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;\n}\n\n.active .spinner-layer,\n.active .spinner-layer.spinner-blue-only,\n.active .spinner-layer.spinner-red-only,\n.active .spinner-layer.spinner-yellow-only,\n.active .spinner-layer.spinner-green-only {\n  /* durations: 4 * ARCTIME */\n  opacity: 1;\n  -webkit-animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;\n  animation: fill-unfill-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;\n}\n\n@-webkit-keyframes fill-unfill-rotate {\n  12.5% {\n    -webkit-transform: rotate(135deg);\n  }\n  /* 0.5 * ARCSIZE */\n  25% {\n    -webkit-transform: rotate(270deg);\n  }\n  /* 1   * ARCSIZE */\n  37.5% {\n    -webkit-transform: rotate(405deg);\n  }\n  /* 1.5 * ARCSIZE */\n  50% {\n    -webkit-transform: rotate(540deg);\n  }\n  /* 2   * ARCSIZE */\n  62.5% {\n    -webkit-transform: rotate(675deg);\n  }\n  /* 2.5 * ARCSIZE */\n  75% {\n    -webkit-transform: rotate(810deg);\n  }\n  /* 3   * ARCSIZE */\n  87.5% {\n    -webkit-transform: rotate(945deg);\n  }\n  /* 3.5 * ARCSIZE */\n  to {\n    -webkit-transform: rotate(1080deg);\n  }\n  /* 4   * ARCSIZE */\n}\n\n@keyframes fill-unfill-rotate {\n  12.5% {\n    -webkit-transform: rotate(135deg);\n            transform: rotate(135deg);\n  }\n  /* 0.5 * ARCSIZE */\n  25% {\n    -webkit-transform: rotate(270deg);\n            transform: rotate(270deg);\n  }\n  /* 1   * ARCSIZE */\n  37.5% {\n    -webkit-transform: rotate(405deg);\n            transform: rotate(405deg);\n  }\n  /* 1.5 * ARCSIZE */\n  50% {\n    -webkit-transform: rotate(540deg);\n            transform: rotate(540deg);\n  }\n  /* 2   * ARCSIZE */\n  62.5% {\n    -webkit-transform: rotate(675deg);\n            transform: rotate(675deg);\n  }\n  /* 2.5 * ARCSIZE */\n  75% {\n    -webkit-transform: rotate(810deg);\n            transform: rotate(810deg);\n  }\n  /* 3   * ARCSIZE */\n  87.5% {\n    -webkit-transform: rotate(945deg);\n            transform: rotate(945deg);\n  }\n  /* 3.5 * ARCSIZE */\n  to {\n    -webkit-transform: rotate(1080deg);\n            transform: rotate(1080deg);\n  }\n  /* 4   * ARCSIZE */\n}\n\n@-webkit-keyframes blue-fade-in-out {\n  from {\n    opacity: 1;\n  }\n  25% {\n    opacity: 1;\n  }\n  26% {\n    opacity: 0;\n  }\n  89% {\n    opacity: 0;\n  }\n  90% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes blue-fade-in-out {\n  from {\n    opacity: 1;\n  }\n  25% {\n    opacity: 1;\n  }\n  26% {\n    opacity: 0;\n  }\n  89% {\n    opacity: 0;\n  }\n  90% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes red-fade-in-out {\n  from {\n    opacity: 0;\n  }\n  15% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 1;\n  }\n  51% {\n    opacity: 0;\n  }\n}\n\n@keyframes red-fade-in-out {\n  from {\n    opacity: 0;\n  }\n  15% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 1;\n  }\n  51% {\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes yellow-fade-in-out {\n  from {\n    opacity: 0;\n  }\n  40% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  75% {\n    opacity: 1;\n  }\n  76% {\n    opacity: 0;\n  }\n}\n\n@keyframes yellow-fade-in-out {\n  from {\n    opacity: 0;\n  }\n  40% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  75% {\n    opacity: 1;\n  }\n  76% {\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes green-fade-in-out {\n  from {\n    opacity: 0;\n  }\n  65% {\n    opacity: 0;\n  }\n  75% {\n    opacity: 1;\n  }\n  90% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes green-fade-in-out {\n  from {\n    opacity: 0;\n  }\n  65% {\n    opacity: 0;\n  }\n  75% {\n    opacity: 1;\n  }\n  90% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n/**\r\n * Patch the gap that appear between the two adjacent div.circle-clipper while the\r\n * spinner is rotating (appears on Chrome 38, Safari 7.1, and IE 11).\r\n */\n.gap-patch {\n  position: absolute;\n  top: 0;\n  left: 45%;\n  width: 10%;\n  height: 100%;\n  overflow: hidden;\n  border-color: inherit;\n}\n\n.gap-patch .circle {\n  width: 1000%;\n  left: -450%;\n}\n\n.circle-clipper {\n  display: inline-block;\n  position: relative;\n  width: 50%;\n  height: 100%;\n  overflow: hidden;\n  border-color: inherit;\n}\n\n.circle-clipper .circle {\n  width: 200%;\n  height: 100%;\n  border-width: 3px;\n  /* STROKEWIDTH */\n  border-style: solid;\n  border-color: inherit;\n  border-bottom-color: transparent !important;\n  border-radius: 50%;\n  -webkit-animation: none;\n  animation: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.circle-clipper.left .circle {\n  left: 0;\n  border-right-color: transparent !important;\n  -webkit-transform: rotate(129deg);\n  transform: rotate(129deg);\n}\n\n.circle-clipper.right .circle {\n  left: -100%;\n  border-left-color: transparent !important;\n  -webkit-transform: rotate(-129deg);\n  transform: rotate(-129deg);\n}\n\n.active .circle-clipper.left .circle {\n  /* duration: ARCTIME */\n  -webkit-animation: left-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;\n  animation: left-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;\n}\n\n.active .circle-clipper.right .circle {\n  /* duration: ARCTIME */\n  -webkit-animation: right-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;\n  animation: right-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;\n}\n\n@-webkit-keyframes left-spin {\n  from {\n    -webkit-transform: rotate(130deg);\n  }\n  50% {\n    -webkit-transform: rotate(-5deg);\n  }\n  to {\n    -webkit-transform: rotate(130deg);\n  }\n}\n\n@keyframes left-spin {\n  from {\n    -webkit-transform: rotate(130deg);\n            transform: rotate(130deg);\n  }\n  50% {\n    -webkit-transform: rotate(-5deg);\n            transform: rotate(-5deg);\n  }\n  to {\n    -webkit-transform: rotate(130deg);\n            transform: rotate(130deg);\n  }\n}\n\n@-webkit-keyframes right-spin {\n  from {\n    -webkit-transform: rotate(-130deg);\n  }\n  50% {\n    -webkit-transform: rotate(5deg);\n  }\n  to {\n    -webkit-transform: rotate(-130deg);\n  }\n}\n\n@keyframes right-spin {\n  from {\n    -webkit-transform: rotate(-130deg);\n            transform: rotate(-130deg);\n  }\n  50% {\n    -webkit-transform: rotate(5deg);\n            transform: rotate(5deg);\n  }\n  to {\n    -webkit-transform: rotate(-130deg);\n            transform: rotate(-130deg);\n  }\n}\n\n#spinnerContainer.cooldown {\n  /* duration: SHRINK_TIME */\n  -webkit-animation: container-rotate 1568ms linear infinite, fade-out 400ms cubic-bezier(0.4, 0, 0.2, 1);\n  animation: container-rotate 1568ms linear infinite, fade-out 400ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@-webkit-keyframes fade-out {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fade-out {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.slider {\n  position: relative;\n  height: 400px;\n  width: 100%;\n}\n\n.slider.fullscreen {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.slider.fullscreen ul.slides {\n  height: 100%;\n}\n\n.slider.fullscreen ul.indicators {\n  z-index: 2;\n  bottom: 30px;\n}\n\n.slider .slides {\n  background-color: #9e9e9e;\n  margin: 0;\n  height: 400px;\n}\n\n.slider .slides li {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: inherit;\n  overflow: hidden;\n}\n\n.slider .slides li img {\n  height: 100%;\n  width: 100%;\n  background-size: cover;\n  background-position: center;\n}\n\n.slider .slides li .caption {\n  color: #fff;\n  position: absolute;\n  top: 15%;\n  left: 15%;\n  width: 70%;\n  opacity: 0;\n}\n\n.slider .slides li .caption p {\n  color: #e0e0e0;\n}\n\n.slider .slides li.active {\n  z-index: 2;\n}\n\n.slider .indicators {\n  position: absolute;\n  text-align: center;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 0;\n}\n\n.slider .indicators .indicator-item {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  height: 16px;\n  width: 16px;\n  margin: 0 12px;\n  background-color: #e0e0e0;\n  -webkit-transition: background-color .3s;\n  transition: background-color .3s;\n  border-radius: 50%;\n}\n\n.slider .indicators .indicator-item.active {\n  background-color: #4CAF50;\n}\n\n.carousel {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  height: 400px;\n  -webkit-perspective: 500px;\n          perspective: 500px;\n  -webkit-transform-style: preserve-3d;\n          transform-style: preserve-3d;\n  -webkit-transform-origin: 0% 50%;\n          transform-origin: 0% 50%;\n}\n\n.carousel.carousel-slider {\n  top: 0;\n  left: 0;\n}\n\n.carousel.carousel-slider .carousel-fixed-item {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 20px;\n  z-index: 1;\n}\n\n.carousel.carousel-slider .carousel-fixed-item.with-indicators {\n  bottom: 68px;\n}\n\n.carousel.carousel-slider .carousel-item {\n  width: 100%;\n  height: 100%;\n  min-height: 400px;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.carousel.carousel-slider .carousel-item h2 {\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 32px;\n}\n\n.carousel.carousel-slider .carousel-item p {\n  font-size: 15px;\n}\n\n.carousel .carousel-item {\n  display: none;\n  width: 200px;\n  height: 200px;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.carousel .carousel-item > img {\n  width: 100%;\n}\n\n.carousel .indicators {\n  position: absolute;\n  text-align: center;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 0;\n}\n\n.carousel .indicators .indicator-item {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  height: 8px;\n  width: 8px;\n  margin: 24px 4px;\n  background-color: rgba(255, 255, 255, 0.5);\n  -webkit-transition: background-color .3s;\n  transition: background-color .3s;\n  border-radius: 50%;\n}\n\n.carousel .indicators .indicator-item.active {\n  background-color: #fff;\n}\n\n.carousel.scrolling .carousel-item .materialboxed,\n.carousel .carousel-item:not(.active) .materialboxed {\n  pointer-events: none;\n}\n\n.tap-target-wrapper {\n  width: 800px;\n  height: 800px;\n  position: fixed;\n  z-index: 1000;\n  visibility: hidden;\n  -webkit-transition: visibility 0s .3s;\n  transition: visibility 0s .3s;\n}\n\n.tap-target-wrapper.open {\n  visibility: visible;\n  -webkit-transition: visibility 0s;\n  transition: visibility 0s;\n}\n\n.tap-target-wrapper.open .tap-target {\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  opacity: .95;\n  -webkit-transition: opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1), -webkit-transform 0.3s cubic-bezier(0.42, 0, 0.58, 1);\n  transition: opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1), -webkit-transform 0.3s cubic-bezier(0.42, 0, 0.58, 1);\n  transition: transform 0.3s cubic-bezier(0.42, 0, 0.58, 1), opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1);\n  transition: transform 0.3s cubic-bezier(0.42, 0, 0.58, 1), opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1), -webkit-transform 0.3s cubic-bezier(0.42, 0, 0.58, 1);\n}\n\n.tap-target-wrapper.open .tap-target-wave::before {\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n\n.tap-target-wrapper.open .tap-target-wave::after {\n  visibility: visible;\n  -webkit-animation: pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1) infinite;\n          animation: pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1) infinite;\n  -webkit-transition: opacity .3s,\r visibility 0s 1s,\r -webkit-transform .3s;\n  transition: opacity .3s,\r visibility 0s 1s,\r -webkit-transform .3s;\n  transition: opacity .3s,\r transform .3s,\r visibility 0s 1s;\n  transition: opacity .3s,\r transform .3s,\r visibility 0s 1s,\r -webkit-transform .3s;\n}\n\n.tap-target {\n  position: absolute;\n  font-size: 1rem;\n  border-radius: 50%;\n  background-color: #ee6e73;\n  -webkit-box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.14), 0 10px 50px 0 rgba(0, 0, 0, 0.12), 0 30px 10px -20px rgba(0, 0, 0, 0.2);\n          box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.14), 0 10px 50px 0 rgba(0, 0, 0, 0.12), 0 30px 10px -20px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  -webkit-transform: scale(0);\n          transform: scale(0);\n  -webkit-transition: opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1), -webkit-transform 0.3s cubic-bezier(0.42, 0, 0.58, 1);\n  transition: opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1), -webkit-transform 0.3s cubic-bezier(0.42, 0, 0.58, 1);\n  transition: transform 0.3s cubic-bezier(0.42, 0, 0.58, 1), opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1);\n  transition: transform 0.3s cubic-bezier(0.42, 0, 0.58, 1), opacity 0.3s cubic-bezier(0.42, 0, 0.58, 1), -webkit-transform 0.3s cubic-bezier(0.42, 0, 0.58, 1);\n}\n\n.tap-target-content {\n  position: relative;\n  display: table-cell;\n}\n\n.tap-target-wave {\n  position: absolute;\n  border-radius: 50%;\n  z-index: 10001;\n}\n\n.tap-target-wave::before, .tap-target-wave::after {\n  content: '';\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: #ffffff;\n}\n\n.tap-target-wave::before {\n  -webkit-transform: scale(0);\n          transform: scale(0);\n  -webkit-transition: -webkit-transform .3s;\n  transition: -webkit-transform .3s;\n  transition: transform .3s;\n  transition: transform .3s, -webkit-transform .3s;\n}\n\n.tap-target-wave::after {\n  visibility: hidden;\n  -webkit-transition: opacity .3s,\r visibility 0s,\r -webkit-transform .3s;\n  transition: opacity .3s,\r visibility 0s,\r -webkit-transform .3s;\n  transition: opacity .3s,\r transform .3s,\r visibility 0s;\n  transition: opacity .3s,\r transform .3s,\r visibility 0s,\r -webkit-transform .3s;\n  z-index: -1;\n}\n\n.tap-target-origin {\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  z-index: 10002;\n  position: absolute !important;\n}\n\n.tap-target-origin:not(.btn):not(.btn-large), .tap-target-origin:not(.btn):not(.btn-large):hover {\n  background: none;\n}\n\n@media only screen and (max-width: 600px) {\n  .tap-target, .tap-target-wrapper {\n    width: 600px;\n    height: 600px;\n  }\n}\n\n.pulse {\n  overflow: initial;\n  position: relative;\n}\n\n.pulse::before {\n  content: '';\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background-color: inherit;\n  border-radius: inherit;\n  -webkit-transition: opacity .3s, -webkit-transform .3s;\n  transition: opacity .3s, -webkit-transform .3s;\n  transition: opacity .3s, transform .3s;\n  transition: opacity .3s, transform .3s, -webkit-transform .3s;\n  -webkit-animation: pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1) infinite;\n          animation: pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1) infinite;\n  z-index: -1;\n}\n\n@-webkit-keyframes pulse-animation {\n  0% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 0;\n    -webkit-transform: scale(1.5);\n            transform: scale(1.5);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(1.5);\n            transform: scale(1.5);\n  }\n}\n\n@keyframes pulse-animation {\n  0% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 0;\n    -webkit-transform: scale(1.5);\n            transform: scale(1.5);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(1.5);\n            transform: scale(1.5);\n  }\n}\n\n/* ==========================================================================\r\n   $BASE-PICKER\r\n   ========================================================================== */\n/**\r\n * Note: the root picker element should *NOT* be styled more than what's here.\r\n */\n.picker {\n  font-size: 16px;\n  text-align: left;\n  line-height: 1.2;\n  color: #000000;\n  position: absolute;\n  z-index: 10000;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  outline: none;\n}\n\n/**\r\n * The picker input element.\r\n */\n.picker__input {\n  cursor: default;\n}\n\n/**\r\n * When the picker is opened, the input element is \"activated\".\r\n */\n.picker__input.picker__input--active {\n  border-color: #0089ec;\n}\n\n/**\r\n * The holder is the only \"scrollable\" top-level container element.\r\n */\n.picker__holder {\n  width: 100%;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/*!\r\n * Default mobile-first, responsive styling for pickadate.js\r\n * Demo: http://amsul.github.io/pickadate.js\r\n */\n/**\r\n * Note: the root picker element should *NOT* be styled more than what's here.\r\n */\n/**\r\n * Make the holder and frame fullscreen.\r\n */\n.picker__holder,\n.picker__frame {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 100%;\n}\n\n/**\r\n * The holder should overlay the entire screen.\r\n */\n.picker__holder {\n  position: fixed;\n  -webkit-transition: background 0.15s ease-out, top 0s 0.15s;\n  transition: background 0.15s ease-out, top 0s 0.15s;\n  -webkit-backface-visibility: hidden;\n}\n\n/**\r\n * The frame that bounds the box contents of the picker.\r\n */\n.picker__frame {\n  position: absolute;\n  margin: 0 auto;\n  min-width: 256px;\n  width: 300px;\n  max-height: 350px;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n  filter: alpha(opacity=0);\n  -moz-opacity: 0;\n  opacity: 0;\n  -webkit-transition: all 0.15s ease-out;\n  transition: all 0.15s ease-out;\n}\n\n@media (min-height: 28.875em) {\n  .picker__frame {\n    overflow: visible;\n    top: auto;\n    bottom: -100%;\n    max-height: 80%;\n  }\n}\n\n@media (min-height: 40.125em) {\n  .picker__frame {\n    margin-bottom: 7.5%;\n  }\n}\n\n/**\r\n * The wrapper sets the stage to vertically align the box contents.\r\n */\n.picker__wrap {\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n\n@media (min-height: 28.875em) {\n  .picker__wrap {\n    display: block;\n  }\n}\n\n/**\r\n * The box contains all the picker contents.\r\n */\n.picker__box {\n  background: #ffffff;\n  display: table-cell;\n  vertical-align: middle;\n}\n\n@media (min-height: 28.875em) {\n  .picker__box {\n    display: block;\n    border: 1px solid #777777;\n    border-top-color: #898989;\n    border-bottom-width: 0;\n    border-radius: 5px 5px 0 0;\n    -webkit-box-shadow: 0 12px 36px 16px rgba(0, 0, 0, 0.24);\n    box-shadow: 0 12px 36px 16px rgba(0, 0, 0, 0.24);\n  }\n}\n\n/**\r\n * When the picker opens...\r\n */\n.picker--opened .picker__holder {\n  top: 0;\n  background: transparent;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.gradient(startColorstr=#1E000000,endColorstr=#1E000000)\";\n  zoom: 1;\n  background: rgba(0, 0, 0, 0.32);\n  -webkit-transition: background 0.15s ease-out;\n  transition: background 0.15s ease-out;\n}\n\n.picker--opened .picker__frame {\n  top: 0;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n  filter: alpha(opacity=100);\n  -moz-opacity: 1;\n  opacity: 1;\n}\n\n@media (min-height: 35.875em) {\n  .picker--opened .picker__frame {\n    top: 10%;\n    bottom: auto;\n  }\n}\n\n/**\r\n * For `large` screens, transform into an inline picker.\r\n */\n/* ==========================================================================\r\n   CUSTOM MATERIALIZE STYLES\r\n   ========================================================================== */\n.picker__input.picker__input--active {\n  border-color: #E3F2FD;\n}\n\n.picker__frame {\n  margin: 0 auto;\n  max-width: 325px;\n}\n\n@media (min-height: 38.875em) {\n  .picker--opened .picker__frame {\n    top: 10%;\n    bottom: auto;\n  }\n}\n\n@media only screen and (min-width: 601px) {\n  .picker__box {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n  }\n  .picker__frame {\n    width: 80%;\n    max-width: 600px;\n  }\n}\n\n/* ==========================================================================\r\n   $BASE-DATE-PICKER\r\n   ========================================================================== */\n/**\r\n * The picker box.\r\n */\n.picker__box {\n  padding: 0;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n/**\r\n * The header containing the month and year stuff.\r\n */\n.picker__header {\n  text-align: center;\n  position: relative;\n  margin-top: .75em;\n}\n\n/**\r\n * The month and year labels.\r\n */\n.picker__month,\n.picker__year {\n  display: inline-block;\n  margin-left: .25em;\n  margin-right: .25em;\n}\n\n/**\r\n * The month and year selectors.\r\n */\n.picker__select--month,\n.picker__select--year {\n  height: 2em;\n  padding: 0;\n  margin-left: .25em;\n  margin-right: .25em;\n}\n\n.picker__select--month.browser-default {\n  display: inline;\n  background-color: #FFFFFF;\n  width: 40%;\n}\n\n.picker__select--year.browser-default {\n  display: inline;\n  background-color: #FFFFFF;\n  width: 26%;\n}\n\n.picker__select--month:focus,\n.picker__select--year:focus {\n  border-color: rgba(0, 0, 0, 0.05);\n}\n\n/**\r\n * The month navigation buttons.\r\n */\n.picker__nav--prev,\n.picker__nav--next {\n  position: absolute;\n  padding: .5em 1.25em;\n  width: 1em;\n  height: 1em;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  top: -0.25em;\n}\n\n.picker__nav--prev {\n  left: -1em;\n  padding-right: 1.25em;\n}\n\n.picker__nav--next {\n  right: -1em;\n  padding-left: 1.25em;\n}\n\n.picker__nav--disabled,\n.picker__nav--disabled:hover,\n.picker__nav--disabled:before,\n.picker__nav--disabled:before:hover {\n  cursor: default;\n  background: none;\n  border-right-color: #f5f5f5;\n  border-left-color: #f5f5f5;\n}\n\n/**\r\n * The calendar table of dates\r\n */\n.picker__table {\n  text-align: center;\n  border-collapse: collapse;\n  border-spacing: 0;\n  table-layout: fixed;\n  font-size: 1rem;\n  width: 100%;\n  margin-top: .75em;\n  margin-bottom: .5em;\n}\n\n.picker__table th, .picker__table td {\n  text-align: center;\n}\n\n.picker__table td {\n  margin: 0;\n  padding: 0;\n}\n\n/**\r\n * The weekday labels\r\n */\n.picker__weekday {\n  width: 14.285714286%;\n  font-size: .75em;\n  padding-bottom: .25em;\n  color: #999999;\n  font-weight: 500;\n  /* Increase the spacing a tad */\n}\n\n@media (min-height: 33.875em) {\n  .picker__weekday {\n    padding-bottom: .5em;\n  }\n}\n\n/**\r\n * The days on the calendar\r\n */\n.picker__day--today {\n  position: relative;\n  color: #595959;\n  letter-spacing: -.3;\n  padding: .75rem 0;\n  font-weight: 400;\n  border: 1px solid transparent;\n}\n\n.picker__day--disabled:before {\n  border-top-color: #aaaaaa;\n}\n\n.picker__day--infocus:hover {\n  cursor: pointer;\n  color: #000;\n  font-weight: 500;\n}\n\n.picker__day--outfocus {\n  display: none;\n  padding: .75rem 0;\n  color: #fff;\n}\n\n.picker__day--outfocus:hover {\n  cursor: pointer;\n  color: #dddddd;\n  font-weight: 500;\n}\n\n.picker__day--highlighted:hover,\n.picker--focused .picker__day--highlighted {\n  cursor: pointer;\n}\n\n.picker__day--selected,\n.picker__day--selected:hover,\n.picker--focused .picker__day--selected {\n  border-radius: 50%;\n  -webkit-transform: scale(0.75);\n          transform: scale(0.75);\n  background: #0089ec;\n  color: #ffffff;\n}\n\n.picker__day--disabled,\n.picker__day--disabled:hover,\n.picker--focused .picker__day--disabled {\n  background: #f5f5f5;\n  border-color: #f5f5f5;\n  color: #dddddd;\n  cursor: default;\n}\n\n.picker__day--highlighted.picker__day--disabled,\n.picker__day--highlighted.picker__day--disabled:hover {\n  background: #bbbbbb;\n}\n\n/**\r\n * The footer containing the \"today\", \"clear\", and \"close\" buttons.\r\n */\n.picker__footer {\n  text-align: right;\n}\n\n.picker__button--today,\n.picker__button--clear,\n.picker__button--close {\n  border: 1px solid #ffffff;\n  background: #ffffff;\n  font-size: .8em;\n  padding: .66em 0;\n  font-weight: bold;\n  width: 33%;\n  display: inline-block;\n  vertical-align: bottom;\n}\n\n.picker__button--today:hover,\n.picker__button--clear:hover,\n.picker__button--close:hover {\n  cursor: pointer;\n  color: #000000;\n  background: #b1dcfb;\n  border-bottom-color: #b1dcfb;\n}\n\n.picker__button--today:focus,\n.picker__button--clear:focus,\n.picker__button--close:focus {\n  background: #b1dcfb;\n  border-color: rgba(0, 0, 0, 0.05);\n  outline: none;\n}\n\n.picker__button--today:before,\n.picker__button--clear:before,\n.picker__button--close:before {\n  position: relative;\n  display: inline-block;\n  height: 0;\n}\n\n.picker__button--today:before,\n.picker__button--clear:before {\n  content: \" \";\n  margin-right: .45em;\n}\n\n.picker__button--today:before {\n  top: -0.05em;\n  width: 0;\n  border-top: 0.66em solid #0059bc;\n  border-left: .66em solid transparent;\n}\n\n.picker__button--clear:before {\n  top: -0.25em;\n  width: .66em;\n  border-top: 3px solid #ee2200;\n}\n\n.picker__button--close:before {\n  content: \"\\D7\";\n  top: -0.1em;\n  vertical-align: top;\n  font-size: 1.1em;\n  margin-right: .35em;\n  color: #777777;\n}\n\n.picker__button--today[disabled],\n.picker__button--today[disabled]:hover {\n  background: #f5f5f5;\n  border-color: #f5f5f5;\n  color: #dddddd;\n  cursor: default;\n}\n\n.picker__button--today[disabled]:before {\n  border-top-color: #aaaaaa;\n}\n\n/* ==========================================================================\r\n   CUSTOM MATERIALIZE STYLES\r\n   ========================================================================== */\n/*.picker__box {\r\n  border-radius: 2px;\r\n  overflow: hidden;\r\n}*/\n.picker__date-display {\n  text-align: left;\n  background-color: #26a69a;\n  color: #fff;\n  padding: 18px;\n  font-weight: 300;\n}\n\n@media only screen and (min-width: 601px) {\n  .picker__date-display {\n    -webkit-box-flex: 1;\n    -webkit-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n  }\n  .picker__weekday-display {\n    display: block;\n  }\n  .picker__container__wrapper {\n    -webkit-box-flex: 2;\n    -webkit-flex: 2;\n        -ms-flex: 2;\n            flex: 2;\n  }\n}\n\n.picker__nav--prev:hover,\n.picker__nav--next:hover {\n  cursor: pointer;\n  color: #000000;\n  background: #a1ded8;\n}\n\n.picker__weekday-display {\n  font-weight: 500;\n  font-size: 2.8rem;\n  margin-right: 5px;\n  margin-top: 4px;\n}\n\n.picker__month-display {\n  font-size: 2.8rem;\n  font-weight: 500;\n}\n\n.picker__day-display {\n  font-size: 2.8rem;\n  font-weight: 500;\n  margin-right: 5px;\n}\n\n.picker__year-display {\n  font-size: 1.5rem;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/*.picker__box {\r\n  padding: 0;\r\n}*/\n.picker__calendar-container {\n  padding: 0 1rem;\n}\n\n.picker__calendar-container thead {\n  border: none;\n}\n\n.picker__table {\n  margin-top: 0;\n  margin-bottom: .5em;\n}\n\n.picker__day--infocus {\n  color: rgba(0, 0, 0, 0.87);\n  letter-spacing: -.3px;\n  padding: 0.75rem 0;\n  font-weight: 400;\n  border: 1px solid transparent;\n}\n\n@media only screen and (min-width: 601px) {\n  .picker__day--infocus {\n    padding: 1.1rem 0;\n  }\n}\n\n.picker__day.picker__day--today {\n  color: #26a69a;\n}\n\n.picker__day.picker__day--today.picker__day--selected {\n  color: #fff;\n}\n\n.picker__weekday {\n  font-size: .9rem;\n}\n\n.picker__day--selected,\n.picker__day--selected:hover,\n.picker--focused .picker__day--selected {\n  border-radius: 50%;\n  -webkit-transform: scale(0.9);\n          transform: scale(0.9);\n  background-color: #26a69a;\n  color: #ffffff;\n}\n\n.picker__day--selected.picker__day--outfocus,\n.picker__day--selected:hover.picker__day--outfocus,\n.picker--focused .picker__day--selected.picker__day--outfocus {\n  background-color: #a1ded8;\n}\n\n.picker__footer {\n  text-align: right;\n  padding: 5px 10px;\n}\n\n.picker__close, .picker__today, .picker__clear {\n  font-size: 1.1rem;\n  padding: 0 1rem;\n  color: #26a69a;\n}\n\n.picker__clear {\n  color: #f44336;\n  float: left;\n}\n\n.picker__nav--prev:before,\n.picker__nav--next:before {\n  content: \" \";\n  border-top: .5em solid transparent;\n  border-bottom: .5em solid transparent;\n  border-right: 0.75em solid #676767;\n  width: 0;\n  height: 0;\n  display: block;\n  margin: 0 auto;\n}\n\n.picker__nav--next:before {\n  border-right: 0;\n  border-left: 0.75em solid #676767;\n}\n\nbutton.picker__today:focus, button.picker__clear:focus, button.picker__close:focus {\n  background-color: #a1ded8;\n}\n\n/* ==========================================================================\r\n   $BASE-TIME-PICKER\r\n   ========================================================================== */\n/**\r\n * The list of times.\r\n */\n.picker__list {\n  list-style: none;\n  padding: 0.75em 0 4.2em;\n  margin: 0;\n}\n\n/**\r\n * The times on the clock.\r\n */\n.picker__list-item {\n  border-bottom: 1px solid #ddd;\n  border-top: 1px solid #ddd;\n  margin-bottom: -1px;\n  position: relative;\n  background: #fff;\n  padding: .75em 1.25em;\n}\n\n@media (min-height: 46.75em) {\n  .picker__list-item {\n    padding: .5em 1em;\n  }\n}\n\n/* Hovered time */\n.picker__list-item:hover {\n  cursor: pointer;\n  color: #000;\n  background: #b1dcfb;\n  border-color: #0089ec;\n  z-index: 10;\n}\n\n/* Highlighted and hovered/focused time */\n.picker__list-item--highlighted {\n  border-color: #0089ec;\n  z-index: 10;\n}\n\n.picker__list-item--highlighted:hover,\n.picker--focused .picker__list-item--highlighted {\n  cursor: pointer;\n  color: #000;\n  background: #b1dcfb;\n}\n\n/* Selected and hovered/focused time */\n.picker__list-item--selected,\n.picker__list-item--selected:hover,\n.picker--focused .picker__list-item--selected {\n  background: #0089ec;\n  color: #fff;\n  z-index: 10;\n}\n\n/* Disabled time */\n.picker__list-item--disabled,\n.picker__list-item--disabled:hover,\n.picker--focused .picker__list-item--disabled {\n  background: #f5f5f5;\n  border-color: #f5f5f5;\n  color: #ddd;\n  cursor: default;\n  border-color: #ddd;\n  z-index: auto;\n}\n\n/**\r\n * The clear button\r\n */\n.picker--time .picker__button--clear {\n  display: block;\n  width: 80%;\n  margin: 1em auto 0;\n  padding: 1em 1.25em;\n  background: none;\n  border: 0;\n  font-weight: 500;\n  font-size: .67em;\n  text-align: center;\n  text-transform: uppercase;\n  color: rgba(0, 0, 0, 0.87);\n}\n\n.picker--time .picker__button--clear:hover,\n.picker--time .picker__button--clear:focus {\n  color: #000;\n  background: #b1dcfb;\n  background: #ee2200;\n  border-color: #ee2200;\n  cursor: pointer;\n  color: #fff;\n  outline: none;\n}\n\n.picker--time .picker__button--clear:before {\n  top: -0.25em;\n  color: rgba(0, 0, 0, 0.87);\n  font-size: 1.25em;\n  font-weight: bold;\n}\n\n.picker--time .picker__button--clear:hover:before,\n.picker--time .picker__button--clear:focus:before {\n  color: #fff;\n}\n\n/* ==========================================================================\r\n   $DEFAULT-TIME-PICKER\r\n   ========================================================================== */\n/**\r\n * The frame the bounds the time picker.\r\n */\n.picker--time .picker__frame {\n  min-width: 256px;\n  max-width: 320px;\n}\n\n/**\r\n * The picker box.\r\n */\n.picker--time .picker__box {\n  font-size: 1em;\n  background: #f2f2f2;\n  padding: 0;\n}\n\n@media (min-height: 40.125em) {\n  .picker--time .picker__box {\n    margin-bottom: 5em;\n  }\n}\n\n/* ==========================================================================\r\n   $DEFAULT-TIME-PICKER\r\n   ========================================================================== */\n.clockpicker-display {\n  font-size: 4rem;\n  font-weight: bold;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 400;\n  clear: both;\n  position: relative;\n}\n\n.clockpicker-span-am-pm {\n  font-size: 1.3rem;\n  position: absolute;\n  right: 1rem;\n  bottom: 0.3rem;\n  line-height: 2rem;\n  font-weight: 500;\n}\n\n@media only screen and (min-width: 601px) {\n  .clockpicker-display {\n    top: 32%;\n  }\n  .clockpicker-span-am-pm {\n    position: relative;\n    right: auto;\n    bottom: auto;\n    text-align: center;\n    margin-top: 1.2rem;\n  }\n}\n\n.text-primary {\n  color: white;\n}\n\n.clockpicker-span-hours {\n  margin-right: 3px;\n}\n\n.clockpicker-span-minutes {\n  margin-left: 3px;\n}\n\n.clockpicker-span-hours,\n.clockpicker-span-minutes,\n.clockpicker-span-am-pm div {\n  cursor: pointer;\n}\n\n.clockpicker-moving {\n  cursor: move;\n}\n\n.clockpicker-plate {\n  background-color: #eee;\n  border-radius: 50%;\n  width: 270px;\n  height: 270px;\n  overflow: visible;\n  position: relative;\n  margin: auto;\n  margin-top: 25px;\n  margin-bottom: 5px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.clockpicker-canvas,\n.clockpicker-dial {\n  width: 270px;\n  height: 270px;\n  position: absolute;\n  left: -1px;\n  top: -1px;\n}\n\n.clockpicker-minutes {\n  visibility: hidden;\n}\n\n.clockpicker-tick {\n  border-radius: 50%;\n  color: rgba(0, 0, 0, 0.87);\n  line-height: 40px;\n  text-align: center;\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  cursor: pointer;\n}\n\n.clockpicker-tick.active,\n.clockpicker-tick:hover {\n  background-color: rgba(38, 166, 154, 0.25);\n}\n\n.clockpicker-dial {\n  -webkit-transition: -webkit-transform 350ms, opacity 350ms;\n  -webkit-transition: opacity 350ms, -webkit-transform 350ms;\n  transition: opacity 350ms, -webkit-transform 350ms;\n  transition: transform 350ms, opacity 350ms;\n  transition: transform 350ms, opacity 350ms, -webkit-transform 350ms;\n}\n\n.clockpicker-dial-out {\n  opacity: 0;\n}\n\n.clockpicker-hours.clockpicker-dial-out {\n  -webkit-transform: scale(1.2, 1.2);\n  transform: scale(1.2, 1.2);\n}\n\n.clockpicker-minutes.clockpicker-dial-out {\n  -webkit-transform: scale(0.8, 0.8);\n  transform: scale(0.8, 0.8);\n}\n\n.clockpicker-canvas {\n  -webkit-transition: opacity 175ms;\n  transition: opacity 175ms;\n}\n\n.clockpicker-canvas-out {\n  opacity: 0.25;\n}\n\n.clockpicker-canvas-bearing {\n  stroke: none;\n  fill: #26a69a;\n}\n\n.clockpicker-canvas-bg {\n  stroke: none;\n  fill: #26a69a;\n}\n\n.clockpicker-canvas-bg-trans {\n  fill: #26a69a;\n}\n\n.clockpicker-canvas line {\n  stroke: #26a69a;\n  stroke-width: 4;\n  stroke-linecap: round;\n  /*shape-rendering: crispEdges;*/\n}\n", ""]);

// exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n.preloader[data-v-18d6d9ee] {\n  padding: 128px;\n  margin: 0 auto;\n  text-align: center;\n}\n.preloader .spinner-layer[data-v-18d6d9ee] {\n    border-color: #00BDD1;\n}\n.compare-mode .estimate-table[data-v-18d6d9ee] {\n  padding: 20px;\n  border-collapse: collapse;\n}\n.compare-mode .estimate-table th[data-v-18d6d9ee], .compare-mode .estimate-table td[data-v-18d6d9ee] {\n    text-align: center;\n    padding: 5px 10px;\n    border-right: 1px dotted lightgray;\n}\n.compare-mode .estimate-table th[data-v-18d6d9ee]:last-child, .compare-mode .estimate-table td[data-v-18d6d9ee]:last-child {\n    border-right: none;\n}\n.compare-mode .estimate-table tr[data-v-18d6d9ee] {\n    border-bottom: 1px dotted lightgray;\n}\n.compare-mode .estimate-table tr[data-v-18d6d9ee]:last-child {\n      border-bottom: none;\n}\n.compare-mode .estimate-table .distortion[data-v-18d6d9ee] {\n    padding: 5px;\n}\n.compare-mode .estimate-table .file[data-v-18d6d9ee] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    width: 100%;\n}\n.compare-mode .estimate-table .file .filename[data-v-18d6d9ee] {\n      overflow-wrap: break-word;\n      max-width: 200px;\n      text-align: start;\n      -ms-flex: 1 1 100%;\n          flex: 1 1 100%;\n      padding: 0 10px;\n}\n.compare-mode .estimate-table.nested-table .plate-estimate[data-v-18d6d9ee], .compare-mode .estimate-table.nested-table .plate-estimate td[data-v-18d6d9ee]:not(:first-of-type), .compare-mode .estimate-table.nested-table .plate-estimate th[data-v-18d6d9ee] {\n    border: 1px dotted lightgray;\n}\n.compare-mode .estimate-table.nested-table .plate-estimate[data-v-18d6d9ee], .compare-mode .estimate-table.nested-table .plate-estimate[data-v-18d6d9ee]:first-child {\n    border: none;\n}\n.compare-mode .total-estimate[data-v-18d6d9ee] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  border: 1px dotted gray;\n  border-radius: 5px;\n  margin-top: 20px;\n}\n.compare-mode .total-estimate div[data-v-18d6d9ee] {\n    padding: 15px;\n    text-align: center;\n}\n.compare-mode .total-estimate div[data-v-18d6d9ee]:not(:last-child) {\n      border-right: 1px dotted lightgray;\n}\n.compare-mode .total-estimate div[data-v-18d6d9ee]:nth-of-type(2n + 1) {\n      font-weight: bold;\n}\n.compare-mode .btn-delete-estimate[data-v-18d6d9ee] {\n  font-size: 17px;\n  cursor: pointer;\n}\n.compare-mode .nested-job-name[data-v-18d6d9ee] {\n  font-size: 18px;\n  margin-top: 20px;\n  font-weight: bold;\n}\n.compare-mode .nested-part-name[data-v-18d6d9ee] {\n  margin-top: 10px;\n  font-weight: bold;\n}\n.compare-mode .estimate-row td[data-v-18d6d9ee]:first-child {\n  padding-left: 0;\n}\n.compare-mode .error[data-v-18d6d9ee] {\n  margin-bottom: 10px;\n}\n.modal-content[data-v-18d6d9ee] {\n  padding: 16px;\n}\n.modal-content .modal-header[data-v-18d6d9ee] {\n    font-size: 20px;\n    color: #000;\n    padding-bottom: 16px;\n}\n.modal-content .modal-form .radio-group .radio-item[data-v-18d6d9ee] {\n    padding-bottom: 8px;\n}\n.modal-content .modal-form .radio-group .radio-item label[data-v-18d6d9ee] {\n      color: #000;\n}\n.modal-content .modal-form .radio-group .radio-item [type=\"radio\"]:checked + label[data-v-18d6d9ee]:after,\n    .modal-content .modal-form .radio-group .radio-item [type=\"radio\"].with-gap:checked + label[data-v-18d6d9ee]:after {\n      background-color: #00BDD1;\n}\n.modal-content .modal-form .radio-group .radio-item [type=\"radio\"]:checked + label[data-v-18d6d9ee]:after,\n    .modal-content .modal-form .radio-group .radio-item [type=\"radio\"].with-gap:checked + label[data-v-18d6d9ee]:before,\n    .modal-content .modal-form .radio-group .radio-item [type=\"radio\"].with-gap:checked + label[data-v-18d6d9ee]:after {\n      border-color: #00BDD1;\n}\n.modal-content .modal-form .input-field.cost[data-v-18d6d9ee]:before {\n    content: \"$\";\n    position: absolute;\n    top: 12px;\n}\n.modal-content .modal-form .input-field.cost input[data-v-18d6d9ee] {\n    text-indent: 14px;\n}\n.modal-content .modal-form .input-field.cost.total[data-v-18d6d9ee]:before {\n    top: 9px;\n    font-size: 18px;\n}\n.modal-content .modal-form .input-field.cost.total input[data-v-18d6d9ee] {\n    font-size: 18px;\n}\n.modal-content .modal-form .input-field label.active[data-v-18d6d9ee] {\n    font-size: 16px;\n    color: #000;\n}\n.modal-content .modal-form .total-label[data-v-18d6d9ee] {\n    padding-top: 24px;\n    font-size: 18px;\n}\n.modal-content .modal-form .error[data-v-18d6d9ee] {\n    text-align: center;\n    color: #ff0000;\n}\n", ""]);

// exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n.loading-styles[data-v-25c81e86] {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.preloader[data-v-25c81e86] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.preloader.overlay[data-v-25c81e86] {\n    background-color: #fff;\n}\n.a3d.btn.no-wrap[data-v-25c81e86] {\n  white-space: nowrap;\n}\n#viewport[data-v-25c81e86] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: #1b1c1e;\n  background-image: linear-gradient(#7d8fa3, #1b1c1e);\n}\n#info[data-v-25c81e86], #bottom-legend[data-v-25c81e86] {\n  position: absolute;\n}\n#info[data-v-25c81e86], #bottom-legend[data-v-25c81e86], .jobOptimization[data-v-25c81e86] {\n  text-align: center;\n  z-index: 100;\n}\n#info .info-text[data-v-25c81e86], #bottom-legend .info-text[data-v-25c81e86], .jobOptimization .info-text[data-v-25c81e86] {\n    padding: 8px 24px;\n    display: inline-block;\n    margin: 0 auto;\n    color: #fff;\n    background-color: rgba(0, 189, 209, 0.8);\n    border: 1px solid #00bdd1;\n    border-radius: 8px;\n}\n.jobOptimization .info-text[data-v-25c81e86] {\n  padding: 16px 24px;\n}\n#info[data-v-25c81e86] {\n  top: 1em;\n  left: 120px;\n  right: 380px;\n}\n#bottom-legend[data-v-25c81e86] {\n  bottom: 1em;\n  margin: 0 100px;\n}\n#inset[data-v-25c81e86] {\n  width: 150px;\n  height: 150px;\n  background-color: transparent;\n  /* or transparent; will show through only if renderer alpha: true */\n  border: none;\n  /* or none; */\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  z-index: 100;\n}\n.dialog-help[data-v-25c81e86] {\n  padding: 20px;\n}\n.left-panel p[data-v-25c81e86], .bottom-block .controls-box p[data-v-25c81e86] {\n  margin: 0.5em 0;\n}\n.left-panel label[data-v-25c81e86], .bottom-block .controls-box label[data-v-25c81e86] {\n  color: #fff;\n  font-size: 14px;\n}\n.left-panel [type=\"radio\"]:not(:checked) + label[data-v-25c81e86],\n.left-panel [type=\"radio\"]:checked + label[data-v-25c81e86],\n.left-panel [type=\"radio\"].with-gap:checked + label[data-v-25c81e86], .bottom-block .controls-box [type=\"radio\"]:not(:checked) + label[data-v-25c81e86],\n.bottom-block .controls-box [type=\"radio\"]:checked + label[data-v-25c81e86],\n.bottom-block .controls-box [type=\"radio\"].with-gap:checked + label[data-v-25c81e86] {\n  height: 24px;\n  line-height: 24px;\n}\n.left-panel [type=\"radio\"]:checked + label[data-v-25c81e86]:after,\n.left-panel [type=\"radio\"].with-gap:checked + label[data-v-25c81e86]:before,\n.left-panel [type=\"radio\"].with-gap:checked + label[data-v-25c81e86]:after, .bottom-block .controls-box [type=\"radio\"]:checked + label[data-v-25c81e86]:after,\n.bottom-block .controls-box [type=\"radio\"].with-gap:checked + label[data-v-25c81e86]:before,\n.bottom-block .controls-box [type=\"radio\"].with-gap:checked + label[data-v-25c81e86]:after {\n  border-color: #fff;\n}\n.left-panel [type=\"radio\"]:checked + label[data-v-25c81e86]:after,\n.left-panel [type=\"radio\"].with-gap:checked + label[data-v-25c81e86]:after, .bottom-block .controls-box [type=\"radio\"]:checked + label[data-v-25c81e86]:after,\n.bottom-block .controls-box [type=\"radio\"].with-gap:checked + label[data-v-25c81e86]:after {\n  background-color: #fff;\n}\n.left-panel [type=\"radio\"]:not(:checked) + label[data-v-25c81e86]:before,\n.left-panel [type=\"radio\"]:not(:checked) + label[data-v-25c81e86]:after, .bottom-block .controls-box [type=\"radio\"]:not(:checked) + label[data-v-25c81e86]:before,\n.bottom-block .controls-box [type=\"radio\"]:not(:checked) + label[data-v-25c81e86]:after {\n  border-color: #d5d5d5;\n}\n.left-panel [type=\"checkbox\"] + label[data-v-25c81e86], .bottom-block .controls-box [type=\"checkbox\"] + label[data-v-25c81e86] {\n  margin-left: 4px;\n  padding-left: 32px;\n}\n.left-panel [type=\"checkbox\"]:not(:checked) + label[data-v-25c81e86]:after, .bottom-block .controls-box [type=\"checkbox\"]:not(:checked) + label[data-v-25c81e86]:after {\n  border-color: #d5d5d5;\n  top: 4px;\n  width: 16px;\n  height: 16px;\n}\n.left-panel [type=\"checkbox\"].filled-in:checked + label[data-v-25c81e86]:after, .bottom-block .controls-box [type=\"checkbox\"].filled-in:checked + label[data-v-25c81e86]:after {\n  border-color: #fff;\n  background-color: #fff;\n  top: 4px;\n  width: 16px;\n  height: 16px;\n}\n.left-panel [type=\"checkbox\"].filled-in:checked + label[data-v-25c81e86]:before, .bottom-block .controls-box [type=\"checkbox\"].filled-in:checked + label[data-v-25c81e86]:before {\n  border-bottom-color: #00BDD1;\n  border-right-color: #00BDD1;\n  top: 3px;\n  width: 6px;\n  height: 12px;\n}\n.left-panel[data-v-25c81e86] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: 100vh;\n  width: 700px;\n  right: 0;\n  position: absolute;\n  padding: 15px;\n  -ms-flex-align: end;\n      align-items: end;\n}\n.left-panel__box[data-v-25c81e86] {\n    color: #fff;\n    background-color: rgba(0, 189, 209, 0.8);\n    border: 1px solid #00bdd1;\n    border-radius: 8px;\n    padding: 0 16px;\n    margin-top: 1em;\n}\n.left-panel__box input[data-v-25c81e86] {\n      margin: 0 0 10px 0;\n      width: 60px;\n      height: 30px;\n      padding: 0 5px;\n      color: #000000;\n      border-style: solid;\n      border-width: 1px;\n      background: whitesmoke;\n      border-color: whitesmoke;\n}\n.bottom-block[data-v-25c81e86] {\n  position: absolute;\n  width: 300px;\n  right: 1em;\n  bottom: 200px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.bottom-block.single-legend[data-v-25c81e86] {\n    bottom: 140px;\n}\n.bottom-block .controls-box[data-v-25c81e86] {\n    color: #fff;\n    background-color: rgba(0, 189, 209, 0.8);\n    border: 1px solid #00bdd1;\n    border-radius: 8px;\n    padding: 0 16px;\n    margin-top: 1em;\n    height: 100%;\n}\n.bottom-block .controls-box.modify-supports[data-v-25c81e86] {\n      padding-bottom: 16px;\n}\n.bottom-block .controls-box .caution[data-v-25c81e86] {\n      margin: 0 -16px;\n      border-top-left-radius: 8px;\n      border-top-right-radius: 8px;\n      padding: 4px 16px;\n      font-weight: bold;\n      background-color: #ff4444;\n}\n.bottom-block .controls-box .range-bar[data-v-25c81e86] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n.bottom-block .controls-box .range-bar .range-bar-slider[data-v-25c81e86] {\n        -ms-flex: 3;\n            flex: 3;\n}\n.bottom-block .controls-box .range-bar .range-bar-slider input[type=\"range\"][data-v-25c81e86]::-webkit-slider-thumb {\n          background-color: #fff;\n}\n.bottom-block .controls-box .range-bar .range-bar-slider input[type=\"range\"][data-v-25c81e86]::-moz-range-thumb {\n          background-color: #fff;\n}\n.bottom-block .controls-box .range-bar .range-bar-slider input[type=\"range\"][data-v-25c81e86]::-ms-thumb {\n          background-color: #fff;\n}\n.bottom-block .controls-box .range-bar .range-bar-value[data-v-25c81e86] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        -ms-flex-pack: right;\n            justify-content: right;\n        padding-left: 12px;\n}\n.bottom-block .controls-box .range-bar .range-bar-value input[data-v-25c81e86] {\n          color: #fff;\n          border-bottom: none;\n          padding-top: 14px;\n          width: 50px;\n          margin-bottom: 0;\n}\n.bottom-block .controls-box .range-bar .range-bar-value input[data-v-25c81e86]:focus {\n            border-bottom: none;\n            box-shadow: none;\n}\n.bottom-block .controls-box .button-block[data-v-25c81e86] {\n      padding-bottom: 4px;\n}\n.bottom-block .controls-box .button-block[data-v-25c81e86]:last-child {\n        padding-bottom: 0;\n}\n.bottom-block .controls-box .button-block .btn[data-v-25c81e86] {\n        width: 100%;\n}\n.legend-block[data-v-25c81e86] {\n  width: 300px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row-reverse;\n      flex-direction: row-reverse;\n}\n.legend-block .inset-legend[data-v-25c81e86] {\n    width: 300px;\n    height: 150px;\n    background-color: transparent;\n    /* or transparent; will show through only if renderer alpha: true */\n    border: none;\n    /* or none; */\n    margin: 0;\n    padding: 0;\n    position: relative;\n}\n.legend-block .inset-legend .filename[data-v-25c81e86] {\n      width: 300px;\n      padding: 8px 24px;\n      text-align: center;\n      word-break: break-all;\n      color: #000000;\n}\n.legend-block .inset-legend .legend-title[data-v-25c81e86] {\n      width: 300px;\n      text-align: center;\n      color: #000000;\n      position: absolute;\n      bottom: 0;\n}\n.legend-block .inset-legend .inset-legend-wrp[data-v-25c81e86] {\n      position: absolute;\n      top: 0;\n      left: 0;\n}\n.buttons-block[data-v-25c81e86] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: right;\n      justify-content: right;\n}\n.buttons-block.second[data-v-25c81e86] {\n    top: calc(2em + 54px);\n}\n.buttons-block .btn[data-v-25c81e86] {\n    margin-left: 0.5em;\n}\n.buttons-block .browser-default[data-v-25c81e86] {\n    height: 54px;\n    min-width: 150px;\n    max-width: 400px;\n    border: none;\n}\n.context-menu[data-v-25c81e86] {\n  position: absolute;\n  background-color: #fff;\n  z-index: 110;\n  box-shadow: 4px 4px 15px 0px rgba(0, 0, 0, 0.2);\n}\n.context-menu ul[data-v-25c81e86] {\n    margin: 0;\n    border: 1px solid #c5c5c5;\n}\n.context-menu ul li a[data-v-25c81e86] {\n      cursor: pointer;\n      display: block;\n      padding: 8px 16px;\n      white-space: nowrap;\n}\n.context-menu ul li a[data-v-25c81e86]:hover {\n        background-color: #f5f5f5;\n}\n.prompt-modal[data-v-25c81e86] {\n  padding: 20px;\n}\n.prompt-modal .row[data-v-25c81e86] {\n    margin-bottom: 0;\n}\n.prompt-modal .title[data-v-25c81e86] {\n    font-size: 1.4em;\n    text-align: center;\n    padding-bottom: 20px;\n}\n.prompt-modal .modal-content[data-v-25c81e86] {\n    padding-bottom: 12px;\n}\n.prompt-modal .alert-title[data-v-25c81e86] {\n    color: red;\n    margin: 0 15px;\n}\n.prompt-modal .wrap[data-v-25c81e86] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    margin: 0 0 20px;\n}\n.prompt-modal .plate[data-v-25c81e86] {\n    width: 30%;\n    padding: 0 10px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n.prompt-modal .plate ul[data-v-25c81e86] {\n      margin: 0;\n}\n.prompt-modal .plate-title[data-v-25c81e86] {\n    font-size: 18px;\n    font-weight: bolder;\n}\n.prompt-modal .plate-error[data-v-25c81e86] {\n    padding: 0 0 0 10px;\n}\n", ""]);

// exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n.my-dropdown-dd {\n  position: absolute !important;\n  box-sizing: border-box !important;\n}\n.ani-none-leave-active, .ani-none-leave, .ani-none-enter-active, .ani-none-enter{\n  transition: none;\n}\n.ani-slide-leave-active {\n  transition: transform .3s ease, opacity .3s ease;\n  transform: scale(0, 0);\n  opacity: 0;\n}\n.ani-slide-leave {\n  transform: scale(1, 1);\n  opacity: 1;\n}\n.ani-slide-enter-active {\n  transition: transform .3s ease, opacity .3s ease;\n  transform: scale(1, 1);\n  opacity: 1;\n}\n.ani-slide-enter {\n  transform: scale(0, 0);\n  opacity: 0;\n}\n.ani-slide-x-leave-active {\n  transition: transform .3s ease, opacity .3s ease;\n  transform: scaleX(0);\n  opacity: 0;\n}\n.ani-slide-x-leave {\n  transform: scaleX(1);\n  opacity: 1;\n}\n.ani-slide-x-enter-active {\n  transition: transform .3s ease, opacity .3s ease;\n  transform: scaleX(1);\n  opacity: 1;\n}\n.ani-slide-x-enter {\n  transform: scaleX(0);\n  opacity: 0;\n}\n.ani-slide-y-leave-active {\n  transition: transform .3s ease, opacity .3s ease;\n  transform: scaleY(0);\n  opacity: 0;\n}\n.ani-slide-y-leave {\n  transform: scaleY(1);\n  opacity: 1;\n}\n.ani-slide-y-enter-active {\n  transition: transform .3s ease, opacity .3s ease;\n  transform: scaleY(1);\n  opacity: 1;\n}\n.ani-slide-y-enter {\n  transform: scaleY(0);\n  opacity: 0;\n}\n.ani-fade-leave-active {\n  transition: transform .3s ease, opacity .3s ease;\n  opacity: 0;\n}\n.ani-fade-leave {\n  opacity: 1;\n}\n.ani-fade-enter-active {\n  transition: transform .3s ease, opacity .3s ease;\n  opacity: 1\n}\n.ani-fade-enter {\n  opacity: 0\n}\n", ""]);

// exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n.banner[data-v-38ba4ea0] {\n  background-color: #06E9F4;\n  height: 120px;\n  width: 100%;\n  transition: background-color .3s;\n}\n.banner .btn.inv.dark[data-v-38ba4ea0] {\n    width: 100%;\n    font-size: inherit;\n    padding: 0.5em;\n    line-height: 1;\n    height: auto;\n}\n.banner.govcloud[data-v-38ba4ea0] {\n    background-color: #ff405c;\n    color: #ffffff;\n}\n.banner.govcloud .btn.inv.dark[data-v-38ba4ea0] {\n      color: #ffffff;\n      border-color: #ffffff;\n}\n.banner.govcloud .btn.inv.dark[data-v-38ba4ea0]:hover {\n        background-color: #e8184b;\n}\n.banner.govcloud .govcloud-secure[data-v-38ba4ea0] {\n      padding-top: 8px;\n      font-size: 16px;\n      font-weight: bold;\n}\n", ""]);

// exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n.illustration[data-v-3907c46c] {\n  height: 100%;\n  background-color: #f2f2f2;\n  padding: 24px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  position: relative;\n  min-height: 600px;\n}\n.illustration.centered[data-v-3907c46c] {\n    -ms-flex-pack: center;\n        justify-content: center;\n}\n.illustration .canvas[data-v-3907c46c] {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-pack: center;\n        justify-content: center;\n    background: #00e9f6;\n}\n.illustration .canvas .base-gap[data-v-3907c46c] {\n      background: #fff;\n      height: 350px;\n      width: 100%;\n}\n.illustration .canvas .layer[data-v-3907c46c] {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-pack: center;\n          justify-content: center;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.illustration .canvas .layer.support[data-v-3907c46c] {\n        top: 0px;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.illustration .canvas .layer.legends[data-v-3907c46c] {\n        -ms-flex-align: center;\n            align-items: center;\n        right: 60px;\n        top: -2px;\n}\n.illustration .canvas .layer.block-names[data-v-3907c46c] {\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n        top: 0;\n}\n.illustration .canvas .layer.block-names .top-name[data-v-3907c46c], .illustration .canvas .layer.block-names .bottom-name[data-v-3907c46c] {\n          font-size: 1.8rem;\n          text-transform: uppercase;\n}\n.illustration .canvas .layer.block-names .top-name[data-v-3907c46c] {\n          padding-top: 40px;\n}\n.illustration .canvas .layer.block-names .bottom-name[data-v-3907c46c] {\n          padding-bottom: 40px;\n}\n.illustration .canvas .fill[data-v-3907c46c] {\n      -ms-flex: 1;\n          flex: 1;\n      height: 100%;\n      width: 100%;\n}\n.illustration .canvas .fill[data-v-3907c46c] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-direction: column;\n          flex-direction: column;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.illustration .canvas .fill.top[data-v-3907c46c] {\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n}\n.illustration .canvas .fill.bottom[data-v-3907c46c] {\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n}\n.illustration .canvas .base[data-v-3907c46c] {\n      background: #00e9f6;\n      width: 100%;\n}\n.illustration .canvas .rect[data-v-3907c46c] {\n      width: 40px;\n      height: 110px;\n      background: #000;\n}\n.illustration .canvas .rect.trapecia[data-v-3907c46c] {\n        background: transparent;\n        border-left: 35px solid transparent;\n        border-right: 35px solid transparent;\n        height: 0;\n        box-sizing: content-box;\n}\n.illustration .canvas .rect.trapecia.upper[data-v-3907c46c] {\n          border-bottom: 80px solid #888;\n}\n.illustration .canvas .rect.trapecia.bottom[data-v-3907c46c] {\n          border-top: 80px solid #888;\n}\n.illustration .canvas .rect.trapecia .legend-line[data-v-3907c46c] {\n          width: 100%;\n          height: 2px;\n          background: #000;\n          margin-top: 5px;\n          display: -ms-flexbox;\n          display: flex;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.illustration .canvas .rect.trapecia .legend-line[data-v-3907c46c]:before, .illustration .canvas .rect.trapecia .legend-line[data-v-3907c46c]:after {\n            content: \"\";\n            width: 0;\n            height: 0;\n            border-left: 5px solid transparent;\n            border-right: 5px solid transparent;\n            border-bottom: 7px solid;\n            position: relative;\n            top: -3px;\n            right: 3px;\n            transform: rotate(-90deg);\n}\n.illustration .canvas .rect.trapecia .legend-line[data-v-3907c46c]:after {\n            transform: rotate(90deg);\n            left: 3px;\n}\n.illustration .canvas .rect.trapecia.bottom[data-v-3907c46c] {\n          position: relative;\n}\n.illustration .canvas .rect.trapecia.bottom .legend-title[data-v-3907c46c], .illustration .canvas .rect.trapecia.bottom .legend-line[data-v-3907c46c] {\n            position: relative;\n            bottom: 35px;\n}\n.illustration .canvas .rect.main[data-v-3907c46c] {\n        background: #eee;\n        width: 110px;\n        height: 110px;\n}\n.illustration .canvas .rect.main.build-plate[data-v-3907c46c] {\n          height: 200px;\n}\n.illustration .canvas .legend[data-v-3907c46c] {\n      display: -ms-flexbox;\n      display: flex;\n      position: relative;\n      font-size: 20px;\n      font-family: Arial, sans-serif;\n      padding: 10px 0px;\n      font-weight: bold;\n      border-top: 2px dashed #222;\n      width: 90px;\n      box-sizing: content-box;\n}\n.illustration .canvas .legend.last[data-v-3907c46c] {\n        border-bottom: 2px dashed #222;\n}\n.illustration .canvas .legend.trapecia[data-v-3907c46c] {\n        height: 56px;\n}\n.illustration .canvas .legend.ot[data-v-3907c46c] {\n        height: 19px;\n}\n.illustration .canvas .legend.depth[data-v-3907c46c] {\n        height: 47px;\n}\n.illustration .canvas .legend .legend-line[data-v-3907c46c] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        width: 2px;\n        height: 100%;\n        background: #000;\n        position: absolute;\n        top: 0;\n        left: 28px;\n}\n.illustration .canvas .legend .legend-line[data-v-3907c46c]:before, .illustration .canvas .legend .legend-line[data-v-3907c46c]:after {\n          content: \"\";\n          width: 0;\n          height: 0;\n          border-left: 5px solid transparent;\n          border-right: 5px solid transparent;\n          border-bottom: 7px solid #000;\n          position: relative;\n          right: 4px;\n}\n.illustration .canvas .legend .legend-line[data-v-3907c46c]:after {\n          border-bottom: none;\n          border-top: 7px solid #000;\n}\n.illustration .canvas .legend .legend-title[data-v-3907c46c] {\n        width: 20px;\n        -ms-flex-item-align: center;\n            -ms-grid-row-align: center;\n            align-self: center;\n}\n.illustration .canvas .placeholder-legends-left[data-v-3907c46c] {\n      height: 109px;\n}\n", ""]);

// exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n#uploadfile[data-v-3cf5c9a2] {\n  display: none;\n}\n.files-preloader[data-v-3cf5c9a2] {\n  padding: 128px;\n}\n.pagination .active[data-v-3cf5c9a2] {\n  background-color: #00BDD1;\n}\n.pagination .skip[data-v-3cf5c9a2] {\n  font-weight: bold;\n  line-height: 30px;\n}\n.a3d .file[data-v-3cf5c9a2] {\n  margin: 0.5em 0;\n  padding: 1em;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 100%;\n  background-color: #F2F2F2;\n}\n.a3d .jobout[data-v-3cf5c9a2] {\n  margin: 0.5em 0;\n  padding: 1em;\n  background-color: #F2F2F2;\n  width: 100%;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.a3d .job-status[data-v-3cf5c9a2] {\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.a3d .job-status .job-status-message[data-v-3cf5c9a2] {\n    -ms-flex-item-align: start;\n        align-self: flex-start;\n}\n.a3d .jobs[data-v-3cf5c9a2] {\n  background-color: #F2F2F2;\n}\n.a3d .job[data-v-3cf5c9a2] {\n  background-color: #FFFFFF;\n  display: -ms-flexbox;\n  display: flex;\n}\n.a3d .align-right[data-v-3cf5c9a2] {\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n}\n.a3d .toggleIcon[data-v-3cf5c9a2] {\n  padding-left: 16px;\n  cursor: pointer;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n}\n.a3d .jobout-buttons[data-v-3cf5c9a2] {\n  padding-top: 1px;\n  margin-left: 24px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex: 2;\n      flex: 2;\n}\n.a3d .jobout-buttons.nested-row[data-v-3cf5c9a2] {\n    -ms-flex: 4;\n        flex: 4;\n}\n.a3d .jobout-buttons .jobout-buttons-row[data-v-3cf5c9a2] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n    padding-bottom: 6px;\n}\n.a3d .jobout-buttons .jobout-buttons-row .btn[data-v-3cf5c9a2] {\n      margin: auto 0 auto 6px;\n}\n#files-root[data-v-3cf5c9a2] {\n  height: 100%;\n  margin-top: -64px;\n  padding-top: 64px;\n}\n#section-body[data-v-3cf5c9a2] {\n  height: 100%;\n  margin-top: -120px;\n  padding-top: 120px;\n  margin-bottom: 0;\n}\n#section-body > div[data-v-3cf5c9a2] {\n    height: 100%;\n}\n#section-body .row.flex[data-v-3cf5c9a2] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: start;\n        justify-content: flex-start;\n}\n#section-body .files .upload[data-v-3cf5c9a2] {\n    padding: 0.5em 1em;\n    margin-left: 1em;\n}\n#section-body .files .create-nested[data-v-3cf5c9a2] {\n    margin-left: auto;\n}\n#section-body .files .error[data-v-3cf5c9a2] {\n    padding: 0.5em 0 1em 0;\n    color: #ff0000;\n}\n#section-body .file [type=\"checkbox\"].filled-in + label[data-v-3cf5c9a2] {\n    padding-left: 24px;\n}\n#section-body .file [type=\"checkbox\"].filled-in:checked + label[data-v-3cf5c9a2]:after {\n    border-color: #00BDD1;\n    background-color: #00BDD1;\n}\n#section-body .file-name-block[data-v-3cf5c9a2] {\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n#section-body .file-name-block .file-name[data-v-3cf5c9a2] {\n      word-break: break-all;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n      font-size: 1.3em;\n      font-weight: bold;\n      padding-right: 4px;\n}\n#section-body .file-name-block .file-date[data-v-3cf5c9a2] {\n      font-size: 14px;\n}\n#section-body .file-name-nested[data-v-3cf5c9a2] {\n    -ms-flex: 2;\n        flex: 2;\n}\n#section-body .button-block[data-v-3cf5c9a2] {\n    display: -ms-flexbox;\n    display: flex;\n    text-align: right;\n    min-width: 120px;\n    -ms-flex-pack: end;\n        justify-content: flex-end;\n    -ms-flex: 3;\n        flex: 3;\n}\n#section-body .button-block .btn[data-v-3cf5c9a2] {\n      margin-left: 4px;\n}\n#section-body .button-block .btn i[data-v-3cf5c9a2] {\n        font-size: 0.9rem;\n}\n#section-body .button-block .menu .btn[data-v-3cf5c9a2] {\n      width: 100%;\n      margin-bottom: 0 !important;\n}\n.remove-modal[data-v-3cf5c9a2] {\n  padding: 20px;\n}\n.remove-modal .row[data-v-3cf5c9a2] {\n    margin-bottom: 0;\n}\n.remove-modal .title[data-v-3cf5c9a2] {\n    font-size: 1.4em;\n    text-align: center;\n    padding-bottom: 20px;\n}\n@media (max-width: 1400px) {\n#section-body .jobs .jobfile .button-block[data-v-3cf5c9a2] {\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n#section-body .jobs .jobfile .button-block .btn[data-v-3cf5c9a2] {\n      margin-bottom: 4px;\n}\n}\n@media (max-width: 1200px) {\n#section-body .files .button-block[data-v-3cf5c9a2] {\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n#section-body .files .button-block .btn[data-v-3cf5c9a2] {\n      margin-bottom: 4px;\n}\n}\n@media (max-width: 992px) {\n#section-body .files[data-v-3cf5c9a2] {\n    width: 100%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n.job-summary[data-v-3e32201d] {\n  padding: 0 24px;\n}\n.job-summary .input-field-label[data-v-3e32201d] {\n    padding-top: 14px;\n}\n.job-summary .input-field[data-v-3e32201d] {\n    margin: 0;\n}\n.job-summary .input-field input[data-v-3e32201d] {\n      margin: 0;\n}\n", ""]);

// exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\nnav[data-v-3f482306] {\n  height: auto;\n  position: relative;\n}\nnav .last-login[data-v-3f482306] {\n    position: absolute;\n    bottom: -20px;\n    right: 8px;\n    line-height: 18px;\n    font-size: 0.85rem;\n    color: #000;\n    z-index: 1;\n}\n.v--modal-overlay[data-modal=\"details-submitted\"][data-v-3f482306] {\n  z-index: 1000;\n  color: #000;\n}\n.v--modal-overlay[data-modal=\"details-submitted\"] .row.details-completed[data-v-3f482306] {\n    width: 100%;\n    padding: 50px 14px 30px 14px;\n}\n.v--modal-overlay[data-modal=\"details-submitted\"] .row.details-completed .details-completed-title[data-v-3f482306] {\n      padding-bottom: 20px;\n}\n.v--modal-overlay[data-modal=\"details\"][data-v-3f482306] {\n  z-index: 1000;\n  color: #000;\n}\n.v--modal-overlay[data-modal=\"details\"] .row.details[data-v-3f482306] {\n    width: 100%;\n    padding: 32px 14px 0 14px;\n}\n.v--modal-overlay[data-modal=\"details\"] .row.details .details-title[data-v-3f482306] {\n      font-size: 1.6rem;\n      font-weight: bold;\n      vertical-align: center;\n      padding-bottom: 20px;\n}\n.v--modal-overlay[data-modal=\"details\"] .row.details .details-form[data-v-3f482306] {\n      font-size: 1rem;\n      font-weight: normal;\n      width: 100%;\n}\n.v--modal-overlay[data-modal=\"details\"] .row.details .details-form .details-label[data-v-3f482306] {\n        line-height: 36px;\n}\n.v--modal-overlay[data-modal=\"details\"] .row.details .details-form .details-input input[data-v-3f482306] {\n        height: 2.4rem;\n        margin-bottom: 27px;\n        min-width: 100%;\n        display: block;\n}\n.v--modal-overlay[data-modal=\"details\"] .row.details .details-form .details-input .error[data-v-3f482306] {\n        margin-top: -19px;\n        font-size: 0.8rem;\n        color: #ff0000;\n}\n.a3d .nav-wrapper[data-v-3f482306] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  min-height: 64px;\n  height: auto;\n}\n.a3d .nav-wrapper .hide-on-med-and-down[data-v-3f482306] {\n    display: -ms-flexbox;\n    display: flex;\n}\n.a3d .nav-wrapper .hide-on-med-and-down .menu-link[data-v-3f482306] {\n      white-space: nowrap;\n}\n.a3d .nav-wrapper .clear-cache[data-v-3f482306] {\n    word-wrap: break-word;\n    font-size: 1.3em;\n    line-height: 1.5;\n    padding: 16px;\n    text-align: center;\n}\n.a3d .nav-wrapper .webgl-warning[data-v-3f482306] {\n    font-size: 24px;\n    color: #ffc107;\n    padding: 0 8px;\n    position: relative;\n}\n.a3d .nav-wrapper .webgl-warning i[data-v-3f482306] {\n      line-height: 24px;\n      height: 24px;\n}\n.a3d .nav-wrapper .webgl-warning-message-wrp[data-v-3f482306] {\n    position: relative;\n    display: none;\n}\n.a3d .nav-wrapper .webgl-warning-message-wrp .webgl-warning-message[data-v-3f482306] {\n      position: absolute;\n      min-width: 200px;\n      max-width: 300px;\n      transform: translateX(-100%);\n      padding: 8px;\n      line-height: 24px;\n      text-align: center;\n      top: -52px;\n      left: -8px;\n      margin-right: 20px;\n      background-color: #00BDD1;\n      border-radius: 12px;\n      color: #fff;\n      white-space: normal;\n      z-index: 2;\n      font-size: 1rem;\n      font-weight: normal;\n}\n.a3d .nav-wrapper .webgl-warning-message-wrp .webgl-warning-message a[data-v-3f482306] {\n        display: inline-block;\n        padding: 0;\n}\n.a3d .nav-wrapper .webgl-warning-message-wrp .webgl-warning-message a[data-v-3f482306]:hover {\n          text-decoration: underline;\n          background-color: transparent;\n}\n.a3d .nav-wrapper .webgl-warning-message-wrp .webgl-warning-message[data-v-3f482306]:after {\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        right: 0;\n        margin-right: -5px;\n        margin-top: -5px;\n        width: 10px;\n        height: 10px;\n        background-color: #00BDD1;\n        transform: rotate(45deg);\n        z-index: -1;\n}\n.a3d .nav-wrapper .webgl-warning:hover + .webgl-warning-message-wrp[data-v-3f482306] {\n    display: block;\n}\n.info-banner[data-v-3f482306] {\n  padding: 12px 24px;\n  text-align: center;\n}\na[data-v-3f482306] {\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n.container .title[data-v-414352eb] {\n  padding: 1em 0;\n}\n.container table.highlight .quantity[data-v-414352eb] {\n  width: 20%;\n  min-width: 100px;\n}\n.container table.highlight .importance[data-v-414352eb] {\n  width: 33%;\n  min-width: 200px;\n}\n.container table.highlight .remove-file[data-v-414352eb] {\n  width: 48px;\n}\n.container table.highlight td[data-v-414352eb] {\n  padding: 15px 12px;\n  border-bottom: 1px solid #d0d0d0;\n}\n.container table.highlight td .filename[data-v-414352eb] {\n    word-break: break-all;\n}\n.container table.highlight td input[type=\"number\"][data-v-414352eb], .container table.highlight td input[type=\"text\"][data-v-414352eb] {\n    box-sizing: border-box;\n    background-color: #fff;\n    padding: 0 12px;\n    margin: 0;\n}\n.container table.highlight td .error[data-v-414352eb] {\n    color: #ff0000;\n}\n.container .block-buttons[data-v-414352eb] {\n  padding-top: 1em;\n}\n", ""]);

// exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n.a3d .file[data-v-49a3b049] {\n  margin: 0.5em 0;\n  padding: 1em;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 100%;\n  background-color: #F2F2F2;\n}\n.a3d .file .file-name-block[data-v-49a3b049] {\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n.a3d .file .file-name-block .file-name[data-v-49a3b049] {\n      word-break: break-all;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n      font-size: 1.3em;\n      font-weight: bold;\n      padding-right: 4px;\n}\n.a3d .file .file-name-block .file-date[data-v-49a3b049] {\n      font-size: 14px;\n}\n.a3d .job[data-v-49a3b049] {\n  background-color: #FFFFFF;\n  display: -ms-flexbox;\n  display: flex;\n}\n.a3d .jobout[data-v-49a3b049] {\n  margin: 0.5em 0;\n  padding: 1em;\n  width: 100%;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.a3d .jobout .name[data-v-49a3b049] {\n    font-size: 1.2em;\n}\n.a3d .jobout .description[data-v-49a3b049] {\n    font-size: 16px;\n}\n.a3d .jobout .date[data-v-49a3b049] {\n    font-size: 14px;\n}\n.a3d .job-status[data-v-49a3b049] {\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.a3d .job-status .job-status-message[data-v-49a3b049] {\n    -ms-flex-item-align: start;\n        align-self: flex-start;\n}\n.a3d .jobout-buttons[data-v-49a3b049] {\n  padding-top: 1px;\n  margin-left: 24px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex: 2;\n      flex: 2;\n}\n.a3d .jobout-buttons .jobout-buttons-row[data-v-49a3b049] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n    padding-bottom: 6px;\n}\n.a3d .jobout-buttons .jobout-buttons-row .btn[data-v-49a3b049] {\n      margin: auto 0 auto 6px;\n}\n.a3d .toggleIcon[data-v-49a3b049] {\n  padding-left: 16px;\n  cursor: pointer;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n}\n.a3d .align-right[data-v-49a3b049] {\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n}\n.a3d .align-center[data-v-49a3b049] {\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.a3d .btn.nowrap[data-v-49a3b049] {\n  white-space: nowrap;\n  display: block;\n}\n.a3d .button-block[data-v-49a3b049] {\n  display: -ms-flexbox;\n  display: flex;\n  text-align: right;\n  min-width: 120px;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  -ms-flex: 3;\n      flex: 3;\n}\n.a3d .button-block .btn[data-v-49a3b049] {\n    margin-left: 4px;\n}\n.a3d .button-block .btn i[data-v-49a3b049] {\n      font-size: 0.9rem;\n}\n.a3d .button-block .menu .btn[data-v-49a3b049] {\n    width: 100%;\n    margin-bottom: 0 !important;\n}\n.file-name-nested[data-v-49a3b049] {\n  -ms-flex: 2;\n      flex: 2;\n}\n.load-more[data-v-49a3b049] {\n  margin-left: 30px;\n}\n.load-more .btn[data-v-49a3b049] {\n    width: 95%;\n}\n@media (max-width: 1400px) {\n#section-body .jobs .jobfile .button-block[data-v-49a3b049] {\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n#section-body .jobs .jobfile .button-block .btn[data-v-49a3b049] {\n      margin-bottom: 4px;\n}\n}\n@media (max-width: 1200px) {\n#section-body .files .button-block[data-v-49a3b049] {\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n#section-body .files .button-block .btn[data-v-49a3b049] {\n      margin-bottom: 4px;\n}\n}\n", ""]);

// exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\na[data-v-6c0f179e] {\n  cursor: pointer;\n}\n.container .note[data-v-6c0f179e] {\n  padding: 8px 0;\n}\n.container input[type=\"checkbox\"].filled-in:checked + label[data-v-6c0f179e]:after {\n  border-color: #00BDD1;\n  background-color: #00BDD1;\n}\n.container input[type=\"range\"][data-v-6c0f179e] {\n  border: none;\n}\n.container input[type=\"range\"][data-v-6c0f179e]::-webkit-slider-thumb {\n  background-color: #00BDD1;\n}\n.container input[type=\"range\"][data-v-6c0f179e]::-moz-range-thumb {\n  background-color: #00BDD1;\n}\n.container input[type=\"range\"][data-v-6c0f179e]::-ms-thumb {\n  background-color: #00BDD1;\n}\n.container label[for=\"useForAll\"][data-v-6c0f179e] {\n  color: inherit;\n}\n.container .row .status-message[data-v-6c0f179e] {\n  font-size: 1.6rem;\n}\n.error[data-v-6c0f179e] {\n  color: #ff0000;\n}\n.info-overlay[data-v-6c0f179e] {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  background-color: rgba(204, 204, 204, 0.9);\n}\n.info-overlay > .content[data-v-6c0f179e] {\n    position: absolute;\n    height: 100%;\n}\n.info-overlay > .content > *[data-v-6c0f179e] {\n      text-align: center;\n}\n.startjobtitle .title[data-v-6c0f179e] {\n  font-weight: bold;\n  padding: 8px 0;\n}\n.startjobtitle .note[data-v-6c0f179e] {\n  padding-top: 8px;\n}\n.startjobtitle .startjobor[data-v-6c0f179e] {\n  margin-bottom: 16px;\n}\n.startjobtitle .file-row[data-v-6c0f179e] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n.startjobtitle .file-row div[data-v-6c0f179e] {\n    padding: 0 4px;\n}\n.startjobtitle .file-row div.file-name[data-v-6c0f179e] {\n      -ms-flex: 2;\n          flex: 2;\n}\n.startjobtitle .file-row div.file-name[data-v-6c0f179e], .startjobtitle .file-row div.file-unit[data-v-6c0f179e] {\n      padding-top: 8px;\n}\n.startjobtitle .file-row div input[data-v-6c0f179e] {\n      min-width: 40px;\n      max-width: 60px;\n      padding: 0 4px;\n      height: 2.5rem;\n      background: #fff;\n}\n.startjobtitle .input-field[data-v-6c0f179e] {\n  margin: 0 4px;\n  width: 100px;\n}\n.startjobtitle .input-field #maxDist[data-v-6c0f179e] {\n    background-color: #fff;\n    text-align: right;\n    height: 2rem;\n    margin: 0;\n}\n.restrictions-block[data-v-6c0f179e] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.restrictions-block .restrictions[data-v-6c0f179e] {\n    padding: 16px;\n    display: inline-block;\n}\n.restrictions-block .restrictions .restriction[data-v-6c0f179e] {\n      padding-bottom: 12px;\n}\n.restrictions-block .restrictions .restriction[data-v-6c0f179e]:last-child {\n        padding-bottom: 0;\n}\n.restrictions-block .restrictions label[data-v-6c0f179e] {\n      padding-right: 48px;\n}\n.restrictions-block .restrictions label[data-v-6c0f179e]:last-child {\n        padding-right: 0;\n}\n.block-dots.top[data-v-6c0f179e] {\n  padding-top: 12px;\n}\n.block-dots.bottom[data-v-6c0f179e] {\n  padding-bottom: 12px;\n}\n.block-dots .tooltip-wrp[data-v-6c0f179e] {\n  display: inline-block;\n}\n.block-dots .tooltip-wrp .tooltip[data-v-6c0f179e] {\n    display: none;\n    margin: 0;\n}\n.block-dots .tooltip-wrp .tooltip .tooltipvalue[data-v-6c0f179e] {\n      top: -52px;\n      left: 12px;\n      width: auto;\n      padding: 2px 12px;\n      transform: translateX(-50%);\n      margin-left: 0;\n}\n.block-dots .tooltip-wrp .file-dot[data-v-6c0f179e] {\n    margin: 4px;\n    width: 16px;\n    height: 16px;\n    border: 1px solid #00BDD1;\n    border-radius: 50%;\n    background-color: transparent;\n}\n.block-dots .tooltip-wrp .file-dot.selected[data-v-6c0f179e], .block-dots .tooltip-wrp .file-dot[data-v-6c0f179e]:hover {\n      background-color: #00BDD1;\n}\n.block-dots .tooltip-wrp .file-dot:hover + .tooltip[data-v-6c0f179e] {\n    display: block;\n}\n.tooltip-wrp[data-v-6c0f179e] {\n  position: relative;\n}\n.tooltip-wrp .tooltip[data-v-6c0f179e] {\n    position: relative;\n}\n.tooltip-wrp .tooltip .tooltipvalue[data-v-6c0f179e] {\n      position: absolute;\n      width: 40px;\n      text-align: center;\n      top: -20px;\n      margin-left: -20px;\n      background-color: #00BDD1;\n      border-radius: 12px;\n      color: #fff;\n}\n.tooltip-wrp .tooltip .tooltipvalue[data-v-6c0f179e]:after {\n        content: \"\";\n        position: absolute;\n        top: 100%;\n        left: 50%;\n        margin-left: -5px;\n        margin-top: -7px;\n        width: 10px;\n        height: 10px;\n        background-color: #00BDD1;\n        transform: rotate(45deg);\n        z-index: -1;\n}\n@media (min-width: 993px) {\n.container[data-v-6c0f179e] {\n    width: 85%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports
exports.i(__webpack_require__(412), "");
exports.i(__webpack_require__(411), "");
exports.push([module.i, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);", ""]);

// module
exports.push([module.i, "\n#rootDiv {\n  font-family: 'Libre-Franklin', sans-serif;\n}\n.bold {\n  font-weight: bold;\n}\n.startjob {\n  margin: 0;\n}\n.startjobtitle {\n  margin: 40px 12%;\n}\n.upspace {\n  margin-top: 30%;\n}\n.upsmallspace {\n  margin-top: 10%;\n}\n.buymodal {\n  height: 100%;\n  width: 100%;\n  margin: 0;\n}\n.my-dropdown-dd {\n  z-index: 10;\n}\n.buymodalblue {\n  background-color: #06E9F4;\n}\n.a3dbg {\n  background-color: #00BDD1;\n}\n.a3dlightgray {\n  background-color: #F2F2F2;\n}\n.a3d {\n  font-family: 'Libre-Franklin', sans-serif;\n}\n.a3d.color {\n    color: #06E9F4;\n}\n.a3d.btn {\n    border-radius: 0;\n    text-transform: none;\n    font-weight: bold;\n    box-shadow: 0 0 0;\n    background-color: #00BDD1;\n}\n.a3d.btn.small {\n      height: auto;\n      line-height: 1;\n      padding: 0.5em 1em;\n      font-size: 0.8em;\n}\n.a3d.btn:hover {\n      background-color: #06E9F4;\n}\n.a3d.btn.inv {\n      border: 1px solid #00BDD1;\n      background-color: #FFFFFF;\n      color: #00BDD1;\n}\n.a3d.btn.inv:hover {\n        border-color: #06E9F4;\n        background-color: #FFFFFF;\n        color: #06E9F4;\n}\n.a3d.btn.inv.dark {\n        background: inherit;\n        border-color: black;\n        color: black;\n}\n.a3d.btn.inv.dark:hover {\n          background-color: #00BDD1;\n}\n.a3d.logo {\n    display: block;\n    width: 150px;\n    height: 100%;\n}\n.a3d.bell {\n    margin: 20px;\n    height: 20px;\n    display: block;\n}\n.a3d.splash {\n    margin-top: 15%;\n}\n.tooltip-wrp {\n  position: relative;\n}\n.tooltip-wrp .tooltip {\n    margin: 0 8px;\n    position: relative;\n}\n.tooltip-wrp .tooltip .tooltipvalue {\n      position: absolute;\n      width: 40px;\n      text-align: center;\n      top: -20px;\n      margin-left: -20px;\n      background-color: #00BDD1;\n      border-radius: 12px;\n      color: #fff;\n      white-space: nowrap;\n      z-index: 0;\n}\n.tooltip-wrp .tooltip .tooltipvalue:after {\n        content: \"\";\n        position: absolute;\n        top: 100%;\n        left: 50%;\n        margin-left: -5px;\n        margin-top: -7px;\n        width: 10px;\n        height: 10px;\n        background-color: #00BDD1;\n        transform: rotate(45deg);\n        z-index: -1;\n}\ninput[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background-color: #00BDD1;\n  cursor: pointer;\n  margin-top: -7px;\n}\ninput[type=\"range\"]::-moz-range-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background-color: #00BDD1;\n  cursor: pointer;\n  margin-top: -7px;\n}\ninput[type=\"range\"]::-ms-tooltip {\n  display: none;\n}\ninput[type=\"range\"]::-ms-thumb {\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background-color: #00BDD1;\n  cursor: pointer;\n  top: -4px;\n}\ninput[type=\"range\"] {\n  border: none;\n  height: 30px;\n  margin: 0;\n}\ninput[type=\"checkbox\"].filled-in:checked + label:after {\n  border-color: #00BDD1;\n  background-color: #00BDD1;\n}\nnav.a3d {\n  background-color: #333333;\n}\ni.material-icons.a3d {\n  font-family: 'Material Icons' !important;\n}\n.progress .indeterminate, .progress .determinate {\n  background-color: #00BDD1;\n}\n.v--modal-box {\n  overflow: auto !important;\n  max-height: 90vh;\n}\n.c > input[type=checkbox] {\n  position: inherit !important;\n  opacity: 1 !important;\n  pointer-events: auto;\n}\n.c > div > input {\n  height: 1rem !important;\n}\n.c > select {\n  display: inherit;\n  color: #000;\n  height: auto;\n  padding: 0;\n}\n.c > select:disabled {\n    background-color: #c5c5c5;\n}\nhtml, body, #rootDiv {\n  /*height: 100%;*/\n}\n", ""]);

// exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n.container .a3d.btn[data-v-7055ef20] {\n  white-space: nowrap;\n  min-width: 170px;\n}\n.container .a3d.btn.multiline[data-v-7055ef20] {\n    white-space: normal;\n    height: auto;\n    line-height: 26px;\n}\n.container .block-title[data-v-7055ef20] {\n  text-transform: uppercase;\n  font-size: 20px;\n}\n.container .block-button[data-v-7055ef20] {\n  padding-bottom: 16px;\n}\n.container .error[data-v-7055ef20] {\n  color: #ff0000;\n}\n.container .row .status-message[data-v-7055ef20] {\n  font-size: 1.6rem;\n}\n.container .blocks-wrp[data-v-7055ef20] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.container .blocks-wrp label[data-v-7055ef20] {\n    color: inherit;\n}\n.container .blocks-wrp .divider-block[data-v-7055ef20] {\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n    padding-top: 20px;\n}\n.container .blocks-wrp .block-full-width[data-v-7055ef20] {\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n}\n.container .blocks-wrp .block-wrp[data-v-7055ef20] {\n    width: 50%;\n    -ms-flex-item-align: stretch;\n        -ms-grid-row-align: stretch;\n        align-self: stretch;\n    padding: 16px;\n}\n.container .blocks-wrp .block-wrp.block-wrp-33[data-v-7055ef20] {\n      width: 33.33%;\n}\n.container .blocks-wrp .block-wrp.block-wrp-100[data-v-7055ef20] {\n      width: 100%;\n}\n.container .blocks-wrp .block-wrp.block-wrp__flex[data-v-7055ef20] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.container .blocks-wrp .block-wrp.with-image[data-v-7055ef20] {\n      display: -ms-flexbox;\n      display: flex;\n}\n.container .blocks-wrp .block-wrp #uploadsupports[data-v-7055ef20] {\n      display: none;\n}\n.container .blocks-wrp .block-wrp .block-image[data-v-7055ef20] {\n      width: 200px;\n      min-width: 120px;\n      background-color: #F2F2F2;\n      padding: 20px 0 0 10px;\n}\n.container .blocks-wrp .block-wrp .block-image img[data-v-7055ef20] {\n        width: 100%;\n}\n.container .blocks-wrp .block-wrp .block-input.block-input__half[data-v-7055ef20] {\n      margin-bottom: 10px;\n}\n.container .blocks-wrp .block-wrp .block-input.block-input__half[data-v-7055ef20]:last-child {\n        margin: 0;\n        height: fit-content;\n}\n.container .blocks-wrp .block-wrp .block-input[data-v-7055ef20] {\n      width: 100%;\n      height: 100%;\n      background-color: #F2F2F2;\n      padding: 24px;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-direction: column;\n          flex-direction: column;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.container .blocks-wrp .block-wrp .block-input .upload-supports[data-v-7055ef20] {\n        padding-bottom: 8px;\n}\n.container .blocks-wrp .block-wrp .block-input .block-support[data-v-7055ef20] {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n        padding-top: 12px;\n}\n.container .blocks-wrp .block-wrp .block-input .block-support .a3d.btn[data-v-7055ef20] {\n          width: 150px;\n          min-width: 150px;\n}\n.container .blocks-wrp .block-wrp .block-input .support-checkboxes[data-v-7055ef20] {\n        max-width: 300px;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n            flex-direction: column;\n        -ms-flex-item-align: center;\n            align-self: center;\n}\n.container .blocks-wrp .block-wrp .block-input .block-description[data-v-7055ef20] {\n        text-align: justify;\n}\n.container .blocks-wrp .block-wrp .block-input .block-alert[data-v-7055ef20] {\n        margin: 8px 0;\n        padding: 12px;\n        background-color: #fff;\n        text-align: justify;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value[data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range[data-v-7055ef20] {\n        padding-top: 24px;\n        text-align: left;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: row;\n            flex-direction: row;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value .icon-remove[data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range .icon-remove[data-v-7055ef20] {\n          padding-top: 9px;\n          padding-right: 9px;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value label[data-v-7055ef20]:after, .container .blocks-wrp .block-wrp .block-input .block-value-range label[data-v-7055ef20]:after {\n          background-color: #00BDD1;\n          border-color: #00BDD1;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value.column[data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range.column[data-v-7055ef20] {\n          -ms-flex-direction: column;\n              flex-direction: column;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value input[type=\"number\"][data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value input[type=\"text\"][data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range input[type=\"number\"][data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range input[type=\"text\"][data-v-7055ef20] {\n          box-sizing: border-box;\n          background-color: #fff;\n          padding: 0 12px;\n          margin: 0;\n          -ms-flex: 8;\n              flex: 8;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value input[type=\"range\"][data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range input[type=\"range\"][data-v-7055ef20] {\n          -ms-flex: 3;\n              flex: 3;\n          border: none;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value [type=\"radio\"]:not(:checked) + label[data-v-7055ef20],\n        .container .blocks-wrp .block-wrp .block-input .block-value [type=\"radio\"]:checked + label[data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range [type=\"radio\"]:not(:checked) + label[data-v-7055ef20],\n        .container .blocks-wrp .block-wrp .block-input .block-value-range [type=\"radio\"]:checked + label[data-v-7055ef20] {\n          min-height: 25px;\n          height: auto;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value .field-name[data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range .field-name[data-v-7055ef20] {\n          -ms-flex: 1;\n              flex: 1;\n          font-weight: bold;\n          font-size: 22px;\n          padding-top: 1px;\n          padding-right: 5px;\n          min-width: 36px;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value .field-name.small[data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range .field-name.small[data-v-7055ef20] {\n            font-size: 16px;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value .unit[data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range .unit[data-v-7055ef20] {\n          -ms-flex: 1;\n              flex: 1;\n          padding-left: 16px;\n          font-size: 22px;\n          font-weight: bold;\n          white-space: nowrap;\n          line-height: 42px;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value .unit.first[data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range .unit.first[data-v-7055ef20] {\n            padding-right: 16px;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value .unit.label[data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range .unit.label[data-v-7055ef20] {\n            padding-left: 0;\n            padding-right: 16px;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value.select[data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range.select[data-v-7055ef20] {\n          z-index: 10;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value.select .menu .btn[data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range.select .menu .btn[data-v-7055ef20] {\n            height: 52px;\n            line-height: 36px;\n            padding: 6px 1rem 0 1rem;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value.select .select-icon[data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range.select .select-icon[data-v-7055ef20] {\n            display: inline-block;\n            padding-right: 12px;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value.select .select-icon img[data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range.select .select-icon img[data-v-7055ef20] {\n              max-height: 36px;\n              width: auto;\n              border-radius: 50%;\n}\n.container .blocks-wrp .block-wrp .block-input .block-value.select .select-text[data-v-7055ef20], .container .blocks-wrp .block-wrp .block-input .block-value-range.select .select-text[data-v-7055ef20] {\n            display: inline-block;\n            vertical-align: top;\n}\n.container .blocks-wrp .block-wrp .block-input .block-buttons[data-v-7055ef20] {\n        padding-top: 12px;\n}\n.container .blocks-wrp .block-wrp .block-support-input input[type=number][data-v-7055ef20] {\n      -ms-flex: 3;\n          flex: 3;\n}\n.container .blocks-wrp .block-wrp .block-support-input .block-value-range[data-v-7055ef20] {\n      -ms-flex-align: center;\n          align-items: center;\n}\n.container .blocks-wrp .block-wrp .block-support-input .block-value-range .field-name[data-v-7055ef20] {\n        min-width: 72px;\n}\n.container .blocks-wrp .block-wrp .block-support-input .block-value-range input[type=\"number\"][data-v-7055ef20] {\n        max-width: 72px;\n}\n.container .blocks-wrp .block-wrp .block-support-input .block-value-range .tooltip-wrp[data-v-7055ef20] {\n        -ms-flex: 3;\n            flex: 3;\n}\n.container .blocks-wrp .block-checkbox[data-v-7055ef20] {\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n    padding-bottom: 12px;\n}\n.container .blocks-wrp .block-dots[data-v-7055ef20] {\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n}\n.container .blocks-wrp .block-dots.top[data-v-7055ef20] {\n      padding-top: 12px;\n}\n.container .blocks-wrp .block-dots.bottom[data-v-7055ef20] {\n      padding-bottom: 12px;\n}\n.container .blocks-wrp .block-dots .tooltip-wrp[data-v-7055ef20] {\n      display: inline-block;\n}\n.container .blocks-wrp .block-dots .tooltip-wrp .tooltip[data-v-7055ef20] {\n        display: none;\n        margin: 0;\n}\n.container .blocks-wrp .block-dots .tooltip-wrp .tooltip .tooltipvalue[data-v-7055ef20] {\n          top: -52px;\n          left: 12px;\n          width: auto;\n          padding: 2px 12px;\n          transform: translateX(-50%);\n          margin-left: 0;\n}\n.container .blocks-wrp .block-dots .tooltip-wrp .file-dot[data-v-7055ef20] {\n        margin: 4px;\n        width: 16px;\n        height: 16px;\n        border: 1px solid #00BDD1;\n        border-radius: 50%;\n        background-color: transparent;\n}\n.container .blocks-wrp .block-dots .tooltip-wrp .file-dot.selected[data-v-7055ef20], .container .blocks-wrp .block-dots .tooltip-wrp .file-dot[data-v-7055ef20]:hover {\n          background-color: #00BDD1;\n}\n.container .blocks-wrp .block-dots .tooltip-wrp .file-dot:hover + .tooltip[data-v-7055ef20] {\n        display: block;\n}\n.container .startjobor .file-name[data-v-7055ef20] {\n  color: #06E9F4;\n  margin-top: 0;\n  word-break: break-all;\n}\n.container .startjobor .title[data-v-7055ef20] {\n  padding-top: 32px;\n  text-transform: uppercase;\n}\n.container .init-settings[data-v-7055ef20] {\n  padding: 0;\n  display: -ms-flexbox;\n  display: flex;\n}\n.container .init-settings .settings-block[data-v-7055ef20] {\n    border: 1px solid #c3c3c3;\n    padding: 24px;\n}\n.container .init-settings .settings-block[data-v-7055ef20]:last-child {\n      border-left: none;\n}\n.container .init-settings .settings-block .alert[data-v-7055ef20] {\n      padding-top: 20px;\n      font-size: 0.9em;\n      font-weight: bold;\n}\n.container .jobSpec[data-v-7055ef20] {\n  padding-top: 20px;\n  margin-bottom: 0;\n}\n.container .jobSpec .col.s12[data-v-7055ef20] {\n    padding-bottom: 8px;\n}\n.container .jobSpec label[data-v-7055ef20] {\n    color: inherit;\n}\na[data-v-7055ef20] {\n  cursor: pointer;\n}\n#uploadfile[data-v-7055ef20] {\n  display: none;\n}\na.a3d.btn[data-v-7055ef20] {\n  width: 100%;\n}\n.menu-list .material-icons[data-v-7055ef20] {\n  position: absolute;\n  left: 4px;\n  cursor: pointer;\n}\n.caution-modal[data-v-7055ef20] {\n  padding: 20px;\n}\n.caution-modal .text-block[data-v-7055ef20] {\n    text-align: justify;\n    padding-bottom: 20px;\n}\n.caution-modal .row[data-v-7055ef20] {\n    margin-bottom: 0;\n}\n@media (max-width: 992px) {\n.container .init-settings[data-v-7055ef20] {\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n.container .init-settings .settings-block[data-v-7055ef20]:last-child {\n      border-top: none;\n      border-left: 1px solid #c3c3c3;\n}\n}\n@media (max-width: 768px) {\n.container .a3d.btn[data-v-7055ef20] {\n    min-width: 120px;\n}\n.container .block-title[data-v-7055ef20] {\n    font-size: 18px;\n}\n.container .blocks-wrp .block-wrp[data-v-7055ef20] {\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n.modal-block.danger .modal-content-header[data-v-788e9811] {\n  background-color: #fccccc;\n}\n.modal-block .modal-content-header[data-v-788e9811] {\n  font-weight: bold;\n}\n.modal-block .modal-content-header[data-v-788e9811], .modal-block .modal-content[data-v-788e9811] {\n  padding: 12px;\n}\n.modal-block .modal-content .buttons-block[data-v-788e9811] {\n  padding-top: 12px;\n}\n.modal-block .modal-content .details-block .details-button a[data-v-788e9811] {\n  cursor: pointer;\n}\n.modal-block .modal-content .details-block .details[data-v-788e9811] {\n  padding: 4px 8px;\n  background-color: #F2F2F2;\n  border: 1px solid #c3c3c3;\n  word-break: break-all;\n  max-height: 400px;\n  overflow: auto;\n}\n", ""]);

// exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n.onboard-title[data-v-79d2a423] {\n  padding-top: 20px;\n}\n.form-wrapper[data-v-79d2a423] {\n  padding: 40px 0 80px;\n  max-width: 500px;\n  margin: 0 auto;\n}\n.nav-wrapper[data-v-79d2a423] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  min-height: 64px;\n  height: auto;\n}\n[type=\"checkbox\"] + label[data-v-79d2a423] {\n  color: black;\n  height: auto;\n}\n[type=\"checkbox\"].filled-in + label[data-v-79d2a423]:after, [type=\"checkbox\"].filled-in + label[data-v-79d2a423]:before {\n  top: 15px;\n}\n\n", ""]);

// exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n.trial[data-v-8b602f5c] {\n  padding-top: 5%;\n}\n.trial .responsive-img[data-v-8b602f5c] {\n    max-width: 400px;\n    margin: 0 30px;\n}\n.trial .form-block[data-v-8b602f5c], .trial .description[data-v-8b602f5c] {\n    min-width: 400px;\n}\n.trial .description[data-v-8b602f5c] {\n    max-width: 80%;\n    margin: 0 auto;\n}\n.trial .description strong[data-v-8b602f5c] {\n      font-weight: 600;\n}\n.trial .form-title[data-v-8b602f5c] {\n    font-size: 1.1rem;\n}\n.trial .form-block[data-v-8b602f5c] {\n    max-width: 50%;\n    background-color: #F2F2F2;\n    padding: 15px;\n    margin: 15px auto 30px;\n}\n.trial .form-block .label[data-v-8b602f5c] {\n      padding: 4px 0;\n}\n.trial .form-block input[data-v-8b602f5c] {\n      background-color: #FFFFFF;\n}\n.trial .buttons-block button[data-v-8b602f5c] {\n    margin: 0 2px;\n}\n.trial .error[data-v-8b602f5c] {\n    color: #FF0000;\n}\n", ""]);

// exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\na[data-v-8cfe374a] {\n  cursor: pointer;\n}\n.responsive-img[data-v-8cfe374a] {\n  max-width: 400px;\n  margin: 0 30px;\n}\n.reset-password-message[data-v-8cfe374a] {\n  padding: 20px 20px 10px;\n  background: rgb(255, 220, 220);\n  border: 2px solid rgb(255, 100, 100);\n  border-radius: 20px;\n  font-weight: 600;\n  max-width: 660px;\n  margin: 50px auto 0;\n  text-align: justify;\n}\n.reset-password-message > ul > li[data-v-8cfe374a] {\n  list-style-type: disc;\n  margin-left: 40px;\n}\n", ""]);

// exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n.progress[data-v-a5456eb0] {\n  background-color: #06E9F4;\n}\n.progress .indeterminate[data-v-a5456eb0] {\n    background-color: #00BDD1;\n}\n.buymodal[data-v-a5456eb0] {\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n  padding: 50px 14px;\n  height: unset;\n}\n.buymodal .subscription-title[data-v-a5456eb0] {\n    font-weight: bold;\n    font-size: 2em;\n    vertical-align: middle;\n}\n.buymodal .subscription-subtitle[data-v-a5456eb0] {\n    font-size: 1em;\n    vertical-align: middle;\n    padding-bottom: 30px;\n}\n.buymodal .subscription-price[data-v-a5456eb0] {\n    font-weight: bold;\n    vertical-align: middle;\n}\n.buymodal .subscription-price .subscription-price-amount[data-v-a5456eb0] {\n      font-size: 3em;\n}\n.buymodal .subscription-price .subscription-price-sign[data-v-a5456eb0] {\n      font-size: 2.5em;\n      vertical-align: top;\n}\n.buymodal .subscription-price .subscription-price-per[data-v-a5456eb0] {\n      font-size: 1.5em;\n}\n", ""]);

// exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n#uploadfile[data-v-c4e0099a] {\n  display: none;\n}\n.files-preloader[data-v-c4e0099a] {\n  padding: 128px;\n}\n.pagination .active[data-v-c4e0099a] {\n  background-color: #00BDD1;\n}\n.pagination .skip[data-v-c4e0099a] {\n  font-weight: bold;\n  line-height: 30px;\n}\n.a3d.file[data-v-c4e0099a] {\n  position: relative;\n  margin: 0.5em 0;\n  padding: 1em;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 100%;\n  background-color: #F2F2F2;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.a3d.file .progress[data-v-c4e0099a] {\n    position: absolute;\n    bottom: 0px;\n    left: 0px;\n    margin-bottom: 0px;\n}\n.a3d.file .material-icons.a3d[data-v-c4e0099a] {\n    display: -ms-flexbox;\n    display: flex;\n}\n.a3d.file .file-error[data-v-c4e0099a] {\n    color: #ff0000;\n    font-size: 14px;\n    font-weight: bold;\n    text-align: center;\n}\n.a3d.jobout[data-v-c4e0099a] {\n  margin: 0.5em 0;\n  padding: 1em;\n  background-color: #F2F2F2;\n  width: 100%;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.a3d.job-status[data-v-c4e0099a] {\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.a3d.job-status .job-status-message[data-v-c4e0099a] {\n    -ms-flex-item-align: start;\n        align-self: flex-start;\n}\n.a3d.jobs[data-v-c4e0099a] {\n  background-color: #F2F2F2;\n}\n.a3d.job[data-v-c4e0099a] {\n  background-color: #FFFFFF;\n  display: -ms-flexbox;\n  display: flex;\n}\n.a3d.job .message[data-v-c4e0099a] {\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    padding: 1em 0;\n}\n.a3d.align-right[data-v-c4e0099a] {\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n}\n.a3d .toggleIcon[data-v-c4e0099a] {\n  padding-left: 16px;\n  cursor: pointer;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n}\n.a3d .jobout-buttons[data-v-c4e0099a] {\n  padding-top: 1px;\n  margin-left: 24px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex: 2;\n      flex: 2;\n}\n.a3d .jobout-buttons .jobout-buttons-row[data-v-c4e0099a] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n    padding-bottom: 6px;\n}\n.a3d .jobout-buttons .jobout-buttons-row .btn[data-v-c4e0099a] {\n      margin: auto 0 auto 6px;\n}\n#files-root[data-v-c4e0099a] {\n  height: 100%;\n  margin-top: -64px;\n  padding-top: 64px;\n}\n#section-body[data-v-c4e0099a] {\n  height: 100%;\n  margin-top: -120px;\n  padding-top: 120px;\n  margin-bottom: 0;\n}\n#section-body > div[data-v-c4e0099a] {\n    height: 100%;\n}\n#section-body .row.flex[data-v-c4e0099a] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: start;\n        justify-content: flex-start;\n}\n#section-body .files .upload[data-v-c4e0099a] {\n    padding: 0.5em 1em;\n    margin-left: 1em;\n}\n#section-body .files .create-nested[data-v-c4e0099a] {\n    margin-left: auto;\n}\n#section-body .files .error[data-v-c4e0099a] {\n    padding: 0.5em 0 1em 0;\n    color: #ff0000;\n}\n#section-body .files .no-files[data-v-c4e0099a] {\n    padding: 1em;\n}\n#section-body .files .load-files[data-v-c4e0099a] {\n    margin-bottom: 0.5em;\n}\n#section-body .file [type=\"checkbox\"].filled-in + label[data-v-c4e0099a] {\n    padding-left: 24px;\n}\n#section-body .file [type=\"checkbox\"].filled-in:checked + label[data-v-c4e0099a]:after {\n    border-color: #00BDD1;\n    background-color: #00BDD1;\n}\n#section-body .file-name-block[data-v-c4e0099a] {\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n#section-body .file-name-block .file-name[data-v-c4e0099a] {\n      word-break: break-all;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n      font-size: 1.3em;\n      font-weight: bold;\n      padding-right: 4px;\n}\n#section-body .file-name-block .file-date[data-v-c4e0099a] {\n      font-size: 14px;\n}\n#section-body .file-name-nested[data-v-c4e0099a] {\n    word-break: break-all;\n    -ms-flex: 2;\n        flex: 2;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n}\n#section-body .button-block[data-v-c4e0099a] {\n    display: -ms-flexbox;\n    display: flex;\n    text-align: right;\n    min-width: 120px;\n    -ms-flex-pack: end;\n        justify-content: flex-end;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex: 4;\n        flex: 4;\n}\n#section-body .button-block .btn[data-v-c4e0099a] {\n      margin-left: 4px;\n}\n#section-body .button-block .btn i[data-v-c4e0099a] {\n        font-size: 0.9rem;\n}\n#section-body .button-block .menu .btn[data-v-c4e0099a] {\n      width: 100%;\n      margin-bottom: 0 !important;\n}\n.prompt-modal[data-v-c4e0099a] {\n  padding: 20px;\n}\n.prompt-modal .row[data-v-c4e0099a] {\n    margin-bottom: 0;\n}\n.prompt-modal .title[data-v-c4e0099a] {\n    font-size: 1.4em;\n    text-align: center;\n    padding-bottom: 20px;\n}\n.prompt-modal .modal-content[data-v-c4e0099a] {\n    padding-bottom: 12px;\n}\n.repair-form .block-input-wrp[data-v-c4e0099a] {\n  margin-bottom: 20px;\n}\n.repair-form .block-input-wrp .block-input[data-v-c4e0099a] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n}\n.repair-form .block-input-wrp .block-input .block-description[data-v-c4e0099a] {\n      margin-bottom: 2px;\n      -ms-flex: 1;\n          flex: 1;\n}\n.repair-form .block-input-wrp .block-input .block-value[data-v-c4e0099a] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-direction: row;\n          flex-direction: row;\n      padding-left: 10px;\n      -ms-flex: 1;\n          flex: 1;\n}\n.repair-form .block-input-wrp .block-input .block-value input[data-v-c4e0099a] {\n        margin: 0;\n}\n.repair-form .block-input-wrp .block-input .block-value .unit[data-v-c4e0099a] {\n        padding-left: 10px;\n        font-weight: bold;\n        font-size: 22px;\n}\n.repair-form .block-input-wrp .block-note[data-v-c4e0099a] {\n    font-size: 12px;\n    padding-top: 5px;\n}\n.repair-form .block-input-wrp .error[data-v-c4e0099a] {\n    font-size: 12px;\n    color: #ff0000;\n}\n@media (max-width: 1400px) {\n#section-body .jobs .jobfile .button-block[data-v-c4e0099a] {\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n#section-body .jobs .jobfile .button-block .btn[data-v-c4e0099a] {\n      margin-bottom: 4px;\n}\n}\n@media (max-width: 1200px) {\n#section-body .files .button-block[data-v-c4e0099a] {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-align: stretch;\n        align-items: stretch;\n    -ms-flex: 1;\n        flex: 1;\n}\n#section-body .files .button-block .btn[data-v-c4e0099a] {\n      margin-bottom: 4px;\n}\n#section-body .files .button-block .btn[data-v-c4e0099a]:last-child {\n        margin-bottom: 0px;\n}\n}\n@media (max-width: 992px) {\n#section-body .files[data-v-c4e0099a], #section-body .jobs[data-v-c4e0099a] {\n    width: 100%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\n.spinner[data-v-ee81178e] {\n  position: absolute;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 100vh;\n  width: 100vw;\n  background-color: white;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.spinner img[data-v-ee81178e] {\n    width: 120px;\n    height: 120px;\n    animation: spin 1000ms linear infinite;\n}\n@keyframes spin {\n100% {\n    transform: rotate(360deg);\n}\n}\n", ""]);

// exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "\na[data-v-f70131b6] {\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/support-fs.1439dda.png";

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/support-wl.53373b8.png";

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Bold.eed9aab.woff";

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Bold.c0f1e4a.woff2";

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Light.ea36cd9.woff";

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Light.3c37aa6.woff2";

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Medium.cf4d60b.woff";

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Medium.1561b42.woff2";

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Regular.3cf6adf.woff";

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Regular.5136cbe.woff2";

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Thin.44b78f1.woff";

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Roboto-Thin.1f35e6a.woff2";

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(517)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(494),
  /* scopeId */
  "data-v-ee81178e",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Callback.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Callback.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ee81178e", Component.options)
  } else {
    hotAPI.reload("data-v-ee81178e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(510)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(487),
  /* scopeId */
  "data-v-7055ef20",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Create.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Create.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7055ef20", Component.options)
  } else {
    hotAPI.reload("data-v-7055ef20", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(502)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(479),
  /* scopeId */
  "data-v-3907c46c",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/CreateForm/SupportCanvas.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SupportCanvas.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3907c46c", Component.options)
  } else {
    hotAPI.reload("data-v-3907c46c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(505)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(482),
  /* scopeId */
  "data-v-3f482306",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Dash.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Dash.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3f482306", Component.options)
  } else {
    hotAPI.reload("data-v-3f482306", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(498)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(474),
  /* scopeId */
  "data-v-18d6d9ee",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/EstimateCost.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EstimateCost.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-18d6d9ee", Component.options)
  } else {
    hotAPI.reload("data-v-18d6d9ee", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(493),
  /* scopeId */
  "data-v-c4e0099a",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Files.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Files.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c4e0099a", Component.options)
  } else {
    hotAPI.reload("data-v-c4e0099a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(484),
  /* scopeId */
  "data-v-49a3b049",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Files/FileOutput.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FileOutput.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-49a3b049", Component.options)
  } else {
    hotAPI.reload("data-v-49a3b049", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(495),
  /* scopeId */
  "data-v-f70131b6",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Login.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Login.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f70131b6", Component.options)
  } else {
    hotAPI.reload("data-v-f70131b6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(506)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(483),
  /* scopeId */
  "data-v-414352eb",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Nested.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Nested.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-414352eb", Component.options)
  } else {
    hotAPI.reload("data-v-414352eb", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(488),
  /* scopeId */
  "data-v-788e9811",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Notifications/Alert.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Alert.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-788e9811", Component.options)
  } else {
    hotAPI.reload("data-v-788e9811", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(512)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(489),
  /* scopeId */
  "data-v-79d2a423",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Onboard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Onboard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-79d2a423", Component.options)
  } else {
    hotAPI.reload("data-v-79d2a423", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(491),
  /* scopeId */
  "data-v-8cfe374a",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Splash.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Splash.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8cfe374a", Component.options)
  } else {
    hotAPI.reload("data-v-8cfe374a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(485),
  /* scopeId */
  "data-v-6c0f179e",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Start.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Start.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6c0f179e", Component.options)
  } else {
    hotAPI.reload("data-v-6c0f179e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(490),
  /* scopeId */
  "data-v-8b602f5c",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Trial.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Trial.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8b602f5c", Component.options)
  } else {
    hotAPI.reload("data-v-8b602f5c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(499)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(475),
  /* scopeId */
  "data-v-25c81e86",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/Viewer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Viewer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25c81e86", Component.options)
  } else {
    hotAPI.reload("data-v-25c81e86", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(476),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/WebGLDetect.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] WebGLDetect.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-32e5de78", Component.options)
  } else {
    hotAPI.reload("data-v-32e5de78", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "estimate-cost",
    attrs: {
      "name": "estimate-cost",
      "height": "auto",
      "width": _vm.isCompare ? 1160 : 600,
      "pivotY": 0.2,
      "pivotX": 0.5
    },
    on: {
      "before-open": _vm.beforeOpen,
      "opened": _vm.opened
    }
  }, [(_vm.modalLoading) ? [_c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "preloader-wrapper small active"
  }, [_c('div', {
    staticClass: "spinner-layer"
  }, [_c('div', {
    staticClass: "circle-clipper left"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gap-patch"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-clipper right"
  }, [_c('div', {
    staticClass: "circle"
  })])])])])] : [(_vm.isCompare) ? _c('div', {
    staticClass: "modal-content compare-mode"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("Estimate Print Costs Comparison")]), _vm._v(" "), _c('form', {
    staticClass: "modal-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-field col s6 cost"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.costPerHour),
      expression: "formData.costPerHour"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "name": "costPerHour",
      "id": "costPerHour"
    },
    domProps: {
      "value": (_vm.formData.costPerHour)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "costPerHour", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "costPerHour"
    }
  }, [_vm._v("Cost per Print Hour")])]), _vm._v(" "), _c('div', {
    staticClass: "input-field col s6 cost"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.costPerKg),
      expression: "formData.costPerKg"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "name": "costPerKg",
      "id": "costPerKg"
    },
    domProps: {
      "value": (_vm.formData.costPerKg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "costPerKg", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "costPerKg"
    }
  }, [_vm._v("Cost per kg")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "radio-group col s6"
  }, [_c('div', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.multiplier),
      expression: "formData.multiplier"
    }],
    attrs: {
      "type": "radio",
      "name": "multiplier",
      "id": "multiplier"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.formData.multiplier, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.formData, "multiplier", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "multiplier"
    }
  }, [_vm._v("\n                                Multiplier\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.multiplier),
      expression: "formData.multiplier"
    }],
    attrs: {
      "type": "radio",
      "name": "multiplier",
      "id": "flat"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.formData.multiplier, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.formData, "multiplier", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "flat"
    }
  }, [_vm._v("\n                                Flat Dollar Amount\n                            ")])])]), _vm._v(" "), (_vm.formData.multiplier) ? _c('div', {
    staticClass: "input-field col s6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.overhead),
      expression: "formData.overhead"
    }],
    attrs: {
      "type": "number",
      "name": "overhead",
      "id": "overhead",
      "step": "0.1",
      "min": "0"
    },
    domProps: {
      "value": (_vm.formData.overhead)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "overhead", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "overhead"
    }
  }, [_vm._v("Overhead and Profit")])]) : _vm._e(), _vm._v(" "), (!_vm.formData.multiplier) ? _c('div', {
    staticClass: "input-field col s6 cost"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.overheadFlat),
      expression: "formData.overheadFlat"
    }],
    attrs: {
      "type": "number",
      "name": "overheadFlat",
      "id": "overheadFlat",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.formData.overheadFlat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "overheadFlat", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "overhead"
    }
  }, [_vm._v("Overhead and Profit")])]) : _vm._e(), _vm._v(" "), (_vm.validationError) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n                        " + _vm._s(_vm.validationError) + "\n                    ")]) : _vm._e()]), _vm._v(" "), (_vm.estimates.length) ? [_c('div', {
    staticClass: "row col"
  }, [_c('table', {
    staticClass: "estimate-table"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Filename")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Objective Function")]), _vm._v(" "), _c('th', {
    staticClass: "distortion",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("Max Distortion, mm")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Material Required, kg")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Print Time, h")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Material Cost, $")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Time Cost, $")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Total Cost, $")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("On-supp")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Off-supp")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Stress")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "distortion"
  }, [_vm._v("X")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Y")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Z")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Normal")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("X")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Y")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Z")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Normal")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("X")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Y")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Z")]), _vm._v(" "), _c('th', {
    staticClass: "distortion"
  }, [_vm._v("Normal")])]), _vm._v(" "), _vm._l((_vm.estimates), function(estimate) {
    return _c('tr', {
      key: estimate.jobOutputPathKey,
      staticClass: "estimate-row"
    }, [_c('td', [_c('div', {
      staticClass: "file"
    }, [_c('i', {
      staticClass: "material-icons a3d color btn-delete-estimate",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteJobFromEstimate(estimate.jobOutputPathKey)
        }
      }
    }, [_vm._v("\n                                            clear\n                                        ")]), _vm._v(" "), _c('div', {
      staticClass: "filename"
    }, [_vm._v(_vm._s(estimate.filename))])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(estimate.objectiveFunc))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'on_x')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'on_y')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'on_z')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'on_normal')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'off_x')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'off_y')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'off_z')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'off_normal')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'stress_x')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'stress_y')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'stress_z')))]), _vm._v(" "), _c('td', {
      staticClass: "distortion"
    }, [_vm._v(_vm._s(_vm.formatDistortion(estimate.distortion, 'stress_normal')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(estimate.M_material).toFixed(3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(estimate.build_time).toFixed(3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalCostMaterialPerEstimate(estimate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalCostTimePerEstimate(estimate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.costPerEstimate(estimate)))])])
  })], 2)])] : _vm._e(), _vm._v(" "), _vm._l((_vm.nestedEstimates), function(estimate) {
    return [_c('div', {
      key: ("wrapper-" + (estimate.jobOutputPathKey)),
      staticClass: "row col"
    }, [_c('div', {
      key: ("name-" + (estimate.jobOutputPathKey)),
      staticClass: "nested-job-name"
    }, [_c('i', {
      staticClass: "material-icons a3d color btn-delete-estimate",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteJobFromEstimate(estimate.jobOutputPathKey)
        }
      }
    }, [_vm._v("\n                                clear\n                            ")]), _vm._v("\n                            " + _vm._s(estimate.filename) + "\n                        ")]), _vm._v(" "), _vm._l((estimate.plates), function(plate, index) {
      return [_c('div', {
        key: ("plate-number-" + index + "-" + (estimate.jobOutputPathKey)),
        staticClass: "nested-part-name"
      }, [_vm._v("Plate " + _vm._s(index + 1))]), _vm._v(" "), _c('table', {
        key: ("plate-" + index + "-" + (estimate.jobOutputPathKey)),
        staticClass: "estimate-table nested-table"
      }, [_c('tr', [_c('th', {
        attrs: {
          "rowspan": "2"
        }
      }, [_vm._v("Part")]), _vm._v(" "), _c('th', {
        attrs: {
          "rowspan": "2"
        }
      }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
        staticClass: "distortion",
        attrs: {
          "colspan": "3"
        }
      }, [_vm._v("On-plate distortion")]), _vm._v(" "), _c('th', {
        staticClass: "distortion",
        attrs: {
          "colspan": "3"
        }
      }, [_vm._v("Off-plate distortion")]), _vm._v(" "), _c('th', {
        attrs: {
          "rowspan": "2"
        }
      }, [_vm._v("Relative Completion Time, h")]), _vm._v(" "), _c('th', {
        attrs: {
          "rowspan": "2"
        }
      }, [_vm._v("Part max Z (mm)")]), _vm._v(" "), _c('th', {
        attrs: {
          "colspan": "4"
        }
      }, [_vm._v("X-Y Bounding Box (mm from 0,0)")])]), _vm._v(" "), _c('tr', [_c('th', {
        staticClass: "distortion"
      }, [_vm._v("X")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Y")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Z")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("X")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Y")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Z")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Min X")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Max X")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Min Y")]), _vm._v(" "), _c('th', {
        staticClass: "distortion"
      }, [_vm._v("Max Y")])]), _vm._v(" "), _vm._l((plate), function(part, partIndex) {
        return [_c('tr', {
          key: ("part-" + partIndex + "-" + (estimate.jobOutputPathKey))
        }, [_c('td', [_vm._v(_vm._s(part.filename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(part.count))]), _vm._v(" "), _c('td', {
          staticClass: "distortion"
        }, [_vm._v(_vm._s(_vm.formatDistortion(part.distortion, 'on_x')))]), _vm._v(" "), _c('td', {
          staticClass: "distortion"
        }, [_vm._v(_vm._s(_vm.formatDistortion(part.distortion, 'on_y')))]), _vm._v(" "), _c('td', {
          staticClass: "distortion"
        }, [_vm._v(_vm._s(_vm.formatDistortion(part.distortion, 'on_z')))]), _vm._v(" "), _c('td', {
          staticClass: "distortion"
        }, [_vm._v(_vm._s(_vm.formatDistortion(part.distortion, 'off_x')))]), _vm._v(" "), _c('td', {
          staticClass: "distortion"
        }, [_vm._v(_vm._s(_vm.formatDistortion(part.distortion, 'off_y')))]), _vm._v(" "), _c('td', {
          staticClass: "distortion"
        }, [_vm._v(_vm._s(_vm.formatDistortion(part.distortion, 'off_z')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((part.buildTime && part.buildTime[0].toFixed(3)) || part.build_time.toFixed(3)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(part.distortion.partMaxZ ? part.distortion.partMaxZ : part.distortion.partHeight + part.distortion.offsetZ))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(part.distortion.bounding_min[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(part.distortion.bounding_max[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(part.distortion.bounding_min[1]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(part.distortion.bounding_max[1]))])])]
      }), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', {
        staticClass: "plate-estimate"
      }, [_c('td', {
        attrs: {
          "colspan": "4"
        }
      }), _vm._v(" "), _c('th', {
        attrs: {
          "colspan": "4"
        }
      }, [_vm._v("Print Time, h:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(estimate.timePerPlate[index]).toFixed(3)))]), _vm._v(" "), _c('th', [_vm._v("Material Consumed, kg:")]), _vm._v(" "), _c('td', {
        attrs: {
          "colspan": "4"
        }
      }, [_vm._v(_vm._s(Number(estimate.materialPerPlate[index]).toFixed(3)))])])], 2)]
    }), _vm._v(" "), _c('div', {
      staticClass: "total-estimate"
    }, [_c('div', [_vm._v("Total Print Time:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(Number(estimate.build_time).toFixed(3)) + " h")]), _vm._v(" "), _c('div', [_vm._v("Total Material Consumed:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(Number(estimate.M_material).toFixed(3)) + " kg")]), _vm._v(" "), _c('div', [_vm._v("Total Cost for Nested Job:")]), _vm._v(" "), _c('div', [_vm._v("$ " + _vm._s(_vm.costPerEstimate(estimate)))])])], 2)]
  })], 2)]) : _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("Estimate Print Costs")]), _vm._v(" "), _c('form', {
    staticClass: "modal-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-field col s6"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "totalPrintTime",
      "id": "totalPrintTime",
      "disabled": ""
    },
    domProps: {
      "value": _vm.printTime
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "totalPrintTime"
    }
  }, [_vm._v("Total Print Time")])]), _vm._v(" "), _c('div', {
    staticClass: "input-field col s6 cost"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.costPerHour),
      expression: "formData.costPerHour"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "name": "costPerHour",
      "id": "costPerHour"
    },
    domProps: {
      "value": (_vm.formData.costPerHour)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "costPerHour", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "costPerHour"
    }
  }, [_vm._v("Cost per Print Hour")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-field col s6"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "totalMaterial",
      "id": "totalMaterial",
      "disabled": ""
    },
    domProps: {
      "value": _vm.totalMaterial
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "totalMaterial"
    }
  }, [_vm._v("Total Material Required")])]), _vm._v(" "), _c('div', {
    staticClass: "input-field col s6 cost"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.costPerKg),
      expression: "formData.costPerKg"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "name": "costPerKg",
      "id": "costPerKg"
    },
    domProps: {
      "value": (_vm.formData.costPerKg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "costPerKg", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "costPerKg"
    }
  }, [_vm._v("Cost per kg")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "radio-group col s6"
  }, [_c('div', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.multiplier),
      expression: "formData.multiplier"
    }],
    attrs: {
      "type": "radio",
      "name": "multiplier",
      "id": "multiplier"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.formData.multiplier, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.formData, "multiplier", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "multiplier"
    }
  }, [_vm._v("\n                                Multiplier\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.multiplier),
      expression: "formData.multiplier"
    }],
    attrs: {
      "type": "radio",
      "name": "multiplier",
      "id": "flat"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.formData.multiplier, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.formData, "multiplier", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "flat"
    }
  }, [_vm._v("\n                                Flat Dollar Amount\n                            ")])])]), _vm._v(" "), (_vm.formData.multiplier) ? _c('div', {
    staticClass: "input-field col s6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.overhead),
      expression: "formData.overhead"
    }],
    attrs: {
      "type": "number",
      "name": "overhead",
      "id": "overhead",
      "step": "0.1",
      "min": "0"
    },
    domProps: {
      "value": (_vm.formData.overhead)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "overhead", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "overhead"
    }
  }, [_vm._v("Overhead and Profit")])]) : _vm._e(), _vm._v(" "), (!_vm.formData.multiplier) ? _c('div', {
    staticClass: "input-field col s6 cost"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.overheadFlat),
      expression: "formData.overheadFlat"
    }],
    attrs: {
      "type": "number",
      "name": "overheadFlat",
      "id": "overheadFlat",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.formData.overheadFlat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "overheadFlat", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "active",
    attrs: {
      "for": "overhead"
    }
  }, [_vm._v("Overhead and Profit")])]) : _vm._e()]), _vm._v(" "), (_vm.validationError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "error"
  }, [_vm._v("\n                        " + _vm._s(_vm.validationError) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "total-label col s6"
  }, [_vm._v("Total Print Cost")]), _vm._v(" "), _c('div', {
    staticClass: "input-field col s6 cost total"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.totalCost),
      expression: "totalCost"
    }],
    attrs: {
      "type": "text",
      "name": "totalCost",
      "id": "totalCost",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.totalCost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totalCost = $event.target.value
      }
    }
  })])])])])]], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-18d6d9ee", module.exports)
  }
}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'loading-styles': _vm.creatingJob || _vm.loading3JS
    }
  }, [_c('div', {
    attrs: {
      "id": "inset"
    }
  }), _vm._v(" "), (_vm.creatingJob || _vm.loading3JS) ? _c('div', {
    staticClass: "preloader",
    class: {
      'overlay': _vm.showOverlay
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "text-align": "center"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _vm._m(0)])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.type === "input" && !this.isSupportUploaded) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contextMenu),
      expression: "contextMenu"
    }],
    ref: "cMenu",
    staticClass: "context-menu",
    style: ({
      'top': _vm.contextMenuPosY + 'px',
      'left': _vm.contextMenuPosX + 'px'
    })
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.cMenuParallel()
      }
    }
  }, [_vm._v("Make parallel to build plate")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.loading3JS || _vm.creatingJob) && !_vm.isSupportUploaded),
      expression: "!(loading3JS || creatingJob) && !isSupportUploaded"
    }],
    attrs: {
      "id": "info"
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [(!_vm.nestedMode) ? _c('span', [_vm._v("Check \"Support structures\" to generate support;")]) : _vm._e(), _vm._v("\n      Check \"Orient Model\" to scale and/or orient part.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.loading3JS || _vm.creatingJob) && !_vm.isSupportUploaded),
      expression: "!(loading3JS || creatingJob) && !isSupportUploaded"
    }],
    attrs: {
      "id": "bottom-legend"
    }
  }, [(!_vm.nestedMode) ? _c('div', {
    staticClass: "info-text"
  }, [_vm._v("To orient your part, simply grab anywhere around the part with your mouse and drag your mouse until you\n      have oriented it the way you would like. Dragging UP or DOWN will rotate the part about the screen's horizontal direction.\n      Dragging LEFT or RIGHT will rotate the part about the screen's vertical direction.")]) : _vm._e()])] : [_c('div', {
    staticClass: "bottom-block",
    class: {
      'single-legend': _vm.legends < 2
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.modifyMode) ? _c('div', {
    staticClass: "controls-box modify-supports"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Facets selection")]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.facetsSelection),
      expression: "facetsSelection"
    }],
    attrs: {
      "name": "facetsSelection",
      "type": "radio",
      "id": "restrictFace",
      "value": "restrict"
    },
    domProps: {
      "checked": _vm._q(_vm.facetsSelection, "restrict")
    },
    on: {
      "change": [function($event) {
        _vm.facetsSelection = "restrict"
      }, function($event) {
        return _vm.switchFacetSelectionMode('restrict')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "restrictFace"
    }
  }, [_vm._v("Remove Supports")])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.facetsSelection),
      expression: "facetsSelection"
    }],
    attrs: {
      "name": "facetsSelection",
      "type": "radio",
      "id": "allowFace",
      "value": "allow"
    },
    domProps: {
      "checked": _vm._q(_vm.facetsSelection, "allow")
    },
    on: {
      "change": [function($event) {
        _vm.facetsSelection = "allow"
      }, function($event) {
        return _vm.switchFacetSelectionMode('allow')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "allowFace"
    }
  }, [_vm._v("Add Support Structures")])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.facetsSelection),
      expression: "facetsSelection"
    }],
    attrs: {
      "name": "facetsSelection",
      "type": "radio",
      "id": "eraseFace",
      "value": "erase"
    },
    domProps: {
      "checked": _vm._q(_vm.facetsSelection, "erase")
    },
    on: {
      "change": [function($event) {
        _vm.facetsSelection = "erase"
      }, function($event) {
        return _vm.switchFacetSelectionMode('erase')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "eraseFace"
    }
  }, [_vm._v("Erase Support Modification")])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brushMode),
      expression: "brushMode"
    }],
    staticClass: "filled-in",
    attrs: {
      "name": "brushMode",
      "type": "checkbox",
      "id": "brushMode"
    },
    domProps: {
      "checked": Array.isArray(_vm.brushMode) ? _vm._i(_vm.brushMode, null) > -1 : (_vm.brushMode)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.brushMode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.brushMode = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.brushMode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.brushMode = $$c
        }
      }, function($event) {
        return _vm.switchBrushMode()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "brushMode"
    }
  }, [_vm._v("Brush Mode")])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brushBothSide),
      expression: "brushBothSide"
    }],
    staticClass: "filled-in",
    attrs: {
      "name": "brushBothSide",
      "type": "checkbox",
      "id": "brushBothSide"
    },
    domProps: {
      "checked": Array.isArray(_vm.brushBothSide) ? _vm._i(_vm.brushBothSide, null) > -1 : (_vm.brushBothSide)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.brushBothSide,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.brushBothSide = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.brushBothSide = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.brushBothSide = $$c
        }
      }, function($event) {
        return _vm.switchBrushSide()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "brushBothSide"
    }
  }, [_vm._v("Brush paints on both sides")])]), _vm._v(" "), (!_vm.brushMode) ? _c('div', {
    staticClass: "range-bar"
  }, [_c('div', {
    staticClass: "range-bar-slider"
  }, [_c('label', {
    attrs: {
      "for": "selectionTolerance"
    }
  }, [_vm._v("Tolerance")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectionTolerance),
      expression: "selectionTolerance"
    }],
    attrs: {
      "name": "selectionTolerance",
      "type": "range",
      "id": "selectionTolerance",
      "min": "0.1",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.selectionTolerance)
    },
    on: {
      "change": function($event) {
        return _vm.setSelectionTolerance($event)
      },
      "__r": function($event) {
        _vm.selectionTolerance = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "range-bar-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectionTolerance),
      expression: "selectionTolerance"
    }],
    attrs: {
      "type": "number",
      "min": "0.1",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.selectionTolerance)
    },
    on: {
      "change": function($event) {
        return _vm.setBrushRadius($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectionTolerance = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.brushMode) ? _c('div', {
    staticClass: "range-bar"
  }, [_c('div', {
    staticClass: "range-bar-slider"
  }, [_c('label', {
    attrs: {
      "for": "brushRadius"
    }
  }, [_vm._v("Brush Radius")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brushRadius),
      expression: "brushRadius"
    }],
    attrs: {
      "name": "brushRadius",
      "type": "range",
      "id": "brushRadius",
      "min": "0.1",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.brushRadius)
    },
    on: {
      "change": function($event) {
        return _vm.setBrushRadius($event)
      },
      "__r": function($event) {
        _vm.brushRadius = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "range-bar-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brushRadius),
      expression: "brushRadius"
    }],
    attrs: {
      "type": "number",
      "min": "0.1",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.brushRadius)
    },
    on: {
      "change": function($event) {
        return _vm.setBrushRadius($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.brushRadius = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "range-bar"
  }, [_c('div', {
    staticClass: "range-bar-slider"
  }, [_c('label', {
    attrs: {
      "for": "supportTransparency"
    }
  }, [_vm._v("Support Transparency")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportTransparency),
      expression: "supportTransparency"
    }],
    attrs: {
      "name": "supportTransparency",
      "type": "range",
      "id": "supportTransparency",
      "min": "0",
      "max": "1",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.supportTransparency)
    },
    on: {
      "input": function($event) {
        return _vm.setSupportTransparency($event)
      },
      "__r": function($event) {
        _vm.supportTransparency = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "range-bar-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportTransparency),
      expression: "supportTransparency"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "1",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.supportTransparency)
    },
    on: {
      "change": function($event) {
        return _vm.setSupportTransparency($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.supportTransparency = $event.target.value
      }
    }
  })])]), _vm._v(" "), (this.isStrengthenSupp) ? _c('div', {
    staticClass: "range-bar"
  }, [_c('div', {
    staticClass: "range-bar-slider"
  }, [_c('label', {
    attrs: {
      "for": "StrengthenSupportTransparency"
    }
  }, [_vm._v("Strengthen Supp Transparency")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.strengthenSupportTransparency),
      expression: "strengthenSupportTransparency"
    }],
    attrs: {
      "name": "StrengthenSupportTransparency",
      "type": "range",
      "id": "StrengthenSupportTransparency",
      "min": "0",
      "max": "1",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.strengthenSupportTransparency)
    },
    on: {
      "input": function($event) {
        return _vm.setSupportTransparency($event, true)
      },
      "__r": function($event) {
        _vm.strengthenSupportTransparency = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "range-bar-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.strengthenSupportTransparency),
      expression: "strengthenSupportTransparency"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "1",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.strengthenSupportTransparency)
    },
    on: {
      "change": function($event) {
        return _vm.setSupportTransparency($event, true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.strengthenSupportTransparency = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-block center-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.$modal.show('modifycaution')
      }
    }
  }, [_vm._v("Generate supports")])]), _vm._v(" "), _c('div', {
    staticClass: "button-block center-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.resetFaces()
      }
    }
  }, [_vm._v("Reset selection")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.modifySupportsMode && _vm.isHasSupports && _vm.showDirectionSelection && _vm.isHasOptions),
      expression: "!modifySupportsMode && isHasSupports && showDirectionSelection && isHasOptions"
    }],
    staticClass: "left-panel"
  }, [(!(_vm.creatingJob || _vm.loading3JS)) ? _c('div', {
    staticClass: "buttons-block"
  }, [(_vm.nestedMode) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nestedPlate),
      expression: "nestedPlate"
    }],
    staticClass: "browser-default",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.nestedPlate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.switchBuildPlate()
      }]
    }
  }, [_vm._l((_vm.nestedNames), function(plate, index) {
    return [_c('option', {
      key: plate,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(plate))])]
  })], 2)]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "a3d btn btn-large no-wrap",
    on: {
      "click": function($event) {
        return _vm.viewer.reset()
      }
    }
  }, [_vm._v("Reset View")]), _vm._v(" "), (_vm.isHasSupports && !_vm.modifySupportsMode && _vm.isHasDistortionData) ? _c('button', {
    staticClass: "a3d btn btn-large no-wrap",
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "disabled": _vm.modifyMode
    },
    on: {
      "click": function($event) {
        return _vm.toggleSupports()
      }
    }
  }, [_vm._v(_vm._s(_vm.showSupportsOutput ? 'Show distortion' : 'Show Support'))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSupportsOutput),
      expression: "!showSupportsOutput"
    }],
    staticClass: "second",
    staticStyle: {
      "flex-grow": "1",
      "margin": "15px 0"
    }
  }, [(!(_vm.creatingJob || _vm.loading3JS)) ? _c('div', {
    staticClass: "jobOptimization"
  }, [(_vm.jobOptimization) ? _c('div', {
    staticClass: "info-text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Optimization: ")]), _vm._v(_vm._s(_vm.jobOptimization) + "\n          ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSupportsOutput),
      expression: "!showSupportsOutput"
    }],
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "left-panel__box",
    staticStyle: {
      "align-self": "flex-end",
      "padding": "16px",
      "margin-right": "15px"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn a3d inv",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": function($event) {
        return _vm.viewer.applyNewLegendLimit()
      }
    }
  }, [_vm._v("Apply new legend limit")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn a3d inv",
    staticStyle: {
      "margin": "5px 0 0 0",
      "width": "100%"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": function($event) {
        return _vm.viewer.resetLegendLimit()
      }
    }
  }, [_vm._v("\n              Reset legend limit\n            ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "300px"
    }
  }, [_c('div', {
    staticClass: "left-panel__box"
  }, [(_vm.isBladeCanCrush) ? _c('div', {
    staticClass: "caution"
  }, [_vm._v(_vm._s(_vm.isBladeCanCrushMessage))]) : _vm._e(), _vm._v(" "), (_vm.isHasOptionsFull) ? _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displacementOption),
      expression: "displacementOption"
    }],
    attrs: {
      "name": "displacementOption",
      "type": "radio",
      "id": "default-opt",
      "value": "default"
    },
    domProps: {
      "checked": _vm._q(_vm.displacementOption, "default")
    },
    on: {
      "change": [function($event) {
        _vm.displacementOption = "default"
      }, function($event) {
        return _vm.switchDistortionOption('default')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "default-opt"
    }
  }, [_vm._v("Total distortion (post-support removal to stl)")])]) : _vm._e(), _vm._v(" "), (_vm.isHasOptionsFull) ? _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displacementOption),
      expression: "displacementOption"
    }],
    attrs: {
      "name": "displacementOption",
      "type": "radio",
      "id": "removal-opt",
      "value": "removal"
    },
    domProps: {
      "checked": _vm._q(_vm.displacementOption, "removal")
    },
    on: {
      "change": [function($event) {
        _vm.displacementOption = "removal"
      }, function($event) {
        return _vm.switchDistortionOption('removal')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "removal-opt"
    }
  }, [_vm._v("Distortion due to residual stress (post-support removal to as-built part)")])]) : _vm._e(), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displacementOption),
      expression: "displacementOption"
    }],
    attrs: {
      "name": "displacementOption",
      "type": "radio",
      "id": "on-opt",
      "value": "on"
    },
    domProps: {
      "checked": _vm._q(_vm.displacementOption, "on")
    },
    on: {
      "change": [function($event) {
        _vm.displacementOption = "on"
      }, function($event) {
        return _vm.switchDistortionOption('on')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "on-opt"
    }
  }, [_vm._v("Distortion due to build process (as-built to stl)")])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel__box"
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displacementDirection),
      expression: "displacementDirection"
    }],
    attrs: {
      "name": "displacementDirection",
      "type": "radio",
      "id": "z-dist",
      "value": "z"
    },
    domProps: {
      "checked": _vm._q(_vm.displacementDirection, "z")
    },
    on: {
      "change": [function($event) {
        _vm.displacementDirection = "z"
      }, function($event) {
        return _vm.viewer.switchDistortion('z')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "z-dist"
    }
  }, [_vm._v("Z-Direction Displacement")])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displacementDirection),
      expression: "displacementDirection"
    }],
    attrs: {
      "name": "displacementDirection",
      "type": "radio",
      "id": "y-dist",
      "value": "y"
    },
    domProps: {
      "checked": _vm._q(_vm.displacementDirection, "y")
    },
    on: {
      "change": [function($event) {
        _vm.displacementDirection = "y"
      }, function($event) {
        return _vm.viewer.switchDistortion('y')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "y-dist"
    }
  }, [_vm._v("Y-Direction Displacement")])]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displacementDirection),
      expression: "displacementDirection"
    }],
    attrs: {
      "name": "displacementDirection",
      "type": "radio",
      "id": "x-dist",
      "value": "x"
    },
    domProps: {
      "checked": _vm._q(_vm.displacementDirection, "x")
    },
    on: {
      "change": [function($event) {
        _vm.displacementDirection = "x"
      }, function($event) {
        return _vm.viewer.switchDistortion('x')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "x-dist"
    }
  }, [_vm._v("X-Direction Displacement")])]), _vm._v(" "), (_vm.displacementDirectionN) ? _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displacementDirection),
      expression: "displacementDirection"
    }],
    attrs: {
      "name": "displacementDirection",
      "type": "radio",
      "id": "n-dist",
      "value": "n"
    },
    domProps: {
      "checked": _vm._q(_vm.displacementDirection, "n")
    },
    on: {
      "change": [function($event) {
        _vm.displacementDirection = "n"
      }, function($event) {
        return _vm.viewer.switchDistortion('n')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "n-dist"
    }
  }, [_vm._v("Displacement normal to part surface")])]) : _vm._e()]), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.legends > 0) ? _c('div', {
    staticClass: "legend-block"
  }, [_c('div', {
    staticClass: "inset-legend"
  }, [_c('div', {
    staticClass: "filename"
  }, [_vm._v(_vm._s(_vm.currentPartName))]), _vm._v(" "), _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("Distortion [mm]")]), _vm._v(" "), _c('div', {
    staticClass: "inset-legend-wrp",
    attrs: {
      "id": "inset-legend-wrp"
    }
  })])]) : _vm._e()])])])], _vm._v(" "), (!_vm.isNxUser) ? _c('router-link', {
    staticClass: "a3d btn btn-large",
    staticStyle: {
      "position": "absolute",
      "top": "1em",
      "left": "1em"
    },
    attrs: {
      "to": {
        name: 'Dash'
      }
    }
  }, [_vm._v("Back")]) : _vm._e(), _vm._v(" "), (_vm.showOverlay) ? _c('div', {
    staticClass: "overlay"
  }) : _vm._e(), _vm._v(" "), _c('modal', {
    ref: "summarymodal",
    attrs: {
      "name": "summarymodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "75%"
    }
  }, [_c('job-summary', {
    attrs: {
      "config": _vm.config,
      "jobDescription": _vm.jobDescription,
      "submit": _vm.submitInput
    }
  })], 1), _vm._v(" "), _c('modal', {
    ref: "summarynestedmodal",
    attrs: {
      "name": "summarynestedmodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "40%"
    }
  }, [_c('div', {
    staticClass: "prompt-modal"
  }, [(!_vm.isManualPlacement) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("Submit Nested Job?")]) : _c('div', [(_vm.platesErrors) ? _c('div', {
    staticClass: "title alert-title"
  }, [_vm._v("There are some errors on build plates. Submit anyway?")]) : (!_vm.platesConfig.length) ? _c('div', {
    staticClass: "title alert-title"
  }, [_vm._v("You should add plates first")]) : _c('div', {
    staticClass: "title"
  }, [_vm._v("Submit Nested Job?")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, _vm._l((_vm.platesConfig), function(plate, index) {
    return _c('div', {
      key: index,
      staticClass: "plate"
    }, _vm._l((plate), function(plateName, name) {
      return _c('div', {
        key: name
      }, [_c('div', {
        staticClass: "plate-title",
        style: (plateName.errors && 'color: red')
      }, [_vm._v(" Build " + _vm._s(name) + " ")]), _vm._v(" "), _vm._l((plateName), function(part, name) {
        return _c('div', {
          key: name
        }, [(name !== 'errors') ? _c('div', [_vm._v(_vm._s(name) + "  copies: " + _vm._s(part.length / 3))]) : _vm._e()])
      })], 2)
    }), 0)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6 right-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    attrs: {
      "disabled": !_vm.platesConfig.length && _vm.isManualPlacement
    },
    on: {
      "click": function($event) {
        return _vm.submitInput()
      }
    }
  }, [_vm._v("Ok")])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 left-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('summarynestedmodal')
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('modal', {
    ref: "modifycaution",
    attrs: {
      "name": "modifycaution",
      "pivotY": 0.3,
      "reset": true,
      "height": "auto",
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "prompt-modal"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Modifying supports jeopardizes build success. Modified support builds are at user's own risk.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6 right-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.generateSupportStructures()
      }
    }
  }, [_vm._v("Modify")])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 left-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('modifycaution')
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('modal', {
    ref: "dialoghelp",
    attrs: {
      "name": "dialoghelp",
      "pivotY": 0.3,
      "reset": true,
      "height": "auto",
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "dialog-help"
  }, [_c('p', [_c('b', [_vm._v("Instructions")])]), _vm._v(" "), _c('p', [_vm._v(" The viewer allows the user to choose the unit, scaling factor and orientation of the part and start the AM simulation.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Choose the unit associated with the STL file.")]), _vm._v(" "), _c('li', [_vm._v("Choose the scaling factor of the part, e.g., scaling factor = 1.5 means the printed part is 150% of the orignal size of the STL.")]), _vm._v(" "), _c('li', [_vm._v("Change the part orientation by dragging the part or by entering the three Euler angles.")]), _vm._v(" "), _c('li', [_vm._v("After the scaling factor and orientation is chosen, uncheck \"Orient Model\" to generate support structures.")]), _vm._v(" "), _c('li', [_vm._v("To choose a different unit, scaling factor or part orientation, check \"Orient Model\" again.")]), _vm._v(" "), _c('li', [_vm._v("The user can reset the view by clicking \"Reset View\".")]), _vm._v(" "), _c('li', [_vm._v("After the unit, scaling factor and orientatoin are decided, click \"RUN JOB\" to start the job.")])]), _vm._v(" "), _c('div', {
    staticClass: "center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('dialoghelp')
      }
    }
  }, [_vm._v("Ok")])])])]), _vm._v(" "), _c('modal', {
    ref: "zrotationmodal",
    attrs: {
      "name": "zrotationmodal",
      "pivotY": 0.3,
      "reset": true,
      "height": "auto",
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "dialog-help"
  }, [_c('p', [_vm._v("WARNING: By setting the z rotation manually, you may not achieve the best possible density of parts, uncheck the box again to let AM Build Optimizer maximize your part density")]), _vm._v(" "), _c('div', {
    staticClass: "center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.changeZRotation(true)
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.changeZRotation(false)
      }
    }
  }, [_vm._v("Cancel")])])])]), _vm._v(" "), _c('modal', {
    ref: "removeplatemodal",
    attrs: {
      "name": "removeplatemodal",
      "pivotY": 0.3,
      "reset": true,
      "height": "auto",
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "dialog-help"
  }, [_c('p', [_vm._v("WARNING: There are some nested parts on this build plate. Remove plate anyway?")]), _vm._v(" "), _c('div', {
    staticClass: "center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.removePlate(true)
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.removePlate(false)
      }
    }
  }, [_vm._v("Cancel")])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("Legend lower limit (mm): ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "legendLowerLimit"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("Legend upper limit (mm): ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "legendUpperLimit"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-panel__box"
  }, [_c('p', [_c('label', {
    attrs: {
      "id": "distortionAtSelect"
    }
  }, [_vm._v("Distortion at select: ")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-25c81e86", module.exports)
  }
}

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-32e5de78", module.exports)
  }
}

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.animation
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "my-dropdown-dd",
    style: (_vm.ddStyle)
  }, [_vm._t("dropdown")], 2)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3764253e", module.exports)
  }
}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a3d banner valign-wrapper",
    class: {
      'govcloud': _vm.user.isGovcloudUser
    },
    staticStyle: {
      "padding": "0 5em",
      "justify-content": "space-between",
      "position": "relative"
    }
  }, [(!_vm.user.loaded) ? [_vm._m(0)] : [_c('div', {
    staticClass: "subscription-block"
  }, [(_vm.subscription) ? _c('div', {
    staticStyle: {
      "font-size": "1.2em"
    }
  }, [_vm._v("\n        You have unlimited credits until "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.subscription))])]) : _vm._e(), _vm._v(" "), (!_vm.subscription && _vm.user.credits.length === 0) ? _c('div', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("\n        To submit a job, you need to buy a subscription.\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.subscription && _vm.user.credits.length > 0) ? _c('div', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("\n        You can submit one job per credit.\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.user.isGovcloudUser && _vm.subscription) ? _c('div', {
    staticClass: "govcloud-secure"
  }, [_vm._v("\n      Secure GovCloud\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.subscription) ? _c('div', {
    staticClass: "valign-wrapper",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "bottom": "0",
      "left": "0",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-direction": "column",
      "margin": "auto",
      "font-weight": "bold"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "3.5em",
      "line-height": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.user.credits.length) + " ")]), _vm._v(" "), _c('div', [_vm._v("credits")])])]) : _vm._e(), _vm._v(" "), (!_vm.subscription) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "z-index": "1",
      "font-size": "0.8em",
      "text-align": "right",
      "font-weight": "bold"
    }
  }, [_c('buy-credits', {
    attrs: {
      "showModal": _vm.showModal
    },
    on: {
      "update:showModal": function($event) {
        _vm.showModal = $event
      },
      "update:show-modal": function($event) {
        _vm.showModal = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "display",
      fn: function(props) {
        return _c('a', {
          staticClass: "a3d btn inv dark",
          on: {
            "click": props.open
          }
        }, [_vm._v("\n          + Buy Subscription\n        ")])
      }
    }], null, false, 3326603751)
  }), _vm._v(" "), (_vm.user.isGovcloudUser) ? _c('div', {
    staticClass: "govcloud-secure"
  }, [_vm._v("\n        Secure GovCloud\n      ")]) : _vm._e()], 1) : _vm._e()]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader-wrapper small active"
  }, [_c('div', {
    staticClass: "spinner-layer"
  }, [_c('div', {
    staticClass: "circle-clipper left"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gap-patch"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-clipper right"
  }, [_c('div', {
    staticClass: "circle"
  })])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38ba4ea0", module.exports)
  }
}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-input illustration"
  }, [_c('div', {
    staticClass: "canvas"
  }, [_c('div', {
    staticClass: "base-gap",
    style: ({
      'height': ((_vm.getBaseGapHeight()) + "px")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "layer block-names"
  }, [_c('div', {
    staticClass: "top-name"
  }, [_vm._v("\n                Part\n            ")]), _vm._v(" "), (_vm.buildPlate) ? _c('div', {
    staticClass: "bottom-name"
  }, [_vm._v("\n                Build plate\n            ")]) : _c('div', {
    staticClass: "bottom-name"
  }, [_vm._v("\n                Part\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "layer legends"
  }, [_c('div', {
    staticClass: "fill top"
  }, [_c('div', {
    staticClass: "legend depth",
    style: ({
      'height': ((_vm.getLegendHeight('top-depth')) + "px"),
      'display': _vm.isDepthVisible('top')
    })
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "legend-line"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "legend ot",
    style: ({
      'height': ((_vm.getLegendHeight('top-rect')) + "px")
    })
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "legend-line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "legend trapecia last",
    style: ({
      'height': ((_vm.getLegendHeight('top-trape')) + "px")
    })
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "legend-line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "placeholder-legends-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend trapecia",
    style: ({
      'height': ((_vm.getLegendHeight('bot-trape')) + "px"),
      'opacity': _vm.getOpacity()
    })
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "legend-line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "legend ot",
    style: ({
      'height': ((_vm.getLegendHeight('bot-rect')) + "px"),
      'opacity': _vm.getOpacity()
    })
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "legend-line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fill"
  }, [_c('div', {
    staticClass: "legend depth last",
    style: ({
      'height': ((_vm.getLegendHeight('bot-depth')) + "px"),
      'display': _vm.isDepthVisible('bot'),
      'opacity': _vm.getOpacity()
    })
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "legend-line"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "layer support"
  }, [_c('div', {
    staticClass: "fill top"
  }, [_c('div', {
    staticClass: "rect depth",
    style: ({
      'height': ((_vm.getTopDepthHeight()) + "px"),
      'display': _vm.isDepthVisible('top'),
      'width': ((_vm.getWidth('top')) + "px")
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "rect",
    style: ({
      'height': ((_vm.getTopRectHeight()) + "px"),
      'width': ((_vm.getWidth('top')) + "px")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "rect upper trapecia",
    style: ({
      'border-bottom-width': ((_vm.getTopTrapeHeight()) + "px"),
      'border-left-width': _vm.getTrapeSkew('top'),
      'border-right-width': _vm.getTrapeSkew('top'),
      'width': ((_vm.getWidth('top')) + "px")
    })
  }, [_c('div', {
    staticClass: "legend-line"
  }), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "rect main",
    class: {
      'build-plate': _vm.buildPlate
    }
  }), _vm._v(" "), (!_vm.buildPlate) ? _c('div', {
    staticClass: "rect bottom trapecia",
    style: ({
      'border-top-width': ((_vm.getBotTrapeHeight()) + "px"),
      'border-left-width': _vm.getTrapeSkew('bot'),
      'border-right-width': _vm.getTrapeSkew('bot'),
      'width': ((_vm.getWidth('bot')) + "px")
    })
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "legend-line"
  })]) : _vm._e(), _vm._v(" "), (!_vm.buildPlate) ? _c('div', {
    staticClass: "rect",
    style: ({
      'height': ((_vm.getBotRectHeight()) + "px"),
      'width': ((_vm.getWidth('bot')) + "px")
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fill bottom"
  }, [_c('div', {
    staticClass: "rect depth",
    style: ({
      'height': ((_vm.getBotDepthHeight()) + "px"),
      'display': _vm.isDepthVisible('bot'),
      'width': ((_vm.getWidth('bot')) + "px"),
      'opacity': _vm.getOpacity()
    })
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("P"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("O"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("T"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("T"), _c('sub', [_vm._v("b")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("O"), _c('sub', [_vm._v("b")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("P"), _c('sub', [_vm._v("b")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("W"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-title"
  }, [_vm._v("W"), _c('sub', [_vm._v("b")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3907c46c", module.exports)
  }
}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a3d"
  }, [_c('div', {
    staticClass: "file job",
    on: {
      "click": function($event) {
        return _vm.toggleJobs(_vm.job.jobPathKey, _vm.job.sourceFilePathKey)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "1em",
      "height": "1px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "file-name-block"
  }, [(_vm.job.isNested) ? _c('div', {
    staticClass: "file-name"
  }, [_vm._v(_vm._s(_vm.job.nestedJobName))]) : _c('div', {
    staticClass: "file-name"
  }, [_vm._v(_vm._s(_vm.job.filename))]), _vm._v(" "), _c('div', {
    staticClass: "file-date"
  }, [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.job.createdAt)))])]), _vm._v(" "), (!_vm.job.parentPathKey) ? [(!_vm.job.isArchived) ? _c('div', {
    staticStyle: {
      "align-self": "center"
    }
  }, [_c('button', {
    staticClass: "a3d btn small inv",
    attrs: {
      "disabled": _vm.archivingProcess[_vm.job.jobPathKey]
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.archiveJob({
          jobPathKey: _vm.job.jobPathKey
        })
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.archivingProcess[_vm.job.jobPathKey] ? 'Archiving...' : 'Archive') + "\n                ")])]) : _c('div', {
    staticStyle: {
      "align-self": "center"
    }
  }, [_c('button', {
    staticClass: "a3d btn small inv",
    attrs: {
      "disabled": _vm.unarchivingProcess[_vm.job.jobPathKey]
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.unarchiveJob({
          jobPathKey: _vm.job.jobPathKey
        })
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.unarchivingProcess[_vm.job.jobPathKey] ? 'Unarchiving...' : 'Unarchive') + "\n                ")])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "toggleIcon"
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-chevron-up': _vm.isOpen, 'fa-chevron-down': !_vm.isOpen
    }
  })])], 2), _vm._v(" "), (_vm.isLoading || _vm.archivingProcess[_vm.job.jobPathKey] || _vm.unarchivingProcess[_vm.job.jobPathKey]) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.job.jobOutputs), function(jobOutput, joI) {
    return (_vm.isOpen && _vm.job.hasOwnProperty('jobOutputs')) ? _c('div', {
      key: joI,
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_c('div', {
      staticClass: "job jobout",
      on: {
        "click": function($event) {
          return _vm.toggleJobsFiles(joI, jobOutput)
        }
      }
    }, [(_vm.compareMode && _vm.isHasCost(jobOutput.outputFiles, _vm.job)) ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('input', {
      staticClass: "filled-in",
      attrs: {
        "type": "checkbox",
        "id": jobOutput.jobOutputPathKey
      },
      domProps: {
        "checked": _vm.isCheckedToCompare(jobOutput.jobOutputPathKey)
      },
      on: {
        "change": function($event) {
          return _vm.toggleJobCompare({
            jobOutput: jobOutput,
            job: _vm.job
          })
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": jobOutput.jobOutputPathKey
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.subscription || jobOutput.paidfor || _vm.job.isNested) ? _c('div', {
      staticStyle: {
        "flex": "3",
        "font-size": "1.2em"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.jobDescription(jobOutput.analysisId, jobOutput.objectiveId, false)) + "\n            ")]) : _vm._e(), _vm._v(" "), (jobOutput.outputFiles && jobOutput.outputFiles.length > 0 && (_vm.subscription || jobOutput.paidfor) && _vm.job.isNested) ? _c('div', {
      staticClass: "jobout-buttons nested-row"
    }, [_c('div', {
      staticClass: "jobout-buttons-row"
    }, [(_vm.job.isNested) ? _c('router-link', {
      staticClass: "a3d btn inv small",
      attrs: {
        "to": {
          name: 'ThreeJSViewer',
          params: {
            id: jobOutput.id,
            type: 'output'
          }
        }
      }
    }, [_vm._v("\n                        View\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.isHasCost(jobOutput.outputFiles, _vm.job)) ? _c('button', {
      staticClass: "a3d btn inv small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showEstimateModal({
            jobOutput: jobOutput,
            job: _vm.job
          })
        }
      }
    }, [_vm._v("Estimate print costs")]) : _vm._e(), _vm._v(" "), (_vm.isHasConfigJson(jobOutput.outputFiles)) ? _c('button', {
      staticClass: "a3d btn inv small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.fileDownload($event, {
            filename: _vm.isHasConfigJson(jobOutput.outputFiles),
            sourceFilePathKey: _vm.job.sourceFilePathKey,
            jobPathKey: _vm.job.jobPathKey,
            jobOutputPathKey: jobOutput.jobOutputPathKey,
            newTab: true
          })
        }
      }
    }, [_vm._v("Download config")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (jobOutput.outputFiles && jobOutput.outputFiles.length > 0 && (jobOutput.paidfor || _vm.subscription) && !_vm.job.isNested) ? _c('div', {
      staticClass: "jobout-buttons"
    }, [(_vm.isHasOutput(jobOutput.outputFiles)) ? _c('div', {
      staticClass: "jobout-buttons-row"
    }, [_c('router-link', {
      staticClass: "a3d btn inv small",
      attrs: {
        "to": {
          name: 'ThreeJSViewer',
          params: {
            id: jobOutput.id,
            type: 'output'
          }
        }
      }
    }, [_vm._v("\n                        View\n                    ")]), _vm._v(" "), (_vm.isHasLog(jobOutput.outputFiles)) ? _c('button', {
      staticClass: "right a3d btn small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.fileDownload($event, {
            filename: _vm.isHasLog(jobOutput.outputFiles),
            sourceFilePathKey: _vm.job.sourceFilePathKey,
            jobPathKey: _vm.job.jobPathKey,
            jobOutputPathKey: jobOutput.jobOutputPathKey,
            newTab: true
          })
        }
      }
    }, [_vm._v("Download optimization log")]) : _vm._e(), _vm._v(" "), (_vm.isHasConfigJson(jobOutput.outputFiles)) ? _c('button', {
      staticClass: "right a3d btn small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.fileDownload($event, {
            filename: _vm.isHasConfigJson(jobOutput.outputFiles),
            sourceFilePathKey: _vm.job.sourceFilePathKey,
            jobPathKey: _vm.job.jobPathKey,
            jobOutputPathKey: jobOutput.jobOutputPathKey,
            newTab: true
          })
        }
      }
    }, [_vm._v("Download config")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isHasOutput(jobOutput.outputFiles)) ? _c('div', {
      staticClass: "jobout-buttons-row"
    }, [_c('router-link', {
      staticClass: "a3d btn inv small",
      attrs: {
        "to": {
          name: 'ThreeJSViewer',
          params: {
            id: jobOutput.id,
            type: 'output'
          },
          query: {
            modifySupports: true
          }
        }
      }
    }, [_vm._v("Modify Supports")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.subscription && !jobOutput.paidfor && !_vm.job.isNested) ? [_c('div', {
      staticStyle: {
        "flex-grow": "1",
        "padding-top": "1px",
        "margin-left": "30px"
      }
    }, [_c('i', [_vm._v(_vm._s(_vm.jobDescription(jobOutput.analysisId, jobOutput.objectiveId)))]), _vm._v("\n                    is not yet unlocked.\n                ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-grow": "1",
        "flex-basis": "50%",
        "align-self": "center"
      }
    }, [(_vm.user.credits.length > 0) ? _c('button', {
      staticClass: "right a3d btn small inv",
      staticStyle: {
        "margin-right": "0.5em"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.unlockJob($event, jobOutput, _vm.job)
        }
      }
    }, [_vm._v("Unlock"), _c('br'), _vm._v("(1 credit)\n                    ")]) : _c('a', {
      staticClass: "a3d btn small right",
      on: {
        "click": _vm.buymodal
      }
    }, [_vm._v("Buy Subscription")])])] : _vm._e(), _vm._v(" "), (_vm.subscription || jobOutput.paidfor || _vm.job.isNested) ? _c('div', {
      staticClass: "toggleIcon"
    }, [_c('i', {
      staticClass: "fa",
      class: {
        'fa-chevron-up': _vm.jobsFilesToggle[joI], 'fa-chevron-down': !_vm.jobsFilesToggle[joI]
      }
    })]) : _vm._e()], 2), _vm._v(" "), (_vm.jobsFilesToggle[joI] && (_vm.subscription || jobOutput.paidfor || _vm.job.isNested)) ? [(jobOutput.outputFiles && jobOutput.outputFiles.length > 0) ? _c('div', _vm._l((jobOutput.outputFiles), function(outputFile, ofI) {
      return (!outputFile.name.match(/\.json$/)) ? _c('div', {
        key: ofI,
        staticStyle: {
          "margin-left": "40px"
        }
      }, [(outputFile.name.match(/^1_.*_0m\.stl$/) &&
        !outputFile.name.match(/_compensated_0m\.stl$/)) ? _c('div', {
        staticClass: "job jobout jobfile"
      }, [(outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)) ? _c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                            Support Structure Renishaw\n                        ")]) : (outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                            Support Structure Polymer \n                        ")]) : (outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)) ? _c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                            Strengthening support\n                        ")]) : (!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) && !outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                            Support Structure\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "button-block right"
      }, [(!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) && !outputFile.name.match(/^1_magicSupp_0m\.stl$/) && !outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('dropdown', {
        attrs: {
          "position": ['center', 'top', 'center', 'top'],
          "visible": !!(_vm.jobsFilesSupportVisible[joI])
        },
        on: {
          "clickout": function($event) {
            return _vm.visibleJobsFilesSupport(joI, false)
          }
        }
      }, [_c('div', {
        staticClass: "a3d btn small",
        on: {
          "click": function($event) {
            return _vm.visibleJobsFilesSupport(joI, true)
          }
        }
      }, [_vm._v("\n                                    Download "), _c('i', {
        staticClass: "fa fa-angle-down"
      })]), _vm._v(" "), _c('div', {
        staticClass: "dialog no-padding",
        attrs: {
          "slot": "dropdown"
        },
        slot: "dropdown"
      }, [_c('aside', {
        staticClass: "menu"
      }, [_c('ul', {
        staticClass: "menu-list"
      }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
        return (outputFileNested.name.match(/^1_.*_0m\.[\S]{3}$/) &&
          !outputFileNested.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) &&
          !outputFileNested.name.match(/^1_magicSupp_0m\.stl$/) &&
          !outputFileNested.name.match(/^1_polymerSupp.*_0m\.stl$/) &&
          !outputFileNested.name.match(/_compensated_0m\.[\S]{3}$/)) ? _c('li', {
          key: ofNI
        }, [_c('button', {
          staticClass: "a3d btn inv small",
          on: {
            "click": function($event) {
              _vm.fileDownload($event, {
                filename: outputFileNested.name,
                sourceFilePathKey: _vm.job.sourceFilePathKey,
                jobPathKey: _vm.job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              });
              _vm.visibleJobsFilesSupport(joI, false)
            }
          }
        }, [_vm._v("\n                                                    Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                                ")])]) : _vm._e()
      }), 0)])])]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)) ? _c('div', {
        staticClass: "a3d btn small nowrap",
        on: {
          "click": function($event) {
            return _vm.fileDownload($event, {
              filename: outputFile.name,
              sourceFilePathKey: _vm.job.sourceFilePathKey,
              jobPathKey: _vm.job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("\n                              Download STL\n                            ")]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('div', {
        staticClass: "a3d btn small nowrap",
        on: {
          "click": function($event) {
            return _vm.fileDownload($event, {
              filename: outputFile.name,
              sourceFilePathKey: _vm.job.sourceFilePathKey,
              jobPathKey: _vm.job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("\n                              Download STL\n                            ")]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)) ? _c('div', {
        staticClass: "a3d btn small nowrap",
        on: {
          "click": function($event) {
            return _vm.fileDownload($event, {
              filename: outputFile.name,
              sourceFilePathKey: _vm.job.sourceFilePathKey,
              jobPathKey: _vm.job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("\n                              Download STL\n                            ")]) : _vm._e()], 1)]) : (outputFile.name.match(/(.*)_output\.stl$/) || outputFile.name.match(/(.*)_new\.stl$/)) ? _c('div', {
        staticClass: "job jobout jobfile"
      }, [_c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                            Oriented Part\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "button-block right"
      }, [(_vm.isCost(jobOutput.outputFiles) && outputFile.name.match(/(.*)\.stl$/)) ? _c('button', {
        staticClass: "a3d btn inv small",
        on: {
          "click": function($event) {
            return _vm.showEstimateCost($event, {
              filename: 'cost.json',
              sourceFilePathKey: _vm.job.sourceFilePathKey,
              jobPathKey: _vm.job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("Estimate print costs")]) : _vm._e(), _vm._v(" "), _c('dropdown', {
        attrs: {
          "position": ['center', 'top', 'center', 'top'],
          "visible": !!(_vm.jobsFilesPartVisible[joI])
        },
        on: {
          "clickout": function($event) {
            return _vm.visibleJobsFilesPart(joI, false)
          }
        }
      }, [_c('div', {
        staticClass: "a3d btn small",
        on: {
          "click": function($event) {
            return _vm.visibleJobsFilesPart(joI, true)
          }
        }
      }, [_vm._v("\n                                    Download "), _c('i', {
        staticClass: "fa fa-angle-down"
      })]), _vm._v(" "), _c('div', {
        staticClass: "dialog no-padding",
        attrs: {
          "slot": "dropdown"
        },
        slot: "dropdown"
      }, [_c('aside', {
        staticClass: "menu"
      }, [_c('ul', {
        staticClass: "menu-list"
      }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
        return (outputFileNested.name.match(/^(.*)_output\.(?!(txt)$)([^.]{3}$)/) || outputFileNested.name.match(/^.*_new\.[\S]{3}$/)) ? _c('li', {
          key: ofNI
        }, [_c('button', {
          staticClass: "a3d btn inv small",
          on: {
            "click": function($event) {
              _vm.fileDownload($event, {
                filename: outputFileNested.name,
                sourceFilePathKey: _vm.job.sourceFilePathKey,
                jobPathKey: _vm.job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              });
              _vm.visibleJobsFilesPart(joI, false)
            }
          }
        }, [_vm._v("\n                                                    Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                                ")])]) : _vm._e()
      }), 0)])])])], 1)]) : (outputFile.name.match(/plate_[0-9]+\.stl$/)) ? _c('div', {
        staticClass: "job jobout jobfile"
      }, [_c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                            Build plate #" + _vm._s(Number(outputFile.name.match(/plate_([0-9]+)\.stl$/)[1])) + "\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "button-block right"
      }, [_c('button', {
        staticClass: "a3d btn small",
        on: {
          "click": function($event) {
            return _vm.fileDownload($event, {
              filename: outputFile.name,
              sourceFilePathKey: _vm.job.sourceFilePathKey,
              jobPathKey: _vm.job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("Download")])])]) : (outputFile.name.match(/support[0-9]+\.stl$/)) ? _c('div', {
        staticClass: "job jobout jobfile"
      }, [_c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                            Build plate supports #" + _vm._s(Number(outputFile.name.match(/support([0-9]+)\.stl$/)[1])) + "\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "button-block right"
      }, [_c('button', {
        staticClass: "a3d btn small",
        on: {
          "click": function($event) {
            return _vm.fileDownload($event, {
              filename: outputFile.name,
              sourceFilePathKey: _vm.job.sourceFilePathKey,
              jobPathKey: _vm.job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("Download")])])]) : _vm._e()]) : _vm._e()
    }), 0) : _c('div', [_c('div', {
      staticStyle: {
        "margin-left": "40px"
      }
    }, [_c('div', {
      staticClass: "job jobout job-status"
    }, [_c('div', {
      staticClass: "job-status-message"
    }, [_vm._v("\n                            " + _vm._s(_vm.displayMessage(jobOutput.status)) + "\n                            "), (jobOutput.status === 'PROCESSING') ? _c('span', [_vm._v(_vm._s(jobOutput.progress) + "%")]) : _vm._e()]), _vm._v(" "), (jobOutput.status === 'PROCESSING') ? _c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "determinate",
      style: ({
        width: jobOutput.progress + '%'
      })
    })]) : _vm._e(), _vm._v(" "), _vm._m(0, true)])])])] : _vm._e(), _vm._v(" "), (_vm.isHasCompensated(jobOutput.outputFiles) && (_vm.subscription || jobOutput.paidfor)) ? _c('div', {
      staticClass: "job jobout",
      on: {
        "click": function($event) {
          return _vm.toggleJobsFilesCompensated(joI)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "flex": "3",
        "font-size": "1.2em"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.jobDescription(jobOutput.analysisId, jobOutput.objectiveId, true)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "jobout-buttons"
    }, [_c('div', {
      staticClass: "jobout-buttons-row"
    }, [_c('router-link', {
      staticClass: "a3d btn inv small",
      attrs: {
        "to": {
          name: 'ThreeJSViewer',
          params: {
            id: jobOutput.id,
            type: 'output'
          },
          query: {
            compensated: true
          }
        }
      }
    }, [_vm._v("\n                        View\n                    ")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "toggleIcon"
    }, [_c('i', {
      staticClass: "fa",
      class: {
        'fa-chevron-up': _vm.jobsFilesCompensatedToggle[joI], 'fa-chevron-down': !_vm.jobsFilesCompensatedToggle[joI]
      }
    })])]) : _vm._e(), _vm._v(" "), (jobOutput.outputFiles && jobOutput.outputFiles.length > 0 && _vm.jobsFilesCompensatedToggle[joI]) ? _vm._l((jobOutput.outputFiles), function(outputFile, ofI) {
      return (!outputFile.name.match(/\.json$/) && (_vm.subscription || jobOutput.paidfor)) ? _c('div', {
        key: "compensated" + ofI,
        staticStyle: {
          "margin-left": "40px"
        }
      }, [(outputFile.name.match(/^1_.*_0m\.stl$/) && outputFile.name.match(/_compensated_0m\.stl$/)) ? _c('div', {
        staticClass: "job jobout jobfile"
      }, [_c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                        Support Structure\n                    ")]), _vm._v(" "), _c('div', {
        staticClass: "button-block right"
      }, [_c('dropdown', {
        attrs: {
          "position": ['center', 'top', 'center', 'top'],
          "visible": !!(_vm.jobsFilesSupportCompensatedVisible[joI])
        },
        on: {
          "clickout": function($event) {
            return _vm.visibleJobsFilesSupportCompensated(joI, false)
          }
        }
      }, [_c('div', {
        staticClass: "a3d btn small",
        on: {
          "click": function($event) {
            return _vm.visibleJobsFilesSupportCompensated(joI, true)
          }
        }
      }, [_vm._v("\n                                Download "), _c('i', {
        staticClass: "fa fa-angle-down"
      })]), _vm._v(" "), _c('div', {
        staticClass: "dialog no-padding",
        attrs: {
          "slot": "dropdown"
        },
        slot: "dropdown"
      }, [_c('aside', {
        staticClass: "menu"
      }, [_c('ul', {
        staticClass: "menu-list"
      }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
        return (outputFileNested.name.match(/^1_.*_0m\.[\S]{3}$/) && outputFileNested.name.match(/_compensated_0m\.[\S]{3}$/)) ? _c('li', {
          key: ofNI
        }, [_c('button', {
          staticClass: "a3d btn inv small",
          on: {
            "click": function($event) {
              _vm.fileDownload($event, {
                filename: outputFileNested.name,
                sourceFilePathKey: _vm.job.sourceFilePathKey,
                jobPathKey: _vm.job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              });
              _vm.visibleJobsFilesSupportCompensated(joI, false)
            }
          }
        }, [_vm._v("\n                                                Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                            ")])]) : _vm._e()
      }), 0)])])])], 1)]) : (outputFile.name.match(/output_compensated\.stl$/)) ? _c('div', {
        staticClass: "job jobout jobfile"
      }, [_c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                        Oriented Part\n                    ")]), _vm._v(" "), _c('div', {
        staticClass: "button-block right"
      }, [(_vm.isCost(jobOutput.outputFiles) && outputFile.name.match(/(.*)\.stl$/)) ? _c('button', {
        staticClass: "a3d btn inv small",
        on: {
          "click": function($event) {
            return _vm.showEstimateCost($event, {
              filename: 'cost.json',
              sourceFilePathKey: _vm.job.sourceFilePathKey,
              jobPathKey: _vm.job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("Estimate print costs")]) : _vm._e(), _vm._v(" "), _c('dropdown', {
        attrs: {
          "position": ['center', 'top', 'center', 'top'],
          "visible": !!(_vm.jobsFilesPartCompensatedVisible[joI])
        },
        on: {
          "clickout": function($event) {
            return _vm.visibleJobsFilesPartCompensated(joI, false)
          }
        }
      }, [_c('div', {
        staticClass: "a3d btn small",
        on: {
          "click": function($event) {
            return _vm.visibleJobsFilesPartCompensated(joI, true)
          }
        }
      }, [_vm._v("\n                                Download "), _c('i', {
        staticClass: "fa fa-angle-down"
      })]), _vm._v(" "), _c('div', {
        staticClass: "dialog no-padding",
        attrs: {
          "slot": "dropdown"
        },
        slot: "dropdown"
      }, [_c('aside', {
        staticClass: "menu"
      }, [_c('ul', {
        staticClass: "menu-list"
      }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
        return (outputFileNested.name.match(/output_compensated\.[\S]{3}$/)) ? _c('li', {
          key: ofNI
        }, [_c('button', {
          staticClass: "a3d btn inv small",
          on: {
            "click": function($event) {
              _vm.fileDownload($event, {
                filename: outputFileNested.name,
                sourceFilePathKey: _vm.job.sourceFilePathKey,
                jobPathKey: _vm.job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              });
              _vm.visibleJobsFilesPartCompensated(joI, false)
            }
          }
        }, [_vm._v("\n                                                Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                            ")])]) : _vm._e()
      }), 0)])])])], 1)]) : _vm._e()]) : _vm._e()
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.job.nestedJobs), function(jobNested) {
      return (_vm.job.nestedJobs) ? _c('div', {
        key: jobNested.id
      }, [_c('job-output', {
        attrs: {
          "job": jobNested,
          "compare-mode": _vm.compareMode
        }
      })], 1) : _vm._e()
    })], 2) : _vm._e()
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "1em",
      "height": "1px"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3cf5c9a2", module.exports)
  }
}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "job-summary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Restricted faces:")]), _vm._v(" "), (_vm.config.RestrictedFaces.length > 0) ? _c('div', {
    staticClass: "col s5"
  }, [_vm._v("Has restricted faces")]) : _c('div', {
    staticClass: "col s5"
  }, [_vm._v("No restrictions")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Orientation constraints for optimization, (x, y ,z):")]), _vm._v(" "), (_vm.config.AngleRestriction.length > 0) ? _c('div', {
    staticClass: "col s5"
  }, [_vm._v("\n            " + _vm._s(_vm.config.AngleRestriction[0]) + ", " + _vm._s(_vm.config.AngleRestriction[1]) + ", " + _vm._s(_vm.config.AngleRestriction[2]) + "\n        ")]) : _c('div', {
    staticClass: "col s5"
  }, [_vm._v("No restrictions")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Powder thickness:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.layerThickness[0]) + " µm")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Top support tooth width:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.Wt[0]) + " mm")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Bottom support tooth width:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.Wb[0]) + " mm")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Support density:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(parseInt(_vm.config.fraction_avg[0] * 100)) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Printer:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.printer))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Material:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.material_name))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("STL Unit of Measure:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.unit))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Element Size:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.elementsize[0] * 1000) + " mm")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7"
  }, [_vm._v("Z-offset (distance from build plate):")]), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_vm._v(_vm._s(_vm.config.hsub[0]) + " mm")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s7 input-field-label"
  }, [_vm._v("Job Description:")]), _vm._v(" "), _c('div', {
    staticClass: "col s5 input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jobDescriptionData),
      expression: "jobDescriptionData"
    }],
    attrs: {
      "id": "jobDescription",
      "type": "text"
    },
    domProps: {
      "value": (_vm.jobDescriptionData)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.jobDescriptionData = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.submitData()
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.hideSummary()
      }
    }
  }, [_vm._v("Cancel")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 center-align"
  }, [_c('h4', [_vm._v("Job summary")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e32201d", module.exports)
  }
}

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('nav', {
    staticClass: "a3d"
  }, [_c('div', {
    staticClass: "nav-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dash'
      }
    }
  }, [_c('img', {
    staticClass: "a3d logo",
    attrs: {
      "src": "/static/img/siemens_logo_white.svg"
    }
  })]), _vm._v(" "), (_vm.clearCacheBanner) ? _c('div', {
    staticClass: "clear-cache"
  }, [_vm._v("\n          Please clear your browser cache to ensure you run with the latest AM Build Optimizer"), _c('sup', [_vm._v("TM")]), _vm._v(" updates!\n        ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "hide-on-med-and-down a3d bold",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "nav-mobile"
    }
  }, [(_vm.webGL < 1) ? _c('li', [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "menu-link",
    attrs: {
      "to": "/dash/"
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), (!_vm.subscription) ? _c('li', [_c('buy-credits', {
    staticClass: "menu-link"
  })], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "menu-link",
    on: {
      "click": function($event) {
        return _vm.auth.logout()
      }
    }
  }, [_vm._v("Logout")])])])], 1), _vm._v(" "), (_vm.user.lastLogin) ? _c('div', {
    staticClass: "last-login right-align"
  }, [_vm._v("\n        Last login at: " + _vm._s(_vm._f("dateFormat")(_vm.user.lastLogin.date)) + " | " + _vm._s(_vm.user.lastLogin.geo) + " (" + _vm._s(_vm.user.lastLogin.ip) + ")\n      ")]) : _vm._e()]), _vm._v(" "), _c('banner'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "details-submitted",
      "height": "180px",
      "pivotY": 0.3
    }
  }, [_c('div', {
    staticClass: "row details-completed"
  }, [_c('div', {
    staticClass: "col s12 center-align details-completed-title"
  }, [_vm._v("\n          A sales representative will contact you shortly to set up payment\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col s12 center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "details",
      "height": "600px",
      "pivotY": 0.3
    },
    on: {
      "before-open": _vm.modalBeforeOpen
    }
  }, [_c('div', {
    staticClass: "row details"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('div', {
    staticClass: "center-align details-title"
  }, [_vm._v("\n            Billing information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "details-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s4 right-align details-label"
  }, [_vm._v("Name:")]), _vm._v(" "), _c('div', {
    staticClass: "col s8 details-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name.current),
      expression: "formData.name.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.name.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyString(_vm.formData.name, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.name, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.name.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please enter your name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s4 right-align details-label"
  }, [_vm._v("Company:")]), _vm._v(" "), _c('div', {
    staticClass: "col s8 details-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.company.current),
      expression: "formData.company.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.company.current)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.company, "current", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s4 right-align details-label"
  }, [_vm._v("Address:")]), _vm._v(" "), _c('div', {
    staticClass: "col s8 details-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.address.current),
      expression: "formData.address.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.address.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyString(_vm.formData.address, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.address, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.address.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please enter your address.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s4 right-align details-label"
  }, [_vm._v("Phone:")]), _vm._v(" "), _c('div', {
    staticClass: "col s8 details-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.phone.current),
      expression: "formData.phone.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.phone.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyString(_vm.formData.phone, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.phone, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.phone.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please enter your phone.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s4 right-align details-label"
  }, [_vm._v("Email:")]), _vm._v(" "), _c('div', {
    staticClass: "col s8 details-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.email.current),
      expression: "formData.email.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.email.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyString(_vm.formData.email, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.email, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.email.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please enter your email.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 center-align"
  }, [(!_vm.submitting) ? _c('button', {
    staticClass: "a3d btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")]) : _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })])])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "webgl-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "webgl-warning-message-wrp"
  }, [_c('div', {
    staticClass: "webgl-warning-message"
  }, [_vm._v("WebGL is unavailable.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f482306", module.exports)
  }
}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticStyle: {
      "height": "100%",
      "text-align": "center"
    }
  }, [_c('h4', [_vm._v("Loading")]), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('div', {
    staticClass: "center-align"
  }, [_c('h5', {
    staticClass: "bold title"
  }, [_vm._v("Enter the quantity of parts desired on the build plate")]), _vm._v(" "), _c('table', {
    staticClass: "highlight"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.filesNested), function(file, pathKey) {
    return _c('tr', {
      key: file.id
    }, [_c('td', [_c('i', {
      staticClass: "material-icons a3d color",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.removeFile(file)
        }
      }
    }, [_vm._v("clear")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "filename"
    }, [_vm._v(_vm._s(file.name))])]), _vm._v(" "), _c('td', [_c('input', {
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": file.quantity
      },
      on: {
        "input": function($event) {
          return _vm.updateQuantity(pathKey, $event)
        }
      }
    }), _vm._v(" "), (file.quantity < 1) ? _c('div', {
      staticClass: "error"
    }, [_vm._v("Quantity should be greater than 0")]) : _vm._e()])])
  }), 0)]), _vm._v(" "), (_vm.submitting) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-buttons"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "a3d btn",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.goNext()
      }
    }
  }, [_vm._v("Next")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader-wrapper small active"
  }, [_c('div', {
    staticClass: "spinner-layer"
  }, [_c('div', {
    staticClass: "circle-clipper left"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gap-patch"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-clipper right"
  }, [_c('div', {
    staticClass: "circle"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "remove-file"
  }), _vm._v(" "), _c('th', [_vm._v("File")]), _vm._v(" "), _c('th', {
    staticClass: "quantity"
  }, [_vm._v("Desired Quantity")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-414352eb", module.exports)
  }
}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.total > 0 && ((_vm.file.archived > 0 && _vm.showArchived) || (_vm.file.unarchived >= 0 && !_vm.showArchived))) ? _c('div', {
    staticClass: "a3d"
  }, [_c('div', {
    staticClass: "file job",
    on: {
      "click": function($event) {
        return _vm.toggleJobs()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "1em",
      "height": "1px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "file-name-block"
  }, [_c('div', {
    staticClass: "file-name"
  }, [_vm._v(_vm._s(_vm.file.name))])]), _vm._v(" "), _c('div', {
    staticClass: "toggleIcon"
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-chevron-up': _vm.isOpen, 'fa-chevron-down': !_vm.isOpen
    }
  })])]), _vm._v(" "), (_vm.isOpen) ? [_vm._l((_vm.file.jobs), function(job, jI) {
    return (!(job.parentPathKey || (job.isNested || job.nestedJobName))) ? [(!_vm.showArchived && job.outputsLoaded && Array.isArray(job.jobOutputs) && job.jobOutputs.length === 0) ? _c('div', {
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_c('div', {
      staticClass: "job jobout"
    }, [_c('div', {
      staticStyle: {
        "flex": "3"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("Unfinished job")]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("dateFormat")(job.createdAt)))])]), _vm._v(" "), _c('div', [(_vm.subscription || _vm.user.credits.length > 0) ? [_c('button', {
      staticClass: "a3d btn small inv",
      staticStyle: {
        "margin-left": "0.5em"
      },
      on: {
        "click": function($event) {
          return _vm.createJob(job.id, job.jobPathKey)
        }
      }
    }, [_vm._v("Create\n                            ")])] : _c('button', {
      staticClass: "a3d btn small",
      staticStyle: {
        "margin-right": "0.5em"
      },
      on: {
        "click": _vm.buymodal
      }
    }, [_vm._v("Buy Subscription")]), _vm._v(" "), _c('button', {
      staticClass: "a3d btn small inv",
      staticStyle: {
        "margin-right": "0.5em"
      },
      on: {
        "click": function($event) {
          return _vm.removeJobConfirmation($event, _vm.file.pathKey, job.jobPathKey)
        }
      }
    }, [_vm._v("Remove\n                        ")])], 2)])]) : _vm._e(), _vm._v(" "), _vm._l((job.jobOutputs), function(jobOutput, joI) {
      return (jobOutput.isArchived === _vm.showArchived && job.hasOwnProperty('jobOutputs')) ? _c('div', {
        key: jobOutput.pathKey,
        staticStyle: {
          "margin-left": "30px"
        }
      }, [(jobOutput.paidfor || _vm.subscription || jobOutput.status === 'ERROR') ? [_c('div', {
        staticClass: "job jobout",
        on: {
          "click": function($event) {
            return _vm.toggleJobsFiles(jI, joI)
          }
        }
      }, [(_vm.compareMode && _vm.isCost(jobOutput.outputFiles)) ? _c('input', {
        staticClass: "filled-in",
        attrs: {
          "type": "checkbox",
          "id": jobOutput.jobOutputPathKey
        },
        domProps: {
          "checked": _vm.filesCompare[jobOutput.jobOutputPathKey]
        },
        on: {
          "change": function($event) {
            return _vm.toggleJobCompare({
              jobOutput: jobOutput,
              job: job
            })
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('label', {
        attrs: {
          "for": jobOutput.jobOutputPathKey
        }
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "flex": "3"
        }
      }, [_c('div', {
        staticClass: "name"
      }, [_vm._v("\n                                " + _vm._s(_vm.jobDescription(jobOutput.analysisId, jobOutput.objectiveId, false)) + "\n                            ")]), _vm._v(" "), (job.jobDescription) ? _c('div', {
        staticClass: "description"
      }, [_vm._v(_vm._s(job.jobDescription))]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_vm._v(_vm._s(_vm._f("dateFormat")(job.createdAt)))])]), _vm._v(" "), (jobOutput.outputFiles && jobOutput.outputFiles.length >= 0) ? _c('div', {
        staticClass: "jobout-buttons"
      }, [_c('div', {
        staticClass: "jobout-buttons-row"
      }, [(jobOutput.outputFiles && jobOutput.outputFiles.length > 0) ? [_c('router-link', {
        staticClass: "a3d btn inv small",
        attrs: {
          "to": {
            name: 'ThreeJSViewer',
            params: {
              id: jobOutput.id,
              type: 'output'
            }
          }
        }
      }, [_vm._v("\n                                        View\n                                    ")])] : _vm._e(), _vm._v(" "), (jobOutput.isArchived) ? _c('button', {
        staticClass: "a3d btn small inv",
        attrs: {
          "disabled": _vm.unarchivingProcess[jobOutput.jobOutputPathKey]
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.unarchiveJob({
              sourceFilePathKey: _vm.file.pathKey,
              jobPathKey: job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v(_vm._s(_vm.unarchivingProcess[jobOutput.jobOutputPathKey] ? 'Unarchiving...' : 'Unarchive'))]) : _vm._e(), _vm._v(" "), (!jobOutput.isArchived) ? _c('button', {
        staticClass: "a3d btn small inv",
        attrs: {
          "disabled": _vm.archivingProcess[jobOutput.jobOutputPathKey]
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.archiveJob({
              sourceFilePathKey: _vm.file.pathKey,
              jobPathKey: job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v(_vm._s(_vm.archivingProcess[jobOutput.jobOutputPathKey] ? 'Archiving...' : 'Archive'))]) : _vm._e(), _vm._v(" "), _c('button', {
        staticClass: "a3d btn small",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.resubmitJobConfirmation($event, {
              sourceFilePathKey: _vm.file.pathKey,
              filename: _vm.file.name,
              jobPathKey: job.jobPathKey,
              jobConfig: job.config,
              jobDescription: job.jobDescription,
              jobAnalysisId: jobOutput.analysisId,
              jobObjectiveId: jobOutput.objectiveId
            })
          }
        }
      }, [_vm._v("Re-Submit")])], 2), _vm._v(" "), (_vm.isHasOutput(jobOutput.outputFiles)) ? _c('div', {
        staticClass: "jobout-buttons-row"
      }, [_c('router-link', {
        staticClass: "a3d btn inv small",
        attrs: {
          "to": {
            name: 'ThreeJSViewer',
            params: {
              id: jobOutput.id,
              type: 'output'
            },
            query: {
              modifySupports: true
            }
          }
        }
      }, [_vm._v("Modify Supports")]), _vm._v(" "), (_vm.isHasLog(jobOutput.outputFiles)) ? _c('button', {
        staticClass: "right a3d btn small",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.fileDownload($event, {
              filename: _vm.isHasLog(jobOutput.outputFiles),
              sourceFilePathKey: _vm.file.pathKey,
              jobPathKey: job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey,
              newTab: true
            })
          }
        }
      }, [_vm._v("Download optimization log")]) : _vm._e(), _vm._v(" "), (_vm.isHasConfigJson(jobOutput.outputFiles)) ? _c('button', {
        staticClass: "right a3d btn small",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.fileDownload($event, {
              filename: _vm.isHasConfigJson(jobOutput.outputFiles),
              sourceFilePathKey: _vm.file.pathKey,
              jobPathKey: job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey,
              newTab: true
            })
          }
        }
      }, [_vm._v("Download config")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (jobOutput.paidfor || _vm.subscription || jobOutput.status === 'ERROR') ? _c('div', {
        staticClass: "toggleIcon"
      }, [_c('i', {
        staticClass: "fa",
        class: {
          'fa-chevron-up': _vm.jobsFilesToggle[jI][joI], 'fa-chevron-down': !_vm.jobsFilesToggle[jI][joI]
        }
      })]) : _vm._e()])] : [_c('div', {
        staticClass: "job jobout"
      }, [_c('div', [_c('div', [_c('i', [_vm._v(_vm._s(_vm.jobDescription(jobOutput.analysisId, jobOutput.objectiveId)))]), _vm._v("\n                                is not yet unlocked.\n                            ")]), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_vm._v(_vm._s(_vm._f("dateFormat")(job.createdAt)))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "flex-grow": "1",
          "flex-basis": "50%",
          "align-self": "center"
        }
      }, [(_vm.user.credits.length > 0) ? _c('button', {
        staticClass: "right a3d btn small inv",
        staticStyle: {
          "margin-right": "0.5em"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.unlockJob($event, jobOutput, job)
          }
        }
      }, [_vm._v("Unlock"), _c('br'), _vm._v("(1 credit)\n                            ")]) : _c('a', {
        staticClass: "a3d btn small right",
        on: {
          "click": _vm.buymodal
        }
      }, [_vm._v("Buy Subscription")])])])], _vm._v(" "), (_vm.jobsFilesToggle[jI][joI] && (jobOutput.paidfor || _vm.subscription || jobOutput.status === 'ERROR')) ? [(jobOutput.outputFiles && jobOutput.outputFiles.length > 0) ? _c('div', [_vm._l((jobOutput.outputFiles), function(outputFile, ofI) {
        return (!outputFile.name.match(/\.json$/)) ? _c('div', {
          key: outputFile.name,
          staticStyle: {
            "margin-left": "40px"
          }
        }, [(outputFile.name.match(/^1_.*_0m\.stl$/) &&
          (!outputFile.name.match(/_compensated_0m\.stl$/) &&
            !outputFile.name.match(/_compensated_Renishaw_0m\.stl$/) &&
            !outputFile.name.match(/_compensated_strengthen_0m\.stl$/))) ? _c('div', {
          staticClass: "job jobout jobfile"
        }, [(outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                    Support Structure Renishaw\n                                ")]) : (outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                    Support Structure Polymer\n                                ")]) : (outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                    Strengthening support\n                                ")]) : (!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                    Support Structure\n                                ")]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "button-block right"
        }, [(!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) && !outputFile.name.match(/^1_magicSupp_0m\.stl$/) && !outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('dropdown', {
          attrs: {
            "position": ['center', 'top', 'center', 'top'],
            "visible": !!(_vm.jobsFilesSupportVisible[jI][joI])
          },
          on: {
            "clickout": function($event) {
              return _vm.visibleJobsFilesSupport(jI, joI)
            }
          }
        }, [_c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.visibleJobsFilesSupport(jI, joI)
            }
          }
        }, [_vm._v("\n                                            Download "), _c('i', {
          staticClass: "fa fa-angle-down"
        })]), _vm._v(" "), _c('div', {
          staticClass: "dialog no-padding",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('aside', {
          staticClass: "menu"
        }, [_c('ul', {
          staticClass: "menu-list"
        }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
          return (outputFileNested.name.match(/^1_.*_0m\.[\S]{3}$/) &&
            !outputFileNested.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) &&
            !outputFileNested.name.match(/_compensated_0m\.[\S]{3}$/) &&
            !outputFileNested.name.match(/_compensated_(Renishaw|strengthen)_0m\.[\S]{3}$/) &&
            !outputFileNested.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('li', {
            key: ofNI + outputFileNested.name
          }, [_c('button', {
            staticClass: "a3d btn inv small",
            on: {
              "click": function($event) {
                _vm.fileDownload($event, {
                  filename: outputFileNested.name,
                  sourceFilePathKey: _vm.file.pathKey,
                  jobPathKey: job.jobPathKey,
                  jobOutputPathKey: jobOutput.jobOutputPathKey
                });
                _vm.visibleJobsFilesSupport(jI, joI)
              }
            }
          }, [_vm._v("\n                                                            Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                                        ")])]) : _vm._e()
        }), 0)])])]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)) ? _c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.fileDownload($event, {
                filename: outputFile.name,
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("\n                                        Download STL\n                                    ")]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.fileDownload($event, {
                filename: outputFile.name,
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("\n                                        Download STL\n                                    ")]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)) ? _c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.fileDownload($event, {
                filename: outputFile.name,
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("\n                                        Download STL\n                                    ")]) : _vm._e()], 1)]) : (outputFile.name.match(/(.*)_output\.stl$/) || outputFile.name.match(/(.*)_new\.stl$/)) ? _c('div', {
          staticClass: "job jobout jobfile"
        }, [_c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                    Oriented Part\n                                ")]), _vm._v(" "), _c('div', {
          staticClass: "button-block right"
        }, [(_vm.isCost(jobOutput.outputFiles) && outputFile.name.match(/(.*)\.stl$/)) ? _c('button', {
          staticClass: "a3d btn inv small",
          on: {
            "click": function($event) {
              return _vm.showEstimateCost($event, {
                filename: 'cost.json',
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("Estimate print costs")]) : _vm._e(), _vm._v(" "), _c('dropdown', {
          attrs: {
            "position": ['center', 'top', 'center', 'top'],
            "visible": !!(_vm.jobsFilesPartVisible[jI][joI])
          },
          on: {
            "clickout": function($event) {
              return _vm.visibleJobsFilesPart(jI, joI, false)
            }
          }
        }, [_c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.visibleJobsFilesPart(jI, joI)
            }
          }
        }, [_vm._v("\n                                            Download "), _c('i', {
          staticClass: "fa fa-angle-down"
        })]), _vm._v(" "), _c('div', {
          staticClass: "dialog no-padding",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('aside', {
          staticClass: "menu"
        }, [_c('ul', {
          staticClass: "menu-list"
        }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
          return (outputFileNested.name.match(/^(.*)_output\.(?!(txt)$)([^.]{3}$)/) || outputFileNested.name.match(/^.*_new\.[\S]{3}$/)) ? _c('li', {
            key: ofNI + outputFileNested.name
          }, [_c('button', {
            staticClass: "a3d btn inv small",
            on: {
              "click": function($event) {
                _vm.fileDownload($event, {
                  filename: outputFileNested.name,
                  sourceFilePathKey: _vm.file.pathKey,
                  jobPathKey: job.jobPathKey,
                  jobOutputPathKey: jobOutput.jobOutputPathKey
                });
                _vm.visibleJobsFilesPart(jI, joI)
              }
            }
          }, [_vm._v("\n                                                            Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                                        ")])]) : _vm._e()
        }), 0)])])])], 1)]) : _vm._e()]) : _vm._e()
      }), _vm._v(" "), (_vm.getTempList(jI, joI).length) ? _c('div', {
        staticStyle: {
          "margin-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.toggleTemperatureFiles(jI, joI)
          }
        }
      }, [_c('div', {
        staticClass: "job jobout jobfile"
      }, [_c('div', {
        staticClass: "file-name-nested"
      }, [_vm._v("\n                              Temperature\n                            ")]), _vm._v(" "), _c('div', {
        staticClass: "button-block right"
      }, [_c('div', {
        staticClass: "a3d btn small nowrap",
        on: {
          "click": function($event) {
            _vm.allFilesDownload($event, {
              list: _vm.getTempList(jI, joI),
              sourceFilePathKey: _vm.file.pathKey,
              jobPathKey: job.jobPathKey,
              jobOutputPathKey: jobOutput.jobOutputPathKey
            })
          }
        }
      }, [_vm._v("\n                                  Download all\n                              ")])]), _vm._v(" "), _c('div', {
        staticClass: "toggleIcon"
      }, [_c('i', {
        staticClass: "fa",
        class: {
          'fa-chevron-up': _vm.temperatureFilesToggle[jI, joI], 'fa-chevron-down': !_vm.temperatureFilesToggle[jI][joI]
        }
      })])]), _vm._v(" "), (_vm.temperatureFilesToggle[jI][joI]) ? [_c('div', {
        staticStyle: {
          "margin-left": "40px"
        }
      }, _vm._l((_vm.getTempList(jI, joI)), function(tempFile, i) {
        return _c('div', {
          key: 'tempDec' + i,
          staticClass: "job jobout jobfile"
        }, [_c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                  " + _vm._s(tempFile.name) + "\n                                ")]), _vm._v(" "), _c('div', {
          staticClass: "button-block right"
        }, [_c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.fileDownload($event, {
                filename: tempFile.name,
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("\n                                      Download\n                                  ")])])])
      }), 0)] : _vm._e()], 2) : _vm._e()], 2) : _c('div', [_c('div', {
        staticStyle: {
          "margin-left": "40px"
        }
      }, [_c('div', {
        staticClass: "job jobout job-status"
      }, [_c('div', {
        staticClass: "job-status-message"
      }, [_vm._v("\n                                    " + _vm._s(_vm.displayMessage(jobOutput.status)) + "\n                                    "), (jobOutput.status === 'PROCESSING') ? _c('span', [_vm._v(_vm._s(jobOutput.progress) + "%")]) : _vm._e()]), _vm._v(" "), (jobOutput.status === 'PROCESSING') ? _c('div', {
        staticClass: "progress"
      }, [_c('div', {
        staticClass: "determinate",
        style: ({
          width: jobOutput.progress + '%'
        })
      })]) : _vm._e()])])])] : _vm._e(), _vm._v(" "), (_vm.isHasCompensated(jobOutput.outputFiles) && (jobOutput.paidfor || _vm.subscription)) ? _c('div', {
        staticClass: "job jobout",
        on: {
          "click": function($event) {
            return _vm.toggleJobsFilesCompensated(jI, joI)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "flex": "3"
        }
      }, [_c('div', {
        staticClass: "name"
      }, [_vm._v("\n                            " + _vm._s(_vm.jobDescription(jobOutput.analysisId, jobOutput.objectiveId, true)) + "\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_vm._v(_vm._s(_vm._f("dateFormat")(job.createdAt)))])]), _vm._v(" "), _c('div', {
        staticClass: "jobout-buttons"
      }, [_c('div', {
        staticClass: "jobout-buttons-row"
      }, [_c('router-link', {
        staticClass: "a3d btn inv small",
        attrs: {
          "to": {
            name: 'ThreeJSViewer',
            params: {
              id: jobOutput.id,
              type: 'output'
            },
            query: {
              compensated: true
            }
          }
        }
      }, [_vm._v("\n                                View\n                            ")])], 1)]), _vm._v(" "), _c('div', {
        staticClass: "toggleIcon"
      }, [_c('i', {
        staticClass: "fa",
        class: {
          'fa-chevron-up': _vm.jobsFilesCompensatedToggle[jI][joI], 'fa-chevron-down': !_vm.jobsFilesCompensatedToggle[jI][joI]
        }
      })])]) : _vm._e(), _vm._v(" "), (jobOutput.outputFiles && jobOutput.outputFiles.length > 0 && _vm.jobsFilesCompensatedToggle[jI][joI] && (jobOutput.paidfor || _vm.subscription)) ? _vm._l((jobOutput.outputFiles), function(outputFile, ofI) {
        return (!outputFile.name.match(/\.json$/)) ? _c('div', {
          key: outputFile.name + "_compensated",
          staticStyle: {
            "margin-left": "40px"
          }
        }, [(outputFile.name.match(/_compensated_0m\.stl$/) || outputFile.name.match(/_compensated_Renishaw_0m\.stl$/) || outputFile.name.match(/_compensated_strengthen_0m\.stl$/)) ? _c('div', {
          staticClass: "job jobout jobfile"
        }, [(outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                Support Structure Renishaw\n                            ")]) : (outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                Support Structure Polymer \n                            ")]) : (outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                Strengthening support\n                            ")]) : (!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/)) ? _c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                Support Structure\n                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "button-block right"
        }, [(!outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/) && !outputFile.name.match(/^1_magicSupp_0m\.stl$/) && !outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('dropdown', {
          attrs: {
            "position": ['center', 'top', 'center', 'top'],
            "visible": !!(_vm.jobsFilesSupportCompensatedVisible[jI][joI])
          },
          on: {
            "clickout": function($event) {
              return _vm.visibleJobsFilesSupportCompensated(jI, joI)
            }
          }
        }, [_c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.visibleJobsFilesSupportCompensated(jI, joI)
            }
          }
        }, [_vm._v("\n                                        Download "), _c('i', {
          staticClass: "fa fa-angle-down"
        })]), _vm._v(" "), _c('div', {
          staticClass: "dialog no-padding",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('aside', {
          staticClass: "menu"
        }, [_c('ul', {
          staticClass: "menu-list"
        }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
          return (outputFileNested.name.match(/^1_.*_0m\.[\S]{3}$/) &&
            !outputFileNested.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) &&
            !outputFileNested.name.match(/^1_magicSupp_0m\.stl$/) &&
            !outputFileNested.name.match(/^1_polymerSupp.*_0m\.stl$/) &&
            (outputFileNested.name.match(/_compensated_0m\.[\S]{3}$/) ||
              outputFileNested.name.match(/_compensated_Renishaw_0m\.[\S]{3}$/))) ? _c('li', {
            key: ofNI + outputFileNested.name
          }, [_c('button', {
            staticClass: "a3d btn inv small",
            on: {
              "click": function($event) {
                _vm.fileDownload($event, {
                  filename: outputFileNested.name,
                  sourceFilePathKey: _vm.file.pathKey,
                  jobPathKey: job.jobPathKey,
                  jobOutputPathKey: jobOutput.jobOutputPathKey
                });
                _vm.visibleJobsFilesSupportCompensated(jI, joI)
              }
            }
          }, [_vm._v("\n                                                        Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                                    ")])]) : _vm._e()
        }), 0)])])]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)) ? _c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.fileDownload($event, {
                filename: outputFile.name,
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("\n                                    Download STL\n                                ")]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)) ? _c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.fileDownload($event, {
                filename: outputFile.name,
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("\n                                    Download STL\n                                ")]) : _vm._e(), _vm._v(" "), (outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)) ? _c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.fileDownload($event, {
                filename: outputFile.name,
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("\n                                    Download STL\n                                ")]) : _vm._e()], 1)]) : (outputFile.name.match(/output_compensated\.stl$/)) ? _c('div', {
          staticClass: "job jobout jobfile"
        }, [_c('div', {
          staticClass: "file-name-nested"
        }, [_vm._v("\n                                Oriented Part\n                            ")]), _vm._v(" "), _c('div', {
          staticClass: "button-block right"
        }, [(_vm.isCost(jobOutput.outputFiles) && outputFile.name.match(/(.*)\.stl$/)) ? _c('button', {
          staticClass: "a3d btn inv small nowrap",
          on: {
            "click": function($event) {
              return _vm.showEstimateCost($event, {
                filename: 'cost.json',
                sourceFilePathKey: _vm.file.pathKey,
                jobPathKey: job.jobPathKey,
                jobOutputPathKey: jobOutput.jobOutputPathKey
              })
            }
          }
        }, [_vm._v("Estimate print costs")]) : _vm._e(), _vm._v(" "), _c('dropdown', {
          attrs: {
            "position": ['center', 'top', 'center', 'top'],
            "visible": !!(_vm.jobsFilesPartCompensatedVisible[jI][joI])
          },
          on: {
            "clickout": function($event) {
              return _vm.visibleJobsFilesPartCompensated(jI, joI)
            }
          }
        }, [_c('div', {
          staticClass: "a3d btn small nowrap",
          on: {
            "click": function($event) {
              return _vm.visibleJobsFilesPartCompensated(jI, joI)
            }
          }
        }, [_vm._v("\n                                        Download "), _c('i', {
          staticClass: "fa fa-angle-down"
        })]), _vm._v(" "), _c('div', {
          staticClass: "dialog no-padding",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('aside', {
          staticClass: "menu"
        }, [_c('ul', {
          staticClass: "menu-list"
        }, _vm._l((jobOutput.outputFiles), function(outputFileNested, ofNI) {
          return (outputFileNested.name.match(/output_compensated\.[\S]{3}$/)) ? _c('li', {
            key: ofNI + outputFileNested.name
          }, [_c('button', {
            staticClass: "a3d btn inv small",
            on: {
              "click": function($event) {
                _vm.fileDownload($event, {
                  filename: outputFileNested.name,
                  sourceFilePathKey: _vm.file.pathKey,
                  jobPathKey: job.jobPathKey,
                  jobOutputPathKey: jobOutput.jobOutputPathKey
                });
                _vm.visibleJobsFilesPartCompensated(jI, joI)
              }
            }
          }, [_vm._v("\n                                                        Download " + _vm._s(outputFileNested.name.slice(-3).toUpperCase()) + "\n                                                    ")])]) : _vm._e()
        }), 0)])])])], 1)]) : _vm._e()]) : _vm._e()
      }) : _vm._e()], 2) : _vm._e()
    })] : _vm._e()
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), (_vm.isCanLoadMore && !_vm.isLoading) ? _c('div', {
    staticClass: "load-more"
  }, [_c('div', {
    staticClass: "job jobout align-center"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.loadMore(_vm.loaded)
      }
    }
  }, [_vm._v("Load more")])])]) : _vm._e()] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-49a3b049", module.exports)
  }
}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.failure) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _c('div', [(_vm.initing) ? _c('div', {
    staticStyle: {
      "height": "100%",
      "text-align": "center"
    }
  }, [_c('h4', [_vm._v("Loading")]), _vm._v(" "), _vm._m(1)]) : [(_vm.nestedMode) ? _c('div', {
    staticClass: "startjobtitle"
  }, [_c('div', {
    staticClass: "center-align"
  }, [_c('h5', {
    staticClass: "bold startjob"
  }, [_vm._v("Start Nested Job: " + _vm._s(_vm.nestedJobName))]), _vm._v(" "), _c('h5', {
    staticClass: "bold startjob"
  }, [_vm._v("Choose your orientation optimization")])]), _vm._v(" "), (!_vm.subscription) ? _c('div', {
    staticClass: "center-align startjob"
  }, [_c('p', {
    staticClass: "startjob"
  }, [_vm._v("This job costs " + _vm._s(_vm.costString) + ". 1 credit for each part file to be nested.\n                    "), _c('buy-credits', {
    attrs: {
      "showModal": _vm.showModal
    },
    on: {
      "update:showModal": function($event) {
        _vm.showModal = $event
      },
      "update:show-modal": function($event) {
        _vm.showModal = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "display",
      fn: function(props) {
        return _c('a', {
          on: {
            "click": props.open
          }
        }, [_vm._v("Buy Subscription")])
      }
    }], null, false, 2185934191)
  })], 1)]) : _vm._e()]) : _c('div', {
    staticClass: "startjobtitle"
  }, [_vm._m(2), _vm._v(" "), (!_vm.subscription) ? _c('div', {
    staticClass: "center-align startjob"
  }, [_c('p', {
    staticClass: "startjob"
  }, [_vm._v("This job costs " + _vm._s(_vm.costString) + ".\n                    "), _c('buy-credits', {
    attrs: {
      "showModal": _vm.showModal
    },
    on: {
      "update:showModal": function($event) {
        _vm.showModal = $event
      },
      "update:show-modal": function($event) {
        _vm.showModal = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "display",
      fn: function(props) {
        return _c('a', {
          on: {
            "click": props.open
          }
        }, [_vm._v("Buy Subscription")])
      }
    }], null, false, 2185934191)
  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.nestedMode) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 center-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partParamsAll),
      expression: "partParamsAll"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "useForAll"
    },
    domProps: {
      "checked": Array.isArray(_vm.partParamsAll) ? _vm._i(_vm.partParamsAll, null) > -1 : (_vm.partParamsAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.partParamsAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.partParamsAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.partParamsAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.partParamsAll = $$c
        }
      }, function($event) {
        return _vm.switchPartParamAll()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "useForAll"
    }
  }, [_vm._v("Use the same parameters for all nested parts")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(!_vm.partParamsAll) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('div', {
    staticClass: "block-dots top center-align"
  }, _vm._l((_vm.files), function(fileObj, index) {
    return _c('div', {
      key: fileObj.id,
      staticClass: "tooltip-wrp"
    }, [_c('div', {
      staticClass: "file-dot",
      class: {
        'selected': index === _vm.fileIndex
      },
      on: {
        "click": function($event) {
          return _vm.switchFile(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tooltip"
    }, [_c('span', {
      staticClass: "tooltipvalue"
    }, [_vm._v(_vm._s(fileObj.name))])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "inline-flex"
    }
  }, [_c('div', {
    staticClass: "col s4 a3dlightgray",
    staticStyle: {
      "border-right": "6px solid white",
      "position": "relative"
    }
  }, [(_vm.expertAdvice || _vm.files[_vm.fileIndex].optMinDist || _vm.files[_vm.fileIndex].optMaxDist) ? _c('div', {
    staticClass: "info-overlay"
  }, [_c('div', {
    staticClass: "blur"
  }), _vm._v(" "), _c('div', {
    staticClass: "content valign-wrapper"
  }, [_c('h6', {
    staticClass: "bold startjobtitle"
  }, [_vm._v("\n                                In order to select weights, please deselect " + _vm._s(_vm.selectedColumn) + ".")])])]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "bold startjobtitle"
  }, [_vm._v("\n                        Use the experience of \"Design for Additive\" experts by weighing each of the following 3 factors:")]), _vm._v(" "), _c('div', {
    staticClass: "startjobtitle"
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('p', [_vm._v("Minimum Build Time")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.files[_vm.fileIndex].weights[0]),
      expression: "files[fileIndex].weights[0]",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "range",
      "id": "minbuildtime",
      "min": "0",
      "max": "1",
      "step": "any",
      "disabled": _vm.files[_vm.fileIndex].optMinDist || _vm.loading
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].weights[0])
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.files[_vm.fileIndex].weights, 0, _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Minimum Material Consumption")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.files[_vm.fileIndex].weights[1]),
      expression: "files[fileIndex].weights[1]",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "range",
      "id": "minmaterialconsumption",
      "min": "0",
      "max": "1",
      "step": "any",
      "disabled": _vm.files[_vm.fileIndex].optMinDist || _vm.loading
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].weights[1])
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.files[_vm.fileIndex].weights, 1, _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Minimum Support Structure Removal")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.files[_vm.fileIndex].weights[2]),
      expression: "files[fileIndex].weights[2]",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "range",
      "id": "minsupportstructure",
      "min": "0",
      "max": "1",
      "step": "any",
      "disabled": _vm.files[_vm.fileIndex].optMinDist || _vm.loading
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].weights[2])
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.files[_vm.fileIndex].weights, 2, _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('p', [_vm._v("Minimum Distortion")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.files[_vm.fileIndex].weights[3]),
      expression: "files[fileIndex].weights[3]",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "range",
      "id": "minimumdistortion",
      "min": "0",
      "max": "1",
      "step": "any",
      "disabled": _vm.files[_vm.fileIndex].optMinDist || _vm.loading
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].weights[3])
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.files[_vm.fileIndex].weights, 3, _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col s4 a3dlightgray",
    staticStyle: {
      "border-left": "6px solid white"
    }
  }, [_c('div', {
    staticClass: "startjobtitle"
  }, [(_vm.nestedMode) ? _c('h6', {
    staticClass: "bold"
  }, [_vm._v("\n                            Maximize part density while minimizing thermal distortion for each part.\n                        ")]) : _c('h6', {
    staticClass: "bold"
  }, [_vm._v("\n                            Use Siemens proven ability to computationally minimize thermal distortion.\n                        ")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('p', {
    staticClass: "startjobor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].optMinDist),
      expression: "files[fileIndex].optMinDist"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "mindistortion",
      "disabled": (_vm.expertAdvice || _vm.files[_vm.fileIndex].optMaxDist) || _vm.loading,
      "checked": "unchecked"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[_vm.fileIndex].optMinDist) ? _vm._i(_vm.files[_vm.fileIndex].optMinDist, null) > -1 : (_vm.files[_vm.fileIndex].optMinDist)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.files[_vm.fileIndex].optMinDist,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[_vm.fileIndex], "optMinDist", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[_vm.fileIndex], "optMinDist", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[_vm.fileIndex], "optMinDist", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "mindistortion"
    }
  }, [_vm._v("Minimal distortion is most important")])]), _vm._v(" "), (_vm.files[_vm.fileIndex].optMinDist) ? _c('p', {
    staticClass: "startjobor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].isHeatTreatment),
      expression: "files[fileIndex].isHeatTreatment"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isHeatTreatment",
      "disabled": (_vm.expertAdvice || _vm.files[_vm.fileIndex].optMaxDist) || _vm.loading,
      "checked": "unchecked"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[_vm.fileIndex].isHeatTreatment) ? _vm._i(_vm.files[_vm.fileIndex].isHeatTreatment, null) > -1 : (_vm.files[_vm.fileIndex].isHeatTreatment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.files[_vm.fileIndex].isHeatTreatment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[_vm.fileIndex], "isHeatTreatment", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[_vm.fileIndex], "isHeatTreatment", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[_vm.fileIndex], "isHeatTreatment", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isHeatTreatment"
    }
  }, [_vm._v("Perform \"stress relief\" before removing parts from the build plate")])]) : _vm._e(), _vm._v(" "), (_vm.files[_vm.fileIndex].optMinDist) ? _c('p', {
    staticClass: "startjobor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].isMinPeeling),
      expression: "files[fileIndex].isMinPeeling"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isMinPeeling",
      "disabled": (_vm.expertAdvice || _vm.files[_vm.fileIndex].optMaxDist) || _vm.loading,
      "checked": "unchecked"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[_vm.fileIndex].isMinPeeling) ? _vm._i(_vm.files[_vm.fileIndex].isMinPeeling, null) > -1 : (_vm.files[_vm.fileIndex].isMinPeeling)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.files[_vm.fileIndex].isMinPeeling,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[_vm.fileIndex], "isMinPeeling", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[_vm.fileIndex], "isMinPeeling", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[_vm.fileIndex], "isMinPeeling", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isMinPeeling"
    }
  }, [_vm._v("Minimal recoater interference is more important than overall dimensional accurary.")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col s4 a3dlightgray",
    staticStyle: {
      "border-left": "6px solid white"
    }
  }, [_c('div', {
    staticClass: "startjobtitle"
  }, [(_vm.nestedMode) ? _c('h6', {
    staticClass: "bold"
  }, [_vm._v("\n                            Minimize build time while controlling thermal distortion for each part.\n                        ")]) : _c('h6', {
    staticClass: "bold"
  }, [_vm._v("\n                            Use Siemens ability to find the least amount of build time within a constraint.\n                        ")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('p', {
    staticClass: "startjobor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].optMaxDist),
      expression: "files[fileIndex].optMaxDist"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "maxDistFlag",
      "disabled": (_vm.expertAdvice || _vm.files[_vm.fileIndex].optMinDist) || _vm.loading
    },
    domProps: {
      "checked": Array.isArray(_vm.files[_vm.fileIndex].optMaxDist) ? _vm._i(_vm.files[_vm.fileIndex].optMaxDist, null) > -1 : (_vm.files[_vm.fileIndex].optMaxDist)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.files[_vm.fileIndex].optMaxDist,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[_vm.fileIndex], "optMaxDist", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[_vm.fileIndex], "optMaxDist", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[_vm.fileIndex], "optMaxDist", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "maxDistFlag"
    }
  }, [_vm._v("Set a limit on maximum thermal distortion")])])]), _vm._v(" "), (_vm.files[_vm.fileIndex].optMaxDist) ? _c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n                                What is the maximum thermal distortion allowable on this part? +/-\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "input-field inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].maxDist),
      expression: "files[fileIndex].maxDist"
    }],
    attrs: {
      "id": "maxDist",
      "type": "number",
      "min": "0",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].maxDist)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[_vm.fileIndex], "maxDist", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "maxDist"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("\n                                millimeters\n                            ")]), _vm._v(" "), (Array.isArray(_vm.validationError) && _vm.validationError[_vm.fileIndex]) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n                                " + _vm._s(_vm.validationError[_vm.fileIndex]) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "startjobor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].isHeatTreatment),
      expression: "files[fileIndex].isHeatTreatment"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isHeatTreatment",
      "disabled": (_vm.expertAdvice || _vm.files[_vm.fileIndex].optMinDist) || _vm.loading,
      "checked": "unchecked"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[_vm.fileIndex].isHeatTreatment) ? _vm._i(_vm.files[_vm.fileIndex].isHeatTreatment, null) > -1 : (_vm.files[_vm.fileIndex].isHeatTreatment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.files[_vm.fileIndex].isHeatTreatment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[_vm.fileIndex], "isHeatTreatment", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[_vm.fileIndex], "isHeatTreatment", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[_vm.fileIndex], "isHeatTreatment", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isHeatTreatment"
    }
  }, [_vm._v("Perform \"stress relief\" before removing parts from the build plate")])]), _vm._v(" "), (_vm.files[_vm.fileIndex].optMinDist) ? _c('p', {
    staticClass: "startjobor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].isMinPeeling),
      expression: "files[fileIndex].isMinPeeling"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isMinPeeling",
      "disabled": (_vm.expertAdvice || _vm.files[_vm.fileIndex].optMaxDist) || _vm.loading,
      "checked": "unchecked"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[_vm.fileIndex].isMinPeeling) ? _vm._i(_vm.files[_vm.fileIndex].isMinPeeling, null) > -1 : (_vm.files[_vm.fileIndex].isMinPeeling)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.files[_vm.fileIndex].isMinPeeling,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[_vm.fileIndex], "isMinPeeling", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[_vm.fileIndex], "isMinPeeling", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[_vm.fileIndex], "isMinPeeling", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isMinPeeling"
    }
  }, [_vm._v("Minimal recoater interference is more important than overall dimensional accurary.")])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), (!_vm.partParamsAll) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('div', {
    staticClass: "block-dots bottom center-align"
  }, _vm._l((_vm.files), function(fileObj, index) {
    return _c('div', {
      key: fileObj.id,
      staticClass: "tooltip-wrp"
    }, [_c('div', {
      staticClass: "file-dot",
      class: {
        'selected': index === _vm.fileIndex
      },
      on: {
        "click": function($event) {
          return _vm.switchFile(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tooltip"
    }, [_c('span', {
      staticClass: "tooltipvalue"
    }, [_vm._v(_vm._s(fileObj.name))])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.nestedMode) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "a3dlightgray col s12 restrictions-block"
  }, [_c('div', {
    staticClass: "restrictions"
  }, [_c('div', {
    staticClass: "restriction"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optimizationConstrain),
      expression: "optimizationConstrain"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "optimizationConstrain",
      "disabled": _vm.loading || _vm.submitting
    },
    domProps: {
      "checked": Array.isArray(_vm.optimizationConstrain) ? _vm._i(_vm.optimizationConstrain, null) > -1 : (_vm.optimizationConstrain)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.optimizationConstrain,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.optimizationConstrain = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.optimizationConstrain = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.optimizationConstrain = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "optimizationConstrain"
    }
  }, [_vm._v("Constrain the optimization to a range of orientations and/or specify faces of the part where supports should not be attached")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading && _vm.statusMessage) ? _c('div', {
    staticClass: "col s12 center-align status-message"
  }, [_vm._v("\n                    " + _vm._s(_vm.statusMessage) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "progress"
  }, [(_vm.remeshingPart && _vm.remeshingProgress > 0) ? _c('div', {
    staticClass: "determinate",
    style: ({
      width: _vm.remeshingProgress * 100 + '%'
    })
  }) : _c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "col s12 center-align"
  }, [(_vm.subscription || _vm.user.credits.length >= this.files.length) ? _c('a', {
    staticClass: "btn a3d",
    on: {
      "click": _vm.validate
    }
  }, [(_vm.subscription) ? [_vm._v("\n                                Start job\n                            ")] : [_vm._v("\n                                Start job (" + _vm._s(_vm.costString) + ")\n                            ")]], 2) : [_c('a', {
    staticClass: "a3d btn",
    on: {
      "click": _vm.buymodal
    }
  }, [_vm._v("Buy Subscription")]), _vm._v(" "), _c('div', {
    staticClass: "note bold"
  }, [_vm._v("This job costs " + _vm._s(_vm.costString))])]], 2), _vm._v(" "), (_vm.nestedMode && !_vm.subscription) ? _c('div', {
    staticClass: "col s12 center-align note"
  }, [_vm._v("\n                        1 credit for each part file to be nested.\n                    ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('modal', {
    ref: "summarymodal",
    attrs: {
      "name": "summarymodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "75%"
    }
  }, [_c('job-summary', {
    attrs: {
      "config": _vm.files[0].config,
      "jobDescription": _vm.jobDescription,
      "submit": _vm.submitSingle
    }
  })], 1)]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s6 offset-s3 center-align",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h5', [_vm._v("\n            There was a problem processing your file.  We will return to you to the dashboard in a few seconds.  If this consumed one of your credits, please contact us with details and we will correct this.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader-wrapper small active"
  }, [_c('div', {
    staticClass: "spinner-layer"
  }, [_c('div', {
    staticClass: "circle-clipper left"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gap-patch"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-clipper right"
  }, [_c('div', {
    staticClass: "circle"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-align"
  }, [_c('h5', {
    staticClass: "bold startjob"
  }, [_vm._v("Start Job: choose your orientation optimization")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c0f179e", module.exports)
  }
}

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rootDiv"
    }
  }, [_c('alert'), _vm._v(" "), _c('webgl-detect'), _vm._v(" "), _c('router-view', {
    key: _vm.$route.fullPath
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6fe9077c", module.exports)
  }
}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.failure) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _c('div', [(_vm.fileLoading) ? _c('div', {
    staticStyle: {
      "height": "100%",
      "text-align": "center"
    }
  }, [_c('h4', [_vm._v("Loading")]), _vm._v(" "), _vm._m(1)]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('div', {
    staticClass: "center-align startjobor"
  }, [_c('h4', {
    staticClass: "bold title"
  }, [_vm._v("\n                        " + _vm._s(_vm.nestedMode ? 'Create nested job' : 'Create job for') + "\n                    ")]), _vm._v(" "), (!_vm.nestedMode) ? _c('h4', {
    staticClass: "bold file-name"
  }, [_vm._v(_vm._s(_vm.file.name) + ":")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col s10 offset-s1 init-settings"
  }, [_c('div', {
    staticClass: "col s12 l6 center-align settings-block"
  }, [_c('h5', {
    staticClass: "bold block-title"
  }, [_vm._v("Choose materials:")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "visible": _vm.materialvisible,
      "position": _vm.position
    },
    on: {
      "clickout": function($event) {
        _vm.materialvisible = false
      }
    }
  }, [_c('span', {
    staticClass: "link btn a3d",
    on: {
      "click": function($event) {
        _vm.materialvisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.materials[_vm.material - 1].name)), (_vm.materials[_vm.material - 1].trademark) ? _c('span', [_vm._v("™")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog no-padding",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.materials), function(material, index) {
    return _c('li', {
      key: material.name
    }, [_c('a', {
      staticClass: "a3d btn inv",
      on: {
        "click": function($event) {
          return _vm.materialChoice(index)
        }
      }
    }, [(index > _vm.predefinedMaterials - 1 && index !== _vm.materials.length - 1) ? _c('i', {
      staticClass: "material-icons a3d color",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeMaterial(index)
        }
      }
    }, [_vm._v("\n                                                clear\n                                            ")]) : _vm._e(), _vm._v("\n                                            " + _vm._s(material.name)), (material.trademark) ? _c('span', [_vm._v("™")]) : _vm._e()])])
  }), 0)])])]), _vm._v(" "), (!_vm.isValidMaterial) ? _c('div', {
    staticClass: "alert"
  }, [_vm._v("Material is unvalidated")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col s12 l6 center-align settings-block"
  }, [_c('h5', {
    staticClass: "bold block-title"
  }, [_vm._v("Choose printer:")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "visible": _vm.printervisible,
      "position": _vm.position
    },
    on: {
      "clickout": function($event) {
        _vm.printervisible = false
      }
    }
  }, [_c('span', {
    staticClass: "link btn a3d",
    on: {
      "click": function($event) {
        _vm.printervisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.printers[_vm.printer - 1].name) + " "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog no-padding",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.printers), function(printer, index) {
    return _c('li', {
      key: printer.name
    }, [_c('a', {
      staticClass: "a3d btn inv",
      on: {
        "click": function($event) {
          return _vm.printerChoice(index)
        }
      }
    }, [(index > _vm.predefinedPrinters - 1 && index !== _vm.printers.length - 1) ? _c('i', {
      staticClass: "material-icons a3d color",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removePrinter(index)
        }
      }
    }, [_vm._v("\n                                                clear\n                                            ")]) : _vm._e(), _vm._v("\n                                            " + _vm._s(printer.name) + "\n                                        ")])])
  }), 0)])])]), _vm._v(" "), (!_vm.printers[_vm.printer - 1].valid) ? _c('div', {
    staticClass: "alert"
  }, [_vm._v("Physical validation is still pending")]) : _vm._e(), _vm._v(" "), (_vm.printer > _vm.predefinedPrinters) ? _c('div', {
    staticClass: "alert"
  }, [_vm._v("Printer is unvalidated")]) : _vm._e()], 1)])]), _vm._v(" "), (!_vm.nestedMode) ? [_c('div', {
    staticClass: "blocks-wrp"
  }, [_c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the units you selected when creating your .stl file (usually mm or cm):\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('dropdown', {
    attrs: {
      "visible": _vm.unitvisible,
      "position": _vm.position
    },
    on: {
      "clickout": function($event) {
        _vm.unitvisible = false
      }
    }
  }, [_c('span', {
    staticClass: "link btn a3d",
    on: {
      "click": function($event) {
        _vm.unitvisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.units[_vm.files[0].unit - 1].name) + "\n                                    "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog no-padding",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.units), function(unit, index) {
    return _c('li', {
      key: unit.name
    }, [_c('a', {
      staticClass: "a3d btn inv",
      on: {
        "click": function($event) {
          return _vm.unitChoice(index)
        }
      }
    }, [_vm._v(_vm._s(unit.name))])])
  }), 0)])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input thickness of each powder layer (must be consistent with the layer thickness set in your printer):")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thickness.current),
      expression: "thickness.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "thicknessfield"
    },
    domProps: {
      "value": (_vm.thickness.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.thickness)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.thickness, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("µm")])]), _vm._v(" "), (_vm.thickness.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid thickness.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the scaling factor you want to apply when printing the file, relative to your .stl file (example: if you want to print at 150% the dimensions of your .stl file, you would enter 1.50):\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].scale.current),
      expression: "files[0].scale.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "scalefield"
    },
    domProps: {
      "value": (_vm.files[0].scale.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.files[0].scale)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[0].scale, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.files[0].scale.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid scale.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the distance between the part and the build platform. (Z-offset)\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].hsub.current),
      expression: "files[0].hsub.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "hsubfield",
      "disabled": _vm.isWithoutSupport
    },
    domProps: {
      "value": (_vm.files[0].hsub.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNum(_vm.files[0].hsub)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[0].hsub, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.files[0].hsub.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid distance.")]) : _vm._e(), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the temperature of the build platform.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tplate.current),
      expression: "tplate.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "tplatefield"
    },
    domProps: {
      "value": (_vm.tplate.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNum(_vm.tplate)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tplate, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("°C")])]), _vm._v(" "), (_vm.tplate.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid temperature.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the build plate thickness.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-note left-align"
  }, [_vm._v("\n                          A difference of +/- 20% or more is material to the simulation.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.H_buildPlate.current),
      expression: "H_buildPlate.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "hbuildplatefield"
    },
    domProps: {
      "value": (_vm.H_buildPlate.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.H_buildPlate)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.H_buildPlate, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.H_buildPlate.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid thickness.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input your suggested element size:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.element.current),
      expression: "element.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "elementfield"
    },
    domProps: {
      "value": (_vm.element.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.element)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.element, "current", $event.target.value)
      }, function($event) {
        return _vm.calculateElementSizeReset()
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.element.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid size.")]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), (!_vm.checkElementSizeResult || (_vm.checkElementSizeResult && _vm.checkElementSizeError)) ? _c('button', {
    staticClass: "a3d btn multiline",
    attrs: {
      "disabled": _vm.checkElementSizeProcess
    },
    on: {
      "click": function($event) {
        return _vm.calculateElementSize()
      }
    }
  }, [_vm._v("\n                            Confirm that your element size is not too small\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.checkElementSizeProcess) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), (_vm.checkElementSizeResult) ? _c('div', {
    staticClass: "block-note bold",
    class: {
      'error': _vm.checkElementSizeError
    }
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                " + _vm._s(_vm.checkElementSizeResult) + "\n                            ")])]) : _vm._e()])]), _vm._v(" "), (!this.showAdvanced) ? _c('div', {
    staticClass: "divider-block center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.confirmAdvanced()
      }
    }
  }, [_vm._v("\n                        Advanced Options\n                    ")])]) : _c('h5', {
    staticClass: "divider-block center-align block-title bold"
  }, [_vm._v("\n                    Advanced Options\n                ")])]), _vm._v(" "), (this.showAdvanced) ? _c('div', {
    staticClass: "blocks-wrp"
  }, [_c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Infill laser scan speed:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.speed.current),
      expression: "speed.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "speedfield"
    },
    domProps: {
      "value": (_vm.speed.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.speed)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.speed, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm / s")])]), _vm._v(" "), (_vm.speed.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid speed.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Infill laser beam diameter:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diameter.current),
      expression: "diameter.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "diameterfield"
    },
    domProps: {
      "value": (_vm.diameter.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.diameter)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.diameter, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("µm")])]), _vm._v(" "), (_vm.diameter.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid diameter.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Infill laser power:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.power.current),
      expression: "power.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "powerfield"
    },
    domProps: {
      "value": (_vm.power.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.power)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.power, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("W")])]), _vm._v(" "), (_vm.power.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid power.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                          Number of lasers employed for this build\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-note left-align"
  }, [_vm._v("\n                          (only impacts build time calculation)\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nlaser.current),
      expression: "nlaser.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "nlaserfield"
    },
    domProps: {
      "value": (_vm.nlaser.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.nlaser)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nlaser, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.nlaser.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid number of lasers.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Laser scanning speed for support structures:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vlaserSupp.current),
      expression: "vlaserSupp.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "vlaserSupp"
    },
    domProps: {
      "value": (_vm.vlaserSupp.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.vlaserSupp)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vlaserSupp, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm / s")])]), _vm._v(" "), (_vm.vlaserSupp.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid laser scanning speed.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Hatch distance:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hatch.current),
      expression: "hatch.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "hatch"
    },
    domProps: {
      "value": (_vm.hatch.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.hatch)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.hatch, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.hatch.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid hatch distance.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Recoater Crash Tolerance:")]), _vm._v(" "), _c('div', {
    staticClass: "block-note left-align"
  }, [_vm._v("\n                          0.4 mm is the tolerance of a stiff recoater blade. Flexible recoater blade materials will allow for more\n                          z-direction displacement. Please indicate the tolerance of the recoater material employed for this build.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CrashTolerance.current),
      expression: "CrashTolerance.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "crashtolerancefield"
    },
    domProps: {
      "value": (_vm.CrashTolerance.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.CrashTolerance)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.CrashTolerance, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.CrashTolerance.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid recoater crash tolerance.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the critical angle for generating support structures (in degrees):\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].critical_angle.current),
      expression: "files[0].critical_angle.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "critical_anglefield"
    },
    domProps: {
      "value": (_vm.files[0].critical_angle.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNum(_vm.files[0].critical_angle)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[0].critical_angle, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.files[0].critical_angle.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid angle.")]) : _vm._e(), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter material dependent scaling defined in your machine:\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('div', {
    staticClass: "unit label"
  }, [_vm._v("X-axis")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scalingX_material.current),
      expression: "scalingX_material.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "scalingX_material"
    },
    domProps: {
      "value": (_vm.scalingX_material.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositiveFromZero(_vm.scalingX_material)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scalingX_material, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("%")])]), _vm._v(" "), (_vm.scalingX_material.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid value.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('div', {
    staticClass: "unit label"
  }, [_vm._v("Y-axis")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scalingY_material.current),
      expression: "scalingY_material.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "scalingY_material"
    },
    domProps: {
      "value": (_vm.scalingY_material.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositiveFromZero(_vm.scalingY_material)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scalingY_material, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("%")])]), _vm._v(" "), (_vm.scalingY_material.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid value.")]) : _vm._e(), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Please enter parameters for distortion compensation:")]), _vm._v(" "), _c('div', {
    staticClass: "col s12 center-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].isCompensate),
      expression: "files[0].isCompensate"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isCompensate"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[0].isCompensate) ? _vm._i(_vm.files[0].isCompensate, null) > -1 : (_vm.files[0].isCompensate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.files[0].isCompensate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[0], "isCompensate", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[0], "isCompensate", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[0], "isCompensate", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isCompensate"
    }
  }, [_vm._v("Create an additional job result that includes design modifications that compensate for thermal distortion (remeshing is required)")])]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('div', {
    staticClass: "unit label"
  }, [_vm._v("Scaling Factor")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.compensationScale.current),
      expression: "compensationScale.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "compensationScale"
    },
    domProps: {
      "value": (_vm.compensationScale.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.compensationScale)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.compensationScale, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.compensationScale.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid scale.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('div', {
    staticClass: "unit label"
  }, [_vm._v("Mesh envelope size")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tetraEps.current),
      expression: "tetraEps.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "tetraEpsField"
    },
    domProps: {
      "value": (_vm.tetraEps.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.tetraEps)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tetraEps, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.tetraEps.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid size.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('div', {
    staticClass: "unit label"
  }, [_vm._v("Tetra mesh size")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tetraMeshSize.current),
      expression: "tetraMeshSize.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "tetraMeshSizeField"
    },
    domProps: {
      "value": (_vm.tetraMeshSize.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.tetraMeshSize)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tetraMeshSize, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.tetraMeshSize.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid size.")]) : _vm._e()])]), _vm._v(" "), _c('h5', {
    staticClass: "divider-block center-align block-title bold"
  }, [_vm._v("\n                    Support Structure\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp block-wrp-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isWithoutSupport),
      expression: "isWithoutSupport"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isWithoutSupport"
    },
    domProps: {
      "checked": Array.isArray(_vm.isWithoutSupport) ? _vm._i(_vm.isWithoutSupport, null) > -1 : (_vm.isWithoutSupport)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isWithoutSupport,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isWithoutSupport = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isWithoutSupport = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isWithoutSupport = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isWithoutSupport"
    }
  }, [_vm._v("Lay parts directly on build platform without any support")])]), _vm._v(" "), (!_vm.isWithoutSupport) ? _c('div', {
    staticClass: "center-align block-wrp block-wrp-100"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('input', {
    attrs: {
      "id": "uploadsupports",
      "accept": ".stl",
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.uploadSupports
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "a3d btn",
    on: {
      "click": _vm.selectSupportsFile
    }
  }, [_vm._v("Upload supports STL")]), _vm._v(" "), (Object.keys(_vm.fileSupports) > 0) ? _c('div', {
    staticClass: "block-buttons"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Supports units:")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "visible": _vm.unitsuppvisible,
      "position": _vm.position
    },
    on: {
      "clickout": function($event) {
        _vm.unitsuppvisible = false
      }
    }
  }, [_c('span', {
    staticClass: "link btn a3d",
    on: {
      "click": function($event) {
        _vm.unitsuppvisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.units_supp[_vm.files[0].unit_supp].name) + "\n                                    "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog no-padding",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.units_supp), function(unit, index) {
    return _c('li', {
      key: unit.name
    }, [_c('a', {
      staticClass: "a3d btn inv",
      on: {
        "click": function($event) {
          return _vm.unitSuppChoice(index)
        }
      }
    }, [_vm._v(_vm._s(unit.name))])])
  }), 0)])])])], 1) : _vm._e(), _vm._v(" "), _vm._l((Object.keys(_vm.fileSupports)), function(fileSupport) {
    return _c('div', {
      key: fileSupport,
      staticClass: "block-support"
    }, [_c('div', {
      staticClass: "bold upload-supports"
    }, [_vm._v(_vm._s(_vm.fileSupports[fileSupport].name))]), _vm._v(" "), _c('button', {
      staticClass: "a3d btn inv",
      on: {
        "click": function($event) {
          return _vm.removeSupportsFile(fileSupport)
        }
      }
    }, [_vm._v("Remove")])])
  }), _vm._v(" "), (_vm.uploadSupportsMessage) ? _c('div', [_vm._v(_vm._s(_vm.uploadSupportsMessage))]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (!(Object.keys(_vm.fileSupports).length > 0 || _vm.isWithoutSupport)) ? [_c('div', {
    staticClass: "center-align block-wrp with-image"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "block-input"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].suppSpacing_xy.current),
      expression: "files[0].suppSpacing_xy.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "suppSpacing_xyfield"
    },
    domProps: {
      "value": (_vm.files[0].suppSpacing_xy.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.files[0].suppSpacing_xy)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[0].suppSpacing_xy, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.files[0].suppSpacing_xy.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid distance.")]) : _vm._e(), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                              Please enter the size of the desired support at boundary.\n                          ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].supp_size_boundary.current),
      expression: "files[0].supp_size_boundary.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "supp_size_boundaryfield"
    },
    domProps: {
      "value": (_vm.files[0].supp_size_boundary.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.files[0].supp_size_boundary)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[0].supp_size_boundary, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.files[0].supp_size_boundary.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid distance.")]) : _vm._e(), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp block-wrp__flex"
  }, [_c('div', {
    staticClass: "block-input block-input__half"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                              Support structure hatch distance\n                          ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].suppHatchSize.current),
      expression: "files[0].suppHatchSize.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "suppHatchSizefield"
    },
    domProps: {
      "value": (_vm.files[0].suppHatchSize.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.files[0].suppHatchSize)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[0].suppHatchSize, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.files[0].suppHatchSize.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid distance.")]) : _vm._e(), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "block-input block-input__half"
  }, [_c('div', {
    staticClass: "left-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isStrengthSupp),
      expression: "isStrengthSupp"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isStrengthSupp"
    },
    domProps: {
      "checked": Array.isArray(_vm.isStrengthSupp) ? _vm._i(_vm.isStrengthSupp, null) > -1 : (_vm.isStrengthSupp)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isStrengthSupp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isStrengthSupp = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isStrengthSupp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isStrengthSupp = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "bold block-description",
    attrs: {
      "for": "isStrengthSupp"
    }
  }, [_vm._v("Use strengthened supports where distortion is highest?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp with-image"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-descripton"
  }, [_vm._v("\n                          Critical angle evaluated on:\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "support-checkboxes"
  }, [_c('div', {
    staticClass: "left-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isEvalFacet),
      expression: "isEvalFacet"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isEvalFacet"
    },
    domProps: {
      "checked": Array.isArray(_vm.isEvalFacet) ? _vm._i(_vm.isEvalFacet, null) > -1 : (_vm.isEvalFacet)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isEvalFacet,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isEvalFacet = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isEvalFacet = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isEvalFacet = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isEvalFacet"
    }
  }, [_vm._v("STL faces")])]), _vm._v(" "), _c('div', {
    staticClass: "left-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isEvalVertex),
      expression: "isEvalVertex"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isEvalVertex"
    },
    domProps: {
      "checked": Array.isArray(_vm.isEvalVertex) ? _vm._i(_vm.isEvalVertex, null) > -1 : (_vm.isEvalVertex)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isEvalVertex,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isEvalVertex = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isEvalVertex = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isEvalVertex = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isEvalVertex"
    }
  }, [_vm._v("STL vertices")])]), _vm._v(" "), _c('div', {
    staticClass: "left-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isEvalEdge),
      expression: "isEvalEdge"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isEvalEdge"
    },
    domProps: {
      "checked": Array.isArray(_vm.isEvalEdge) ? _vm._i(_vm.isEvalEdge, null) > -1 : (_vm.isEvalEdge)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isEvalEdge,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isEvalEdge = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isEvalEdge = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isEvalEdge = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isEvalEdge"
    }
  }, [_vm._v("STL edges")])]), _vm._v(" "), _c('div', {
    staticClass: "left-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isFragmentation),
      expression: "isFragmentation"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isFragmentation"
    },
    domProps: {
      "checked": Array.isArray(_vm.isFragmentation) ? _vm._i(_vm.isFragmentation, null) > -1 : (_vm.isFragmentation)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isFragmentation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isFragmentation = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isFragmentation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isFragmentation = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isFragmentation"
    }
  }, [_vm._v("Divide support blocks into fragments for easier removal")])]), _vm._v(" "), _c('div', {
    staticClass: "block-input"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fragmentationSize.current),
      expression: "fragmentationSize.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "fragmentationsizefield"
    },
    domProps: {
      "value": (_vm.fragmentationSize.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.fragmentationSize)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fragmentationSize, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.fragmentationSize.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid fragmentation size.")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp block-wrp-33"
  }, [_c('div', {
    staticClass: "block-input block-support-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                                Change the following parameters to change the support geometry:\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.wt.current),
      expression: "supportParams.wt.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.wt.min,
      "max": _vm.suppRanges.wt.max
    },
    domProps: {
      "value": (_vm.supportParams.wt.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('wt')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.wt, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("%")])]), _vm._v(" "), (_vm.supportParams.wt.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('wt')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.pt.current),
      expression: "supportParams.pt.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.pt.min,
      "max": _vm.suppRanges.pt.max,
      "step": _vm.suppRanges.pt.step
    },
    domProps: {
      "value": (_vm.supportParams.pt.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('pt')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.pt, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.supportParams.pt.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('pt')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.tt.current),
      expression: "supportParams.tt.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.tt.min,
      "max": _vm.suppRanges.tt.max,
      "step": _vm.suppRanges.tt.step
    },
    domProps: {
      "value": (_vm.supportParams.tt.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('tt')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.tt, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.supportParams.tt.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('tt')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.ot.current),
      expression: "supportParams.ot.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.ot.min,
      "max": _vm.suppRanges.ot.max,
      "step": _vm.suppRanges.ot.step
    },
    domProps: {
      "value": (_vm.supportParams.ot.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('ot')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.ot, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.supportParams.ot.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('ot')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(18), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.wb.current),
      expression: "supportParams.wb.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.wb.min,
      "max": _vm.suppRanges.wb.max
    },
    domProps: {
      "value": (_vm.supportParams.wb.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('wb')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.wb, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("%")])]), _vm._v(" "), (_vm.supportParams.wb.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('wb')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.pb.current),
      expression: "supportParams.pb.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.pb.min,
      "max": _vm.suppRanges.pb.max,
      "step": _vm.suppRanges.pb.step
    },
    domProps: {
      "value": (_vm.supportParams.pb.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('pb')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.pb, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.supportParams.pb.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('pb')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.tb.current),
      expression: "supportParams.tb.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.tb.min,
      "max": _vm.suppRanges.tb.max,
      "step": _vm.suppRanges.tb.step
    },
    domProps: {
      "value": (_vm.supportParams.tb.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('tb')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.tb, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.supportParams.tb.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('tb')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.ob.current),
      expression: "supportParams.ob.current"
    }],
    attrs: {
      "type": "number",
      "min": _vm.suppRanges.ob.min,
      "max": _vm.suppRanges.ob.max,
      "step": _vm.suppRanges.ob.step
    },
    domProps: {
      "value": (_vm.supportParams.ob.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('ob')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supportParams.ob, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.supportParams.ob.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('ob')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-value-range"
  }, [_c('div', {
    staticClass: "field-name small"
  }, [_vm._v("Support Density")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-wrp"
  }, [_c('div', {
    staticClass: "tooltip"
  }, [_c('span', {
    staticClass: "tooltipvalue",
    style: ({
      left: parseInt(_vm.supportParams.fraction_avg.current * 100) + '%'
    })
  }, [_vm._v("\n                                    " + _vm._s(parseInt(_vm.supportParams.fraction_avg.current * 100)) + "\n                                ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportParams.fraction_avg.current),
      expression: "supportParams.fraction_avg.current"
    }],
    attrs: {
      "type": "range",
      "min": _vm.suppRanges.fraction_avg.min,
      "max": _vm.suppRanges.fraction_avg.max,
      "step": _vm.suppRanges.fraction_avg.step
    },
    domProps: {
      "value": (_vm.supportParams.fraction_avg.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifySuppRange('fraction_avg')
      },
      "__r": function($event) {
        return _vm.$set(_vm.supportParams.fraction_avg, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("%")])]), _vm._v(" "), _c('div', {
    staticClass: "block-alert"
  }, [_vm._v("\n                                Increasing the support density will reduce the size of each support, making the aggregate of\n                                the supports more solid. Example: 100% density means that supports will create a solid \"wall\"\n                                of supports. Caution! Without teeth, removal of 100% solid supports would require machining.\n                            ")]), _vm._v(" "), (_vm.supportParams.fraction_avg.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.supportErrorMessage('fraction_avg')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp block-wrp-33"
  }, [_c('draw-support', {
    attrs: {
      "params": _vm.supportParams
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp block-wrp-33"
  }, [_c('draw-support', {
    attrs: {
      "params": _vm.supportParams,
      "buildPlate": true
    }
  })], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row jobSpec"
  }, [_c('div', {
    staticClass: "col s12 center-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[0].needRemesh),
      expression: "files[0].needRemesh"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "needRemesh"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[0].needRemesh) ? _vm._i(_vm.files[0].needRemesh, null) > -1 : (_vm.files[0].needRemesh)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.files[0].needRemesh,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[0], "needRemesh", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[0], "needRemesh", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[0], "needRemesh", $$c)
        }
      }, function($event) {
        return _vm.toggleRemesh($event)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "needRemesh"
    }
  }, [_vm._v("Match the resolution of the simulation to the resolution of the STL file (Remesh)")])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 center-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.saveSpec),
      expression: "saveSpec"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "saveForNext"
    },
    domProps: {
      "checked": Array.isArray(_vm.saveSpec) ? _vm._i(_vm.saveSpec, null) > -1 : (_vm.saveSpec)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.saveSpec,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.saveSpec = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.saveSpec = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.saveSpec = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "saveForNext"
    }
  }, [_vm._v("Use this job's specifications for the next job")])]), _vm._v(" "), (Object.keys(this.fileSupports).length > 0 && !_vm.isWithoutSupport) ? _c('div', {
    staticClass: "col s12 center-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPreviewSupports),
      expression: "isPreviewSupports"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isPreviewSupports"
    },
    domProps: {
      "checked": Array.isArray(_vm.isPreviewSupports) ? _vm._i(_vm.isPreviewSupports, null) > -1 : (_vm.isPreviewSupports)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isPreviewSupports,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isPreviewSupports = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isPreviewSupports = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isPreviewSupports = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isPreviewSupports"
    }
  }, [_vm._v("Preview support in viewer")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(22), _vm._v(" "), (_vm.loading && _vm.statusMessage) ? _c('div', {
    staticClass: "col s12 center-align status-message"
  }, [_vm._v("\n                    " + _vm._s(_vm.statusMessage) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.loading && !_vm.nestedMode) ? _c('div', {
    staticClass: "progress"
  }, [(_vm.remeshingPart && _vm.remeshingProgress > 0) ? _c('div', {
    staticClass: "determinate",
    style: ({
      width: _vm.remeshingProgress * 100 + '%'
    })
  }) : _c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), (_vm.loading && _vm.nestedMode) ? _c('div', {
    staticClass: "progress"
  }, [(_vm.remeshingPart.some(function (part) { return part === true; }) && _vm.remeshingProgress > 0) ? _c('div', {
    staticClass: "determinate",
    style: ({
      width: _vm.remeshingProgress * 100 + '%'
    })
  }) : _c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), _vm._m(23), _vm._v(" "), (_vm.subscription || _vm.user.credits.length > 0) ? [(!(Object.keys(this.fileSupports).length > 0) || _vm.isWithoutSupport) ? [(!_vm.files[0].isCompensate) ? _c('div', {
    staticClass: "col s4"
  }, [_c('div', [_c('a', {
    staticClass: "btn a3d multiline",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.submit(false, null)
      }
    }
  }, [_vm._v("Use AM Build Optimizer Intelligence")])])]) : _vm._e(), _vm._v(" "), (!_vm.files[0].isCompensate) ? _c('div', {
    staticClass: "col s4"
  }, [_c('div', [_c('a', {
    staticClass: "btn a3d inv multiline",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.submit(true, false)
      }
    }
  }, [_vm._v("\n                                  Orient Manually & Generate Supports "), _c('b', [_vm._v("Without")]), _vm._v(" Simulation\n                              ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col",
    class: {
      's4': !_vm.files[0].isCompensate, 's12': _vm.files[0].isCompensate
    }
  }, [_c('div', [_c('a', {
    staticClass: "btn a3d inv multiline",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.submit(true, true)
      }
    }
  }, [_vm._v("\n                                  Orient Manually "), _c('b', [_vm._v("With")]), _vm._v(" Simulation\n                              ")])])])] : (Object.keys(this.fileSupports).length > 0 && !_vm.isWithoutSupport) ? [_c('div', {
    staticClass: "col offset-s3 s6"
  }, [_c('div', {
    staticClass: "center-align"
  }, [_c('button', {
    staticClass: "btn a3d inv",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.submit(true, true)
      }
    }
  }, [_vm._v("\n                                  Open preview\n                              ")])])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s4 offset-s4"
  }, [_c('div', {
    staticClass: "center-align",
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [(!_vm.subscription) ? _c('h6', [_vm._v("This job costs 1 credit.")]) : _vm._e(), _vm._v(" "), (_vm.files[0].isCompensate) ? _c('h6', {
    staticClass: "bold"
  }, [_vm._v("Distortion compensation is not possible without prediction of thermal distortion.")]) : _vm._e()])])])] : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s4 offset-s4"
  }, [_c('div', {
    staticClass: "center-align",
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('button', {
    staticClass: "btn a3d",
    on: {
      "click": _vm.buymodal
    }
  }, [_vm._v("\n                                Buy Subscription\n                            ")]), _vm._v(" "), _c('h6', {
    staticClass: "bold"
  }, [_vm._v("This job costs 1 credit.")])])])])], 2)] : [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center",
      "padding-top": "20px"
    }
  }, [_c('div', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nestedJobFlow.isManually),
      expression: "nestedJobFlow.isManually"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isManuallyOrient"
    },
    domProps: {
      "checked": Array.isArray(_vm.nestedJobFlow.isManually) ? _vm._i(_vm.nestedJobFlow.isManually, null) > -1 : (_vm.nestedJobFlow.isManually)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.nestedJobFlow.isManually,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.nestedJobFlow, "isManually", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.nestedJobFlow, "isManually", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.nestedJobFlow, "isManually", $$c)
        }
      }, function($event) {
        return _vm.changeNestedJobsFlow()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isManuallyOrient"
    }
  }, [_vm._v("Orient my parts manually")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nestedJobFlow.isManualPlacement),
      expression: "nestedJobFlow.isManualPlacement"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isManualPlacement",
      "disabled": !_vm.nestedJobFlow.isManually
    },
    domProps: {
      "checked": Array.isArray(_vm.nestedJobFlow.isManualPlacement) ? _vm._i(_vm.nestedJobFlow.isManualPlacement, null) > -1 : (_vm.nestedJobFlow.isManualPlacement)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.nestedJobFlow.isManualPlacement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.nestedJobFlow, "isManualPlacement", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.nestedJobFlow, "isManualPlacement", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.nestedJobFlow, "isManualPlacement", $$c)
        }
      }, function($event) {
        return _vm.changeNestedJobsFlow()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isManualPlacement"
    }
  }, [_vm._v("Place my parts on the build tray manually")])])])]), _vm._v(" "), _c('div', {
    staticClass: "blocks-wrp"
  }, [_c('h5', {
    staticClass: "divider-block center-align block-title bold"
  }, [_vm._v("\n                    Build parameters\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input thickness of each powder layer (must be consistent with the layer thickness set in your printer):")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thickness.current),
      expression: "thickness.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "thicknessfield"
    },
    domProps: {
      "value": (_vm.thickness.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.thickness)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.thickness, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("µm")])]), _vm._v(" "), (_vm.thickness.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid thickness.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input your laser scanning speed:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.speed.current),
      expression: "speed.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "speedfield"
    },
    domProps: {
      "value": (_vm.speed.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.speed)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.speed, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm / s")])]), _vm._v(" "), (_vm.speed.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid speed.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input your laser beam diameter:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diameter.current),
      expression: "diameter.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "diameterfield"
    },
    domProps: {
      "value": (_vm.diameter.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.diameter)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.diameter, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("µm")])]), _vm._v(" "), (_vm.diameter.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid diameter.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input your laser power:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.power.current),
      expression: "power.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "powerfield"
    },
    domProps: {
      "value": (_vm.power.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.power)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.power, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("W")])]), _vm._v(" "), (_vm.power.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid power.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input your laser scanning speed for support structures:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vlaserSupp.current),
      expression: "vlaserSupp.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "vlaserSupp"
    },
    domProps: {
      "value": (_vm.vlaserSupp.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.vlaserSupp)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vlaserSupp, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm / s")])]), _vm._v(" "), (_vm.vlaserSupp.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid laser scanning speed.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                          Number of lasers employed for this build\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-note left-align"
  }, [_vm._v("\n                          (only impacts build time calculation)\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nlaser.current),
      expression: "nlaser.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "nlaserfield"
    },
    domProps: {
      "value": (_vm.nlaser.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.nlaser)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nlaser, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.nlaser.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid number of lasers.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Hatch distance:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hatch.current),
      expression: "hatch.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "hatch"
    },
    domProps: {
      "value": (_vm.hatch.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.hatch)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.hatch, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.hatch.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid hatch distance.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Input your suggested element size:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.element.current),
      expression: "element.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "elementfield"
    },
    domProps: {
      "value": (_vm.element.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.element)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.element, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.element.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid size.")]) : _vm._e(), _vm._v(" "), _vm._m(24)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the temperature of the build platform.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tplate.current),
      expression: "tplate.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "tplatefield"
    },
    domProps: {
      "value": (_vm.tplate.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNum(_vm.tplate)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tplate, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("°C")])]), _vm._v(" "), (_vm.tplate.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid temperature.")]) : _vm._e()])]), _vm._v(" "), (!_vm.nestedJobFlow.isManualPlacement) ? _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Input the number of degrees each part should be rotated about the\n                            z-axis during each optimization iteration for maximizing the number\n                            of parts on the build plate:\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deltaR.current),
      expression: "deltaR.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "deltarfield"
    },
    domProps: {
      "value": (_vm.deltaR.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumExactRange(_vm.deltaR, 1, 360)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deltaR, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("°")])]), _vm._v(" "), (_vm.deltaR.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid degree.")]) : _vm._e(), _vm._v(" "), _vm._m(25)])]) : _vm._e(), _vm._v(" "), (_vm.nestedMode) ? _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Build plate margin from the border by X-axis\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marginX.current),
      expression: "marginX.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "marginXfield"
    },
    domProps: {
      "value": (_vm.marginX.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumExactRange(_vm.marginX, 0, _vm.parentJobConfig.plateWidth / 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.marginX, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.marginX.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Invalid margin. Must be " + _vm._s(_vm.parentJobConfig.plateWidth / 2) + " - mm")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.nestedMode) ? _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Build plate margin from the border by Y-axis\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marginY.current),
      expression: "marginY.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "marginYfield"
    },
    domProps: {
      "value": (_vm.marginY.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumExactRange(_vm.marginY, 0, _vm.parentJobConfig.plateHeight / 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.marginY, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.marginY.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Invalid margin. Must be " + _vm._s(_vm.parentJobConfig.plateHeight / 2) + " - 0 mm")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "blocks-wrp"
  }, [_c('h5', {
    staticClass: "divider-block center-align block-title bold"
  }, [_vm._v("\n                    Part parameters\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "block-full-width"
  }, [_c('div', {
    staticClass: "center-align"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partParamsAll),
      expression: "partParamsAll"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "useForAll"
    },
    domProps: {
      "checked": Array.isArray(_vm.partParamsAll) ? _vm._i(_vm.partParamsAll, null) > -1 : (_vm.partParamsAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.partParamsAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.partParamsAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.partParamsAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.partParamsAll = $$c
        }
      }, function($event) {
        return _vm.switchPartParamAll()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "useForAll"
    }
  }, [_vm._v("Use the same parameters for all nested parts")])])]), _vm._v(" "), (!_vm.partParamsAll) ? _c('div', {
    staticClass: "block-dots top center-align"
  }, _vm._l((_vm.files), function(fileObj, index) {
    return _c('div', {
      key: fileObj.id,
      staticClass: "tooltip-wrp"
    }, [_c('div', {
      staticClass: "file-dot",
      class: {
        'selected': index === _vm.fileIndex
      },
      on: {
        "click": function($event) {
          return _vm.switchFile(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tooltip"
    }, [_c('span', {
      staticClass: "tooltipvalue"
    }, [_vm._v(_vm._s(fileObj.name))])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the units you selected when creating your .stl file (usually mm or cm):\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('dropdown', {
    attrs: {
      "visible": _vm.unitvisible,
      "position": _vm.position
    },
    on: {
      "clickout": function($event) {
        _vm.unitvisible = false
      }
    }
  }, [_c('span', {
    staticClass: "link btn a3d",
    on: {
      "click": function($event) {
        _vm.unitvisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.units[_vm.files[_vm.fileIndex].unit - 1].name) + "\n                                    "), _c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog no-padding",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.units), function(unit, index) {
    return _c('li', {
      key: 'nested' + unit.name
    }, [_c('a', {
      staticClass: "a3d btn inv",
      on: {
        "click": function($event) {
          return _vm.unitChoice(index)
        }
      }
    }, [_vm._v(_vm._s(unit.name))])])
  }), 0)])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the scaling factor you want to apply when printing the file, relative to your .stl file (example: if you want to print at 150% the dimensions of your .stl file, you would enter 1.50):\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].scale.current),
      expression: "files[fileIndex].scale.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "scalefield"
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].scale.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.files[_vm.fileIndex].scale)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[_vm.fileIndex].scale, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.files[_vm.fileIndex].scale.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid scale.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the distance between the part and the build platform.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].hsub.current),
      expression: "files[fileIndex].hsub.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "hsubfield"
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].hsub.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNum(_vm.files[_vm.fileIndex].hsub)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[_vm.fileIndex].hsub, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.files[_vm.fileIndex].hsub.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid distance.")]) : _vm._e(), _vm._v(" "), _vm._m(26)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                            Please enter the critical angle for generating support structures (in degrees):\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].critical_angle.current),
      expression: "files[fileIndex].critical_angle.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "critical_anglefield"
    },
    domProps: {
      "value": (_vm.files[_vm.fileIndex].critical_angle.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNum(_vm.files[_vm.fileIndex].critical_angle)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files[_vm.fileIndex].critical_angle, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.files[_vm.fileIndex].critical_angle.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid angle.")]) : _vm._e(), _vm._v(" "), _vm._m(27)])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-dots bottom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files[_vm.fileIndex].needRemesh),
      expression: "files[fileIndex].needRemesh"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "needRemesh"
    },
    domProps: {
      "checked": Array.isArray(_vm.files[_vm.fileIndex].needRemesh) ? _vm._i(_vm.files[_vm.fileIndex].needRemesh, null) > -1 : (_vm.files[_vm.fileIndex].needRemesh)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.files[_vm.fileIndex].needRemesh,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.files[_vm.fileIndex], "needRemesh", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.files[_vm.fileIndex], "needRemesh", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.files[_vm.fileIndex], "needRemesh", $$c)
        }
      }, function($event) {
        return _vm.toggleNestedRemesh($event, _vm.fileIndex)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "needRemesh"
    }
  }, [_vm._v("Match the resolution of the simulation to the resolution of the STL file (Remesh)")])]), _vm._v(" "), (!_vm.partParamsAll) ? _c('div', {
    staticClass: "block-dots bottom center-align"
  }, _vm._l((_vm.files), function(fileObj, index) {
    return _c('div', {
      key: 'nested' + fileObj.pathKey,
      staticClass: "tooltip-wrp"
    }, [_c('div', {
      staticClass: "file-dot",
      class: {
        'selected': index === _vm.fileIndex
      },
      on: {
        "click": function($event) {
          return _vm.switchFile(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tooltip"
    }, [_c('span', {
      staticClass: "tooltipvalue"
    }, [_vm._v(_vm._s(fileObj.name))])])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.nestedMode) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6 offset-s3 job-name"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Name of Nested job:")]), _vm._v(" "), _c('div', {
    staticClass: "input-field inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nestedJobName.current),
      expression: "nestedJobName.current"
    }],
    attrs: {
      "id": "nestedJobName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.nestedJobName.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyString(_vm.nestedJobName, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nestedJobName, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.nestedJobName.invalid) ? _c('div', {
    staticClass: "error center-align"
  }, [_vm._v("\n                        Enter valid job name\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col s6 offset-s3 center-align"
  }, [_vm._v("Enter the name you would like to use to refer to this job in your dashboard")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.submitting) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col s12 center-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "a3d btn",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.goNext()
      }
    }
  }, [_vm._v("Next")])])])], _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1",
      "padding-top": "3px"
    }
  }, [_c('modal', {
    ref: "otherprintermodal",
    attrs: {
      "name": "otherprintermodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "70%"
    },
    on: {
      "before-close": function($event) {
        return _vm.beforeClosePrinter()
      }
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "blocks-wrp"
  }, [_c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Printer name:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.name.current),
      expression: "printerCustom.name.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "printerName"
    },
    domProps: {
      "value": (_vm.printerCustom.name.current)
    },
    on: {
      "change": function($event) {
        _vm.verifyPrinterName(_vm.printerCustom.name) && _vm.verifyString(_vm.printerCustom.name, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.name, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.printerCustom.name.duplicate) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input unique name.")]) : _vm._e(), _vm._v(" "), (_vm.printerCustom.name.invalid && !_vm.printerCustom.name.duplicate) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Build chamber height:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.plateZ.current),
      expression: "printerCustom.plateZ.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "chamberHeight"
    },
    domProps: {
      "value": (_vm.printerCustom.plateZ.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.plateZ)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.plateZ, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.printerCustom.plateZ.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid height.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Build plate width:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.plateX.current),
      expression: "printerCustom.plateX.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "plateWidth"
    },
    domProps: {
      "value": (_vm.printerCustom.plateX.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.plateX)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.plateX, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.printerCustom.plateY.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid width.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Build plate length:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.plateY.current),
      expression: "printerCustom.plateY.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "plateLength"
    },
    domProps: {
      "value": (_vm.printerCustom.plateY.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.plateY)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.plateY, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.printerCustom.plateX.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid length.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Build plate thickness:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.plateThickness.current),
      expression: "printerCustom.plateThickness.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "plateThickness"
    },
    domProps: {
      "value": (_vm.printerCustom.plateThickness.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.plateThickness)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.plateThickness, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])]), _vm._v(" "), (_vm.printerCustom.plateThickness.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid length.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Recoater blade direction:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value column"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.DirectionRecoater.current),
      expression: "printerCustom.DirectionRecoater.current"
    }],
    attrs: {
      "name": "bladeDirection",
      "type": "radio",
      "id": "width",
      "value": "width"
    },
    domProps: {
      "checked": _vm._q(_vm.printerCustom.DirectionRecoater.current, "width")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.printerCustom.DirectionRecoater, "current", "width")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "width"
    }
  }, [_vm._v("Blade travels across the plate width")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.DirectionRecoater.current),
      expression: "printerCustom.DirectionRecoater.current"
    }],
    attrs: {
      "name": "bladeDirection",
      "type": "radio",
      "id": "length",
      "value": "length"
    },
    domProps: {
      "checked": _vm._q(_vm.printerCustom.DirectionRecoater.current, "length")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.printerCustom.DirectionRecoater, "current", "length")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "length"
    }
  }, [_vm._v("Blade travels across the plate length")])])])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Default Infill laser beam scan speed:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.speed.current),
      expression: "printerCustom.speed.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "scanningSpeed"
    },
    domProps: {
      "value": (_vm.printerCustom.speed.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.speed)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.speed, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm / s")])]), _vm._v(" "), (_vm.printerCustom.speed.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid scan speed.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Build Time Calibration Factor:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.calibrationFactor.current),
      expression: "printerCustom.calibrationFactor.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "calibrationFactor"
    },
    domProps: {
      "value": (_vm.printerCustom.calibrationFactor.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumBetween(_vm.printerCustom.calibrationFactor, 0, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.calibrationFactor, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.printerCustom.calibrationFactor.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Build Time Calibration Factor should be between 0 and 2.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Default Infill laser beam diameter:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.diameter.current),
      expression: "printerCustom.diameter.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "beamDiameter"
    },
    domProps: {
      "value": (_vm.printerCustom.diameter.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.diameter)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.diameter, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("µm")])]), _vm._v(" "), (_vm.printerCustom.diameter.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid diameter.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Default Infill laser beam power:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.power.current),
      expression: "printerCustom.power.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "laserPower"
    },
    domProps: {
      "value": (_vm.printerCustom.power.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.power)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.power, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("W")])]), _vm._v(" "), (_vm.printerCustom.power.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid power.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Default thickness of each powder layer (must be consistent with the layer thickness set in your printer):")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerCustom.thickness.current),
      expression: "printerCustom.thickness.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "layerThickness"
    },
    domProps: {
      "value": (_vm.printerCustom.thickness.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.printerCustom.thickness)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.printerCustom.thickness, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("µm")])]), _vm._v(" "), (_vm.printerCustom.thickness.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid thickness.")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-button"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.addPrinter()
      }
    }
  }, [_vm._v("Save printer")])]), _vm._v(" "), _c('div', {
    staticClass: "col s10 offset-s1 center-align"
  }, [_vm._v("\n                        AM Build Optimizer should work on any DMLS printer - however, only the printers listed have been validated.\n                        Please enter your printer’s make and model so we can add it to our validation work and eventually add it to the dropdown list.\n                        Please click the button below to send us an email with information to help us optimize for your printer.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col s10 offset-s1 center-align"
  }, [_c('a', {
    staticClass: "a3d btn small inv",
    staticStyle: {
      "margin-top": "20px",
      "width": "50%"
    },
    attrs: {
      "href": "mailto:support@atlas3d.xyz?subject=Job%20with%20Unsupported%20Material?body=Please%20insert%20the%20following%20information%2C%20and%20any%20other%20relevant%20information:%20Printer%20Make%2C%20Printer%20model."
    }
  }, [_vm._v("Send Email\n                        ")])])])]), _vm._v(" "), _c('modal', {
    ref: "othermaterialmodal",
    attrs: {
      "name": "othermaterialmodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "70%"
    },
    on: {
      "before-close": function($event) {
        return _vm.beforeCloseMaterial()
      }
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "blocks-wrp"
  }, [_c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Material name:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.name.current),
      expression: "materialCustom.name.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "materialName"
    },
    domProps: {
      "value": (_vm.materialCustom.name.current)
    },
    on: {
      "change": function($event) {
        _vm.verifyMaterialName(_vm.materialCustom.name) && _vm.verifyString(_vm.materialCustom.name, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.name, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.materialCustom.name.duplicate) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input unique name.")]) : _vm._e(), _vm._v(" "), (_vm.materialCustom.name.invalid && !_vm.materialCustom.name.duplicate) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Poisson's Ratio:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.nu.current),
      expression: "materialCustom.nu.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "poissonsRatio"
    },
    domProps: {
      "value": (_vm.materialCustom.nu.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.nu)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.nu, "current", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.materialCustom.nu.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Poisson's Ratio.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Young's modulus:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.E.current),
      expression: "materialCustom.E.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "elasticity"
    },
    domProps: {
      "value": (_vm.materialCustom.E.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.E)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.E, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("GPa")])]), _vm._v(" "), (_vm.materialCustom.E.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Young's modulus.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Young's modulus at high temperatures:")]), _vm._v(" "), _vm._l((_vm.materialCustom.E_heat), function(value, valueIndex) {
    return [_c('div', {
      key: valueIndex,
      staticClass: "block-value"
    }, [(_vm.materialCustom.E_heat.length > 1) ? _c('div', {
      staticClass: "icon-remove"
    }, [_c('i', {
      staticClass: "material-icons a3d color",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.removeMaterialHeatDependentValue(_vm.materialCustom.E_heat, valueIndex)
        }
      }
    }, [_vm._v("\n                                                clear\n                                            ")])]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.materialCustom.E_heat[valueIndex].temperature.current),
        expression: "materialCustom.E_heat[valueIndex].temperature.current"
      }],
      staticClass: "validate",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.materialCustom.E_heat[valueIndex].temperature.current)
      },
      on: {
        "change": function($event) {
          return _vm.verifyNumPositive(_vm.materialCustom.E_heat[valueIndex].temperature)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.materialCustom.E_heat[valueIndex].temperature, "current", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "unit first"
    }, [_vm._v("°C")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.materialCustom.E_heat[valueIndex].value.current),
        expression: "materialCustom.E_heat[valueIndex].value.current"
      }],
      staticClass: "validate",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.materialCustom.E_heat[valueIndex].value.current)
      },
      on: {
        "change": function($event) {
          return _vm.verifyNumPositive(_vm.materialCustom.E_heat[valueIndex].value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.materialCustom.E_heat[valueIndex].value, "current", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "unit"
    }, [_vm._v("GPa")])]), _vm._v(" "), (_vm.materialCustom.E_heat[valueIndex].temperature.invalid) ? _c('h6', {
      key: valueIndex,
      staticClass: "error"
    }, [_vm._v("Please input a valid temperature.")]) : _vm._e(), _vm._v(" "), (_vm.materialCustom.E_heat[valueIndex].value.invalid) ? _c('h6', {
      key: valueIndex,
      staticClass: "error"
    }, [_vm._v("Please input a valid Young's modulus.")]) : _vm._e()]
  }), _vm._v(" "), _c('div', {
    staticClass: "block-buttons"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.addMaterialHeatDependentValue(_vm.materialCustom.E_heat)
      }
    }
  }, [_vm._v("Add")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Density:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.rho.current),
      expression: "materialCustom.rho.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "density"
    },
    domProps: {
      "value": (_vm.materialCustom.rho.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.rho)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.rho, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("kg/m"), _c('sup', [_vm._v("3")])])]), _vm._v(" "), (_vm.materialCustom.rho.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Density.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Specific Heat:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.Cp.current),
      expression: "materialCustom.Cp.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "specificHeat"
    },
    domProps: {
      "value": (_vm.materialCustom.Cp.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.Cp)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.Cp, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("J/(kgK)")])]), _vm._v(" "), (_vm.materialCustom.Cp.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Specific Heat.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Thermal Conductivity:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.k.current),
      expression: "materialCustom.k.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "thermalConductivity"
    },
    domProps: {
      "value": (_vm.materialCustom.k.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.k)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.k, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("W/(mK)")])]), _vm._v(" "), (_vm.materialCustom.k.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Thermal Conductivity.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Solidus Temperature:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.Tsolid.current),
      expression: "materialCustom.Tsolid.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "solidusTemp"
    },
    domProps: {
      "value": (_vm.materialCustom.Tsolid.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.Tsolid)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.Tsolid, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("°C")])]), _vm._v(" "), (_vm.materialCustom.Tsolid.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid temperature.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Liquidus temperature:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.Tliquid.current),
      expression: "materialCustom.Tliquid.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "liquidusTemp"
    },
    domProps: {
      "value": (_vm.materialCustom.Tliquid.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.Tliquid)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.Tliquid, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("°C")])]), _vm._v(" "), (_vm.materialCustom.Tliquid.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid temperature.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Yield Stress:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.sigma_y.current),
      expression: "materialCustom.sigma_y.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "yieldStress"
    },
    domProps: {
      "value": (_vm.materialCustom.sigma_y.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.sigma_y)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.sigma_y, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("MPa")])]), _vm._v(" "), (_vm.materialCustom.sigma_y.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Yield Stress.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Yield Stress at high temperatures:")]), _vm._v(" "), _vm._l((_vm.materialCustom.sigma_y_heat), function(value, valueIndex) {
    return [_c('div', {
      key: valueIndex,
      staticClass: "block-value"
    }, [(_vm.materialCustom.sigma_y_heat.length > 1) ? _c('div', {
      staticClass: "icon-remove"
    }, [_c('i', {
      staticClass: "material-icons a3d color",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.removeMaterialHeatDependentValue(_vm.materialCustom.sigma_y_heat, valueIndex)
        }
      }
    }, [_vm._v("\n                                                clear\n                                            ")])]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.materialCustom.sigma_y_heat[valueIndex].temperature.current),
        expression: "materialCustom.sigma_y_heat[valueIndex].temperature.current"
      }],
      staticClass: "validate",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.materialCustom.sigma_y_heat[valueIndex].temperature.current)
      },
      on: {
        "change": function($event) {
          return _vm.verifyNumPositive(_vm.materialCustom.sigma_y_heat[valueIndex].temperature)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.materialCustom.sigma_y_heat[valueIndex].temperature, "current", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "unit first"
    }, [_vm._v("°C")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.materialCustom.sigma_y_heat[valueIndex].value.current),
        expression: "materialCustom.sigma_y_heat[valueIndex].value.current"
      }],
      staticClass: "validate",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.materialCustom.sigma_y_heat[valueIndex].value.current)
      },
      on: {
        "change": function($event) {
          return _vm.verifyNumPositive(_vm.materialCustom.sigma_y_heat[valueIndex].value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.materialCustom.sigma_y_heat[valueIndex].value, "current", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "unit"
    }, [_vm._v("MPa")])]), _vm._v(" "), (_vm.materialCustom.sigma_y_heat[valueIndex].temperature.invalid) ? _c('h6', {
      key: valueIndex,
      staticClass: "error"
    }, [_vm._v("Please input a valid temperature.")]) : _vm._e(), _vm._v(" "), (_vm.materialCustom.sigma_y_heat[valueIndex].value.invalid) ? _c('h6', {
      key: valueIndex,
      staticClass: "error"
    }, [_vm._v("Please input a valid Young's modulus.")]) : _vm._e()]
  }), _vm._v(" "), _c('div', {
    staticClass: "block-buttons"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.addMaterialHeatDependentValue(_vm.materialCustom.sigma_y_heat)
      }
    }
  }, [_vm._v("Add")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Melting Latent Heat:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.hsl.current),
      expression: "materialCustom.hsl.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "meltingHeat"
    },
    domProps: {
      "value": (_vm.materialCustom.hsl.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.hsl)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.hsl, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("kJ/kg")])]), _vm._v(" "), (_vm.materialCustom.hsl.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Melting Latent Heat.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Thermal Expansion Coefficient:")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialCustom.alpha.current),
      expression: "materialCustom.alpha.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "thermalExpansion"
    },
    domProps: {
      "value": (_vm.materialCustom.alpha.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.materialCustom.alpha)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.materialCustom.alpha, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("10"), _c('sup', [_vm._v("-6")]), _vm._v("/°C")])]), _vm._v(" "), (_vm.materialCustom.alpha.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid Thermal Expansion Coefficient.")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "center-align block-button"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.addMaterial(false)
      }
    }
  }, [_vm._v("Save material")])]), _vm._v(" "), _c('div', {
    staticClass: "col s10 offset-s1 center-align"
  }, [_vm._v("\n                        AM Build Optimizer has not been validated with your material.\n                        We will attempt to gather the required material properties and eventually add it to the dropdown list.\n                        Please click the button below to send us an email with information to help optimize for your material.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col s10 offset-s1 center-align"
  }, [_c('a', {
    staticClass: "a3d btn small inv",
    staticStyle: {
      "margin-top": "20px",
      "width": "50%"
    },
    attrs: {
      "href": "mailto:support@atlas3d.xyz?subject=Job%20with%20Unsupported%20Material?body=Please%20insert%20the%20following%20information%2C%20and%20any%20other%20relevant%20information:%20Material%20name%2C%20material%20description%2C%20and%20source."
    }
  }, [_vm._v("Send Email\n                        ")])])])]), _vm._v(" "), _c('modal', {
    ref: "cautionmodal",
    attrs: {
      "name": "cautionmodal",
      "pivotY": 0.4,
      "reset": true,
      "height": "auto",
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "caution-modal"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('b', [_vm._v("Caution:")]), _vm._v(" Changing these parameters may prevent your\n                        part from printing successfully. If you are an advanced user, please\n                        proceed and make your desired changes.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_vm._v("\n                        Click \"OK\" to proceed, or \"Cancel\" to return to the previous screen.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6 right-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.acceptModal(true)
      }
    }
  }, [_vm._v("OK")])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 left-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.acceptModal(false)
      }
    }
  }, [_vm._v("Cancel")])])])])])], 1)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s6 offset-s3 center-align"
  }, [_c('h5', [_vm._v("\n            There was a problem processing your file.  We will return to you to the dashboard in a few seconds.  If this consumed one of your credits, please contact us with details and we will correct this.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader-wrapper small active"
  }, [_c('div', {
    staticClass: "spinner-layer"
  }, [_c('div', {
    staticClass: "circle-clipper left"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gap-patch"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-clipper right"
  }, [_c('div', {
    staticClass: "circle"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                (If the distance is 0, the part will be built directly from the build platform.)\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                (We suggest 2 mm. A smaller element size will result in a more accurate optimization, but a longer processing time.)\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                Surfaces with angles relative to the build plate smaller than this angle will be supported\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                Material dependent scaling is a global addition or subtraction of material in the indicated plane.\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                            higher value gives more compensation\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(442),
      "alt": "Support width and length"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("\n                              Individual support width and length (WL"), _c('sub', [_vm._v("0")]), _vm._v(")\n                          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                  (The default is 1.0 mm)\n                              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                  (The default is 0.6 mm)\n                              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                  (The default is 3.5 mm)\n                              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(441),
      "alt": "Critical angle"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bold block-description"
  }, [_vm._v("Fragmentation size (S"), _c('sub', [_vm._v("0")]), _vm._v("):")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("W"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("P"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("T"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("O"), _c('sub', [_vm._v("t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("W"), _c('sub', [_vm._v("b")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("P"), _c('sub', [_vm._v("b")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("T"), _c('sub', [_vm._v("b")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-name"
  }, [_vm._v("O"), _c('sub', [_vm._v("b")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s12 center-align"
  }, [_c('h5', {
    staticClass: "bold"
  }, [_vm._v("Prepare file for print run:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s10 offset-s1",
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                        You can choose to orient your part manually. AM Build Optimizer™ will automatically add support structures where you need them.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                (We suggest 2 mm. A smaller element size will result in a more accurate optimization, but a longer processing time.)\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                (30 degrees is recommended. A lower number will potentially result\n                                in a higher density, but the optimization will take longer to\n                                complete. Enter ‘360’ to fix the z rotation.)\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                (If the distance is 0, the part will be built directly from the build platform.)\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-note"
  }, [_c('h6', {
    staticClass: "center-align"
  }, [_vm._v("\n                                (Surfaces with angles to the horizontal smaller than the critical angle will be supported.)\n                            ")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7055ef20", module.exports)
  }
}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "alertmodal",
    attrs: {
      "name": "alertmodal",
      "pivotY": 0.3,
      "reset": true,
      "height": "auto",
      "width": "50%"
    },
    on: {
      "before-open": _vm.beforeOpen,
      "closed": _vm.onClosed
    }
  }, [_c('div', {
    staticClass: "modal-block",
    class: _vm.params.type
  }, [(_vm.title) ? _c('div', {
    staticClass: "modal-content-header"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "message"
  }, [_vm._v("\n                " + _vm._s(_vm.params.message) + "\n            ")]), _vm._v(" "), (_vm.params.details) ? _c('div', {
    staticClass: "details-block"
  }, [_c('div', {
    staticClass: "details-button right-align"
  }, [_c('a', {
    on: {
      "click": _vm.toggleDetails
    }
  }, [_vm._v("\n                        Details\n                        "), _c('i', {
    staticClass: "fa",
    class: {
      'fa-chevron-up': _vm.isDetailsOpen, 'fa-chevron-down': !_vm.isDetailsOpen
    }
  })])]), _vm._v(" "), (_vm.isDetailsOpen) ? _c('div', {
    staticClass: "details"
  }, [_vm._v("\n                    " + _vm._s(_vm.params.details) + "\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons-block center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": _vm.modalClose
    }
  }, [_vm._v(_vm._s(_vm.params.dismissTitle))]), _vm._v(" "), (_vm.params.isCanRetry) ? _c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": _vm.retry
    }
  }, [_vm._v(_vm._s(_vm.params.retryTitle))]) : _vm._e()])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-788e9811", module.exports)
  }
}

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "a3d"
  }, [_c('div', {
    staticClass: "nav-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dash'
      }
    }
  }, [_c('img', {
    staticClass: "a3d logo",
    attrs: {
      "src": "/static/img/siemens_logo_white.svg"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "hide-on-med-and-down a3d bold",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "nav-mobile"
    }
  }, [_c('li', [_c('a', {
    staticClass: "menu-link",
    on: {
      "click": function($event) {
        return _vm.auth.logout()
      }
    }
  }, [_vm._v("Logout")])])])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('div', {
    staticClass: "field-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.isGovcloudUser),
      expression: "form.isGovcloudUser"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isGovcloudUser"
    },
    domProps: {
      "checked": _vm.form.isGovcloudUser,
      "checked": Array.isArray(_vm.form.isGovcloudUser) ? _vm._i(_vm.form.isGovcloudUser, null) > -1 : (_vm.form.isGovcloudUser)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.isGovcloudUser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "isGovcloudUser", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "isGovcloudUser", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "isGovcloudUser", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isGovcloudUser"
    }
  }, [_vm._v("My data needs to be kept in a government restricted zone due to it being covered by regulations such as ITAR.")])])]), _vm._v(" "), _c('div', {
    staticClass: "center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-align"
  }, [_c('h4', {
    staticClass: "onboard-title"
  }, [_vm._v("Please finish configuring your account")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-79d2a423", module.exports)
  }
}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container a3d trial"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.isShowForm) ? _c('div', [_c('h6', {
    staticClass: "form-title center"
  }, [_vm._v("FREE TRIAL REGISTRATION")]), _vm._v(" "), _c('div', {
    staticClass: "form-block"
  }, [_c('div', {
    staticClass: "form-input"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n          First Name\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.firstName.current),
      expression: "form.firstName.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.firstName.current)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.firstName, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.form.firstName.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please enter your First Name")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n          Last Name\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.lastName.current),
      expression: "form.lastName.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.lastName.current)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.lastName, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.form.lastName.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please enter your Last Name")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n          Email\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email.current),
      expression: "form.email.current"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.email.current)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.email, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.form.email.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please enter your email")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col s12 center buttons-block"
  }, [(_vm.submitting) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _c('button', {
    staticClass: "btn a3d",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Sign Up")])]), _vm._v(" "), (_vm.error) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Something went wrong")]) : _vm._e()]), _vm._v(" "), _vm._m(2)]) : (_vm.submitted) ? _c('div', {
    staticClass: "center"
  }, [_c('h6', {
    staticClass: "form-title"
  }, [_vm._v("An invitation to AM Build Optimizer has been sent to your email.")])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 center buttons-block"
  }, [_c('button', {
    staticClass: "btn a3d",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showForm
    }
  }, [_vm._v("Start Free Trial")]), _vm._v(" "), _c('a', {
    staticClass: "btn a3d inv",
    attrs: {
      "href": _vm.loginHost
    }
  }, [_vm._v("Log in")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "responsive-img center-align",
    attrs: {
      "src": "/static/img/siemens_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 center"
  }, [_c('h5', [_vm._v("AM Build Optimizer")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description"
  }, [_c('ol', [_c('li', [_vm._v("\n          The trial subscription will be active for 30 days.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          You will be asked to enter your email and create a password, you should use the same\n          email and password you use for other Siemens sites you may have access to.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          You can submit optimizations from within NX-AM from the modeling perspective. You can\n          also submit optimizations directly through the web-based user interface at\n          "), _c('a', {
    attrs: {
      "href": "https://portal.atlas3d.xyz"
    }
  }, [_vm._v("https://portal.atlas3d.xyz")]), _vm._v(" or\n          "), _c('a', {
    attrs: {
      "href": "https://portal.atlas3dxyz.com"
    }
  }, [_vm._v("https://portal.atlas3dxyz.com")]), _vm._v(". Finally, you\n          can also submit optimizations from within any NX installation you may have on your\n          computer, provided it has been updated to version 1957 or later. Simply install the NX\n          plugin by running the application called "), _c('strong', [_vm._v("“Atlas3DtoNX.exe”")]), _vm._v(" available at\n          "), _c('strong', [_vm._v("C:\\Program Files\\Siemens\\NX[Version Number]\\MACH\\auxiliary\\mfgam")]), _vm._v(". For\n          either of these options, you must first complete the onboarding process for the AM Build\n          Optimizer trial.\n        ")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8b602f5c", module.exports)
  }
}

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isForceLogin) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _c('div', {
    staticClass: "container a3d splash"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row center"
  }, [_c('div', {
    staticClass: "col s6 right-align"
  }, [_c('a', {
    staticClass: "btn a3d inv",
    on: {
      "click": function($event) {
        return _vm.auth.login(true)
      }
    }
  }, [_vm._v("Sign up")])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 left-align"
  }, [_c('a', {
    staticClass: "btn a3d",
    on: {
      "click": function($event) {
        return _vm.auth.login(false)
      }
    }
  }, [_vm._v("Log in")])]), _vm._v(" "), (_vm.$route.path == '/logout') ? _c('p', {
    staticClass: "col s12 align-center"
  }, [_vm._v("You have logged out successfully")]) : _vm._e()]), _vm._v(" "), (!_vm.isPassWasChanged) ? _c('div', {
    staticClass: "reset-password-message"
  }, [_vm._v("\n    As Siemens security has now been added to this software as a service,\n    you must change your password before logging in if you have not changed your password since June 5, 2020.\n    Please follow next steps:\n    "), _vm._m(1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 center"
  }, [_c('img', {
    staticClass: "responsive-img center-align",
    attrs: {
      "src": "/static/img/siemens_logo.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Click \"Log in\".")]), _vm._v(" "), _c('li', [_vm._v("Into Siemens login page click \"Don't remember your password?\".")]), _vm._v(" "), _c('li', [_vm._v("Follow the link from your E-mail.")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8cfe374a", module.exports)
  }
}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("display", function() {
    return [_c('a', {
      on: {
        "click": _vm.showModal
      }
    }, [_vm._v("\n      Buy Subscription\n    ")])]
  }, {
    "open": _vm.showModal
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a5456eb0", module.exports)
  }
}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "files-root"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "section-body"
    }
  }, [_c('div', {
    staticClass: "col l6 files",
    staticStyle: {
      "padding": "2.5em"
    }
  }, [_c('div', {
    staticClass: "row flex",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.4em",
      "vertical-align": "middle"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "uploadfile",
      "accept": ".stl",
      "type": "file"
    },
    on: {
      "change": _vm.upload
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "a3d btn small upload",
    on: {
      "click": function($event) {
        return _vm.selectUploadFile()
      }
    }
  }, [_vm._v("\n                    Upload new file\n                ")]), _vm._v(" "), (_vm.files.length > 0) ? _c('button', {
    staticClass: "a3d btn small create-nested",
    on: {
      "click": function($event) {
        return _vm.toggleNestedMode()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.nestedMode ? 'Cancel' : 'Create') + " nested job\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.deleting || _vm.uploading) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.message) + "\n            ")]), _vm._v(" "), (_vm.files.length < 1 && !_vm.filesPagination.loading) ? _c('div', {
    staticClass: "no-files center-align"
  }, [_vm._v("\n                There are no files yet\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.files), function(file, index) {
    return _c('div', {
      key: file.pathKey,
      staticClass: "a3d file"
    }, [_c('div', {
      staticStyle: {
        "margin-right": "1em"
      }
    }, [(!_vm.nestedMode) ? _c('i', {
      staticClass: "material-icons a3d color",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.deleteF(file)
        }
      }
    }, [_vm._v("\n                       clear\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.nestedMode) ? _c('input', {
      staticClass: "filled-in",
      attrs: {
        "type": "checkbox",
        "id": file.pathKey
      },
      domProps: {
        "checked": _vm.filesNested[file.pathKey]
      },
      on: {
        "change": function($event) {
          return _vm.setNestedFile(file)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('label', {
      attrs: {
        "for": file.pathKey
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "file-name-nested"
    }, [_vm._v("\n                    " + _vm._s(file.name) + "\n                ")]), _vm._v(" "), (file.isVirus) ? _c('div', {
      staticClass: "file-error"
    }, [_vm._v("\n                  File is infected\n                ")]) : _c('div', {
      staticClass: "button-block right"
    }, [(file.isInvalidStlFile) ? _c('div', {
      staticClass: "file-error"
    }, [_vm._v("\n                      File is corrupted\n                    ")]) : _vm._e(), _vm._v(" "), ((!file.fixOperation || file.fixOperation.status === 'DRAFT' || file.fixOperation.status === 'SUBMITTED') && !_vm.user.isGovcloudUser && !file.isInvalidStlFile) ? _c('button', {
      staticClass: "a3d btn small inv",
      attrs: {
        "disabled": _vm.repairProcess[file.id]
      },
      on: {
        "click": function($event) {
          return _vm.fileRepairOpen(file)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.repairProcess[file.id] ? 'Repairing...' : 'Repair File') + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "a3d btn small inv",
      on: {
        "click": function($event) {
          return _vm.fileDownload({
            filename: file.name,
            sourceFilePathKey: file.pathKey
          })
        }
      }
    }, [_vm._v("Download")]), _vm._v(" "), (!file.isInvalidStlFile) ? _c('router-link', {
      staticClass: "a3d btn small",
      attrs: {
        "to": {
          name: 'CreateJob',
          params: {
            id: file.id
          }
        }
      }
    }, [_vm._v("\n                        Create job\n                    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.repairProcess[file.id]) ? _c('div', {
      staticClass: "progress"
    }, [(true) ? _c('div', {
      staticClass: "indeterminate"
    }) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), (_vm.deleting || _vm.filesPagination.loading) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), (!_vm.filesPagination.isAllLoaded && _vm.filesFormatted.length > 0 && !_vm.filesPagination.loading) ? _c('div', {
    staticClass: "center-align"
  }, [_c('button', {
    staticClass: "a3d btn load-files",
    attrs: {
      "disabled": _vm.filesPagination.loading || _vm.uploading || _vm.deleting
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadSourceFiles()
      }
    }
  }, [_vm._v("Load more")])]) : _vm._e(), _vm._v(" "), (_vm.nestedMode && Object.keys(_vm.filesNested).length > 0) ? _c('div', {
    staticClass: "center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.nestParts()
      }
    }
  }, [_vm._v("Nest selected parts")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col l6 jobs a3d",
    staticStyle: {
      "padding": "2.5em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), (_vm.loadingJobs) ? _c('div', {
    staticClass: "progress"
  }, [(!_vm.jobsProgress.loaded) ? _c('div', {
    staticClass: "indeterminate"
  }) : _c('div', {
    staticClass: "determinate",
    style: ('width: ' + (_vm.jobsProgress.loaded / _vm.jobsProgress.total) * 100 + '%')
  })]) : _c('div', [(_vm.filesFormatted.length > 0) ? _c('div', {
    staticClass: "right-align"
  }, [(_vm.compareMode && (Object.keys(_vm.filesCompare).length > 0 || Object.keys(_vm.nestedFilesCompare).length > 0)) ? _c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.showEstimateModal()
      }
    }
  }, [_vm._v("\n                            Compare\n                          ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.toggleCompareMode()
      }
    }
  }, [_vm._v(_vm._s(_vm.compareMode ? 'Cancel comparing' : 'Compare Print Costs'))]), _vm._v(" "), (!_vm.showArchived && _vm.countArchivedJobs > 0) ? _c('a', {
    staticClass: "a3d btn inv",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleArchived.apply(null, arguments)
      }
    }
  }, [_vm._v("View Archived Jobs")]) : _vm._e(), _vm._v(" "), (_vm.showArchived && _vm.countActiveJobs > 0) ? _c('a', {
    staticClass: "a3d btn inv",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleArchived.apply(null, arguments)
      }
    }
  }, [_vm._v("View Active Jobs")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showArchived && _vm.countArchivedJobs < 1) ? _c('div', {
    staticClass: "a3d file job"
  }, [_c('div', {
    staticClass: "message center-align"
  }, [_vm._v("\n                            There are no archived jobs yet\n                        ")])]) : _vm._e(), _vm._v(" "), (!_vm.showArchived && _vm.countActiveJobs < 1) ? _c('div', {
    staticClass: "a3d file job"
  }, [_c('div', {
    staticClass: "message center-align"
  }, [_vm._v("\n                            There are no created jobs yet\n                        ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filesFormatted), function(file, index) {
    return _c('div', {
      key: file.jobId ? file.jobId : file.id
    }, [(file.isNested) ? [(file.isArchived === _vm.showArchived) ? _c('job-output', {
      attrs: {
        "job": file,
        "compare-mode": _vm.compareMode
      }
    }) : _vm._e()] : [_c('file-output', {
      attrs: {
        "file": file,
        "show-archived": _vm.showArchived,
        "compare-mode": _vm.compareMode
      }
    })]], 2)
  }), _vm._v(" "), (_vm.jobsPagination.loading) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1",
      "padding-top": "3px"
    }
  }, [_c('modal', {
    ref: "removemodal",
    attrs: {
      "name": "removemodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "300px"
    },
    on: {
      "before-open": _vm.removeJobOpen
    }
  }, [_c('div', {
    staticClass: "prompt-modal"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Are you sure that you want to delete this job?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6 right-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.removeJob()
      }
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 left-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.removeJobConfirmationCancel()
      }
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), _c('modal', {
    ref: "repairmodal",
    attrs: {
      "name": "repairmodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "400px"
    },
    on: {
      "closed": _vm.fileRepairClose
    }
  }, [_c('div', {
    staticClass: "prompt-modal"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "repair-form"
  }, [_c('div', {
    staticClass: "block-input-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "block-description"
  }, [_vm._v("\n                                      Mesh envelope size\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repairConfig.tetraEps.current),
      expression: "repairConfig.tetraEps.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "tetraEpsField"
    },
    domProps: {
      "value": (_vm.repairConfig.tetraEps.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.repairConfig.tetraEps)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.repairConfig.tetraEps, "current", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "block-note"
  }, [_vm._v("Small envelope size improves accuracy but increases run time")]), _vm._v(" "), (_vm.repairConfig.tetraEps.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid size.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block-input-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "block-description"
  }, [_vm._v("\n                                      Tetra mesh size\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repairConfig.tetraMeshSize.current),
      expression: "repairConfig.tetraMeshSize.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "tetraMeshSizeField"
    },
    domProps: {
      "value": (_vm.repairConfig.tetraMeshSize.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.repairConfig.tetraMeshSize)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.repairConfig.tetraMeshSize, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])])]), _vm._v(" "), (_vm.repairConfig.tetraMeshSize.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid size.")]) : _vm._e()])]), _vm._v(" "), _c('div', [_vm._v("\n                                Please review your geometry carefully once the repair is complete. Repairing STL\n                                files may create unwanted changes to discreet features.\n                              ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6 right-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.fileRepair()
      }
    }
  }, [_vm._v("Repair File")])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 left-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.fileRepairClose()
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('modal', {
    ref: "resubmitjobmodal",
    attrs: {
      "name": "resubmitjobmodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "400px"
    },
    on: {
      "before-open": _vm.resubmitJobOpen
    }
  }, [_c('div', {
    staticClass: "prompt-modal"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._v("\n                                Are you sure that you want to re-submit job?\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6 right-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.resubmitJob()
      }
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 left-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.resubmitJobClose()
      }
    }
  }, [_vm._v("Cancel")])])])])])], 1), _vm._v(" "), _c('estimate-cost')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.4em",
      "vertical-align": "middle"
    }
  }, [_vm._v("Jobs")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c4e0099a", module.exports)
  }
}

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(440),
      "alt": "loading"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ee81178e", module.exports)
  }
}

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "center-align"
  }, [_c('p', [_vm._v("login")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f70131b6", module.exports)
  }
}

/***/ }),
/* 496 */,
/* 497 */,
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(413);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("fd3718de", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-18d6d9ee\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EstimateCost.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-18d6d9ee\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EstimateCost.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(414);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("219f8a60", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-25c81e86\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Viewer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-25c81e86\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Viewer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(415);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("7ca3834c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3764253e\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./vue-my-dropdown.vue", function() {
     var newContent = require("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3764253e\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./vue-my-dropdown.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(416);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("46a01c30", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-38ba4ea0\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Banner.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-38ba4ea0\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Banner.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(417);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("360aa236", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3907c46c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SupportCanvas.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3907c46c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SupportCanvas.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(418);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("02dc8869", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3cf5c9a2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JobOutput.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3cf5c9a2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JobOutput.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(419);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("4b1d61de", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3e32201d\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JobSummary.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3e32201d\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JobSummary.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(420);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("63ac0c24", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3f482306\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dash.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3f482306\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dash.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(421);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("3dda9fb7", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-414352eb\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Nested.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-414352eb\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Nested.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(422);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("4967a128", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-49a3b049\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FileOutput.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-49a3b049\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FileOutput.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(423);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("73ec7e36", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6c0f179e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Start.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6c0f179e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Start.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(424);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("1086e0e8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6fe9077c\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6fe9077c\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(425);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("70d5a8f4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7055ef20\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Create.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7055ef20\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Create.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(426);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("7b36ae32", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-788e9811\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Alert.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-788e9811\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Alert.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(427);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("a2af6622", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-79d2a423\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Onboard.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-79d2a423\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Onboard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(428);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("f55b8e00", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-8b602f5c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Trial.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-8b602f5c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Trial.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(429);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("59393fe0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-8cfe374a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Splash.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-8cfe374a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Splash.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(430);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("6c987d16", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-a5456eb0\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BuyCredits.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-a5456eb0\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BuyCredits.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(431);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("2a651dd8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c4e0099a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Files.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c4e0099a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Files.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(432);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("04b4535f", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ee81178e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Callback.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ee81178e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Callback.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(433);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("34149e4d", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f70131b6\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Login.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f70131b6\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Login.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ })
]),[313]);


// WEBPACK FOOTER //
// static/js/app.038bc4de570fbae9aa4e.js